webpackJsonp([7],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Created by rong on 17/7/12.
 */

// import Utils from '../common/utils';

// const  alySource = Utils.getCookie('source');

var app_version = "11.0.1";
// 直接调用接口
var api = function api(_this, type, target, url, params, success, fail) {
  var success = success ? success : function () {};
  var apiUrl = _this.$utils.getSpliceHost(target) + url;
  params.app_version = app_version;
  if (type === 'get') {
    var param = {
      params: params
    };
    if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
      param.client_type = 22;
    }
    if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
      param.login_token = window.localStorage.getItem('wxLoginToken');
    }
    if (window.localStorage.getItem('wxToken') && window.localStorage.getItem('wxToken') != 'undefined' && window.localStorage.getItem('wxToken') != 'null') {
      param.token = window.localStorage.getItem('wxToken');
    }
    _this.$http.get(apiUrl, param).then(function (response) {
      if (JSON.parse(response.bodyText).flag === 1) {
        success(JSON.parse(response.bodyText).data);
      } else {
        // if(fail) {
        //   fail(response);
        // } else {
        //   alert(response.data.message)
        // }
        if (response.data.flag === '-641' || response.data.flag == '-615') {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
    });
  } else if (type === 'post') {
    _this.$http.post(apiUrl, params, { emulateJSON: true }).then(function (response) {
      // 响应成功回调
      if (response.data.flag === 1) {
        success(response.data.data);
      } else {
        if (fail) {
          fail(response);
        } else {
          alert(response.data.message);
        }
        if (response.data.flag === '-641' || response.data.flag == '-615') {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        }
      }
    }, function (response) {
      // 响应错误回调
      // alert(response.data.message)
    });
  }
};
// PHP转发接口（V2）
var transmitApiV2 = function transmitApiV2(_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {};
  var url;
  var host = _this.$utils.getAgentApiHost();
  // if(process.env.NODE_ENV=='local'){
  //   // host = 'http://web-agent.imcoming.com.cn'
  //   host = 'http://web-agent.imcoming.com'
  // }else if(process.env.NODE_ENV=='development'){
  //   host = 'http://web-agent.imcoming.com.cn'
  // }else if(process.env.NODE_ENV=='test'){
  //   host = 'http://web-agent.imcoming.com'
  // }else{
  //   host = 'https://web-agent.anlaiye.com'
  // }
  if (target === 'erp') {
    url = host + '/agent/epost';
  } else if (target === 'public') {
    url = host + '/agent/ppost';
  } else {
    if (type === 'get') {
      url = host + '/agent/get';
    } else {
      url = host + '/agent/postV2';
    }
  }
  // 合并json方法
  var mergeJSON = function mergeJSON(jsonbject1, jsonbject2) {
    var resultJsonObject = {};
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i];
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m];
    }
    return resultJsonObject;
  };
  var token = window.localStorage.getItem('wxToken');
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params);
  if (type === 'get') {

    var apiUrl = url + '?';
    for (var p in pa) {
      if (p === 'target') {
        apiUrl = apiUrl + p + '=' + pa[p];
      } else {
        apiUrl = apiUrl + '&' + p + '=' + pa[p];
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data);
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.message) {
              alert(response.data.message);
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message);
      }
    });
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        success(response.data.data);
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message);
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message);
      }
      // 响应错误回调
    });
  }
};
// PHP转发接口（V3）
var transmitApiV3 = function transmitApiV3(_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {};
  var url;
  var host = _this.$utils.getAgentApiHost();
  // if(process.env.NODE_ENV=='local'){
  //   // host = 'http://web-agent.imcoming.com.cn'
  //   host = 'http://web-agent.imcoming.com'
  // }else if(process.env.NODE_ENV=='development'){
  //   host = 'http://web-agent.imcoming.com.cn'
  // }else if(process.env.NODE_ENV=='test'){
  //   host = 'http://web-agent.imcoming.com'
  // }else{
  //   host = 'https://web-agent.anlaiye.com'
  // }
  if (target === 'erp') {
    url = host + '/agent/epost';
  } else if (target === 'public') {
    url = host + '/agent/ppost';
  } else {
    if (type === 'get') {
      url = host + '/agent/get';
    } else {
      url = host + '/agent/postV3';
    }
  }
  // 合并json方法
  var mergeJSON = function mergeJSON(jsonbject1, jsonbject2) {
    var resultJsonObject = {};
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i];
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m];
    }
    return resultJsonObject;
  };
  var token = window.localStorage.getItem('wxToken');
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token,
    device_id: _this.$store.state.openId
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params);
  if (type === 'get') {

    var apiUrl = url + '?';
    for (var p in pa) {
      if (p === 'target') {
        apiUrl = apiUrl + p + '=' + pa[p];
      } else {
        apiUrl = apiUrl + '&' + p + '=' + pa[p];
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data);
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.message) {
              alert(response.data.message);
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message);
      }
    });
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        success(response.data.data);
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message);
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message);
      }
      // 响应错误回调
    });
  }
};
// PHP转发接口
var transmitApi = function transmitApi(_this, type, target, action, params, success, fail) {
  var success = success ? success : function () {};
  var url;
  var host = _this.$utils.getAgentApiHost();
  if (target === 'erp') {
    url = host + '/agent/epost';
  } else if (target === 'public') {
    url = host + '/agent/ppost';
  } else {
    if (type === 'get') {
      url = host + '/agent/get';
    } else {
      url = host + '/agent/post';
    }
  }
  // 合并json方法
  var mergeJSON = function mergeJSON(jsonbject1, jsonbject2) {
    var resultJsonObject = {};
    for (var i in jsonbject1) {
      resultJsonObject[i] = jsonbject1[i];
    }
    for (var m in jsonbject2) {
      resultJsonObject[m] = jsonbject2[m];
    }
    return resultJsonObject;
  };
  var token = void 0;
  if (params.token) {
    token = params.token;
    delete params.token;
  } else {
    token = window.localStorage.getItem('wxToken');
  }
  // var token = window.localStorage.getItem('wxToken')
  // var token = 'e4a5d084e984e215d38312088d80aaae'
  var paramsMust = {
    app_version: app_version,
    target: target,
    action: encodeURIComponent(action),
    token: token,
    // client_type:  11, //云闪付支付调式
    client_type: localStorage.getItem('platformType')
  };
  if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
    paramsMust.client_type = 22;
  }
  if (window.localStorage.getItem('wxLoginToken') && window.localStorage.getItem('wxLoginToken') != 'undefined' && window.localStorage.getItem('wxLoginToken') != 'null') {
    paramsMust.login_token = window.localStorage.getItem('wxLoginToken');
  }
  var pa = mergeJSON(paramsMust, params);
  if (type === 'get') {
    var apiUrl = url + '?target=' + pa.target;
    for (var p in pa) {
      // if(p === 'target') {
      //   apiUrl = apiUrl + p + '=' + pa[p]
      // } else {
      //   apiUrl = apiUrl + '&' + p + '=' + pa[p]
      // }
      if (p != 'target') {
        if (_typeof(pa[p]) === "object") {
          for (var k in pa[p]) {
            // p[k] = pa[p][k]
            apiUrl = apiUrl + '&' + (p + '[' + k + ']') + '=' + pa[p][k];
          }
        } else {
          apiUrl = apiUrl + '&' + p + '=' + pa[p];
        }
      }
    }
    _this.$http.get(apiUrl).then(function (response) {
      if (response.body.flag === 1) {
        success(response.body.data);
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          _this.$router.push({ name: 'Login' });
          var obj = {
            wxUid: ''
          };
          window.localStorage.removeItem('userDefinedMobile'); //退出账号清除自定义自提电话
          window.localStorage.removeItem('cartInfo'); //退出账号清除购物车信息
          window.localStorage.removeItem('userInfo');
          window.localStorage.removeItem('wxLoginToken');
          _this.$store.commit('changeState', obj);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.message) {
              alert(response.data.message);
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      // 响应错误回调
      if (response.data.message) {
        alert(response.data.message);
      }
    });
  } else if (type === 'post') {
    _this.$http.post(url, pa, { emulateJSON: true }).then(function (response) {
      if (response.data.result) {
        if (action === '/v1/public/log/add') {
          success(response);
        } else {
          success(response.data.data);
        }
        // success(response.data.data)
      } else {
        if (response.data.flag == '-641' || response.data.flag == '-615' || response.data.flag == -60004) {
          // _this.$router.push({name: 'Login'})
          _this.$utils.toLogin(_this);
          var obj = {
            wxUid: ''
          };
          window.localStorage.removeItem('userDefinedMobile'); //退出账号清除自定义自提电话
          window.localStorage.removeItem('cartInfo'); //退出账号清除购物车信息
          window.localStorage.removeItem('userInfo');
          window.localStorage.removeItem('wxLoginToken');
          _this.$store.commit('changeState', obj);
        } else {
          if (fail) {
            fail(response);
          } else {
            if (response.data.flag != '-603') {
              if (response.data.message) {
                alert(response.data.message);
              }
            }
          }
        }
      }
      // 响应成功回调
    }, function (response) {
      if (response.data.message) {
        alert(response.data.message);
      }
      // 响应错误回调
    });
  }
};

var actions = {
  // 内部流量统计
  postLogAdd: function postLogAdd(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'my-order-j', '/v1/public/log/add', params, onSuccess, onFail);
  },
  // 根据选择的学校id,获取学校信息
  postSchoolInfo: function postSchoolInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', ' /api/schoolInfo', params, onSuccess, onFail);
  },
  // 获取图形验证码
  postCaptcha: function postCaptcha(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/web/captcha/get', params, onSuccess, onFail);
  },
  // 发送短信验证码
  postSmsCaptcha: function postSmsCaptcha(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/webSendCaptcha', params, onSuccess, onFail);
  },
  // 发送短信验证码2
  postAuthCaptcha: function postAuthCaptcha(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/authCaptcha', params, onSuccess, onFail);
  },
  // 发送短信验证码3
  postSendCaptcha: function postSendCaptcha(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/sms/sendCaptcha', params, onSuccess, onFail);
  },
  // 登录注册
  postSignIn: function postSignIn(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signIn', params, onSuccess, onFail);
  },
  // 北大绑定手机号
  postSignInIaaa: function postSignInIaaa(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signInIaaa', params, onSuccess, onFail);
  },
  // 登录
  postSignOut: function postSignOut(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/signOut', params, onSuccess, onFail);
  },
  // 登录注册
  postAuthInfo: function postAuthInfo(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/authInfo', params, onSuccess, onFail);
  },
  // 登录注册测试
  postAuth: function postAuth(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/auth', params, onSuccess, onFail);
  },
  // 定位,搜索附近学校列表
  postSchoolSearch: function postSchoolSearch(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/search', params, onSuccess, onFail);
  },
  // 获取学校详情
  postSchoolStatus: function postSchoolStatus(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/status', params, onSuccess, onFail);
  },
  //获取学校公告
  getNoticeInfo: function getNoticeInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/notice/info', params, onSuccess, onFail);
  },
  // 获取首页开关状态
  getHomeStatus: function getHomeStatus(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/school/homeStatus', params, onSuccess, onFail);
  },
  // 获取标签首页列表
  getTagIndexList: function getTagIndexList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/home/index', params, onSuccess, onFail);
  },
  //获取中部幻灯片列表
  getLanternSlide: function getLanternSlide(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/home/slide', params, onSuccess, onFail);
  },
  // 获取店铺分类列表
  postShopCategoryList: function postShopCategoryList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/category/list', params, onSuccess, onFail);
  },
  // 获取投诉电话
  getCommercialTel: function getCommercialTel(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/commercial/telInfo', params, onSuccess, onFail);
  },
  // 根据tag获取学校店铺列表
  getTagShopList: function getTagShopList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/specialList', params, onSuccess, onFail);
  },
  // 根据tag获取标签图片信息
  getTagInfo: function getTagInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/tags/info', params, onSuccess, onFail);
  },
  // 获取当前学校店铺列表
  getShopList: function getShopList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/listForGoods', params, onSuccess, onFail);
  },
  // 获取当前学校店铺列表
  getShopListNew: function getShopListNew(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/localMerchants', params, onSuccess, onFail);
  },
  // 获取活动店铺
  getPromtionList: function getPromtionList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/promotionShop', params, onSuccess, onFail);
  },
  // 获取买过的店
  getBoughtList: function getBoughtList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shop/BoughtShop', params, onSuccess, onFail);
  },
  //获取商家权益包
  getBenefitList: function getBenefitList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/school/benefit/list', params, onSuccess, onFail);
  },
  // 获取店铺标签列表
  getShopTagList: function getShopTagList(_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'goods_center', '/v1/public/app/shop/tag', params, onSuccsee, onFail);
  },
  // 获取店铺信息
  getShopInfo: function getShopInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shop/shopLiteInfo', params, onSuccess, onFail);
  },
  // 获取商品列表
  getGoodsList: function getGoodsList(_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'merchants', '/pub/shop/goodsV2', params, onSuccess, onFail);
  },
  // 获取店铺分类列表
  getShopCodeList: function getShopCodeList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'goods_center', '/v1/public/app/shop/code/list', params, onSuccess, onFail);
  },
  // 获取店铺分类列表
  getShopDetailList: function getShopDetailList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'goods_center', '/v1/public/app/shop/gd/page', params, onSuccess, onFail);
  },
  // 获取搜索关键词
  getSearchRecom: function getSearchRecom(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/pub/search/recommend', params, onSuccess, onFail);
  },
  // 获取搜索推荐店铺
  getShopRecom: function getShopRecom(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shop/recommend', params, onSuccess, onFail);
  },

  // 获取楼栋列表
  postBuildList: function postBuildList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/build/list', params, onSuccess, onFail);
  },
  // 获取可下单楼栋列表
  postBuildLists: function postBuildLists(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/shopBuild/getBuildList', params, onSuccess, onFail);
  },
  // 获取楼栋列表1
  postBuildList1: function postBuildList1(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/school/buildlist', params, onSuccess, onFail);
  },
  // 获取店铺楼栋
  postShopBuildList: function postShopBuildList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'merchants', '/pub/shopbuild/get', params, onSuccess, onFail);
  },
  // 保存自提地址
  savePickupAddress: function savePickupAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/save', params, onSuccess, onFail);
  },
  // 自提地址详情
  pickupInfo: function pickupInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/pickup', params, onSuccess, onFail);
  },
  // 订单预检
  postOrderPreview: function postOrderPreview(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/precheck', params, onSuccess, onFail);
  },
  // 提交订单
  postOrderCreate: function postOrderCreate(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/info', params, onSuccess, onFail);
  },
  //获取订单列表
  postOrderList: function postOrderList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/mylist', params, onSuccess, onFail);
  },
  // 无人餐厅订单详情
  getOrderDetail_Youxin: function getOrderDetail_Youxin(_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'order_center', '/pub/v1/youXin/order/info', params, onSuccess, onFail);
  },
  //商家获取评论列表
  getBusinessCommentList: function getBusinessCommentList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate/for/app', params, onSuccess, onFail);
  },
  //获取用户评论页面信息
  getOnlineCommentInfo: function getOnlineCommentInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/applyEstimate', params, onSuccess, onFail);
  },
  //用户获取评论列表
  getCommentList: function getCommentList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate', params, onSuccess, onFail);
  },
  //用户获取评论详情
  getCommentDetails: function getCommentDetails(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/estimate/detail', params, onSuccess, onFail);
  },
  //用户提交评价
  postSaveComment: function postSaveComment(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/saveEstimate', params, onSuccess, onFail);
  },
  //删除评论
  getDeleteComment: function getDeleteComment(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/deleteEstimate', params, onSuccess, onFail);
  },
  //点击投诉申请投诉
  getApplyComplaints: function getApplyComplaints(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/complaint/apply', params, onSuccess, onFail);
  },
  //用户提交投诉
  postSaveComplaint: function postSaveComplaint(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/complaint/add', params, onSuccess, onFail);
  },
  //投诉结果反馈
  postFeedBack: function postFeedBack(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/submit/resultFeedBack', params, onSuccess, onFail);
  },
  //获取投诉列表
  getComplaintList: function getComplaintList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/complaint/page', params, onSuccess, onFail);
  },
  //获取投诉详情
  getComplaintDetails: function getComplaintDetails(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/complaint/detail', params, onSuccess, onFail);
  },
  //用户取消投诉
  getCancelComplaint: function getCancelComplaint(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cancel/complaint', params, onSuccess, onFail);
  },
  //点击申请退款
  getApplyRefund: function getApplyRefund(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/refund/apply', params, onSuccess, onFail);
  },
  //获取退款进度详情
  getRefundDetails: function getRefundDetails(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/query/refund/detail', params, onSuccess, onFail);
  },
  //同意商家处理结果
  getRefundResult: function getRefundResult(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/accept/shop/refund', params, onSuccess, onFail);
  },
  //用户申诉操作
  postAppeal: function postAppeal(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/handle/appeal', params, onSuccess, onFail);
  },
  //获取优惠券列表
  PostCouponList: function PostCouponList(_this, params, onSuccess, onFail) {
    transmitApiV2(_this, 'post', 'coupon_center', '/pub/user/myCoupon', params, onSuccess, onFail);
  },
  //在线发放优惠券列表
  PostOnlineCouponList: function PostOnlineCouponList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/coupon/grantOnline', params, onSuccess, onFail);
  },
  //领取新优惠券
  receiveCouponNew: function receiveCouponNew(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'coupon_center', '/pub/coupon/trigger', params, onSuccess, onFail);
  },
  //领取老优惠券
  receiveCouponOld: function receiveCouponOld(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon', '/v1/scenario/grant', params, onSuccess, onFail);
  },
  // 店铺优惠券列表
  shopGrantList: function shopGrantList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'coupon_center', '/pub/activity/grantlist', params, onSuccess, onFail);
  },
  // 领取店铺优惠券
  receiveShopGrant: function receiveShopGrant(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/grant', params, onSuccess, onFail);
  },
  // 一键领取店铺优惠券
  receiveAllShopGrant: function receiveAllShopGrant(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/allgrant', params, onSuccess, onFail);
  },
  // 设置优惠券弹框
  setGrantTotast: function setGrantTotast(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'coupon_center', '/pub/activity/toast', params, onSuccess, onFail);
  },
  // 兑换优惠券
  redeemCoupon: function redeemCoupon(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'coupon-base', '/web/coupon/redeemCoupon', params, onSuccess, onFail);
  },

  //推荐下单活动banner入口
  recommendBanner: function recommendBanner(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'star', '/api/recommend/show', params, onSuccess, onFail);
  },
  //新学期优惠券弹框
  showCoupon: function showCoupon(_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'star', '/api/popbonus/show', params, onSuccess, onFail);
  },
  //模糊匹配学校列表
  postSearchSchool: function postSearchSchool(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/search', params, onSuccess, onFail);
  },
  //全量城市信息列表
  postCityList: function postCityList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'public', '/api/school/cityListSortByPinyin', params, onSuccess, onFail);
  },
  // 结算接口
  postGetPromotion: function postGetPromotion(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/api/promotion/getPromotion', params, onSuccess, onFail);
  },
  //订单支付方式选择
  getPayWay: function getPayWay(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/detail/beforePayment/' + params.order_id, params, onSuccess, onFail);
  },
  //支付
  postWxJsPay: function postWxJsPay(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/status/paid', params, onSuccess, onFail);
  },
  // H5支付
  h5WxPay: function h5WxPay(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'payment', '/payment/v1/user/9298055/wx_h5/trans', params, onSuccess, onFail);
  },
  // 校园卡信息
  schoolCardInfo: function schoolCardInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/campusCard/get', params, onSuccess, onFail);
  },
  //订单状态
  postOrderStatuslist: function postOrderStatuslist(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', 'api/order/orderStatuslist', params, onSuccess, onFail);
  },
  //订单详情
  getOrderDetail: function getOrderDetail(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/detail', params, onSuccess, onFail);
  },
  //取消订单
  postCancelOrder: function postCancelOrder(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/cancel', params, onSuccess, onFail);
  },
  //取消订单并退款
  postCancelRefundOrder: function postCancelRefundOrder(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/refund/noduty', params, onSuccess, onFail);
  },
  //确认收货
  postFinalOrder: function postFinalOrder(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/food/order/confirmReceived', params, onSuccess, onFail);
  },
  // 一键开柜
  openCabinet: function openCabinet(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/take/food', params, onSuccess, onFail);
  },
  // 催单
  reminderOrder: function reminderOrder(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/reminder', params, onSuccess, onFail);
  },
  //客服信息
  managerInfo: function managerInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/api/manager/info', params, onSuccess, onFail);
  },

  // 获取商品分类列表
  postCategoryList: function postCategoryList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/category/list', params, onSuccess, onFail);
  },

  // 获取商品详情
  postGoodsDetail: function postGoodsDetail(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/goods_center/detail', params, onSuccess, onFail);
  },
  // 搜索商品列表
  postGoodsSearch: function postGoodsSearch(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'erp', '/v1/public/school/goods_center/search', params, onSuccess, onFail);
  },
  // 热门商品列表
  postGoodsSearchHost: function postGoodsSearchHost(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/supermarket/searchhot', params, onSuccess, onFail);
  },
  // 商品搜索
  getGoodsSearch: function getGoodsSearch(_this, params, onSuccess, onFail) {
    // merchants / goods
    transmitApi(_this, 'get', 'merchants', '/pub/shop/search', params, onSuccess, onFail);
  },

  // 获取用户默认地址
  postDefaultAddress: function postDefaultAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/default', params, onSuccess, onFail);
  },
  // 获取地址列表
  postAddressList: function postAddressList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/list', params, onSuccess, onFail);
  },
  // 设置默认地址
  postSetDefaultAddress: function postSetDefaultAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/pub/address/setdefault', params, onSuccess, onFail);
  },
  // 新增收货地址
  postAddAddress: function postAddAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/address/createUserAddress', params, onSuccess, onFail);
  },
  // 获取收货地址详情
  postUserAddressInfo: function postUserAddressInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/detail', params, onSuccess, onFail);
  },
  // 编辑收货地址
  postEditAddress: function postEditAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport', '/api/address/editUserAddress', params, onSuccess, onFail);
  },
  // 保存收货地址
  postSaveAddress: function postSaveAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/save', params, onSuccess, onFail);
  },
  // 删除收货地址
  postDeleteAddress: function postDeleteAddress(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/address/remove', params, onSuccess, onFail);
  },
  // 判断是否为商家配送
  getJudgeShopDelivery: function getJudgeShopDelivery(_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/judge/shopDelivery', params, onSuccsee, onFail);
  },
  // 用户获取配送单详情
  getTransportInfo: function getTransportInfo(_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/customer/transportInfo', params, onSuccsee, onFail);
  },
  // 用户查询配送进程状态记录
  getProgressLog: function getProgressLog(_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'transport_center', '/transport/app/customer/progress/log', params, onSuccsee, onFail);
  },
  //红包分享接口
  getredPacketShare: function getredPacketShare(_this, params, onSuccsee, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/redPacket/detail', params, onSuccsee, onFail);
  },

  // 云柜相关

  postSignInByMujia: function postSignInByMujia(_this, params, onSuccess, onFail) {
    api(_this, 'post', 'open-base', '/passport/authByBusiness', params, onSuccess, onFail);
  },
  // 查询免密状态
  postContractInfoByMujia: function postContractInfoByMujia(_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'passport_v3', '/priv/payment/contractInfo', params, onSuccess, onFail);
  },
  // 订单
  getOrderListByMujia: function getOrderListByMujia(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/list', params, onSuccess, onFail);
  },
  // 开门后查订单
  getPaidDetailByMujia: function getPaidDetailByMujia(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/paidDetail', params, onSuccess, onFail);
  },
  // 订单预检
  getOrderPreviewByMujia: function getOrderPreviewByMujia(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/cloudArk/order/precheck', params, onSuccess, onFail);
  },
  // 开启免密支付
  getEntrustWebByMujia: function getEntrustWebByMujia(_this, params, onSuccess, onFail) {
    api(_this, 'get', 'payment', '/pub/provider/wx/entrustweb', params, onSuccess, onFail);
  },
  // 开柜
  getTerminalOpenByMujia: function getTerminalOpenByMujia(_this, params, onSuccess, onFail) {
    transmitApiV3(_this, 'post', 'passport_v3', '/pub/terminal/open', params, onSuccess, onFail);
  },
  // 调起免密支付
  postWeixinEntrustByMujia: function postWeixinEntrustByMujia(_this, params, onSuccess, onFail) {
    api(_this, 'get', 'oc', '/food/trade/pay/wx_entrust/h5', params, onSuccess, onFail);
  },
  // 打赏西游侠信息
  getWeixinRewardInfo: function getWeixinRewardInfo(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/order/reward/detail', params, onSuccess, onFail);
  },
  // 打赏西游侠列表
  getWeixinRewardList: function getWeixinRewardList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/reward/order/list', params, onSuccess, onFail);
  },
  // 查询核销状态
  getOrderStatus: function getOrderStatus(_this, params, onSuccess, onFail) {
    api(_this, 'get', 'oc', '/admin/order/status', params, onSuccess, onFail);
  },
  // 哆啦宝
  getOrderPaywayStatus: function getOrderPaywayStatus(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/order/payway/status', params, onSuccess, onFail);
  },
  // 我的西游积分
  getMyScore: function getMyScore(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getScore', params, onSuccess, onFail);
  },
  getScoreList: function getScoreList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getEventList', params, onSuccess, onFail);
  },
  getScoreDetail: function getScoreDetail(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/detail', params, onSuccess, onFail);
  },
  userSign: function userSign(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/sign/userSign', params, onSuccess, onFail);
  },
  getUserSignList: function getUserSignList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/sign/userSignList', params, onSuccess, onFail);
  },
  getScoreListNew: function getScoreListNew(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getEventListNew', params, onSuccess, onFail);
  },
  //点击广告得积分
  scoreClickAd: function scoreClickAd(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/pub/score/clickAd', params, onSuccess, onFail);
  },
  // 会员等级
  getLevel: function getLevel(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/getLevel', params, onSuccess, onFail);
  },
  // 经验说明
  getExpDesc: function getExpDesc(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/score/level', params, onSuccess, onFail);
  },
  addLog: function addLog(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'my-order-j', '/v1/public/log/add', params, onSuccess, onFail);
  },
  // 优信订单详情
  youxinOrderList: function youxinOrderList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'order_center', '/pub/v1/youXin/order/info', params, onSuccess, onFail);
  },
  // 券包列表
  postPackageList: function postPackageList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/pub/package/get', params, onSuccess, onFail);
  },
  // 券包可用店铺列表
  postPackageShop: function postPackageShop(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'merchants', '/pub/package/shop', params, onSuccess, onFail);
  },
  // 券包购买
  postPackagePurchaseRecord: function postPackagePurchaseRecord(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'promotion', '/pub/package/packagePurchaseRecord', params, onSuccess, onFail);
  },
  // 新学期红包
  postPopBonusShow: function postPopBonusShow(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/pub/popBonus/show', params, onSuccess, onFail);
  },
  // 店铺 获取标签下的code列表
  postShopCodeList: function postShopCodeList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'gc', '/v1/public/app/shop/code/list', params, onSuccess, onFail);
  },
  postShopGdList: function postShopGdList(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'gc', '/v1/public/app/shop/gd/page', params, onSuccess, onFail);
  },
  // 幸福星期天
  getHappySundayShow: function getHappySundayShow(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'promotion', '/pub/happy/show', params, onSuccess, onFail);
  },
  // 下单返券
  getOrderCoupon: function getOrderCoupon(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'promotion', '/pub/order/coupon', params, onSuccess, onFail);
  },
  // 下单返券
  getOrderCard: function getOrderCard(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'star', '/api/cardPlus/orderCard', params, onSuccess, onFail);
  },
  // 下单预计得积分
  getScorePartake: function getScorePartake(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'passport_v3', '/api/score/partake', params, onSuccess, onFail);
  },
  // 常驻活动入口
  postCardPlus: function postCardPlus(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/cardPlus/appCard', params, onSuccess, onFail);
  },
  // 切换学校
  toggleSchool: function toggleSchool(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/toggleSchool', params, onSuccess, onFail);
  },
  // clc 邀请有礼
  clcAcceptInvite: function clcAcceptInvite(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/clc/acceptInvite', params, onSuccess, onFail);
  },
  // 订单获取立减金
  getOrderBonus: function getOrderBonus(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'star', '/api/weekend/getOrderBonus', params, onSuccess, onFail);
  },
  // 保单详情
  getPunctualOrderDetail: function getPunctualOrderDetail(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'get', 'order_center', '/food/punctual/order/detail', params, onSuccess, onFail);
  },
  // 准时达
  getUserInfoFullByUid: function getUserInfoFullByUid(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/fullbyuid', params, onSuccess, onFail);
  },
  setUserSignContract: function setUserSignContract(_this, params, onSuccess, onFail) {
    transmitApi(_this, 'post', 'passport_v3', '/api/userinfo/signContract', params, onSuccess, onFail);
  },
  //获取微信相关信息
  getJslbsConf: function getJslbsConf(_this, url, onSuccess) {
    var host = _this.$utils.getAgentApiHost(),
        str = void 0;
    if (false) {
      host = host + '/wechatDev';
    } else {
      host = host + '/wechat';
    }
    // 解决安卓和ios兼容问题
    str = url;
    if (!_this.$utils.isAndroid()) {
      str = encodeURIComponent(window.localStorage.getItem('upSDKUrl'));
    }
    _this.$http.get(host + '/Jssdk/lbsConf?url=' + str).then(function (redata) {
      var wxInfo = JSON.parse(redata.bodyText);
      if (wxInfo.flag == -1) {
        // alert(wxInfo.message);
        return;
      }
      onSuccess(wxInfo.data);
    }, function (redata) {
      if (redata.body.message) {
        // alert(redata.body.message);
      }
    });
  },
  //获取微信相关信息
  getJsShareConf: function getJsShareConf(_this, url, onSuccess) {
    var host = _this.$utils.getAgentApiHost();
    if (false) {
      host = host + '/wechatDev';
    } else {
      host = host + '/wechat';
    }
    _this.$http.get(host + '/Jssdk/shareconf?url=' + url).then(function (redata) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (redata.flag == -1) {
        // alert(redata.message);
        return;
      }
      onSuccess(redata.data);
    }, function (redata) {
      if (redata.message) {
        // alert(redata.message);
      }
    });
  },
  // 扫码
  getJsScanQRCodeConf: function getJsScanQRCodeConf(_this, url, onSuccess) {
    var host = _this.$utils.getAgentApiHost() + '/wechat';
    // let host = '';
    // if(process.env.NODE_ENV=='local'){
    //   host = 'http://web-agent.imcoming.com.cn/wechat'
    // }else if(process.env.NODE_ENV=='development'){
    //   host = 'http://web-agent.imcoming.com.cn/wechat'
    // }else if(process.env.NODE_ENV=='test'){
    //   host = 'http://web-agent.imcoming.com/wechat'
    // }else{
    //   host = 'https://web-agent.anlaiye.com/wechat'
    // }
    //var url = 'http://alywechat.imcoming.com/?school_lock=false';
    _this.$http.get(host + '/Jssdk/qrScanConf?url=' + url).then(function (redata) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (redata.flag == -1) {
        // alert(redata.message);
        return;
      }
      onSuccess(redata.data);
    }, function (redata) {
      if (redata.message) {
        // alert(redata.message);
      }
    });
  }
};

module.exports = {
  actions: actions
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-01.7eefe85.png";

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4649c04c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callNative;
//文档地址：https://cf.jd.com/pages/viewpage.action?pageId=242773483

var adminNative = function adminNative() {};
var emptyFunction = function emptyFunction() {
  console.log("this is empty callback");
};
var errorCallback = function errorCallback(id) {
  console.log("\u539F\u751F\u63A5\u53E3\u8C03\u7528\u9519\u8BEF typeId:" + id);
};
// 初始化bridge
function initJsBridge(readyCallback) {
  window.console.log("======开始初始化bridge======", Date.now());
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        //callback(WebViewJavascriptBridge)
        callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener("WebViewJavascriptBridgeReady", function () {
          window.console.log("======完成初始化bridge======", Date.now());
          callback(window.WebViewJavascriptBridge);
        }, false);
      }
      return;
    }
    if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        // return callback(WebViewJavascriptBridge)
        return callback(window.WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
        window.console.log("======完成初始化bridge======", Date.now(), window.WebViewJavascriptBridge);
      }, 0);
    }
  }
  // 调用注册方法

  connectWebViewJavascriptBridge(function (bridge) {
    readyCallback(bridge);
  });
}

adminNative.initJsBridge = initJsBridge;

// 调起客户端方法  type  方法名  param 参数  responseCallBack 回调
function callHandleAppFunction(type) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var responseCallBack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyFunction;

  if (window.WebViewJavascriptBridge) {
    window.WebViewJavascriptBridge.callHandler(type, param, responseCallBack);
  } else {
    if (responseCallBack) {
      responseCallBack(false);
    }
  }
}

function readyJsBridge(cb) {
  var u = navigator.userAgent;
  var isApp = u.indexOf("yocial") > -1;
  if (isApp) {
    if (window.WebViewJavascriptBridge) {
      cb(window.WebViewJavascriptBridge);
    } else {
      initJsBridge(cb);
    }
  } else {
    cb(false);
  }
}

/**
 * 调用Native函数
 * @param name
 * @param data
 * @param options
 * @return {Promise<any>}
 */
function callNative(name, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    timeout: 0
  };

  return new Promise(function (resolve, reject) {
    var id = void 0;

    if (options.timeout) {
      id = setTimeout(function () {
        return reject('timeout');
      }, options.timeout);
    }

    initJsBridge(function (bridge) {
      // 数据返回可能是 JS Object 或者 String
      bridge.callHandler(name, data, function (res) {
        if (id) clearTimeout(id);

        try {
          resolve(res && typeof res === 'string' ? JSON.parse(res) : res);
        } catch (e) {
          reject(e);
        }
      });
    });
  });
}

//调用原生获取sdkToken
adminNative.getSdkToken = function (param, callback) {
  readyJsBridge(function (bridge) {
    if (bridge) {
      callHandleAppFunction("jsGetRiskControlToken", param, callback);
    } else {
      errorCallback(1);
    }
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = (adminNative);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAI/SURBVEgNzVZBS5RBGH7edYX1kLAQKYZk2eZBTyF4WL12FTIUEg/+AKFbIV06dOsHiKcg8RAKQeBNJPq2UDp4ErTD4mFBsWihaLXU6Zmx73NWZtzZFcSBYd5553mfZ+ad9xs+4Ko1FeEh+3f28Xr2JqFgpZBGhE0F3BFBCW3olhwOQuJTISCDifBYC2ibgjexi8nQ2KCTkDSFAjY49sTEPM02MshJP/7GPt8YdpJPGLUFNBnnt1DBhI/Y9tcUIZlA4bkdlNiCaa43JXOP4U0Xg9P4jC4cYZh38coTD0lxA014iwEUmcJDF86IqI+8UMED7jhH0D3TBbcp1OwKcvlIpAWK5Nni+NWMaSzLALZORCKUSNjhCr6Ij+RlGUI2vpOVi5B5YwUf9NqJSAaTzOeiF9zAAvmW+MGO6VCTLm2Yiy5gjqNZ0L5GGwXeI4tH0os/miNOF0xl5DHOcb5Rch3HXb/jRzoSC2hfImIAwoLNY4LAN3peb2PcAlowevYVSNJlEzJlKT6G3/h9ZG3/eTaJ9jGIayYjZ4BVJ0nW1tFaj4COIz6DVbQnHJbhFtlHr4UJN4/dcW6RI/SFM1tIT5xbBO4dWXQ+05mBYBFe6E9e7gtpRjvtadplh5JTxF1dEXZYYW2ahIAD1toMS/Ol3MdeTMxHVVfeMwKmiG35j/3FCmvlJlgHp813kgqBx+yvKdAjeTyxBQzhEH7w8XtK+y43Mst+SMHfp9Q1LPUF19UaOmvAqpb5B9OhCrhR5bzMyT/Q0Yqz+bT7XQAAAABJRU5ErkJggg=="

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Swiper 3.4.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2017, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: March 10, 2017
 */
!function () {
  "use strict";
  var e,
      a = function a(s, i) {
    function r(e) {
      return Math.floor(e);
    }function n() {
      var e = T.params.autoplay,
          a = T.slides.eq(T.activeIndex);a.attr("data-swiper-autoplay") && (e = a.attr("data-swiper-autoplay") || T.params.autoplay), T.autoplayTimeoutId = setTimeout(function () {
        T.params.loop ? (T.fixLoop(), T._slideNext(), T.emit("onAutoplay", T)) : T.isEnd ? i.autoplayStopOnLast ? T.stopAutoplay() : (T._slideTo(0), T.emit("onAutoplay", T)) : (T._slideNext(), T.emit("onAutoplay", T));
      }, e);
    }function o(a, t) {
      var s = e(a.target);if (!s.is(t)) if ("string" == typeof t) s = s.parents(t);else if (t.nodeType) {
        var i;return s.parents().each(function (e, a) {
          a === t && (i = t);
        }), i ? t : void 0;
      }if (0 !== s.length) return s[0];
    }function l(e, a) {
      a = a || {};var t = window.MutationObserver || window.WebkitMutationObserver,
          s = new t(function (e) {
        e.forEach(function (e) {
          T.onResize(!0), T.emit("onObserverUpdate", T, e);
        });
      });s.observe(e, { attributes: void 0 === a.attributes || a.attributes, childList: void 0 === a.childList || a.childList, characterData: void 0 === a.characterData || a.characterData }), T.observers.push(s);
    }function p(e) {
      e.originalEvent && (e = e.originalEvent);var a = e.keyCode || e.charCode;if (!T.params.allowSwipeToNext && (T.isHorizontal() && 39 === a || !T.isHorizontal() && 40 === a)) return !1;if (!T.params.allowSwipeToPrev && (T.isHorizontal() && 37 === a || !T.isHorizontal() && 38 === a)) return !1;if (!(e.shiftKey || e.altKey || e.ctrlKey || e.metaKey || document.activeElement && document.activeElement.nodeName && ("input" === document.activeElement.nodeName.toLowerCase() || "textarea" === document.activeElement.nodeName.toLowerCase()))) {
        if (37 === a || 39 === a || 38 === a || 40 === a) {
          var t = !1;if (T.container.parents("." + T.params.slideClass).length > 0 && 0 === T.container.parents("." + T.params.slideActiveClass).length) return;var s = { left: window.pageXOffset, top: window.pageYOffset },
              i = window.innerWidth,
              r = window.innerHeight,
              n = T.container.offset();T.rtl && (n.left = n.left - T.container[0].scrollLeft);for (var o = [[n.left, n.top], [n.left + T.width, n.top], [n.left, n.top + T.height], [n.left + T.width, n.top + T.height]], l = 0; l < o.length; l++) {
            var p = o[l];p[0] >= s.left && p[0] <= s.left + i && p[1] >= s.top && p[1] <= s.top + r && (t = !0);
          }if (!t) return;
        }T.isHorizontal() ? (37 !== a && 39 !== a || (e.preventDefault ? e.preventDefault() : e.returnValue = !1), (39 === a && !T.rtl || 37 === a && T.rtl) && T.slideNext(), (37 === a && !T.rtl || 39 === a && T.rtl) && T.slidePrev()) : (38 !== a && 40 !== a || (e.preventDefault ? e.preventDefault() : e.returnValue = !1), 40 === a && T.slideNext(), 38 === a && T.slidePrev()), T.emit("onKeyPress", T, a);
      }
    }function d(e) {
      var a = 0,
          t = 0,
          s = 0,
          i = 0;return "detail" in e && (t = e.detail), "wheelDelta" in e && (t = -e.wheelDelta / 120), "wheelDeltaY" in e && (t = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (a = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (a = t, t = 0), s = 10 * a, i = 10 * t, "deltaY" in e && (i = e.deltaY), "deltaX" in e && (s = e.deltaX), (s || i) && e.deltaMode && (1 === e.deltaMode ? (s *= 40, i *= 40) : (s *= 800, i *= 800)), s && !a && (a = s < 1 ? -1 : 1), i && !t && (t = i < 1 ? -1 : 1), { spinX: a, spinY: t, pixelX: s, pixelY: i };
    }function u(e) {
      e.originalEvent && (e = e.originalEvent);var a = 0,
          t = T.rtl ? -1 : 1,
          s = d(e);if (T.params.mousewheelForceToAxis) {
        if (T.isHorizontal()) {
          if (!(Math.abs(s.pixelX) > Math.abs(s.pixelY))) return;a = s.pixelX * t;
        } else {
          if (!(Math.abs(s.pixelY) > Math.abs(s.pixelX))) return;a = s.pixelY;
        }
      } else a = Math.abs(s.pixelX) > Math.abs(s.pixelY) ? -s.pixelX * t : -s.pixelY;if (0 !== a) {
        if (T.params.mousewheelInvert && (a = -a), T.params.freeMode) {
          var i = T.getWrapperTranslate() + a * T.params.mousewheelSensitivity,
              r = T.isBeginning,
              n = T.isEnd;if (i >= T.minTranslate() && (i = T.minTranslate()), i <= T.maxTranslate() && (i = T.maxTranslate()), T.setWrapperTransition(0), T.setWrapperTranslate(i), T.updateProgress(), T.updateActiveIndex(), (!r && T.isBeginning || !n && T.isEnd) && T.updateClasses(), T.params.freeModeSticky ? (clearTimeout(T.mousewheel.timeout), T.mousewheel.timeout = setTimeout(function () {
            T.slideReset();
          }, 300)) : T.params.lazyLoading && T.lazy && T.lazy.load(), T.emit("onScroll", T, e), T.params.autoplay && T.params.autoplayDisableOnInteraction && T.stopAutoplay(), 0 === i || i === T.maxTranslate()) return;
        } else {
          if (new window.Date().getTime() - T.mousewheel.lastScrollTime > 60) if (a < 0) {
            if (T.isEnd && !T.params.loop || T.animating) {
              if (T.params.mousewheelReleaseOnEdges) return !0;
            } else T.slideNext(), T.emit("onScroll", T, e);
          } else if (T.isBeginning && !T.params.loop || T.animating) {
            if (T.params.mousewheelReleaseOnEdges) return !0;
          } else T.slidePrev(), T.emit("onScroll", T, e);T.mousewheel.lastScrollTime = new window.Date().getTime();
        }return e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1;
      }
    }function c(a, t) {
      a = e(a);var s,
          i,
          r,
          n = T.rtl ? -1 : 1;s = a.attr("data-swiper-parallax") || "0", i = a.attr("data-swiper-parallax-x"), r = a.attr("data-swiper-parallax-y"), i || r ? (i = i || "0", r = r || "0") : T.isHorizontal() ? (i = s, r = "0") : (r = s, i = "0"), i = i.indexOf("%") >= 0 ? parseInt(i, 10) * t * n + "%" : i * t * n + "px", r = r.indexOf("%") >= 0 ? parseInt(r, 10) * t + "%" : r * t + "px", a.transform("translate3d(" + i + ", " + r + ",0px)");
    }function m(e) {
      return 0 !== e.indexOf("on") && (e = e[0] !== e[0].toUpperCase() ? "on" + e[0].toUpperCase() + e.substring(1) : "on" + e), e;
    }if (!(this instanceof a)) return new a(s, i);var h = { direction: "horizontal", touchEventsTarget: "container", initialSlide: 0, speed: 300, autoplay: !1, autoplayDisableOnInteraction: !0, autoplayStopOnLast: !1, iOSEdgeSwipeDetection: !1, iOSEdgeSwipeThreshold: 20, freeMode: !1, freeModeMomentum: !0, freeModeMomentumRatio: 1, freeModeMomentumBounce: !0, freeModeMomentumBounceRatio: 1, freeModeMomentumVelocityRatio: 1, freeModeSticky: !1, freeModeMinimumVelocity: .02, autoHeight: !1, setWrapperSize: !1, virtualTranslate: !1, effect: "slide", coverflow: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: !0 }, flip: { slideShadows: !0, limitRotation: !0 }, cube: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: .94 }, fade: { crossFade: !1 }, parallax: !1, zoom: !1, zoomMax: 3, zoomMin: 1, zoomToggle: !0, scrollbar: null, scrollbarHide: !0, scrollbarDraggable: !1, scrollbarSnapOnRelease: !1, keyboardControl: !1, mousewheelControl: !1, mousewheelReleaseOnEdges: !1, mousewheelInvert: !1, mousewheelForceToAxis: !1, mousewheelSensitivity: 1, mousewheelEventsTarged: "container", hashnav: !1, hashnavWatchState: !1, history: !1, replaceState: !1, breakpoints: void 0, spaceBetween: 0, slidesPerView: 1, slidesPerColumn: 1, slidesPerColumnFill: "column", slidesPerGroup: 1, centeredSlides: !1, slidesOffsetBefore: 0, slidesOffsetAfter: 0, roundLengths: !1, touchRatio: 1, touchAngle: 45, simulateTouch: !0, shortSwipes: !0, longSwipes: !0, longSwipesRatio: .5, longSwipesMs: 300, followFinger: !0, onlyExternal: !1, threshold: 0, touchMoveStopPropagation: !0, touchReleaseOnEdges: !1, uniqueNavElements: !0, pagination: null, paginationElement: "span", paginationClickable: !1, paginationHide: !1, paginationBulletRender: null, paginationProgressRender: null, paginationFractionRender: null, paginationCustomRender: null, paginationType: "bullets", resistance: !0, resistanceRatio: .85, nextButton: null, prevButton: null, watchSlidesProgress: !1, watchSlidesVisibility: !1, grabCursor: !1, preventClicks: !0, preventClicksPropagation: !0, slideToClickedSlide: !1, lazyLoading: !1, lazyLoadingInPrevNext: !1, lazyLoadingInPrevNextAmount: 1, lazyLoadingOnTransitionStart: !1, preloadImages: !0, updateOnImagesReady: !0, loop: !1, loopAdditionalSlides: 0, loopedSlides: null, control: void 0, controlInverse: !1, controlBy: "slide", normalizeSlideIndex: !0, allowSwipeToPrev: !0, allowSwipeToNext: !0, swipeHandler: null, noSwiping: !0, noSwipingClass: "swiper-no-swiping", passiveListeners: !0, containerModifierClass: "swiper-container-", slideClass: "swiper-slide", slideActiveClass: "swiper-slide-active", slideDuplicateActiveClass: "swiper-slide-duplicate-active", slideVisibleClass: "swiper-slide-visible", slideDuplicateClass: "swiper-slide-duplicate", slideNextClass: "swiper-slide-next", slideDuplicateNextClass: "swiper-slide-duplicate-next", slidePrevClass: "swiper-slide-prev", slideDuplicatePrevClass: "swiper-slide-duplicate-prev", wrapperClass: "swiper-wrapper", bulletClass: "swiper-pagination-bullet", bulletActiveClass: "swiper-pagination-bullet-active", buttonDisabledClass: "swiper-button-disabled", paginationCurrentClass: "swiper-pagination-current", paginationTotalClass: "swiper-pagination-total", paginationHiddenClass: "swiper-pagination-hidden", paginationProgressbarClass: "swiper-pagination-progressbar", paginationClickableClass: "swiper-pagination-clickable", paginationModifierClass: "swiper-pagination-", lazyLoadingClass: "swiper-lazy", lazyStatusLoadingClass: "swiper-lazy-loading", lazyStatusLoadedClass: "swiper-lazy-loaded", lazyPreloaderClass: "swiper-lazy-preloader", notificationClass: "swiper-notification", preloaderClass: "preloader", zoomContainerClass: "swiper-zoom-container", observer: !1, observeParents: !1, a11y: !1, prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", runCallbacksOnInit: !0 },
        g = i && i.virtualTranslate;i = i || {};var f = {};for (var v in i) {
      if ("object" != _typeof(i[v]) || null === i[v] || i[v].nodeType || i[v] === window || i[v] === document || void 0 !== t && i[v] instanceof t || "undefined" != typeof jQuery && i[v] instanceof jQuery) f[v] = i[v];else {
        f[v] = {};for (var w in i[v]) {
          f[v][w] = i[v][w];
        }
      }
    }for (var y in h) {
      if (void 0 === i[y]) i[y] = h[y];else if ("object" == _typeof(i[y])) for (var x in h[y]) {
        void 0 === i[y][x] && (i[y][x] = h[y][x]);
      }
    }var T = this;if (T.params = i, T.originalParams = f, T.classNames = [], void 0 !== e && void 0 !== t && (e = t), (void 0 !== e || (e = void 0 === t ? window.Dom7 || window.Zepto || window.jQuery : t)) && (T.$ = e, T.currentBreakpoint = void 0, T.getActiveBreakpoint = function () {
      if (!T.params.breakpoints) return !1;var e,
          a = !1,
          t = [];for (e in T.params.breakpoints) {
        T.params.breakpoints.hasOwnProperty(e) && t.push(e);
      }t.sort(function (e, a) {
        return parseInt(e, 10) > parseInt(a, 10);
      });for (var s = 0; s < t.length; s++) {
        (e = t[s]) >= window.innerWidth && !a && (a = e);
      }return a || "max";
    }, T.setBreakpoint = function () {
      var e = T.getActiveBreakpoint();if (e && T.currentBreakpoint !== e) {
        var a = e in T.params.breakpoints ? T.params.breakpoints[e] : T.originalParams,
            t = T.params.loop && a.slidesPerView !== T.params.slidesPerView;for (var s in a) {
          T.params[s] = a[s];
        }T.currentBreakpoint = e, t && T.destroyLoop && T.reLoop(!0);
      }
    }, T.params.breakpoints && T.setBreakpoint(), T.container = e(s), 0 !== T.container.length)) {
      if (T.container.length > 1) {
        var b = [];return T.container.each(function () {
          b.push(new a(this, i));
        }), b;
      }T.container[0].swiper = T, T.container.data("swiper", T), T.classNames.push(T.params.containerModifierClass + T.params.direction), T.params.freeMode && T.classNames.push(T.params.containerModifierClass + "free-mode"), T.support.flexbox || (T.classNames.push(T.params.containerModifierClass + "no-flexbox"), T.params.slidesPerColumn = 1), T.params.autoHeight && T.classNames.push(T.params.containerModifierClass + "autoheight"), (T.params.parallax || T.params.watchSlidesVisibility) && (T.params.watchSlidesProgress = !0), T.params.touchReleaseOnEdges && (T.params.resistanceRatio = 0), ["cube", "coverflow", "flip"].indexOf(T.params.effect) >= 0 && (T.support.transforms3d ? (T.params.watchSlidesProgress = !0, T.classNames.push(T.params.containerModifierClass + "3d")) : T.params.effect = "slide"), "slide" !== T.params.effect && T.classNames.push(T.params.containerModifierClass + T.params.effect), "cube" === T.params.effect && (T.params.resistanceRatio = 0, T.params.slidesPerView = 1, T.params.slidesPerColumn = 1, T.params.slidesPerGroup = 1, T.params.centeredSlides = !1, T.params.spaceBetween = 0, T.params.virtualTranslate = !0), "fade" !== T.params.effect && "flip" !== T.params.effect || (T.params.slidesPerView = 1, T.params.slidesPerColumn = 1, T.params.slidesPerGroup = 1, T.params.watchSlidesProgress = !0, T.params.spaceBetween = 0, void 0 === g && (T.params.virtualTranslate = !0)), T.params.grabCursor && T.support.touch && (T.params.grabCursor = !1), T.wrapper = T.container.children("." + T.params.wrapperClass), T.params.pagination && (T.paginationContainer = e(T.params.pagination), T.params.uniqueNavElements && "string" == typeof T.params.pagination && T.paginationContainer.length > 1 && 1 === T.container.find(T.params.pagination).length && (T.paginationContainer = T.container.find(T.params.pagination)), "bullets" === T.params.paginationType && T.params.paginationClickable ? T.paginationContainer.addClass(T.params.paginationModifierClass + "clickable") : T.params.paginationClickable = !1, T.paginationContainer.addClass(T.params.paginationModifierClass + T.params.paginationType)), (T.params.nextButton || T.params.prevButton) && (T.params.nextButton && (T.nextButton = e(T.params.nextButton), T.params.uniqueNavElements && "string" == typeof T.params.nextButton && T.nextButton.length > 1 && 1 === T.container.find(T.params.nextButton).length && (T.nextButton = T.container.find(T.params.nextButton))), T.params.prevButton && (T.prevButton = e(T.params.prevButton), T.params.uniqueNavElements && "string" == typeof T.params.prevButton && T.prevButton.length > 1 && 1 === T.container.find(T.params.prevButton).length && (T.prevButton = T.container.find(T.params.prevButton)))), T.isHorizontal = function () {
        return "horizontal" === T.params.direction;
      }, T.rtl = T.isHorizontal() && ("rtl" === T.container[0].dir.toLowerCase() || "rtl" === T.container.css("direction")), T.rtl && T.classNames.push(T.params.containerModifierClass + "rtl"), T.rtl && (T.wrongRTL = "-webkit-box" === T.wrapper.css("display")), T.params.slidesPerColumn > 1 && T.classNames.push(T.params.containerModifierClass + "multirow"), T.device.android && T.classNames.push(T.params.containerModifierClass + "android"), T.container.addClass(T.classNames.join(" ")), T.translate = 0, T.progress = 0, T.velocity = 0, T.lockSwipeToNext = function () {
        T.params.allowSwipeToNext = !1, T.params.allowSwipeToPrev === !1 && T.params.grabCursor && T.unsetGrabCursor();
      }, T.lockSwipeToPrev = function () {
        T.params.allowSwipeToPrev = !1, T.params.allowSwipeToNext === !1 && T.params.grabCursor && T.unsetGrabCursor();
      }, T.lockSwipes = function () {
        T.params.allowSwipeToNext = T.params.allowSwipeToPrev = !1, T.params.grabCursor && T.unsetGrabCursor();
      }, T.unlockSwipeToNext = function () {
        T.params.allowSwipeToNext = !0, T.params.allowSwipeToPrev === !0 && T.params.grabCursor && T.setGrabCursor();
      }, T.unlockSwipeToPrev = function () {
        T.params.allowSwipeToPrev = !0, T.params.allowSwipeToNext === !0 && T.params.grabCursor && T.setGrabCursor();
      }, T.unlockSwipes = function () {
        T.params.allowSwipeToNext = T.params.allowSwipeToPrev = !0, T.params.grabCursor && T.setGrabCursor();
      }, T.setGrabCursor = function (e) {
        T.container[0].style.cursor = "move", T.container[0].style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", T.container[0].style.cursor = e ? "-moz-grabbin" : "-moz-grab", T.container[0].style.cursor = e ? "grabbing" : "grab";
      }, T.unsetGrabCursor = function () {
        T.container[0].style.cursor = "";
      }, T.params.grabCursor && T.setGrabCursor(), T.imagesToLoad = [], T.imagesLoaded = 0, T.loadImage = function (e, a, t, s, i, r) {
        function n() {
          r && r();
        }var o;e.complete && i ? n() : a ? (o = new window.Image(), o.onload = n, o.onerror = n, s && (o.sizes = s), t && (o.srcset = t), a && (o.src = a)) : n();
      }, T.preloadImages = function () {
        function e() {
          void 0 !== T && null !== T && T && (void 0 !== T.imagesLoaded && T.imagesLoaded++, T.imagesLoaded === T.imagesToLoad.length && (T.params.updateOnImagesReady && T.update(), T.emit("onImagesReady", T)));
        }T.imagesToLoad = T.container.find("img");for (var a = 0; a < T.imagesToLoad.length; a++) {
          T.loadImage(T.imagesToLoad[a], T.imagesToLoad[a].currentSrc || T.imagesToLoad[a].getAttribute("src"), T.imagesToLoad[a].srcset || T.imagesToLoad[a].getAttribute("srcset"), T.imagesToLoad[a].sizes || T.imagesToLoad[a].getAttribute("sizes"), !0, e);
        }
      }, T.autoplayTimeoutId = void 0, T.autoplaying = !1, T.autoplayPaused = !1, T.startAutoplay = function () {
        return void 0 === T.autoplayTimeoutId && !!T.params.autoplay && !T.autoplaying && (T.autoplaying = !0, T.emit("onAutoplayStart", T), void n());
      }, T.stopAutoplay = function (e) {
        T.autoplayTimeoutId && (T.autoplayTimeoutId && clearTimeout(T.autoplayTimeoutId), T.autoplaying = !1, T.autoplayTimeoutId = void 0, T.emit("onAutoplayStop", T));
      }, T.pauseAutoplay = function (e) {
        T.autoplayPaused || (T.autoplayTimeoutId && clearTimeout(T.autoplayTimeoutId), T.autoplayPaused = !0, 0 === e ? (T.autoplayPaused = !1, n()) : T.wrapper.transitionEnd(function () {
          T && (T.autoplayPaused = !1, T.autoplaying ? n() : T.stopAutoplay());
        }));
      }, T.minTranslate = function () {
        return -T.snapGrid[0];
      }, T.maxTranslate = function () {
        return -T.snapGrid[T.snapGrid.length - 1];
      }, T.updateAutoHeight = function () {
        var e,
            a = [],
            t = 0;if ("auto" !== T.params.slidesPerView && T.params.slidesPerView > 1) for (e = 0; e < Math.ceil(T.params.slidesPerView); e++) {
          var s = T.activeIndex + e;if (s > T.slides.length) break;a.push(T.slides.eq(s)[0]);
        } else a.push(T.slides.eq(T.activeIndex)[0]);for (e = 0; e < a.length; e++) {
          if (void 0 !== a[e]) {
            var i = a[e].offsetHeight;t = i > t ? i : t;
          }
        }t && T.wrapper.css("height", t + "px");
      }, T.updateContainerSize = function () {
        var e, a;e = void 0 !== T.params.width ? T.params.width : T.container[0].clientWidth, a = void 0 !== T.params.height ? T.params.height : T.container[0].clientHeight, 0 === e && T.isHorizontal() || 0 === a && !T.isHorizontal() || (e = e - parseInt(T.container.css("padding-left"), 10) - parseInt(T.container.css("padding-right"), 10), a = a - parseInt(T.container.css("padding-top"), 10) - parseInt(T.container.css("padding-bottom"), 10), T.width = e, T.height = a, T.size = T.isHorizontal() ? T.width : T.height);
      }, T.updateSlidesSize = function () {
        T.slides = T.wrapper.children("." + T.params.slideClass), T.snapGrid = [], T.slidesGrid = [], T.slidesSizesGrid = [];var e,
            a = T.params.spaceBetween,
            t = -T.params.slidesOffsetBefore,
            s = 0,
            i = 0;if (void 0 !== T.size) {
          "string" == typeof a && a.indexOf("%") >= 0 && (a = parseFloat(a.replace("%", "")) / 100 * T.size), T.virtualSize = -a, T.rtl ? T.slides.css({ marginLeft: "", marginTop: "" }) : T.slides.css({ marginRight: "", marginBottom: "" });var n;T.params.slidesPerColumn > 1 && (n = Math.floor(T.slides.length / T.params.slidesPerColumn) === T.slides.length / T.params.slidesPerColumn ? T.slides.length : Math.ceil(T.slides.length / T.params.slidesPerColumn) * T.params.slidesPerColumn, "auto" !== T.params.slidesPerView && "row" === T.params.slidesPerColumnFill && (n = Math.max(n, T.params.slidesPerView * T.params.slidesPerColumn)));var o,
              l = T.params.slidesPerColumn,
              p = n / l,
              d = p - (T.params.slidesPerColumn * p - T.slides.length);for (e = 0; e < T.slides.length; e++) {
            o = 0;var u = T.slides.eq(e);if (T.params.slidesPerColumn > 1) {
              var c, m, h;"column" === T.params.slidesPerColumnFill ? (m = Math.floor(e / l), h = e - m * l, (m > d || m === d && h === l - 1) && ++h >= l && (h = 0, m++), c = m + h * n / l, u.css({ "-webkit-box-ordinal-group": c, "-moz-box-ordinal-group": c, "-ms-flex-order": c, "-webkit-order": c, order: c })) : (h = Math.floor(e / p), m = e - h * p), u.css("margin-" + (T.isHorizontal() ? "top" : "left"), 0 !== h && T.params.spaceBetween && T.params.spaceBetween + "px").attr("data-swiper-column", m).attr("data-swiper-row", h);
            }"none" !== u.css("display") && ("auto" === T.params.slidesPerView ? (o = T.isHorizontal() ? u.outerWidth(!0) : u.outerHeight(!0), T.params.roundLengths && (o = r(o))) : (o = (T.size - (T.params.slidesPerView - 1) * a) / T.params.slidesPerView, T.params.roundLengths && (o = r(o)), T.isHorizontal() ? T.slides[e].style.width = o + "px" : T.slides[e].style.height = o + "px"), T.slides[e].swiperSlideSize = o, T.slidesSizesGrid.push(o), T.params.centeredSlides ? (t = t + o / 2 + s / 2 + a, 0 === s && 0 !== e && (t = t - T.size / 2 - a), 0 === e && (t = t - T.size / 2 - a), Math.abs(t) < .001 && (t = 0), i % T.params.slidesPerGroup == 0 && T.snapGrid.push(t), T.slidesGrid.push(t)) : (i % T.params.slidesPerGroup == 0 && T.snapGrid.push(t), T.slidesGrid.push(t), t = t + o + a), T.virtualSize += o + a, s = o, i++);
          }T.virtualSize = Math.max(T.virtualSize, T.size) + T.params.slidesOffsetAfter;var g;if (T.rtl && T.wrongRTL && ("slide" === T.params.effect || "coverflow" === T.params.effect) && T.wrapper.css({ width: T.virtualSize + T.params.spaceBetween + "px" }), T.support.flexbox && !T.params.setWrapperSize || (T.isHorizontal() ? T.wrapper.css({ width: T.virtualSize + T.params.spaceBetween + "px" }) : T.wrapper.css({ height: T.virtualSize + T.params.spaceBetween + "px" })), T.params.slidesPerColumn > 1 && (T.virtualSize = (o + T.params.spaceBetween) * n, T.virtualSize = Math.ceil(T.virtualSize / T.params.slidesPerColumn) - T.params.spaceBetween, T.isHorizontal() ? T.wrapper.css({ width: T.virtualSize + T.params.spaceBetween + "px" }) : T.wrapper.css({ height: T.virtualSize + T.params.spaceBetween + "px" }), T.params.centeredSlides)) {
            for (g = [], e = 0; e < T.snapGrid.length; e++) {
              T.snapGrid[e] < T.virtualSize + T.snapGrid[0] && g.push(T.snapGrid[e]);
            }T.snapGrid = g;
          }if (!T.params.centeredSlides) {
            for (g = [], e = 0; e < T.snapGrid.length; e++) {
              T.snapGrid[e] <= T.virtualSize - T.size && g.push(T.snapGrid[e]);
            }T.snapGrid = g, Math.floor(T.virtualSize - T.size) - Math.floor(T.snapGrid[T.snapGrid.length - 1]) > 1 && T.snapGrid.push(T.virtualSize - T.size);
          }0 === T.snapGrid.length && (T.snapGrid = [0]), 0 !== T.params.spaceBetween && (T.isHorizontal() ? T.rtl ? T.slides.css({ marginLeft: a + "px" }) : T.slides.css({ marginRight: a + "px" }) : T.slides.css({ marginBottom: a + "px" })), T.params.watchSlidesProgress && T.updateSlidesOffset();
        }
      }, T.updateSlidesOffset = function () {
        for (var e = 0; e < T.slides.length; e++) {
          T.slides[e].swiperSlideOffset = T.isHorizontal() ? T.slides[e].offsetLeft : T.slides[e].offsetTop;
        }
      }, T.currentSlidesPerView = function () {
        var e,
            a,
            t = 1;if (T.params.centeredSlides) {
          var s,
              i = T.slides[T.activeIndex].swiperSlideSize;for (e = T.activeIndex + 1; e < T.slides.length; e++) {
            T.slides[e] && !s && (i += T.slides[e].swiperSlideSize, t++, i > T.size && (s = !0));
          }for (a = T.activeIndex - 1; a >= 0; a--) {
            T.slides[a] && !s && (i += T.slides[a].swiperSlideSize, t++, i > T.size && (s = !0));
          }
        } else for (e = T.activeIndex + 1; e < T.slides.length; e++) {
          T.slidesGrid[e] - T.slidesGrid[T.activeIndex] < T.size && t++;
        }return t;
      }, T.updateSlidesProgress = function (e) {
        if (void 0 === e && (e = T.translate || 0), 0 !== T.slides.length) {
          void 0 === T.slides[0].swiperSlideOffset && T.updateSlidesOffset();var a = -e;T.rtl && (a = e), T.slides.removeClass(T.params.slideVisibleClass);for (var t = 0; t < T.slides.length; t++) {
            var s = T.slides[t],
                i = (a + (T.params.centeredSlides ? T.minTranslate() : 0) - s.swiperSlideOffset) / (s.swiperSlideSize + T.params.spaceBetween);if (T.params.watchSlidesVisibility) {
              var r = -(a - s.swiperSlideOffset),
                  n = r + T.slidesSizesGrid[t];(r >= 0 && r < T.size || n > 0 && n <= T.size || r <= 0 && n >= T.size) && T.slides.eq(t).addClass(T.params.slideVisibleClass);
            }s.progress = T.rtl ? -i : i;
          }
        }
      }, T.updateProgress = function (e) {
        void 0 === e && (e = T.translate || 0);var a = T.maxTranslate() - T.minTranslate(),
            t = T.isBeginning,
            s = T.isEnd;0 === a ? (T.progress = 0, T.isBeginning = T.isEnd = !0) : (T.progress = (e - T.minTranslate()) / a, T.isBeginning = T.progress <= 0, T.isEnd = T.progress >= 1), T.isBeginning && !t && T.emit("onReachBeginning", T), T.isEnd && !s && T.emit("onReachEnd", T), T.params.watchSlidesProgress && T.updateSlidesProgress(e), T.emit("onProgress", T, T.progress);
      }, T.updateActiveIndex = function () {
        var e,
            a,
            t,
            s = T.rtl ? T.translate : -T.translate;for (a = 0; a < T.slidesGrid.length; a++) {
          void 0 !== T.slidesGrid[a + 1] ? s >= T.slidesGrid[a] && s < T.slidesGrid[a + 1] - (T.slidesGrid[a + 1] - T.slidesGrid[a]) / 2 ? e = a : s >= T.slidesGrid[a] && s < T.slidesGrid[a + 1] && (e = a + 1) : s >= T.slidesGrid[a] && (e = a);
        }T.params.normalizeSlideIndex && (e < 0 || void 0 === e) && (e = 0), t = Math.floor(e / T.params.slidesPerGroup), t >= T.snapGrid.length && (t = T.snapGrid.length - 1), e !== T.activeIndex && (T.snapIndex = t, T.previousIndex = T.activeIndex, T.activeIndex = e, T.updateClasses(), T.updateRealIndex());
      }, T.updateRealIndex = function () {
        T.realIndex = parseInt(T.slides.eq(T.activeIndex).attr("data-swiper-slide-index") || T.activeIndex, 10);
      }, T.updateClasses = function () {
        T.slides.removeClass(T.params.slideActiveClass + " " + T.params.slideNextClass + " " + T.params.slidePrevClass + " " + T.params.slideDuplicateActiveClass + " " + T.params.slideDuplicateNextClass + " " + T.params.slideDuplicatePrevClass);var a = T.slides.eq(T.activeIndex);a.addClass(T.params.slideActiveClass), i.loop && (a.hasClass(T.params.slideDuplicateClass) ? T.wrapper.children("." + T.params.slideClass + ":not(." + T.params.slideDuplicateClass + ')[data-swiper-slide-index="' + T.realIndex + '"]').addClass(T.params.slideDuplicateActiveClass) : T.wrapper.children("." + T.params.slideClass + "." + T.params.slideDuplicateClass + '[data-swiper-slide-index="' + T.realIndex + '"]').addClass(T.params.slideDuplicateActiveClass));var t = a.next("." + T.params.slideClass).addClass(T.params.slideNextClass);T.params.loop && 0 === t.length && (t = T.slides.eq(0), t.addClass(T.params.slideNextClass));var s = a.prev("." + T.params.slideClass).addClass(T.params.slidePrevClass);if (T.params.loop && 0 === s.length && (s = T.slides.eq(-1), s.addClass(T.params.slidePrevClass)), i.loop && (t.hasClass(T.params.slideDuplicateClass) ? T.wrapper.children("." + T.params.slideClass + ":not(." + T.params.slideDuplicateClass + ')[data-swiper-slide-index="' + t.attr("data-swiper-slide-index") + '"]').addClass(T.params.slideDuplicateNextClass) : T.wrapper.children("." + T.params.slideClass + "." + T.params.slideDuplicateClass + '[data-swiper-slide-index="' + t.attr("data-swiper-slide-index") + '"]').addClass(T.params.slideDuplicateNextClass), s.hasClass(T.params.slideDuplicateClass) ? T.wrapper.children("." + T.params.slideClass + ":not(." + T.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.attr("data-swiper-slide-index") + '"]').addClass(T.params.slideDuplicatePrevClass) : T.wrapper.children("." + T.params.slideClass + "." + T.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.attr("data-swiper-slide-index") + '"]').addClass(T.params.slideDuplicatePrevClass)), T.paginationContainer && T.paginationContainer.length > 0) {
          var r,
              n = T.params.loop ? Math.ceil((T.slides.length - 2 * T.loopedSlides) / T.params.slidesPerGroup) : T.snapGrid.length;if (T.params.loop ? (r = Math.ceil((T.activeIndex - T.loopedSlides) / T.params.slidesPerGroup), r > T.slides.length - 1 - 2 * T.loopedSlides && (r -= T.slides.length - 2 * T.loopedSlides), r > n - 1 && (r -= n), r < 0 && "bullets" !== T.params.paginationType && (r = n + r)) : r = void 0 !== T.snapIndex ? T.snapIndex : T.activeIndex || 0, "bullets" === T.params.paginationType && T.bullets && T.bullets.length > 0 && (T.bullets.removeClass(T.params.bulletActiveClass), T.paginationContainer.length > 1 ? T.bullets.each(function () {
            e(this).index() === r && e(this).addClass(T.params.bulletActiveClass);
          }) : T.bullets.eq(r).addClass(T.params.bulletActiveClass)), "fraction" === T.params.paginationType && (T.paginationContainer.find("." + T.params.paginationCurrentClass).text(r + 1), T.paginationContainer.find("." + T.params.paginationTotalClass).text(n)), "progress" === T.params.paginationType) {
            var o = (r + 1) / n,
                l = o,
                p = 1;T.isHorizontal() || (p = o, l = 1), T.paginationContainer.find("." + T.params.paginationProgressbarClass).transform("translate3d(0,0,0) scaleX(" + l + ") scaleY(" + p + ")").transition(T.params.speed);
          }"custom" === T.params.paginationType && T.params.paginationCustomRender && (T.paginationContainer.html(T.params.paginationCustomRender(T, r + 1, n)), T.emit("onPaginationRendered", T, T.paginationContainer[0]));
        }T.params.loop || (T.params.prevButton && T.prevButton && T.prevButton.length > 0 && (T.isBeginning ? (T.prevButton.addClass(T.params.buttonDisabledClass), T.params.a11y && T.a11y && T.a11y.disable(T.prevButton)) : (T.prevButton.removeClass(T.params.buttonDisabledClass), T.params.a11y && T.a11y && T.a11y.enable(T.prevButton))), T.params.nextButton && T.nextButton && T.nextButton.length > 0 && (T.isEnd ? (T.nextButton.addClass(T.params.buttonDisabledClass), T.params.a11y && T.a11y && T.a11y.disable(T.nextButton)) : (T.nextButton.removeClass(T.params.buttonDisabledClass), T.params.a11y && T.a11y && T.a11y.enable(T.nextButton))));
      }, T.updatePagination = function () {
        if (T.params.pagination && T.paginationContainer && T.paginationContainer.length > 0) {
          var e = "";if ("bullets" === T.params.paginationType) {
            for (var a = T.params.loop ? Math.ceil((T.slides.length - 2 * T.loopedSlides) / T.params.slidesPerGroup) : T.snapGrid.length, t = 0; t < a; t++) {
              e += T.params.paginationBulletRender ? T.params.paginationBulletRender(T, t, T.params.bulletClass) : "<" + T.params.paginationElement + ' class="' + T.params.bulletClass + '"></' + T.params.paginationElement + ">";
            }T.paginationContainer.html(e), T.bullets = T.paginationContainer.find("." + T.params.bulletClass), T.params.paginationClickable && T.params.a11y && T.a11y && T.a11y.initPagination();
          }"fraction" === T.params.paginationType && (e = T.params.paginationFractionRender ? T.params.paginationFractionRender(T, T.params.paginationCurrentClass, T.params.paginationTotalClass) : '<span class="' + T.params.paginationCurrentClass + '"></span> / <span class="' + T.params.paginationTotalClass + '"></span>', T.paginationContainer.html(e)), "progress" === T.params.paginationType && (e = T.params.paginationProgressRender ? T.params.paginationProgressRender(T, T.params.paginationProgressbarClass) : '<span class="' + T.params.paginationProgressbarClass + '"></span>', T.paginationContainer.html(e)), "custom" !== T.params.paginationType && T.emit("onPaginationRendered", T, T.paginationContainer[0]);
        }
      }, T.update = function (e) {
        function a() {
          T.rtl, T.translate;t = Math.min(Math.max(T.translate, T.maxTranslate()), T.minTranslate()), T.setWrapperTranslate(t), T.updateActiveIndex(), T.updateClasses();
        }if (T) {
          T.updateContainerSize(), T.updateSlidesSize(), T.updateProgress(), T.updatePagination(), T.updateClasses(), T.params.scrollbar && T.scrollbar && T.scrollbar.set();var t;if (e) {
            T.controller && T.controller.spline && (T.controller.spline = void 0), T.params.freeMode ? (a(), T.params.autoHeight && T.updateAutoHeight()) : (("auto" === T.params.slidesPerView || T.params.slidesPerView > 1) && T.isEnd && !T.params.centeredSlides ? T.slideTo(T.slides.length - 1, 0, !1, !0) : T.slideTo(T.activeIndex, 0, !1, !0)) || a();
          } else T.params.autoHeight && T.updateAutoHeight();
        }
      }, T.onResize = function (e) {
        T.params.onBeforeResize && T.params.onBeforeResize(T), T.params.breakpoints && T.setBreakpoint();var a = T.params.allowSwipeToPrev,
            t = T.params.allowSwipeToNext;T.params.allowSwipeToPrev = T.params.allowSwipeToNext = !0, T.updateContainerSize(), T.updateSlidesSize(), ("auto" === T.params.slidesPerView || T.params.freeMode || e) && T.updatePagination(), T.params.scrollbar && T.scrollbar && T.scrollbar.set(), T.controller && T.controller.spline && (T.controller.spline = void 0);var s = !1;if (T.params.freeMode) {
          var i = Math.min(Math.max(T.translate, T.maxTranslate()), T.minTranslate());T.setWrapperTranslate(i), T.updateActiveIndex(), T.updateClasses(), T.params.autoHeight && T.updateAutoHeight();
        } else T.updateClasses(), s = ("auto" === T.params.slidesPerView || T.params.slidesPerView > 1) && T.isEnd && !T.params.centeredSlides ? T.slideTo(T.slides.length - 1, 0, !1, !0) : T.slideTo(T.activeIndex, 0, !1, !0);T.params.lazyLoading && !s && T.lazy && T.lazy.load(), T.params.allowSwipeToPrev = a, T.params.allowSwipeToNext = t, T.params.onAfterResize && T.params.onAfterResize(T);
      }, T.touchEventsDesktop = { start: "mousedown", move: "mousemove", end: "mouseup" }, window.navigator.pointerEnabled ? T.touchEventsDesktop = { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled && (T.touchEventsDesktop = { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" }), T.touchEvents = { start: T.support.touch || !T.params.simulateTouch ? "touchstart" : T.touchEventsDesktop.start, move: T.support.touch || !T.params.simulateTouch ? "touchmove" : T.touchEventsDesktop.move, end: T.support.touch || !T.params.simulateTouch ? "touchend" : T.touchEventsDesktop.end }, (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && ("container" === T.params.touchEventsTarget ? T.container : T.wrapper).addClass("swiper-wp8-" + T.params.direction), T.initEvents = function (e) {
        var a = e ? "off" : "on",
            t = e ? "removeEventListener" : "addEventListener",
            s = "container" === T.params.touchEventsTarget ? T.container[0] : T.wrapper[0],
            r = T.support.touch ? s : document,
            n = !!T.params.nested;if (T.browser.ie) s[t](T.touchEvents.start, T.onTouchStart, !1), r[t](T.touchEvents.move, T.onTouchMove, n), r[t](T.touchEvents.end, T.onTouchEnd, !1);else {
          if (T.support.touch) {
            var o = !("touchstart" !== T.touchEvents.start || !T.support.passiveListener || !T.params.passiveListeners) && { passive: !0, capture: !1 };s[t](T.touchEvents.start, T.onTouchStart, o), s[t](T.touchEvents.move, T.onTouchMove, n), s[t](T.touchEvents.end, T.onTouchEnd, o);
          }(i.simulateTouch && !T.device.ios && !T.device.android || i.simulateTouch && !T.support.touch && T.device.ios) && (s[t]("mousedown", T.onTouchStart, !1), document[t]("mousemove", T.onTouchMove, n), document[t]("mouseup", T.onTouchEnd, !1));
        }window[t]("resize", T.onResize), T.params.nextButton && T.nextButton && T.nextButton.length > 0 && (T.nextButton[a]("click", T.onClickNext), T.params.a11y && T.a11y && T.nextButton[a]("keydown", T.a11y.onEnterKey)), T.params.prevButton && T.prevButton && T.prevButton.length > 0 && (T.prevButton[a]("click", T.onClickPrev), T.params.a11y && T.a11y && T.prevButton[a]("keydown", T.a11y.onEnterKey)), T.params.pagination && T.params.paginationClickable && (T.paginationContainer[a]("click", "." + T.params.bulletClass, T.onClickIndex), T.params.a11y && T.a11y && T.paginationContainer[a]("keydown", "." + T.params.bulletClass, T.a11y.onEnterKey)), (T.params.preventClicks || T.params.preventClicksPropagation) && s[t]("click", T.preventClicks, !0);
      }, T.attachEvents = function () {
        T.initEvents();
      }, T.detachEvents = function () {
        T.initEvents(!0);
      }, T.allowClick = !0, T.preventClicks = function (e) {
        T.allowClick || (T.params.preventClicks && e.preventDefault(), T.params.preventClicksPropagation && T.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
      }, T.onClickNext = function (e) {
        e.preventDefault(), T.isEnd && !T.params.loop || T.slideNext();
      }, T.onClickPrev = function (e) {
        e.preventDefault(), T.isBeginning && !T.params.loop || T.slidePrev();
      }, T.onClickIndex = function (a) {
        a.preventDefault();var t = e(this).index() * T.params.slidesPerGroup;T.params.loop && (t += T.loopedSlides), T.slideTo(t);
      }, T.updateClickedSlide = function (a) {
        var t = o(a, "." + T.params.slideClass),
            s = !1;if (t) for (var i = 0; i < T.slides.length; i++) {
          T.slides[i] === t && (s = !0);
        }if (!t || !s) return T.clickedSlide = void 0, void (T.clickedIndex = void 0);if (T.clickedSlide = t, T.clickedIndex = e(t).index(), T.params.slideToClickedSlide && void 0 !== T.clickedIndex && T.clickedIndex !== T.activeIndex) {
          var r,
              n = T.clickedIndex,
              l = "auto" === T.params.slidesPerView ? T.currentSlidesPerView() : T.params.slidesPerView;if (T.params.loop) {
            if (T.animating) return;r = parseInt(e(T.clickedSlide).attr("data-swiper-slide-index"), 10), T.params.centeredSlides ? n < T.loopedSlides - l / 2 || n > T.slides.length - T.loopedSlides + l / 2 ? (T.fixLoop(), n = T.wrapper.children("." + T.params.slideClass + '[data-swiper-slide-index="' + r + '"]:not(.' + T.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
              T.slideTo(n);
            }, 0)) : T.slideTo(n) : n > T.slides.length - l ? (T.fixLoop(), n = T.wrapper.children("." + T.params.slideClass + '[data-swiper-slide-index="' + r + '"]:not(.' + T.params.slideDuplicateClass + ")").eq(0).index(), setTimeout(function () {
              T.slideTo(n);
            }, 0)) : T.slideTo(n);
          } else T.slideTo(n);
        }
      };var S,
          C,
          z,
          M,
          E,
          P,
          I,
          k,
          L,
          D,
          B = "input, select, textarea, button, video",
          H = Date.now(),
          G = [];T.animating = !1, T.touches = { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 };var X, A;T.onTouchStart = function (a) {
        if (a.originalEvent && (a = a.originalEvent), (X = "touchstart" === a.type) || !("which" in a) || 3 !== a.which) {
          if (T.params.noSwiping && o(a, "." + T.params.noSwipingClass)) return void (T.allowClick = !0);if (!T.params.swipeHandler || o(a, T.params.swipeHandler)) {
            var t = T.touches.currentX = "touchstart" === a.type ? a.targetTouches[0].pageX : a.pageX,
                s = T.touches.currentY = "touchstart" === a.type ? a.targetTouches[0].pageY : a.pageY;if (!(T.device.ios && T.params.iOSEdgeSwipeDetection && t <= T.params.iOSEdgeSwipeThreshold)) {
              if (S = !0, C = !1, z = !0, E = void 0, A = void 0, T.touches.startX = t, T.touches.startY = s, M = Date.now(), T.allowClick = !0, T.updateContainerSize(), T.swipeDirection = void 0, T.params.threshold > 0 && (k = !1), "touchstart" !== a.type) {
                var i = !0;e(a.target).is(B) && (i = !1), document.activeElement && e(document.activeElement).is(B) && document.activeElement.blur(), i && a.preventDefault();
              }T.emit("onTouchStart", T, a);
            }
          }
        }
      }, T.onTouchMove = function (a) {
        if (a.originalEvent && (a = a.originalEvent), !X || "mousemove" !== a.type) {
          if (a.preventedByNestedSwiper) return T.touches.startX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, void (T.touches.startY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY);if (T.params.onlyExternal) return T.allowClick = !1, void (S && (T.touches.startX = T.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, T.touches.startY = T.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, M = Date.now()));if (X && T.params.touchReleaseOnEdges && !T.params.loop) if (T.isHorizontal()) {
            if (T.touches.currentX < T.touches.startX && T.translate <= T.maxTranslate() || T.touches.currentX > T.touches.startX && T.translate >= T.minTranslate()) return;
          } else if (T.touches.currentY < T.touches.startY && T.translate <= T.maxTranslate() || T.touches.currentY > T.touches.startY && T.translate >= T.minTranslate()) return;if (X && document.activeElement && a.target === document.activeElement && e(a.target).is(B)) return C = !0, void (T.allowClick = !1);if (z && T.emit("onTouchMove", T, a), !(a.targetTouches && a.targetTouches.length > 1)) {
            if (T.touches.currentX = "touchmove" === a.type ? a.targetTouches[0].pageX : a.pageX, T.touches.currentY = "touchmove" === a.type ? a.targetTouches[0].pageY : a.pageY, void 0 === E) {
              var t;T.isHorizontal() && T.touches.currentY === T.touches.startY || !T.isHorizontal() && T.touches.currentX === T.touches.startX ? E = !1 : (t = 180 * Math.atan2(Math.abs(T.touches.currentY - T.touches.startY), Math.abs(T.touches.currentX - T.touches.startX)) / Math.PI, E = T.isHorizontal() ? t > T.params.touchAngle : 90 - t > T.params.touchAngle);
            }if (E && T.emit("onTouchMoveOpposite", T, a), void 0 === A && (T.touches.currentX === T.touches.startX && T.touches.currentY === T.touches.startY || (A = !0)), S) {
              if (E) return void (S = !1);if (A) {
                T.allowClick = !1, T.emit("onSliderMove", T, a), a.preventDefault(), T.params.touchMoveStopPropagation && !T.params.nested && a.stopPropagation(), C || (i.loop && T.fixLoop(), I = T.getWrapperTranslate(), T.setWrapperTransition(0), T.animating && T.wrapper.trigger("webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd"), T.params.autoplay && T.autoplaying && (T.params.autoplayDisableOnInteraction ? T.stopAutoplay() : T.pauseAutoplay()), D = !1, !T.params.grabCursor || T.params.allowSwipeToNext !== !0 && T.params.allowSwipeToPrev !== !0 || T.setGrabCursor(!0)), C = !0;var s = T.touches.diff = T.isHorizontal() ? T.touches.currentX - T.touches.startX : T.touches.currentY - T.touches.startY;s *= T.params.touchRatio, T.rtl && (s = -s), T.swipeDirection = s > 0 ? "prev" : "next", P = s + I;var r = !0;if (s > 0 && P > T.minTranslate() ? (r = !1, T.params.resistance && (P = T.minTranslate() - 1 + Math.pow(-T.minTranslate() + I + s, T.params.resistanceRatio))) : s < 0 && P < T.maxTranslate() && (r = !1, T.params.resistance && (P = T.maxTranslate() + 1 - Math.pow(T.maxTranslate() - I - s, T.params.resistanceRatio))), r && (a.preventedByNestedSwiper = !0), !T.params.allowSwipeToNext && "next" === T.swipeDirection && P < I && (P = I), !T.params.allowSwipeToPrev && "prev" === T.swipeDirection && P > I && (P = I), T.params.threshold > 0) {
                  if (!(Math.abs(s) > T.params.threshold || k)) return void (P = I);if (!k) return k = !0, T.touches.startX = T.touches.currentX, T.touches.startY = T.touches.currentY, P = I, void (T.touches.diff = T.isHorizontal() ? T.touches.currentX - T.touches.startX : T.touches.currentY - T.touches.startY);
                }T.params.followFinger && ((T.params.freeMode || T.params.watchSlidesProgress) && T.updateActiveIndex(), T.params.freeMode && (0 === G.length && G.push({ position: T.touches[T.isHorizontal() ? "startX" : "startY"], time: M }), G.push({ position: T.touches[T.isHorizontal() ? "currentX" : "currentY"], time: new window.Date().getTime() })), T.updateProgress(P), T.setWrapperTranslate(P));
              }
            }
          }
        }
      }, T.onTouchEnd = function (a) {
        if (a.originalEvent && (a = a.originalEvent), z && T.emit("onTouchEnd", T, a), z = !1, S) {
          T.params.grabCursor && C && S && (T.params.allowSwipeToNext === !0 || T.params.allowSwipeToPrev === !0) && T.setGrabCursor(!1);var t = Date.now(),
              s = t - M;if (T.allowClick && (T.updateClickedSlide(a), T.emit("onTap", T, a), s < 300 && t - H > 300 && (L && clearTimeout(L), L = setTimeout(function () {
            T && (T.params.paginationHide && T.paginationContainer.length > 0 && !e(a.target).hasClass(T.params.bulletClass) && T.paginationContainer.toggleClass(T.params.paginationHiddenClass), T.emit("onClick", T, a));
          }, 300)), s < 300 && t - H < 300 && (L && clearTimeout(L), T.emit("onDoubleTap", T, a))), H = Date.now(), setTimeout(function () {
            T && (T.allowClick = !0);
          }, 0), !S || !C || !T.swipeDirection || 0 === T.touches.diff || P === I) return void (S = C = !1);S = C = !1;var i;if (i = T.params.followFinger ? T.rtl ? T.translate : -T.translate : -P, T.params.freeMode) {
            if (i < -T.minTranslate()) return void T.slideTo(T.activeIndex);if (i > -T.maxTranslate()) return void (T.slides.length < T.snapGrid.length ? T.slideTo(T.snapGrid.length - 1) : T.slideTo(T.slides.length - 1));if (T.params.freeModeMomentum) {
              if (G.length > 1) {
                var r = G.pop(),
                    n = G.pop(),
                    o = r.position - n.position,
                    l = r.time - n.time;T.velocity = o / l, T.velocity = T.velocity / 2, Math.abs(T.velocity) < T.params.freeModeMinimumVelocity && (T.velocity = 0), (l > 150 || new window.Date().getTime() - r.time > 300) && (T.velocity = 0);
              } else T.velocity = 0;T.velocity = T.velocity * T.params.freeModeMomentumVelocityRatio, G.length = 0;var p = 1e3 * T.params.freeModeMomentumRatio,
                  d = T.velocity * p,
                  u = T.translate + d;T.rtl && (u = -u);var c,
                  m = !1,
                  h = 20 * Math.abs(T.velocity) * T.params.freeModeMomentumBounceRatio;if (u < T.maxTranslate()) T.params.freeModeMomentumBounce ? (u + T.maxTranslate() < -h && (u = T.maxTranslate() - h), c = T.maxTranslate(), m = !0, D = !0) : u = T.maxTranslate();else if (u > T.minTranslate()) T.params.freeModeMomentumBounce ? (u - T.minTranslate() > h && (u = T.minTranslate() + h), c = T.minTranslate(), m = !0, D = !0) : u = T.minTranslate();else if (T.params.freeModeSticky) {
                var g,
                    f = 0;for (f = 0; f < T.snapGrid.length; f += 1) {
                  if (T.snapGrid[f] > -u) {
                    g = f;break;
                  }
                }u = Math.abs(T.snapGrid[g] - u) < Math.abs(T.snapGrid[g - 1] - u) || "next" === T.swipeDirection ? T.snapGrid[g] : T.snapGrid[g - 1], T.rtl || (u = -u);
              }if (0 !== T.velocity) p = T.rtl ? Math.abs((-u - T.translate) / T.velocity) : Math.abs((u - T.translate) / T.velocity);else if (T.params.freeModeSticky) return void T.slideReset();T.params.freeModeMomentumBounce && m ? (T.updateProgress(c), T.setWrapperTransition(p), T.setWrapperTranslate(u), T.onTransitionStart(), T.animating = !0, T.wrapper.transitionEnd(function () {
                T && D && (T.emit("onMomentumBounce", T), T.setWrapperTransition(T.params.speed), T.setWrapperTranslate(c), T.wrapper.transitionEnd(function () {
                  T && T.onTransitionEnd();
                }));
              })) : T.velocity ? (T.updateProgress(u), T.setWrapperTransition(p), T.setWrapperTranslate(u), T.onTransitionStart(), T.animating || (T.animating = !0, T.wrapper.transitionEnd(function () {
                T && T.onTransitionEnd();
              }))) : T.updateProgress(u), T.updateActiveIndex();
            }return void ((!T.params.freeModeMomentum || s >= T.params.longSwipesMs) && (T.updateProgress(), T.updateActiveIndex()));
          }var v,
              w = 0,
              y = T.slidesSizesGrid[0];for (v = 0; v < T.slidesGrid.length; v += T.params.slidesPerGroup) {
            void 0 !== T.slidesGrid[v + T.params.slidesPerGroup] ? i >= T.slidesGrid[v] && i < T.slidesGrid[v + T.params.slidesPerGroup] && (w = v, y = T.slidesGrid[v + T.params.slidesPerGroup] - T.slidesGrid[v]) : i >= T.slidesGrid[v] && (w = v, y = T.slidesGrid[T.slidesGrid.length - 1] - T.slidesGrid[T.slidesGrid.length - 2]);
          }var x = (i - T.slidesGrid[w]) / y;if (s > T.params.longSwipesMs) {
            if (!T.params.longSwipes) return void T.slideTo(T.activeIndex);"next" === T.swipeDirection && (x >= T.params.longSwipesRatio ? T.slideTo(w + T.params.slidesPerGroup) : T.slideTo(w)), "prev" === T.swipeDirection && (x > 1 - T.params.longSwipesRatio ? T.slideTo(w + T.params.slidesPerGroup) : T.slideTo(w));
          } else {
            if (!T.params.shortSwipes) return void T.slideTo(T.activeIndex);"next" === T.swipeDirection && T.slideTo(w + T.params.slidesPerGroup), "prev" === T.swipeDirection && T.slideTo(w);
          }
        }
      }, T._slideTo = function (e, a) {
        return T.slideTo(e, a, !0, !0);
      }, T.slideTo = function (e, a, t, s) {
        void 0 === t && (t = !0), void 0 === e && (e = 0), e < 0 && (e = 0), T.snapIndex = Math.floor(e / T.params.slidesPerGroup), T.snapIndex >= T.snapGrid.length && (T.snapIndex = T.snapGrid.length - 1);var i = -T.snapGrid[T.snapIndex];if (T.params.autoplay && T.autoplaying && (s || !T.params.autoplayDisableOnInteraction ? T.pauseAutoplay(a) : T.stopAutoplay()), T.updateProgress(i), T.params.normalizeSlideIndex) for (var r = 0; r < T.slidesGrid.length; r++) {
          -Math.floor(100 * i) >= Math.floor(100 * T.slidesGrid[r]) && (e = r);
        }return !(!T.params.allowSwipeToNext && i < T.translate && i < T.minTranslate()) && !(!T.params.allowSwipeToPrev && i > T.translate && i > T.maxTranslate() && (T.activeIndex || 0) !== e) && (void 0 === a && (a = T.params.speed), T.previousIndex = T.activeIndex || 0, T.activeIndex = e, T.updateRealIndex(), T.rtl && -i === T.translate || !T.rtl && i === T.translate ? (T.params.autoHeight && T.updateAutoHeight(), T.updateClasses(), "slide" !== T.params.effect && T.setWrapperTranslate(i), !1) : (T.updateClasses(), T.onTransitionStart(t), 0 === a || T.browser.lteIE9 ? (T.setWrapperTranslate(i), T.setWrapperTransition(0), T.onTransitionEnd(t)) : (T.setWrapperTranslate(i), T.setWrapperTransition(a), T.animating || (T.animating = !0, T.wrapper.transitionEnd(function () {
          T && T.onTransitionEnd(t);
        }))), !0));
      }, T.onTransitionStart = function (e) {
        void 0 === e && (e = !0), T.params.autoHeight && T.updateAutoHeight(), T.lazy && T.lazy.onTransitionStart(), e && (T.emit("onTransitionStart", T), T.activeIndex !== T.previousIndex && (T.emit("onSlideChangeStart", T), T.activeIndex > T.previousIndex ? T.emit("onSlideNextStart", T) : T.emit("onSlidePrevStart", T)));
      }, T.onTransitionEnd = function (e) {
        T.animating = !1, T.setWrapperTransition(0), void 0 === e && (e = !0), T.lazy && T.lazy.onTransitionEnd(), e && (T.emit("onTransitionEnd", T), T.activeIndex !== T.previousIndex && (T.emit("onSlideChangeEnd", T), T.activeIndex > T.previousIndex ? T.emit("onSlideNextEnd", T) : T.emit("onSlidePrevEnd", T))), T.params.history && T.history && T.history.setHistory(T.params.history, T.activeIndex), T.params.hashnav && T.hashnav && T.hashnav.setHash();
      }, T.slideNext = function (e, a, t) {
        if (T.params.loop) {
          if (T.animating) return !1;T.fixLoop();T.container[0].clientLeft;return T.slideTo(T.activeIndex + T.params.slidesPerGroup, a, e, t);
        }return T.slideTo(T.activeIndex + T.params.slidesPerGroup, a, e, t);
      }, T._slideNext = function (e) {
        return T.slideNext(!0, e, !0);
      }, T.slidePrev = function (e, a, t) {
        if (T.params.loop) {
          if (T.animating) return !1;T.fixLoop();T.container[0].clientLeft;return T.slideTo(T.activeIndex - 1, a, e, t);
        }return T.slideTo(T.activeIndex - 1, a, e, t);
      }, T._slidePrev = function (e) {
        return T.slidePrev(!0, e, !0);
      }, T.slideReset = function (e, a, t) {
        return T.slideTo(T.activeIndex, a, e);
      }, T.disableTouchControl = function () {
        return T.params.onlyExternal = !0, !0;
      }, T.enableTouchControl = function () {
        return T.params.onlyExternal = !1, !0;
      }, T.setWrapperTransition = function (e, a) {
        T.wrapper.transition(e), "slide" !== T.params.effect && T.effects[T.params.effect] && T.effects[T.params.effect].setTransition(e), T.params.parallax && T.parallax && T.parallax.setTransition(e), T.params.scrollbar && T.scrollbar && T.scrollbar.setTransition(e), T.params.control && T.controller && T.controller.setTransition(e, a), T.emit("onSetTransition", T, e);
      }, T.setWrapperTranslate = function (e, a, t) {
        var s = 0,
            i = 0;T.isHorizontal() ? s = T.rtl ? -e : e : i = e, T.params.roundLengths && (s = r(s), i = r(i)), T.params.virtualTranslate || (T.support.transforms3d ? T.wrapper.transform("translate3d(" + s + "px, " + i + "px, 0px)") : T.wrapper.transform("translate(" + s + "px, " + i + "px)")), T.translate = T.isHorizontal() ? s : i;var n,
            o = T.maxTranslate() - T.minTranslate();n = 0 === o ? 0 : (e - T.minTranslate()) / o, n !== T.progress && T.updateProgress(e), a && T.updateActiveIndex(), "slide" !== T.params.effect && T.effects[T.params.effect] && T.effects[T.params.effect].setTranslate(T.translate), T.params.parallax && T.parallax && T.parallax.setTranslate(T.translate), T.params.scrollbar && T.scrollbar && T.scrollbar.setTranslate(T.translate), T.params.control && T.controller && T.controller.setTranslate(T.translate, t), T.emit("onSetTranslate", T, T.translate);
      }, T.getTranslate = function (e, a) {
        var t, s, i, r;return void 0 === a && (a = "x"), T.params.virtualTranslate ? T.rtl ? -T.translate : T.translate : (i = window.getComputedStyle(e, null), window.WebKitCSSMatrix ? (s = i.transform || i.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map(function (e) {
          return e.replace(",", ".");
        }).join(", ")), r = new window.WebKitCSSMatrix("none" === s ? "" : s)) : (r = i.MozTransform || i.OTransform || i.MsTransform || i.msTransform || i.transform || i.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), t = r.toString().split(",")), "x" === a && (s = window.WebKitCSSMatrix ? r.m41 : 16 === t.length ? parseFloat(t[12]) : parseFloat(t[4])), "y" === a && (s = window.WebKitCSSMatrix ? r.m42 : 16 === t.length ? parseFloat(t[13]) : parseFloat(t[5])), T.rtl && s && (s = -s), s || 0);
      }, T.getWrapperTranslate = function (e) {
        return void 0 === e && (e = T.isHorizontal() ? "x" : "y"), T.getTranslate(T.wrapper[0], e);
      }, T.observers = [], T.initObservers = function () {
        if (T.params.observeParents) for (var e = T.container.parents(), a = 0; a < e.length; a++) {
          l(e[a]);
        }l(T.container[0], { childList: !1 }), l(T.wrapper[0], { attributes: !1 });
      }, T.disconnectObservers = function () {
        for (var e = 0; e < T.observers.length; e++) {
          T.observers[e].disconnect();
        }T.observers = [];
      }, T.createLoop = function () {
        T.wrapper.children("." + T.params.slideClass + "." + T.params.slideDuplicateClass).remove();var a = T.wrapper.children("." + T.params.slideClass);"auto" !== T.params.slidesPerView || T.params.loopedSlides || (T.params.loopedSlides = a.length), T.loopedSlides = parseInt(T.params.loopedSlides || T.params.slidesPerView, 10), T.loopedSlides = T.loopedSlides + T.params.loopAdditionalSlides, T.loopedSlides > a.length && (T.loopedSlides = a.length);var t,
            s = [],
            i = [];for (a.each(function (t, r) {
          var n = e(this);t < T.loopedSlides && i.push(r), t < a.length && t >= a.length - T.loopedSlides && s.push(r), n.attr("data-swiper-slide-index", t);
        }), t = 0; t < i.length; t++) {
          T.wrapper.append(e(i[t].cloneNode(!0)).addClass(T.params.slideDuplicateClass));
        }for (t = s.length - 1; t >= 0; t--) {
          T.wrapper.prepend(e(s[t].cloneNode(!0)).addClass(T.params.slideDuplicateClass));
        }
      }, T.destroyLoop = function () {
        T.wrapper.children("." + T.params.slideClass + "." + T.params.slideDuplicateClass).remove(), T.slides.removeAttr("data-swiper-slide-index");
      }, T.reLoop = function (e) {
        var a = T.activeIndex - T.loopedSlides;T.destroyLoop(), T.createLoop(), T.updateSlidesSize(), e && T.slideTo(a + T.loopedSlides, 0, !1);
      }, T.fixLoop = function () {
        var e;T.activeIndex < T.loopedSlides ? (e = T.slides.length - 3 * T.loopedSlides + T.activeIndex, e += T.loopedSlides, T.slideTo(e, 0, !1, !0)) : ("auto" === T.params.slidesPerView && T.activeIndex >= 2 * T.loopedSlides || T.activeIndex > T.slides.length - 2 * T.params.slidesPerView) && (e = -T.slides.length + T.activeIndex + T.loopedSlides, e += T.loopedSlides, T.slideTo(e, 0, !1, !0));
      }, T.appendSlide = function (e) {
        if (T.params.loop && T.destroyLoop(), "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) for (var a = 0; a < e.length; a++) {
          e[a] && T.wrapper.append(e[a]);
        } else T.wrapper.append(e);T.params.loop && T.createLoop(), T.params.observer && T.support.observer || T.update(!0);
      }, T.prependSlide = function (e) {
        T.params.loop && T.destroyLoop();var a = T.activeIndex + 1;if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) {
          for (var t = 0; t < e.length; t++) {
            e[t] && T.wrapper.prepend(e[t]);
          }a = T.activeIndex + e.length;
        } else T.wrapper.prepend(e);T.params.loop && T.createLoop(), T.params.observer && T.support.observer || T.update(!0), T.slideTo(a, 0, !1);
      }, T.removeSlide = function (e) {
        T.params.loop && (T.destroyLoop(), T.slides = T.wrapper.children("." + T.params.slideClass));var a,
            t = T.activeIndex;if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.length) {
          for (var s = 0; s < e.length; s++) {
            a = e[s], T.slides[a] && T.slides.eq(a).remove(), a < t && t--;
          }t = Math.max(t, 0);
        } else a = e, T.slides[a] && T.slides.eq(a).remove(), a < t && t--, t = Math.max(t, 0);T.params.loop && T.createLoop(), T.params.observer && T.support.observer || T.update(!0), T.params.loop ? T.slideTo(t + T.loopedSlides, 0, !1) : T.slideTo(t, 0, !1);
      }, T.removeAllSlides = function () {
        for (var e = [], a = 0; a < T.slides.length; a++) {
          e.push(a);
        }T.removeSlide(e);
      }, T.effects = { fade: { setTranslate: function setTranslate() {
            for (var e = 0; e < T.slides.length; e++) {
              var a = T.slides.eq(e),
                  t = a[0].swiperSlideOffset,
                  s = -t;T.params.virtualTranslate || (s -= T.translate);var i = 0;T.isHorizontal() || (i = s, s = 0);var r = T.params.fade.crossFade ? Math.max(1 - Math.abs(a[0].progress), 0) : 1 + Math.min(Math.max(a[0].progress, -1), 0);a.css({ opacity: r }).transform("translate3d(" + s + "px, " + i + "px, 0px)");
            }
          }, setTransition: function setTransition(e) {
            if (T.slides.transition(e), T.params.virtualTranslate && 0 !== e) {
              var a = !1;T.slides.transitionEnd(function () {
                if (!a && T) {
                  a = !0, T.animating = !1;for (var e = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], t = 0; t < e.length; t++) {
                    T.wrapper.trigger(e[t]);
                  }
                }
              });
            }
          } }, flip: { setTranslate: function setTranslate() {
            for (var a = 0; a < T.slides.length; a++) {
              var t = T.slides.eq(a),
                  s = t[0].progress;T.params.flip.limitRotation && (s = Math.max(Math.min(t[0].progress, 1), -1));var i = t[0].swiperSlideOffset,
                  r = -180 * s,
                  n = r,
                  o = 0,
                  l = -i,
                  p = 0;if (T.isHorizontal() ? T.rtl && (n = -n) : (p = l, l = 0, o = -n, n = 0), t[0].style.zIndex = -Math.abs(Math.round(s)) + T.slides.length, T.params.flip.slideShadows) {
                var d = T.isHorizontal() ? t.find(".swiper-slide-shadow-left") : t.find(".swiper-slide-shadow-top"),
                    u = T.isHorizontal() ? t.find(".swiper-slide-shadow-right") : t.find(".swiper-slide-shadow-bottom");0 === d.length && (d = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "left" : "top") + '"></div>'), t.append(d)), 0 === u.length && (u = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "right" : "bottom") + '"></div>'), t.append(u)), d.length && (d[0].style.opacity = Math.max(-s, 0)), u.length && (u[0].style.opacity = Math.max(s, 0));
              }t.transform("translate3d(" + l + "px, " + p + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
            }
          }, setTransition: function setTransition(a) {
            if (T.slides.transition(a).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(a), T.params.virtualTranslate && 0 !== a) {
              var t = !1;T.slides.eq(T.activeIndex).transitionEnd(function () {
                if (!t && T && e(this).hasClass(T.params.slideActiveClass)) {
                  t = !0, T.animating = !1;for (var a = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"], s = 0; s < a.length; s++) {
                    T.wrapper.trigger(a[s]);
                  }
                }
              });
            }
          } }, cube: { setTranslate: function setTranslate() {
            var a,
                t = 0;T.params.cube.shadow && (T.isHorizontal() ? (a = T.wrapper.find(".swiper-cube-shadow"), 0 === a.length && (a = e('<div class="swiper-cube-shadow"></div>'), T.wrapper.append(a)), a.css({ height: T.width + "px" })) : (a = T.container.find(".swiper-cube-shadow"), 0 === a.length && (a = e('<div class="swiper-cube-shadow"></div>'), T.container.append(a))));for (var s = 0; s < T.slides.length; s++) {
              var i = T.slides.eq(s),
                  r = 90 * s,
                  n = Math.floor(r / 360);T.rtl && (r = -r, n = Math.floor(-r / 360));var o = Math.max(Math.min(i[0].progress, 1), -1),
                  l = 0,
                  p = 0,
                  d = 0;s % 4 == 0 ? (l = 4 * -n * T.size, d = 0) : (s - 1) % 4 == 0 ? (l = 0, d = 4 * -n * T.size) : (s - 2) % 4 == 0 ? (l = T.size + 4 * n * T.size, d = T.size) : (s - 3) % 4 == 0 && (l = -T.size, d = 3 * T.size + 4 * T.size * n), T.rtl && (l = -l), T.isHorizontal() || (p = l, l = 0);var u = "rotateX(" + (T.isHorizontal() ? 0 : -r) + "deg) rotateY(" + (T.isHorizontal() ? r : 0) + "deg) translate3d(" + l + "px, " + p + "px, " + d + "px)";if (o <= 1 && o > -1 && (t = 90 * s + 90 * o, T.rtl && (t = 90 * -s - 90 * o)), i.transform(u), T.params.cube.slideShadows) {
                var c = T.isHorizontal() ? i.find(".swiper-slide-shadow-left") : i.find(".swiper-slide-shadow-top"),
                    m = T.isHorizontal() ? i.find(".swiper-slide-shadow-right") : i.find(".swiper-slide-shadow-bottom");0 === c.length && (c = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "left" : "top") + '"></div>'), i.append(c)), 0 === m.length && (m = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "right" : "bottom") + '"></div>'), i.append(m)), c.length && (c[0].style.opacity = Math.max(-o, 0)), m.length && (m[0].style.opacity = Math.max(o, 0));
              }
            }if (T.wrapper.css({ "-webkit-transform-origin": "50% 50% -" + T.size / 2 + "px", "-moz-transform-origin": "50% 50% -" + T.size / 2 + "px", "-ms-transform-origin": "50% 50% -" + T.size / 2 + "px", "transform-origin": "50% 50% -" + T.size / 2 + "px" }), T.params.cube.shadow) if (T.isHorizontal()) a.transform("translate3d(0px, " + (T.width / 2 + T.params.cube.shadowOffset) + "px, " + -T.width / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + T.params.cube.shadowScale + ")");else {
              var h = Math.abs(t) - 90 * Math.floor(Math.abs(t) / 90),
                  g = 1.5 - (Math.sin(2 * h * Math.PI / 360) / 2 + Math.cos(2 * h * Math.PI / 360) / 2),
                  f = T.params.cube.shadowScale,
                  v = T.params.cube.shadowScale / g,
                  w = T.params.cube.shadowOffset;a.transform("scale3d(" + f + ", 1, " + v + ") translate3d(0px, " + (T.height / 2 + w) + "px, " + -T.height / 2 / v + "px) rotateX(-90deg)");
            }var y = T.isSafari || T.isUiWebView ? -T.size / 2 : 0;T.wrapper.transform("translate3d(0px,0," + y + "px) rotateX(" + (T.isHorizontal() ? 0 : t) + "deg) rotateY(" + (T.isHorizontal() ? -t : 0) + "deg)");
          }, setTransition: function setTransition(e) {
            T.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), T.params.cube.shadow && !T.isHorizontal() && T.container.find(".swiper-cube-shadow").transition(e);
          } }, coverflow: { setTranslate: function setTranslate() {
            for (var a = T.translate, t = T.isHorizontal() ? -a + T.width / 2 : -a + T.height / 2, s = T.isHorizontal() ? T.params.coverflow.rotate : -T.params.coverflow.rotate, i = T.params.coverflow.depth, r = 0, n = T.slides.length; r < n; r++) {
              var o = T.slides.eq(r),
                  l = T.slidesSizesGrid[r],
                  p = o[0].swiperSlideOffset,
                  d = (t - p - l / 2) / l * T.params.coverflow.modifier,
                  u = T.isHorizontal() ? s * d : 0,
                  c = T.isHorizontal() ? 0 : s * d,
                  m = -i * Math.abs(d),
                  h = T.isHorizontal() ? 0 : T.params.coverflow.stretch * d,
                  g = T.isHorizontal() ? T.params.coverflow.stretch * d : 0;Math.abs(g) < .001 && (g = 0), Math.abs(h) < .001 && (h = 0), Math.abs(m) < .001 && (m = 0), Math.abs(u) < .001 && (u = 0), Math.abs(c) < .001 && (c = 0);var f = "translate3d(" + g + "px," + h + "px," + m + "px)  rotateX(" + c + "deg) rotateY(" + u + "deg)";if (o.transform(f), o[0].style.zIndex = 1 - Math.abs(Math.round(d)), T.params.coverflow.slideShadows) {
                var v = T.isHorizontal() ? o.find(".swiper-slide-shadow-left") : o.find(".swiper-slide-shadow-top"),
                    w = T.isHorizontal() ? o.find(".swiper-slide-shadow-right") : o.find(".swiper-slide-shadow-bottom");0 === v.length && (v = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "left" : "top") + '"></div>'), o.append(v)), 0 === w.length && (w = e('<div class="swiper-slide-shadow-' + (T.isHorizontal() ? "right" : "bottom") + '"></div>'), o.append(w)), v.length && (v[0].style.opacity = d > 0 ? d : 0), w.length && (w[0].style.opacity = -d > 0 ? -d : 0);
              }
            }if (T.browser.ie) {
              T.wrapper[0].style.perspectiveOrigin = t + "px 50%";
            }
          }, setTransition: function setTransition(e) {
            T.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
          } } }, T.lazy = { initialImageLoaded: !1, loadImageInSlide: function loadImageInSlide(a, t) {
          if (void 0 !== a && (void 0 === t && (t = !0), 0 !== T.slides.length)) {
            var s = T.slides.eq(a),
                i = s.find("." + T.params.lazyLoadingClass + ":not(." + T.params.lazyStatusLoadedClass + "):not(." + T.params.lazyStatusLoadingClass + ")");!s.hasClass(T.params.lazyLoadingClass) || s.hasClass(T.params.lazyStatusLoadedClass) || s.hasClass(T.params.lazyStatusLoadingClass) || (i = i.add(s[0])), 0 !== i.length && i.each(function () {
              var a = e(this);a.addClass(T.params.lazyStatusLoadingClass);var i = a.attr("data-background"),
                  r = a.attr("data-src"),
                  n = a.attr("data-srcset"),
                  o = a.attr("data-sizes");T.loadImage(a[0], r || i, n, o, !1, function () {
                if (void 0 !== T && null !== T && T) {
                  if (i ? (a.css("background-image", 'url("' + i + '")'), a.removeAttr("data-background")) : (n && (a.attr("srcset", n), a.removeAttr("data-srcset")), o && (a.attr("sizes", o), a.removeAttr("data-sizes")), r && (a.attr("src", r), a.removeAttr("data-src"))), a.addClass(T.params.lazyStatusLoadedClass).removeClass(T.params.lazyStatusLoadingClass), s.find("." + T.params.lazyPreloaderClass + ", ." + T.params.preloaderClass).remove(), T.params.loop && t) {
                    var e = s.attr("data-swiper-slide-index");if (s.hasClass(T.params.slideDuplicateClass)) {
                      var l = T.wrapper.children('[data-swiper-slide-index="' + e + '"]:not(.' + T.params.slideDuplicateClass + ")");T.lazy.loadImageInSlide(l.index(), !1);
                    } else {
                      var p = T.wrapper.children("." + T.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');T.lazy.loadImageInSlide(p.index(), !1);
                    }
                  }T.emit("onLazyImageReady", T, s[0], a[0]);
                }
              }), T.emit("onLazyImageLoad", T, s[0], a[0]);
            });
          }
        }, load: function load() {
          var a,
              t = T.params.slidesPerView;if ("auto" === t && (t = 0), T.lazy.initialImageLoaded || (T.lazy.initialImageLoaded = !0), T.params.watchSlidesVisibility) T.wrapper.children("." + T.params.slideVisibleClass).each(function () {
            T.lazy.loadImageInSlide(e(this).index());
          });else if (t > 1) for (a = T.activeIndex; a < T.activeIndex + t; a++) {
            T.slides[a] && T.lazy.loadImageInSlide(a);
          } else T.lazy.loadImageInSlide(T.activeIndex);if (T.params.lazyLoadingInPrevNext) if (t > 1 || T.params.lazyLoadingInPrevNextAmount && T.params.lazyLoadingInPrevNextAmount > 1) {
            var s = T.params.lazyLoadingInPrevNextAmount,
                i = t,
                r = Math.min(T.activeIndex + i + Math.max(s, i), T.slides.length),
                n = Math.max(T.activeIndex - Math.max(i, s), 0);for (a = T.activeIndex + t; a < r; a++) {
              T.slides[a] && T.lazy.loadImageInSlide(a);
            }for (a = n; a < T.activeIndex; a++) {
              T.slides[a] && T.lazy.loadImageInSlide(a);
            }
          } else {
            var o = T.wrapper.children("." + T.params.slideNextClass);o.length > 0 && T.lazy.loadImageInSlide(o.index());var l = T.wrapper.children("." + T.params.slidePrevClass);l.length > 0 && T.lazy.loadImageInSlide(l.index());
          }
        }, onTransitionStart: function onTransitionStart() {
          T.params.lazyLoading && (T.params.lazyLoadingOnTransitionStart || !T.params.lazyLoadingOnTransitionStart && !T.lazy.initialImageLoaded) && T.lazy.load();
        }, onTransitionEnd: function onTransitionEnd() {
          T.params.lazyLoading && !T.params.lazyLoadingOnTransitionStart && T.lazy.load();
        } }, T.scrollbar = { isTouched: !1, setDragPosition: function setDragPosition(e) {
          var a = T.scrollbar,
              t = T.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY,
              s = t - a.track.offset()[T.isHorizontal() ? "left" : "top"] - a.dragSize / 2,
              i = -T.minTranslate() * a.moveDivider,
              r = -T.maxTranslate() * a.moveDivider;s < i ? s = i : s > r && (s = r), s = -s / a.moveDivider, T.updateProgress(s), T.setWrapperTranslate(s, !0);
        }, dragStart: function dragStart(e) {
          var a = T.scrollbar;a.isTouched = !0, e.preventDefault(), e.stopPropagation(), a.setDragPosition(e), clearTimeout(a.dragTimeout), a.track.transition(0), T.params.scrollbarHide && a.track.css("opacity", 1), T.wrapper.transition(100), a.drag.transition(100), T.emit("onScrollbarDragStart", T);
        }, dragMove: function dragMove(e) {
          var a = T.scrollbar;a.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, a.setDragPosition(e), T.wrapper.transition(0), a.track.transition(0), a.drag.transition(0), T.emit("onScrollbarDragMove", T));
        }, dragEnd: function dragEnd(e) {
          var a = T.scrollbar;a.isTouched && (a.isTouched = !1, T.params.scrollbarHide && (clearTimeout(a.dragTimeout), a.dragTimeout = setTimeout(function () {
            a.track.css("opacity", 0), a.track.transition(400);
          }, 1e3)), T.emit("onScrollbarDragEnd", T), T.params.scrollbarSnapOnRelease && T.slideReset());
        }, draggableEvents: function () {
          return T.params.simulateTouch !== !1 || T.support.touch ? T.touchEvents : T.touchEventsDesktop;
        }(), enableDraggable: function enableDraggable() {
          var a = T.scrollbar,
              t = T.support.touch ? a.track : document;e(a.track).on(a.draggableEvents.start, a.dragStart), e(t).on(a.draggableEvents.move, a.dragMove), e(t).on(a.draggableEvents.end, a.dragEnd);
        }, disableDraggable: function disableDraggable() {
          var a = T.scrollbar,
              t = T.support.touch ? a.track : document;e(a.track).off(a.draggableEvents.start, a.dragStart), e(t).off(a.draggableEvents.move, a.dragMove), e(t).off(a.draggableEvents.end, a.dragEnd);
        }, set: function set() {
          if (T.params.scrollbar) {
            var a = T.scrollbar;a.track = e(T.params.scrollbar), T.params.uniqueNavElements && "string" == typeof T.params.scrollbar && a.track.length > 1 && 1 === T.container.find(T.params.scrollbar).length && (a.track = T.container.find(T.params.scrollbar)), a.drag = a.track.find(".swiper-scrollbar-drag"), 0 === a.drag.length && (a.drag = e('<div class="swiper-scrollbar-drag"></div>'), a.track.append(a.drag)), a.drag[0].style.width = "", a.drag[0].style.height = "", a.trackSize = T.isHorizontal() ? a.track[0].offsetWidth : a.track[0].offsetHeight, a.divider = T.size / T.virtualSize, a.moveDivider = a.divider * (a.trackSize / T.size), a.dragSize = a.trackSize * a.divider, T.isHorizontal() ? a.drag[0].style.width = a.dragSize + "px" : a.drag[0].style.height = a.dragSize + "px", a.divider >= 1 ? a.track[0].style.display = "none" : a.track[0].style.display = "", T.params.scrollbarHide && (a.track[0].style.opacity = 0);
          }
        }, setTranslate: function setTranslate() {
          if (T.params.scrollbar) {
            var e,
                a = T.scrollbar,
                t = (T.translate, a.dragSize);e = (a.trackSize - a.dragSize) * T.progress, T.rtl && T.isHorizontal() ? (e = -e, e > 0 ? (t = a.dragSize - e, e = 0) : -e + a.dragSize > a.trackSize && (t = a.trackSize + e)) : e < 0 ? (t = a.dragSize + e, e = 0) : e + a.dragSize > a.trackSize && (t = a.trackSize - e), T.isHorizontal() ? (T.support.transforms3d ? a.drag.transform("translate3d(" + e + "px, 0, 0)") : a.drag.transform("translateX(" + e + "px)"), a.drag[0].style.width = t + "px") : (T.support.transforms3d ? a.drag.transform("translate3d(0px, " + e + "px, 0)") : a.drag.transform("translateY(" + e + "px)"), a.drag[0].style.height = t + "px"), T.params.scrollbarHide && (clearTimeout(a.timeout), a.track[0].style.opacity = 1, a.timeout = setTimeout(function () {
              a.track[0].style.opacity = 0, a.track.transition(400);
            }, 1e3));
          }
        }, setTransition: function setTransition(e) {
          T.params.scrollbar && T.scrollbar.drag.transition(e);
        } }, T.controller = { LinearSpline: function LinearSpline(e, a) {
          var t = function () {
            var e, a, t;return function (s, i) {
              for (a = -1, e = s.length; e - a > 1;) {
                s[t = e + a >> 1] <= i ? a = t : e = t;
              }return e;
            };
          }();this.x = e, this.y = a, this.lastIndex = e.length - 1;var s, i;this.x.length;this.interpolate = function (e) {
            return e ? (i = t(this.x, e), s = i - 1, (e - this.x[s]) * (this.y[i] - this.y[s]) / (this.x[i] - this.x[s]) + this.y[s]) : 0;
          };
        }, getInterpolateFunction: function getInterpolateFunction(e) {
          T.controller.spline || (T.controller.spline = T.params.loop ? new T.controller.LinearSpline(T.slidesGrid, e.slidesGrid) : new T.controller.LinearSpline(T.snapGrid, e.snapGrid));
        }, setTranslate: function setTranslate(e, t) {
          function s(a) {
            e = a.rtl && "horizontal" === a.params.direction ? -T.translate : T.translate, "slide" === T.params.controlBy && (T.controller.getInterpolateFunction(a), r = -T.controller.spline.interpolate(-e)), r && "container" !== T.params.controlBy || (i = (a.maxTranslate() - a.minTranslate()) / (T.maxTranslate() - T.minTranslate()), r = (e - T.minTranslate()) * i + a.minTranslate()), T.params.controlInverse && (r = a.maxTranslate() - r), a.updateProgress(r), a.setWrapperTranslate(r, !1, T), a.updateActiveIndex();
          }var i,
              r,
              n = T.params.control;if (Array.isArray(n)) for (var o = 0; o < n.length; o++) {
            n[o] !== t && n[o] instanceof a && s(n[o]);
          } else n instanceof a && t !== n && s(n);
        }, setTransition: function setTransition(e, t) {
          function s(a) {
            a.setWrapperTransition(e, T), 0 !== e && (a.onTransitionStart(), a.wrapper.transitionEnd(function () {
              r && (a.params.loop && "slide" === T.params.controlBy && a.fixLoop(), a.onTransitionEnd());
            }));
          }var i,
              r = T.params.control;if (Array.isArray(r)) for (i = 0; i < r.length; i++) {
            r[i] !== t && r[i] instanceof a && s(r[i]);
          } else r instanceof a && t !== r && s(r);
        } }, T.hashnav = { onHashCange: function onHashCange(e, a) {
          var t = document.location.hash.replace("#", "");t !== T.slides.eq(T.activeIndex).attr("data-hash") && T.slideTo(T.wrapper.children("." + T.params.slideClass + '[data-hash="' + t + '"]').index());
        }, attachEvents: function attachEvents(a) {
          var t = a ? "off" : "on";e(window)[t]("hashchange", T.hashnav.onHashCange);
        }, setHash: function setHash() {
          if (T.hashnav.initialized && T.params.hashnav) if (T.params.replaceState && window.history && window.history.replaceState) window.history.replaceState(null, null, "#" + T.slides.eq(T.activeIndex).attr("data-hash") || "");else {
            var e = T.slides.eq(T.activeIndex),
                a = e.attr("data-hash") || e.attr("data-history");document.location.hash = a || "";
          }
        }, init: function init() {
          if (T.params.hashnav && !T.params.history) {
            T.hashnav.initialized = !0;var e = document.location.hash.replace("#", "");if (e) for (var a = 0, t = T.slides.length; a < t; a++) {
              var s = T.slides.eq(a),
                  i = s.attr("data-hash") || s.attr("data-history");if (i === e && !s.hasClass(T.params.slideDuplicateClass)) {
                var r = s.index();T.slideTo(r, 0, T.params.runCallbacksOnInit, !0);
              }
            }T.params.hashnavWatchState && T.hashnav.attachEvents();
          }
        }, destroy: function destroy() {
          T.params.hashnavWatchState && T.hashnav.attachEvents(!0);
        } }, T.history = { init: function init() {
          if (T.params.history) {
            if (!window.history || !window.history.pushState) return T.params.history = !1, void (T.params.hashnav = !0);T.history.initialized = !0, this.paths = this.getPathValues(), (this.paths.key || this.paths.value) && (this.scrollToSlide(0, this.paths.value, T.params.runCallbacksOnInit), T.params.replaceState || window.addEventListener("popstate", this.setHistoryPopState));
          }
        }, setHistoryPopState: function setHistoryPopState() {
          T.history.paths = T.history.getPathValues(), T.history.scrollToSlide(T.params.speed, T.history.paths.value, !1);
        }, getPathValues: function getPathValues() {
          var e = window.location.pathname.slice(1).split("/"),
              a = e.length;return { key: e[a - 2], value: e[a - 1] };
        }, setHistory: function setHistory(e, a) {
          if (T.history.initialized && T.params.history) {
            var t = T.slides.eq(a),
                s = this.slugify(t.attr("data-history"));window.location.pathname.includes(e) || (s = e + "/" + s), T.params.replaceState ? window.history.replaceState(null, null, s) : window.history.pushState(null, null, s);
          }
        }, slugify: function slugify(e) {
          return e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
        }, scrollToSlide: function scrollToSlide(e, a, t) {
          if (a) for (var s = 0, i = T.slides.length; s < i; s++) {
            var r = T.slides.eq(s),
                n = this.slugify(r.attr("data-history"));if (n === a && !r.hasClass(T.params.slideDuplicateClass)) {
              var o = r.index();T.slideTo(o, e, t);
            }
          } else T.slideTo(0, e, t);
        } }, T.disableKeyboardControl = function () {
        T.params.keyboardControl = !1, e(document).off("keydown", p);
      }, T.enableKeyboardControl = function () {
        T.params.keyboardControl = !0, e(document).on("keydown", p);
      }, T.mousewheel = { event: !1, lastScrollTime: new window.Date().getTime() }, T.params.mousewheelControl && (T.mousewheel.event = navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function () {
        var e = "onwheel" in document;if (!e) {
          var a = document.createElement("div");a.setAttribute("onwheel", "return;"), e = "function" == typeof a.onwheel;
        }return !e && document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0 && (e = document.implementation.hasFeature("Events.wheel", "3.0")), e;
      }() ? "wheel" : "mousewheel"), T.disableMousewheelControl = function () {
        if (!T.mousewheel.event) return !1;var a = T.container;return "container" !== T.params.mousewheelEventsTarged && (a = e(T.params.mousewheelEventsTarged)), a.off(T.mousewheel.event, u), T.params.mousewheelControl = !1, !0;
      }, T.enableMousewheelControl = function () {
        if (!T.mousewheel.event) return !1;var a = T.container;return "container" !== T.params.mousewheelEventsTarged && (a = e(T.params.mousewheelEventsTarged)), a.on(T.mousewheel.event, u), T.params.mousewheelControl = !0, !0;
      }, T.parallax = { setTranslate: function setTranslate() {
          T.container.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
            c(this, T.progress);
          }), T.slides.each(function () {
            var a = e(this);a.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
              c(this, Math.min(Math.max(a[0].progress, -1), 1));
            });
          });
        }, setTransition: function setTransition(a) {
          void 0 === a && (a = T.params.speed), T.container.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function () {
            var t = e(this),
                s = parseInt(t.attr("data-swiper-parallax-duration"), 10) || a;0 === a && (s = 0), t.transition(s);
          });
        } }, T.zoom = { scale: 1, currentScale: 1, isScaling: !1, gesture: { slide: void 0, slideWidth: void 0, slideHeight: void 0, image: void 0, imageWrap: void 0, zoomMax: T.params.zoomMax }, image: { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, velocity: { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 }, getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
          if (e.targetTouches.length < 2) return 1;var a = e.targetTouches[0].pageX,
              t = e.targetTouches[0].pageY,
              s = e.targetTouches[1].pageX,
              i = e.targetTouches[1].pageY;return Math.sqrt(Math.pow(s - a, 2) + Math.pow(i - t, 2));
        }, onGestureStart: function onGestureStart(a) {
          var t = T.zoom;if (!T.support.gestures) {
            if ("touchstart" !== a.type || "touchstart" === a.type && a.targetTouches.length < 2) return;t.gesture.scaleStart = t.getDistanceBetweenTouches(a);
          }if (!(t.gesture.slide && t.gesture.slide.length || (t.gesture.slide = e(this), 0 === t.gesture.slide.length && (t.gesture.slide = T.slides.eq(T.activeIndex)), t.gesture.image = t.gesture.slide.find("img, svg, canvas"), t.gesture.imageWrap = t.gesture.image.parent("." + T.params.zoomContainerClass), t.gesture.zoomMax = t.gesture.imageWrap.attr("data-swiper-zoom") || T.params.zoomMax, 0 !== t.gesture.imageWrap.length))) return void (t.gesture.image = void 0);t.gesture.image.transition(0), t.isScaling = !0;
        }, onGestureChange: function onGestureChange(e) {
          var a = T.zoom;if (!T.support.gestures) {
            if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;a.gesture.scaleMove = a.getDistanceBetweenTouches(e);
          }a.gesture.image && 0 !== a.gesture.image.length && (T.support.gestures ? a.scale = e.scale * a.currentScale : a.scale = a.gesture.scaleMove / a.gesture.scaleStart * a.currentScale, a.scale > a.gesture.zoomMax && (a.scale = a.gesture.zoomMax - 1 + Math.pow(a.scale - a.gesture.zoomMax + 1, .5)), a.scale < T.params.zoomMin && (a.scale = T.params.zoomMin + 1 - Math.pow(T.params.zoomMin - a.scale + 1, .5)), a.gesture.image.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
        }, onGestureEnd: function onGestureEnd(e) {
          var a = T.zoom;!T.support.gestures && ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2) || a.gesture.image && 0 !== a.gesture.image.length && (a.scale = Math.max(Math.min(a.scale, a.gesture.zoomMax), T.params.zoomMin), a.gesture.image.transition(T.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (a.gesture.slide = void 0));
        }, onTouchStart: function onTouchStart(e, a) {
          var t = e.zoom;t.gesture.image && 0 !== t.gesture.image.length && (t.image.isTouched || ("android" === e.device.os && a.preventDefault(), t.image.isTouched = !0, t.image.touchesStart.x = "touchstart" === a.type ? a.targetTouches[0].pageX : a.pageX, t.image.touchesStart.y = "touchstart" === a.type ? a.targetTouches[0].pageY : a.pageY));
        }, onTouchMove: function onTouchMove(e) {
          var a = T.zoom;if (a.gesture.image && 0 !== a.gesture.image.length && (T.allowClick = !1, a.image.isTouched && a.gesture.slide)) {
            a.image.isMoved || (a.image.width = a.gesture.image[0].offsetWidth, a.image.height = a.gesture.image[0].offsetHeight, a.image.startX = T.getTranslate(a.gesture.imageWrap[0], "x") || 0, a.image.startY = T.getTranslate(a.gesture.imageWrap[0], "y") || 0, a.gesture.slideWidth = a.gesture.slide[0].offsetWidth, a.gesture.slideHeight = a.gesture.slide[0].offsetHeight, a.gesture.imageWrap.transition(0), T.rtl && (a.image.startX = -a.image.startX), T.rtl && (a.image.startY = -a.image.startY));var t = a.image.width * a.scale,
                s = a.image.height * a.scale;if (!(t < a.gesture.slideWidth && s < a.gesture.slideHeight)) {
              if (a.image.minX = Math.min(a.gesture.slideWidth / 2 - t / 2, 0), a.image.maxX = -a.image.minX, a.image.minY = Math.min(a.gesture.slideHeight / 2 - s / 2, 0), a.image.maxY = -a.image.minY, a.image.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, a.image.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !a.image.isMoved && !a.isScaling) {
                if (T.isHorizontal() && Math.floor(a.image.minX) === Math.floor(a.image.startX) && a.image.touchesCurrent.x < a.image.touchesStart.x || Math.floor(a.image.maxX) === Math.floor(a.image.startX) && a.image.touchesCurrent.x > a.image.touchesStart.x) return void (a.image.isTouched = !1);if (!T.isHorizontal() && Math.floor(a.image.minY) === Math.floor(a.image.startY) && a.image.touchesCurrent.y < a.image.touchesStart.y || Math.floor(a.image.maxY) === Math.floor(a.image.startY) && a.image.touchesCurrent.y > a.image.touchesStart.y) return void (a.image.isTouched = !1);
              }e.preventDefault(), e.stopPropagation(), a.image.isMoved = !0, a.image.currentX = a.image.touchesCurrent.x - a.image.touchesStart.x + a.image.startX, a.image.currentY = a.image.touchesCurrent.y - a.image.touchesStart.y + a.image.startY, a.image.currentX < a.image.minX && (a.image.currentX = a.image.minX + 1 - Math.pow(a.image.minX - a.image.currentX + 1, .8)), a.image.currentX > a.image.maxX && (a.image.currentX = a.image.maxX - 1 + Math.pow(a.image.currentX - a.image.maxX + 1, .8)), a.image.currentY < a.image.minY && (a.image.currentY = a.image.minY + 1 - Math.pow(a.image.minY - a.image.currentY + 1, .8)), a.image.currentY > a.image.maxY && (a.image.currentY = a.image.maxY - 1 + Math.pow(a.image.currentY - a.image.maxY + 1, .8)), a.velocity.prevPositionX || (a.velocity.prevPositionX = a.image.touchesCurrent.x), a.velocity.prevPositionY || (a.velocity.prevPositionY = a.image.touchesCurrent.y), a.velocity.prevTime || (a.velocity.prevTime = Date.now()), a.velocity.x = (a.image.touchesCurrent.x - a.velocity.prevPositionX) / (Date.now() - a.velocity.prevTime) / 2, a.velocity.y = (a.image.touchesCurrent.y - a.velocity.prevPositionY) / (Date.now() - a.velocity.prevTime) / 2, Math.abs(a.image.touchesCurrent.x - a.velocity.prevPositionX) < 2 && (a.velocity.x = 0), Math.abs(a.image.touchesCurrent.y - a.velocity.prevPositionY) < 2 && (a.velocity.y = 0), a.velocity.prevPositionX = a.image.touchesCurrent.x, a.velocity.prevPositionY = a.image.touchesCurrent.y, a.velocity.prevTime = Date.now(), a.gesture.imageWrap.transform("translate3d(" + a.image.currentX + "px, " + a.image.currentY + "px,0)");
            }
          }
        }, onTouchEnd: function onTouchEnd(e, a) {
          var t = e.zoom;if (t.gesture.image && 0 !== t.gesture.image.length) {
            if (!t.image.isTouched || !t.image.isMoved) return t.image.isTouched = !1, void (t.image.isMoved = !1);t.image.isTouched = !1, t.image.isMoved = !1;var s = 300,
                i = 300,
                r = t.velocity.x * s,
                n = t.image.currentX + r,
                o = t.velocity.y * i,
                l = t.image.currentY + o;0 !== t.velocity.x && (s = Math.abs((n - t.image.currentX) / t.velocity.x)), 0 !== t.velocity.y && (i = Math.abs((l - t.image.currentY) / t.velocity.y));var p = Math.max(s, i);t.image.currentX = n, t.image.currentY = l;var d = t.image.width * t.scale,
                u = t.image.height * t.scale;t.image.minX = Math.min(t.gesture.slideWidth / 2 - d / 2, 0), t.image.maxX = -t.image.minX, t.image.minY = Math.min(t.gesture.slideHeight / 2 - u / 2, 0), t.image.maxY = -t.image.minY, t.image.currentX = Math.max(Math.min(t.image.currentX, t.image.maxX), t.image.minX), t.image.currentY = Math.max(Math.min(t.image.currentY, t.image.maxY), t.image.minY), t.gesture.imageWrap.transition(p).transform("translate3d(" + t.image.currentX + "px, " + t.image.currentY + "px,0)");
          }
        }, onTransitionEnd: function onTransitionEnd(e) {
          var a = e.zoom;a.gesture.slide && e.previousIndex !== e.activeIndex && (a.gesture.image.transform("translate3d(0,0,0) scale(1)"), a.gesture.imageWrap.transform("translate3d(0,0,0)"), a.gesture.slide = a.gesture.image = a.gesture.imageWrap = void 0, a.scale = a.currentScale = 1);
        }, toggleZoom: function toggleZoom(a, t) {
          var s = a.zoom;if (s.gesture.slide || (s.gesture.slide = a.clickedSlide ? e(a.clickedSlide) : a.slides.eq(a.activeIndex), s.gesture.image = s.gesture.slide.find("img, svg, canvas"), s.gesture.imageWrap = s.gesture.image.parent("." + a.params.zoomContainerClass)), s.gesture.image && 0 !== s.gesture.image.length) {
            var i, r, n, o, l, p, d, u, c, m, h, g, f, v, w, y, x, T;void 0 === s.image.touchesStart.x && t ? (i = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX, r = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY) : (i = s.image.touchesStart.x, r = s.image.touchesStart.y), s.scale && 1 !== s.scale ? (s.scale = s.currentScale = 1, s.gesture.imageWrap.transition(300).transform("translate3d(0,0,0)"), s.gesture.image.transition(300).transform("translate3d(0,0,0) scale(1)"), s.gesture.slide = void 0) : (s.scale = s.currentScale = s.gesture.imageWrap.attr("data-swiper-zoom") || a.params.zoomMax, t ? (x = s.gesture.slide[0].offsetWidth, T = s.gesture.slide[0].offsetHeight, n = s.gesture.slide.offset().left, o = s.gesture.slide.offset().top, l = n + x / 2 - i, p = o + T / 2 - r, c = s.gesture.image[0].offsetWidth, m = s.gesture.image[0].offsetHeight, h = c * s.scale, g = m * s.scale, f = Math.min(x / 2 - h / 2, 0), v = Math.min(T / 2 - g / 2, 0), w = -f, y = -v, d = l * s.scale, u = p * s.scale, d < f && (d = f), d > w && (d = w), u < v && (u = v), u > y && (u = y)) : (d = 0, u = 0), s.gesture.imageWrap.transition(300).transform("translate3d(" + d + "px, " + u + "px,0)"), s.gesture.image.transition(300).transform("translate3d(0,0,0) scale(" + s.scale + ")"));
          }
        }, attachEvents: function attachEvents(a) {
          var t = a ? "off" : "on";if (T.params.zoom) {
            var s = (T.slides, !("touchstart" !== T.touchEvents.start || !T.support.passiveListener || !T.params.passiveListeners) && { passive: !0, capture: !1 });T.support.gestures ? (T.slides[t]("gesturestart", T.zoom.onGestureStart, s), T.slides[t]("gesturechange", T.zoom.onGestureChange, s), T.slides[t]("gestureend", T.zoom.onGestureEnd, s)) : "touchstart" === T.touchEvents.start && (T.slides[t](T.touchEvents.start, T.zoom.onGestureStart, s), T.slides[t](T.touchEvents.move, T.zoom.onGestureChange, s), T.slides[t](T.touchEvents.end, T.zoom.onGestureEnd, s)), T[t]("touchStart", T.zoom.onTouchStart), T.slides.each(function (a, s) {
              e(s).find("." + T.params.zoomContainerClass).length > 0 && e(s)[t](T.touchEvents.move, T.zoom.onTouchMove);
            }), T[t]("touchEnd", T.zoom.onTouchEnd), T[t]("transitionEnd", T.zoom.onTransitionEnd), T.params.zoomToggle && T.on("doubleTap", T.zoom.toggleZoom);
          }
        }, init: function init() {
          T.zoom.attachEvents();
        }, destroy: function destroy() {
          T.zoom.attachEvents(!0);
        } }, T._plugins = [];for (var Y in T.plugins) {
        var O = T.plugins[Y](T, T.params[Y]);O && T._plugins.push(O);
      }return T.callPlugins = function (e) {
        for (var a = 0; a < T._plugins.length; a++) {
          e in T._plugins[a] && T._plugins[a][e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        }
      }, T.emitterEventListeners = {}, T.emit = function (e) {
        T.params[e] && T.params[e](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);var a;if (T.emitterEventListeners[e]) for (a = 0; a < T.emitterEventListeners[e].length; a++) {
          T.emitterEventListeners[e][a](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        }T.callPlugins && T.callPlugins(e, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      }, T.on = function (e, a) {
        return e = m(e), T.emitterEventListeners[e] || (T.emitterEventListeners[e] = []), T.emitterEventListeners[e].push(a), T;
      }, T.off = function (e, a) {
        var t;if (e = m(e), void 0 === a) return T.emitterEventListeners[e] = [], T;if (T.emitterEventListeners[e] && 0 !== T.emitterEventListeners[e].length) {
          for (t = 0; t < T.emitterEventListeners[e].length; t++) {
            T.emitterEventListeners[e][t] === a && T.emitterEventListeners[e].splice(t, 1);
          }return T;
        }
      }, T.once = function (e, a) {
        e = m(e);var t = function t() {
          a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]), T.off(e, t);
        };return T.on(e, t), T;
      }, T.a11y = { makeFocusable: function makeFocusable(e) {
          return e.attr("tabIndex", "0"), e;
        }, addRole: function addRole(e, a) {
          return e.attr("role", a), e;
        }, addLabel: function addLabel(e, a) {
          return e.attr("aria-label", a), e;
        }, disable: function disable(e) {
          return e.attr("aria-disabled", !0), e;
        }, enable: function enable(e) {
          return e.attr("aria-disabled", !1), e;
        }, onEnterKey: function onEnterKey(a) {
          13 === a.keyCode && (e(a.target).is(T.params.nextButton) ? (T.onClickNext(a), T.isEnd ? T.a11y.notify(T.params.lastSlideMessage) : T.a11y.notify(T.params.nextSlideMessage)) : e(a.target).is(T.params.prevButton) && (T.onClickPrev(a), T.isBeginning ? T.a11y.notify(T.params.firstSlideMessage) : T.a11y.notify(T.params.prevSlideMessage)), e(a.target).is("." + T.params.bulletClass) && e(a.target)[0].click());
        }, liveRegion: e('<span class="' + T.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'), notify: function notify(e) {
          var a = T.a11y.liveRegion;0 !== a.length && (a.html(""), a.html(e));
        }, init: function init() {
          T.params.nextButton && T.nextButton && T.nextButton.length > 0 && (T.a11y.makeFocusable(T.nextButton), T.a11y.addRole(T.nextButton, "button"), T.a11y.addLabel(T.nextButton, T.params.nextSlideMessage)), T.params.prevButton && T.prevButton && T.prevButton.length > 0 && (T.a11y.makeFocusable(T.prevButton), T.a11y.addRole(T.prevButton, "button"), T.a11y.addLabel(T.prevButton, T.params.prevSlideMessage)), e(T.container).append(T.a11y.liveRegion);
        }, initPagination: function initPagination() {
          T.params.pagination && T.params.paginationClickable && T.bullets && T.bullets.length && T.bullets.each(function () {
            var a = e(this);T.a11y.makeFocusable(a), T.a11y.addRole(a, "button"), T.a11y.addLabel(a, T.params.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
          });
        }, destroy: function destroy() {
          T.a11y.liveRegion && T.a11y.liveRegion.length > 0 && T.a11y.liveRegion.remove();
        } }, T.init = function () {
        T.params.loop && T.createLoop(), T.updateContainerSize(), T.updateSlidesSize(), T.updatePagination(), T.params.scrollbar && T.scrollbar && (T.scrollbar.set(), T.params.scrollbarDraggable && T.scrollbar.enableDraggable()), "slide" !== T.params.effect && T.effects[T.params.effect] && (T.params.loop || T.updateProgress(), T.effects[T.params.effect].setTranslate()), T.params.loop ? T.slideTo(T.params.initialSlide + T.loopedSlides, 0, T.params.runCallbacksOnInit) : (T.slideTo(T.params.initialSlide, 0, T.params.runCallbacksOnInit), 0 === T.params.initialSlide && (T.parallax && T.params.parallax && T.parallax.setTranslate(), T.lazy && T.params.lazyLoading && (T.lazy.load(), T.lazy.initialImageLoaded = !0))), T.attachEvents(), T.params.observer && T.support.observer && T.initObservers(), T.params.preloadImages && !T.params.lazyLoading && T.preloadImages(), T.params.zoom && T.zoom && T.zoom.init(), T.params.autoplay && T.startAutoplay(), T.params.keyboardControl && T.enableKeyboardControl && T.enableKeyboardControl(), T.params.mousewheelControl && T.enableMousewheelControl && T.enableMousewheelControl(), T.params.hashnavReplaceState && (T.params.replaceState = T.params.hashnavReplaceState), T.params.history && T.history && T.history.init(), T.params.hashnav && T.hashnav && T.hashnav.init(), T.params.a11y && T.a11y && T.a11y.init(), T.emit("onInit", T);
      }, T.cleanupStyles = function () {
        T.container.removeClass(T.classNames.join(" ")).removeAttr("style"), T.wrapper.removeAttr("style"), T.slides && T.slides.length && T.slides.removeClass([T.params.slideVisibleClass, T.params.slideActiveClass, T.params.slideNextClass, T.params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-column").removeAttr("data-swiper-row"), T.paginationContainer && T.paginationContainer.length && T.paginationContainer.removeClass(T.params.paginationHiddenClass), T.bullets && T.bullets.length && T.bullets.removeClass(T.params.bulletActiveClass), T.params.prevButton && e(T.params.prevButton).removeClass(T.params.buttonDisabledClass), T.params.nextButton && e(T.params.nextButton).removeClass(T.params.buttonDisabledClass), T.params.scrollbar && T.scrollbar && (T.scrollbar.track && T.scrollbar.track.length && T.scrollbar.track.removeAttr("style"), T.scrollbar.drag && T.scrollbar.drag.length && T.scrollbar.drag.removeAttr("style"));
      }, T.destroy = function (e, a) {
        T.detachEvents(), T.stopAutoplay(), T.params.scrollbar && T.scrollbar && T.params.scrollbarDraggable && T.scrollbar.disableDraggable(), T.params.loop && T.destroyLoop(), a && T.cleanupStyles(), T.disconnectObservers(), T.params.zoom && T.zoom && T.zoom.destroy(), T.params.keyboardControl && T.disableKeyboardControl && T.disableKeyboardControl(), T.params.mousewheelControl && T.disableMousewheelControl && T.disableMousewheelControl(), T.params.a11y && T.a11y && T.a11y.destroy(), T.params.history && !T.params.replaceState && window.removeEventListener("popstate", T.history.setHistoryPopState), T.params.hashnav && T.hashnav && T.hashnav.destroy(), T.emit("onDestroy"), e !== !1 && (T = null);
      }, T.init(), T;
    }
  };a.prototype = { isSafari: function () {
      var e = window.navigator.userAgent.toLowerCase();return e.indexOf("safari") >= 0 && e.indexOf("chrome") < 0 && e.indexOf("android") < 0;
    }(), isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent), isArray: function isArray(e) {
      return "[object Array]" === Object.prototype.toString.apply(e);
    }, browser: { ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled, ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1, lteIE9: function () {
        var e = document.createElement("div");return e.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->", 1 === e.getElementsByTagName("i").length;
      }() }, device: function () {
      var e = window.navigator.userAgent,
          a = e.match(/(Android);?[\s\/]+([\d.]+)?/),
          t = e.match(/(iPad).*OS\s([\d_]+)/),
          s = e.match(/(iPod)(.*OS\s([\d_]+))?/),
          i = !t && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);return { ios: t || i || s, android: a };
    }(), support: { touch: window.Modernizr && Modernizr.touch === !0 || function () {
        return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
      }(), transforms3d: window.Modernizr && Modernizr.csstransforms3d === !0 || function () {
        var e = document.createElement("div").style;return "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e;
      }(), flexbox: function () {
        for (var e = document.createElement("div").style, a = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), t = 0; t < a.length; t++) {
          if (a[t] in e) return !0;
        }
      }(), observer: function () {
        return "MutationObserver" in window || "WebkitMutationObserver" in window;
      }(), passiveListener: function () {
        var e = !1;try {
          var a = Object.defineProperty({}, "passive", { get: function get() {
              e = !0;
            } });window.addEventListener("testPassiveListener", null, a);
        } catch (e) {}return e;
      }(), gestures: function () {
        return "ongesturestart" in window;
      }() }, plugins: {} };for (var t = function () {
    var e = function e(_e) {
      var a = this,
          t = 0;for (t = 0; t < _e.length; t++) {
        a[t] = _e[t];
      }return a.length = _e.length, this;
    },
        a = function a(_a, t) {
      var s = [],
          i = 0;if (_a && !t && _a instanceof e) return _a;if (_a) if ("string" == typeof _a) {
        var r,
            n,
            o = _a.trim();if (o.indexOf("<") >= 0 && o.indexOf(">") >= 0) {
          var l = "div";for (0 === o.indexOf("<li") && (l = "ul"), 0 === o.indexOf("<tr") && (l = "tbody"), 0 !== o.indexOf("<td") && 0 !== o.indexOf("<th") || (l = "tr"), 0 === o.indexOf("<tbody") && (l = "table"), 0 === o.indexOf("<option") && (l = "select"), n = document.createElement(l), n.innerHTML = _a, i = 0; i < n.childNodes.length; i++) {
            s.push(n.childNodes[i]);
          }
        } else for (r = t || "#" !== _a[0] || _a.match(/[ .<>:~]/) ? (t || document).querySelectorAll(_a) : [document.getElementById(_a.split("#")[1])], i = 0; i < r.length; i++) {
          r[i] && s.push(r[i]);
        }
      } else if (_a.nodeType || _a === window || _a === document) s.push(_a);else if (_a.length > 0 && _a[0].nodeType) for (i = 0; i < _a.length; i++) {
        s.push(_a[i]);
      }return new e(s);
    };return e.prototype = { addClass: function addClass(e) {
        if (void 0 === e) return this;for (var a = e.split(" "), t = 0; t < a.length; t++) {
          for (var s = 0; s < this.length; s++) {
            this[s].classList.add(a[t]);
          }
        }return this;
      }, removeClass: function removeClass(e) {
        for (var a = e.split(" "), t = 0; t < a.length; t++) {
          for (var s = 0; s < this.length; s++) {
            this[s].classList.remove(a[t]);
          }
        }return this;
      }, hasClass: function hasClass(e) {
        return !!this[0] && this[0].classList.contains(e);
      }, toggleClass: function toggleClass(e) {
        for (var a = e.split(" "), t = 0; t < a.length; t++) {
          for (var s = 0; s < this.length; s++) {
            this[s].classList.toggle(a[t]);
          }
        }return this;
      }, attr: function attr(e, a) {
        if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;for (var t = 0; t < this.length; t++) {
          if (2 === arguments.length) this[t].setAttribute(e, a);else for (var s in e) {
            this[t][s] = e[s], this[t].setAttribute(s, e[s]);
          }
        }return this;
      }, removeAttr: function removeAttr(e) {
        for (var a = 0; a < this.length; a++) {
          this[a].removeAttribute(e);
        }return this;
      }, data: function data(e, a) {
        if (void 0 !== a) {
          for (var t = 0; t < this.length; t++) {
            var s = this[t];s.dom7ElementDataStorage || (s.dom7ElementDataStorage = {}), s.dom7ElementDataStorage[e] = a;
          }return this;
        }if (this[0]) {
          var i = this[0].getAttribute("data-" + e);return i ? i : this[0].dom7ElementDataStorage && (e in this[0].dom7ElementDataStorage) ? this[0].dom7ElementDataStorage[e] : void 0;
        }
      }, transform: function transform(e) {
        for (var a = 0; a < this.length; a++) {
          var t = this[a].style;t.webkitTransform = t.MsTransform = t.msTransform = t.MozTransform = t.OTransform = t.transform = e;
        }return this;
      }, transition: function transition(e) {
        "string" != typeof e && (e += "ms");for (var a = 0; a < this.length; a++) {
          var t = this[a].style;t.webkitTransitionDuration = t.MsTransitionDuration = t.msTransitionDuration = t.MozTransitionDuration = t.OTransitionDuration = t.transitionDuration = e;
        }return this;
      }, on: function on(e, t, s, i) {
        function r(e) {
          var i = e.target;if (a(i).is(t)) s.call(i, e);else for (var r = a(i).parents(), n = 0; n < r.length; n++) {
            a(r[n]).is(t) && s.call(r[n], e);
          }
        }var n,
            o,
            l = e.split(" ");for (n = 0; n < this.length; n++) {
          if ("function" == typeof t || t === !1) for ("function" == typeof t && (s = arguments[1], i = arguments[2] || !1), o = 0; o < l.length; o++) {
            this[n].addEventListener(l[o], s, i);
          } else for (o = 0; o < l.length; o++) {
            this[n].dom7LiveListeners || (this[n].dom7LiveListeners = []), this[n].dom7LiveListeners.push({ listener: s, liveListener: r }), this[n].addEventListener(l[o], r, i);
          }
        }return this;
      }, off: function off(e, a, t, s) {
        for (var i = e.split(" "), r = 0; r < i.length; r++) {
          for (var n = 0; n < this.length; n++) {
            if ("function" == typeof a || a === !1) "function" == typeof a && (t = arguments[1], s = arguments[2] || !1), this[n].removeEventListener(i[r], t, s);else if (this[n].dom7LiveListeners) for (var o = 0; o < this[n].dom7LiveListeners.length; o++) {
              this[n].dom7LiveListeners[o].listener === t && this[n].removeEventListener(i[r], this[n].dom7LiveListeners[o].liveListener, s);
            }
          }
        }return this;
      }, once: function once(e, a, t, s) {
        function i(n) {
          t(n), r.off(e, a, i, s);
        }var r = this;"function" == typeof a && (a = !1, t = arguments[1], s = arguments[2]), r.on(e, a, i, s);
      }, trigger: function trigger(e, a) {
        for (var t = 0; t < this.length; t++) {
          var s;try {
            s = new window.CustomEvent(e, { detail: a, bubbles: !0, cancelable: !0 });
          } catch (t) {
            s = document.createEvent("Event"), s.initEvent(e, !0, !0), s.detail = a;
          }this[t].dispatchEvent(s);
        }return this;
      }, transitionEnd: function transitionEnd(e) {
        function a(r) {
          if (r.target === this) for (e.call(this, r), t = 0; t < s.length; t++) {
            i.off(s[t], a);
          }
        }var t,
            s = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
            i = this;if (e) for (t = 0; t < s.length; t++) {
          i.on(s[t], a);
        }return this;
      }, width: function width() {
        return this[0] === window ? window.innerWidth : this.length > 0 ? parseFloat(this.css("width")) : null;
      }, outerWidth: function outerWidth(e) {
        return this.length > 0 ? e ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null;
      }, height: function height() {
        return this[0] === window ? window.innerHeight : this.length > 0 ? parseFloat(this.css("height")) : null;
      }, outerHeight: function outerHeight(e) {
        return this.length > 0 ? e ? this[0].offsetHeight + parseFloat(this.css("margin-top")) + parseFloat(this.css("margin-bottom")) : this[0].offsetHeight : null;
      }, offset: function offset() {
        if (this.length > 0) {
          var e = this[0],
              a = e.getBoundingClientRect(),
              t = document.body,
              s = e.clientTop || t.clientTop || 0,
              i = e.clientLeft || t.clientLeft || 0,
              r = window.pageYOffset || e.scrollTop,
              n = window.pageXOffset || e.scrollLeft;return { top: a.top + r - s, left: a.left + n - i };
        }return null;
      }, css: function css(e, a) {
        var t;if (1 === arguments.length) {
          if ("string" != typeof e) {
            for (t = 0; t < this.length; t++) {
              for (var s in e) {
                this[t].style[s] = e[s];
              }
            }return this;
          }if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(e);
        }if (2 === arguments.length && "string" == typeof e) {
          for (t = 0; t < this.length; t++) {
            this[t].style[e] = a;
          }return this;
        }return this;
      }, each: function each(e) {
        for (var a = 0; a < this.length; a++) {
          e.call(this[a], a, this[a]);
        }return this;
      }, html: function html(e) {
        if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;for (var a = 0; a < this.length; a++) {
          this[a].innerHTML = e;
        }return this;
      }, text: function text(e) {
        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;for (var a = 0; a < this.length; a++) {
          this[a].textContent = e;
        }return this;
      }, is: function is(t) {
        if (!this[0]) return !1;var s, i;if ("string" == typeof t) {
          var r = this[0];if (r === document) return t === document;if (r === window) return t === window;if (r.matches) return r.matches(t);if (r.webkitMatchesSelector) return r.webkitMatchesSelector(t);if (r.mozMatchesSelector) return r.mozMatchesSelector(t);if (r.msMatchesSelector) return r.msMatchesSelector(t);for (s = a(t), i = 0; i < s.length; i++) {
            if (s[i] === this[0]) return !0;
          }return !1;
        }if (t === document) return this[0] === document;if (t === window) return this[0] === window;if (t.nodeType || t instanceof e) {
          for (s = t.nodeType ? [t] : t, i = 0; i < s.length; i++) {
            if (s[i] === this[0]) return !0;
          }return !1;
        }return !1;
      }, index: function index() {
        if (this[0]) {
          for (var e = this[0], a = 0; null !== (e = e.previousSibling);) {
            1 === e.nodeType && a++;
          }return a;
        }
      }, eq: function eq(a) {
        if (void 0 === a) return this;var t,
            s = this.length;return a > s - 1 ? new e([]) : a < 0 ? (t = s + a, new e(t < 0 ? [] : [this[t]])) : new e([this[a]]);
      }, append: function append(a) {
        var t, s;for (t = 0; t < this.length; t++) {
          if ("string" == typeof a) {
            var i = document.createElement("div");for (i.innerHTML = a; i.firstChild;) {
              this[t].appendChild(i.firstChild);
            }
          } else if (a instanceof e) for (s = 0; s < a.length; s++) {
            this[t].appendChild(a[s]);
          } else this[t].appendChild(a);
        }return this;
      }, prepend: function prepend(a) {
        var t, s;for (t = 0; t < this.length; t++) {
          if ("string" == typeof a) {
            var i = document.createElement("div");for (i.innerHTML = a, s = i.childNodes.length - 1; s >= 0; s--) {
              this[t].insertBefore(i.childNodes[s], this[t].childNodes[0]);
            }
          } else if (a instanceof e) for (s = 0; s < a.length; s++) {
            this[t].insertBefore(a[s], this[t].childNodes[0]);
          } else this[t].insertBefore(a, this[t].childNodes[0]);
        }return this;
      }, insertBefore: function insertBefore(e) {
        for (var t = a(e), s = 0; s < this.length; s++) {
          if (1 === t.length) t[0].parentNode.insertBefore(this[s], t[0]);else if (t.length > 1) for (var i = 0; i < t.length; i++) {
            t[i].parentNode.insertBefore(this[s].cloneNode(!0), t[i]);
          }
        }
      }, insertAfter: function insertAfter(e) {
        for (var t = a(e), s = 0; s < this.length; s++) {
          if (1 === t.length) t[0].parentNode.insertBefore(this[s], t[0].nextSibling);else if (t.length > 1) for (var i = 0; i < t.length; i++) {
            t[i].parentNode.insertBefore(this[s].cloneNode(!0), t[i].nextSibling);
          }
        }
      }, next: function next(t) {
        return new e(this.length > 0 ? t ? this[0].nextElementSibling && a(this[0].nextElementSibling).is(t) ? [this[0].nextElementSibling] : [] : this[0].nextElementSibling ? [this[0].nextElementSibling] : [] : []);
      }, nextAll: function nextAll(t) {
        var s = [],
            i = this[0];if (!i) return new e([]);for (; i.nextElementSibling;) {
          var r = i.nextElementSibling;t ? a(r).is(t) && s.push(r) : s.push(r), i = r;
        }return new e(s);
      }, prev: function prev(t) {
        return new e(this.length > 0 ? t ? this[0].previousElementSibling && a(this[0].previousElementSibling).is(t) ? [this[0].previousElementSibling] : [] : this[0].previousElementSibling ? [this[0].previousElementSibling] : [] : []);
      }, prevAll: function prevAll(t) {
        var s = [],
            i = this[0];if (!i) return new e([]);for (; i.previousElementSibling;) {
          var r = i.previousElementSibling;t ? a(r).is(t) && s.push(r) : s.push(r), i = r;
        }return new e(s);
      }, parent: function parent(e) {
        for (var t = [], s = 0; s < this.length; s++) {
          e ? a(this[s].parentNode).is(e) && t.push(this[s].parentNode) : t.push(this[s].parentNode);
        }return a(a.unique(t));
      }, parents: function parents(e) {
        for (var t = [], s = 0; s < this.length; s++) {
          for (var i = this[s].parentNode; i;) {
            e ? a(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
          }
        }return a(a.unique(t));
      }, find: function find(a) {
        for (var t = [], s = 0; s < this.length; s++) {
          for (var i = this[s].querySelectorAll(a), r = 0; r < i.length; r++) {
            t.push(i[r]);
          }
        }return new e(t);
      }, children: function children(t) {
        for (var s = [], i = 0; i < this.length; i++) {
          for (var r = this[i].childNodes, n = 0; n < r.length; n++) {
            t ? 1 === r[n].nodeType && a(r[n]).is(t) && s.push(r[n]) : 1 === r[n].nodeType && s.push(r[n]);
          }
        }return new e(a.unique(s));
      }, remove: function remove() {
        for (var e = 0; e < this.length; e++) {
          this[e].parentNode && this[e].parentNode.removeChild(this[e]);
        }return this;
      }, add: function add() {
        var e,
            t,
            s = this;for (e = 0; e < arguments.length; e++) {
          var i = a(arguments[e]);for (t = 0; t < i.length; t++) {
            s[s.length] = i[t], s.length++;
          }
        }return s;
      } }, a.fn = e.prototype, a.unique = function (e) {
      for (var a = [], t = 0; t < e.length; t++) {
        a.indexOf(e[t]) === -1 && a.push(e[t]);
      }return a;
    }, a;
  }(), s = ["jQuery", "Zepto", "Dom7"], i = 0; i < s.length; i++) {
    window[s[i]] && function (e) {
      e.fn.swiper = function (t) {
        var s;return e(this).each(function () {
          var e = new a(this, t);s || (s = e);
        }), s;
      };
    }(window[s[i]]);
  }var r;r = void 0 === t ? window.Dom7 || window.Zepto || window.jQuery : t, r && ("transitionEnd" in r.fn || (r.fn.transitionEnd = function (e) {
    function a(r) {
      if (r.target === this) for (e.call(this, r), t = 0; t < s.length; t++) {
        i.off(s[t], a);
      }
    }var t,
        s = ["webkitTransitionEnd", "transitionend", "oTransitionEnd", "MSTransitionEnd", "msTransitionEnd"],
        i = this;if (e) for (t = 0; t < s.length; t++) {
      i.on(s[t], a);
    }return this;
  }), "transform" in r.fn || (r.fn.transform = function (e) {
    for (var a = 0; a < this.length; a++) {
      var t = this[a].style;t.webkitTransform = t.MsTransform = t.msTransform = t.MozTransform = t.OTransform = t.transform = e;
    }return this;
  }), "transition" in r.fn || (r.fn.transition = function (e) {
    "string" != typeof e && (e += "ms");for (var a = 0; a < this.length; a++) {
      var t = this[a].style;t.webkitTransitionDuration = t.MsTransitionDuration = t.msTransitionDuration = t.MozTransitionDuration = t.OTransitionDuration = t.transitionDuration = e;
    }return this;
  }), "outerWidth" in r.fn || (r.fn.outerWidth = function (e) {
    return this.length > 0 ? e ? this[0].offsetWidth + parseFloat(this.css("margin-right")) + parseFloat(this.css("margin-left")) : this[0].offsetWidth : null;
  })), window.Swiper = a;
}(),  true ? module.exports = window.Swiper : "function" == typeof define && define.amd && define([], function () {
  "use strict";
  return window.Swiper;
});
//# sourceMappingURL=maps/swiper.min.js.map

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 70 */,
/* 71 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA6BJREFUWAnNmT1oFEEYht9dJDnhrhBBwcLCWIUgQrCKaCNYGkUJ2GgTkPxYqFj6g4UgCTaaxkoLRaNGRSGCINiLBNOIioJ4oJUmB0ajWd93bje3u7eb3b3bS25gb2Znvvnmme/b+T0LDQZnAV34gwNw0AsLW6hmC9OKwfcyf8t8LzP9Gh14bBXw0ZRl/LGyyDvz2IQljLDRg2y8J0td1pllnSnYuGaV8D1t3VSAjoMiKjhNuDNUXEyrPEauQsgxahm3LGpNCImAtNoh9nyCz+YEXdmKLXyjVYdozYcrVbTjCmk1i3DnCXY/dzg1qg5Tt9pQW3EckQWssB7zuEkFR+Iq5ppvYRIlHKPLf4X11gGa3szj7qrBeURVyAFCOl6W4noXV3Bu1eFEIm+p7VAIWNAdEPrmAvmhOq17lfUsHPYPnGUQurbI7+4DRfIdrVm7o9FdwnZvCqq5WPPcWsOpM2IQixuMBelarRBaipqdhD29zcaazLu04lQtuITRNoJT54pmSWWiCmihX7ltFbTeM9hmV5J14W+wJ7fuAFu7gZ19wJuZBCVkEptttkwJsnkUT9wAjp8AvnwFZmaBk2dTaOV2bh1HTW8K0aZEBDesfZAvLC76XuKSZLM5MVY3mXFCTeZHwRU6gSuXUigmmwZJywAFNxKynOAe3Qb29KUAJJvl/OT60YL5z4Pzr/we3P59qeAkVJEF/Trqaj6dBrbtALp3AS9f1RVHZuQEJ90OnDm8oxWdqGfpB5yNG0wH1AmHFnCmH0TLevWvj8Hh8mTkTQMp63n1AzHZZEGdwCIDNxD4+69WtPAb6D8KPH9Ry/OncrScp7Zss6+xgDbxr172ZKtxHGQL4OQHHl3ncCpg1gh3y23ECzx+d+fqVn/7ZIOWkyRAlcdBDg/m+M354ZTW5YACrfi2UciVLJtGZ6wMmcSmQSLnTZk44WdoEKAlY0MD81ysLo+poQ2rBkR4be3oAJ5wt5JhEo6H4wQd2LCauxJdR6QMsuTEOM3vnmgKBeDZvdzg5Ncxw0Qetwl6uYFD03seEj59BvbuBjq5xuYSQoemZUApb8djZ3WQuF0351ELF3OxRCNK2LZh8NUNWFD5bX/1Ye5GeJHDr3PS15HWJmuXR1qtAiHgYq/E3DKVMMDRdIGgdZU8uaZj6VYbbMu0GaGwzsVhGXfgrNkFZiKggM0U1K5XwH6Lulcko3R7P53T4y9LTLfyEj2qcbPTWIW/If4DwWqQSNxwgaIAAAAASUVORK5CYII="

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAM9SURBVEgNzVfNaxNBFH9vNrWt+eihUqjiRQ9F7EFP9qJnexBPUtq0pWjRg6Ylgqi39KIgSKXpQaT1oP0Q8eal/gW9CGLFL0RQKiJtqthk87k7zzdp12zS2ZDYQh3YzJvfe7/3m8zOzEsw2z/aYUm6BnU2CXIxNDc5nQxH7iOhrx46ESV9BcB2IvtCPcSNWNHI/TRIGOJJKLvmhoCrouboHQ4sWyJEnAKEca0GQZSXaFjrc4Eo8BwP37mgkilpgQAOKqBSOBGYndCSUuGRBAuXknhYwoDP/kdxbY713kgeYCNHmbA7F0WjzbBiNRSxmYmk2T/qdle1KRbbA5/WmopB/s4MPrhUqCR4vuPkj8KTpKTf6kmdH9lXSaw2Tn1MDDtc03zTo4v1FNYF7yTmudSI4hVsHpNAw968mc/UrCsAlyXSC0UgAd91RE/h4NxEzE3gzeUeVrX98/HnHKAez1YmLIkuJ/si/bpo9rXo8EpMWrTAOXj3ahpRu3MuyoSBKMiOoIZSM8Qnrs05MtVIu7a5dk3YF5BNr03MnK62LFofiuJuRUOcQQl1fQECyvtSjaYPchTSJq8CGiR/Fd1NsERp+1TRRnwbnNVfl8pvhq90S4KAEEbOBwXjKJH1tEis48MCnOHwAUjDMd5QRT6XuzHGYl5pbIlx3niHpS3/k7LoNdNquAG+D4D2VRUjkBarxgq4xavTQoiZsnPM9TjBxBUPchuXxS3Fonnu7leOH3c42b7ooQJaTSAMCj6+997BVe+fjT90xpXCU1yPbzpOd89X5m0WvuHGdHaBrGccdxylnWP/RmnUBJYJu/3r4cgdrtknFRbcY3SbBel2b9v2FAZJHZy9Symk0G7gHbstsfTA6AnLtjtVEq5eWW/hbclsJVs29fAKRpWH68Gqp3BofvKsm15PWXTzvOy6rjqvJP+Cl31jrrn70+FI8b1WJrOIDlRiakwXr7dkzPSRTd83/leyBIg53tmY7I2UjiZRwKnFKrZMmOvxoEUwuJmkps5MZbt4wgsqmH8ujYXm40PKpkikMZmgrLJ1bfeWusGwl/NS/L15dLPTYQLxpcJ9Ar44fD5ypSuztdWGtZ9eeVN/AEtfO3wgsYivAAAAAElFTkSuQmCC"

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/empty-00.10ada5d.png";

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAA+xJREFUWAntVk1IlEEYdtfddiGwoL89iSWBEXZaKEoq6GI/iwRiEIK4rpcoQugSQQaKePRQCO26/hw8CIHRD3kRPQhehEjo1EEhyQ5iLLS5u+r2PJ8zH+PnzLr7tQRBA7Mz+877PPPMO/PNvBUV/3oZHh4Ooh4u1zo8xRIlk8nz29vbkXw+fx2YWtRDApvxeDwrqLMYfxsKhT5EIpF0sbzSb18hiUTiMpz7IOCSBBVqIeg7xnurqqpetrS0ZAv5qmNGIRMTEwdSqdQLCIipAPQXMdk82m+oG+iH4FOHegX/A6hWgf0zOk2xWOyLMBVstELGx8ePptPpSSUKGbAMgnwAxMs6xrGxsYPZbPYOMN0YrxY+65WVlc3RaHRah1Fte4SISEwrIhZ8Pl9ze3v7kgo09QW+H/gu+kD8T/QvdnZ2fjJhLD/nIM5EHEBrO0Ayib2+i73+5fTb7z94ovBJgAs0niW/3x9ua2tbM+G86gAPphQB+4JbEeTEFibRPGMfnDW5XK6HfVPZJQROfcIxw+1wEwl1oo6Ojh5EY4Y2LhBXwCl1XO3bQnA5XYCz/EQHiz0TKpmzDxF5HNbHwu7f2tp64PSR/20hcLoljSAYkP0/bbEgfuqsLJGdZu+vLQTR4I3Jsmj6RHeGS//1er1vBKoWkT+tY7CFYJDXNj83qV7n78qmciLy1jxOIksIHzAMyLeDN2ZZCya3OSEqpCOXEaEQWTZkp1wtDixvZlnUuaStwhKCA/UDFsvZpNhGuOjg/J2QMPRXZV9tZUR4NlY4AMc61aEcfXCekTyIjjWP/C9bVcgsjQBd4QMmHcrU3iAPFpuqr6//qOO0hTCpEQ4BvqI6Zzc23KbHgGsU2KlwOJzT8dhCmFlBMZMaRqWbr6gOUKoNC3wCPivCaEdMeFuISO96hWM1kqJ+E6hY+9DQUAMmv0d/LHIOqcB7E9YWQgemdwAws2JUusRTzr8lF5yzk4jGKwD9qJs4pI8KkewSInLMJgDWBQhaEk8hak8CVYiUkchkMvPwOS78eD2sFsJoJ8Dk1wB6DQHW3iJKM3xFxQNm5OPBFGeC28FI2AUcy+C4anrVtUKIjsfj5wCmmBqbDa8oHzDY53ltBwKBDSQ8IUxeB9tN+DVK8ehvwvYQ7VnY5DkxijEK4eSjo6NHmFmBiKnjrhVy3FQgYI5nghEE1oOter6fmIJC5ETMrBABJjXMJ7SvJyZPYWwKE444v45ixBQlRApiy3yCTzkm5isaxCSrWP0Kb0zTZUWcTkwwGGxobW39yvGShRDktjjF4Lz1I6+1UkmfW1I3OEQRWvL3sdVraG+D450bnv+YvxqB3/3RvPwKtzOWAAAAAElFTkSuQmCC"

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-coupon-discount.aef63ae.png";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-coupon-reduce.3b094b8.png";

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAAAXNSR0IArs4c6QAAA8pJREFUSA2tlUtIVGEUx5txHAuCInpomqBJ5CpCCouotIQYKaxWbRSfg4K1aNFDiyIqyUUQVsz4TCLMRZbaILjQhVG0qVUEaWQ6Wi3ysZDRGZ1+5zqfXJ253in64Lvn3HP+5/y/8z0ta0xaY2PjnoWFhTx6NtAkegLdRx+3WCyDyG5kZ2lp6U90w2Yx8jQ0NBwmeW0wGNwfwkyT8Bv6OH0tPQFfKtKGfR7ZEhMTc724uHgMPayFEXk8nriRkREXyAK6nyRN9La0tLSBrKysgD5Dc3Pzxrm5OQf+UkiP4puhVzidzid6nOjLiJqamrYEAoFOgjIJ9iDPEzS0MijSf319vYMZeIwvmdh7ZWVll/S4JaL29nb7xMREP84D9BqAVwkI6sFmemtr61afz9fBAA9ardYq1u2OirEqBZKH6BoJVVyJROJ2uz0ulyuIrFZxepmfn/8LkhxiP1LdLalS+TUiDJkYSug9VFKlnBHkXMjmj+DTTAxyhmryIJuEtE5mShwaEYYa9AC7phLAghYR+aMRgFeEEVElJSXDOG6DS5mcnHQKyEo16RiOoLcAkHOxWlOVKGmIjY2NfYRTjkK5gKyQnBKF9mxRGH9VJUzNqhVJhsLCQjnUL4hJ50ymCVEOhmn6AN2sqUqUXBXPMrwWwPz8fI6sUTJ9iEU0DSZQVWKKFQLwn0XSkoUoAYPMZTRNI1BTaBZgs9lU3gS166I6mDqCqCrSD0SIhFVu5GjaX1VEwvhQ0nEr0zbCz86+vj6bGZNut0VVEZtgt+QUDtl1vegbBgcHD5kRca08h+wsZ+SDGVb84HNFgu+18en0+/13MZ7D1i8Oo8bOlF2kdpIRTLPLczM6OnpG8JypL9aioqJP/MgZKuSZSNVQBh8JlnuRWdA2kQFMM3u93nJw25kBlxi0AO64y+ixVPYA59LToUXoPoywh8rfcnvX6cxhKgPeAa6atRlOTEyUN2qRiDvuDcYW/nNJclMckRqD2ByyKxkG47Zex+PZQb5NVFPpcDhmBbQ0BaxVOc732K4JWaTK7Hb7SYKdYCokeGXjrdrMu9ZDbAa+GxTQpTDLpon53waoi74P0lckvRC68hXeUDK44zjdxKYQe5/X9SJy6SJYRiRZpHTekEYCZBfOAnYj2wh8h77srQK7fmpq6gTYMrq8rD5kJbuzQXLpWxiRcnK1H+PA1fK/V2wk+U2Sr8gf/Mahyx25C2lHysifoldD8l3wK5shkQAJtLCDMljc0yTLxpSELR59FjnG/xDT283avSwoKPBKzH9rQv4vyf4AV4fG3e9YxOgAAAAASUVORK5CYII="

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAYAAAA1+Nx+AAAAAXNSR0IArs4c6QAAAQNJREFUOBHFkzEOgjAUhmkTnIRbuHoCL+Dg4IIz4QxOHsEzEGaJiYODF/AEJkzeApyUgO+vhVQsUFh8A7R9r98X+gqzKOI4nmRZtuKc33zfv2NtbERRNCuKYu44ztnzvCcHKE3THS0e8zxPwjBcj4VjLxhggQmOEChAm5KHMRLswV5i2QrvI3Bdd88Yu8rEYEkTDhaY4LHKRn2Y0mddyrJcyLUX9WQTBMGpqtG9W+BLOv8H6msBJkMlffAfwRCJCVwrMJGYwlsFXRLk1NsiG1qfOfJqfPVATWCs64msEVexD47aTgEKNBIsWyZwUSeqex5NiSncWIBCKdlijJ+ouueY/zXeGy/WGeknRrIAAAAASUVORK5CYII="

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAABkCAYAAACy0tHQAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAABEZVhJZk1NACoAAAAIAAIBEgADAAAAAQABAACHaQAEAAAAAQAAACYAAAAAAAKgAgAEAAAAAQAAAAygAwAEAAAAAQAAAGQAAAAAcD5TfwAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDYuMC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KGV7hBwAAARBJREFUWAntV7EOgkAMJcbEr3Bj9Ecc3dwc/QL+SzcmNzdHP8btfE8Fj3qFkrActskLvfY9UnrlAkUBCyFUwJBV5LYGdp+oS25UiihNVkT9ZCGykRuRX4c6gA08EkO8Ng9yTbSByFlEvsmdg2CpPOkF8aDksghjl1eEuVgfDdGq0eMt9O8l2romkslMgqj/QJjLBdmPmbhb2jFzjUl/4ftoiG2e7Jgp0dpS3DyrJerfE+aifZZEq7Rj5iZ4819iNM7AKfWkWpfUb6XRr+gcBKnO8d90QySTmQRR/44wlwuyf83E3dJeoHtMcn+SDmD4toTpZh/yA1eiXxSR4b5MFyHNMkiQ9isCQyM34q/IQO6Int3HfLLz52tZAAAAAElFTkSuQmCC"

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.4bd883e.gif";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAEuUlEQVQ4EX3Ue2xTVRzA8e+9vb297dq13bp2zYoEGBmbPIaAzwm6mADKJowEQU0Ug8FolPjgD0UjRmP0HwKGEAmJiRD+UDEhYRPFZQjIIiQGBBbYxtgcLRtbu669bW/b29trRkKD+Dj/nOfvk3NOfucI/E8xzcHqzEBP6/Efz76c0wrysuWN+yrnLTwsCLPD/xUm/NuEqf3yeN+xzle6j/a2mlq/cj3nwOL1MN2noEUdhabmmUfqW9q+EpTG9rvjpbsHTNNUuna90LXt016ee9JkodPCcuEmNkUl8VAT56IOadPmn9d8ONS3ZmqtIAi5Ow3xzo5pxkK5c9t+2nUwwYZNM3kxlMS9t4dYr0FswCCx6kueNi6yZf969n2vY/bu/M40B5U7jRKYM4fqh9u3DSxddXGppzbAa76LDB5MIk7zYKh5yBURqjx0v36adY5zBB5ZyBOrOlrGf913bfzKzrrbaAmUMx3OI70u+eyNxaxcrJI6n0QcTiB4bNgmDLKnb2KdUYmS0oh+fYa25Xm6rjZw4JQRdIuT9r+BsT+Oh4yzx3cUBTtIGcrVGyRHwWroMJFFmOVAXuRBHEkjUyQ6qFFTkQNBIJ4SsVbJO0xtcsYUemuH4Ws/rNUjkSavU4aCDTMYxNdUTQoT9eFKjA0hnB814tgyH7HKgX+Rj3QmD6ZJ0O+A8PnHYyMnXiqBZWXe+qSqM7MqC0olx844kJrLibVMx4ioCBfSZDpuog9OIm9touLNBRzaHwfKaJwnkR4YIzt8LVQCjYmRlmRcYm5IJXS/zJ4DZZz4LEzjkiBuh4tMT5ziWI7sxTiuyCSXPu7ji/02Ao0e5tUkiEZyFOKXm0qgKKU9alKkfLyPdcsNCroTvX2Uym9+R6yxkq+yUPRL+JqDBLuuEd13iXTeQlurFVesHzUpYXFZrFPgrcS2O+7pFOuGWo1ADRsfUNlRU8WeSD369R4qY/2IbjtaTxy11k/EG+Rb0Q7lHjY+OEbBFcJzr4DdG+oogSD4zaTJjQGVufWDfPLOIt7fupR2dR4kdVozMSo8Ioc6XKRwAF7eelVhSW0/N/qBbAZTTy0ogZJHX1xwBdBHdcJjl3mjyUZbZxldRzNcEeezouEqQXuUwpEa8nGNaXMcvLdiiJvdQ2R0BcUnI3nlOVPgrc8hlzrzbPS3zw9qo3lyUR3CfzJrdSO2gAJGDCMmkRrTcM+ogOmVEI4yeLgXzeXDOdOJvdqBd/aGZVbvUydLv00hdf752KUdu42s5o6eGkUqM6leVo8xoaFn0ogOBaWiDEG2EuseoGBIuBfPQs8S89Q9tt4ZWNtZOvJUQ41mI9lRu6YEiu5Acy1GIo2hJsEhY5E9yHbIT6ZIh+Mo0ytRQgFykxmyEdXM1iSmiFul9Jat5sl3/fe5qq3eILlEkaIhUTQsZMdVMIvkYwlS/eMIU9khCGRHoljtIoFHgz6bM7X5H2CZrXm1qnl2Z8LhtGyZpNxfwCpkkAUdS24SU9NwzfFRXluOKKeQ3DKCt3q4IDV+4PRPPHMbLN3h7YHevW/7kuMjK7N6eFlNg6/BSJpOxStWWO12Mklz2O6vyEi+hvOxgWhn3QXjmLB9e/F27FT9F7ehBVLGAxSGAAAAAElFTkSuQmCC"

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wait.4c0fead.png";

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(422),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// var wx = require('weixin-js-sdk')
// const env = 'production';
var env = "production";
var CryptoJS = __webpack_require__(197);
var key = CryptoJS.enc.Utf8.parse('q6%WF*1SvQx^YWzK');

/* harmony default export */ __webpack_exports__["a"] = ({
  ua: navigator.userAgent,
  // 获取host
  getHost: function getHost() {
    var host = void 0;
    switch (env) {
      case 'test':
        host = 'http://alywechat.imcoming.com';
        break;
      case 'production':
        host = 'https://alywechat.anlaiye.com';
        if (document.domain.indexOf('xiyoushi.com') >= 0) {
          host = window.location.origin;
        }
        break;
      default:
        host = 'http://alywechat.imcoming.com.cn';
    }
    return host;
  },

  // 获取 拼接 host
  getSpliceHost: function getSpliceHost(target) {
    var host = void 0;
    switch (env) {
      case 'test':
        host = 'http://' + target + '.imcoming.com';
        break;
      case 'production':
        // if(target == 'open-base'){
        //   target = 'web-agent';
        // }
        host = 'https://' + target + '.anlaiye.com';
        break;
      default:
        host = 'http://' + target + '.imcoming.com.cn';
    }
    return host;
  },

  // 获取 api agent host
  getAgentApiHost: function getAgentApiHost() {
    var host = void 0;
    switch (env) {
      case 'test':
        host = 'http://open-base.imcoming.com';
        break;
      case 'production':
        host = 'https://open-base.anlaiye.com';
        break;
      default:
        host = 'http://web-agent.imcoming.com.cn';
    }
    return host;
  },


  // 判断是否微信
  isWeiXin: function isWeiXin() {
    return this.ua.indexOf('MicroMessenger') > -1;
  },

  // 判断是否企业微信
  isWxWork: function isWxWork() {
    var ua = this.ua.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork';
  },


  // 判断是否是安卓
  platform: function platform(os) {
    var ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(this.ua.toLowerCase()) || [, 0])[1]).replace(/_/g, '.');
    return parseFloat(ver) || undefined;
  },
  isAndroid: function isAndroid() {
    return this.platform('android[/ ]');
  },

  // 二级域名下
  setCookie: function setCookie(name, value, days) {
    var domain, domainParts, date, expires, host;

    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    host = location.host;
    if (host.split('.').length === 1) {
      // no "." in a domain - it's localhost or something similar
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = host.split('.');
      domainParts.shift();
      domain = '.' + domainParts.join('.');

      document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;

      // check if cookie was successfuly set to the given domain
      // (otherwise it was a Top-Level Domain)
      if (this.getCookie(name) == null || this.getCookie(name) != value) {
        // append "." to current domain
        domain = '.' + host;
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
      }
    }
  },
  getCookie: function getCookie(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
  },

  // 解析地址
  resolveUrl: function resolveUrl() {
    var obj = {};
    var url = window.location.href;
    if (url.indexOf('?') !== -1) {
      var param = url.split('?')[1];
      if (param.indexOf('&') === -1) {
        var pa = param.split('=');
        var paName = pa[0];
        var paValue = pa[1];
        obj[paName] = paValue;
      } else {
        var paramsArry = param.split('&');

        for (var i = 0; i < paramsArry.length; i++) {
          var pa = paramsArry[i].split('=');
          var paName = pa[0];
          var paValue = pa[1];
          obj[paName] = paValue;
        }
      }
    }
    return obj;
  },
  // 时间格式化
  getFormatTime: function getFormatTime(time) {
    var date = new Date(time);
    return date.getFullYear() + "." + (date.getMonth() + 1) + "." + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
  },
  wx_share: function wx_share(title, link, imgurl, desc) {
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function success() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function cancel() {
        // 用户取消分享后执行的回调函数
      }
    });
    // 分享给微信好友
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function success() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function cancel() {
        // 用户取消分享后执行的回调函数
      }
    });
    // 分享给qq好友
    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function success() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function cancel() {
        // 用户取消分享后执行的回调函数
      }

    });
    // 分享到微博
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function success() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function cancel() {
        // 用户取消分享后执行的回调函数
      }
    });
    //分享到qq空间
    wx.onMenuShareQZone({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function success() {
        // 用户确认分享后执行的回调函数
      },
      cancel: function cancel() {
        // 用户取消分享后执行的回调函数
      }
    });
  },
  wxShareNew: function wxShareNew(_this, title, link, imgurl, desc) {
    var u = encodeURIComponent(window.location.href.split('#')[0]);
    var host = this.getAgentApiHost();
    if (env == 'local' || env == 'development') {
      host = host + '/wechatDev';
    } else {
      host = host + '/wechat';
    }
    var that = _this;
    that.$http.get(host + '/Jssdk/shareconf?url=' + u).then(function (res) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (res.flag == -1) {
        // alert(redata.message);
        return;
      }
      var data = res.body.data;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
        openTagList: ['wx-open-launch-weapp']
      });
      wx.ready(function () {
        // 分享到朋友圈、qq空间
        wx.updateTimelineShareData({
          title: title, // 分享标题
          link: link, // 分享链接
          imgUrl: imgurl, // 分享图标
          success: function success() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
          }
        });
        // 分享给微信好友、qq好友
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接
          imgUrl: imgurl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
          }
        });
      });
      wx.error(function (res) {
        console.log(res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    }, function (data) {
      if (data.message) {
        // alert(redata.message);
      }
    });
  },

  //去掉url后的某个参数
  funcUrlDel: function funcUrlDel(name) {
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + "?";
    var query = loca.search.substr(1);
    if (query.indexOf(name) > -1) {
      var obj = {};
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      };
      delete obj[name];
      var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
      return url;
    };
  },

  //在微信内修改url后点击用safari打开/复制链接是修改之前的页面
  share: function share(route) {
    var replaceQueryParam = function replaceQueryParam(param, newval, search) {
      var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
      var query = search.replace(regex, '$1').replace(/&$/, '');
      return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
    };

    if (!route.query.refresh) {
      var chat = '&';
      if (!Object.keys(route.query).length) {
        chat = '?';
      }
      window.location.replace(location.protocol + '//' + location.host + location.pathname + replaceQueryParam('_wxr_', new Date().getTime(), location.search) + location.hash + chat + 'refresh=true');
    }
  },
  toLogin: function toLogin(that, page) {
    if (this.getCookie('source') === 'iaaa') {
      //调转北大登录
      var hostStr = window.location.host;
      var host = hostStr.replace('alywechat', 'open-base');
      var url = location.protocol + '//' + host + '/' + 'iaaa/auth/callback?openId=' + that.$store.state.wxToken;
      // <input type=hidden name='redirectUrl' value='http://web-agent.imcoming.com/iaaa/auth/callback?openId=${that.$store.state.wxToken}'>
      document.write('<form action=\'https://iaaa.pku.edu.cn/iaaa/oauth.jsp\' method=post name=\'formx1\' style=\'display:none\'>\n              <input type=hidden name=\'appID\' value=\'Alyxndc2020\'>\n              <input type=hidden name=\'appName\' value=\'\u4FFA\u6765\u4E5F\u6821\u5185\u8BA2\u9910\'>\n              <input type=hidden name=\'redirectUrl\' value=\'' + url + '\'>\n          </form>');
      setTimeout("document.formx1.submit();", 1000);
    } else if (this.getCookie('source') !== 'iaaa' && page !== 'index') {
      that.$router.push({ name: 'Login' });
    }
  },

  // 获取设备号
  setupWebViewJavascriptBridge: function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  },
  firstLogPush: function firstLogPush(size, arr, code, key) {
    size = size ? size : 0;
    var uid = localStorage.getItem('wxUid');
    var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
    exposureLog = exposureLog ? exposureLog : [];
    var list = new Array(),
        idx = 0;
    if (size > arr.length) {
      idx = arr.length - 1;
      list = arr;
    } else {
      list = arr.slice(0, size);
      idx = size - 1;
    }
    // console.log(list)
    // console.log(key)
    for (var i = 0; i < list.length; i++) {
      exposureLog.push({
        uid: uid,
        firstValue: i,
        // shopid: list[i][key],
        refId: list[i][key],
        createTime: new Date().getTime(),
        code: code
      });
    }
    localStorage.getItem('recordLogIdx', idx);
    localStorage.setItem('lastLogTime', new Date().getTime());
    localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
  },

  // aes 加密
  Encrypt: function Encrypt(word) {
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString().toUpperCase();
  },

  // aes解密
  Decrypt: function Decrypt(word) {
    if (!word) {
      return '';
    } else {
      var encryptedHexStr = CryptoJS.format.Hex.parse(word);
      var decrypt = CryptoJS.AES.decrypt(encryptedHexStr, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt);
    }
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_TagPage__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_TagPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_TagPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_HomePage__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ShopList__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_ShopList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_ShopList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_GoodsList__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_GoodsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_GoodsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_UserCenter__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_UserCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_UserCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Search__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ChooseSchool__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_ChooseSchool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_ChooseSchool__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_ChooseAddress__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_ChooseAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_ChooseAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Cart__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_OrderSettle__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_OrderSettle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_OrderSettle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_AddressList__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_AddressList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_AddressList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_AddAddress__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_AddAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_AddAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_EditAddress__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_EditAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_EditAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_FindBuild__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_FindBuild___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_FindBuild__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_OrderList__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_OrderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_OrderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_OrderDetail__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_OrderDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_OrderDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_DeviceDetail__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_DeviceDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_DeviceDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_DeliveryDetail__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_DeliveryDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_DeliveryDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_MyComment__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_MyComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_MyComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_MyComplaints__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_MyComplaints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_MyComplaints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_MyCoupons__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_MyCoupons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_MyCoupons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_MyDisableCoupons__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_MyDisableCoupons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_MyDisableCoupons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelectCoupon__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_SelectCoupon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_SelectCoupon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_CheckComplaints__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_CheckComplaints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_CheckComplaints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_OnlineComplaints__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_OnlineComplaints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_OnlineComplaints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_OnlineComment__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_OnlineComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_OnlineComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_OtherDetail__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_OtherDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_OtherDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_FeedBack__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_FeedBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_FeedBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Auth__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Payment__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_Payment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_AliPay__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_AliPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_AliPay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Map__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_SelfTakeProtocol__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_SelfTakeProtocol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_SelfTakeProtocol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_OnlineRefund__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_OnlineRefund___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_OnlineRefund__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__mujia__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Reward__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Reward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_Reward__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_RewardList__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_RewardList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_RewardList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_OutRemarks__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_OutRemarks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_OutRemarks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_BindPhone__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_BindPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_BindPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_QrCode__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_QrCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_QrCode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SchoolPaySuc__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_SchoolPaySuc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_SchoolPaySuc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_wxWork__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_wxWork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__pages_wxWork__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_myScore__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_myScore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_myScore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_scoreDetail__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_scoreDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_scoreDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_MemberLevel__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_MemberLevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__pages_MemberLevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_ExpDesc__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_ExpDesc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__pages_ExpDesc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_RestaurantDetail__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_RestaurantDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__pages_RestaurantDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_packingFee__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_packingFee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__pages_packingFee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_CouponPackage__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_CouponPackage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__pages_CouponPackage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_CouponPackageShopList__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_CouponPackageShopList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__pages_CouponPackageShopList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_CouponPackageRecord__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_CouponPackageRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__pages_CouponPackageRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_PaySuccess__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_PaySuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__pages_PaySuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_PaySuccess1__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_PaySuccess1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__pages_PaySuccess1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_PunctualArrive__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_PunctualArrive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__pages_PunctualArrive__);

















































// import RestaurantDetail from '@/pages/RestaurantDetail'











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var constantRouterMap = [{
  path: '/',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Login___default.a,
  meta: {
    title: '登录',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/index',
  name: 'TagPage',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_TagPage___default.a,
  meta: {
    title: '校内订餐',
    keepAlive: true,
    isUseCache: false,
    showTab: true
  }
}, {
  path: '/homepage',
  name: 'HomePage',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_HomePage___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/shoplist',
  name: 'ShopList',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_ShopList___default.a,
  meta: {
    keepAlive: true,
    isUseCache: false,
    showTab: false
  }
}, {
  path: '/goodslist',
  name: 'GoodsList',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_GoodsList___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Login___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/usercenter',
  name: 'UserCenter',
  component: __WEBPACK_IMPORTED_MODULE_7__pages_UserCenter___default.a,
  meta: {
    title: '我的',
    keepAlive: false,
    showTab: true
  }
}, {
  path: '/search',
  name: 'Search',
  component: __WEBPACK_IMPORTED_MODULE_8__pages_Search___default.a,
  meta: {
    title: '搜索',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/chooseschool',
  name: 'ChooseSchool',
  component: __WEBPACK_IMPORTED_MODULE_9__pages_ChooseSchool___default.a,
  meta: {
    title: '选择当前位置',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/chooseaddress',
  name: 'ChooseAddress',
  component: __WEBPACK_IMPORTED_MODULE_10__pages_ChooseAddress___default.a,
  meta: {
    title: '搜索地址',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/cart',
  name: 'Cart',
  component: __WEBPACK_IMPORTED_MODULE_11__pages_Cart___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/ordersettle',
  name: 'OrderSettle',
  component: __WEBPACK_IMPORTED_MODULE_12__pages_OrderSettle___default.a,
  meta: {
    title: '确认下单',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/addresslist',
  name: 'AddressList',
  component: __WEBPACK_IMPORTED_MODULE_13__pages_AddressList___default.a,
  meta: {
    title: '我的收货地址',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/addaddress',
  name: 'AddAddress',
  component: __WEBPACK_IMPORTED_MODULE_14__pages_AddAddress___default.a,
  meta: {
    title: '新增收货地址',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/editaddress',
  name: 'EditAddress',
  component: __WEBPACK_IMPORTED_MODULE_15__pages_EditAddress___default.a,
  meta: {
    title: '编辑收货地址',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/findbuild',
  name: 'FindBuild',
  component: __WEBPACK_IMPORTED_MODULE_16__pages_FindBuild___default.a,
  meta: {
    title: '店铺配送范围',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/orderlist',
  name: 'OrderList',
  component: __WEBPACK_IMPORTED_MODULE_17__pages_OrderList___default.a,
  meta: {
    title: '我的订单',
    keepAlive: true,
    isUseCache: false,
    showTab: true
  }
}, {
  path: '/orderdetail',
  name: 'OrderDetail',
  component: __WEBPACK_IMPORTED_MODULE_18__pages_OrderDetail___default.a,
  meta: {
    title: '订单详情',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/restaurantDetail',
  name: 'RestaurantDetail',
  component: __WEBPACK_IMPORTED_MODULE_49__pages_RestaurantDetail___default.a,
  meta: {
    title: '订单详情',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/deviceDetail/:id',
  name: 'DeviceDetail',
  component: __WEBPACK_IMPORTED_MODULE_19__pages_DeviceDetail___default.a,
  meta: {
    title: '柜子详情',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/deliverydetail',
  name: 'DeliveryDetail',
  component: __WEBPACK_IMPORTED_MODULE_20__pages_DeliveryDetail___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/mycomment',
  name: 'MyComment',
  component: __WEBPACK_IMPORTED_MODULE_21__pages_MyComment___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/mycomplaints',
  name: 'MyComplaints',
  component: __WEBPACK_IMPORTED_MODULE_22__pages_MyComplaints___default.a,
  meta: {
    title: '我的投诉',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/mycoupons',
  name: 'MyCoupons',
  component: __WEBPACK_IMPORTED_MODULE_23__pages_MyCoupons___default.a,
  meta: {
    title: '我的优惠券',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/myDisableCoupons',
  name: 'myDisableCoupons',
  component: __WEBPACK_IMPORTED_MODULE_24__pages_MyDisableCoupons___default.a,
  meta: {
    title: '过期优惠券',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/selectcoupon/:type',
  name: 'SelectCoupon',
  component: __WEBPACK_IMPORTED_MODULE_25__pages_SelectCoupon___default.a,
  meta: {
    title: '我的优惠券',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/checkcomplaints',
  name: 'CheckComplaints',
  component: __WEBPACK_IMPORTED_MODULE_26__pages_CheckComplaints___default.a,
  meta: {
    title: '投诉',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/onlinecomplaints',
  name: 'OnlineComplaints',
  component: __WEBPACK_IMPORTED_MODULE_27__pages_OnlineComplaints___default.a,
  meta: {
    title: '我的订单',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/onlinecomment',
  name: 'OnlineComment',
  component: __WEBPACK_IMPORTED_MODULE_28__pages_OnlineComment___default.a,
  meta: {
    title: '写点评',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/otherdetail',
  name: 'OtherDetail',
  component: __WEBPACK_IMPORTED_MODULE_29__pages_OtherDetail___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/feedback',
  name: 'FeedBack',
  component: __WEBPACK_IMPORTED_MODULE_30__pages_FeedBack___default.a,
  meta: {
    title: '投诉结果反馈',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/auth',
  name: 'Auth',
  component: __WEBPACK_IMPORTED_MODULE_31__pages_Auth___default.a,
  meta: {
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/payment',
  name: 'Payment',
  component: __WEBPACK_IMPORTED_MODULE_32__pages_Payment___default.a,
  meta: {
    title: '在线支付',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/alipay',
  name: 'alipay',
  component: __WEBPACK_IMPORTED_MODULE_33__pages_AliPay___default.a,
  meta: {
    title: '支付宝支付',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/map',
  name: 'Map',
  component: __WEBPACK_IMPORTED_MODULE_34__pages_Map___default.a,
  meta: {
    title: '查看地图',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/selftakeprotocol',
  name: 'SelfTakeProtocol',
  component: __WEBPACK_IMPORTED_MODULE_35__pages_SelfTakeProtocol___default.a,
  meta: {
    title: '自提协议',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/onlinerefund',
  name: 'OnlineRefund',
  component: __WEBPACK_IMPORTED_MODULE_36__pages_OnlineRefund___default.a,
  meta: {
    title: '申请退款',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/reward',
  name: 'Reward',
  component: __WEBPACK_IMPORTED_MODULE_38__pages_Reward___default.a,
  meta: {
    title: '打赏西游侠',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/rewardList',
  name: 'RewardList',
  component: __WEBPACK_IMPORTED_MODULE_39__pages_RewardList___default.a,
  meta: {
    title: '收到的打赏',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/outRemarks',
  name: 'OutRemarks',
  component: __WEBPACK_IMPORTED_MODULE_40__pages_OutRemarks___default.a,
  meta: {
    title: '添加备注',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/bindPhone',
  name: 'BindPhone',
  component: __WEBPACK_IMPORTED_MODULE_41__pages_BindPhone___default.a,
  meta: {
    title: '绑定手机号',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/qrcode',
  name: 'QrCode',
  component: __WEBPACK_IMPORTED_MODULE_42__pages_QrCode___default.a,
  meta: {
    title: '取餐码',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/schoolPaySuc',
  name: 'SchoolPaySuc',
  component: __WEBPACK_IMPORTED_MODULE_43__pages_SchoolPaySuc___default.a,
  meta: {
    title: '校园卡支付成功',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/memberLevel',
  name: 'MemberLevel',
  component: __WEBPACK_IMPORTED_MODULE_47__pages_MemberLevel___default.a,
  meta: {
    title: '会员等级',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/expDesc',
  name: 'ExpDesc',
  component: __WEBPACK_IMPORTED_MODULE_48__pages_ExpDesc___default.a,
  meta: {
    title: '经验说明',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/wxWork',
  name: 'WxWork',
  component: __WEBPACK_IMPORTED_MODULE_44__pages_wxWork___default.a,
  meta: {
    title: '提示',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/myScore',
  name: 'MyScore',
  component: __WEBPACK_IMPORTED_MODULE_45__pages_myScore___default.a,
  meta: {
    title: '蟠桃大厅',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/scoreDetail',
  name: 'ScoreDetail',
  component: __WEBPACK_IMPORTED_MODULE_46__pages_scoreDetail___default.a,
  meta: {
    title: '蟠桃明细',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/packingFee',
  name: 'PackingFee',
  component: __WEBPACK_IMPORTED_MODULE_50__pages_packingFee___default.a,
  meta: {
    title: '打包费说明',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/couponPackage/list',
  name: 'CouponPackage',
  component: __WEBPACK_IMPORTED_MODULE_51__pages_CouponPackage___default.a,
  meta: {
    title: '超值购券',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/couponPackage/shoplist',
  name: 'CouponPackageShopList',
  component: __WEBPACK_IMPORTED_MODULE_52__pages_CouponPackageShopList___default.a,
  meta: {
    title: '超值购券',
    keepAlive: true,
    showTab: false
  }
}, {
  path: '/couponPackage/record',
  name: 'CouponPackageRecord',
  component: __WEBPACK_IMPORTED_MODULE_53__pages_CouponPackageRecord___default.a,
  meta: {
    title: '购买记录',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/paySuccess',
  name: 'PaySuccess',
  component: __WEBPACK_IMPORTED_MODULE_54__pages_PaySuccess___default.a,
  meta: {
    title: '支付成功',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/paySuccess1',
  name: 'PaySuccess1',
  component: __WEBPACK_IMPORTED_MODULE_55__pages_PaySuccess1___default.a,
  meta: {
    title: '支付成功',
    keepAlive: false,
    showTab: false
  }
}, {
  path: '/punctualArrive',
  name: 'PunctualArrive',
  component: __WEBPACK_IMPORTED_MODULE_56__pages_PunctualArrive___default.a,
  meta: {
    title: '准时达',
    keepAlive: false,
    showTab: false
  }
}];

var routes = constantRouterMap.concat(__WEBPACK_IMPORTED_MODULE_37__mujia__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  }
}));

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(467);
/**
 * Created by rong on 17/8/2.
 */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    // 学校信息
    schoolInfo: JSON.parse(window.localStorage.getItem('schoolInfo')),
    userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
    cartInfo: JSON.parse(window.localStorage.getItem('cartInfo')),
    wxToken: window.localStorage.getItem('wxToken'),
    wxUid: window.localStorage.getItem('wxUid'),
    openId: window.localStorage.getItem('openId'),
    platformType: window.localStorage.getItem('platformType'),
    orderId: window.localStorage.getItem('orderId'),
    wxLoginToken: window.localStorage.getItem('wxLoginToken'),
    shopCodeInfo: {},
    needRecord: false,
    recordPage: '',
    recordItemHeight: 0,
    recordOtherHeight: 0,
    recordList: 0
  },
  mutations: {
    //同步
    changeSchoolInfo: function changeSchoolInfo(state, schoolInfo) {
      state.schoolInfo = schoolInfo;
      window.localStorage.setItem('schoolInfo', JSON.stringify(schoolInfo));
    },
    changeCartInfo: function changeCartInfo(state, cartInfo) {
      state.cartInfo = cartInfo;
      window.localStorage.setItem('cartInfo', JSON.stringify(cartInfo));
    },
    changeShopCodeInfo: function changeShopCodeInfo(state, shopInfo) {
      state.shopCodeInfo = shopInfo;
      window.localStorage.setItem('shopCodeInfo', JSON.stringify(shopInfo));
    },
    changeState: function changeState(state, obj) {
      for (var key in obj) {
        state[key] = obj[key];
        window.localStorage.setItem(key, obj[key]);
      }
    },
    changeUserInfo: function changeUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    changeRecordState: function changeRecordState(state, bool) {
      state.needRecord = bool;
    },
    changeRecordPage: function changeRecordPage(state, name) {
      state.recordPage = name;
    },
    changeRecordItemHeight: function changeRecordItemHeight(state, height) {
      state.recordItemHeight = height;
    },
    changeRecordOtherHeight: function changeRecordOtherHeight(state, height) {
      state.recordOtherHeight = height;
    },
    changeRecordList: function changeRecordList(state, list) {
      state.recordList = list;
    }
  }
}));

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      clientHeight: 0,
      showBackBtn: false
      // transitionName: 'slide-left'
    };
  },
  created: function created() {
    window.appScroll = 0;
    localStorage.setItem('lastLogTime', new Date().getTime());
    localStorage.setItem('exposureLog', JSON.stringify([]));
  },
  mounted: function mounted() {
    this.clientHeight = document.documentElement.clientHeight;
    if (document.domain.indexOf('xiyoushi.com') >= 0) {
      this.showBackBtn = true;
    }
    // 创建cnzz统计js
    var script = document.createElement('script');
    script.src = "https://s96.cnzz.com/z_stat.php?id=1277660396&web_id=1277660396";
    script.language = 'JavaScript';
    document.body.appendChild(script);

    window.addEventListener('scroll', this.recordLog);
  },

  // beforeDestroy () {
  //   window.removeEventListener("scroll", this.recordLog)
  // },
  watch: {
    '$route': {
      handler: function handler(to, from) {
        setTimeout(function () {
          //避免首次获取不到window._czc
          if (window._czc) {
            var location = window.location;
            var contentUrl = location.pathname + location.hash;
            var refererUrl = '/';
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_setAutoPageview', false]);
            window._czc.push(['_trackPageview', contentUrl, refererUrl]);
          }
        }, 300);
      },

      immediate: true // 首次进入页面即执行
    }
  },
  methods: {
    recordLog: function recordLog() {
      window.appScroll = document.documentElement.scrollTop || document.body.scrollTop;
      var uid = localStorage.getItem('wxUid');
      if (this.$store.state.needRecord && uid && uid != 'null') {
        if (this.$store.state.recordPage === 'TagPage') {
          this.record1('asa_index_shop', 'id');
        } else if (this.$store.state.recordPage === 'TagPage2') {
          this.record('asa_merc_home_index_list', 'jump_target');
        } else if (this.$store.state.recordPage === 'ShopList') {
          this.record('asa_merc_shop_specialList', 'id');
        } else if (this.$store.state.recordPage === 'ShopList2') {
          this.record('asa_merc_shop_listForGoods_category', 'id');
        } else if (this.$store.state.recordPage === 'Search') {
          this.record('asa_merc_shop_search', 'id');
        } else if (this.$store.state.recordPage === 'OrderList') {
          this.record('asa_oc_order_list', 'supplierId');
        }
      }
    },
    record1: function record1(code, key) {
      var uid = localStorage.getItem('wxUid') || 0;
      var exposureLog = localStorage.getItem('exposureLog');
      exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
      var lastLogTime = localStorage.getItem('lastLogTime');
      var scrollTop = this.$store.state.recordOtherHeight;
      var itemHeight = this.$store.state.recordItemHeight;
      var idx = Math.round((this.clientHeight - scrollTop + window.appScroll) / itemHeight);
      var list = this.$store.state.recordList;
      // console.log('recode')
      // console.log(list)
      // console.log(code)
      // console.log('recode')
      var maxSize = Math.round(this.clientHeight / itemHeight);
      var current = localStorage.getItem('recordLogIdx') ? +localStorage.getItem('recordLogIdx') : 0;
      var indexId = localStorage.getItem('indexId') ? localStorage.getItem('indexId') : 200;
      // console.log(list)
      if (current != idx) {
        if (idx > current) {
          var len = idx - current;
          for (var i = 0; i < len; i++) {
            var addIdx = current + i;
            if (list[addIdx]) {
              exposureLog.push({
                uid: uid,
                firstValue: this.$store.state.schoolInfo.schoolId,
                secondValue: indexId,
                refId: +list[addIdx][key],
                createTime: new Date().getTime(),
                code: code
              });
            }
          }
          // console.log(exposureLog)
          localStorage.setItem('recordLogIdx', idx);
        } else if (idx < current && idx >= maxSize) {
          var max = current - idx,
              size = current - maxSize - 1;
          for (var _i = 0; _i < max; _i++) {
            if (size >= 0 && list[size]) {
              exposureLog.push({
                uid: uid,
                firstValue: this.$store.state.schoolInfo.schoolId,
                secondValue: indexId,
                refId: +list[size][key],
                createTime: new Date().getTime(),
                code: code
              });
              size = size - 1;
            }
          }
          localStorage.setItem('recordLogIdx', idx);
        }
        if (new Date().getTime - lastLogTime >= 1000 * 60 * 5) {
          this.pushLog(exposureLog);
        } else {
          // console.log(exposureLog)
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }
    },
    record: function record(code, key) {
      var uid = localStorage.getItem('wxUid') || 0;
      var exposureLog = localStorage.getItem('exposureLog');
      exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
      var lastLogTime = localStorage.getItem('lastLogTime');
      var scrollTop = this.$store.state.recordOtherHeight;
      var itemHeight = this.$store.state.recordItemHeight;
      var idx = Math.round((this.clientHeight - scrollTop + window.appScroll) / itemHeight);
      var list = this.$store.state.recordList;
      // console.log('recode')
      // console.log(list)
      // console.log(code)
      // console.log('recode')
      var maxSize = Math.round(this.clientHeight / itemHeight);
      var current = localStorage.getItem('recordLogIdx') ? +localStorage.getItem('recordLogIdx') : 0;

      // console.log(list)
      if (current != idx) {
        if (idx > current) {
          var len = idx - current;
          for (var i = 0; i < len; i++) {
            var addIdx = current + i;
            if (list[addIdx]) {
              exposureLog.push({
                uid: uid,
                firstValue: addIdx,
                // shopid: list[addIdx][key],
                refId: +list[addIdx][key],
                createTime: new Date().getTime(),
                code: code
              });
            }
          }
          // console.log(exposureLog)
          localStorage.setItem('recordLogIdx', idx);
        } else if (idx < current && idx >= maxSize) {
          var max = current - idx,
              size = current - maxSize - 1;
          for (var _i2 = 0; _i2 < max; _i2++) {
            if (size >= 0) {
              exposureLog.push({
                uid: uid,
                firstValue: size,
                // shopid: list[size][key],
                refId: +list[size][key],
                createTime: new Date().getTime(),
                code: code
              });
              size = size - 1;
            }
          }
          localStorage.setItem('recordLogIdx', idx);
        }
        if (new Date().getTime - lastLogTime >= 1000 * 60 * 5) {
          this.pushLog(exposureLog);
        } else {
          // console.log(exposureLog)
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }
    },
    pushLog: function pushLog(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (res) {
        if (res.body.message === "Success" && res.body.result) {
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify([]));
        }
      }, function () {});
    },
    goBack: function goBack() {
      this.$router.push({ path: '/index' });
      //验证是否存在记录
      // if ((navigator.userAgent.indexOf('MSIE') >= 0) && (navigator.userAgent.indexOf('Opera') < 0)){ // IE
      //   if(history.length > 0){
      //     window.history.go( -1 );
      //   }else{
      //     // window.location.href = "/index";
      //     this.$router.push({path:'/index'})
      //   }
      // }else{ //非IE浏览器
      //   if (navigator.userAgent.indexOf('Firefox') >= 0 ||
      //     navigator.userAgent.indexOf('Opera') >= 0 ||
      //     navigator.userAgent.indexOf('Safari') >= 0 ||
      //     navigator.userAgent.indexOf('Chrome') >= 0 ||
      //     navigator.userAgent.indexOf('WebKit') >= 0){
      //     console.log(window.history,'9999')
      //     if(window.history.length > 1){
      //       window.history.go( -1 );
      //     }else{
      //       // window.location.href = "/index";
      //       this.$router.push({path:'/index'})
      //     }
      //   }else{ //未知的浏览器
      //     window.history.go( -1 );
      //   }
      // }
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['alertBody', 'type'],
  methods: {
    confirmAlert: function confirmAlert(e) {
      var param = {
        isAlert: false,
        isConfirm: e
      };
      this.$emit('open', param);
    }
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['qualityCode'],
  data: function data() {
    return {
      star1: '0%',
      star2: '0%',
      star3: '0%',
      star4: '0%',
      star5: '0%'
    };
  },
  created: function created() {
    var _this = this;
    var code = _this.qualityCode;
    if (code < 1) {
      _this.star1 = code * 100 + '%';
    } else {
      _this.star1 = '100%';
      if (code < 2) {
        _this.star2 = (code - 1) * 100 + '%';
      } else {
        _this.star2 = '100%';
        if (code < 3) {
          _this.star3 = (code - 2) * 100 + '%';
        } else {
          _this.star3 = '100%';
          if (code < 4) {
            _this.star4 = (code - 3) * 100 + '%';
          } else {
            _this.star4 = '100%';
            _this.star5 = (code - 4) * 100 + '%';
          }
        }
      }
    }
  },

  methods: {}
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_swiper_3_4_2_min_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_swiper_3_4_2_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_js_swiper_3_4_2_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['previewPictures'],
  data: function data() {
    return {
      largeImageList: [],
      pictureTotal: '',
      pictureIndex: '',
      showLarge: false
    };
  },

  methods: {
    viewLarge: function viewLarge(e) {
      var _this = this;
      var imageList = [];
      var list = e.target.parentNode.childNodes;
      var defaultIndex;
      for (var i = 0; i < list.length; i++) {
        if (list[i] == e.target) {
          _this.pictureIndex = i + 1;
          defaultIndex = i;
        }
        var obj = {};
        obj.backgroundImage = list[i].style.backgroundImage;
        imageList.push(obj);
      }
      _this.pictureTotal = list.length;
      _this.largeImageList = imageList;
      _this.showLarge = !_this.showLarge;
      _this.$nextTick(function () {
        var mySwiper = new __WEBPACK_IMPORTED_MODULE_0__assets_js_swiper_3_4_2_min_js___default.a('.swiper-container', {
          watchActiveIndex: true,
          initialSlide: defaultIndex,
          onSlideChangeEnd: function onSlideChangeEnd(swiper) {
            _this.pictureIndex = swiper.activeIndex + 1;
          }
        });
      });
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cart',
  data: function data() {
    return {
      isInit: true,
      propShow: false,
      propBuildShow: false,
      propFloorShow: false,
      propRoomShow: false,
      buildTitle: '请选择楼栋',
      floorTitle: '请选择楼层',
      roomTitle: '请选择房间',
      buildingList: [],
      floorList: [],
      roomList: [],
      build_x_name: null,
      floor_x_name: null,
      room_x_name: null,
      needBuilding: null,
      buildInfo: {
        name: undefined,
        id: undefined
      },
      floorInfo: {
        name: undefined,
        id: undefined
      },
      roomInfo: {
        name: undefined,
        id: undefined
      },
      addressee: '',
      gender: '1', // 默认选男生
      mp: '',
      poi_address: '',
      detail: '',
      lon: '',
      lat: '',

      isCustom: false,
      openCustomRoom: false,
      customRoomName: '' // 自定义房间
    };
  },

  watch: {
    room_x_name: function room_x_name(val) {
      this.room_x_name = val.replace(/\D/g, '');
    }
  },
  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  created: function created() {
    this.getBuildingList();
  },
  mounted: function mounted() {
    var _this = this;
    // document.title = '新增收货地址';
    if (window.localStorage.getItem('addressInfo')) {
      var addressInfo = JSON.parse(window.localStorage.getItem('addressInfo'));
      // console.log(addressInfo)
      _this.gender = addressInfo.gender;
      _this.addressee = addressInfo.addressee;
      _this.mp = addressInfo.mp;
      _this.poi_address = addressInfo.poi_address;
      _this.lat = addressInfo.lat;
      _this.lon = addressInfo.lon;
      _this.detail = addressInfo.detail;
      _this.buildInfo.name = addressInfo.build_name;
      _this.buildInfo.id = addressInfo.build_id;
      _this.floorInfo.name = addressInfo.floor_name;
      _this.floorInfo.id = addressInfo.floor_id;
      _this.roomInfo.name = addressInfo.room_name;
      _this.roomInfo.id = addressInfo.room_id;
      // _this.build_x_name = addressInfo.build_x_name
      // _this.floor_x_name = addressInfo.floor_x_name
      // _this.room_x_name = addressInfo.room_x_name
    }
  },

  methods: {
    closeProp: function closeProp() {
      this.propShow = false;
      this.propBuildShow = false;
      this.propFloorShow = false;
      this.propRoomShow = false;
    },
    clearInfo: function clearInfo(type) {
      if (!type) {
        this.buildingList = [];
        this.needBuilding = null;
      }
      if (type == 2) {
        this.floorList = [];
        this.floorInfo = {
          name: null,
          id: null
        };
      }
      this.roomList = [];
      this.roomInfo = {
        name: null,
        id: null
      };
    },
    getBuildingList: function getBuildingList() {
      var _this2 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        // console.log(data)
        if (data && data.length > 0) {
          _this2.buildingList = data;
          _this2.needBuilding = data[0].area;
          // console.log(this.needBuilding)
        } else {
          _this2.clearInfo();
        }
      });
    },
    getFloorList: function getFloorList() {
      var _this3 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        type: 2,
        code: this.buildInfo.id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          _this3.floorList = data;
          if (!_this.isInit) _this3.propFloorShow = true;
        } else {
          _this3.clearInfo(2);
          _this3.propShow = false;
        }
      });
    },
    getRoomList: function getRoomList() {
      var _this4 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        type: 3,
        code: this.floorInfo.id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          _this4.roomList = data;
          if (!_this.isInit) _this4.propRoomShow = true;
        } else {
          _this4.clearInfo(3);
          _this4.propShow = false;
        }
      });
    },
    toggleBuildProp: function toggleBuildProp() {
      if (!this.propShow) this.propShow = true;
      this.propBuildShow = !this.propBuildShow;
    },
    toggleFloorProp: function toggleFloorProp() {
      if (!this.propShow) this.propShow = true;
      this.propFloorShow = !this.propFloorShow;
    },
    toggleRoomProp: function toggleRoomProp() {
      if (!this.propShow) this.propShow = true;
      this.propRoomShow = !this.propRoomShow;
    },
    changeBuilding: function changeBuilding(item) {
      if (this.isInit) this.isInit = false;
      this.buildInfo.name = item.area;
      this.buildInfo.id = item.id;
      this.propBuildShow = false;
      this.clearInfo(2);
      this.getFloorList();
    },
    changeFloor: function changeFloor(item) {
      if (this.isInit) this.isInit = false;
      this.floorInfo.name = item.area;
      this.floorInfo.id = item.id;
      this.propFloorShow = false;
      if (item.is_custom == 1) {
        this.isCustom = true;
        this.customRoomName = '';
      } else {
        this.isCustom = false;
      }
      this.clearInfo(3);
      this.getRoomList();
    },
    changeRoom: function changeRoom(item) {
      if (this.isInit) this.isInit = false;
      this.roomInfo.name = item.area;
      this.roomInfo.id = item.id;
      this.propRoomShow = false;
      this.propShow = false;
      if (this.roomInfo.id !== -1) {
        this.customRoomName = '';
      }
    },

    inputFocus: function inputFocus() {
      // document.getElementsByTagName('footer')[0].classList.remove('fixed')
    },
    inputBlur: function inputBlur() {
      // document.getElementsByTagName('footer')[0].classList.add('fixed')
    },
    chooseAddress: function chooseAddress() {
      var _this = this;
      var addressInfo = {};
      addressInfo.gender = _this.gender;
      addressInfo.addressee = _this.addressee;
      addressInfo.mp = _this.mp;
      addressInfo.poi_address = _this.poi_address;
      addressInfo.detail = _this.detail;
      addressInfo.lat = _this.lat;
      addressInfo.lon = _this.lon;
      addressInfo.build_name = _this.buildInfo.name;
      addressInfo.build_id = _this.buildInfo.id;
      addressInfo.floor_name = _this.floorInfo.name;
      addressInfo.floor_id = _this.floorInfo.id;
      addressInfo.room_name = _this.roomInfo.name;
      addressInfo.room_id = _this.roomInfo.id;
      // addressInfo.build_x_name = _this.build_x_name
      // addressInfo.floor_x_name = _this.floor_x_name
      // addressInfo.room_x_name = _this.room_x_name
      window.localStorage.setItem('addressInfo', JSON.stringify(addressInfo));
      _this.$router.push({ path: '/chooseaddress' });
    },
    addAddress: function addAddress() {
      var _this = this;
      if (_this.addressee === '') {
        _this.$messagebox.alert('请输入您的姓名', '');
        return false;
      }
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入您的手机号', '');
        return false;
      } else if (!/^1\d{10}$/.test(_this.mp)) {
        _this.$messagebox.alert('请输入正确格式的手机号', '');
        return false;
      }
      if (!_this.lon && !this.needBuilding) {
        _this.$messagebox.alert('请选择地址', '');
        return false;
      }
      if (this.needBuilding) {
        if (!this.buildInfo.id) {
          return _this.$messagebox.alert('请选择楼栋');
        }
        // else if (this.buildInfo.name == '其他' && !this.build_x_name) {
        //   return _this.$messagebox.alert('请填写自定义楼栋')
        // }
        if (!this.floorInfo.id) {
          return _this.$messagebox.alert('请选择楼层');
        }
        // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他') && !this.floor_x_name) {
        //   return _this.$messagebox.alert('请填写自定义楼层')
        // }
        if (!this.roomInfo.id) {
          return _this.$messagebox.alert('请选择房间');
        }
        // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他' || this.roomInfo.name == '其他') && !this.floor_x_name) {
        //   return _this.$messagebox.alert('请填写自定义房间')
        // }
      }
      if (_this.detail === '' && !this.needBuilding) {
        _this.$messagebox.alert('请输入您的详细地址', '');
        return false;
      }
      var gender;
      if (_this.gender == '1') {
        gender = '男';
      } else {
        gender = '女';
      }
      var params = {
        //          school_id: _this.schoolInfo.schoolId,
        addressee: _this.addressee,
        addressee_encryption: _this.$utils.Encrypt(_this.addressee),
        gender: gender,
        // mp: _this.mp,
        mp_encryption: _this.$utils.Encrypt(_this.mp),
        poi_address: _this.poi_address,
        detail: _this.detail,
        lon: _this.lon,
        lat: _this.lat,
        addressType: _this.needBuilding ? 1 : 0,
        is_build: _this.needBuilding ? 1 : 0
      };
      if (this.needBuilding) {
        // params.floor_id = 0
        // params.floor_name = null
        // params.room_id = 0
        // params.room_name = null
        // params.build_x_name = null
        // params.floor_x_name = null
        // params.room_x_name = null
        params.build_id = _this.buildInfo.id;
        params.build_name = _this.buildInfo.name;
        params.floor_id = _this.floorInfo.id;
        params.floor_name = _this.floorInfo.name;
        params.room_id = _this.roomInfo.id;
        params.room_name = _this.roomInfo.name;
        params.addressType = 1;
        // if (_this.buildInfo.name == '其他') {
        //   params.build_x_name = _this.build_x_name;
        //   params.floor_x_name = _this.floor_x_name;
        //   params.room_x_name = _this.room_x_name;
        // }
        // if (_this.buildInfo.name == '其他' || _this.floorInfo.name == '其他') {
        //   params.floor_x_name = _this.floor_x_name;
        //   params.room_x_name = _this.room_x_name;
        //   if (_this.floorInfo.name == '其他') {
        //     params.floor_id = _this.floorInfo.id;
        //     params.floor_name = _this.floorInfo.name;
        //   }
        // } else {
        //   params.floor_id = _this.floorInfo.id;
        //   params.floor_name = _this.floorInfo.name;
        // }
        // if (_this.buildInfo.name == '其他' || _this.floorInfo.name == '其他' || _this.roomInfo.name == '其他') {
        //   params.room_x_name = _this.room_x_name;
        //   if (_this.roomInfo.name == '其他') {
        //     params.room_id = _this.roomInfo.id;
        //     params.room_name = _this.roomInfo.name;
        //   }
        // } else {
        //   params.room_id = _this.roomInfo.id;
        //   params.room_name = _this.roomInfo.name;
        // }
        // console.log(params)
      }
      if (document.domain.indexOf('xiyoushi.com') >= 0) {
        params.school_id = 1826;
      } else {
        params.school_id = _this.schoolInfo.schoolId;
      }
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSaveAddress(_this, params, function (data) {
        _this.$messagebox.alert('新增成功', '');
        window.localStorage.removeItem('addressInfo');
        _this.$router.go(-1);
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },

    changeOpenCustom: function changeOpenCustom() {
      this.openCustomRoom = !this.openCustomRoom;
    },
    choseCustomRoom: function choseCustomRoom() {
      // document.getElementsByTagName('footer')[0].classList.add('fixed');
      if (!this.customRoomName || this.customRoomName.length == 0) {
        this.$messagebox.alert('请输入你的房间号', '');
        return;
      }
      this.roomInfo.id = -1;
      this.roomInfo.name = this.customRoomName;
      this.openCustomRoom = false;
      this.propRoomShow = false;
      this.propShow = false;
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      addressList: [],
      chooseAddress: {},
      isFloor: false, //是否是楼栋模式
      addressVaild: [],
      addressInVaild: [],
      isForm: false //从订单过来
    };
  },

  computed: {
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  mounted: function mounted() {
    var _this = this;
    // document.title = '我的收货地址';

    if (window.localStorage.getItem('chooseAddress')) {
      _this.chooseAddress = JSON.parse(window.localStorage.getItem('chooseAddress'));
    }
    window.localStorage.removeItem('addressInfo');
    this.isForm = window.localStorage.getItem('fromPage') == 'OrderSettle';
    _this.getAddressList();
    window.localStorage.setItem('orderPreviewType', 2);
  },

  methods: {
    // 获取地址列表
    getAddressList: function getAddressList() {
      var _this = this;
      var params = {
        page: 1,
        pageSize: 50,
        school_id: this.$store.state.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postAddressList(_this, params, function (data) {
        var list = [];
        if (data && data.length > 0) {
          // console.log(_this.isForm);
          if (_this.isForm) {
            _this.addressList = [];
            _this.addressInVaild = [];
            _this.addressVaild = [];
            _this.isFloor = data[0].isLimitFloor;
            data.forEach(function (item) {
              if (_this.isFloor) {
                if (item.build_id && item.floor_id && item.room_id) {
                  item.isVaild = true;
                  _this.addressVaild.push(item);
                } else {
                  item.isVaild = false;
                  item.is_default = 0;
                  _this.addressInVaild.push(item);
                }
              } else {
                if (item.poi_address) {
                  item.isVaild = true;
                  _this.addressVaild.push(item);
                } else {
                  item.isVaild = false;
                  item.is_default = 0;
                  _this.addressInVaild.push(item);
                }
              }
            });
            list = _this.addressVaild.concat(_this.addressInVaild);
          } else {
            list = data;
          }
        }
        _this.addressList = list;
        _this.$nextTick(function () {
          var mySwiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            observer: true, // 修改swiper自己或子元素时，自动初始化swiper
            observeParents: true // 修改swiper的父元素时，自动初始化swiper
          });
        });
      });
    },
    // 编辑地址
    editAddress: function editAddress(item) {
      var _this = this;
      window.localStorage.setItem('address-id', item.id);
      _this.$router.push({ name: 'EditAddress' });
    },
    // 删除地址
    handleClickDeleteAddress: function handleClickDeleteAddress(e) {
      var _this = this;
      _this.$messagebox.confirm('确定要删除此地址吗?', '').then(function (action) {
        var params = {
          id: e.id
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postDeleteAddress(_this, params, function () {
          // window.location.reload();
          _this.getAddressList();
          if (_this.addressList.length == 0) {
            window.localStorage.removeItem('chooseAddress');
          }
        });
      }).catch(function () {});
    },
    // 选择地址
    handleClickChooseAddress: function handleClickChooseAddress(e) {
      var _this = this;
      if (window.localStorage.getItem('fromPage') == 'UserCenter') {//代表从我的地址入口进入，无法跳转
      } else {
        window.localStorage.setItem('chooseAddress', JSON.stringify(e));
        var params = {
          id: e.id
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSetDefaultAddress(_this, params, function () {
          window.localStorage.setItem('orderPreviewType', 2);
          _this.$router.go(-1);
        }, function (data) {
          _this.$messagebox.alert(data.body.message, '');
        });
      }
    },
    // 新增地址
    toAddAddress: function toAddAddress() {
      var _this = this;
      window.localStorage.removeItem('addAddressInfo');
      _this.$router.push({ name: 'AddAddress' });
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//


// import { Indicator, MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isWeixin: false,
      query: {},
      timer: ''
    };
  },
  created: function created() {
    var _this2 = this;

    // document.title = '支付宝支付'
    var _href = window.location.href;
    if (_href.indexOf('&replace=1') <= -1) {
      window.location.replace(_href + '&replace=1');
    }
    this.query = this.$route.query;
    this.isWeixin = this.$utils.isWeiXin();

    if (!this.$utils.isWeiXin()) {
      // 判断是否微信浏览器中打开
      this.$indicator.open({
        text: '正在跳转...',
        spinnerType: 'fading-circle'
      });
      var p = new Promise(this.getOrderDetail);
      p.then(function (data) {
        if (data.order_status > 1000) {
          _this2.$indicator.close();
          _this.$router.replace({ name: 'PaySuccess1', query: { orderId: _this2.query.oid } });
          // 支付完成
          // this.$messagebox.alert('您已经成功付款', '支付完成')
          // MessageBox({
          //   title: '支付完成',
          //   message: '您已经成功付款',
          //   confirmButtonText: '确认'
          // })
        } else {
          _this2.aliPay();
        }
      });
    } else {
      this.timer = setInterval(this.refreshOrder, 3000);
    }
  },

  methods: {
    refreshOrder: function refreshOrder() {
      var _this3 = this;

      var _this = this;
      var param = {
        token: this.query.t,
        order_id: this.query.oid
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderDetail(_this, param, function (data) {
        if (data.order_status > 1000) {
          clearInterval(_this3.timer);
          // 支付完成
          // MessageBox({
          //   title: '支付完成',
          //   message: '您已经成功付款',
          //   confirmButtonText: '确认'
          // }).then(action => {
          //   this.$router.push({name: 'OrderDetail'})
          // })
          _this.$router.replace({ name: 'PaySuccess1', query: { orderId: _this.query.oid } });
          // this.$messagebox.confirm('您已经成功付款', '支付完成').then(action => {
          //   // localStorage.setItem('paySource','alipay')
          //   this.$router.push({name: 'OrderDetail'})
          // })
        }
      });
    },
    getOrderDetail: function getOrderDetail(resolve, reject) {
      // 查询订单状态
      var _this = this;
      var param = {
        token: this.query.t,
        order_id: this.query.oid
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderDetail(_this, param, function (data) {
        resolve(data);
      });
    },
    aliPay: function aliPay() {
      var _this4 = this;

      var _this = this;
      var params = {
        token: this.query.t,
        order_id: this.query.oid,
        payType: 52
      };
      params.returnUrl = encodeURIComponent(this.$utils.getHost() + ('/alipay?oid=' + this.query.oid + '&t=' + this.query.t));
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (data) {
        _this.$indicator.close();
        var div = document.createElement('div');
        div.innerHTML = data.body;
        document.body.appendChild(div);
        document.forms[0].submit();
      }, function (response) {
        // 响应错误回调
        if (response.data.message) {
          // MessageBox.alert(response.data.message, '')
          _this4.$messagebox.alert(response.data.message, '');
        }
      });
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    var host = '';
    if (false) {
      host = 'http://open-base.imcoming.com.cn/wechatDev';
    } else if (false) {
      host = 'http://open-base.imcoming.com.cn/wechatDev';
    } else if (false) {
      host = 'http://open-base.imcoming.com/wechatDev';
    } else {
      host = 'https://open-base.anlaiye.com/wechat';
    }
    window.location.href = host + '/auth/enter?redirect=market';
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox, Indicator} from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      graph_token: '',
      mp: '',
      captcha: '',
      countDown: false,
      time: 60
    };
  },

  computed: {
    wxToken: function wxToken() {
      return this.$store.state.wxToken;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  mounted: function mounted() {
    var _this = this;
    /**
     * 如果有指定学校id
     */
    var url_school_id = _this.$utils.resolveUrl().school_id;
    if (url_school_id) {
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolStatus(_this, { school_id: url_school_id }, function (data) {
        var schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);
      }, function () {
        _this.$messagebox.alert(data.body.message, '');
      });
    } else {
      if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {} else {
        _this.$router.push({ path: '/chooseschool' });
        return false;
      }
    }
    this.addLog();
  },

  methods: {
    addLog: function addLog() {
      // 内部统计
      var _this = this;
      var params = {
        logDetails: [{ uid: _this.$store.state.wxUid, code: 'aly_wechat_login', createTime: new Date().getTime(), firstValue: this.$utils.getCookie('UM_distinctid') }]
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        console.log('记录成功');
      }, function (data) {});
    },

    onlyNum: function onlyNum() {
      var _this = this;
      var patt = _this.mp.replace(/[^\d]/g, '');
      if (_this.mp != patt) {
        _this.mp = patt;
        _this.$messagebox.alert('只能输入数字', '');
      }
    },
    // 发送短信验证码
    postSmsCaptcha: function postSmsCaptcha() {
      var _this = this;
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入手机号码', '');
        return false;
      }
      var phonereg = /^1[0-9]{10}$/;
      if (!phonereg.test(_this.mp)) {
        _this.$messagebox.alert('请输入正确格式的手机号', '');
        return false;
      }
      var params = {
        graph_token: _this.graph_token,
        mp: _this.mp,
        type: '101'
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSendCaptcha(_this, params, function (data) {
        if (data.status == 0) {
          _this.$messagebox.alert('短信已发送成功!请注意查收', '');
          _this.countDownFn();
        } else {
          _this.graph_token = data.graph_token;
          _this.showDrag = true;
          setTimeout(function () {
            _this.dialogClientX = document.getElementsByClassName('drag')[0].offsetLeft;
            _this.maxWidth = document.getElementsByClassName('drag_box')[0].offsetWidth - document.getElementsByClassName('handler')[0].offsetWidth; //能滑动的最大间距
            document.getElementsByTagName('html')[0].addEventListener('touchmove', _this.mouseMoveFn);
            document.getElementsByTagName('html')[0].addEventListener('touchend', _this.mouseUpFn);
          }, 1000);
        }
      });
    },
    // 登录注册
    postSignIn: function postSignIn() {
      var _this = this;
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入手机号码', '');
        return false;
      }
      if (_this.captcha === '') {
        _this.$messagebox.alert('请输入短信验证码', '');
        return false;
      }

      var params = {
        school_id: _this.$store.state.schoolInfo.schoolId,
        captcha: _this.captcha,
        captcha_type: 101,
        mp: _this.mp,
        // token:'ef871ba5bce44fc0c36d37a389eab16f',
        token: _this.$store.state.wxToken,
        client_type: localStorage.getItem('platformType')

        /**
         * 是否是单校区*/
      };var school_lock = window.localStorage.getItem('school_lock');
      if (school_lock == '1') {
        params.ref = 'other_wechat';
      } else {
        params.ref = 'aly_wechat';
      }

      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSignInIaaa(_this, params, function (data) {
        var openid = _this.$store.state.openId;
        if (data.openid && data.openid != '') {
          openid = data.openid;
        }

        var userInfo = {
          avatar: data.avatar || data.headimgurl,
          nickname: data.nickname,
          mp: data.mp,
          sex: data.sex
        };

        _this.$store.commit('changeUserInfo', userInfo);

        var obj = {
          wxUid: data.uid,
          wxToken: data.token,
          openId: openid,
          wxLoginToken: data.login_token,
          platformType: data.platform_type
        };
        _this.$store.commit('changeState', obj);
        window.localStorage.removeItem('selfTakeMp');
        _this.$router.push({ name: 'TagPage' });
      });
    },
    // 60s倒计时方法
    countDownFn: function countDownFn() {
      var _this = this;
      _this.time = 60;
      function setTime() {
        if (_this.time === 0) {
          _this.countDown = false;
          return false;
        } else {
          _this.countDown = true;
          _this.time--;
        }
        setTimeout(function () {
          setTime();
        }, 1000);
      }
      setTime();
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BackBtn_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BackBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BackBtn_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cart',
  data: function data() {
    return {};
  },

  computed: {
    cartInfo: function cartInfo() {
      return this.$store.state.cartInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  mounted: function mounted() {
    var _this = this;
    _this.getTotalPrice();
  },

  methods: {
    // 计算总价
    getTotalPrice: function getTotalPrice() {
      var _this = this;
      var totalPrice = 0;
      for (var key in _this.cartInfo.market) {
        var singlePrice = _this.cartInfo.market[key].wx_price;
        var singleNum = _this.cartInfo.market[key].num;
        var singleTotalPrice = singlePrice * singleNum;
        totalPrice += parseFloat(singleTotalPrice);
      }
      _this.cartInfo.amount = totalPrice.toFixed(2);
    },
    // 增加商品
    addGoods: function addGoods(e) {
      var _this = this;
      for (var key in _this.cartInfo.market) {
        if (e.target.id == _this.cartInfo.market[key].goods_id) {
          _this.cartInfo.market[key].num += 1;
        }
      }
      _this.cartInfo.total += 1;
      _this.getTotalPrice();
      _this.$store.commit('changeCartInfo', _this.cartInfo);
    },
    // 删减商品
    minusGoods: function minusGoods(e) {
      var _this = this;
      var cartInfo = _this.cartInfo;
      for (var key in _this.cartInfo.market) {
        if (e.target.id == _this.cartInfo.market[key].goods_id) {
          if (_this.cartInfo.market[key].num == 1) {
            delete _this.cartInfo.market[key];
            var obj = {};
            for (var m in _this.cartInfo.market) {
              obj[m] = _this.cartInfo.market[m];
            }
            cartInfo.market = obj;
          } else {
            _this.cartInfo.market[key].num -= 1;
            cartInfo = _this.cartInfo;
          }
        }
      }
      _this.cartInfo.total -= 1;
      _this.getTotalPrice();
      _this.$store.commit('changeCartInfo', cartInfo);
    },
    // 订单结算,判断是否登录
    settleAccount: function settleAccount() {
      var _this = this;
      if (_this.wxUid !== '' && _this.wxUid !== null) {
        _this.$router.push({ path: 'OrderSettle' });
      } else {
        _this.$router.push({ path: 'Login' });
      }
    },
    // 清空购物车
    clearCart: function clearCart() {
      var _this = this;
      if (confirm('确定要清空购物车？')) {
        var cartInfo = {
          total: 0,
          amount: 0,
          market: {}
        };
        _this.$store.commit('changeCartInfo', cartInfo);
      }
    }
  },
  components: {
    BackBtn: __WEBPACK_IMPORTED_MODULE_0__components_BackBtn_vue___default.a
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { MessageBox, Toast, Indicator} from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      processType: window.localStorage.getItem('processType'),
      // processType: 0,
      complainId: window.localStorage.getItem('complainId'),
      orderId: window.localStorage.getItem('orderCode'),
      details: {},
      refundDetails: {},
      responsibleParty: '',
      messageList: [],
      urls: [],
      showAppealAlert: false,
      appealReason: '' //申诉理由

    };
  },
  created: function created() {
    var _this = this;
    if (_this.processType == 0) {
      document.title = "退款进度";
      _this.getRefundDetails(); //获取退款进度
    } else if (_this.processType == 1) {
      document.title = "投诉进度";
      _this.getComplaintDetails(); //获取投诉进度
    }
  },

  methods: {
    acceptResult: function acceptResult() {
      var _this = this;
      var params = {
        complaintId: _this.complainId
      };
      _this.$messagebox.confirm('点击确认后，我们将按照商家处理结果处理您的退款申请', '').then(function (action) {
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getRefundResult(_this, params, function (data) {
          _this.getRefundDetails();
        }, function (data) {
          _this.$toast(data.body.message);
        });
      }).catch(function () {});
    },
    confirmAppeal: function confirmAppeal() {
      this.showAppealAlert = true;
      this.appealReason = '';
    },
    handleClickAppeal: function handleClickAppeal(type) {
      var _this = this;
      var params = {
        complaintId: _this.complainId,
        appealStatus: type
      };
      if (type == 1) {
        if (_this.appealReason != '') {
          params.appealContent = _this.appealReason;
        } else {
          _this.$toast('申诉理由不能为空');
          return false;
        }
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postAppeal(_this, params, function (data) {
          _this.showAppealAlert = false;
          _this.getRefundDetails();
        }, function (data) {
          _this.showAppealAlert = false;
          _this.$toast(data.body.message);
        });
      } else if (type == 2) {
        _this.$messagebox.confirm('撤销申诉将默认您同意商家处理意见，不可再次进行申诉。', '').then(function (action) {
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postAppeal(_this, params, function (data) {
            _this.getRefundDetails();
          }, function (data) {
            _this.$toast(data.body.message);
          });
        }).catch(function () {});
      }
    },

    getRefundDetails: function getRefundDetails() {
      var _this = this;
      var params = {
        orderId: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getRefundDetails(_this, params, function (data) {
        _this.refundDetails = data;
        if (_this.refundDetails.messageList.length > 0) {
          for (var i = 0; i < _this.refundDetails.messageList.length; i++) {
            if (_this.refundDetails.messageList[i].message) {
              _this.refundDetails.messageList[i].message = _this.refundDetails.messageList[i].message.replace(/\n/g, "<br>");
            }
            // console.log(_this.refundDetails.messageList[i].message)
          }
        }
        _this.complainId = data.complaintId;
      }, function (data) {
        _this.$toast(data.body.message);
      });
    },
    getComplaintDetails: function getComplaintDetails() {
      var _this = this;
      var params = {
        complainId: _this.complainId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getComplaintDetails(_this, params, function (data) {
        _this.details = data;
        _this.urls = _this.details.urls;
        _this.messageList = _this.details.messageList;
        //_this.details.messageList.reverse() //逆转售后流程数组
        if (_this.details.responsibleCode == 1000) {
          _this.responsibleParty = '商家';
        } else if (_this.details.responsibleCode == 2000) {
          _this.responsibleParty = '西游侠';
        } else if (_this.details.responsibleCode == 3000) {
          _this.responsibleParty = '平台';
        }
      }, function (data) {
        _this.$toast(data.body.message);
      });
    },
    toFeedBack: function toFeedBack() {
      window.localStorage.setItem('complainId', this.complainId), this.$router.push({ name: 'FeedBack' });
    },
    // 取消投诉、取消退款申请
    cancelComplaint: function cancelComplaint() {
      var _this = this;
      var params = {
        complainId: _this.complainId
      };
      if (_this.processType == 0) {
        _this.$messagebox.confirm('撤销后无法再申请,确定撤销本次退款申请吗？', '').then(function (action) {
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCancelComplaint(_this, params, function (data) {
            //反馈成功
            _this.$messagebox.alert('撤销成功', '');
            _this.getRefundDetails();
          }, function (data) {
            _this.$toast(data.body.message);
            _this.getRefundDetails();
            //错误返回
          });
        }).catch(function () {});
      } else if (_this.processType == 1) {
        _this.$messagebox.confirm('取消后将无法再申请,已经得到满意答复？', '').then(function (action) {
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCancelComplaint(_this, params, function (data) {
            //反馈成功
            _this.$messagebox.alert('取消成功', '');
            _this.getComplaintDetails();
          }, function (data) {
            _this.$toast(data.body.message);
            _this.getComplaintDetails();
            //错误返回
          });
        }).catch(function () {});
      }
    }
  },
  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var wx = __webpack_require__(59);

var mapLoader = __webpack_require__(200);
// import { MessageBox,Indicator } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var self = this;
    return {
      poiList: [
        //  {
        //    name: '腾飞大厦',
        //    address: '天钥桥路333'
        //  },
        // {
        //   name: '腾飞大厦',
        //   address: '天钥桥路333'
        // }
      ],
      message: '',
      pinyinList: [],
      cityList: [],
      showCity: false,
      currentCity: {
        city_name: '上海市',
        city_id: '181'
      },
      // searchOption: {
      //   city: '',
      //   citylimit: true
      // },
      map: null,
      mapCenter: [31.18839, 121.44239], // 地图中心点位置
      markerGeo: null, // 标记
      mamarkerLayer: null,
      suggest: null, // 输入建议
      suggestionList: [],
      geocoder: null, // 地址解析

      addressInfo: { lon: 0, lat: 0, poi_address: '' },
      tipinput: '',
      locationStatus: false
    };
  },
  created: function created() {
    var _this = this;
    // document.title = "搜索地址";
    _this.addressInfo = JSON.parse(window.localStorage.getItem('addressInfo'));
    if (_this.addressInfo && _this.addressInfo.lat && _this.addressInfo.lon) {
      _this.mapCenter = [_this.addressInfo.lat, _this.addressInfo.lon];
      _this.initMap();
    } else {
      var u = encodeURIComponent(window.location.href.split('#')[0]);
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJslbsConf(_this, u, function (data) {
        var newData = JSON.parse(data);
        wx.config({
          debug: false,
          appId: newData.appId,
          timestamp: newData.timestamp,
          nonceStr: newData.nonceStr,
          signature: newData.signature,
          jsApiList: newData.jsApiList
        });
        wx.ready(function () {
          _this.$indicator.open({
            text: '正在努力定位中'
          });
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function success(res) {
              if (res.latitude && res.longitude) {
                _this.mapCenter = [res.latitude, res.longitude];
                _this.initMap();
              }
            },
            fail: function fail(res) {
              _this.$messagebox.alert('定位失败，请查看是否允许定位或者手动进行搜索');
              _this.initMap();
            }
          });
        });
      });
    }
    _this.postCityList();
  },

  methods: {
    initMap: function initMap() {
      var _this2 = this;

      mapLoader().then(function (TXMap) {
        _this2.TXMap = TXMap;
        var center = new TXMap.LatLng(_this2.mapCenter[0], _this2.mapCenter[1]);
        _this2.map = new TXMap.Map(document.getElementById("mapContainer"), {
          // 配置地图参数
          center: center, //地图中心点 维度，经度
          zoom: 15,
          showControl: false
        });

        // 标记中心点
        _this2.markerGeo = {
          id: 'center',
          position: _this2.map.getCenter()
        };

        // 创建一个位于地图中心点的marker
        _this2.markerLayer = new TXMap.MultiMarker({
          map: _this2.map,
          geometries: [_this2.markerGeo]
        });

        // 新建一个正逆地址解析类
        _this2.geocoder = new TXMap.service.Geocoder();
        _this2.updateLocation(_this2.map.getCenter(), 'init');
        // 新建一个关键字输入提示类
        _this2.suggest = new TXMap.service.Suggestion({
          pageSize: 10 // 返回结果每页条目数
        });
        // 监听中心点变化事件，更新marker的位置
        _this2.map.on('center_changed', function () {
          _this2.updateLocation(_this2.map.getCenter());
        });
        _this2.$indicator.close();
        // var search = new TXMap.service.Search({ pageSize: 10 }); // 新建一个地点搜索类
      });
    },

    // 输入建议
    getSuggestions: function getSuggestions() {
      var _this3 = this;

      this.suggestionList = [];
      if (this.tipinput.length && this.tipinput.length > 1) {
        this.suggest.getSuggestions({ keyword: this.tipinput, location: this.map.getCenter() }).then(function (result) {
          if (result.data && result.data.length) {
            _this3.suggestionList = result.data;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    // 设置地图中心点标记，逆地址解析拿到poilist
    updateLocation: function updateLocation(location, init) {
      var _this4 = this;

      if (!init) {
        this.markerLayer.setGeometries([]);
        this.markerGeo.position = location;
        this.markerLayer.updateGeometries([this.markerGeo]);
        this.map.setCenter(location);
      }
      this.geocoder.getAddress({ location: location, get_poi: 1, pageSize: 10, policy: 2 }) // 将给定的坐标位置转换为地址
      .then(function (result) {
        if (result.result && result.result.pois) {
          _this4.poiList = result.result.pois;
          // this.tipinput = '';
        }
        if (init && result.result.address_component && result.result.address_component.city) {
          _this4.currentCity = { city_name: result.result.address_component.city };
        }
      });
    },

    // 关键字搜索
    setCitySearch: function setCitySearch(item) {
      this.suggestionList = [];
      this.tipinput = item.title;
      this.updateLocation(item.location);
    },

    saveInfo: function saveInfo(item) {
      var _this = this;
      _this.addressInfo.lon = item.location.lng;
      _this.addressInfo.lat = item.location.lat;
      _this.addressInfo.poi_address = item.title;
      window.localStorage.setItem('addressInfo', JSON.stringify(_this.addressInfo));
      _this.$router.go(-1);
    },
    postCityList: function postCityList() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postCityList(_this, {}, function (data) {
        var pinyinList = []; //取出所有拼音列表
        for (var i = 0; i < data.length; i++) {
          if (pinyinList.indexOf(data[i].pinyin_index) < 0) {
            pinyinList.push(data[i].pinyin_index);
          }
        }
        _this.pinyinList = pinyinList;

        var cityList = [];

        for (var i = 0; i < _this.pinyinList.length; i++) {

          var categoryObj = {};
          var city_list = [];
          for (var m = 0; m < data.length; m++) {
            var obj = {};
            if (data[m].pinyin_index === _this.pinyinList[i]) {
              obj.city_name = data[m].city_name;
              obj.city_id = data[m].city_id;
              obj.pinyin = data[m].pinyin;
              city_list.push(obj);
            }
          }

          categoryObj.pinyin_index = _this.pinyinList[i];
          categoryObj.city_list = city_list;
          cityList.push(categoryObj);
        }
        _this.cityList = cityList;
      });
    },
    // 选择城市
    chooseCity: function chooseCity(name, id) {
      var _this5 = this;

      this.poiList = [];
      var currentCity = {
        city_name: name,
        city_id: id
      };
      this.currentCity = currentCity;
      // this.searchOption.city = this.currentCity.city_name;
      this.tipinput = '';
      this.geocoder.getLocation({ address: name }).then(function (result) {
        if (result.result && result.result.location) {
          _this5.updateLocation(result.result.location);
          _this5.toggleCity();
        }
      });
    },
    // mapMoveend: function (e) {
    //   let _this = this
    //   console.log(e,'99')
    //   var map = new AMap.Map("mapContainer", {
    //     resizeEnable: true,
    //     center: _this.mapCenter,
    //     zoom: 15
    //   })
    //   _this.mapCenter = map.getCenter();
    //   console.log(map.getCenter())
    //   // console.log(map.getCenter())
    //
    // },
    toggleCity: function toggleCity() {
      this.showCity = !this.showCity;
    },
    // 选择拼音
    choosePinyin: function choosePinyin(tagCode) {
      var dd = document.getElementById(tagCode).offsetTop;
      document.getElementById('cityList').style.transition = "-webkit-transform 500ms";
      if (dd > 0) {
        document.getElementById('cityList').style.webkitTransform = "translate(0,-" + dd + "px)";
      } else {
        document.getElementById('cityList').style.webkitTransform = "translate(0," + dd + "px)";
      }
    },
    searchSchool: function searchSchool() {
      var _this = this;
      var params = { keyword: _this.message };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSearchSchool(_this, params, function (data) {
        if (data.length > 0) {
          _this.schoolList = data;
        }
      });
    },
    clearInput: function clearInput() {
      this.tipinput = '';
    }

  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_bridge__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var wx = require('weixin-js-sdk');


// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      schoolList: [],
      nearSchoolList: [],
      iSearch: false, // 标识搜索状态
      message: '',
      showBottomTips: false,
      notFound: false,
      isjdlw: false
    };
  },
  mounted: function mounted() {
    // 梨涡
    if (this.$utils.getCookie('source') && this.$utils.getCookie('source') == 'jdlw') {
      if (localStorage.getItem('schoolInfo')) {} else {
        // 监听返回按钮
        if (window.history && window.history.pushState) {
          history.pushState(null, null, document.URL);
          window.addEventListener('popstate', this.backJdlw, false); // false阻止默认事件
        }
        // 搜索文案弹窗
        this.isjdlw = true;
      }
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.backJdlw, false); //false阻止默认事件
  },
  created: function created() {
    var _this = this;
    var u = encodeURIComponent(window.location.href.split('#')[0]);
    __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJslbsConf(_this, u, function (data) {
      var newData = JSON.parse(data);
      wx.config({
        debug: false,
        appId: newData.appId,
        timestamp: newData.timestamp,
        nonceStr: newData.nonceStr,
        signature: newData.signature,
        jsApiList: newData.jsApiList
      });
      wx.ready(function () {
        _this.$indicator.open({
          text: '正在努力定位中'
        });
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function success(res) {
            var params = {
              keyword: '',
              lat: res.latitude,
              lon: res.longitude
            };
            __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolSearch(_this, params, function (data) {
              _this.$indicator.close();
              if (data.length > 0) {
                _this.nearSchoolList = data;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = _this.nearSchoolList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item.schoolName = item.school_name;
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                _this.$messagebox.alert('未查询到附近学校，请手动搜索', '');
              }
            });
          },
          fail: function fail(res) {
            _this.$indicator.close();
            // _this.$messagebox.alert('获取错误信息：'+JSON.stringify(res),'')
            _this.$messagebox.alert('定位失败，请查看是否允许定位或者手动进行搜索');
          }
        });
      });
      wx.error(function (res) {
        // alert(JSON.stringify(res));
        // window.location.reload();
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    }, function (data) {
      _this.$indicator.close();
      _this.$messagebox.alert('未查询到附近学校，请手动搜索', '');
    });
    if (document.domain.indexOf('xiyoushi.com') >= 0) {
      _this.showBottomTips = true;
    }
  },

  watch: {
    message: function message() {
      this.searchSchool();
    }
  },
  methods: {
    backJdlw: function backJdlw() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_bridge__["a" /* callNative */])("jsCallNativePage", { "routeUrl": "yocial://life_consume/" });
    },
    key: function key(e) {
      var _this = this;
      if (e.keyCode == '13') {
        _this.searchSchool(_this.message);
      }
    },

    saveInfo: function saveInfo(e) {
      var _this = this;
      if (_this.$store.state.wxUid) {
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].toggleSchool(_this, { school_id: e.school_id, uid: _this.$store.state.wxUid }, function (data) {}, function () {});
        if (_this.$utils.getCookie('clc') && _this.$utils.getCookie('clc').length > 0) {
          var key = _this.$utils.getCookie('clc');
          _this.$utils.setCookie('clc', '');
          _this.acceptInvite(key, e.school_id);
        }
      }
      var schoolInfo = {};
      schoolInfo.schoolId = e.school_id;
      schoolInfo.schoolName = e.school_name;
      this.$store.commit('changeSchoolInfo', schoolInfo);
      this.$router.push({ path: 'index' });
    },
    searchSchool: function searchSchool() {
      var _this2 = this;

      if (!this.message || this.message.length < 2) {
        this.iSearch = false;
        this.schoolList = [];
        return;
      } else {
        this.iSearch = true;
      }
      var _this = this;
      var params = { keyword: this.message };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSearchSchool(_this, params, function (data) {
        if (data.length > 0) {
          _this2.schoolList = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              item.school_name = item.school_name;
              var replaceReg = new RegExp(_this.message, 'g');
              var replaceString = '<span class="search-text">' + _this.message + '</span>';
              item.schoolName = item.school_name.replace(replaceReg, replaceString);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this2.schoolList = data;
        } else {
          _this2.schoolList = [];
          //            _this.$messagebox.alert('未查询到相关学校','')
        }
      });
    },
    clearInput: function clearInput() {
      this.message = '';
    },

    // 邀请有礼 接受邀请
    acceptInvite: function acceptInvite(key, school_id) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].clcAcceptInvite(_this, { school_id: school_id, link: key }, function (data) {});
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CommentStars__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CouponPackage",
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default.a
  },
  data: function data() {
    return {
      couponPackageList: [],
      packageDetail: {},
      packageShop: [],
      showPayBox: false,
      isCanSubmit: true,
      showUseBox: false,
      recordList: [],
      showPage: true
    };
  },
  created: function created() {
    var uid = this.$store.state.wxUid;
    if (!uid) {
      // 如果没有登录信息先跳转登录页
      this.$utils.toLogin(this);
    } else {
      this.getCouponPackageList();
      this.getRecordList();
    }
  },

  methods: {
    getCouponPackageList: function getCouponPackageList() {
      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        source: 0
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackageList(_this, params, function (data) {
        if (data && data.length > 0) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var v = _step.value;

              if (v.package_rule) {
                v.package_rule = v.package_rule.replace(/(\n|\r|\r\n|↵)/g, "<br/>");
              }
              if (_this.$route.query && _this.$route.query.id) {
                var id = _this.$route.query.id;
                if (v.package_id == id) {
                  _this.packageDetail = v;
                  _this.getPackageShop(v.package_shop);
                  if (v.package_status === 1) {
                    _this.showPayBox = true;
                  }
                }
              } else {
                _this.packageDetail = data[0];
                _this.getPackageShop(data[0].package_shop);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.couponPackageList = data;
          // 曝光埋点
          var logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_coupon_bag_index',
            createTime: new Date().getTime(),
            firstValue: _this.$store.state.schoolInfo.schoolId
          }];
          _this.addLog(logDetails);
        } else {
          _this.showPage = false;
        }
      }, function () {
        _this.showPage = false;
      });
    },
    getPackageShop: function getPackageShop(shops) {
      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        page: 1,
        pageSize: 1000,
        shops: shops
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackageShop(_this, params, function (data) {
        if (data && data.length > 0) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var shop = _step2.value;

              if (shop.promotion_list && shop.promotion_list.length > 0) {
                shop.promotion_list = _.uniqBy(shop.promotion_list, function (item) {
                  return item.promotion_type;
                });
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this.packageShop = data;
        }
      });
    },
    getRecordList: function getRecordList() {
      var _this2 = this;

      var _this = this;
      var params = {
        order_status: 0,
        page: 1,
        page_size: 1000
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackagePurchaseRecord(_this, params, function (data) {
        if (data && data.list && data.list.length > 0) {
          _this2.recordList = data.list;
        }
      });
    },
    toPay: function toPay() {
      var _this = this;
      if (!_this.isCanSubmit) {
        return;
      }
      var params = {
        schoolId: _this.$store.state.schoolInfo.schoolId,
        schoolName: _this.$store.state.schoolInfo.schoolName,
        couponPackageId: _this.packageDetail.package_id,
        couponPackageAmount: _this.packageDetail.package_selling_price,
        orderType: 8,
        couponPackageType: _this.packageDetail.package_type,
        goods: [{
          goodsName: _this.packageDetail.package_name,
          price: _this.packageDetail.package_selling_price,
          number: 1
        }]
      };
      _this.isCanSubmit = false;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postOrderCreate(_this, params, function (data) {
        if (data.status === 0) {
          window.localStorage.setItem("order-type", 8);
          window.localStorage.setItem("orderCode", data.orderId);
          _this.showPayBox = false;
          _this.$router.push({ name: "Payment" });
        }
      }, function (data) {
        _this.$messagebox.alert(data.data.message, "");
        _this.isCanSubmit = true;
      });
    },
    openShowPay: function openShowPay(item) {
      if (item.package_status === 1) {
        this.showPayBox = true;
        this.packageDetail = item;
        // 点击埋点
        var logDetails = [{
          uid: this.$store.state.wxUid,
          code: 'click_coupon_bag_index',
          createTime: new Date().getTime(),
          refId: item.package_id,
          firstValue: this.$store.state.schoolInfo.schoolId
        }];
        this.addLog(logDetails);
      }
    },
    viewShops: function viewShops(item) {
      this.showPayBox = false;
      this.$router.push({
        name: "CouponPackageShopList",
        query: { shops: item.package_shop.join(',') }
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: "orderDishes"
      };
      _this.$store.commit("changeState", obj);
      _this.$router.push({ name: "GoodsList" });
    },
    toRecord: function toRecord() {
      this.$router.push({
        name: "CouponPackageRecord"
      });
    },

    // 统计埋点
    addLog: function addLog(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CouponPackageRecord",
  data: function data() {
    return {
      recordList: []
    };
  },
  created: function created() {
    this.getRecordList();
  },

  methods: {
    getRecordList: function getRecordList() {
      var _this = this;
      var params = {
        page: 1,
        page_size: 1000
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackagePurchaseRecord(_this, params, function (data) {
        if (data && data.list && data.list.length > 0) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var v = _step.value;

              var order_status = v.order_status,
                  order_status_str = '';
              switch (order_status) {
                case 0:
                  order_status_str = '待支付';
                  break;
                case 1:
                  order_status_str = '已支付';
                  break;
                case 2:
                  order_status_str = '已取消';
                  break;
                case 3:
                  order_status_str = '已发放';
                  break;
              }
              v.order_status_str = order_status_str;
              // if(v.order_status === 0){
              //   v.minutes = '00';
              //   v.seconds = '00';
              //   if(v.order_date && new Date().getTime() < new Date(v.order_date).getTime()){
              //     this.countdowns(v);
              //   }
              // }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.recordList = data.list;
        } else {
          _this.$toast('您还没有购买过券包哦');
        }
      });
    },
    countdowns: function countdowns(item) {
      var _this = this;
      var now = new Date().getTime();
      var date = new Date(item.order_date).getTime();
      var SysSecond = parseFloat(date - now) / 1000;
      _this.timer = window.setInterval(function () {
        if (SysSecond > 0) {
          SysSecond = SysSecond - 1;
          var minutes = Math.floor(SysSecond / 60 % 60); // 计算分
          var seconds = Math.floor(SysSecond % 60); // 计算秒
          if (seconds < 10) {
            item.seconds = '0' + seconds;
          } else {
            item.seconds = seconds;
          }
          if (minutes < 10) {
            item.minutes = '0' + minutes;
          } else {
            item.minutes = minutes;
          }
        } else {
          window.clearInterval(_this.timer);
          item.minutes = '00';
          item.seconds = '00';
          _this.getRecordList();
          // _this.$messagebox.alert('支付超时', '')
        }
      }, 1000);
    },
    toPay: function toPay(item) {
      window.localStorage.setItem("order-type", 8);
      window.localStorage.setItem("orderCode", item.order_id);
      this.$router.push({ name: "Payment" });
    },

    // 取消订单
    cancelOrder: function cancelOrder(id) {
      var _this2 = this;

      this.$messagebox.confirm('确定取消订单吗?', '').then(function (action) {
        var _this = _this2;
        var params = {
          order_id: id
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功');
          _this.getRecordList();
        });
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CommentStars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AlertBox__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AlertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AlertBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { MessageBox,Indicator } from 'mint-ui';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_0__components_CommentStars___default.a
  },
  data: function data() {
    return {
      shopList: [],
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      showPage: false,
      shopListType: '',
      bannerUrl: '',
      clientHeight: document.documentElement.clientHeight
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    next();
  },
  mounted: function mounted() {
    var _this = this;
    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      if (marginBot <= 1) {
        if (_this.hasMore) {
          _this.getShopList();
        }
      }
    };
  },
  activated: function activated() {
    var _this = this;
    _this.shopList = [];
    _this.currentPage = 1;
    _this.hasMore = true;
    _this.showPage = false;
    _this.bannerUrl = '';
    _this.getShopList();
  },

  methods: {
    showMoreGift: function showMoreGift(item) {
      item.iShowMore = !item.iShowMore;
    },
    getShopList: function getShopList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize,
        shops: _this.$route.query.shops
      };
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].postPackageShop(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var shop = _step.value;

              var obj = {
                backgroundImage: "url(" + shop.pic + ")"
              };
              shop.backgroundimg = obj;
              shop.iShowMore = false;
              if (shop.promotion_list && shop.promotion_list.length > 0) {
                shop.promotion_list = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                  return item.promotion_type;
                });
              }
              _this.shopList.push(shop);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          _this.hasMore = false;
        }
        _this.showPage = true;
        _this.$indicator.close();
        _this.$nextTick(function () {
          var goodsList = document.getElementsByClassName('goods-list');
          var item = goodsList[0].clientHeight / _this.shopList.length;
          var size = Math.round(_this.clientHeight / item);
          _this.$store.commit('changeRecordItemHeight', item);
          _this.$store.commit('changeRecordList', _this.shopList);
          _this.$store.commit('changeRecordOtherHeight', 0);
          _this.$store.commit('changeRecordPage', 'ShopList');
          _this.$store.commit('changeRecordState', true);
          _this.$utils.firstLogPush(size, _this.shopList, 'asa_merc_shop_specialList', 'id');
        });
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      isShopDelivery: false,
      showStatus: true,
      orderId: 0,
      schoolId: '',
      statusList: [],
      orderInfo: {},
      settle_amount: 0,
      shopTel: '',
      deliveryStatusName: '',
      orderCreateTime: '',
      orderType: '',
      pickupProcess: JSON.parse(window.localStorage.getItem('pickupProcess'))
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  created: function created() {
    var _this = this;
    if (_this.$utils.resolveUrl().order_id) {
      _this.orderId = _this.$utils.resolveUrl().order_id;
      if (_this.$utils.resolveUrl().order_type) {
        _this.orderType = _this.$utils.resolveUrl().order_type;
      } else {
        _this.orderType = 0;
      }
    } else {
      _this.orderType = window.localStorage.getItem('orderType');
      _this.orderId = window.localStorage.getItem('orderCode');
    }
    if (_this.$utils.resolveUrl().school_id) {
      _this.schoolId = _this.$utils.resolveUrl().school_id;
    } else {
      _this.schoolId = _this.schoolInfo.schoolId;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (_this.orderType == 0) {
      document.title = '配送信息';
      _this.getJudgeShopDelivery();
    } else if (_this.orderType == 1) {
      document.title = '自提单详情';
      _this.pickupProcess = JSON.parse(window.localStorage.getItem('pickupProcess')).reverse();
      _this.showPage = true;
    }
  },

  methods: {
    formatDate: function formatDate(time) {
      var date = new Date(time);

      var year = date.getFullYear(),
          month = date.getMonth() + 1,
          //月份是从0开始的
      day = date.getDate(),
          hour = date.getHours(),
          min = date.getMinutes(),
          sec = date.getSeconds();
      var newTime = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
      return newTime;
    },

    // 切换tab
    switchInfo: function switchInfo(e) {
      var _this = this;
      if (e.target.id == 'info') {
        _this.showStatus = true;
        _this.getProgressLog();
      } else {
        _this.showStatus = false;
        _this.getTransportInfo();
      }
    },
    //判断是否为商家配送
    getJudgeShopDelivery: function getJudgeShopDelivery() {
      var _this = this;
      var params = {
        schoolId: _this.schoolId,
        orderCode: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJudgeShopDelivery(_this, params, function (data) {
        _this.isShopDelivery = data.isShopDelivery;
        _this.showPage = true;
        if (_this.isShopDelivery) {
          //是商家配送
          _this.shopTel = data.shopTel;
        } else {
          //不是商家配送
          _this.getProgressLog();
        }
      });
    },
    getTransportInfo: function getTransportInfo() {
      var _this = this;
      var params = {
        schoolId: _this.schoolId,
        orderCode: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getTransportInfo(_this, params, function (data2) {
        _this.orderInfo = data2;
        // var newDate = new Date()
        _this.orderCreateTime = _this.formatDate(data2.orderCreateTime);
        if (data2.status == 1) {
          _this.deliveryStatusName = '商家已接单';
        } else if (data2.status == 2) {
          _this.deliveryStatusName = '派单中';
        } else if (data2.status == 3) {
          _this.deliveryStatusName = '取单中';
        } else if (data2.status == 4) {
          _this.deliveryStatusName = '配送中';
        } else if (data2.status == 5) {
          _this.deliveryStatusName = '已送达';
        } else if (data2.status == 6) {
          _this.deliveryStatusName = '转单中';
        } else if (data2.status == -1) {
          _this.deliveryStatusName = '已撤销';
        }
      });
    },
    getProgressLog: function getProgressLog() {
      var _this = this;
      var params = {
        schoolId: _this.schoolId,
        orderCode: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getProgressLog(_this, params, function (data) {
        _this.statusList = data;
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "deviceDetail",
  data: function data() {
    return {
      orderInfo: {},
      orderId: '',
      countDownLatch: '',
      timer: '',
      countDownPercent: 100
    };
  },
  created: function created() {
    this.orderId = this.$route.params.id;
    this.getOrderDetail();
  },

  methods: {
    getOrderDetail: function getOrderDetail() {
      var _this = this;
      var param = {
        order_id: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderDetail(_this, param, function (data) {
        _this.orderInfo = data;
        _this.countDownLatch = data.orderPickUpInfoBean.countDownLatch;
        _this.countDownFn();
      });
    },
    countDownFn: function countDownFn() {
      var _this2 = this;

      var countDownLatch = this.countDownLatch; // 获取倒计时初始值
      this.timer = setInterval(function () {
        countDownLatch--;
        _this2.countDownLatch = countDownLatch;
        // this.countDownPercent = (countDownLatch/this.data.orderInfo.orderPickUpInfoBean.countDownLatch)*100
        if (countDownLatch == 0) {
          clearInterval(_this2.timer);
          // wx.navigateBack();
          _this2.$router.back();
        }
      }, 1000);
    },

    // 一键开柜
    sureCabinet: function sureCabinet() {
      var _this = this;
      var params = {
        operateType: 1,
        order_id: _this.orderId
      };
      _this.$indicator.open();
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].openCabinet(_this, params, function (data) {
        _this.$indicator.close();
        _this.$toast('开柜成功 请取走您的餐盒并关好箱门');
      }, function (data) {
        _this.$indicator.close();
        _this.$toast(data.data.message);
      });
    },
    closePage: function closePage() {
      this.$router.back();
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isInit: true,
      propShow: false,
      propBuildShow: false,
      propFloorShow: false,
      propRoomShow: false,
      buildTitle: '请选择楼栋',
      floorTitle: '请选择楼层',
      roomTitle: '请选择房间',
      buildingList: [],
      floorList: [],
      roomList: [],
      build_x_name: null,
      floor_x_name: null,
      room_x_name: null,
      needBuilding: null,
      buildInfo: {
        name: undefined,
        id: undefined
      },
      floorInfo: {
        name: undefined,
        id: undefined
      },
      roomInfo: {
        name: undefined,
        id: undefined
      },
      address_id: '',
      gender: '',
      addressee: '',
      mp: '',
      poi_address: '',
      detail: '',

      isCustom: false,
      openCustomRoom: false,
      customRoomName: '' // 自定义房间
    };
  },

  watch: {
    room_x_name: function room_x_name(val) {
      this.room_x_name = val.replace(/\D/g, '');
    }
  },
  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  created: function created() {
    var _this = this;
    // document.title = '编辑收货地址';
    _this.address_id = window.localStorage.getItem('address-id');
    if (window.localStorage.getItem('addressInfo')) {
      var addressInfo = JSON.parse(window.localStorage.getItem('addressInfo'));
      // console.log(addressInfo)
      _this.gender = addressInfo.gender;
      _this.addressee = addressInfo.addressee;
      _this.mp = addressInfo.mp;
      _this.poi_address = addressInfo.poi_address;
      _this.detail = addressInfo.detail;
      _this.lon = addressInfo.lon;
      _this.lat = addressInfo.lat;
      _this.buildInfo.name = addressInfo.build_name;
      _this.buildInfo.id = addressInfo.build_id;
      _this.floorInfo.name = addressInfo.floor_name;
      _this.floorInfo.id = addressInfo.floor_id;
      _this.roomInfo.name = addressInfo.room_name;
      _this.roomInfo.id = addressInfo.room_id;
      // _this.build_x_name = addressInfo.build_x_name
      // _this.floor_x_name = addressInfo.floor_x_name
      // _this.room_x_name = addressInfo.room_x_name
      // if (_this.build_x_name) _this.buildInfo.name = '其他'
      // if (_this.floor_x_name) _this.floorInfo.name = '其他'
      // if (_this.room_x_name) _this.roomInfo.name = '其他'

      _this.getBuildingList();
      if (_this.buildInfo.build_name && _this.buildInfo.floor_name && _this.buildInfo.room_name) {
        _this.getFloorList(1);
        _this.getRoomList();
      }
    } else {
      _this.postUserAddressInfo();
    }
  },

  methods: {
    closeProp: function closeProp() {
      this.propShow = false;
      this.propBuildShow = false;
      this.propFloorShow = false;
      this.propRoomShow = false;
    },
    clearInfo: function clearInfo(type) {
      if (!type) {
        this.buildingList = [];
        this.needBuilding = null;
      }
      if (type == 2) {
        this.floorList = [];
        this.floorInfo = {
          name: null,
          id: null
        };
      }
      this.roomList = [];
      this.roomInfo = {
        name: null,
        id: null
      };
    },
    getBuildingList: function getBuildingList() {
      var _this2 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          _this2.buildingList = data;
          _this2.needBuilding = data[0].area;
          // console.log(this.needBuilding)
        } else {
          _this2.clearInfo();
        }
      });
    },
    getFloorList: function getFloorList(f) {
      var _this3 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        type: 2,
        code: this.buildInfo.id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          _this3.floorList = data;
          if (!_this.isInit) _this3.propFloorShow = true;
          if (f) {
            if (_this3.floorInfo.id) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var v = _step.value;

                  if (v.id == _this3.floorInfo.id && v.is_custom == 1) {
                    _this3.isCustom = true;
                    if (_this3.roomInfo.id == -1) {
                      _this3.customRoomName = _this3.roomInfo.name;
                    }
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }
        } else {
          _this3.clearInfo(2);
          _this3.propShow = false;
        }
      });
    },
    getRoomList: function getRoomList() {
      var _this4 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        type: 3,
        code: this.floorInfo.id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          _this4.roomList = data;
          if (!_this.isInit) _this4.propRoomShow = true;
        } else {
          _this4.clearInfo(3);
          _this4.propShow = false;
        }
      });
    },
    toggleBuildProp: function toggleBuildProp() {
      if (!this.propShow) this.propShow = true;
      this.propBuildShow = !this.propBuildShow;
    },
    toggleFloorProp: function toggleFloorProp() {
      if (!this.propShow) this.propShow = true;
      this.propFloorShow = !this.propFloorShow;
    },
    toggleRoomProp: function toggleRoomProp() {
      if (!this.propShow) this.propShow = true;
      this.propRoomShow = !this.propRoomShow;
    },
    changeBuilding: function changeBuilding(item) {
      if (this.isInit) this.isInit = false;
      this.buildInfo.name = item.area;
      this.buildInfo.id = item.id;
      this.propBuildShow = false;
      this.clearInfo(2);
      this.getFloorList();
    },
    changeFloor: function changeFloor(item) {
      if (this.isInit) this.isInit = false;
      this.floorInfo.name = item.area;
      this.floorInfo.id = item.id;
      this.propFloorShow = false;
      if (item.is_custom == 1) {
        this.isCustom = true;
        this.customRoomName = '';
      } else {
        this.isCustom = false;
      }
      this.clearInfo(3);
      this.getRoomList();
    },
    changeRoom: function changeRoom(item) {
      if (this.isInit) this.isInit = false;
      this.roomInfo.name = item.area;
      this.roomInfo.id = item.id;
      this.propRoomShow = false;
      this.propShow = false;
    },

    inputFocus: function inputFocus() {
      // document.getElementsByTagName('footer')[0].classList.remove('fixed')
    },
    inputBlur: function inputBlur() {
      // document.getElementsByTagName('footer')[0].classList.add('fixed')
    },
    chooseAddress: function chooseAddress() {
      var _this = this;
      var addressInfo = {};
      addressInfo.gender = _this.gender;
      addressInfo.addressee = _this.addressee;
      addressInfo.mp = _this.mp;
      addressInfo.poi_address = _this.poi_address;
      addressInfo.detail = _this.detail;
      addressInfo.lat = _this.lat;
      addressInfo.lon = _this.lon;
      addressInfo.build_name = _this.buildInfo.name;
      addressInfo.build_id = _this.buildInfo.id;
      addressInfo.floor_name = _this.floorInfo.name;
      addressInfo.floor_id = _this.floorInfo.id;
      addressInfo.room_name = _this.roomInfo.name;
      addressInfo.room_id = _this.roomInfo.id;
      // addressInfo.build_x_name = _this.build_x_name
      // addressInfo.floor_x_name = _this.floor_x_name
      // addressInfo.room_x_name = _this.room_x_name
      window.localStorage.setItem('addressInfo', JSON.stringify(addressInfo));
      _this.$router.push({ path: '/chooseaddress' });
    },
    postUserAddressInfo: function postUserAddressInfo() {
      var _this = this;
      var params = {
        id: _this.address_id,
        school_id: this.$store.state.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postUserAddressInfo(_this, params, function (data) {
        _this.addressee = _this.$utils.Decrypt(data.addressee_encryption);
        _this.mp = _this.$utils.Decrypt(data.mp_encryption);
        if (data.gender === '男') {
          _this.gender = '1';
        } else {
          _this.gender = '0';
        }
        _this.poi_address = data.poi_address;
        _this.detail = data.detail;
        _this.lat = data.lat;
        _this.lon = data.lon;
        _this.buildInfo.name = data.build_name;
        _this.buildInfo.id = data.build_id;
        _this.floorInfo.name = data.floor_name;
        _this.floorInfo.id = data.floor_id;
        _this.roomInfo.name = data.room_name;
        _this.roomInfo.id = data.room_id;
        // _this.build_x_name = data.build_x_name
        // _this.floor_x_name = data.floor_x_name
        // _this.room_x_name = data.room_x_name
        if (data.isLimitFloor) {
          _this.getBuildingList();
          if (data.build_name && data.floor_name && data.room_name) {
            _this.getFloorList(1);
            _this.getRoomList();
          }
          // if (_this.build_x_name) {
          //   _this.buildInfo.name = '其他'
          // } else {
          //   _this.getFloorList();
          // }
          // if (_this.floor_x_name) {
          //   _this.floorInfo.name = '其他'
          // } else {
          //   _this.getRoomList();
          // }
          // if (_this.room_x_name) _this.roomInfo.name = '其他'
        }
      });
    },
    // 保存编辑地址
    saveAddress: function saveAddress() {
      var _this = this;
      if (_this.addressee === '') {
        _this.$messagebox.alert('请输入您的姓名', '');
        return false;
      }
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入您的手机号', '');
        return false;
      } else if (!/^1\d{10}$/.test(_this.mp)) {
        _this.$messagebox.alert('请输入正确格式的手机号', '');
        return false;
      }
      if (!_this.lon && !this.needBuilding) {
        _this.$messagebox.alert('请选择地址', '');
        return false;
      }
      if (this.needBuilding) {
        if (!this.buildInfo.id) {
          return _this.$messagebox.alert('请选择楼栋');
        }
        // else if (this.buildInfo.name == '其他' && !this.build_x_name) {
        //   return _this.$messagebox.alert('请填写自定义楼栋')
        // }
        if (!this.floorInfo.id) {
          return _this.$messagebox.alert('请选择楼层');
        }
        // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他') && !this.floor_x_name) {
        //   return _this.$messagebox.alert('请填写自定义楼层')
        // }
        if (!this.roomInfo.id) {
          return _this.$messagebox.alert('请选择房间');
        }
        // else if ((this.buildInfo.name == '其他' || this.floorInfo.name == '其他' || this.roomInfo.name == '其他') && !this.floor_x_name) {
        //   return _this.$messagebox.alert('请填写自定义房间')
        // }
      }
      if (_this.detail === '' && !this.needBuilding) {
        _this.$messagebox.alert('请输入您的详细地址', '');
        return false;
      }
      var gender;
      if (_this.gender === '1') {
        gender = '男';
      } else {
        gender = '女';
      }
      var params = {
        id: _this.address_id,
        // school_id: _this.schoolInfo.schoolId,
        // addressee: _this.addressee,
        addressee_encryption: _this.$utils.Encrypt(_this.addressee),
        gender: gender,
        // mp: _this.mp,
        mp_encryption: _this.$utils.Encrypt(_this.mp),
        poi_address: _this.poi_address,
        detail: _this.detail,
        lon: _this.lon,
        lat: _this.lat,

        // build_x_name: _this.build_x_name,
        // floor_x_name: _this.floor_x_name,
        // room_x_name: _this.room_x_name,
        build_id: _this.buildInfo.id,
        build_name: _this.buildInfo.name,
        floor_id: _this.floorInfo.id,
        floor_name: _this.floorInfo.name,
        room_id: _this.roomInfo.id,
        room_name: _this.roomInfo.name,
        addressType: _this.needBuilding ? 1 : 0,
        is_build: _this.needBuilding ? 1 : 0

        // if (document.domain.indexOf('xiyoushi.com') >= 0) {
        //   params.school_id = 1826
        // } else {
        //   params.school_id = _this.schoolInfo.schoolId
        // }
      };__WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSaveAddress(_this, params, function () {
        // _this.$messagebox.alert('修改成功','')
        window.localStorage.removeItem('addressInfo');
        _this.$router.go(-1);
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },

    changeOpenCustom: function changeOpenCustom() {
      this.openCustomRoom = !this.openCustomRoom;
    },
    choseCustomRoom: function choseCustomRoom() {
      // document.getElementsByTagName('footer')[0].classList.add('fixed');
      if (!this.customRoomName || this.customRoomName.length == 0) {
        this.$messagebox.alert('请输入你的房间号', '');
        return;
      }
      this.roomInfo.id = -1;
      this.roomInfo.name = this.customRoomName;
      this.openCustomRoom = false;
      this.propRoomShow = false;
      this.propShow = false;
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      list: {}
    };
  },
  created: function created() {
    this.getExpDesc();
  },

  methods: {
    getExpDesc: function getExpDesc() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getExpDesc(_this, { uid: localStorage.getItem('wxUid') }, function (data) {
        _this.list = data;
      });
    }
  }

});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { Toast } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      complainId: window.localStorage.getItem('complainId'),
      resultFeedBack: 1
    };
  },

  // created () {
  //   document.title = '投诉结果反馈'
  // },
  methods: {
    selected: function selected(data) {
      var _this = this;
      if (data === 'good') {
        if (_this.resultFeedBack !== 1) {
          _this.resultFeedBack = 1;
        }
      } else if (data === 'bad') {
        if (_this.resultFeedBack !== 2) {
          _this.resultFeedBack = 2;
        }
      }
    },
    submit: function submit() {
      var _this = this;
      var params = {
        complainId: _this.complainId,
        resultFeedBack: _this.resultFeedBack
      };
      window.localStorage.setItem('complainId', _this.complainId), __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postFeedBack(_this, params, function () {
        //提交反馈成功
        _this.$router.go(-1);
      }, function (response) {
        _this.$toast(response.body.message);
      });
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "findBuild",
  data: function data() {
    return {
      buildsList: [],
      schoolName: this.$store.state.schoolInfo.schoolName,
      charge_per_floor: 0
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  created: function created() {
    var _this = this;
    _this.getBuildingList();
  },

  methods: {
    getBuildingList: function getBuildingList() {
      var _this = this;
      var orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
      _this.charge_per_floor = orderPreviewInfo.isCanChooseDeliveryWay;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: window.localStorage.getItem('shop_code'),
        charge_per_floor: _this.charge_per_floor
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildLists(_this, params, function (data) {
        if (data && data.length > 0) {
          _this.buildsList = data;
        }
      });
    }
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CommentStars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_iscroll_probe_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_iscroll_probe_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_js_iscroll_probe_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var wx = require('weixin-js-sdk')





// import { MessageBox, Toast, Indicator} from 'mint-ui'

var myScroll;
var myScroll1;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      spreadPrice: '',
      thresholdAmount: '',
      propShow: false,
      goodsList: [],
      myGoodsList: [], //超市商品列表
      req_type: 0, //是否是超市
      isClickSupperTag: false,
      isFromSupperPage: false,
      cartInfoTags: new Map(),
      page: 0,
      noMore: false,
      isLoading: false,
      myIndex: 0,
      shopDetail: {
        promotion_list: []
      },
      goodsDetail: {},
      shopCartInfo: [],
      cartTotal: 0,
      cartAmount: 0, //商品总价
      cartOriginAmount: 0, //商品总原价
      showBlock: 'orderDishes',
      propShopInfo: false,
      propGoodInfo: false,
      propSpecInfo: false,
      CommentNum: '',
      businessCommentList: [],
      activeGoodsNum: 0,
      activeGoodsArray: [], // 购物车内活动商品
      flag: true,
      showPage: false,
      shopCode: '',
      shopUrl: window.location.href,
      landingPage: window.localStorage.getItem('landingPage'),
      openTime: '',
      orderType: '',
      hasSpecial: false,
      reductionAmount: '', //已减金额
      nextFullReductionAmount: 0, //下一满足金额
      nextFullReductionAmountGap: '', //距下一满足金额差额
      previewPic: false, //图片预览弹框
      previewImgUrl: '', //预览图片url
      specification: {}, //规格
      attributes: [], //属性
      orderCode: '',

      hasNeedChoose: false, //是否包含必点商品
      needChooseCates: [], // 必选分类组
      needChooseCatesIds: [],
      isShowCartGoods: false,
      changeGoodsInCart: [],

      couponModalOpened: false, //店铺优惠券弹框
      couponInfo: {},
      tips: '',
      showTip: false,

      keyword: '',
      searchResults: [],
      showShopSearch: false,
      iShowSearchNothing: false,

      gdCode: 0
    };
  },

  computed: {
    cartInfo: function cartInfo() {
      return this.$store.state.cartInfo;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    },
    wxLoginToken: function wxLoginToken() {
      return this.$store.state.wxLoginToken;
    }
  },
  created: function created() {
    var _this = this;

    // if(_this.isIos && !_this.$utils.resolveUrl().isShare && document.domain.indexOf('xiyoushi.com') < 0) {
    //   window.history.replaceState({}, '', _this.landingPage);
    // }

    if (!window.localStorage.getItem('cartInfo')) {
      var cartInfo = {};
      _this.$store.commit('changeCartInfo', cartInfo);
    }

    if (window.localStorage.getItem('showBlockType')) {
      _this.showBlock = window.localStorage.getItem('showBlockType');
    }

    // 更新用户详细信息
    var token = window.localStorage.getItem('wxToken');
    if (_this.$utils.getCookie('token')) {
      token = _this.$utils.getCookie('token');
      var obj = {
        wxToken: token
      };
      _this.$store.commit('changeState', obj);
      // _this.updateUserInfo(token);
    }

    if (_this.$utils.resolveUrl().shopCode) {
      _this.shopCode = _this.$utils.resolveUrl().shopCode;
      var obj = {
        shop_code: _this.$utils.resolveUrl().shopCode
      };
      _this.getShopInfo();
      // localStorage.removeItem('urlSource');
      // 来源：上海现代高校智慧后勤研究院
      // let urlSource = _this.$utils.resolveUrl().source;
      // if (urlSource && urlSource == 'yjy') {
      //   localStorage.setItem('urlSource','yjy');
      // }
    } else {
      _this.shopCode = window.localStorage.getItem('shop_code');
      _this.getShopInfo();
    }

    if (_this.$utils.resolveUrl().gdCode) {
      _this.gdCode = _this.$utils.resolveUrl().gdCode;
    }

    if (!_this.cartInfo[_this.shopCode]) {
      _this.cartInfo[_this.shopCode] = {
        total: 0,
        amount: 0,
        market: {}
      };
      _this.$store.commit('changeCartInfo', _this.cartInfo);
    }

    if (_this.cartInfo[_this.shopCode].total) {
      _this.cartTotal = _this.cartInfo[_this.shopCode].total; //初始化购物车商品数量
      _this.cartAmount = _this.cartInfo[_this.shopCode].amount; //初始化页面购物车金额
      _this.isFromSupperPage = true;
      var data = Object.values(_this.cartInfo[_this.shopCode].market);
      var arr = new Map();
      for (var i = 0; i < data.length; i++) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = data[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (arr.has(item.tag_id1)) {
              var num = arr.get(item.tag_id1) + item.cartNum;
              arr.set(item.tag_id1, num);
            } else {
              arr.set(item.tag_id1, item.cartNum);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      _this.cartInfoTags = arr;
    }
    _this.orderCode = _this.$route.params.orderCode;
    if (_this.orderCode) {
      if (_this.cartTotal > 0) {
        _this.propShow = true;
      }
      _this.changeGoodsInCart = JSON.parse(window.localStorage.getItem('changeGoodsInCart'));
      if (_this.changeGoodsInCart.length > 0) {
        _this.isShowCartGoods = true;
      }
    }
    _this.addLog();
    window.localStorage.removeItem('selectedCoupon');
    window.localStorage.removeItem('selectedDeliveryCoupon');
  },

  methods: {
    updateUserInfo: function updateUserInfo(token) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postAuthInfo(_this, { token: token }, function (data) {
        var openid = _this.$store.state.openId;
        if (data.openid && data.openid != '') {
          openid = data.openid;
        }
        if (data.login_token) {
          var obj = {
            openId: openid,
            wxUid: data.uid,
            wxToken: data.token,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          };
          _this.$store.commit('changeState', obj);

          var userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex,
            mp_real: _this.$utils.Decrypt(data.mp_encryption)
          };
          _this.$store.commit('changeUserInfo', userInfo);
        }
      });
    },
    addLog: function addLog(param) {
      // 内部统计
      var _this = this;
      var params = param || {
        logDetails: [{
          uid: _this.$store.state.wxUid == 'undefined' ? 0 : _this.$store.state.wxUid,
          code: 'aly_wechat_shop',
          createTime: new Date().getTime(),
          refId: localStorage.getItem('shop_code'),
          firstValue: this.$utils.getCookie('UM_distinctid')
        }, {
          uid: _this.$store.state.wxUid == 'undefined' ? 0 : _this.$store.state.wxUid,
          code: 'display_takeout_shop_index',
          createTime: new Date().getTime(),
          refId: localStorage.getItem('shop_code'),
          firstValue: this.$utils.getCookie('UM_distinctid')
        }],
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },

    // 图片预览
    picPreview: function picPreview(e) {
      this.previewPic = true;
      this.previewImgUrl = e.target.currentSrc;
    },


    showMoreGift: function showMoreGift() {
      this.shopDetail.iShowMore = !this.shopDetail.iShowMore;
    },
    switchInfo: function switchInfo(e) {
      var _this = this;
      if (e.target.id == 'orderDishes') {
        _this.showBlock = 'orderDishes';
        _this.flag = true;
        window.localStorage.setItem('showBlockType', 'orderDishes');
        if (_this.shopDetail.req_type) {
          _this.myGoodsList.forEach(function (item) {
            item.goods_list = [];
          });
          _this.isClickSupperTag = true;
          _this.isFromSupperPage = true;
          _this.getShopTagList(0, _this.defaultGoodsList[0].tag_id, _this.defaultGoodsList[0].is_special_tag);
        } else {
          _this.getGoodsList();
        }
      } else if (e.target.id == 'commentInfo') {
        _this.showBlock = 'commentInfo';
        window.localStorage.setItem('showBlockType', 'commentInfo');
        _this.getBusinessCommentList();
      } else if (e.target.id == 'shopInfo') {
        _this.showBlock = 'shopInfo';
        window.localStorage.setItem('showBlockType', 'shopInfo');
      }
      // _this.$nextTick(function () {
      //   var height = window.innerHeight;
      //   var topAreaHeight = document.getElementById("topArea").scrollHeight;
      //   var checkTab = document.getElementById("checkTab").scrollHeight;
      //
      //   if (e.target.id == 'orderDishes') {
      //     //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
      //     var goodList = document.getElementById("goodList");
      //     var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
      //     goodList.style.height = (height - botHeight - topAreaHeight - checkTab) + 'px';
      //     goodList.lastChild.style.minHeight = (height - topAreaHeight - botHeight - checkTab) + 'px';
      //   } else {
      //     var content3 = document.getElementById("content3");
      //     content3.style.height = (height - topAreaHeight - checkTab) + 'px';
      //   }
      // })
    },
    //获取店铺分类列表信息
    getShopTagList: function getShopTagList(sortType, tagCode, specialTag) {
      var _this = this;
      _this.$indicator.open();
      this.noMore = false;
      var params = {
        sortType: sortType,
        size: 20,
        tagCode: specialTag ? '' : tagCode,
        shopCode: _this.shopCode,
        specialTag: specialTag,
        token: _this.wxLoginToken
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopCodeList(_this, params, function (data) {
        _this.$indicator.close();
        if (data.goods_list && data.goods_list.length) {
          var val = _this.myGoodsList.findIndex(function (el) {
            return data.goods_list[0].tag_id == el.tag_id;
          });
          if (val != -1) {
            _this.myGoodsList[val].goods_list = _this.myGoodsList[val].goods_list.concat(data.goods_list);
            _this.myGoodsList[val].codes = data.codes;
          }
          if (data.goods_list.length < 20) {
            _this.noMore = true;
          } else {
            _this.isLoading = false;
          }
          _this.getGoodsList1();
          _this.$forceUpdate();
        } else {
          _this.noMore = true;
          _this.$forceUpdate();
        }
      });
    },
    getDetailGoods: function getDetailGoods(specialTag, index) {
      var _this = this;
      var nums = _this.myGoodsList[index].codes.length - 20 * _this.page;
      _this.page++;
      var codesList = nums >= 20 ? _this.myGoodsList[index].codes.slice(20 * _this.page, 20 * _this.page + 20) : _this.myGoodsList[index].codes.slice(20 * _this.page, 20 * _this.page + nums);
      if (codesList.length) {
        _this.$indicator.open();
        var params = {
          codes: codesList,
          shopCode: _this.shopCode,
          specialTag: specialTag,
          token: _this.wxLoginToken
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopDetailList(_this, params, function (data) {
          _this.$indicator.close();
          if (data.goods_list && data.goods_list.length) {
            var val = _this.myGoodsList.findIndex(function (el) {
              return data.goods_list[0].tag_id == el.tag_id;
            });
            if (val != -1) {
              _this.myGoodsList[val].goods_list = _this.myGoodsList[val].goods_list.concat(data.goods_list);
            }
            if (data.goods_list.length < 20) {
              _this.noMore = true;
            } else {
              _this.isLoading = false;
            }
            _this.$forceUpdate();
          }
        });
      } else {
        _this.noMore = true;
        _this.$forceUpdate();
      }
    },

    // 获取店铺所有信息
    getShopInfo: function getShopInfo() {
      var _this = this;
      _this.$indicator.open();
      // 获取商品列表接口
      var params = {
        shop_id: _this.shopCode,
        token: _this.wxLoginToken
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getGoodsList(_this, params, function (data) {
        _this.$indicator.close();
        data.shop_detail.isShowMore = false;
        _this.showPage = true;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = data.item_list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (item.is_single_spec == 1) {
              //单规格商品
              item.sku_id = item.sku_list[0].sku_id;
            }
            if (item.type == 1) {
              _this.needChooseCates.push({ tag_id: item.tag_id, tag_name: item.tag_name });
              _this.needChooseCatesIds.push(item.tag_id);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this.defaultGoodsList = data.item_list; //商品数据
        var schoolInfo = {
          schoolId: data.shop_detail.school_id,
          schoolName: data.shop_detail.school_name
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);

        // 活动展示
        var promotion_list1 = [];
        if (data.shop_detail.promotion_reduce && data.shop_detail.promotion_reduce.reduce_info) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = data.shop_detail.promotion_reduce.reduce_info[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var r = _step3.value;

              promotion_list1.push(r.meet_price + '\u51CF' + r.cut_price);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
        if (data.shop_detail.promotion_list && data.shop_detail.promotion_list.length > 0) {
          var promotion_list = data.shop_detail.promotion_list;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = promotion_list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var p = _step4.value;

              promotion_list1.push(p.promotion_tips);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
        if (promotion_list1.length > 0) {
          data.shop_detail.promotion_list1 = [].concat(_toConsumableArray(new Set(promotion_list1)));
        }

        if (data.shop_detail.aptitude) {
          var aptitude = data.shop_detail.aptitude;
          if (aptitude.license_list && aptitude.license_list.length > 0) {
            aptitude.license_url_list = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = aptitude.license_list[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var v = _step5.value;

                aptitude.license_url_list.push(v.license);
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
          if (aptitude.food_license_list && aptitude.food_license_list.length > 0) {
            aptitude.food_license_url_list = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = aptitude.food_license_list[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _v = _step6.value;

                aptitude.food_license_url_list.push(_v.food_license);
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }
        }

        _this.shopDetail = data.shop_detail; //店铺信息
        // 券包埋点
        if (_this.shopDetail.promotion_package && _this.shopDetail.promotion_package.length > 0) {
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_shop_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.shopDetail.promotion_package[0].promotion_id,
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.shopCode
          }];
          _this.addLog1(clickParams);
        }
        document.title = _this.shopDetail.shop_name; //页面title
        if (_this.shopDetail.open_rules == 0) {
          //店铺营业时间格式展示处理
          var open_time = [];
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = data.shop_detail.open_setting[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _item = _step7.value;

              var str = _item.begin_time + '-' + _item.end_time;
              open_time.push(str);
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          _this.openTime = open_time.join('、');
        }
        _this.thresholdAmount = data.shop_detail.threshold_amount; //店铺配送费

        window.localStorage.setItem('shopType', _this.shopDetail.is_self_take_new); //是否支持自提 0 否 ，1是
        window.localStorage.setItem('is_take_out', _this.shopDetail.is_take_out); //是否支持外卖 0 否 ，1是
        window.localStorage.setItem('is_eat_in', _this.shopDetail.is_eat_in); //是否支持堂食 0 否 ，1是
        if (_this.shopDetail.req_type) {
          _this.req_type = 1;
          _this.myGoodsList = JSON.parse(JSON.stringify(_this.defaultGoodsList));
          _this.myGoodsList.forEach(function (item) {
            if (!item.goods_list) {
              item.goods_list = [];
              item.codes = [];
            }
          });
          _this.isClickSupperTag = true;
          _this.getShopTagList(0, _this.defaultGoodsList[0].tag_id, _this.defaultGoodsList[0].is_special_tag);
        } else {
          _this.getGoodsList();
        }
        _this.getTotalPrice();
        _this.getGrantlist(1);
        if (_this.shopDetail.is_take_out == 1) {
          _this.orderType = 0; //外卖
        } else if (_this.shopDetail.is_self_take_new == 1 && _this.shopDetail.is_take_out == 0 && _this.shopDetail.is_eat_in == 0) {
          _this.orderType = 1; //仅自提
        } else if (_this.shopDetail.is_eat_in == 1 && _this.shopDetail.is_self_take_new == 0 && _this.shopDetail.is_take_out == 0) {
          _this.orderType = 3; //仅堂食
        } else if (_this.shopDetail.is_self_take_new == 1 && _this.shopDetail.is_eat_in == 1 && _this.shopDetail.is_take_out == 0) {
          _this.orderType = 1; //自提+堂食
        }
        // 自定义分享
        var host = _this.$utils.getHost();
        var link = _this.$utils.isWxWork() ? host + '/wxWork' : _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=goodslist&data=' + encodeURIComponent(JSON.stringify({ 'shopCode': _this.shopCode }));
        _this.$utils.wxShareNew(_this, _this.shopDetail.shop_name, // 分享标题
        link, // 分享链接
        _this.shopDetail.pic, // 分享图标
        '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
        );
      }, function (data) {
        _this.$indicator.close();
        if (data.body.flag == -202) {
          _this.tips = data.body.message;
          _this.showTip = true;
        } else {
          _this.$messagebox.alert(data.body.message, '');
        }
      });
    },
    // 展示刷新商品列表
    getGoodsList1: function getGoodsList1() {
      var _this = this;
      var list = _this.myGoodsList; //取默认数据
      var data = Object.values(_this.cartInfo[_this.shopCode].market);
      var arr = new Map();
      for (var i = 0; i < data.length; i++) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = data[i][Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var item = _step8.value;

            if (arr.has(item.tag_id1)) {
              var num = arr.get(item.tag_id1) + item.cartNum;
              arr.set(item.tag_id1, num);
            } else {
              arr.set(item.tag_id1, item.cartNum);
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
      _this.cartInfoTags = arr;
      if (list.length > 0) {
        //判断购物车中是否有商品
        if (JSON.stringify(_this.cartInfo[_this.shopCode].market) == "{}") {
          //购物车无商品
          //遍历接口返回的商品列表，添加cartNum属性
          for (var g in list) {
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 7) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            list[g].tagNum = 0;
            var goodsList = list[g].goods_list;
            if (goodsList && goodsList.length) {
              for (var e in goodsList) {
                goodsList[e].cartNum = 0;
                goodsList[e].cateType = list[g].type;
              }
            }
          }
        } else {
          //购物车有商品，则遍历购物车中商品，取出商品id,组成数组
          var goodsCodes = [];
          for (var pa in _this.cartInfo[_this.shopCode].market) {
            goodsCodes.push(pa);
          }

          //判断库存是否还有
          for (var key in _this.cartInfo[_this.shopCode].market) {
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
              for (var _iterator9 = _this.cartInfo[_this.shopCode].market[key][Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var obj = _step9.value;

                if (obj.stock <= obj.cartNum) {
                  obj.noStock = true; //无库存
                } else {
                  obj.noStock = false; //有库存
                }
              }
            } catch (err) {
              _didIteratorError9 = true;
              _iteratorError9 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }
              } finally {
                if (_didIteratorError9) {
                  throw _iteratorError9;
                }
              }
            }
          }
          if (!_this.isClickSupperTag && !_this.isFromSupperPage) {
            //修改当前侧边栏的商品
            list[_this.myIndex].tagNum = 0;
            //侧边栏名字显示字数控制
            if (list[_this.myIndex].tag_name.length > 6) {
              list[_this.myIndex].tag_name_short = list[_this.myIndex].tag_name.substring(0, 7) + "...";
            } else {
              list[_this.myIndex].tag_name_short = list[_this.myIndex].tag_name;
            }
            var goodsList = list[_this.myIndex].goods_list;
            if (goodsList && goodsList.length) {
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = goodsList[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var _item2 = _step10.value;

                  _item2.cateType = list[_this.myIndex].type;
                  if (_item2.is_single_spec == 1) {
                    //单规格商品
                    if (goodsCodes.indexOf(_item2.sku_list[0].sku_id) >= 0) {
                      var cartNum = 0; // 已有该商品id
                      var _iteratorNormalCompletion11 = true;
                      var _didIteratorError11 = false;
                      var _iteratorError11 = undefined;

                      try {
                        for (var _iterator11 = _this.cartInfo[_this.shopCode].market[_item2.sku_list[0].sku_id][Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                          var _obj = _step11.value;

                          cartNum += _obj.cartNum;
                        }
                      } catch (err) {
                        _didIteratorError11 = true;
                        _iteratorError11 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion11 && _iterator11.return) {
                            _iterator11.return();
                          }
                        } finally {
                          if (_didIteratorError11) {
                            throw _iteratorError11;
                          }
                        }
                      }

                      _item2.cartNum = cartNum;
                    } else {
                      // 无该商品id
                      _item2.cartNum = 0;
                    }
                  } else {
                    //多规格商品
                    var _cartNum = 0;
                    var _iteratorNormalCompletion12 = true;
                    var _didIteratorError12 = false;
                    var _iteratorError12 = undefined;

                    try {
                      for (var _iterator12 = _item2.sku_list[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                        var _obj2 = _step12.value;

                        if (goodsCodes.indexOf(_obj2.sku_id) >= 0) {
                          var _iteratorNormalCompletion13 = true;
                          var _didIteratorError13 = false;
                          var _iteratorError13 = undefined;

                          try {
                            for (var _iterator13 = _this.cartInfo[_this.shopCode].market[_obj2.sku_id][Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                              var obj2 = _step13.value;

                              _cartNum += obj2.cartNum;
                            }
                          } catch (err) {
                            _didIteratorError13 = true;
                            _iteratorError13 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                                _iterator13.return();
                              }
                            } finally {
                              if (_didIteratorError13) {
                                throw _iteratorError13;
                              }
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError12 = true;
                      _iteratorError12 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                          _iterator12.return();
                        }
                      } finally {
                        if (_didIteratorError12) {
                          throw _iteratorError12;
                        }
                      }
                    }

                    _item2.cartNum = _cartNum;
                  }
                  list[_this.myIndex].tagNum += _item2.cartNum;
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }
            }
          } else if (_this.isClickSupperTag) {
            for (var g in list) {
              list[g].tagNum = 0;
              //侧边栏名字显示字数控制
              if (list[g].tag_name.length > 6) {
                list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
              } else {
                list[g].tag_name_short = list[g].tag_name;
              }
              var goodsList = list[g].goods_list;
              if (goodsList && goodsList.length) {
                var _iteratorNormalCompletion14 = true;
                var _didIteratorError14 = false;
                var _iteratorError14 = undefined;

                try {
                  for (var _iterator14 = goodsList[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var _item3 = _step14.value;

                    _item3.cateType = list[g].type;
                    if (_item3.is_single_spec == 1) {
                      //单规格商品
                      if (goodsCodes.indexOf(_item3.sku_list[0].sku_id) >= 0) {
                        var _cartNum2 = 0; // 已有该商品id
                        var _iteratorNormalCompletion15 = true;
                        var _didIteratorError15 = false;
                        var _iteratorError15 = undefined;

                        try {
                          for (var _iterator15 = _this.cartInfo[_this.shopCode].market[_item3.sku_list[0].sku_id][Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                            var _obj3 = _step15.value;

                            _cartNum2 += _obj3.cartNum;
                          }
                        } catch (err) {
                          _didIteratorError15 = true;
                          _iteratorError15 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion15 && _iterator15.return) {
                              _iterator15.return();
                            }
                          } finally {
                            if (_didIteratorError15) {
                              throw _iteratorError15;
                            }
                          }
                        }

                        _item3.cartNum = _cartNum2;
                      } else {
                        // 无该商品id
                        _item3.cartNum = 0;
                      }
                    } else {
                      //多规格商品
                      var _cartNum3 = 0;
                      var _iteratorNormalCompletion16 = true;
                      var _didIteratorError16 = false;
                      var _iteratorError16 = undefined;

                      try {
                        for (var _iterator16 = _item3.sku_list[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                          var _obj4 = _step16.value;

                          if (goodsCodes.indexOf(_obj4.sku_id) >= 0) {
                            var _iteratorNormalCompletion17 = true;
                            var _didIteratorError17 = false;
                            var _iteratorError17 = undefined;

                            try {
                              for (var _iterator17 = _this.cartInfo[_this.shopCode].market[_obj4.sku_id][Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                                var _obj5 = _step17.value;

                                _cartNum3 += _obj5.cartNum;
                              }
                            } catch (err) {
                              _didIteratorError17 = true;
                              _iteratorError17 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion17 && _iterator17.return) {
                                  _iterator17.return();
                                }
                              } finally {
                                if (_didIteratorError17) {
                                  throw _iteratorError17;
                                }
                              }
                            }
                          }
                        }
                      } catch (err) {
                        _didIteratorError16 = true;
                        _iteratorError16 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion16 && _iterator16.return) {
                            _iterator16.return();
                          }
                        } finally {
                          if (_didIteratorError16) {
                            throw _iteratorError16;
                          }
                        }
                      }

                      _item3.cartNum = _cartNum3;
                    }
                    list[g].tagNum += _item3.cartNum;
                    _this.isClickSupperTag = false;
                  }
                } catch (err) {
                  _didIteratorError14 = true;
                  _iteratorError14 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                      _iterator14.return();
                    }
                  } finally {
                    if (_didIteratorError14) {
                      throw _iteratorError14;
                    }
                  }
                }
              }
            }
            if (_this.isFromSupperPage) {
              for (var v in list) {
                list[v].tagNum = _this.cartInfoTags.get(list[v].tag_id + '') || 0;
              }
              _this.isFromSupperPage = false;
            }
          }
        }
      }
      _this.myGoodsList = list;
      if (_this.flag) {
        _this.$nextTick(function () {

          _this.flag = false;

          // 页面渲染完成后，计算页面元素高度
          var height = window.innerHeight;
          var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
          var navBox = document.getElementById("scrollBox1");
          var goodList = document.getElementById("goodList");
          var topAreaHeight = document.getElementById("topArea").scrollHeight;
          var checkTab = document.getElementById("checkTab").scrollHeight;
          var navBoxChild = navBox.children;

          //默认第一个tab高亮
          if (navBoxChild.length > 0) {
            for (var k = 1; k < navBoxChild.length; k++) {
              navBoxChild[k].className = "";
            }
            navBoxChild[0].className = "active";
          }

          //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
          goodList.style.height = height - botHeight - topAreaHeight - checkTab + 'px';
          myScroll1 = new __WEBPACK_IMPORTED_MODULE_3__assets_js_iscroll_probe_js___default.a('#goodList', {
            bounce: false,
            mouseWheel: true,
            // scrollbars: true,
            // preventDefault: false,//（把这句加上去哦）
            preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|SPAN|A|DIV)$/ }, //（这个后面加|A,因为iscroll阻止了A的默认事件）
            probeType: 3
          });
          _this.flag = false;

          myScroll1.on('scrollEnd', function () {
            var scrollTop = Math.abs(this.y);
            //当导航与相应文档接触的时候加载下一页
            //method1
            if (scrollTop == Math.abs(this.maxScrollY) && this.directionY === 1 && !_this.noMore && !_this.isLoading) {
              console.log('滚动到底部');
              _this.isLoading = true;
              _this.getDetailGoods(_this.myGoodsList[_this.myIndex].is_special_tag, _this.myIndex);
            }
            setTimeout(function () {
              //放在计时器里边才好使，不然容易出错
              myScroll1.refresh();
            }, 0);
          });
        });
      }
      // 同步搜索
      if (_this.showShopSearch) {
        if (_this.searchResults.length > 0) {
          var searchResults = _this.searchResults;
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = _this.myGoodsList[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var _v2 = _step18.value;
              var _iteratorNormalCompletion19 = true;
              var _didIteratorError19 = false;
              var _iteratorError19 = undefined;

              try {
                for (var _iterator19 = _v2.goods_list[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                  var v1 = _step19.value;
                  var _iteratorNormalCompletion20 = true;
                  var _didIteratorError20 = false;
                  var _iteratorError20 = undefined;

                  try {
                    for (var _iterator20 = searchResults[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                      var s = _step20.value;

                      if (s.gd_code == v1.gd_code) {
                        s = v1;
                      }
                    }
                  } catch (err) {
                    _didIteratorError20 = true;
                    _iteratorError20 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion20 && _iterator20.return) {
                        _iterator20.return();
                      }
                    } finally {
                      if (_didIteratorError20) {
                        throw _iteratorError20;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError19 = true;
                _iteratorError19 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion19 && _iterator19.return) {
                    _iterator19.return();
                  }
                } finally {
                  if (_didIteratorError19) {
                    throw _iteratorError19;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }

          _this.searchResults = searchResults;
        }
      }
    },

    // 展示刷新商品列表
    getGoodsList: function getGoodsList() {
      var _this = this;
      var list = _this.defaultGoodsList; //取默认数据
      if (list.length > 0) {
        //判断购物车中是否有商品
        if (JSON.stringify(_this.cartInfo[_this.shopCode].market) == "{}") {
          //购物车无商品
          //遍历接口返回的商品列表，添加cartNum属性
          for (var g in list) {
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 7) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            var goodsList = list[g].goods_list;
            for (var e in goodsList) {
              goodsList[e].cartNum = 0;
              goodsList[e].cateType = list[g].type;
            }
            list[g].tagNum = 0;
          }
        } else {
          //购物车有商品，则遍历购物车中商品，取出商品id,组成数组
          var goodsCodes = [];
          for (var pa in _this.cartInfo[_this.shopCode].market) {
            goodsCodes.push(pa);
          }

          //判断库存是否还有
          for (var key in _this.cartInfo[_this.shopCode].market) {
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
              for (var _iterator21 = _this.cartInfo[_this.shopCode].market[key][Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                var obj = _step21.value;

                if (obj.stock <= obj.cartNum) {
                  obj.noStock = true; //无库存
                } else {
                  obj.noStock = false; //有库存
                }
              }
            } catch (err) {
              _didIteratorError21 = true;
              _iteratorError21 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }
              } finally {
                if (_didIteratorError21) {
                  throw _iteratorError21;
                }
              }
            }
          }
          //遍历接口返回的商品列表，与商品id
          for (var g in list) {
            list[g].tagNum = 0;
            //侧边栏名字显示字数控制
            if (list[g].tag_name.length > 6) {
              list[g].tag_name_short = list[g].tag_name.substring(0, 7) + "...";
            } else {
              list[g].tag_name_short = list[g].tag_name;
            }
            var goodsList = list[g].goods_list;
            if (goodsList && goodsList.length) {
              var _iteratorNormalCompletion22 = true;
              var _didIteratorError22 = false;
              var _iteratorError22 = undefined;

              try {
                for (var _iterator22 = goodsList[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                  var item = _step22.value;

                  item.cateType = list[g].type;
                  if (item.is_single_spec == 1) {
                    //单规格商品
                    if (goodsCodes.indexOf(item.sku_list[0].sku_id) >= 0) {
                      var cartNum = 0; // 已有该商品id
                      var _iteratorNormalCompletion23 = true;
                      var _didIteratorError23 = false;
                      var _iteratorError23 = undefined;

                      try {
                        for (var _iterator23 = _this.cartInfo[_this.shopCode].market[item.sku_list[0].sku_id][Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                          var _obj6 = _step23.value;

                          cartNum += _obj6.cartNum;
                        }
                      } catch (err) {
                        _didIteratorError23 = true;
                        _iteratorError23 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion23 && _iterator23.return) {
                            _iterator23.return();
                          }
                        } finally {
                          if (_didIteratorError23) {
                            throw _iteratorError23;
                          }
                        }
                      }

                      item.cartNum = cartNum;
                    } else {
                      // 无该商品id
                      item.cartNum = 0;
                    }
                  } else {
                    //多规格商品
                    var _cartNum4 = 0;
                    var _iteratorNormalCompletion24 = true;
                    var _didIteratorError24 = false;
                    var _iteratorError24 = undefined;

                    try {
                      for (var _iterator24 = item.sku_list[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                        var _obj7 = _step24.value;

                        if (goodsCodes.indexOf(_obj7.sku_id) >= 0) {
                          var _iteratorNormalCompletion25 = true;
                          var _didIteratorError25 = false;
                          var _iteratorError25 = undefined;

                          try {
                            for (var _iterator25 = _this.cartInfo[_this.shopCode].market[_obj7.sku_id][Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                              var obj2 = _step25.value;

                              _cartNum4 += obj2.cartNum;
                            }
                          } catch (err) {
                            _didIteratorError25 = true;
                            _iteratorError25 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion25 && _iterator25.return) {
                                _iterator25.return();
                              }
                            } finally {
                              if (_didIteratorError25) {
                                throw _iteratorError25;
                              }
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError24 = true;
                      _iteratorError24 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion24 && _iterator24.return) {
                          _iterator24.return();
                        }
                      } finally {
                        if (_didIteratorError24) {
                          throw _iteratorError24;
                        }
                      }
                    }

                    item.cartNum = _cartNum4;
                  }
                  list[g].tagNum += item.cartNum;
                }
              } catch (err) {
                _didIteratorError22 = true;
                _iteratorError22 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion22 && _iterator22.return) {
                    _iterator22.return();
                  }
                } finally {
                  if (_didIteratorError22) {
                    throw _iteratorError22;
                  }
                }
              }
            }
          }
        }
      }
      _this.goodsList = list;
      setTimeout(function () {
        if (_this.gdCode) {
          _this.goToGood();
        }
      }, 500);
      if (_this.flag) {
        _this.$nextTick(function () {

          _this.flag = false;

          // 页面渲染完成后，计算页面元素高度
          var height = window.innerHeight;
          var botHeight = document.getElementsByTagName('footer')[0].clientHeight;
          var navBox = document.getElementById("scrollBox");
          var goodList = document.getElementById("goodList");
          var topAreaHeight = document.getElementById("topArea").scrollHeight;
          var checkTab = document.getElementById("checkTab").scrollHeight;
          var navBoxChild = navBox.children;
          var scroller = document.getElementById("scroller");
          var textChild = scroller.children;

          //默认第一个tab高亮
          if (navBoxChild.length > 0) {
            for (var k = 1; k < navBoxChild.length; k++) {
              navBoxChild[k].className = "";
            }
            navBoxChild[0].className = "active";
          }

          //给页面最底部的ul加最小高度，保证页面能滚动到相应位置
          goodList.style.height = height - botHeight - topAreaHeight - checkTab + 'px';
          if (textChild.length > 0) {
            scroller.lastChild.style.minHeight = height - topAreaHeight - botHeight - checkTab + 'px';
          }

          myScroll = new __WEBPACK_IMPORTED_MODULE_3__assets_js_iscroll_probe_js___default.a('#goodList', {
            bounce: false,
            mouseWheel: true,
            // preventDefault: false,//（把这句加上去哦）
            preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|SPAN|A|DIV)$/ }, //（这个后面加|A,因为iscroll阻止了A的默认事件）
            probeType: 3
          });
          _this.flag = false;

          myScroll.on('scroll', function () {
            var scrollTop = Math.abs(this.y);

            //当导航与相应文档接触的时候自动切换
            //method1
            if (scrollTop > 0) {
              for (var i = 0; i < navBoxChild.length; i++) {
                if (scrollTop >= textChild[i].offsetTop) {
                  for (var j = 0; j < navBoxChild.length; j++) {
                    navBoxChild[j].className = "";
                  }
                  navBoxChild[i].className = "active";
                }
              }
            }
          });

          myScroll.on('scrollEnd', function () {
            var scrollTop = Math.abs(this.y);
            //当导航与相应文档接触的时候自动切换
            //method1
            if (scrollTop > 0) {
              for (var i = 0; i < navBoxChild.length; i++) {
                if (scrollTop >= textChild[i].offsetTop) {
                  for (var j = 0; j < navBoxChild.length; j++) {
                    navBoxChild[j].className = "";
                  }
                  navBoxChild[i].className = "active";
                }
              }
            }
          });
        });
      }
      // 同步搜索
      if (_this.showShopSearch) {
        if (_this.searchResults.length > 0) {
          var searchResults = _this.searchResults;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = _this.goodsList[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var v = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = v.goods_list[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var v1 = _step27.value;
                  var _iteratorNormalCompletion28 = true;
                  var _didIteratorError28 = false;
                  var _iteratorError28 = undefined;

                  try {
                    for (var _iterator28 = searchResults[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                      var s = _step28.value;

                      if (s.gd_code == v1.gd_code) {
                        s = v1;
                      }
                    }
                  } catch (err) {
                    _didIteratorError28 = true;
                    _iteratorError28 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion28 && _iterator28.return) {
                        _iterator28.return();
                      }
                    } finally {
                      if (_didIteratorError28) {
                        throw _iteratorError28;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }

          _this.searchResults = searchResults;
        }
      }
    },
    // 获取店铺评价
    getBusinessCommentList: function getBusinessCommentList() {
      var _this = this;
      _this.goodList = [];
      _this.badList = [];
      var params = {
        supplierId: _this.shopCode,
        pageNo: 1,
        pageSize: 10
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getBusinessCommentList(_this, params, function (data) {
        _this.CommentNum = data.total;
        _this.businessCommentList = data.list;
        for (var i = 0; i < _this.businessCommentList.length; i++) {
          _this.businessCommentList[i].goodList = [];
          _this.businessCommentList[i].badList = [];
          for (var m = 0; m < _this.businessCommentList[i].goodsMarkList.length; m++) {
            if (_this.businessCommentList[i].goodsMarkList[m].goodsScore == 2) {
              _this.businessCommentList[i].goodList.push(_this.businessCommentList[i].goodsMarkList[m].goodsName);
            } else if (_this.businessCommentList[i].goodsMarkList[m].goodsScore == 1) {
              _this.businessCommentList[i].badList.push(_this.businessCommentList[i].goodsMarkList[m].goodsName);
            }
          }
        }
      });
    },
    // 计算总价
    getTotalPrice: function getTotalPrice() {
      var _this = this;
      var cartInfo = _this.cartInfo;
      var market = _this.cartInfo[_this.shopCode].market;
      var totalPrice = 0; //商品总价
      var activeGoods = []; //初始化购物车中所有活动商品数组
      var orderNumList = [];
      var originPrice = 0; //商品总原价
      var totalPackFee = 0; // 打包费
      var packFeeDetail = [];
      _this.hasSpecial = false; //购物车是否有特价商品：true是有
      _this.reductionAmount = '';
      _this.nextFullReductionAmount = 0;
      _this.nextFullReductionAmountGap = '';
      _this.activeGoodsNum = 0; //初始化购物车中活动商品的数量
      _this.activeGoodsArray = [];

      for (var key in market) {
        var _iteratorNormalCompletion29 = true;
        var _didIteratorError29 = false;
        var _iteratorError29 = undefined;

        try {
          for (var _iterator29 = market[key][Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
            var item = _step29.value;

            if (item.activityId > 0) {
              orderNumList.push(item.orderNum);
              var obj = {};
              obj.gdName = item.gdName;
              obj.activityId = item.activityId;
              obj.sku_id = item.sku_id;
              obj.goodsNum = item.goodsNum; //商品限购数量
              obj.leftNum = item.leftNum;
              obj.cartNum = item.cartNum;
              obj.orderNum = item.orderNum;
              obj.priceGap = (parseFloat(item.salePrice) - parseFloat(item.activePrice)).toFixed(2);
              if (item.attrIdArr) {
                obj.attr_id = item.attrIdArr.join("-");
              }
              activeGoods.push(obj); //活动商品组
              _this.activeGoodsNum += item.cartNum;

              var exist = 0;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = _this.activeGoodsArray[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var v = _step30.value;

                  if (v.activityId == item.activityId) {
                    exist++;
                    v.activityNums += item.cartNum;
                    v.orderNum = Math.min(v.orderNum, item.orderNum);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }

              if (exist == 0) {
                _this.activeGoodsArray.push({
                  activityId: item.activityId,
                  activityNums: item.cartNum,
                  orderNum: item.orderNum
                });
              }
            }
            item.activeBuyNum = 0;
          }
        } catch (err) {
          _didIteratorError29 = true;
          _iteratorError29 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion29 && _iterator29.return) {
              _iterator29.return();
            }
          } finally {
            if (_didIteratorError29) {
              throw _iteratorError29;
            }
          }
        }
      }
      // console.log(_this.activeGoodsArray)
      // 同一个店铺支持多种活动
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = _this.activeGoodsArray[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var _v3 = _step31.value;

          if (_v3.orderNum) {
            if (_v3.activityNums <= _v3.orderNum) {
              for (var key in market) {
                var _iteratorNormalCompletion37 = true;
                var _didIteratorError37 = false;
                var _iteratorError37 = undefined;

                try {
                  for (var _iterator37 = market[key][Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                    var _item6 = _step37.value;

                    if (_item6.activityId > 0 && _item6.activityId == _v3.activityId) {
                      //是特价商品
                      var _activeBuyNum = void 0;
                      var _buyNum = _item6.cartNum; //单个商品购买数量
                      var _leftNum = _item6.leftNum; //活动商品剩余库存
                      var _goodsNum = _item6.goodsNum; //活动商品限购数量
                      var _minNum = Math.min(_leftNum, _goodsNum); //单个商品中活动价能够购买数量
                      if (_buyNum <= _minNum) {
                        _activeBuyNum = _buyNum;
                      } else {
                        _activeBuyNum = _minNum;
                      }
                      _item6.activeBuyNum = _activeBuyNum;
                    }
                  }
                } catch (err) {
                  _didIteratorError37 = true;
                  _iteratorError37 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion37 && _iterator37.return) {
                      _iterator37.return();
                    }
                  } finally {
                    if (_didIteratorError37) {
                      throw _iteratorError37;
                    }
                  }
                }
              }
            } else {
              var array = [];
              var _iteratorNormalCompletion38 = true;
              var _didIteratorError38 = false;
              var _iteratorError38 = undefined;

              try {
                for (var _iterator38 = activeGoods[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                  var v1 = _step38.value;

                  if (_v3.activityId == v1.activityId) {
                    array.push(v1);
                  }
                }
                // 活动商品数量大于订单限制,给活动商品的价格做排序，取最优值
              } catch (err) {
                _didIteratorError38 = true;
                _iteratorError38 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion38 && _iterator38.return) {
                    _iterator38.return();
                  }
                } finally {
                  if (_didIteratorError38) {
                    throw _iteratorError38;
                  }
                }
              }

              var sortActiveGoodsList = array.sort(_this.compare);
              sortActiveGoodsList.reverse();
              // 按排序好的活动商品按照各个限制，重新做区分，分成活动价和非活动价
              var leftOrderNum = _v3.orderNum; // 剩余活动订单限购数量
              for (var i = 0; i < sortActiveGoodsList.length; i++) {
                if (leftOrderNum > 0) {
                  var activeBuyNum;
                  var buyNum = sortActiveGoodsList[i].cartNum; //单个商品购买数量
                  var leftNum = sortActiveGoodsList[i].leftNum; //活动商品剩余库存
                  var goodsNum = sortActiveGoodsList[i].goodsNum; //活动商品限购数量
                  var minNum = Math.min(leftNum, goodsNum, leftOrderNum); //单个商品中活动价能够购买数量
                  if (buyNum <= minNum) {
                    activeBuyNum = buyNum;
                  } else {
                    activeBuyNum = minNum;
                  }
                  leftOrderNum = leftOrderNum - activeBuyNum; // 去掉该商品活动数量后，剩余活动订单限购数量
                  // 遍历购物车，给该id商品加属性activeBuyNum
                  for (var m in market) {
                    var _iteratorNormalCompletion39 = true;
                    var _didIteratorError39 = false;
                    var _iteratorError39 = undefined;

                    try {
                      for (var _iterator39 = market[m][Symbol.iterator](), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
                        var _item7 = _step39.value;

                        // item.attr_id = item.attrIdArr.join("-")
                        if (_item7.attrIdArr) {
                          _item7.attr_id = _item7.attrIdArr.join("-");
                          if (sortActiveGoodsList[i].sku_id == _item7.sku_id && _item7.attr_id == sortActiveGoodsList[i].attr_id) {
                            _item7.activeBuyNum = activeBuyNum;
                          }
                        } else {
                          if (sortActiveGoodsList[i].sku_id == _item7.sku_id) {
                            _item7.activeBuyNum = activeBuyNum;
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError39 = true;
                      _iteratorError39 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion39 && _iterator39.return) {
                          _iterator39.return();
                        }
                      } finally {
                        if (_didIteratorError39) {
                          throw _iteratorError39;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        // if (orderNumList.length > 0) { //有订单限购的情况下
        //   _this.orderNum = Math.min.apply(null, orderNumList); //取最小值订单限制
        //   if (_this.activeGoodsNum <= _this.orderNum) {
        //     //判断活动商品数量在订单限制以内
        //     for (var key in market) {
        //       for (let item of market[key]) {
        //         if (item.activityId > 0) { //是特价商品
        //           var activeBuyNum;
        //           var buyNum = item.cartNum; //单个商品购买数量
        //           var leftNum = item.leftNum; //活动商品剩余库存
        //           var goodsNum = item.goodsNum; //活动商品限购数量
        //           var minNum = Math.min(leftNum, goodsNum); //单个商品中活动价能够购买数量
        //           if (buyNum <= minNum) {
        //             activeBuyNum = buyNum
        //           } else {
        //             activeBuyNum = minNum
        //           }
        //           item.activeBuyNum = activeBuyNum
        //         }
        //       }
        //
        //     }
        //   } else {
        //     // 活动商品数量大于订单限制,给活动商品的价格做排序，取最优值
        //     let sortActiveGoodsList = activeGoods.sort(_this.compare)
        //     sortActiveGoodsList.reverse()
        //     //按排序好的活动商品按照各个限制，重新做区分，分成活动价和非活动价
        //     var leftOrderNum = _this.orderNum; // 剩余活动订单限购数量
        //     for (var i = 0; i < sortActiveGoodsList.length; i++) {
        //       if (leftOrderNum > 0) {
        //         var activeBuyNum;
        //         var buyNum = sortActiveGoodsList[i].cartNum; //单个商品购买数量
        //         var leftNum = sortActiveGoodsList[i].leftNum; //活动商品剩余库存
        //         var goodsNum = sortActiveGoodsList[i].goodsNum; //活动商品限购数量
        //         var minNum = Math.min(leftNum, goodsNum, leftOrderNum); //单个商品中活动价能够购买数量
        //         if (buyNum <= minNum) {
        //           activeBuyNum = buyNum
        //         } else {
        //           activeBuyNum = minNum
        //         }
        //         leftOrderNum = leftOrderNum - activeBuyNum; // 去掉该商品活动数量后，剩余活动订单限购数量
        //         // 遍历购物车，给该id商品加属性activeBuyNum
        //         for (var m in market) {
        //           for (let item of market[m]) {
        //             // item.attr_id = item.attrIdArr.join("-")
        //             if (item.attrIdArr) {
        //               item.attr_id = item.attrIdArr.join("-")
        //               if (sortActiveGoodsList[i].sku_id == item.sku_id && item.attr_id == sortActiveGoodsList[i].attr_id) {
        //                 item.activeBuyNum = activeBuyNum
        //               }
        //             } else {
        //               if (sortActiveGoodsList[i].sku_id == item.sku_id) {
        //                 item.activeBuyNum = activeBuyNum
        //               }
        //             }
        //
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
        // 遍历新的购物车，计算价格
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      var chooseCatesTemp = [];
      for (var g in market) {
        var _iteratorNormalCompletion32 = true;
        var _didIteratorError32 = false;
        var _iteratorError32 = undefined;

        try {
          for (var _iterator32 = market[g][Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
            var _item4 = _step32.value;

            var singleTotalPrice, singleOriginPrice, singlePackFee; //单个商品现总价和原总价
            if (_item4.activeBuyNum > 0) {
              //购物车中有活动商品
              _this.hasSpecial = true;
              singleTotalPrice = (_item4.activePrice * _item4.activeBuyNum + _item4.salePrice * (_item4.cartNum - _item4.activeBuyNum)).toFixed(2);
            } else {
              //无活动商品
              singleTotalPrice = (_item4.salePrice * _item4.cartNum).toFixed(2);
            }
            singleOriginPrice = (_item4.salePrice * _item4.cartNum).toFixed(2); //单个折扣商品的总原价
            _item4.singleTotalPrice = singleTotalPrice;
            _item4.singleOriginPrice = singleOriginPrice;
            totalPrice += parseFloat(singleTotalPrice); // 商品总价
            originPrice += parseFloat(singleOriginPrice); // 商品总原价

            if (_item4.packing_fee && _item4.packing_fee_rule) {
              var n = 0;
              var _iteratorNormalCompletion33 = true;
              var _didIteratorError33 = false;
              var _iteratorError33 = undefined;

              try {
                for (var _iterator33 = packFeeDetail[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                  var _v4 = _step33.value;

                  if (_v4.gd_code == _item4.gd_code) {
                    _v4.cartNum = _v4.cartNum + _item4.cartNum;
                    n++;
                  }
                }
              } catch (err) {
                _didIteratorError33 = true;
                _iteratorError33 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion33 && _iterator33.return) {
                    _iterator33.return();
                  }
                } finally {
                  if (_didIteratorError33) {
                    throw _iteratorError33;
                  }
                }
              }

              if (n == 0) {
                packFeeDetail.push({
                  gd_code: _item4.gd_code,
                  title: _item4.gdName,
                  subTitle: '每' + _item4.packing_fee_rule + '份收' + _item4.packing_fee + '元',
                  cartNum: _item4.cartNum,
                  packing_fee_rule: _item4.packing_fee_rule,
                  packing_fee: _item4.packing_fee
                });
              }
            }
            // 判断每个分类是否包含必点商品
            if (_item4.cateType == 1) {
              if (chooseCatesTemp.indexOf(_item4.tag_id1) == -1) {
                chooseCatesTemp.push(_item4.tag_id1);
              }
            }
          }
        } catch (err) {
          _didIteratorError32 = true;
          _iteratorError32 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion32 && _iterator32.return) {
              _iterator32.return();
            }
          } finally {
            if (_didIteratorError32) {
              throw _iteratorError32;
            }
          }
        }
      }
      // 打包费说明
      if (packFeeDetail.length > 0) {
        var _iteratorNormalCompletion34 = true;
        var _didIteratorError34 = false;
        var _iteratorError34 = undefined;

        try {
          for (var _iterator34 = packFeeDetail[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
            var _v5 = _step34.value;

            var value = void 0;
            if (_v5.cartNum > _v5.packing_fee_rule) {
              value = Math.ceil(_v5.cartNum / _v5.packing_fee_rule) * parseFloat(_v5.packing_fee);
            } else {
              value = parseFloat(_v5.packing_fee);
            }
            totalPackFee += parseFloat(value); // 打包费总价
            _v5.value = '¥' + value.toFixed(2) + '元';
          }
        } catch (err) {
          _didIteratorError34 = true;
          _iteratorError34 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion34 && _iterator34.return) {
              _iterator34.return();
            }
          } finally {
            if (_didIteratorError34) {
              throw _iteratorError34;
            }
          }
        }

        packFeeDetail.push({ title: '小计', value: '¥' + totalPackFee.toFixed(2) + '元' });
        var packingFeeDetail = {
          title: "打包费说明",
          value: {
            description: _this.shopDetail.packing_fee_notice,
            packingFeeDetail: packFeeDetail
          }
        };
        localStorage.setItem('packingFeeDetail', JSON.stringify(packingFeeDetail));
      }

      if (totalPackFee > 0) {
        totalPrice = parseFloat(totalPrice) + parseFloat(totalPackFee);
        originPrice = parseFloat(originPrice) + parseFloat(totalPackFee);
      }
      if (_this.needChooseCatesIds.sort().toString() == chooseCatesTemp.sort().toString()) {
        _this.hasNeedChoose = true;
      } else {
        _this.hasNeedChoose = false;
      }

      var reductionAmount = void 0;
      reductionAmount = (parseFloat(originPrice) - parseFloat(totalPrice)).toFixed(2); //已减多少元
      if (parseInt(reductionAmount) == reductionAmount) {
        _this.reductionAmount = parseInt(reductionAmount);
      } else {
        _this.reductionAmount = reductionAmount;
      }

      // 满减活动
      var fullReductionAmount = {},
          nextFullReduction = []; //满足(满减金额，减去金额),不满足(满减金额，差额)
      if (_this.shopDetail.promotion_reduce && _this.shopDetail.promotion_reduce.reduce_info.length > 0) {
        //该商铺有满减活动
        if (!_this.hasSpecial) {
          //购物车无特价商品
          var _iteratorNormalCompletion35 = true;
          var _didIteratorError35 = false;
          var _iteratorError35 = undefined;

          try {
            for (var _iterator35 = _this.shopDetail.promotion_reduce.reduce_info[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
              var _item5 = _step35.value;

              if (parseFloat(totalPrice) - parseFloat(_item5.meet_price) >= 0) {
                var _obj8 = {
                  meet_price: _item5.meet_price,
                  cut_price: _item5.cut_price
                };
                fullReductionAmount = _extends({}, _obj8);
              } else {
                var _obj9 = {
                  meet_price: _item5.meet_price,
                  cut_price: _item5.cut_price,
                  gap: (parseFloat(_item5.meet_price) - parseFloat(totalPrice)).toFixed(2)
                };
                nextFullReduction.push(_obj9);
              }
            }
          } catch (err) {
            _didIteratorError35 = true;
            _iteratorError35 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion35 && _iterator35.return) {
                _iterator35.return();
              }
            } finally {
              if (_didIteratorError35) {
                throw _iteratorError35;
              }
            }
          }

          if (fullReductionAmount.cut_price && fullReductionAmount.cut_price > 0) {
            _this.reductionAmount = fullReductionAmount.cut_price; //已减
            totalPrice = parseFloat(totalPrice) - parseFloat(fullReductionAmount.cut_price); //满减之后金额
          }

          if (nextFullReduction.length > 0) {
            _this.nextFullReductionAmount = nextFullReduction[0].cut_price; //下一满减金额
            if (parseInt(nextFullReduction[0].gap) == nextFullReduction[0].gap) {
              _this.nextFullReductionAmountGap = parseInt(nextFullReduction[0].gap); //距下一满减金额差额
            } else {
              _this.nextFullReductionAmountGap = nextFullReduction[0].gap; //距下一满减金额差额
            }
          }
        }
      }

      // 购物车展示数据格式处理
      var cartArr = [];
      for (var _m in cartInfo[_this.shopCode].market) {
        var _iteratorNormalCompletion36 = true;
        var _didIteratorError36 = false;
        var _iteratorError36 = undefined;

        try {
          for (var _iterator36 = cartInfo[_this.shopCode].market[_m][Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
            var _obj10 = _step36.value;

            if (_obj10.cartNum > 0) {
              cartArr.push(_obj10);
              // console.log(obj)
            }
          }
        } catch (err) {
          _didIteratorError36 = true;
          _iteratorError36 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion36 && _iterator36.return) {
              _iterator36.return();
            }
          } finally {
            if (_didIteratorError36) {
              throw _iteratorError36;
            }
          }
        }
      }
      _this.shopCartInfo = cartArr;

      cartInfo[_this.shopCode].amount = totalPrice.toFixed(2); //计算后的总金额
      cartInfo[_this.shopCode].originAmount = originPrice.toFixed(2); //计算后的原价总金额
      cartInfo[_this.shopCode].packFee = totalPackFee.toFixed(2); //计算后的打包费总金额
      _this.cartAmount = cartInfo[_this.shopCode].amount;
      _this.cartOriginAmount = cartInfo[_this.shopCode].originAmount;
      _this.spreadPrice = (parseFloat(_this.thresholdAmount) - parseFloat(totalPrice)).toFixed(2); //起送价和总价差值
      _this.$store.commit('changeCartInfo', cartInfo); //更新购物车总价信息
    },
    // 增加商品
    addGoods: function addGoods(e) {
      var _this = this;
      var num = null;
      _this.shopCartInfo.forEach(function (item) {
        if (e.gdName == item.gdName || e.goods_name == item.gdName) {
          num = num + item.cartNum;
        }
      });
      // 更改商品列表展示,整理goods字段信息
      if (e.restriction_type && num >= e.restriction_num) {
        //每单限购商品
        this.$toast({
          message: '此商品仅限购买' + e.restriction_num + '件哦!',
          duration: 1500
        });
        return;
      }
      if (e.smallNumber && e.smallNumber > e.stock) {
        //每单限购商品
        this.$toast({
          message: '库存不足!',
          duration: 1500
        });
        return;
      }
      // 判断加料属性
      if (e.attribute_list) {
        var attribute_list = e.attribute_list;
        var _iteratorNormalCompletion40 = true;
        var _didIteratorError40 = false;
        var _iteratorError40 = undefined;

        try {
          for (var _iterator40 = attribute_list[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
            var attr = _step40.value;
            var _iteratorNormalCompletion41 = true;
            var _didIteratorError41 = false;
            var _iteratorError41 = undefined;

            try {
              for (var _iterator41 = e.attributes[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                var v = _step41.value;

                if (attr.addPrice === 1 && attr.attributeTypeId == v.id) {
                  var len = v.attributeList.length;
                  // 非必选
                  if (attr.mustSelect === 0) {
                    if (attr.maxBuyLimit != -1) {
                      if (len > attr.maxBuyLimit) {
                        this.$toast({
                          message: '[' + attr.attributeTypeName + ']\u6700\u591A\u9009' + attr.maxBuyLimit + '\u4E2A',
                          duration: 1500
                        });
                        return;
                      }
                    }
                  } else {
                    if (attr.minBuyLimit > 1) {
                      if (attr.maxBuyLimit === -1) {
                        if (len < attr.minBuyLimit) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u6700\u5C11\u9009' + attr.minBuyLimit + '\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      } else if (attr.maxBuyLimit == attr.minBuyLimit) {
                        if (len != attr.minBuyLimit) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u53EA\u80FD\u9009' + attr.minBuyLimit + '\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      } else if (attr.maxBuyLimit > attr.minBuyLimit) {
                        if (len < attr.minBuyLimit || len > attr.maxBuyLimit) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u5FC5\u9009' + attr.minBuyLimit + '~' + attr.maxBuyLimit + '\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      }
                    } else {
                      if (attr.maxBuyLimit === -1) {
                        if (len < 1) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u6700\u5C11\u90091\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      } else if (attr.maxBuyLimit === 1) {
                        if (len != 1) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u53EA\u80FD\u90091\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      } else if (attr.maxBuyLimit > 1) {
                        if (len < 1) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u6700\u5C11\u90091\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                        if (len > attr.maxBuyLimit) {
                          this.$toast({
                            message: '[' + attr.attributeTypeName + ']\u6700\u591A\u9009' + attr.maxBuyLimit + '\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError41 = true;
              _iteratorError41 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion41 && _iterator41.return) {
                  _iterator41.return();
                }
              } finally {
                if (_didIteratorError41) {
                  throw _iteratorError41;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError40 = true;
          _iteratorError40 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion40 && _iterator40.return) {
              _iterator40.return();
            }
          } finally {
            if (_didIteratorError40) {
              throw _iteratorError40;
            }
          }
        }
      }

      if (e.is_single_spec == 1) {
        //单规格商品
        e.specifications = e.sku_list[0];
      } else {
        //多规格
        if (e.sku_list.length == 1) {
          e.specifications = e.sku_list[0];
          if (!e.attributes) {
            e.specAttrStr = e.specifications.specification;
          }
        }
      }
      if (e.specifications) {
        e.sku_id = e.specifications.sku_id;
        e.activity_id = e.specifications.activity_id;
        // e.activity_price = e.specifications.activity_price
        e.praise_rate = e.specifications.praise_rate;
        if (!e.sales_price) {
          e.sales_price = e.specifications.sales_price;
        }
        // e.sales_price = e.specifications.sales_price
        e.sales_status = e.specifications.sales_status;
        e.sales_volume = e.specifications.sales_volume;
        e.stock = e.specifications.stock;
        e.specifications = e.specifications;
        e.specification = {
          id: e.specifications.specification_id,
          name: e.specifications.specification
        };
        if (e.activity_id > 0) {
          e.num_per_goods = e.specifications.num_per_goods;
          e.num_per_order = e.specifications.num_per_order;
          e.left_stock = e.specifications.left_stock;
          e.activity_desc = e.specifications.activity_desc;
        }
      }

      if (e.attributes) {
        //有属性
        var arr = [];
        var _iteratorNormalCompletion42 = true;
        var _didIteratorError42 = false;
        var _iteratorError42 = undefined;

        try {
          for (var _iterator42 = e.attributes[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
            var item = _step42.value;

            arr.push(item.id);
            var _iteratorNormalCompletion43 = true;
            var _didIteratorError43 = false;
            var _iteratorError43 = undefined;

            try {
              for (var _iterator43 = item.attributeList[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
                var obj = _step43.value;

                arr.push(obj.id);
              }
            } catch (err) {
              _didIteratorError43 = true;
              _iteratorError43 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion43 && _iterator43.return) {
                  _iterator43.return();
                }
              } finally {
                if (_didIteratorError43) {
                  throw _iteratorError43;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError42 = true;
          _iteratorError42 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion42 && _iterator42.return) {
              _iterator42.return();
            }
          } finally {
            if (_didIteratorError42) {
              throw _iteratorError42;
            }
          }
        }

        e.attrIdArr = arr;
      }
      if (e.specification) {
        var goodsList = [];
        if (_this.req_type) {
          goodsList = _this.myGoodsList;
        } else {
          goodsList = _this.goodsList;
        }
        for (var key in goodsList) {
          var goodList = goodsList[key].goods_list;
          if (goodList.length > 0) {
            for (var m in goodList) {
              if (e.sku_id == goodList[m].sku_id && e.tag_id == goodList[m].tag_id) {
                goodList[m].cartNum += 1;
                e.cartNum = goodList[m].cartNum;
              }
            }
          }
        }
      }
      _this.goodsDetail = _extends({}, e);
      //更改购物车存储数据
      var cartInfo = _this.cartInfo;

      //判断库存是否还有
      for (var key in cartInfo[_this.shopCode].market) {
        if (key == e.sku_id) {
          var _iteratorNormalCompletion44 = true;
          var _didIteratorError44 = false;
          var _iteratorError44 = undefined;

          try {
            for (var _iterator44 = cartInfo[_this.shopCode].market[key][Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
              var _obj11 = _step44.value;

              if (_obj11.stock > _obj11.cartNum) {
                _obj11.noStock = false; //有库存
              } else {
                _obj11.noStock = true; //无库存
                _this.$toast('该商品库存为' + _obj11.stock + '件，下单可能会出现异常，请重新选择');
              }
            }
          } catch (err) {
            _didIteratorError44 = true;
            _iteratorError44 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion44 && _iterator44.return) {
                _iterator44.return();
              }
            } finally {
              if (_didIteratorError44) {
                throw _iteratorError44;
              }
            }
          }
        }
      }
      // 判断cartInfo中是否有这个商品
      if (cartInfo[_this.shopCode].market.hasOwnProperty(e.sku_id)) {
        // 已有该商品sku_id
        if (e.attrIdArr) {
          //有属性
          var attrList = [];
          var _iteratorNormalCompletion45 = true;
          var _didIteratorError45 = false;
          var _iteratorError45 = undefined;

          try {
            for (var _iterator45 = cartInfo[_this.shopCode].market[e.sku_id][Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
              var _item8 = _step45.value;

              attrList.push(JSON.stringify(_item8.attrIdArr));
            }
          } catch (err) {
            _didIteratorError45 = true;
            _iteratorError45 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion45 && _iterator45.return) {
                _iterator45.return();
              }
            } finally {
              if (_didIteratorError45) {
                throw _iteratorError45;
              }
            }
          }

          if (attrList.indexOf(JSON.stringify(e.attrIdArr)) >= 0) {
            //有相同属性的商品
            var _iteratorNormalCompletion46 = true;
            var _didIteratorError46 = false;
            var _iteratorError46 = undefined;

            try {
              for (var _iterator46 = cartInfo[_this.shopCode].market[e.sku_id][Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
                var _item9 = _step46.value;

                if (_item9.attrIdArr.toString() == e.attrIdArr.toString()) {
                  _item9.cartNum += 1;
                }
              }
            } catch (err) {
              _didIteratorError46 = true;
              _iteratorError46 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion46 && _iterator46.return) {
                  _iterator46.return();
                }
              } finally {
                if (_didIteratorError46) {
                  throw _iteratorError46;
                }
              }
            }
          } else {
            //无相同属性的商品
            // console.log('in')
            // console.log(e)
            var goodsId = e.sku_id;
            var goodsInfo = {
              gdName: e.goods_name,
              gd_code: e.gd_code,
              sku_id: e.sku_id,
              is_single_spec: e.is_single_spec,
              sku_list: e.sku_list,
              salePrice: e.sales_price,
              activePrice: e.activity_price,
              activityId: e.activity_id,
              cartNum: e.smallNumber ? e.smallNumber : 1,
              specification: e.specification, //规格
              original_tag_id: e.original_tag_id,
              specifications: e.specifications,
              stock: e.stock,
              restriction_type: e.restriction_type,
              restriction_num: e.restriction_num,
              tag_id1: e.original_tag_id,
              cateType: e.cateType,
              smallNumber: e.smallNumber,
              packing_fee: e.packing_fee,
              packing_fee_rule: e.packing_fee_rule
            };
            if (e.activity_id > 0) {
              goodsInfo.goodsNum = e.num_per_goods;
              goodsInfo.orderNum = e.num_per_order;
              goodsInfo.leftNum = e.left_stock;
            }
            if (e.attributes) {
              goodsInfo.attributes = e.attributes; //属性
              goodsInfo.attrIdArr = e.attrIdArr; //属性id数组
            }
            goodsInfo.specAttrStr = e.specAttrStr; //规格属性拼接字符串
            cartInfo[_this.shopCode].market[goodsId].push(goodsInfo);
          }
        } else {
          //无属性
          for (var _key in cartInfo[_this.shopCode].market) {
            var _iteratorNormalCompletion47 = true;
            var _didIteratorError47 = false;
            var _iteratorError47 = undefined;

            try {
              for (var _iterator47 = cartInfo[_this.shopCode].market[_key][Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
                var _item10 = _step47.value;

                if (_item10.sku_id == e.sku_id) {
                  _item10.cartNum += 1;
                }
              }
            } catch (err) {
              _didIteratorError47 = true;
              _iteratorError47 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion47 && _iterator47.return) {
                  _iterator47.return();
                }
              } finally {
                if (_didIteratorError47) {
                  throw _iteratorError47;
                }
              }
            }
          }
        }
      } else {
        var goodsId = e.sku_id;
        var goodsInfo = [{
          gdName: e.goods_name,
          gd_code: e.gd_code,
          sku_id: e.sku_id,
          is_single_spec: e.is_single_spec,
          sku_list: e.sku_list,
          salePrice: e.sales_price,
          activePrice: e.activity_price,
          activityId: e.activity_id,
          cartNum: e.smallNumber ? e.smallNumber : 1,
          specification: e.specification, //规格
          original_tag_id: e.original_tag_id,
          specifications: e.specifications,
          stock: e.stock,
          restriction_type: e.restriction_type,
          restriction_num: e.restriction_num,
          tag_id1: e.original_tag_id,
          cateType: e.cateType,
          smallNumber: e.smallNumber,
          packing_fee: e.packing_fee,
          packing_fee_rule: e.packing_fee_rule
        }];
        if (e.activity_id > 0) {
          goodsInfo[0].goodsNum = e.num_per_goods;
          goodsInfo[0].orderNum = e.num_per_order;
          goodsInfo[0].leftNum = e.left_stock;
        }
        if (e.attributes) {
          goodsInfo[0].attributes = e.attributes; //属性
          goodsInfo[0].attrIdArr = e.attrIdArr; //属性id数组
        }
        goodsInfo[0].specAttrStr = e.specAttrStr; //规格属性拼接字符串
        cartInfo[_this.shopCode].market[goodsId] = goodsInfo;
      }

      cartInfo[_this.shopCode].total = parseInt(cartInfo[_this.shopCode].total) + 1;

      _this.cartTotal = cartInfo[_this.shopCode].total;

      //更新超市下的购物车信息
      if (_this.cartInfo[_this.shopCode].total) {
        _this.isFromSupperPage = true;
        _this.isClickSupperTag = true;
        var data = Object.values(cartInfo[_this.shopCode].market);
        var brr = new Map();
        for (var i = 0; i < data.length; i++) {
          var _iteratorNormalCompletion48 = true;
          var _didIteratorError48 = false;
          var _iteratorError48 = undefined;

          try {
            for (var _iterator48 = data[i][Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
              var _item11 = _step48.value;

              if (brr.has(_item11.tag_id1)) {
                var _num = brr.get(_item11.tag_id1) + _item11.cartNum;
                brr.set(_item11.tag_id1, _num);
              } else {
                brr.set(_item11.tag_id1, _item11.cartNum);
              }
            }
          } catch (err) {
            _didIteratorError48 = true;
            _iteratorError48 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion48 && _iterator48.return) {
                _iterator48.return();
              }
            } finally {
              if (_didIteratorError48) {
                throw _iteratorError48;
              }
            }
          }
        }
        _this.cartInfoTags = brr;
      }
      //更新购物车商品信息
      _this.$store.commit('changeCartInfo', cartInfo);
      //计算购物车商品总价
      _this.getTotalPrice();
      if (_this.shopDetail.req_type) {
        _this.getGoodsList1();
      } else {
        _this.getGoodsList();
      }
      _this.propSpecInfo = false; //多规格弹框

      //判断该商品是否为特价 折扣商品
      if (e.activity_id > 0) {
        //判断购物车中活动商品数量是否超过订单限购数量
        var activityNums = 0;
        var _iteratorNormalCompletion49 = true;
        var _didIteratorError49 = false;
        var _iteratorError49 = undefined;

        try {
          for (var _iterator49 = _this.activeGoodsArray[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
            var _v6 = _step49.value;

            if (_v6.activityId == e.activity_id) {
              activityNums = _v6.activityNums;
            }
          }
        } catch (err) {
          _didIteratorError49 = true;
          _iteratorError49 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion49 && _iterator49.return) {
              _iterator49.return();
            }
          } finally {
            if (_didIteratorError49) {
              throw _iteratorError49;
            }
          }
        }

        if (activityNums == e.num_per_order + 1) {
          _this.$toast('每单最多享受' + e.num_per_order + '份特价折扣，超出部分为您恢复原价');
          return;
        }
        for (var key in cartInfo[_this.shopCode].market) {
          var list = cartInfo[_this.shopCode].market[key];
          var _iteratorNormalCompletion50 = true;
          var _didIteratorError50 = false;
          var _iteratorError50 = undefined;

          try {
            for (var _iterator50 = list[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
              var _v7 = _step50.value;

              if (_v7.sku_id == e.sku_id) {
                //判断购物车中该商品数量是否超出特价剩余数量
                if (_v7.cartNum == _v7.leftNum + 1) {
                  _this.$toast('特价折扣商品剩余0份，已原价购买');
                  return;
                }
                //判断购物车中该商品数量是否超出特价限购数量
                if (_v7.cartNum == _v7.goodsNum + 1) {
                  _this.$toast('特价折扣商品限购' + e.num_per_goods + '份，超出部分为您恢复原价');
                  return;
                }
              }
            }
          } catch (err) {
            _didIteratorError50 = true;
            _iteratorError50 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion50 && _iterator50.return) {
                _iterator50.return();
              }
            } finally {
              if (_didIteratorError50) {
                throw _iteratorError50;
              }
            }
          }
        }
      }
    },
    // 删减商品
    minusGoods: function minusGoods(e) {
      var _this = this;
      if (e.is_single_spec == 1) {
        //单规格
        e.sku_id = e.sku_list[0].sku_id;
      } else {
        if (e.activity_id > 0 && e.sku_list && e.sku_list.length == 1) {
          e.sku_id = e.sku_list[0].sku_id;
        }
      }
      var goodsList = [];
      if (_this.req_type) {
        goodsList = _this.myGoodsList;
      } else {
        goodsList = _this.goodsList;
      }

      for (var key in goodsList) {
        var goodList = goodsList[key].goods_list;
        if (goodList.length > 0) {
          var _iteratorNormalCompletion51 = true;
          var _didIteratorError51 = false;
          var _iteratorError51 = undefined;

          try {
            for (var _iterator51 = goodList[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
              var item = _step51.value;
              var _iteratorNormalCompletion52 = true;
              var _didIteratorError52 = false;
              var _iteratorError52 = undefined;

              try {
                for (var _iterator52 = item.sku_list[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
                  var obj = _step52.value;

                  if (obj.sku_id == e.sku_id) {
                    if (obj.smallNumber) {
                      if (item.cartNum - 1 < obj.smallNumber) {
                        item.cartNum = 0;
                      } else {
                        item.cartNum -= 1;
                      }
                    } else {
                      if (item.cartNum > 0) {
                        item.cartNum -= 1;
                      } else {
                        item.cartNum = 0;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError52 = true;
                _iteratorError52 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion52 && _iterator52.return) {
                    _iterator52.return();
                  }
                } finally {
                  if (_didIteratorError52) {
                    throw _iteratorError52;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError51 = true;
            _iteratorError51 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion51 && _iterator51.return) {
                _iterator51.return();
              }
            } finally {
              if (_didIteratorError51) {
                throw _iteratorError51;
              }
            }
          }
        }
      }
      // 更新购物车数据
      var cartInfo = _this.cartInfo;
      for (var m in cartInfo[_this.shopCode].market[e.sku_id]) {
        if (e.attrIdArr) {
          if (e.attrIdArr.toString() == cartInfo[_this.shopCode].market[e.sku_id][m].attrIdArr.toString()) {
            cartInfo[_this.shopCode].market[e.sku_id][m].cartNum -= 1;
            if (e.smallNumber && cartInfo[_this.shopCode].market[e.sku_id][m].cartNum < e.smallNumber) {
              cartInfo[_this.shopCode].market[e.sku_id][m].cartNum = 0;
            }
          }
        } else {
          cartInfo[_this.shopCode].market[e.sku_id][m].cartNum -= 1;
          if (e.smallNumber && cartInfo[_this.shopCode].market[e.sku_id][m].cartNum < e.smallNumber) {
            cartInfo[_this.shopCode].market[e.sku_id][m].cartNum = 0;
          }
        }
        if (cartInfo[_this.shopCode].market[e.sku_id][m].cartNum == 0) {
          cartInfo[_this.shopCode].market[e.sku_id].splice(m, 1);
        }
        if (cartInfo[_this.shopCode].market[e.sku_id].length == 0) {
          delete cartInfo[_this.shopCode].market[e.sku_id];
        }
      }
      if (cartInfo[_this.shopCode].total > 0) {
        cartInfo[_this.shopCode].total -= 1;
      }
      if (cartInfo[_this.shopCode].total == 0) {
        _this.propShow = false;
      }

      _this.cartTotal = cartInfo[_this.shopCode].total;
      //更新超市下的购物车信息
      if (_this.cartInfo[_this.shopCode].total) {
        _this.isFromSupperPage = true;
        _this.isClickSupperTag = true;
        var data = Object.values(_this.cartInfo[_this.shopCode].market);
        var arr = new Map();
        for (var i = 0; i < data.length; i++) {
          var _iteratorNormalCompletion53 = true;
          var _didIteratorError53 = false;
          var _iteratorError53 = undefined;

          try {
            for (var _iterator53 = data[i][Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
              var _item12 = _step53.value;

              if (arr.has(_item12.tag_id1)) {
                var num = arr.get(_item12.tag_id1) + _item12.cartNum;
                arr.set(_item12.tag_id1, num);
              } else {
                arr.set(_item12.tag_id1, _item12.cartNum);
              }
            }
          } catch (err) {
            _didIteratorError53 = true;
            _iteratorError53 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion53 && _iterator53.return) {
                _iterator53.return();
              }
            } finally {
              if (_didIteratorError53) {
                throw _iteratorError53;
              }
            }
          }
        }
        _this.cartInfoTags = arr;
      }
      _this.$store.commit('changeCartInfo', cartInfo);
      _this.getTotalPrice();
      if (_this.shopDetail.req_type) {
        _this.getGoodsList1();
      } else {
        _this.getGoodsList();
      }
    },
    clearCart: function clearCart() {
      var _this = this;
      var cartInfo = _this.cartInfo;
      cartInfo[_this.shopCode] = {
        total: 0,
        amount: 0,
        market: {}
      };
      _this.$store.commit('changeCartInfo', cartInfo);
      if (_this.shopDetail.req_type) {
        _this.getGoodsList1();
      } else {
        _this.getGoodsList();
      }
      _this.cartTotal = 0;
      _this.propShow = !_this.propShow;
      _this.reductionAmount = ''; //已减金额
      _this.nextFullReductionAmount = ''; //下一满减金额
      _this.nextFullReductionAmountGap = ''; //距下一满减金额差额
      _this.shopCartInfo = [];
    },
    toggleProp: function toggleProp(e, item) {
      //item为_this.goodsDetail
      var _this = this;
      _this.attributes = [];
      if (e == 'cart') {
        _this.propShow = !_this.propShow;
      } else if (e == 'shopInfo') {
        _this.propShopInfo = !_this.propShopInfo;
      } else if (e == 'goodInfo') {
        _this.propGoodInfo = !_this.propGoodInfo;
        _this.goodsDetail = item;
      } else if (e == 'specInfo') {
        _this.propSpecInfo = !_this.propSpecInfo;
        if (_this.propSpecInfo) {
          _this.propGoodInfo = false;
        }
        if (item) {
          _this.goodsDetail = item;
          var first_spec = _this.goodsDetail.sku_list.find(function (obj) {
            //找出第一个符合条件的规格
            if (obj.is_can_choose == 1) {
              return obj;
            }
          });
          if (_this.goodsDetail.sku_list) {
            var _iteratorNormalCompletion54 = true;
            var _didIteratorError54 = false;
            var _iteratorError54 = undefined;

            try {
              for (var _iterator54 = _this.goodsDetail.sku_list[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
                var obj = _step54.value;

                if (obj.sku_id == first_spec.sku_id) {
                  obj.is_selected = 1;
                  _this.goodsDetail.specifications = obj;
                } else {
                  obj.is_selected = 0;
                }
              }
            } catch (err) {
              _didIteratorError54 = true;
              _iteratorError54 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion54 && _iterator54.return) {
                  _iterator54.return();
                }
              } finally {
                if (_didIteratorError54) {
                  throw _iteratorError54;
                }
              }
            }
          }
          if (_this.goodsDetail.attribute_list) {
            //有属性 每个属性的第一个值作为默认选项
            var _iteratorNormalCompletion55 = true;
            var _didIteratorError55 = false;
            var _iteratorError55 = undefined;

            try {
              for (var _iterator55 = item.attribute_list[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
                var _obj12 = _step55.value;

                if (_obj12.addPrice === 0) {
                  for (var n in _obj12.attributeList) {
                    if (n == 0) {
                      var attributeParams = {
                        id: _obj12.attributeTypeId,
                        name: _obj12.attributeTypeName,
                        attributeList: [{
                          id: _obj12.attributeList[n].id,
                          name: _obj12.attributeList[n].name
                        }]
                      };
                      _this.attributes.push(attributeParams); //属性
                      _obj12.attributeList[n].is_selected = 1; //选中
                    } else {
                      _obj12.attributeList[n].is_selected = 0;
                    }
                  }
                } else {
                  // 是否必须提示
                  var selectTips = '';
                  if (_obj12.mustSelect === 1) {
                    // 必选
                    if (_obj12.minBuyLimit > 1) {
                      if (_obj12.maxBuyLimit === -1) {
                        // 不限
                        selectTips = '\u5FC5\u9009\uFF0C\u6700\u5C11\u9009' + _obj12.minBuyLimit;
                      }
                      if (_obj12.maxBuyLimit == _obj12.minBuyLimit) {
                        selectTips = '\u5FC5\u9009' + _obj12.minBuyLimit + '\u4E2A';
                      }
                      if (_obj12.maxBuyLimit > _obj12.minBuyLimit) {
                        selectTips = '\u53EF\u9009' + _obj12.minBuyLimit + '~' + _obj12.maxBuyLimit + '\u4E2A';
                      }
                    } else {
                      // 不限或1
                      if (_obj12.maxBuyLimit === -1) {
                        // 最多选不限
                        selectTips = '必选，最少选1个';
                      }
                      if (_obj12.maxBuyLimit === 1) {
                        // 最多选不限
                        selectTips = '必选1个';
                      }
                      if (_obj12.maxBuyLimit > 1) {
                        // 最多选不限
                        selectTips = '\u5FC5\u9009\uFF0C\u6700\u591A\u9009' + _obj12.maxBuyLimit + '\u4E2A';
                      }
                    }
                  } else {
                    if (_obj12.minBuyLimit === -1) {
                      if (_obj12.maxBuyLimit === -1) {
                        selectTips = '非必选';
                      } else {
                        selectTips = '\u975E\u5FC5\u9009\uFF0C\u6700\u591A\u9009' + _obj12.maxBuyLimit + '\u4E2A';
                      }
                    }
                  }
                  _obj12.selectTips = selectTips;
                  for (var _n in _obj12.attributeList) {
                    _obj12.attributeList[_n].is_selected = 0;
                  }
                  var _attributeParams = {
                    id: _obj12.attributeTypeId,
                    name: _obj12.attributeTypeName,
                    attributeList: []
                  };
                  _this.attributes.push(_attributeParams); //属性
                }
              }
            } catch (err) {
              _didIteratorError55 = true;
              _iteratorError55 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion55 && _iterator55.return) {
                  _iterator55.return();
                }
              } finally {
                if (_didIteratorError55) {
                  throw _iteratorError55;
                }
              }
            }

            _this.goodsDetail.attributes = _this.attributes;
          }

          if (_this.goodsDetail.specifications.specification && _this.goodsDetail.attributes) {
            var AttrStr = [];
            var _iteratorNormalCompletion56 = true;
            var _didIteratorError56 = false;
            var _iteratorError56 = undefined;

            try {
              for (var _iterator56 = _this.goodsDetail.attributes[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
                var item2 = _step56.value;
                var _iteratorNormalCompletion57 = true;
                var _didIteratorError57 = false;
                var _iteratorError57 = undefined;

                try {
                  for (var _iterator57 = item2.attributeList[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
                    var item3 = _step57.value;

                    AttrStr.push(item3.name);
                  }
                } catch (err) {
                  _didIteratorError57 = true;
                  _iteratorError57 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion57 && _iterator57.return) {
                      _iterator57.return();
                    }
                  } finally {
                    if (_didIteratorError57) {
                      throw _iteratorError57;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError56 = true;
              _iteratorError56 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion56 && _iterator56.return) {
                  _iterator56.return();
                }
              } finally {
                if (_didIteratorError56) {
                  throw _iteratorError56;
                }
              }
            }

            _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification + '/' + AttrStr.join('/');
          } else if (!_this.goodsDetail.specifications.specification && _this.goodsDetail.attributes) {
            var _AttrStr = [];
            var _iteratorNormalCompletion58 = true;
            var _didIteratorError58 = false;
            var _iteratorError58 = undefined;

            try {
              for (var _iterator58 = _this.goodsDetail.attributes[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
                var _item13 = _step58.value;
                var _iteratorNormalCompletion59 = true;
                var _didIteratorError59 = false;
                var _iteratorError59 = undefined;

                try {
                  for (var _iterator59 = _item13.attributeList[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
                    var _item14 = _step59.value;

                    _AttrStr.push(_item14.name);
                  }
                } catch (err) {
                  _didIteratorError59 = true;
                  _iteratorError59 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion59 && _iterator59.return) {
                      _iterator59.return();
                    }
                  } finally {
                    if (_didIteratorError59) {
                      throw _iteratorError59;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError58 = true;
              _iteratorError58 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion58 && _iterator58.return) {
                  _iterator58.return();
                }
              } finally {
                if (_didIteratorError58) {
                  throw _iteratorError58;
                }
              }
            }

            _this.goodsDetail.specAttrStr = _AttrStr.join('/');
          } else if (_this.goodsDetail.specifications.specification && !_this.goodsDetail.attributes) {
            _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification;
          }
          _this.goodsDetail.activity_price = _this.goodsDetail.specifications.activity_price;
          _this.goodsDetail.sales_price = _this.goodsDetail.specifications.sales_price;
        }
      }
    },
    // 切换规格属性操作
    handleSelect: function handleSelect(type, item, parent) {
      var _this = this;
      _this.$forceUpdate();
      if (type == 'spec') {
        //选择规格
        if (item.is_can_choose == 1) {
          var _iteratorNormalCompletion60 = true;
          var _didIteratorError60 = false;
          var _iteratorError60 = undefined;

          try {
            for (var _iterator60 = _this.goodsDetail.sku_list[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
              var _obj13 = _step60.value;

              if (_obj13.sku_id == item.sku_id) {
                _this.$set(_obj13, 'is_selected', 1); //选中值
                _this.$set(_this.goodsDetail, 'specifications', _obj13); //规格
                _this.getGoodPrice();
              } else {
                _this.$set(_obj13, 'is_selected', 0);
              }
            }
          } catch (err) {
            _didIteratorError60 = true;
            _iteratorError60 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion60 && _iterator60.return) {
                _iterator60.return();
              }
            } finally {
              if (_didIteratorError60) {
                throw _iteratorError60;
              }
            }
          }
        }
      } else if (type == 'attr') {
        //选择属性
        var _iteratorNormalCompletion61 = true;
        var _didIteratorError61 = false;
        var _iteratorError61 = undefined;

        try {
          for (var _iterator61 = _this.goodsDetail.attribute_list[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
            var obj = _step61.value;

            if (obj.attributeTypeId == parent.attributeTypeId) {
              var _iteratorNormalCompletion62 = true;
              var _didIteratorError62 = false;
              var _iteratorError62 = undefined;

              try {
                for (var _iterator62 = obj.attributeList[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
                  var obj2 = _step62.value;

                  if (parent.addPrice === 0) {
                    if (obj2.id == item.id) {
                      _this.$set(obj2, 'is_selected', 1); //选中值
                      var _iteratorNormalCompletion63 = true;
                      var _didIteratorError63 = false;
                      var _iteratorError63 = undefined;

                      try {
                        for (var _iterator63 = _this.goodsDetail.attributes[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
                          var obj3 = _step63.value;

                          if (obj3.id == parent.attributeTypeId) {
                            obj3.attributeList[0] = {
                              id: obj2.id,
                              name: obj2.name
                            };
                          }
                        }
                      } catch (err) {
                        _didIteratorError63 = true;
                        _iteratorError63 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion63 && _iterator63.return) {
                            _iterator63.return();
                          }
                        } finally {
                          if (_didIteratorError63) {
                            throw _iteratorError63;
                          }
                        }
                      }
                    } else {
                      _this.$set(obj2, 'is_selected', 0);
                    }
                  } else {
                    // 加料属性
                    if (item.saleStatus == 1) {
                      if (item.is_selected === 0 && _this.goodsDetail.attributes && _this.goodsDetail.attributes.length > 0) {
                        var arr = _this.goodsDetail.attributes.filter(function (attrItem) {
                          return attrItem.id == parent.attributeTypeId;
                        });
                        if (arr && arr.length > 0 && arr[0].attributeList.length == parent.maxBuyLimit) {
                          this.$toast({
                            message: '[' + parent.attributeTypeName + ']\u6700\u591A\u9009' + parent.maxBuyLimit + '\u4E2A',
                            duration: 1500
                          });
                          return;
                        }
                      }
                      if (obj2.id == item.id) {
                        var is_selected = 1 - obj2.is_selected;
                        _this.$set(obj2, 'is_selected', is_selected);
                        var _iteratorNormalCompletion64 = true;
                        var _didIteratorError64 = false;
                        var _iteratorError64 = undefined;

                        try {
                          for (var _iterator64 = _this.goodsDetail.attributes[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
                            var obj3 = _step64.value;

                            if (obj3.id == parent.attributeTypeId) {
                              if (is_selected == 1) {
                                obj3.attributeList.push({
                                  id: obj2.id,
                                  name: obj2.name,
                                  salePrice: obj2.salePrice,
                                  costPrice: obj2.costPrice,
                                  skuCode: obj2.skuCode
                                });
                              } else {
                                var index = 0;
                                for (var i = 0; i < obj3.attributeList.length; i++) {
                                  if (obj3.attributeList[i] == obj2.id) {
                                    index = i;
                                  }
                                }
                                obj3.attributeList.splice(index, 1);
                              }
                            }
                          }
                        } catch (err) {
                          _didIteratorError64 = true;
                          _iteratorError64 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion64 && _iterator64.return) {
                              _iterator64.return();
                            }
                          } finally {
                            if (_didIteratorError64) {
                              throw _iteratorError64;
                            }
                          }
                        }

                        _this.getGoodPrice();
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError62 = true;
                _iteratorError62 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion62 && _iterator62.return) {
                    _iterator62.return();
                  }
                } finally {
                  if (_didIteratorError62) {
                    throw _iteratorError62;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError61 = true;
          _iteratorError61 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion61 && _iterator61.return) {
              _iterator61.return();
            }
          } finally {
            if (_didIteratorError61) {
              throw _iteratorError61;
            }
          }
        }
      }

      if (_this.goodsDetail.attribute_list && _this.goodsDetail.attribute_list.length > 0) {
        _this.attributes = _this.goodsDetail.attributes;
        var AttrStr = [];
        var _iteratorNormalCompletion65 = true;
        var _didIteratorError65 = false;
        var _iteratorError65 = undefined;

        try {
          for (var _iterator65 = _this.attributes[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
            var item2 = _step65.value;
            var _iteratorNormalCompletion66 = true;
            var _didIteratorError66 = false;
            var _iteratorError66 = undefined;

            try {
              for (var _iterator66 = item2.attributeList[Symbol.iterator](), _step66; !(_iteratorNormalCompletion66 = (_step66 = _iterator66.next()).done); _iteratorNormalCompletion66 = true) {
                var item3 = _step66.value;

                AttrStr.push(item3.name);
              }
            } catch (err) {
              _didIteratorError66 = true;
              _iteratorError66 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion66 && _iterator66.return) {
                  _iterator66.return();
                }
              } finally {
                if (_didIteratorError66) {
                  throw _iteratorError66;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError65 = true;
          _iteratorError65 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion65 && _iterator65.return) {
              _iterator65.return();
            }
          } finally {
            if (_didIteratorError65) {
              throw _iteratorError65;
            }
          }
        }

        if (_this.goodsDetail.specifications.specification) {
          _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification + '/' + AttrStr.join('/');
        } else {
          _this.goodsDetail.specAttrStr = AttrStr.join('/');
        }
      } else {
        if (_this.goodsDetail.specifications.specification) {
          _this.goodsDetail.specAttrStr = _this.goodsDetail.specifications.specification;
        }
      }
    },

    // 计算多规格商品价格
    getGoodPrice: function getGoodPrice() {
      var salePrice = this.goodsDetail.specifications.sales_price;
      var activityPrice = this.goodsDetail.specifications.activity_price;
      if (this.goodsDetail.attributes) {
        var _iteratorNormalCompletion67 = true;
        var _didIteratorError67 = false;
        var _iteratorError67 = undefined;

        try {
          for (var _iterator67 = this.goodsDetail.attributes[Symbol.iterator](), _step67; !(_iteratorNormalCompletion67 = (_step67 = _iterator67.next()).done); _iteratorNormalCompletion67 = true) {
            var v1 = _step67.value;
            var _iteratorNormalCompletion68 = true;
            var _didIteratorError68 = false;
            var _iteratorError68 = undefined;

            try {
              for (var _iterator68 = v1.attributeList[Symbol.iterator](), _step68; !(_iteratorNormalCompletion68 = (_step68 = _iterator68.next()).done); _iteratorNormalCompletion68 = true) {
                var v2 = _step68.value;

                if (v2.salePrice) {
                  salePrice = (parseFloat(salePrice) + parseFloat(v2.salePrice)).toFixed(2);
                  activityPrice = (parseFloat(activityPrice) + parseFloat(v2.salePrice)).toFixed(2);
                }
              }
            } catch (err) {
              _didIteratorError68 = true;
              _iteratorError68 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion68 && _iterator68.return) {
                  _iterator68.return();
                }
              } finally {
                if (_didIteratorError68) {
                  throw _iteratorError68;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError67 = true;
          _iteratorError67 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion67 && _iterator67.return) {
              _iterator67.return();
            }
          } finally {
            if (_didIteratorError67) {
              throw _iteratorError67;
            }
          }
        }
      }
      this.goodsDetail.sales_price = salePrice;
      this.goodsDetail.activity_price = activityPrice;
    },


    compare: function compare(obj1, obj2) {
      return obj1.priceGap - obj2.priceGap;
    },
    // 获取用户默认地址
    postDefaultAddress: function postDefaultAddress(resolve) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postDefaultAddress(_this, { school_id: this.$store.state.schoolInfo.schoolId }, function (data) {
        // 未设置默认地址的时候，返回的是最新地址
        if (data && data.mp) {
          var mp_real = _this.$utils.Decrypt(data.mp_encryption);

          if (!window.localStorage.getItem('selfTakeMp') || window.localStorage.getItem('selfTakeMp') == 'undefined' || window.localStorage.getItem('selfTakeMp') == 'null') {
            // window.localStorage.setItem('selfTakeMp', data.mp)
            window.localStorage.setItem('selfTakeMp', mp_real);
          } else {
            var selfTakeMp = window.localStorage.getItem('selfTakeMp');
            if (selfTakeMp.indexOf('*') >= 0) {
              window.localStorage.setItem('selfTakeMp', mp_real);
            }
          }
          if (_this.shopDetail.is_self_take_new == 1) {
            //仅自提店铺
            resolve(window.localStorage.getItem('selfTakeMp'));
          } else {
            resolve(mp_real);
          }
          window.localStorage.setItem('chooseAddress', JSON.stringify(data));
        } else {
          window.localStorage.removeItem("chooseAddress");
          if (!window.localStorage.getItem('selfTakeMp') || window.localStorage.getItem('selfTakeMp') == 'undefined' || window.localStorage.getItem('selfTakeMp') == 'null') {
            window.localStorage.setItem('selfTakeMp', _this.$store.state.userInfo.mp);
          } else {
            var _selfTakeMp = window.localStorage.getItem('selfTakeMp');
            if (_selfTakeMp.indexOf('*') >= 0) {
              window.localStorage.setItem('selfTakeMp', _this.$store.state.userInfo.mp);
            }
          }
          if (_this.shopDetail.is_self_take_new == 1) {
            //仅自提店铺
            resolve(window.localStorage.getItem('selfTakeMp'));
          } else {
            resolve(_this.$store.state.userInfo.mp);
          }
        }
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },

    //结算
    settleAccounts: function settleAccounts() {
      var _this2 = this;

      new Promise(this.postDefaultAddress).then(function (res) {
        _this2.orderPreview(res);
      });
    },


    // 订单预检
    orderPreview: function orderPreview(mp) {
      var _this = this;
      window.localStorage.removeItem('selectedCoupon');
      window.localStorage.removeItem('date');
      window.localStorage.removeItem('dateList');
      window.localStorage.removeItem('couponList');
      window.localStorage.removeItem('orderPreviewInfo');
      window.localStorage.removeItem('order-type');
      window.localStorage.removeItem('canSubmit');
      window.localStorage.removeItem('shop_comment');
      window.localStorage.removeItem('isSelectedCoupon');
      window.localStorage.removeItem('order-type');
      var goods = [];
      var uid = _this.$store.state.wxUid;
      if (uid == "null" || uid == '' || uid == null) {
        //如果没有登录信息先跳转登录页
        // _this.$router.push({name: 'Login'})
        _this.$utils.toLogin(_this);
      } else {
        var market = _this.cartInfo[_this.shopCode].market;
        var chooseCatesIds = [];
        for (var key in market) {
          var _iteratorNormalCompletion69 = true;
          var _didIteratorError69 = false;
          var _iteratorError69 = undefined;

          try {
            for (var _iterator69 = market[key][Symbol.iterator](), _step69; !(_iteratorNormalCompletion69 = (_step69 = _iterator69.next()).done); _iteratorNormalCompletion69 = true) {
              var item = _step69.value;

              var good1 = {},
                  good2 = {}; //good1活动商品 good2原价商品
              if (item.cateType == 1) {
                if (chooseCatesIds.indexOf(item.tag_id1) == -1) {
                  chooseCatesIds.push(item.tag_id1);
                }
              }
              if (item.activeBuyNum > 0) {
                //判断是活动商品
                good1.price = item.activePrice + '';
                good1.original_price = item.salePrice + '';
                good1.number = item.activeBuyNum;
                good1.goods_sale_id = item.sku_id + '';
                if (item.cartNum - item.activeBuyNum > 0) {
                  good2.price = item.salePrice + '';
                  good2.number = item.cartNum - item.activeBuyNum;
                  good2.goods_sale_id = item.sku_id + '';
                  good2.specification = { //规格
                    id: 0,
                    name: ''
                  };
                  if (item.specification.name) {
                    good2.specification.name = item.specification.name;
                  }
                  if (item.specification.id) {
                    good2.specification.id = item.specification.id;
                  }
                  if (item.attributes) {
                    //属性
                    good2.attributes = item.attributes;
                  }
                }
                good1.specification = { //规格
                  id: 0,
                  name: ''
                };
                if (item.specification.name) {
                  good1.specification.name = item.specification.name;
                }
                if (item.specification.id) {
                  good1.specification.id = item.specification.id;
                }
                if (item.attributes) {
                  //属性
                  good1.attributes = item.attributes;
                }
              } else {
                good2.price = item.salePrice + '';
                good2.number = item.cartNum;
                good2.goods_sale_id = item.sku_id + '';
                good2.specification = { //规格
                  id: 0,
                  name: ''
                };
                if (item.specification.name) {
                  good2.specification.name = item.specification.name;
                }
                if (item.specification.id) {
                  good2.specification.id = item.specification.id;
                }
                if (item.attributes) {
                  //属性
                  good2.attributes = item.attributes;
                }
              }
              if (JSON.stringify(good2) != '{}') {
                goods.push(good2);
              }
              if (JSON.stringify(good1) != '{}') {
                goods.push(good1);
              }
            }
          } catch (err) {
            _didIteratorError69 = true;
            _iteratorError69 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion69 && _iterator69.return) {
                _iterator69.return();
              }
            } finally {
              if (_didIteratorError69) {
                throw _iteratorError69;
              }
            }
          }
        }
        // 加价属性
        var _iteratorNormalCompletion70 = true;
        var _didIteratorError70 = false;
        var _iteratorError70 = undefined;

        try {
          for (var _iterator70 = goods[Symbol.iterator](), _step70; !(_iteratorNormalCompletion70 = (_step70 = _iterator70.next()).done); _iteratorNormalCompletion70 = true) {
            var v = _step70.value;

            var attributePrice = 0;
            if (v.attributes && v.attributes.length > 0) {
              var _iteratorNormalCompletion74 = true;
              var _didIteratorError74 = false;
              var _iteratorError74 = undefined;

              try {
                for (var _iterator74 = v.attributes[Symbol.iterator](), _step74; !(_iteratorNormalCompletion74 = (_step74 = _iterator74.next()).done); _iteratorNormalCompletion74 = true) {
                  var v1 = _step74.value;
                  var _iteratorNormalCompletion75 = true;
                  var _didIteratorError75 = false;
                  var _iteratorError75 = undefined;

                  try {
                    for (var _iterator75 = v1.attributeList[Symbol.iterator](), _step75; !(_iteratorNormalCompletion75 = (_step75 = _iterator75.next()).done); _iteratorNormalCompletion75 = true) {
                      var v2 = _step75.value;

                      if (v2.salePrice || v2.salePrice === 0) {
                        attributePrice = (parseFloat(attributePrice) + parseFloat(v2.salePrice)).toFixed(2);
                      }
                    }
                  } catch (err) {
                    _didIteratorError75 = true;
                    _iteratorError75 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion75 && _iterator75.return) {
                        _iterator75.return();
                      }
                    } finally {
                      if (_didIteratorError75) {
                        throw _iteratorError75;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError74 = true;
                _iteratorError74 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion74 && _iterator74.return) {
                    _iterator74.return();
                  }
                } finally {
                  if (_didIteratorError74) {
                    throw _iteratorError74;
                  }
                }
              }
            }
            v.attributePrice = attributePrice;
          }
        } catch (err) {
          _didIteratorError70 = true;
          _iteratorError70 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion70 && _iterator70.return) {
              _iterator70.return();
            }
          } finally {
            if (_didIteratorError70) {
              throw _iteratorError70;
            }
          }
        }

        if (_this.needChooseCates.length > 0) {
          if (chooseCatesIds.length === 0) {
            _this.$messagebox.alert('\u9700\u6DFB\u52A0[' + _this.needChooseCates[0].tag_name + ']\u4E2D\u7684\u5546\u54C1\u624D\u53EF\u4E0B\u5355~', '');
            if (_this.req_type) {
              _this.scrollGoods1(_this.needChooseCates[0]);
            } else {
              _this.scrollGoods(_this.needChooseCates[0]);
            }
            return;
          } else {
            var _iteratorNormalCompletion71 = true;
            var _didIteratorError71 = false;
            var _iteratorError71 = undefined;

            try {
              for (var _iterator71 = _this.needChooseCates[Symbol.iterator](), _step71; !(_iteratorNormalCompletion71 = (_step71 = _iterator71.next()).done); _iteratorNormalCompletion71 = true) {
                var _v8 = _step71.value;

                if (chooseCatesIds.indexOf(_v8.tag_id.toString()) === -1) {
                  _this.$messagebox.alert('\u9700\u6DFB\u52A0[' + _v8.tag_name + ']\u4E2D\u7684\u5546\u54C1\u624D\u53EF\u4E0B\u5355~', '');
                  if (_this.req_type) {
                    _this.scrollGoods1(_v8);
                  } else {
                    _this.scrollGoods(_v8);
                  }
                  return;
                }
              }
            } catch (err) {
              _didIteratorError71 = true;
              _iteratorError71 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion71 && _iterator71.return) {
                  _iterator71.return();
                }
              } finally {
                if (_didIteratorError71) {
                  throw _iteratorError71;
                }
              }
            }
          }
        }
        var params = {
          school_id: _this.schoolInfo.schoolId,
          supplier_id: _this.shopCode,
          supplier_short_name: _this.shopDetail.shop_name,
          goods: goods,
          // client_type: 7,
          orderType: _this.orderType, //1支持自提，0不支持自提,(外送和外送+自提:0,仅自提:1)
          mobile: mp
        };
        // 如果有默认地址，传默认地址经纬度
        var chooseAddress = window.localStorage.getItem('chooseAddress');
        if (chooseAddress) {
          if (JSON.parse(chooseAddress).isLimitFloor) {
            params.buildingId = JSON.parse(chooseAddress).build_id;
            params.building = JSON.parse(chooseAddress).build_name;
            params.floorId = JSON.parse(chooseAddress).floor_id;
            params.floor = JSON.parse(chooseAddress).floor_name;
            params.roomId = JSON.parse(chooseAddress).room_id;
            params.room = JSON.parse(chooseAddress).room_name;
            params.isSelectAddress = 1;
          } else {
            params.isSelectAddress = 1;
            params.address_lng = JSON.parse(chooseAddress).lon;
            params.address_lat = JSON.parse(chooseAddress).lat;
          }
        }
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postOrderPreview(_this, params, function (data) {
          if (data.flag === 1001) {
            _this.$messagebox.alert('商家不存在', '');
            _this.$router.push({ name: 'TagPage' });
          } else if (data.flag === 1002) {
            _this.$messagebox.alert('商品价格信息错误', '');
            return;
          } else if (data.flag === 1003) {
            _this.$messagebox.alert('库存不足', '');
            return;
          } else if (data.flag === 1004) {
            _this.$messagebox.alert('商品已售完', '');
            return;
          } else if (data.flag === 1005) {
            _this.$messagebox.alert('超过限购数量', '');
            return;
          } else if (data.flag === 1007) {
            _this.$messagebox.alert('不满足商家起送价', '');
            return;
          } else if (data.flag === 1008) {
            _this.$messagebox.alert('商家已打烊', '');
            return;
          } else {
            // 商品有更新
            if (data.update_goods && data.update_goods.length > 0) {
              // _this.$messagebox.alert(data.update_goods[0].good_name + data.update_goods[0].message, '')
              _this.changeGoodsInCart = [];
              var update_goods = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.uniqWith(data.update_goods, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual);
              var _iteratorNormalCompletion72 = true;
              var _didIteratorError72 = false;
              var _iteratorError72 = undefined;

              try {
                for (var _iterator72 = update_goods[Symbol.iterator](), _step72; !(_iteratorNormalCompletion72 = (_step72 = _iterator72.next()).done); _iteratorNormalCompletion72 = true) {
                  var _v9 = _step72.value;

                  if (_v9.goods_sale_id) {
                    var _iteratorNormalCompletion73 = true;
                    var _didIteratorError73 = false;
                    var _iteratorError73 = undefined;

                    try {
                      for (var _iterator73 = _this.shopCartInfo[Symbol.iterator](), _step73; !(_iteratorNormalCompletion73 = (_step73 = _iterator73.next()).done); _iteratorNormalCompletion73 = true) {
                        var v1 = _step73.value;

                        if (v1.sku_id == _v9.goods_sale_id) {
                          _this.changeGoodsInCart.push({
                            sku_id: v1.sku_id,
                            name: v1.gdName + (v1.specAttrStr ? '-' + v1.specAttrStr : ''),
                            num: _v9.number,
                            message: _v9.messageBackUp
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError73 = true;
                      _iteratorError73 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion73 && _iterator73.return) {
                          _iterator73.return();
                        }
                      } finally {
                        if (_didIteratorError73) {
                          throw _iteratorError73;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError72 = true;
                _iteratorError72 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion72 && _iterator72.return) {
                    _iterator72.return();
                  }
                } finally {
                  if (_didIteratorError72) {
                    throw _iteratorError72;
                  }
                }
              }

              if (_this.changeGoodsInCart.length > 0) {
                _this.isShowCartGoods = true;
              }
              return;
            }
          }
          var dateList = data.deliveryDateTimeList;
          for (var i = 0; i < dateList.length; i++) {
            if (i === 0) {
              dateList[i].isActive = true;
            } else {
              dateList[i].isActive = false;
            }
          }
          data.deliveryDateTimeList = dateList;
          window.localStorage.setItem('orderPreviewInfo', JSON.stringify(data));
          window.localStorage.setItem('shop_code', _this.shopCode);
          window.localStorage.setItem('shop_name', _this.shopDetail.shop_name);
          window.localStorage.setItem('orderPreviewType', 1);
          window.localStorage.removeItem('hikes');
          _this.$router.push({ name: 'OrderSettle' });
        });
      }
    },
    showOtherInfo: function showOtherInfo(data) {
      var _this = this;
      if (data.image_list.length > 0 || data.content != '') {
        window.localStorage.setItem('otherDetail', JSON.stringify(data));
        _this.$router.push({ 'path': '/otherdetail' });
      } else {
        MessageBox.alert('店铺尚未上传内容', '');
      }
    },
    scrollGoods2: function scrollGoods2(item, index) {
      var title = document.getElementById(item.tag_id) ? document.getElementById(item.tag_id).clientHeight : 0;
      var val = document.getElementById(item.tag_id + 'goods' + index).offsetHeight;
      var y = document.getElementById(item.tag_id).offsetTop + title + val * index;
      if (this.req_type) {
        myScroll1.scrollTo(0, -y, 200);
      } else {
        myScroll.scrollTo(0, -y, 200);
      }
    },
    scrollGoods1: function scrollGoods1(item) {
      var _this3 = this;

      var tag = 0;
      this.myGoodsList.forEach(function (el, index) {
        el.goods_list = [];
        if (el.tag_id == item.tag_id) {
          _this3.myIndex = index;
          tag = el.is_special_tag;
        }
      });
      this.page = 0;
      var navBox = document.getElementById("scrollBox1");
      var navBoxChild = navBox.children;
      navBox.scrollTop = navBoxChild[0].clientHeight * (this.myIndex - 1) - navBox.offsetTop;
      for (var j = 0; j < navBoxChild.length; j++) {
        navBoxChild[j].className = "";
      }
      navBoxChild[this.myIndex].className = "active";
      myScroll1.scrollTo(0, 0, 200);
      this.getShopTagList(0, item.tag_id, tag);
    },
    scrollGoods: function scrollGoods(item) {
      var y = document.getElementById(item.tag_id).offsetTop;
      myScroll.scrollTo(0, -y, 200);
    },
    readyWxshare: function readyWxshare() {
      var _this = this;
      var u = encodeURIComponent(window.location.href.split('#')[0]);
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJsShareConf(this, u, function (data) {
        wx.config({
          debug: false,
          appId: data.data.appId,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        });
        wx.ready(function () {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          var link;
          if (_this.$utils.isWxWork()) {
            link = _this.$utils.getHost() + '/wxWork';
          } else {
            link = _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=goodslist&data=' + encodeURIComponent(JSON.stringify({ 'shopCode': _this.shopCode }));
          }
          _this.$utils.wxShareNew(_this.shopDetail.shop_name, // 分享标题
          link, // 分享链接
          _this.shopDetail.pic, // 分享图标
          '俺来也微信校内订餐平台' // 分享描述
          );
        });
        wx.error(function (res) {
          console.log(res);
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      });
    },

    goToGood: function goToGood() {
      var data = this.goodsList;
      for (var k = 0; k < data.length; k++) {
        for (var v = 0; v < data[k].goods_list.length; v++) {
          if (data[k].goods_list[v].gd_code == this.gdCode) {
            var y = document.getElementById(data[k].tag_name);
            y.scrollIntoView({ behavior: "instant", block: "start" });
            this.scrollGoods2(data[k], v);
          }
        }
      }
    },


    // 店铺优惠券
    getGrantlist: function getGrantlist(n) {
      var _this = this;
      var params = {
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId,
        shop_cate_id: this.shopDetail.shop_cate_id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].shopGrantList(_this, params, function (data) {
        if (data && data.coupon_list && data.coupon_list.length > 0) {
          var _iteratorNormalCompletion76 = true;
          var _didIteratorError76 = false;
          var _iteratorError76 = undefined;

          try {
            for (var _iterator76 = data.coupon_list[Symbol.iterator](), _step76; !(_iteratorNormalCompletion76 = (_step76 = _iterator76.next()).done); _iteratorNormalCompletion76 = true) {
              var v = _step76.value;

              var amount = v.couponAmount;
              var index = String(amount).indexOf(".") + 1; //获取小数点的位置
              if (index > 0) {
                var temp = String(amount).split('.');
                v.decimal = temp[1];
                v.couponAmount = temp[0];
              }
              if (v.couponName && v.couponName.length > 5) {
                v.couponName = v.couponName.substring(0, 5) + '...';
              }
            }
          } catch (err) {
            _didIteratorError76 = true;
            _iteratorError76 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion76 && _iterator76.return) {
                _iterator76.return();
              }
            } finally {
              if (_didIteratorError76) {
                throw _iteratorError76;
              }
            }
          }

          _this.couponInfo = data;
          if (n) {
            _this.couponModalOpened = data.is_toast == 1 ? true : false;
            if (data.is_toast == 1) {
              // console.log(_this.$store.state.wxUid)
              if (_this.$store.state.wxUid) {
                _this.setCouponToast();
              }
            }
          }
        }
        // _this.$toast('领取成功')
      }, function (response) {
        _this.$messagebox.alert(response.message);
        // 响应错误回调
      });
    },

    // 领取店铺优惠券
    receiveCoupon: function receiveCoupon(item) {
      var _this = this;
      if (item.status == 1 || item.status == 2) {
        return;
      }
      var param = {
        coupon_code: item.couponCode,
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].receiveShopGrant(_this, param, function (data) {
        _this.$toast('领取成功');
        _this.getGrantlist();
      }, function (response) {
        _this.$messagebox.alert(response.body.message);
        // 响应错误回调
      });
    },

    // 购买券包
    buyCouponPackage: function buyCouponPackage(item) {
      this.$router.push({ name: 'CouponPackage', query: { id: item.promotion_id } });
      // 埋点
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_shop_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.promotion_id,
        firstValue: this.schoolInfo.schoolId,
        secondValue: this.shopCode
      }];
      this.addLog1(clickParams);
    },

    // 一键领取
    receiveAllCoupons: function receiveAllCoupons(e) {
      e.stopPropagation();
      var _this = this;
      var temp = [];
      var _iteratorNormalCompletion77 = true;
      var _didIteratorError77 = false;
      var _iteratorError77 = undefined;

      try {
        for (var _iterator77 = this.couponInfo.coupon_list[Symbol.iterator](), _step77; !(_iteratorNormalCompletion77 = (_step77 = _iterator77.next()).done); _iteratorNormalCompletion77 = true) {
          var v = _step77.value;

          temp.push(v.couponCode);
        }
      } catch (err) {
        _didIteratorError77 = true;
        _iteratorError77 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion77 && _iterator77.return) {
            _iterator77.return();
          }
        } finally {
          if (_didIteratorError77) {
            throw _iteratorError77;
          }
        }
      }

      var param = {
        coupon_code_list: temp.join(','),
        shop_id: this.shopCode,
        school_id: this.schoolInfo.schoolId
      };
      var params = {
        params: param
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].receiveAllShopGrant(_this, param, function (data) {
        _this.$toast('一键领取成功');
        _this.couponModalOpened = false;
        _this.getGrantlist();
        // _this.setCouponToast();
      });
    },

    // 设置优惠券弹框
    setCouponToast: function setCouponToast() {
      var _this = this;
      var param = {
        shop_id: this.shopCode
      };
      var params = {
        params: param
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].setGrantTotast(_this, param, function (data) {});
    },
    closeCouponModal: function closeCouponModal() {
      this.couponModalOpened = false;
    },
    viewPackDesc: function viewPackDesc() {
      this.$router.push({ name: 'PackingFee' });
    },

    // 店铺内搜索
    toShopSearch: function toShopSearch() {
      this.showShopSearch = true;
      this.keyword = '';
      // this.$refs.keyword.focus();
      this.$nextTick(function () {
        document.getElementById('keyword').focus();
      });
    },
    closeShopSearch: function closeShopSearch() {
      this.showShopSearch = false;
      this.searchResults = [];
    },
    submitShopSearch: function submitShopSearch() {
      if (this.keyword.length === 0) {
        // this.$messagebox.alert('请输入搜索关键字', '')
        return;
      }
      var params = {
        keyword: this.keyword,
        schoolId: this.schoolInfo.schoolId,
        shopCode: this.shopCode,
        display: 1,
        saleStatus: 2
      };
      this.searchResults = [];
      var url = this.$utils.getSpliceHost('search-center') + '/search/priv/goods/in/shop/search';
      var _this = this;
      _this.$http.post(url, params).then(function (response) {
        var res = response.body;
        if (res.data && res.data.goodsResponses && res.data.goodsResponses.length > 0) {
          var goodsResponses = res.data.goodsResponses,
              shopGoods = [],
              searchResults = [];
          if (_this.req_type) {
            shopGoods = _this.myGoodsList;
          } else {
            shopGoods = _this.goodsList;
          }
          var _iteratorNormalCompletion78 = true;
          var _didIteratorError78 = false;
          var _iteratorError78 = undefined;

          try {
            for (var _iterator78 = shopGoods[Symbol.iterator](), _step78; !(_iteratorNormalCompletion78 = (_step78 = _iterator78.next()).done); _iteratorNormalCompletion78 = true) {
              var v1 = _step78.value;

              if (v1.is_special_tag === 0) {
                var _iteratorNormalCompletion79 = true;
                var _didIteratorError79 = false;
                var _iteratorError79 = undefined;

                try {
                  for (var _iterator79 = v1.goods_list[Symbol.iterator](), _step79; !(_iteratorNormalCompletion79 = (_step79 = _iterator79.next()).done); _iteratorNormalCompletion79 = true) {
                    var v2 = _step79.value;
                    var _iteratorNormalCompletion80 = true;
                    var _didIteratorError80 = false;
                    var _iteratorError80 = undefined;

                    try {
                      for (var _iterator80 = goodsResponses[Symbol.iterator](), _step80; !(_iteratorNormalCompletion80 = (_step80 = _iterator80.next()).done); _iteratorNormalCompletion80 = true) {
                        var v = _step80.value;

                        if (v.gdCode === v2.gd_code) {
                          searchResults.push(v2);
                        }
                      }
                    } catch (err) {
                      _didIteratorError80 = true;
                      _iteratorError80 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion80 && _iterator80.return) {
                          _iterator80.return();
                        }
                      } finally {
                        if (_didIteratorError80) {
                          throw _iteratorError80;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError79 = true;
                  _iteratorError79 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion79 && _iterator79.return) {
                      _iterator79.return();
                    }
                  } finally {
                    if (_didIteratorError79) {
                      throw _iteratorError79;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError78 = true;
            _iteratorError78 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion78 && _iterator78.return) {
                _iterator78.return();
              }
            } finally {
              if (_didIteratorError78) {
                throw _iteratorError78;
              }
            }
          }

          if (searchResults.length > 0) {
            _this.searchResults = searchResults;
            _this.iShowSearchNothing = false;
          } else {
            _this.iShowSearchNothing = true;
          }
        } else {
          _this.iShowSearchNothing = true;
        }
      });
    },

    // 统计埋点
    addLog1: function addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    }
  },
  isIos: function isIos() {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'ShopList' || to.name == 'OrderList' || to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    if (this.isIos && !this.$utils.resolveUrl().isShare && document.domain.indexOf('xiyoushi.com') < 0) {
      window.history.replaceState({}, '', this.shopUrl);
    }
    // var u  = encodeURIComponent(window.location.href.split('#')[0]);
    // var _this = this;
    // actions.getJsShareConf(_this,u,function (data) {
    //   let host = _this.$utils.getHost();
    //   wx.config({
    //     debug: false,
    //     appId: data.data.appId,
    //     timestamp: data.data.timestamp,
    //     nonceStr: data.data.nonceStr,
    //     signature: data.data.signature,
    //     jsApiList: data.data.jsApiList
    //   });
    //   wx.ready(function () {
    //     _this.$utils.wx_share(
    //       '【俺来也】校内订餐，暖心服务', // 分享标题
    //       host + '/auth', // 分享链接
    //       host + '/share.png', // 分享图标
    //       '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
    //     );
    //   });
    //   wx.error(function (res) {
    //     // console.log(res)
    //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //   })
    // });

    next();
  },

  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture_vue___default.a,
    CommentStars: __WEBPACK_IMPORTED_MODULE_2__components_CommentStars___default.a
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CommentStars__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      banners: [],
      shopCategoryList: [],
      currentShopList: [],
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      schoolLock: false,
      showPage: false
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'GoodsList' || from.name == 'ShopList') {
      //GoodsList返回时不刷新，
      to.meta.isBack = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  mounted: function mounted() {
    var _this = this;

    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      if (marginBot <= 0) {
        if (_this.hasMore) {
          _this.getShopList();
        }
      }
    };
  },
  activated: function activated() {
    var _this = this;
    document.title = '校内订餐';

    if (!_this.$route.meta.isBack) {
      var school_lock = window.localStorage.getItem('school_lock');
      if (school_lock == '1') {
        _this.schoolLock = true;
      } else {
        _this.schoolLock = false;
      }
      _this.showPage = false;
      _this.banners = [];
      _this.currentPage = 1;
      _this.shopCategoryList = [];
      _this.currentShopList = [];
      document.getElementById('banner1').style.height = '0px';
      _this.getBanner();
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: 1,
        pageSize: 1000
      };
      // 获取店铺分类列表
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postShopCategoryList(_this, params, function (data) {
        if (data && data.length > 0) {
          var list = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var shop = _step.value;

              var obj = {
                backgroundImage: "url(" + shop.icon + ")"
              };
              shop.backgroundimg = obj;
              list.push(shop);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.shopCategoryList = list;
        }
        _this.getShopList();
      });
    }
    _this.$route.meta.isBack = false;
  },

  methods: {
    getBanner: function getBanner() {
      var _this = this;
      var url;
      var host = _this.$utils.getSpliceHost('adsvc');
      //        if(process.env.NODE_ENV=='local'){
      //          host = 'http://adsvc.imcoming.com.cn'
      //        }else if(process.env.NODE_ENV=='development'){
      //          host = 'http://adsvc.imcoming.com.cn'
      //        }else if(process.env.NODE_ENV=='test'){
      //          host = 'http://adsvc.imcoming.com'
      //        }else{
      //          // host = 'https://adsvc.anlaiye.com'
      //          host = 'https://adsvc.anlaiye.com.cn'
      //        }
      url = host + '/ad/app/getList.do';
      // console.log(url)
      var params = {
        app_version: "5.3",
        client_type: 3,
        device_id: "123",
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: "118"
      };
      _this.$http.post(url, params).then(function (response) {
        _this.banners = response.data.data.list;
        if (_this.banners.length > 0) {
          _this.$nextTick(function () {
            var mySwiper = new Swiper('.swiper-container', {
              pagination: '.pagination'
            });
            var bannerWidth = document.body.scrollWidth;
            var bannerHeight = bannerWidth * 8 / 25;
            document.getElementById('banner1').style.height = bannerHeight + 'px';
          });
        }
        // 响应成功回调
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      });
    },
    bannerJump: function bannerJump(data) {
      if (data != '{}') {
        var bannerJump = JSON.parse(data);
        window.location.href = bannerJump.url;
      }
    },
    getShopList: function getShopList() {
      var _this = this;
      _this.hasMore = false;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize
      };
      // 获取当前校区商家列表
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopList(_this, params, function (data) {
        _this.showPage = true;
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var shop = _step2.value;

              var obj = {
                backgroundImage: "url(" + shop.pic + ")"
              };
              shop.backgroundimg = obj;
              shop.isShowAll = false;
              _this.currentShopList.push(shop);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          _this.hasMore = false;
        }
      });
    },
    chooseSchool: function chooseSchool() {
      this.$router.push({ path: '/chooseschool' });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    toSearch: function toSearch() {
      var _this = this;
      _this.$router.push({ name: 'Search' });
    },
    toShopList: function toShopList(id, name) {
      var _this = this;
      var obj = {
        category_code: id,
        category_name: name,
        shopListType: 'category'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'ShopList' });
    },
    toggleShowMore: function toggleShowMore(item) {
      var _this = this;
      for (var key in _this.currentShopList) {
        if (_this.currentShopList[key].id == item.id) {
          _this.currentShopList[key].isShowAll = !_this.currentShopList[key].isShowAll;
        }
      }
    }
  },
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default.a
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox, Indicator} from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      graph_token: '',
      mp: '',
      captcha: '',
      countDown: false,
      time: 60,
      dialogClientX: 0, //弹框距离屏幕左端距离
      beginClientX: 0, //滑块距离屏幕左端距离
      mouseMoveStata: false, //触发拖动状态 判断
      maxWidth: '', //拖动最大宽度，依据滑块宽度算出来的
      confirmSuccess: false, /*验证成功判断*/
      showDrag: false, //二次验证弹框
      hideAly: false // 是否隐藏俺来也相关
    };
  },

  computed: {
    wxToken: function wxToken() {
      return this.$store.state.wxToken;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  mounted: function mounted() {
    // let urlSource = localStorage.getItem('urlSource');
    // if(urlSource && urlSource == 'yjy'){
    //   this.hideAly = true;
    // }
    var _this = this;
    /**
     * 如果有指定学校id
     */
    var url_school_id = _this.$utils.resolveUrl().school_id;
    if (url_school_id) {
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolStatus(_this, { school_id: url_school_id }, function (data) {
        var schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);
      }, function () {
        _this.$messagebox.alert(data.body.message, '');
      });
    } else {
      if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
        // _this.$router.push({path: `/chooseschool`})
      } else {
        _this.$router.push({ path: '/chooseschool' });
        return false;
      }
    }
    this.addLog();
  },

  methods: {
    addLog: function addLog() {
      // 内部统计
      var _this = this;
      var params = {
        logDetails: [{ uid: _this.$store.state.wxUid, code: 'aly_wechat_login', createTime: new Date().getTime(), firstValue: this.$utils.getCookie('UM_distinctid') }]
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        console.log('记录成功');
      }, function (data) {});
    },
    mouseDownFn: function mouseDownFn(e) {
      this.mouseMoveStata = true;
      this.beginClientX = e.changedTouches[0].clientX;
    },
    //按下滑块函数
    mouseMoveFn: function mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        var width = e.changedTouches[0].clientX - this.beginClientX;
        if (width > 0 && width <= this.maxWidth) {
          document.getElementsByClassName('handler')[0].style.left = width / 50 + 'rem';
          document.getElementsByClassName('handler_bg')[0].style.width = (width + 10) / 50 + 'rem';
        } else if (width > this.maxWidth) {
          this.successFunction();
        }
      }
    },
    mouseUpFn: function mouseUpFn(e) {
      this.mouseMoveStata = false;
      var width = e.changedTouches[0].clientX - this.beginClientX;
      if (width < this.maxWidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'rem';
        document.getElementsByClassName('handler_bg')[0].style.width = 0 + 'rem';
      }
    },
    successFunction: function successFunction() {
      this.confirmSuccess = true;
      if (window.addEventListener) {
        document.getElementsByTagName('html')[0].removeEventListener('touchmove', this.mouseMoveFn);
        document.getElementsByTagName('html')[0].removeEventListener('touchend', this.mouseUpFn);
      } else {
        document.getElementsByTagName('html')[0].removeEventListener('touchend', function () {});
      }
      document.getElementsByClassName('handler')[0].style.left = this.maxWidth / 50 + 'rem';
      document.getElementsByClassName('handler_bg')[0].style.width = (this.maxWidth + 10) / 50 + 'rem';
      this.showDrag = false;
      this.postSmsCaptcha();
    },
    //验证成功函数
    onlyNum: function onlyNum() {
      var _this = this;
      var patt = _this.mp.replace(/[^\d]/g, '');
      if (_this.mp != patt) {
        _this.mp = patt;
        _this.$messagebox.alert('只能输入数字', '');
      }
    },
    // 发送短信验证码
    postSmsCaptcha: function postSmsCaptcha() {
      var _this = this;
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入手机号码', '');
        return false;
      }
      var phonereg = /^1[0-9]{10}$/;
      if (!phonereg.test(_this.mp)) {
        _this.$messagebox.alert('请输入正确格式的手机号', '');
        return false;
      }
      var params = {
        graph_token: _this.graph_token,
        // mp: _this.mp,
        mp_encryption: _this.$utils.Encrypt(_this.mp),
        type: '101'
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSendCaptcha(_this, params, function (data) {
        if (data.status == 0) {
          _this.$messagebox.alert('短信已发送成功!请注意查收', '');
          _this.countDownFn();
        } else {
          _this.graph_token = data.graph_token;
          _this.showDrag = true;
          setTimeout(function () {
            _this.dialogClientX = document.getElementsByClassName('drag')[0].offsetLeft;
            _this.maxWidth = document.getElementsByClassName('drag_box')[0].offsetWidth - document.getElementsByClassName('handler')[0].offsetWidth; //能滑动的最大间距
            document.getElementsByTagName('html')[0].addEventListener('touchmove', _this.mouseMoveFn);
            document.getElementsByTagName('html')[0].addEventListener('touchend', _this.mouseUpFn);
          }, 1000);
        }
      });
    },
    // 登录注册
    postSignIn: function postSignIn() {
      var _this = this;
      if (_this.mp === '') {
        _this.$messagebox.alert('请输入手机号码', '');
        return false;
      }
      if (_this.captcha === '') {
        _this.$messagebox.alert('请输入短信验证码', '');
        return false;
      }

      var params = {
        school_id: _this.$store.state.schoolInfo.schoolId,
        captcha: _this.captcha,
        captcha_type: 101,
        mp: _this.mp,
        mp_encryption: _this.$utils.Encrypt(_this.mp),
        // token:'e2fbf9af5cd3373d5de6fb76f61e990e'
        token: _this.$store.state.wxToken,
        client_type: localStorage.getItem('platformType')

        /**
         * 是否是单校区*/
      };var school_lock = window.localStorage.getItem('school_lock');
      if (school_lock == '1') {
        params.ref = 'other_wechat';
      } else {
        params.ref = 'aly_wechat';
      }

      console.log(params);
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSignIn(_this, params, function (data) {
        var openid = _this.$store.state.openId;
        if (data.openid && data.openid != '') {
          openid = data.openid;
        }

        var userInfo = {
          avatar: data.avatar || data.headimgurl,
          nickname: data.nickname,
          mp: data.mp,
          sex: data.sex,
          mp_real: _this.$utils.Decrypt(data.mp_encryption)
        };

        _this.$store.commit('changeUserInfo', userInfo);

        var obj = {
          wxUid: data.uid,
          wxToken: data.token,
          openId: openid,
          wxLoginToken: data.login_token,
          platformType: data.platform_type
        };
        _this.$store.commit('changeState', obj);
        window.localStorage.removeItem('selfTakeMp');
        // 方便二级域名下获取
        _this.$utils.setCookie('alywechatToken', data.login_token);
        if (document.domain.indexOf('xiyoushi.com') >= 0) {
          _this.$router.push({ name: 'TagPage' });
        } else {
          _this.$router.go(-1);
        }
      });
    },
    // 60s倒计时方法
    countDownFn: function countDownFn() {
      var _this = this;
      _this.time = 60;
      function setTime() {
        if (_this.time === 0) {
          _this.countDown = false;
          return false;
        } else {
          _this.countDown = true;
          _this.time--;
        }
        setTimeout(function () {
          setTime();
        }, 1000);
      }
      setTime();
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mapAddr: window.localStorage.getItem('mapAddr'),
      mapPic: window.localStorage.getItem('mapPic')
    };
  },

  // created () {
  //   document.title = "查看地图"
  // },
  methods: {}
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userInfo: {}
    };
  },
  created: function created() {
    this.getLevel();
  },

  methods: {
    getLevel: function getLevel() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getLevel(_this, { uid: localStorage.getItem('wxUid') }, function (data) {
        _this.userInfo = data;
        _this.userInfo.expPecent = data.exp / data.next_level_exp * 100 + '%';
      });
    },
    viewExp: function viewExp() {
      this.$router.push({ name: 'ExpDesc' });
    }
  }

});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CommentStars__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { MessageBox, Toast } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      commentType: window.localStorage.getItem('commentType'),
      orderId: window.localStorage.getItem('orderCode'),
      estimateId: window.localStorage.getItem('estimateId'),
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      commentList: [],
      commentDetail: {}
    };
  },
  created: function created() {
    var _this = this;
    if (_this.commentType == 0) {
      document.title = "评论详情";
    } else if (_this.commentType == 1) {
      document.title = "我的评论";
    }
    _this.getCommentList();

    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      if (marginBot <= 0) {
        if (_this.hasMore) {
          _this.getCommentList();
        }
      }
    };
  },

  methods: {
    getCommentList: function getCommentList() {
      var _this = this;
      _this.hasMore = false;
      if (_this.commentType == 0) {
        //评价详情
        var params = {
          id: _this.estimateId
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCommentDetails(_this, params, function (data) {
          _this.showPage = true;
          _this.commentDetail = data;
          // console.log(_this.commentDetail)
          _this.commentDetail.goodList = [];
          _this.commentDetail.badList = [];
          if (_this.commentDetail.goodsMarkList) {
            if (_this.commentDetail.goodsMarkList.length > 0) {
              for (var m = 0; m < _this.commentDetail.goodsMarkList.length; m++) {
                if (_this.commentDetail.goodsMarkList[m].goodsScore == 2) {
                  _this.commentDetail.goodList.push(_this.commentDetail.goodsMarkList[m].goodsName);
                } else if (_this.commentDetail.goodsMarkList[m].goodsScore == 1) {
                  _this.commentDetail.badList.push(_this.commentDetail.goodsMarkList[m].goodsName);
                }
              }
            }
          }
        });
      } else if (_this.commentType == 1) {
        var params = {
          id: _this.orderId,
          pageSize: _this.pageSize,
          pageNo: _this.currentPage
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCommentList(_this, params, function (data) {
          _this.showPage = true;
          if (data.list.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;

          if (data.list.length > 0) {
            var commentList = data.list;
            for (var i = 0; i < commentList.length; i++) {
              _this.commentList.push(commentList[i]);
            }
            for (var i = 0; i < _this.commentList.length; i++) {
              _this.commentList[i].goodList = [];
              _this.commentList[i].badList = [];
              for (var m = 0; m < _this.commentList[i].goodsMarkList.length; m++) {
                if (_this.commentList[i].goodsMarkList[m].goodsScore == 2) {
                  _this.commentList[i].goodList.push(_this.commentList[i].goodsMarkList[m].goodsName);
                } else if (_this.commentList[i].goodsMarkList[m].goodsScore == 1) {
                  _this.commentList[i].badList.push(_this.commentList[i].goodsMarkList[m].goodsName);
                }
              }
            }
          }
        });
      }
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    deleteComment: function deleteComment(id) {
      var _this = this;
      console.log(id);
      _this.estimateId = id;
      _this.$messagebox.confirm('确认删除这条评价吗', '').then(function (action) {
        var params = {
          estimateId: _this.estimateId
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getDeleteComment(_this, params, function (data) {
          if (data == 1) {
            _this.$toast('评价删除成功');
            _this.currentPage = 1;
            _this.showPage = false;
            _this.commentList = [];
            _this.getCommentList();
            window.localStorage.removeItem('estimateId');
          }
        }, function (data) {
          _this.$messagebox.alert(data.body.message, '');
        });
      }).catch(function () {});
    }
  },
  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a,
    CommentStars: __WEBPACK_IMPORTED_MODULE_2__components_CommentStars___default.a
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      flag: false,
      isShow: true,
      showPage: false,
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      complaitintList: [],
      complainStatus: {
        0: '待处理',
        1: '已受理',
        2: '处理完成',
        3: '已判断',
        9: '已取消'
      }
    };
  },
  created: function created() {
    var _this = this;
    // document.title = "我的投诉"
    _this.getComplaintList();

    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      if (marginBot <= 0) {
        if (_this.hasMore) {
          _this.getComplaintList();
        }
      }
    };
  },

  methods: {
    getComplaintList: function getComplaintList() {
      var _this = this;
      _this.hasMore = false;
      var params = {
        pageSize: _this.pageSize,
        pageNo: _this.currentPage
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getComplaintList(_this, params, function (data) {
        _this.showPage = true;
        if (data.list.length < _this.pageSize) {
          _this.hasMore = false;
        } else {
          _this.hasMore = true;
        }
        _this.currentPage = _this.currentPage + 1;
        if (data.list.length > 0) {
          var complaintList = data.list;
          for (var i = 0; i < complaintList.length; i++) {
            _this.complaitintList.push(complaintList[i]);
          }
        }
        // console.log(_this.complaitintList)
        for (var i = 0; i < _this.complaitintList.length; i++) {
          if (_this.complaitintList[i].goodsList.length > 3) {
            _this.complaitintList[i].goodsList = _this.complaitintList[i].goodsList.slice(0, 3);
            _this.complaitintList[i].omit = true;
          } else {
            _this.complaitintList[i].omit = false;
          }
        }
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      // console.log(id,name)
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    toCheckComplaints: function toCheckComplaints(id) {
      window.localStorage.setItem('processType', 1);
      window.localStorage.setItem('complainId', id);
      this.$router.push({ name: 'CheckComplaints' });
    }
  },
  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox,Toast } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      couponsList: [],
      showTake: true,
      untakeCouponsList: [],
      showUntake: false,
      isShow: true,
      showContent: false,
      redeemCode: "",
      couponPackageList: []
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxLoginToken: function wxLoginToken() {
      return this.$store.state.wxLoginToken;
    },
    openId: function openId() {
      return this.$store.state.openId;
    }
  },
  created: function created() {
    var _this = this;
    // document.title = '我的优惠券'
    _this.getCouponList();
    _this.getOnlineCouponList();
    _this.getCouponPackageList();
  },

  methods: {
    getCouponList: function getCouponList() {
      var _this = this;
      var params2 = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId
      };
      var params = {
        params: params2
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].PostCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            var coupon_property = data[i].coupon_property,
                coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = "\u8D85\u503C\u5238\u5305x" + data[i].package_num + "\u5F20";
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(/(\n|\r|\r\n|↵)/g, "<br/>");
            }
            _this.couponsList.push(data[i]);
          }
        }
        _this.showPage = true;
      });
    },
    getOnlineCouponList: function getOnlineCouponList() {
      var _this = this;
      var params = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId,
        platform: 2
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].PostOnlineCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            var coupon_property = data[i].coupon_property,
                coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = "\u8D85\u503C\u5238\u5305x" + data[i].package_num + "\u5F20";
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(/(\n|\r|\r\n|↵)/g, "<br/>");
            }
            _this.untakeCouponsList.push(data[i]);
          }
        }
        // console.log(_this.untakeCouponsList)
        _this.showContent = true;
      });
    },
    toUseCoupon: function toUseCoupon(item) {
      if (item.coupon_property == 4) {
        if (item.package_shop) {
          this.$router.push({
            name: "CouponPackageShopList",
            query: { shops: item.package_shop.join(',') }
          });
        }
      } else {
        if (item.obtain_shop_id) {
          this.$router.push({
            path: "/goodslist?shopCode=" + item.obtain_shop_id
          });
        } else {
          this.$router.push({ path: "/index" });
        }
      }
    },
    switchStatus: function switchStatus(status) {
      var _this = this;
      if (status === "take") {
        _this.showTake = true;
        _this.showUntake = false;
        _this.isShow = true;
      } else if (status === "untake") {
        _this.showUntake = true;
        _this.showTake = false;
        _this.isShow = false;
      }
    },
    receiveCoupon: function receiveCoupon(coupon) {
      var _this = this;
      _this.showContent = false;
      if (coupon.is_new == 1) {
        var params = {
          user_id: window.localStorage.getItem("wxUid"),
          coupon_code: coupon.code,
          client_type: 3,
          school_id: _this.schoolInfo.schoolId,
          platform: 2
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].receiveCouponNew(_this, params, function (data) {
          _this.$toast("领取成功");
          _this.couponsList = [];
          _this.untakeCouponsList = [];
          _this.showUntake = false;
          _this.getCouponList();
          _this.getOnlineCouponList();
          _this.showUntake = true;
          _this.showTake = false;
          _this.isShow = false;
        }, function (response) {
          _this.$messagebox.alert(response.message);
          // 响应错误回调
        });
      } else {
        var params = _defineProperty({
          user_id: window.localStorage.getItem("wxUid"),
          coupon_id: coupon.coupon_id,
          code: coupon.code,
          school_id: _this.schoolInfo.schoolId,
          client_type: 3
        }, "school_id", _this.schoolInfo.schoolId);
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].receiveCouponOld(_this, params, function (data) {
          _this.$toast("领取成功");
          _this.couponsList = [];
          _this.untakeCouponsList = [];
          _this.showUntake = false;
          _this.getCouponList();
          _this.getOnlineCouponList();
          _this.showUntake = true;
          _this.showTake = false;
          _this.isShow = false;
        }, function (response) {
          _this.$messagebox.alert(response.message);
        });
      }
    },
    redeemCoupon: function redeemCoupon() {
      if (!this.redeemCode || this.redeemCode.length == 0) {
        this.$toast("请输入兑换码");
        return;
      }
      var _this = this;
      var params = {
        redeem_code: this.redeemCode,
        login_token: window.localStorage.getItem("wxLoginToken")
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].redeemCoupon(_this, params, function (response) {
        _this.$toast(response);
        _this.getCouponList();
      }, function (response) {
        _this.$toast(response.data.message);
        // 响应错误回调
      });
    },
    // 券包
    getCouponPackageList: function getCouponPackageList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackageList(_this, params, function (data) {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          // 曝光埋点
          var logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_coupon_bag',
            refId: data[0].package_id,
            createTime: new Date().getTime(),
            firstValue: _this.$store.state.schoolInfo.schoolId
          }];
          _this.addLog(logDetails);
        }
      }, function () {});
    },

    // 购买券包
    buyCouponPackage: function buyCouponPackage(item) {
      if (item.package_status === 0) {
        return;
      }
      this.$router.push({ name: 'CouponPackage', query: { id: item.package_id } });
      // 点击埋点
      var logDetails = [{
        uid: this.$store.state.wxUid,
        code: 'click_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.$store.state.schoolInfo.schoolId
      }];
      this.addLog(logDetails);
    },

    // 统计埋点
    addLog: function addLog(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },
    toDisableCoupon: function toDisableCoupon() {
      this.$router.push({ name: 'myDisableCoupons' });
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox,Toast } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      couponsList: [],
      showTake: true,
      untakeCouponsList: [],
      showUntake: false,
      isShow: true,
      showContent: false,
      redeemCode: "",
      couponPackageList: []
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxLoginToken: function wxLoginToken() {
      return this.$store.state.wxLoginToken;
    },
    openId: function openId() {
      return this.$store.state.openId;
    }
  },
  created: function created() {
    var _this = this;
    // document.title = '我的优惠券'
    _this.getCouponList();
  },

  methods: {
    getCouponList: function getCouponList() {
      var _this = this;
      var params2 = {
        token: _this.wxLoginToken,
        user_id: window.localStorage.getItem("wxUid"),
        school_id: _this.schoolInfo.schoolId,
        need_expire: 1
      };
      var params = {
        params: params2
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].PostCouponList(_this, params, function (data) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].business === 10001 || data[i].business === "10001") {
            var coupon_property = data[i].coupon_property,
                coupon_property_str = "普通优惠";
            switch (coupon_property) {
              case 1:
                coupon_property_str = "普通优惠";
                break;
              case 2:
                coupon_property_str = "会员福利";
                break;
              case 3:
                coupon_property_str = "单单返现";
                break;
              case 4:
                coupon_property_str = "\u8D85\u503C\u5238\u5305x" + data[i].package_num + "\u5F20";
                break;
              case 7:
                coupon_property_str = "配送福利";
                break;
            }
            data[i].showPackageRule = false;
            data[i].coupon_property_str = coupon_property_str;
            if (data[i].package_rule) {
              data[i].package_rule = data[i].package_rule.replace(/(\n|\r|\r\n|↵)/g, "<br/>");
            }
            _this.couponsList.push(data[i]);
          }
        }
        _this.showPage = true;
      });
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
var _name$data$computed$c;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { MessageBox, Indicator,Toast} from 'mint-ui'


/* harmony default export */ __webpack_exports__["default"] = (_name$data$computed$c = {
  name: 'mycomment',
  data: function data() {
    return {
      orderId: window.localStorage.getItem('orderCode'),
      isOk: false,
      isAddShow: true,
      switchbad: [],
      switchgood: [],
      selected: false,
      score: 0,
      complaintList: [],
      remnant: 100,
      mainInfo: {},
      goodsList: [],
      goodsMarkList: [],
      goodsImages: [],
      // canSubmit: false,
      // estimateTemplateList: [],
      comment: '',
      deliveryComment: '',
      qualityScore: 0, // 订单
      packScore: 0, // 包装
      tasteScore: 0, // 味道
      stars: [{
        isShow: true,
        id: 1,
        title: '总体',
        list: [{ id: 1, active: 0 }, { id: 2, active: 0 }, { id: 3, active: 0 }, { id: 4, active: 0 }, { id: 5, active: 0 }],
        desc: ''
      }, {
        isShow: false,
        id: 2,
        title: '口味',
        list: [{ id: 1, active: 0 }, { id: 2, active: 0 }, { id: 3, active: 0 }, { id: 4, active: 0 }, { id: 5, active: 0 }],
        desc: ''
      }, {
        isShow: false,
        id: 3,
        title: '包装',
        list: [{ id: 1, active: 0 }, { id: 2, active: 0 }, { id: 3, active: 0 }, { id: 4, active: 0 }, { id: 5, active: 0 }],
        desc: ''
      }],
      deliveryScores: [{ id: 1, desc: '不满意', score: 85, checked: false }, { id: 2, desc: '满意', score: 100, checked: false }]
    };
  },

  computed: {
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  created: function created() {
    var _this = this;
    document.title = '写点评';
    _this.getOnlineCommentInfo();
  }
}, _defineProperty(_name$data$computed$c, 'computed', {
  //计算属性
  itemClasses: function itemClasses() {
    var result = []; // 返回的是一个数组,用来遍历输出星星
    var integer = this.score;
    for (var i = 0; i < integer; i++) {
      // 整数星星使用on
      result.push("on"); // 一个整数星星就push一个CLS_ON到数组
    }
    while (result.length < 5) {
      // 余下的用无星星补全,使用off
      result.push("off");
    }
    console.log(result);
    return result;
  }
}), _defineProperty(_name$data$computed$c, 'methods', {
  getOnlineCommentInfo: function getOnlineCommentInfo() {
    var _this = this;
    var params = {
      orderId: _this.orderId
    };
    __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOnlineCommentInfo(_this, params, function (data) {
      for (var i = 0; i < data.goodsList.length; i++) {
        data.goodsList[i].scoreType = 0;
      }
      if (data.badDeliveryTemplateList && data.badDeliveryTemplateList.length > 0) {
        for (var i = 0; i < data.badDeliveryTemplateList.length; i++) {
          data.badDeliveryTemplateList[i].checked = false;
        }
      }
      _this.mainInfo = data;
      _this.goodsList = data.goodsList;
      // _this.estimateTemplateList = data.estimateTemplateList
    });
  },
  checkDeliveryScore: function checkDeliveryScore(item) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this.deliveryScores[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var v = _step.value;

        v.checked = false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    item.checked = true;
  },
  checkBadDeliveryTag: function checkBadDeliveryTag(item) {
    item.checked = !item.checked;
  },
  tapStar: function tapStar(parent, index) {
    for (var i = 0; i < this.stars.length; i++) {
      if (parent.title == this.stars[i].title) {
        var list = this.stars[i].list;
        for (var j = 0; j < list.length; j++) {
          if (j <= index) {
            list[j].active = 1;
            var array = ['非常差', '差', '一般', '好', '超赞'];
            this.stars[i].desc = array[index];

            if (this.stars[i].id == 1) {
              this.qualityScore = index + 1;
            } else if (this.stars[i].id == 2) {
              this.tasteScore = index + 1;
            } else if (this.stars[i].id == 3) {
              this.packScore = index + 1;
            }
          } else {
            list[j].active = 0;
          }
        }
      }
      if (parent.id == 1) {
        this.stars[i].isShow = true;
        if (index == 4) {
          var _list = this.stars[i].list;
          for (var _j = 0; _j < _list.length; _j++) {
            _list[_j].active = 1;
            this.stars[i].desc = '超赞';
            this.qualityScore = index + 1;
            this.tasteScore = index + 1;
            this.packScore = index + 1;
          }
        }
      }
    }
    // item.active = 1;
  },

  // shortcutsSelect: function(text){
  //   var _this = this
  //   if(_this.desc.length <= 100){
  //     if(_this.desc == ''){
  //       _this.desc = _this.desc+text
  //     }else if(_this.desc != ''){
  //       _this.desc = _this.desc+'，'+text
  //     }
  //   }
  //   _this.descInput()
  // },
  // descInput(){
  //   var _this = this
  //   var txtVal = _this.desc.length;
  //   if(txtVal<=100) {
  //     _this.remnant = 100 - txtVal;
  //   }
  // },
  // stars: function(index){
  //   this.score = index + 1
  //   // this.validateSubmit()
  // },
  selectClick: function selectClick(item, type, index) {
    var _this = this;
    var goodsList = [];
    for (var i = 0; i < _this.goodsList.length; i++) {
      if (i == index) {
        if (item.scoreType == 0) {
          if (type == 'good') {
            item.scoreType = 2;
          } else {
            item.scoreType = 1;
          }
        } else if (item.scoreType == 1) {
          if (type == 'good') {
            item.scoreType = 2;
          } else {
            item.scoreType = 0;
          }
        } else if (item.scoreType == 2) {
          if (type == 'bad') {
            item.scoreType = 1;
          } else {
            item.scoreType = 0;
          }
        }
      }
      goodsList.push(_this.goodsList[i]);
    }

    _this.goodsList = goodsList;
    for (var i = 0; i < _this.goodsList.length; i++) {
      _this.goodsMarkList[i] = {
        skuCode: _this.goodsList[i].skuCode,
        goodsScore: _this.goodsList[i].scoreType
      };
    }
    // _this.validateSubmit()
  },

  // validateSubmit: function (){
  //   var  _this = this
  //
  //   for(var i = 0; i < _this.goodsMarkList.length; i++){
  //     if(_this.score > 0 && _this.goodsMarkList[i].goodsScore != 0 ) {
  //       _this.canSubmit = true
  //     }else{
  //       _this.canSubmit = false
  //       break;
  //     }
  //   }
  //
  // },
  // 提交成功弹框
  confirm: function confirm() {
    this.isOk = false;
    this.$router.go(-1);
  },

  //上传图片
  getImage: function getImage(e) {
    var _this = this;
    var host = _this.$utils.getSpliceHost('manager-center');
    var url = host + '/api/fileupload/upBase64';
    var file = e.target.files[0];
    if (!/image\/\w+/.test(file.type)) {
      _this.$messagebox.alert('请选择图片', '');
      return false;
    }

    _this.$indicator.open(); //loading

    // 通过canvas压缩图片
    var reader = new FileReader();
    reader.readAsDataURL(file);
    var img = new Image();
    reader.onload = function (e) {
      var width = 320,
          //图像大小
      quality = 0.8,
          //图像质量
      canvas = document.createElement("canvas"),
          drawer = canvas.getContext("2d");
      img.src = this.result;
      img.onload = function () {
        canvas.width = width;
        canvas.height = width * (img.height / img.width);
        drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
        var imgsrc = canvas.toDataURL("image/png", quality);
        _this.$http.post(url, { src: imgsrc }, { emulateJSON: true }).then(function (response) {
          _this.goodsImages.push(response.body.data.path);
          if (_this.goodsImages.length >= 3) {
            _this.isAddShow = !_this.isAddShow;
          }
          _this.$indicator.close();
          // 响应成功回调
        }, function (response) {
          // 响应错误回调
          _this.$indicator.close();
        });
      };
    };
  },

  // 删除图片
  deletepic: function deletepic(index) {
    var _this = this;
    _this.goodsImages.splice(index, 1);
    if (!_this.isAddShow) {
      _this.isAddShow = !_this.isAddShow;
    }
  },
  selectAnonymous: function selectAnonymous() {
    this.selected = !this.selected;
  },
  submit: function submit() {
    var _this = this;
    var deliveryScore = 0,
        deliveryEstimateInfoList = [];
    if (_this.mainInfo.deliveryName) {
      if (!_this.deliveryScores[0].checked && !_this.deliveryScores[1].checked) {
        _this.$toast('请评价骑手服务');
        return false;
      } else {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this.deliveryScores[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var v = _step2.value;

            if (v.checked) {
              deliveryScore = v.score;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (_this.deliveryScores[0].checked) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = this.mainInfo.badDeliveryTemplateList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _v = _step3.value;

              if (_v.checked) {
                deliveryEstimateInfoList.push(_v);
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (deliveryEstimateInfoList.length == 0) {
            _this.$toast('请选择骑手问题');
            return false;
          }
        }
      }
    }

    if (_this.qualityScore === 0) {
      _this.$toast('请评价商家');
      return false;
    }
    if (_this.tasteScore === 0) {
      _this.$toast('请给口味评分');
      return false;
    }
    if (_this.packScore === 0) {
      _this.$toast('请给包装评分');
      return false;
    }
    if (_this.goodsMarkList.length == 0) {
      _this.$toast('需要对菜品打分哦~');
      return false;
    }
    for (var i = 0; i < _this.goodsMarkList.length; i++) {
      if (_this.goodsMarkList[i].goodsScore == 0) {
        _this.$toast('需要对菜品打分哦~');
        return false;
      }
    }
    var anonymous;
    if (_this.selected) {
      anonymous = 1;
    } else {
      anonymous = 0;
    }
    var params = {
      orderId: _this.orderId,
      goodsMarkList: _this.goodsMarkList, //商品打分列表
      anonymous: anonymous, //是否匿名
      comment: _this.comment, //评论内容
      imageList: _this.goodsImages, //图片列表
      packScore: _this.packScore,
      tasteScore: _this.tasteScore,
      qualityScore: _this.qualityScore
    };
    if (_this.mainInfo.deliveryName) {
      params.deliveryScore = deliveryScore;
      params.deliveryComment = _this.deliveryComment;
      params.deliveryEstimateInfoList = deliveryEstimateInfoList;
    }
    __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSaveComment(_this, params, function () {
      _this.isOk = true;
      // 提交成功的回调
    }, function (response) {
      _this.$toast(response.body.message, '');
      // 错误回调
    });
  }
}), _defineProperty(_name$data$computed$c, 'components', {
  PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a
}), _name$data$computed$c);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { Indicator,Toast,MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderId: window.localStorage.getItem('orderCode'),
      flag1: false, //控制责任方列表弹框
      flag: false, //控制投诉理由列表弹框
      isAddShow: true, //控制上传图片按钮
      userTel: '',
      shopName: '',
      content: '',
      remnant: 200,
      responsiblePartyList: [], //责任方列表
      reasonList: [], //投诉理由列表
      responsible: '',
      reason: '',
      goodsImages: [],
      tel: '',
      isCanApplyRefund: 0,
      isRefund: false,
      goodsList: []
    };
  },

  computed: {
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  // created () {
  //   document.title = "投诉";
  // },
  mounted: function mounted() {
    var _this = this;
    _this.getcomplaintInfo();
  },

  methods: {
    getcomplaintInfo: function getcomplaintInfo() {
      var _this = this;
      var params = {
        orderId: _this.orderId
      };
      _this.$indicator.open(); //loading
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getApplyComplaints(_this, params, function (data) {
        _this.$indicator.close();
        _this.userTel = data.userTel;
        _this.shopName = data.shopName;
        _this.goodsList = data.goodsList;
        _this.isCanApplyRefund = data.isCanApplyRefund;
        var params = {
          commercial_id: data.commercialId,
          school_id: data.schoolId
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCommercialTel(_this, params, function (data1) {
          _this.tel = data1;
        });
        for (var i = 0; i < data.applyResponsibleReasonList.length; i++) {
          _this.responsiblePartyList[i] = data.applyResponsibleReasonList[i];
          // if(_this.responsiblePartyList[i].isDefault == 1){
          //   _this.responsible = _this.responsiblePartyList[i]
          //   _this.reasonList = _this.responsiblePartyList[i].reasonList
          // }
        }
        // for (var i = 0; i < _this.reasonList.length; i++) {
        //   if (_this.reasonList[i].isDefault == 1) {
        //     _this.reason = _this.reasonList[i]
        //   }
        // }
        console.log(_this.responsiblePartyList);
      }, function (data) {
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    selectResponsibleParty: function selectResponsibleParty() {
      this.flag1 = !this.flag1;
    },
    selectReason: function selectReason() {
      if (this.responsible.responsibleParty !== '' && this.responsible.responsibleParty != null && this.responsible.responsibleParty !== undefined) {
        this.flag = !this.flag;
      } else {
        this.$messagebox.alert('请选择投诉对象', '');
      }
    },
    //选择投诉对象
    handleClick1: function handleClick1(item, index) {
      var _this = this;
      _this.responsible = item;
      _this.flag1 = false;
      for (var i = 0; i < _this.responsiblePartyList.length; i++) {
        if (i == index) {
          _this.responsiblePartyList[i].isDefault = 1;
        } else {
          _this.responsiblePartyList[i].isDefault = 0;
        }
        if (_this.responsiblePartyList[i].responsibleParty == item.responsibleParty) {
          _this.reasonList = _this.responsiblePartyList[i].reasonList;
        }
      }
      for (var i = 0; i < _this.reasonList.length; i++) {
        if (_this.reasonList[i].isDefault === 1) {
          _this.reason = _this.reasonList[i];
        }
      }
    },
    // 选择投诉理由
    handleClick: function handleClick(item, index) {
      this.reason = item;
      this.flag = false;
      for (var i = 0; i < this.reasonList.length; i++) {
        if (i == index) {
          this.reasonList[i].isDefault = 1;
        } else {
          this.reasonList[i].isDefault = 0;
        }
      }
    },
    //点击空白处隐藏理由列表弹框
    hiddenList: function hiddenList(index) {
      if (index == 1) {
        this.flag1 = false;
      }
      if (index == 2) {
        this.flag = false;
      }
    },
    descInput: function descInput() {
      var _this = this;
      var txtVal = _this.content.length;
      if (txtVal <= 200) {
        _this.remnant = 200 - txtVal;
      }
    },
    //上传图片
    getImage: function getImage(e) {
      var _this = this;
      var host = _this.$utils.getSpliceHost('manager-center');
      //          if(process.env.NODE_ENV=='local'){
      //            host = 'http://manager-center.imcoming.com.cn'
      //          }else if(process.env.NODE_ENV=='development'){
      //            host = 'http://manager-center.imcoming.com.cn'
      //          }else if(process.env.NODE_ENV=='test'){
      //            host = 'http://manager-center.imcoming.com'
      //          }else{
      //            host = 'https://manager-center.anlaiye.com'
      //          }
      var url = host + '/api/fileupload/upBase64';
      var file = e.target.files[0];
      if (!/image\/\w+/.test(file.type)) {
        _this.$messagebox.alert("请选择图片", '');
        return false;
      }
      _this.$indicator.open(); //loading
      // 通过canvas压缩图片
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var img = new Image();
      reader.onload = function (e) {
        var width = 320,
            //图像大小
        quality = 0.8,
            //图像质量
        canvas = document.createElement("canvas"),
            drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var imgsrc = canvas.toDataURL("image/png", quality);
          _this.$http.post(url, { src: imgsrc }, { emulateJSON: true }).then(function (response) {
            _this.goodsImages.push(response.body.data.path);
            if (_this.goodsImages.length >= 3) {
              _this.isAddShow = !_this.isAddShow;
            }
            // _this.loading = false;
            _this.$indicator.close();
            // 响应成功回调
          }, function (response) {
            // 响应错误回调
            _this.$indicator.close();
          });
        };
      };
    },
    // 删除图片
    deletepic: function deletepic(index) {
      var _this = this;
      _this.goodsImages.splice(index, 1);
      if (!_this.isAddShow) {
        _this.isAddShow = !_this.isAddShow;
      }
    },
    //提交投诉
    submit: function submit() {
      var _this = this;
      if (_this.userTel !== '' && _this.responsible.responsibleParty !== undefined && _this.reason.reasonDesc !== undefined && _this.content !== '') {
        _this.$messagebox.confirm('是否提交投诉?', '').then(function (action) {
          var params = {
            orderId: _this.orderId,
            userTel: _this.userTel,
            complaintContent: _this.content,
            complaintImages: _this.goodsImages,
            responsibleCode: _this.responsible.responsibleCode,
            reasonCode: _this.reason.reasonCode,
            goodsList: _this.goodsList,
            isApplyRefund: 0
          };
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSaveComplaint(_this, params, function () {
            _this.$messagebox.alert('提交成功', '').then(function (action) {
              _this.$router.go(-1);
            });
          }, function (data) {
            _this.$messagebox.alert(data.body.message, '');
          });
        });
      } else if (_this.userTel === '') {
        _this.$messagebox.alert('请输入手机号码', '');
      } else if (_this.responsible.responsibleParty === '' || _this.responsible.responsibleParty === undefined || _this.responsible.responsibleParty == null) {
        _this.$messagebox.alert('请选择投诉对象', '');
      } else if (_this.reason.reasonDesc === '' || _this.reason.reasonDesc === undefined || _this.reason.reasonDesc == null) {
        _this.$messagebox.alert('请选择投诉理由', '');
      } else if (_this.content === '') {
        _this.$messagebox.alert('请填写详细描述', '');
      }
    }
  },
  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { Indicator,Toast,MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderId: window.localStorage.getItem('orderCode'),
      isAddShow: true, //控制上传图片按钮
      userTel: '',
      shopName: '',
      content: '',
      goodsImages: [],
      isRefund: false,
      shortGoodsList: [],
      totalGoodList: [],
      goodsList: [],
      isShow: true,
      showTotal: true,
      showPart: false,
      showMore: true,
      refundGoodList: [],
      flag: false, //是否显示选择退款理由弹框
      reasonList: [],
      // reason: '请选择',//退款理由
      // reasonCode: '',
      refundReason: {
        reasonDesc: '请选择',
        reasonCode: null
      },
      refundAmountTotal: '', //全部退款金额
      refundAmount: 0,
      canSubmit: true,

      packingGoodsList: [], // 打包费
      refundDetail: {}
    };
  },

  computed: {
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  // created () {
  //   document.title = "申请退款";
  // },
  mounted: function mounted() {
    var _this = this;
    _this.getRefundInfo();
  },

  methods: {
    // 切换配送方式
    switchStatus: function switchStatus(status) {
      var _this = this;
      _this.isCanSubmit = false;
      if (status === 'total') {
        _this.showTake = true;
        _this.showSelf = false;
        _this.isShow = true;
        _this.showMore = true;
        _this.goodsList = _this.shortGoodsList;
        _this.refundAmount = _this.refundAmountTotal;
      } else if (status === 'part') {
        _this.refundGoodList = [];
        _this.refundAmount = 0;
        _this.showSelf = true;
        _this.showTake = false;
        _this.isShow = false;
        _this.showMore = true;
        // _this.goodsList = _this.totalGoodList
        _this.goodsList = _this.shortGoodsList;
        for (var i = 0; i < _this.goodsList.length; i++) {
          _this.goodsList[i].showRefundNum = false;
          _this.goodsList[i].refundNumber = 0;
        }
      }
    },
    openList: function openList() {
      this.goodsList = this.totalGoodList;
      this.showMore = false;
    },
    closeList: function closeList() {
      this.goodsList = this.shortGoodsList;
      this.showMore = true;
    },
    addRefundGoods: function addRefundGoods(item, attr) {
      var _this = this;
      if (attr) {
        // 加料属性
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.goodsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var v = _step.value;

            if (item.id == v.id && v.attributeGoodsList && v.attributeGoodsList.length > 0) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = v.attributeGoodsList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var v2 = _step2.value;

                  if (v2.id == attr.id) {
                    if (v2.refundNumber < v2.number) {
                      v2.showRefundNum = true;
                      v2.refundNumber++;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        console.log(_this.goodsList);
        for (var i = 0; i < _this.goodsList.length; i++) {
          if (_this.goodsList[i].id == item.id) {
            if (item.refundNumber < item.number) {
              _this.goodsList[i].showRefundNum = true;
              _this.goodsList[i].refundNumber++;
              // 同步加料属性
              console.log(_this.goodsList[i]);
              var attributeGoodsList = _this.goodsList[i].attributeGoodsList;
              if (attributeGoodsList && attributeGoodsList.length > 0) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = attributeGoodsList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _v = _step3.value;

                    if (_v.refundNumber < _v.number) {
                      _v.showRefundNum = true;
                      _v.refundNumber++;
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
          }
        }
      }
      _this.calculateRefund();
    },
    subtractGoods: function subtractGoods(item, attr) {
      var _this = this;
      if (attr) {
        // 加料属性
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this.goodsList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var v = _step4.value;

            if (item.id == v.id && v.attributeGoodsList && v.attributeGoodsList.length > 0) {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = v.attributeGoodsList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var v2 = _step5.value;

                  if (v2.id == attr.id) {
                    if (v2.refundNumber > 0) {
                      v2.showRefundNum = true;
                      v2.refundNumber--;
                      if (v2.refundNumber == 0) {
                        v2.showRefundNum = false;
                      }
                      if (v.refundNumber > v2.refundNumber) {
                        v.refundNumber = v2.refundNumber;
                        if (v.refundNumber == 0) {
                          v.showRefundNum = false;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      } else {
        for (var i = 0; i < _this.goodsList.length; i++) {
          if (_this.goodsList[i].id == item.id) {
            // 加料属性
            if (_this.goodsList[i].attributeGoodsList && _this.goodsList[i].attributeGoodsList.length > 0) {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = _this.goodsList[i].attributeGoodsList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var _v2 = _step6.value;

                  if (item.refundNumber > 0) {
                    _v2.showRefundNum = true;
                    _v2.refundNumber--;
                    if (_v2.refundNumber == 0) {
                      _v2.showRefundNum = false;
                    }
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            }
            if (item.refundNumber > 0) {
              _this.goodsList[i].showRefundNum = true;
              _this.goodsList[i].refundNumber--;
              if (_this.goodsList[i].refundNumber == 0) {
                _this.goodsList[i].showRefundNum = false;
              }
            }
          }
        }
      }
      _this.calculateRefund();
    },
    // 部分退款计算退款金额
    calculateRefund: function calculateRefund() {
      this.refundAmount = 0;
      var num = 0;
      for (var i = 0; i < this.goodsList.length; i++) {
        var itemAmount = parseFloat(this.goodsList[i].amount) * parseInt(this.goodsList[i].refundNumber) / parseInt(this.goodsList[i].number);
        // 加料属性价格
        var attributeGoodsList = this.goodsList[i].attributeGoodsList,
            attrAmount = 0;
        if (attributeGoodsList && attributeGoodsList.length > 0) {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = attributeGoodsList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var v = _step7.value;

              var price = parseFloat(v.amount) * parseInt(v.refundNumber) / parseInt(v.number);
              attrAmount += parseFloat((Math.round(price * 100) / 100).toFixed(2));
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.refundAmount += parseFloat((Math.round((itemAmount + attrAmount) * 100) / 100).toFixed(2));
        if (this.goodsList[i].refundNumber == this.goodsList[i].number) {
          num++;
        }
      }
      if (this.packingGoodsList && this.packingGoodsList.length > 0) {
        // 有打包费
        for (var j = 0; j < this.packingGoodsList.length; j++) {
          this.packingGoodsList[j].refundNumber = 0;
          this.packingGoodsList[j].originNumber = 0;
          var goodsId = this.packingGoodsList[j].goodsId;
          for (var i = 0; i < this.goodsList.length; i++) {
            if (goodsId == this.goodsList[i].goodsId) {
              this.packingGoodsList[j].refundNumber += parseInt(this.goodsList[i].refundNumber);
              this.packingGoodsList[j].originNumber += parseInt(this.goodsList[i].number);
            }
          }
          if (this.packingGoodsList[j].refundNumber > 0) {
            if (this.packingGoodsList[j].refundNumber == this.packingGoodsList[j].originNumber) {
              this.refundAmount += parseFloat(this.packingGoodsList[j].amount);
            } else {
              var packFeeNum = Math.floor(parseInt(this.packingGoodsList[j].refundNumber) / this.packingGoodsList[j].packingFeeRule);
              var _itemAmount = packFeeNum * parseFloat(this.packingGoodsList[j].amount) / parseInt(this.packingGoodsList[j].number);
              this.refundAmount += parseFloat((Math.round(_itemAmount * 100) / 100).toFixed(2));
            }
          }
        }
      }
      if (num == this.goodsList.length) {
        this.refundAmount = this.refundAmountTotal;
      } else {
        this.refundAmount = this.refundAmount.toFixed(2);
      }

      // console.log(this.refundAmount)
    },
    //显示退款理由
    showReasonBox: function showReasonBox() {
      this.flag = true;
    },
    // 选择退款理由
    handleClick: function handleClick(item, index) {
      console.log(item);
      this.refundReason = item;
      this.flag = false;
      this.reasonList.forEach(function (val) {
        if (val.list) {
          val.list.forEach(function (val1) {
            val1.isDefault = 0;
            if (val1.reasonCode === item.reasonCode && val.name === item.responsibleParty) {
              val1.isDefault = 1;
            }
          });
        }
      });
    },
    getRefundInfo: function getRefundInfo() {
      var _this = this;
      var params = {
        orderId: _this.orderId
      };
      _this.$indicator.open(); //loading
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getApplyRefund(_this, params, function (data) {
        _this.$indicator.close();
        if (data.refundApplyReasonList) {
          var refundApplyReasonList = data.refundApplyReasonList,
              array = [];
          var obj = refundApplyReasonList.reduce(function (acc, obj) {
            var key = obj['responsibleParty'];
            if (!acc[key]) {
              acc[key] = [];
            }
            obj.checked = false;
            acc[key].push(obj);
            return acc;
          }, {});
          for (var k in obj) {
            array.push({ name: k, list: obj[k] });
          }
          _this.reasonList = array;
        }
        for (var i = 0; i < data.goodsList.length; i++) {
          data.goodsList[i].showRefundNum = false;
          data.goodsList[i].refundNumber = 0;
          var attributeGoodsList = data.goodsList[i].attributeGoodsList;
          if (attributeGoodsList && attributeGoodsList.length > 0) {
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = attributeGoodsList[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var v = _step8.value;

                v.showRefundNum = false;
                v.refundNumber = 0;
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          }
        }
        _this.totalGoodList = data.goodsList;
        _this.refundAmountTotal = data.amount;
        _this.refundAmount = _this.refundAmountTotal;
        _this.packingGoodsList = data.packingGoodsList || [];
        _this.refundDetail = data;

        if (data.goodsList.length > 2) {
          _this.shortGoodsList = data.goodsList.slice(0, 2);
        } else {
          _this.shortGoodsList = data.goodsList;
        }
        _this.goodsList = _this.shortGoodsList;
      }, function (data) {
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    selectReason: function selectReason() {
      this.flag = !this.flag;
    },
    //点击空白处隐藏理由列表弹框
    hiddenList: function hiddenList(index) {
      if (index == 1) {
        this.flag1 = false;
      }
      if (index == 2) {
        this.flag = false;
      }
    },
    //上传图片
    getImage: function getImage(e) {
      var _this = this;
      var host = _this.$utils.getSpliceHost('manager-center');
      //          if(process.env.NODE_ENV=='local'){
      //            host = 'http://manager-center.imcoming.com.cn'
      //          }else if(process.env.NODE_ENV=='development'){
      //            host = 'http://manager-center.imcoming.com.cn'
      //          }else if(process.env.NODE_ENV=='test'){
      //            host = 'http://manager-center.imcoming.com'
      //          }else{
      //            host = 'https://manager-center.anlaiye.com'
      //          }
      var url = host + '/api/fileupload/upBase64';
      var file = e.target.files[0];
      if (!/image\/\w+/.test(file.type)) {
        _this.$messagebox.alert("请选择图片", '');
        return false;
      }
      _this.$indicator.open(); //loading
      // 通过canvas压缩图片
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var img = new Image();
      reader.onload = function (e) {
        var width = 320,
            //图像大小
        quality = 0.8,
            //图像质量
        canvas = document.createElement("canvas"),
            drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          var imgsrc = canvas.toDataURL("image/png", quality);
          _this.$http.post(url, { src: imgsrc }, { emulateJSON: true }).then(function (response) {
            _this.goodsImages.push(response.body.data.path);
            if (_this.goodsImages.length >= 3) {
              _this.isAddShow = !_this.isAddShow;
            }
            // _this.loading = false;
            _this.$indicator.close();
            // 响应成功回调
          }, function (response) {
            // 响应错误回调
            _this.$indicator.close();
          });
        };
      };
    },
    // 删除图片
    deletepic: function deletepic(index) {
      var _this = this;
      _this.goodsImages.splice(index, 1);
      if (!_this.isAddShow) {
        _this.isAddShow = !_this.isAddShow;
      }
    },
    //提交投诉
    submit: function submit() {
      var _this = this;
      if (_this.isShow) {
        _this.refundGoodList = _this.totalGoodList;
      } else {
        var refundGoodList = [];
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = _this.goodsList[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var v = _step9.value;

            if (v.refundNumber > 0) {
              refundGoodList.push({
                id: v.id,
                goodsSaleId: v.goodsSaleId,
                number: v.refundNumber
              });
            }
            if (v.attributeGoodsList && v.attributeGoodsList.length > 0) {
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = v.attributeGoodsList[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var v1 = _step10.value;

                  if (v1.refundNumber > 0) {
                    refundGoodList.push({
                      id: v1.id,
                      goodsSaleId: v1.goodsSaleId,
                      number: v1.refundNumber
                    });
                  }
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }

        _this.refundGoodList = refundGoodList;
      }
      if (this.refundGoodList.length < 1) {
        this.$toast('请选择需要退款的商品');
        return;
      }
      if (!this.refundReason.reasonCode) {
        this.$toast('请选择退款原因');
        return;
      }
      if (this.refundReason.textNeed === 1 && !this.content) {
        this.$toast('请填写详细描述');
        return;
      }
      if (this.refundReason.pictureNeed === 1 && this.goodsImages.length == 0) {
        this.$toast('请上传图片');
        return;
      }
      // console.log(_this.refundGoodList,"提交退款时")
      _this.$messagebox.confirm('退款将在审核通过后3-5个工作日内原路返回您的支付账户', '确认提交退款申请吗?').then(function (action) {
        var params = {
          orderId: _this.orderId,
          complaintContent: _this.content,
          complaintImages: _this.goodsImages,
          reasonCode: _this.refundReason.reasonCode,
          goodsList: _this.refundGoodList,
          isApplyRefund: 1
        };
        if (_this.canSubmit) {
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSaveComplaint(_this, params, function () {
            _this.canSubmit = false;
            _this.$messagebox.alert('提交成功', '').then(function (action) {
              _this.$router.go(-1);
            });
          }, function (data) {
            _this.$messagebox.alert(data.body.message, '');
          });
        }
      });
    }
  },
  components: {
    PreviewPicture: __WEBPACK_IMPORTED_MODULE_1__components_PreviewPicture___default.a
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var wx = require('weixin-js-sdk')


// import { MessageBox, Toast, Indicator} from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      orderId: 0,
      orderInfo: null,
      orderStatus: '',
      payStatus: '',
      settle_amount: 0,
      orderDesc: '',
      estimateId: '',
      canEstimated: '',
      complaint: '',
      tel: '',
      serviceList: false,
      isShowRedPacket: false,
      redPacketInfo: {}, //红包信息
      wxShareMask: false,
      isShowSelf: false,
      isShowCabinet: false,
      isShowProgress: false,
      defaultGoodsList: [],
      anotherGoodsList: [],
      cartData: {},
      changeGoodsInCart: [],
      schoolCardCode: '',
      orderInfoVisible: false,
      showHappySunday: false, //显示幸福星期天
      managerInfo: {} //获取客服信息
    };
  },

  computed: {
    cartInfo: function cartInfo() {
      return this.$store.state.cartInfo;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    }
  },
  // created () {
  //   document.title = '订单详情'
  // },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderList') {
      to.meta.isUseCache = true;
    }
    next();
  },
  mounted: function mounted() {
    var _this = this;
    if (!_this.$store.state.wxLoginToken) {
      _this.$utils.toLogin(_this);
      return;
    }
    if (_this.$utils.resolveUrl().order_id) {
      _this.orderId = _this.$utils.resolveUrl().order_id;
    } else {
      _this.orderId = window.localStorage.getItem('orderCode');
    }
    if (_this.$utils.resolveUrl().school_id) {
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolStatus(_this, { school_id: _this.$utils.resolveUrl().school_id }, function (data) {
        var schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);
      }, function () {
        _this.$messagebox.alert(data.body.message, '');
      });
    }
    _this.getOrderDetail();

    if (!_this.$utils.isWeiXin()) {
      window.onpopstate = function () {
        // alert('1')
        _this.$router.push({ name: 'OrderList' });
      };
    }
  },

  methods: {
    //客服信息
    getManagerInfo: function getManagerInfo() {
      var _this = this;
      var param = {
        school_id: _this.orderInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].managerInfo(_this, param, function (data) {
        if (data) {
          _this.managerInfo = data;
        }
      });
    },

    //打开出餐进程
    openDialog: function openDialog() {
      this.orderInfoVisible = true;
    },


    //一键开柜
    openCabinet: function openCabinet() {
      this.isShowCabinet = true;
    },
    sureCabinet: function sureCabinet() {
      var _this = this;
      var params = {
        operateType: 0,
        order_id: _this.orderId
        // _this.$indicator.open({text: '开柜中'})
      };_this.isShowProgress = true;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].openCabinet(_this, params, function (data) {
        _this.isShowCabinet = false;
        _this.isShowProgress = false;
        _this.$router.push({ path: '/deviceDetail/' + _this.orderId });
      }, function (data) {
        // _this.$indicator.close();
        _this.isShowProgress = false;
        _this.$toast(data.data.message);
      });
    },
    cancelCab: function cancelCab() {
      this.isShowCabinet = false;
      this.isShowProgress = false;
    },

    //复制
    copy: function copy() {
      var range = document.createRange();
      range.selectNode(document.getElementById('codeNum'));
      var selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      this.$toast('复制成功');
    },

    //取餐二维码
    toQrCode: function toQrCode(val) {
      window.localStorage.setItem('Qr-code', val);
      this.$router.push({
        path: 'QrCode',
        query: { orderType: this.orderInfo.orderType }
      });
    },

    // 查看自提点地图
    toCheckMap: function toCheckMap() {
      window.localStorage.setItem('mapAddr', this.orderInfo.pickUpAddr);
      window.localStorage.setItem('mapPic', this.orderInfo.pickUpImage);
      this.$router.push({ name: 'Map' });
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;
      var param = {
        order_id: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderDetail(_this, param, function (data) {
        data.supplierTel = data.supplierTel ? data.supplierTel.substring(0, 3) + ' ' + data.supplierTel.substring(3, 7) + ' ' + data.supplierTel.substring(7, 11) : '';
        if (data.orderPickUpInfoBean && data.orderPickUpInfoBean.msgTemplate && data.orderPickUpInfoBean.msgParam) {
          var msgTemplate = data.orderPickUpInfoBean.msgTemplate;
          data.orderPickUpInfoBean.msgTemplate = msgTemplate.replace(/%s分钟/, '<span style="color:#ff0000">' + data.orderPickUpInfoBean.msgParam + '\u5206\u949F</span>');
        }
        // console.log(data.supplierTel)
        _this.orderInfo = data;
        _this.orderStatus = _this.orderInfo.order_status;
        _this.payStatus = _this.orderInfo.pay_status;
        _this.canEstimated = _this.orderInfo.canEstimated;
        _this.estimateId = _this.orderInfo.estimateId;
        _this.complaint = _this.orderInfo.complaint;
        _this.complainId = _this.orderInfo.complaintId;

        _this.getManagerInfo(); //获取客服信息
        if (_this.orderInfo.redPacket && _this.orderInfo.order_status > 1000) {
          // actions.getredPacketShare(_this, {order_id: _this.orderId}, function (data) {
          //   if (data) {
          //     _this.redPacketInfo = data;
          //     _this.isShowRedPacket = true;
          //   }
          // }, function () {})
          // _this.$utils.wxShareNew(
          //   _this,
          //   _this.orderInfo.redPacket.share_title, // 分享标题
          //   _this.orderInfo.redPacket.url, // 分享链接
          //   _this.orderInfo.redPacket.share_pic, // 分享图标
          //   _this.orderInfo.redPacket.share_content // 分享描述
          // );
          //红包分享
          // var u = encodeURIComponent(window.location.href.split('#')[0])
          // window.localStorage.setItem('landingPage', u)
          // actions.getJsShareConf(_this, u, function (data) {
          //   wx.config({
          //     debug: false,//开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          //     appId: data.data.appId, // 必填，公众号的唯一标识
          //     timestamp: data.data.timestamp, // 必填，生成签名的时间戳
          //     nonceStr: data.data.nonceStr, //必填， 生成签名的随机串
          //     signature: data.data.signature, //必填，签名
          //     jsApiList: data.data.jsApiList  //必填， JS接口列表，这里只填写了分享需要的接口
          //   });
          //   wx.ready(function () {
          //     _this.$utils.wx_share(
          //       _this.orderInfo.redPacket.share_title, // 分享标题
          //       _this.orderInfo.redPacket.url, // 分享链接
          //       _this.orderInfo.redPacket.share_pic, // 分享图标
          //       _this.orderInfo.redPacket.share_content // 分享描述
          //     );
          //   });
          //   wx.error(function (res) {
          //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          //   })
          // })
        }
        var obj = {
          commercialId: data.commercialId
        };
        _this.$store.commit('changeState', obj);
        if (_this.orderInfo.orderType === 0) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款';
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '已支付';
          } else if (_this.orderStatus === 2001) {
            _this.orderDesc = '配送中';
          } else if (_this.orderStatus === 2002) {
            _this.orderDesc = '配送完成';
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '确认收货';
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消';
          } else if (_this.orderStatus === -8000) {
            _this.orderDesc = '订单错误';
          }
        } else if (_this.orderInfo.orderType === 1) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款';
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '待领取';
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '已完成';
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消';
          }
        } else if (_this.orderInfo.orderType === 3) {
          if (_this.orderStatus === 1000) {
            _this.orderDesc = '待付款';
          } else if (_this.orderStatus === 1001) {
            _this.orderDesc = '备餐中';
          } else if (_this.orderStatus === 2001) {
            _this.orderDesc = '待领取';
          } else if (_this.orderStatus === 3001) {
            _this.orderDesc = '已完成';
          } else if (_this.orderStatus === 9000) {
            _this.orderDesc = '已取消';
          }
        }
        window.localStorage.setItem('deliveryTime', data.eatIn_time);
        window.localStorage.setItem('supplier_name', data.supplier_name);
        window.localStorage.setItem('qrCodeIndate', data.qrCodeIndate);
        window.localStorage.setItem('isInvalid', data.isInvalid);
        _this.isShowHappySunday();
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    // 取消订单
    cancelOrder: function cancelOrder(id) {
      var _this2 = this;

      this.$messagebox.confirm('确定取消订单吗?', '').then(function (action) {
        var _this = _this2;
        var params = {
          order_id: id
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功');
          _this.getOrderDetail();
        });
      }).catch(function () {});
    },
    // 取消订单并退款
    cancelAndRefundOrder: function cancelAndRefundOrder(id) {
      var _this3 = this;

      this.$messagebox.confirm('当前售后申请无需审核，将直接为您退款，是否确认取消订单？', '取消订单并退款').then(function (action) {
        var _this = _this3;
        var params = {
          orderId: id
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postCancelRefundOrder(_this, params, function (res) {
          if (res.flag) {
            var flag = res.flag;
            if (flag === 1) {
              _this3.$toast('取消并退款成功');
              _this3.getOrderDetail();
            } else {
              _this3.$messagebox.alert(res.msg || res.message, '');
            }
          }
        }, function (res) {
          _this3.$messagebox.alert(res.msg || res.message, '');
        });
      }).catch(function () {});
    },
    // 催单
    reminderOrder: function reminderOrder(id) {
      var _this = this;
      var params = {
        order_id: id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].reminderOrder(_this, params, function (data) {
        _this.$toast(data.msg);
        // _this.getOrderDetail()
      });
    },
    closeServiceList: function closeServiceList() {
      this.serviceList = false;
    },
    getSchoolCardInfo: function getSchoolCardInfo() {
      var _this = this;
      // _this.orderSubmitType = 2;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].schoolCardInfo(_this, { school_id: _this.orderInfo.schoolId }, function (data) {
        if (data && data.card_no) {
          _this.schoolCardCode = data.card_no;
        } else {
          _this.schoolCardCode = '';
        }
        _this.cfPay();
      }, function () {
        _this.cfPay();
      });
    },

    // 常州纺织学院支付收银台
    cfPay: function cfPay() {
      var _this4 = this;

      var _this = this;
      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: '请输入学生卡号',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '请输入正确的学工号',
        inputValue: _this.schoolCardCode,
        showCancelButton: true,
        showInput: true
      }).then(function (_ref) {
        var value = _ref.value,
            action = _ref.action;

        _this4.schoolCardCode = value;
        var params = {
          cfOrderInfo: encodeURIComponent(JSON.stringify({ accNum: value })),
          order_id: _this.orderId,
          payType: 92
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (data) {
          var div = document.createElement('div');
          div.innerHTML = data;
          document.body.appendChild(div);
          document.forms[0].submit();
        });
      });
    },
    clickHandle: function clickHandle(type) {
      var _this = this;
      window.localStorage.setItem('orderCode', _this.orderId);
      var param = {
        order_id: _this.orderId
      };
      if (type == 2) {
        //立即支付

        //           if (_this.$utils.isWeiXin()) { // 判断是否微信浏览器中打开
        //
        //             _this.wxBridgeready();
        //
        //           } else {
        //
        //             window.localStorage.setItem('orderCode',_this.orderId)
        //             _this.$router.push({path:'payment'})
        //           }
        window.localStorage.setItem('orderCode', _this.orderId);
        // _this.$router.push({path:'payment'})
        // 常州纺织学院支付收银台
        var cfSchoolId = void 0;
        if (true) {
          cfSchoolId = 2803;
        } else {
          cfSchoolId = 1816;
        }
        if (cfSchoolId == _this.orderInfo.schoolId) {
          _this.getSchoolCardInfo();
        } else {
          _this.$indicator.open(); //loading
          _this.$router.push({ name: 'Payment' });
        }
      } else if (type == 3) {
        //确认收货

        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postFinalOrder(_this, param, function (data) {
          _this.getOrderDetail();
        });
      } else if (type == 4) {
        //查看配送进程

        window.localStorage.setItem('orderType', _this.orderInfo.orderType);
        if (_this.orderInfo.orderType == 1) {
          window.localStorage.setItem('pickupProcess', JSON.stringify(_this.orderInfo.flowList));
        }
        _this.$router.push({ path: '/deliverydetail' });
      } else if (type == 5) {
        //去评价

        _this.$router.push({ path: '/onlinecomment' });
      } else if (type == 6) {//查看评价
        // window.localStorage.setItem('estimateId', _this.estimateId);
        // window.localStorage.setItem('commentType', 0);
        // _this.$router.push({path: '/mycomment'})
      } else if (type == 1) {
        //申请售后
        _this.serviceList = true;
      } else if (type == 7) {
        //是否为校园卡退款单子
        if (_this.orderInfo.refundNotice) {
          _this.$messagebox.confirm('', {
            title: '退款须知',
            message: _this.orderInfo.refundNotice,
            showCancelButton: true,
            confirmButtonText: '继续申请'
          }).then(function (action) {
            _this.$router.push({ path: '/onlinerefund' });
          }).catch(function (err) {});
        } else {
          _this.$router.push({ path: '/onlinerefund' });
        }
      } else if (type == 8) {
        //退款进度
        window.localStorage.setItem('processType', 0);
        window.localStorage.setItem('complainId', _this.complainId);
        _this.$router.push({ path: 'checkcomplaints' });
      } else if (type == 9) {
        //在线投诉
        _this.$router.push({ path: '/onlinecomplaints' });
      } else if (type == 10) {
        //投诉进度
        window.localStorage.setItem('processType', 1);
        window.localStorage.setItem('complainId', _this.complainId);
        _this.$router.push({ path: 'checkcomplaints' });
      } else if (type == 11) {
        var params = {
          commercial_id: _this.orderInfo.commercialId,
          school_id: _this.orderInfo.schoolId
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getCommercialTel(_this, params, function (data) {
          _this.tel = data;
        });
      }
    },
    wxBridgeready: function wxBridgeready() {
      //开始调起微信支付
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.wxpay, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.wxpay);
          document.attachEvent('onWeixinJSBridgeReady', this.wxpay);
        }
      } else {
        this.wxpay();
      }
    },
    //微信支付
    wxpay: function wxpay() {
      var _this = this;
      var u = window.location.href.split('#')[0];
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJslbsConf(this, u, function (data) {
        var wxappid = JSON.parse(data).appId;
        var params = {
          order_id: _this.orderId,
          payType: 9,
          openid: _this.$store.state.openId
          // type:1
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (redata) {
          _this.$indicator.close();
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": wxappid, //公众号名称，由商户传入
            "timeStamp": redata.timeStamp, //时间戳，自1970年以来的秒数
            "nonceStr": redata.rndStr, //随机串
            "package": redata.xpackage,
            "signType": "MD5", //微信签名方式：
            "paySign": redata.sign //微信签名
          }, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              var shopInfo = _this.$store.state.shopCodeInfo;
              var shopcode = shopInfo[_this.orderId];

              delete shopInfo[_this.orderId];
              _this.$store.commit('changeShopCodeInfo', shopInfo);
              delete _this.cartInfo[shopcode];
              _this.$store.commit('changeCartInfo', _this.cartInfo);
              _this.getOrderDetail();
            } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
              // _this.$messagebox.alert('支付失败！', '');
              alert('支付失败:' + JSON.stringify(res));
            } else {
              //alert(JSON.stringify(res))
              var u = navigator.userAgent;
              var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
              if (isAndroid) {
                // _this.$messagebox.alert('支付失败！', '');
                alert('支付失败:' + JSON.stringify(res));
              } else {
                // _this.$messagebox.alert('支付失败！', '');
                alert('支付失败:' + JSON.stringify(res));
              }
              _this.getOrderDetail();
            }
          });
        }, function () {
          _this.$indicator.close();
        });
      });
    },
    H5pay: function H5pay() {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        payType: 12 //公众号支付为9
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (data) {
        _this.$indicator.close();
        window.localStorage.setItem('orderCode', _this.orderId);
        // 跳转中间页
        var url = data.mwebUrl + '&redirect_url=' + encodeURIComponent(_this.$utils.getHost() + '/orderdetail');
        location.href = url;
      }, function (response) {
        // 响应错误回调
        _this.$indicator.close();
        if (response.data.message) {
          _this.$messagebox.alert(response.data.message, '');
        }
      });
    },
    //自提柜信息
    showSelfInfo: function showSelfInfo() {
      this.isShowSelf = true;
    },

    //去打赏西游侠
    toReward: function toReward(id) {
      window.localStorage.setItem('orderId', id);
      this.$router.push({ name: 'Reward' });
    },

    //再来一单
    moreOrder: function moreOrder(id, code, name) {
      var _this = this;
      var obj = {
        shop_code: code,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.anotherGoodsList = [];
      _this.defaultGoodsList = [];
      _this.changeGoodsInCart = [];
      _this.shopDetail = {};

      // 获取店铺商品列表
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getGoodsList(_this, { shop_id: code }, function (data) {
        _this.shopDetail = data.shop_detail; //店铺信息
        if (!_this.shopDetail.req_type) {
          data.item_list.forEach(function (item) {
            if (item.goods_list && item.goods_list.length) {
              item.goods_list = item.goods_list.map(function (secItem) {
                return _extends({}, secItem, {
                  is_special_tag: item.is_special_tag,
                  cateType: item.type
                });
              });
              _this.defaultGoodsList = _this.defaultGoodsList.concat(item.goods_list); // 商品总数据
            }
          });
        }
        // 获取再来一单商品
        _this.anotherGoodsList = _this.orderInfo.goods_list; // 再来一单商品
        if (_this.shopDetail.req_type) {
          if (_this.anotherGoodsList && _this.anotherGoodsList.length) {
            var codesList = [];
            _this.anotherGoodsList.forEach(function (item) {
              codesList.push(item.gdCode + '');
            });
            var params = {
              codes: codesList,
              shopCode: code,
              specialTag: 0,
              token: _this.$store.state.wxToken
            };
            __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopDetailList(_this, params, function (val) {
              _this.$indicator.close();
              var params1 = {
                shop_id: code,
                token: _this.$store.state.wxToken
              };
              __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getGoodsList(_this, params1, function (val1) {
                var list = val1.item_list;

                var _loop = function _loop(k) {
                  val.goods_list.forEach(function (secItem) {
                    if (secItem.tag_id == k.tag_id) {
                      secItem.is_special_tag = k.is_special_tag;
                      secItem.cateType = k.type;
                    }
                  });
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var k = _step.value;

                    _loop(k);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                _this.defaultGoodsList = val.goods_list; // 商品总数据
                _this.ToGoodsList(code, data.amount, data.real_pay, id);
              });
            });
          }
        } else {
          _this.ToGoodsList(code, data.amount, data.real_pay, id);
        }
      }, function () {});
    },
    ToGoodsList: function ToGoodsList(code, amount, real_pay, id) {
      var _this = this;
      var marketObj = {};
      var totalAmount = 0;
      _this.defaultGoodsList.filter(function (item) {
        return item.is_special_tag === 0;
      }).forEach(function (firItem) {
        _this.anotherGoodsList.forEach(function (secItem) {
          if (secItem.isGift != 2) {
            var goodsInfo = {};
            var goodsId = secItem.skuCode;
            var specAttrStr = secItem.specification || '';
            if (firItem.gd_code === secItem.gdCode) {
              var attrIdArr = [];
              var attributes = [];
              // 判断商品名称改变
              if (secItem.name != firItem.goods_name) {
                var specificationName = secItem.specification || '';
                _this.changeGoodsInCart.push({ id: secItem.skuCode, name: secItem.name + specificationName, num: 0 });
                return;
              }
              // 判断属性名称改变
              var attrsPrice = 0;
              if (secItem.attribute) {
                var totalAttr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.flattenDeep(firItem.attribute_list.map(function (item) {
                  return item.attributeList.map(function (secItem) {
                    return _extends({}, secItem, {
                      attributeTypeId: item.attributeTypeId,
                      attributeTypeName: item.attributeTypeName
                    });
                  });
                }));
                var totalAttr1 = totalAttr.filter(function (item) {
                  return !item.skuCode || item.saleStatus == 1;
                });
                var currentAttr = secItem.attribute.split('/');
                var isChange = !currentAttr.every(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(totalAttr1, { name: item });
                });
                if (isChange) {
                  return _this.changeGoodsInCart.push({
                    id: secItem.skuCode,
                    name: secItem.name + (secItem.specification ? '-' + secItem.specification : '-') + secItem.attribute,
                    num: 0
                  });
                }
                attrIdArr = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.flattenDeep(currentAttr.map(function (item) {
                  var findObj = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(totalAttr, { name: item }) || {};
                  return [findObj.attributeTypeId, findObj.id];
                }));
                attributes = currentAttr.map(function (item) {
                  var findObj = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(totalAttr, { name: item }) || {};
                  if (findObj.salePrice) {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name,
                        salePrice: findObj.salePrice,
                        skuCode: findObj.skuCode
                      }]
                    };
                  } else {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name
                      }]
                    };
                  }
                });
                // 存在加价属性
                if (secItem.attributeSkuList && secItem.attributeSkuList.length > 0) {
                  var idArray = [];
                  var newAarray = [];
                  attributes.forEach(function (ele, i) {
                    if (idArray.indexOf(attributes[i].id) === -1) {
                      newAarray.push(attributes[i]);
                      idArray.push(attributes[i].id);
                    } else {
                      newAarray.forEach(function (dom, k) {
                        if (newAarray[k].id == attributes[i].id) {
                          newAarray[k].attributeList.push(attributes[i].attributeList[0]);
                        }
                      });
                    }
                  });
                  attributes = newAarray;
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = secItem.attributeSkuList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var v = _step2.value;
                      var _iteratorNormalCompletion3 = true;
                      var _didIteratorError3 = false;
                      var _iteratorError3 = undefined;

                      try {
                        for (var _iterator3 = totalAttr[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                          var v1 = _step3.value;

                          if (v1.skuCode == v.skuCode) {
                            attrsPrice = (parseFloat(attrsPrice) + parseFloat(v1.salePrice)).toFixed(2);
                          }
                        }
                      } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }
                        } finally {
                          if (_didIteratorError3) {
                            throw _iteratorError3;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }
                if (specAttrStr.length > 0) {
                  specAttrStr += '/' + secItem.attribute;
                } else {
                  specAttrStr = secItem.attribute;
                }
              }
              var findSku = {};
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = firItem.sku_list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var obj = _step4.value;

                  if (obj.sku_id == goodsId) {
                    findSku = _extends({}, obj);
                    // 整理购物车数据
                    var singleTotalPrice = 0;
                    var singleOriginPrice = 0; // 单个商品现总价和原总价
                    var noStock = false;
                    // let findSku = _.find(firItem.sku_list, {sku_id: goodsId});

                    if (secItem.specification && secItem.specification.length > 0) {
                      // 判断规格名称改变
                      var specification = secItem.specification.substring(0, secItem.specification.indexOf('/')) || secItem.specification;
                      // let specFlag = 0
                      // firItem.sku_list.forEach(thirdItem => {
                      //   if (thirdItem.sku_id == secItem.skuCode && thirdItem.specification === specification) {
                      //     specFlag++
                      //   }
                      // })
                      if (findSku.specification != specification) {
                        _this.changeGoodsInCart.push({
                          id: secItem.skuCode,
                          name: secItem.name + secItem.specification,
                          num: 0
                        });
                        return;
                      }
                    }

                    // 判断库存
                    if (findSku.stock === 0) {
                      var _specificationName = secItem.specification || '';
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + _specificationName,
                        num: 0
                      });
                      return;
                    }
                    if (findSku.stock < secItem.buyNum) {
                      noStock = true; // 无库存
                      var _specificationName2 = secItem.specification || '';
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + _specificationName2,
                        num: findSku.stock
                      });
                      totalAmount += findSku.stock;
                    } else {
                      noStock = false; // 有库存
                      totalAmount += secItem.buyNum;
                    }
                    // 计算活动价格
                    if (attrsPrice > 0) {
                      findSku.activity_price = (parseFloat(findSku.activity_price) + parseFloat(attrsPrice)).toFixed(2);
                      findSku.sales_price = (parseFloat(findSku.sales_price) + parseFloat(attrsPrice)).toFixed(2);
                    }
                    if (findSku.num_per_goods > 0) {
                      // 是活动商品
                      singleTotalPrice = (findSku.activity_price * findSku.num_per_goods + findSku.sales_price * (secItem.buyNum - findSku.num_per_goods)).toFixed(2);
                    } else {
                      // 无活动商品
                      singleTotalPrice = (findSku.sales_price * secItem.buyNum).toFixed(2);
                    }
                    singleOriginPrice = (findSku.sales_price * secItem.buyNum).toFixed(2); // 单个折扣商品的总原价
                    goodsInfo = {
                      activeBuyNum: findSku.num_per_goods, // 活动商品限购数量
                      activePrice: findSku.activity_price,
                      activityId: findSku.activity_id,
                      cartNum: noStock ? findSku.stock : secItem.buyNum,
                      cateType: firItem.cateType, // 商品是否限购
                      gdName: secItem.name,
                      is_single_spec: firItem.is_single_spec, // 是否为单规格
                      noStock: noStock,
                      original_tag_id: firItem.tag_id,
                      restriction_num: firItem.restriction_num, // 限购数量
                      restriction_type: firItem.restriction_type, // 限购类型 0-不限购；1-每单限购
                      salePrice: findSku.sales_price,
                      singleOriginPrice: singleOriginPrice,
                      singleTotalPrice: singleTotalPrice,
                      sku_id: secItem.skuCode,
                      sku_list: firItem.sku_list,
                      specification: { id: findSku.specification_id, name: findSku.specification }, // 规格
                      specifications: findSku,
                      stock: findSku.stock,
                      tag_id1: firItem.tag_id,
                      goodsNum: findSku.num_per_goods,
                      orderNum: findSku.num_per_order,
                      leftNum: findSku.left_stock,
                      specAttrStr: specAttrStr,
                      attributes: attributes,
                      attrIdArr: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniq(attrIdArr),
                      packing_fee: firItem.packing_fee,
                      packing_fee_rule: firItem.packing_fee_rule,
                      gd_code: firItem.gd_code
                    };
                    marketObj[goodsId] = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(marketObj, goodsId, [])), [goodsInfo]);
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }
        });
      });
      _this.cartInfo[code] = {
        total: totalAmount,
        amount: amount,
        market: marketObj,
        originAmount: real_pay
        // 下架商品
      };_this.anotherGoodsList.filter(function (item) {
        return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.defaultGoodsList, { gd_code: item.gdCode });
      }).forEach(function (item) {
        if (item.isGift != 2) {
          // 去除加价购商品
          var specificationName = item.specification || '';
          _this.changeGoodsInCart.push({ id: item.skuCode, name: item.name + specificationName, num: 0 });
          return;
        }
      });
      window.localStorage.setItem('changeGoodsInCart', JSON.stringify(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqWith(_this.changeGoodsInCart, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual)));
      _this.$store.commit('changeCartInfo', _this.cartInfo); // 更新购物车总价信息
      _this.$router.push({ name: 'GoodsList', params: { orderCode: id } });
    },

    // 幸福星期天
    isShowHappySunday: function isShowHappySunday() {
      var _this = this;
      var params = {
        school_id: _this.orderInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getHappySundayShow(_this, params, function (res) {
        if (res && res.activityStatus && res.activityStatus === 1) {
          _this.showHappySunday = true;
        }
      }, function () {});
    },

    // 查看准时达保障内容
    viewPunctual: function viewPunctual() {
      this.$router.push({ name: 'PunctualArrive', query: { orderId: this.orderId } });
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//  import VConsole from 'vconsole/dist/vconsole.min.js'
//  let vConsole = new VConsole() // 初始化
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["InfiniteScroll"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'order',
  data: function data() {
    return {
      showPage: false,
      orderList: [],
      //        cacheOrderlist : [],
      hasMore: true,
      currentPage: 1,
      pageSize: 20,
      uid: null,
      loading: false,
      isOk: false,
      noNetwork: false,
      defaultGoodsList: [],
      anotherGoodsList: [],
      cartInfo: {},
      changeGoodsInCart: [],
      isShowCabinet: false,
      isShowProgress: false,
      chooseCabinetItem: {},
      clientHeight: document.documentElement.clientHeight
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.hasMore = false; // 清除滚动加载
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    next();
  },
  mounted: function mounted() {
    if (!this.$utils.isWeiXin()) {
      window.onpopstate = function () {
        // alert('1')
        history.go(1);
      };
    }
    //页面返回刷新
    window.addEventListener('pageshow', function (e) {
      console.log('pageshow');
      if (e.persisted) {
        window.location.reload();
      }
    });
  },

  activated: function activated() {
    // document.title = '我的订单';
    this.uid = this.$store.state.wxUid;
    // 来源：上海现代高校智慧后勤研究院
    // localStorage.removeItem('urlSource');
    // let url = this.$utils.resolveUrl();
    // if (url.source && url.source == 'yjy') {
    //   localStorage.setItem('urlSource','yjy');
    //   // this.$route.meta.showTab = false;
    //   document.getElementsByTagName("footer")[0].style.display = 'none';
    // }
    // if (url.school_id) {
    //   this.getSchoolStatus(url.school_id);
    // }

    this.hasMore = true;
    if (this.uid && this.uid !== "null" && this.uid !== '') {
      if (!this.$route.meta.isUseCache) {
        this.currentPage = 1;
        this.orderList = [];
        this.$indicator.open();
        this.getOrderList(true);
      }
    }
  },
  methods: {
    getOrderList: function getOrderList(flag) {
      var _this2 = this;

      var _this = this;
      this.isOk = false;
      if (!this.hasMore) {
        return;
      }
      if (flag) {
        this.showPage = false;
        this.orderList = [];
        this.currentPage = 1;
      }
      var params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].postOrderList(_this, params, function (data) {
        _this2.$indicator.close();
        if (data != null && data.list.length > 0) {
          if (data.list.length < _this2.pageSize) {
            _this2.hasMore = false;
          }
          _this2.currentPage++;

          var orderList = _this2.orderList.concat(data.list);
          _this2.orderList = orderList;
          for (var i = 0; i < _this2.orderList.length; i++) {
            if (_this2.orderList[i].goodsList && _this2.orderList[i].goodsList.length > 3) {
              _this2.orderList[i].goodsList = _this2.orderList[i].goodsList.slice(0, 3);
              _this2.orderList[i].omit = true;
            } else {
              _this2.orderList[i].omit = false;
            }
          }
          _this2.isOk = true;
        } else {
          _this2.hasMore = false;
        }
        _this2.showPage = true;
        _this2.noNetwork = false;
        _this2.$nextTick(function () {
          var goodsList = document.getElementsByClassName('order_list');
          var uid = localStorage.getItem('wxUid');
          if (uid && goodsList && goodsList[0] && _this2.orderList && _this2.orderList.length > 0) {
            var item = goodsList[0].clientHeight / _this2.orderList.length;
            var size = Math.round(_this2.clientHeight / item);
            _this2.$store.commit('changeRecordItemHeight', item);
            _this2.$store.commit('changeRecordList', _this2.orderList);
            _this2.$store.commit('changeRecordOtherHeight', 0);
            _this2.$store.commit('changeRecordPage', 'OrderList');
            _this2.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this2.orderList, 'asa_oc_order_list', 'supplierId');
          }
        });
      }, function () {
        _this2.$indicator.close();
        _this2.noNetwork = true;
      });
    },
    loadMore: function loadMore() {
      var _this3 = this;

      if (!this.hasMore) {
        return;
      }
      if (this.isOk) {
        this.loading = true;
        //          this.$indicator.open()
        setTimeout(function () {
          _this3.getOrderList(false);
          _this3.loading = false;
        }, 1000);
      }
    },
    // 取消订单
    cancelOrder: function cancelOrder(id) {
      var _this4 = this;

      this.$messagebox.confirm('确定取消订单吗?', '').then(function (action) {
        var _this = _this4;
        var params = {
          order_id: id
        };
        __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].postCancelOrder(_this, params, function (data) {
          _this.$toast('取消成功');
          _this.hasMore = true; // 重置
          _this.getOrderList(true);
        });
      }).catch(function () {});
    },
    // 催单
    reminderOrder: function reminderOrder(id) {
      var _this = this;
      var params = {
        order_id: id
      };
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].reminderOrder(_this, params, function (data) {
        _this.$toast(data.msg);
        // _this.getOrderList(true)
      });
    },
    jumpToOrder: function jumpToOrder(id, type) {
      var _this = this;
      window.localStorage.setItem('orderCode', id);
      if (type == 4) {
        _this.$router.push({ name: 'RestaurantDetail' });
      } else {
        _this.$router.push({ name: 'OrderDetail' });
      }
    },
    toGoodsList: function toGoodsList(id, name, item) {
      if (item.orderType != 4) {
        var _this = this;
        var obj = {
          shop_code: id,
          shop_name: name,
          showBlockType: 'orderDishes'
        };
        _this.$store.commit('changeState', obj);
        _this.$router.push({ name: 'GoodsList' });
      }
    },
    toComment: function toComment(id) {
      var _this = this;
      var obj = {
        orderCode: id
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'OnlineComment' });
    },
    toGoLogin: function toGoLogin() {
      this.$utils.toLogin(this);
    },
    moreOrder: function moreOrder(id, code, name) {
      var _this = this;
      var obj = {
        shop_code: code,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.anotherGoodsList = [];
      _this.defaultGoodsList = [];
      _this.changeGoodsInCart = [];
      _this.shopDetail = {};

      // 获取店铺商品列表
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getGoodsList(_this, { shop_id: code }, function (data) {
        _this.shopDetail = data.shop_detail; //店铺信息
        if (!_this.shopDetail.req_type) {
          data.item_list.forEach(function (item) {
            if (item.goods_list && item.goods_list.length) {
              item.goods_list = item.goods_list.map(function (secItem) {
                return _extends({}, secItem, {
                  is_special_tag: item.is_special_tag,
                  cateType: item.type
                });
              });
              _this.defaultGoodsList = _this.defaultGoodsList.concat(item.goods_list); // 商品总数据
            }
          });
        }
        // 获取再来一单商品
        __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getOrderDetail(_this, { order_id: id }, function (data1) {
          _this.anotherGoodsList = data1.goods_list; // 再来一单商品
          if (_this.shopDetail.req_type) {
            if (_this.anotherGoodsList && _this.anotherGoodsList.length) {
              var codesList = [];
              _this.anotherGoodsList.forEach(function (item) {
                codesList.push(item.gdCode + '');
              });
              var params = {
                codes: codesList,
                shopCode: code,
                specialTag: 0,
                token: _this.$store.state.wxToken
              };
              __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getShopDetailList(_this, params, function (val) {
                _this.$indicator.close();
                var params1 = {
                  shop_id: code,
                  token: _this.$store.state.wxToken
                };
                __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getGoodsList(_this, params1, function (val1) {
                  var list = val1.item_list;

                  var _loop = function _loop(k) {
                    val.goods_list.forEach(function (secItem) {
                      if (secItem.tag_id == k.tag_id) {
                        secItem.is_special_tag = k.is_special_tag;
                        secItem.cateType = k.type;
                      }
                    });
                  };

                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var k = _step.value;

                      _loop(k);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  _this.defaultGoodsList = val.goods_list; // 商品总数据
                  _this.ToGoodsList(code, data.amount, data.real_pay, id);
                });
              });
            }
          } else {
            _this.ToGoodsList(code, data.amount, data.real_pay, id);
          }
        });
      }, function () {});
    },
    ToGoodsList: function ToGoodsList(code, amount, real_pay, id) {
      var _this = this;
      var marketObj = {};
      var totalAmount = 0;
      _this.defaultGoodsList.filter(function (item) {
        return item.is_special_tag === 0;
      }).forEach(function (firItem) {
        // 下架商品
        _this.anotherGoodsList.forEach(function (secItem) {
          if (secItem.isGift != 2) {
            var goodsInfo = {};
            var goodsId = secItem.skuCode;
            var specAttrStr = secItem.specification || '';
            if (firItem.gd_code === secItem.gdCode) {
              var attrIdArr = [];
              var attributes = [];
              // 判断商品名称改变
              if (secItem.name != firItem.goods_name) {
                var specificationName = secItem.specification || '';
                _this.changeGoodsInCart.push({ id: secItem.skuCode, name: secItem.name + specificationName, num: 0 });
                return;
              }
              // 判断属性名称改变
              var attrsPrice = 0;
              if (secItem.attribute) {
                var totalAttr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flattenDeep(firItem.attribute_list.map(function (item) {
                  return item.attributeList.map(function (secItem) {
                    return _extends({}, secItem, {
                      attributeTypeId: item.attributeTypeId,
                      attributeTypeName: item.attributeTypeName
                    });
                  });
                }));
                var totalAttr1 = totalAttr.filter(function (item) {
                  return !item.skuCode || item.saleStatus == 1;
                });
                var currentAttr = secItem.attribute.split('/');
                var isChange = !currentAttr.every(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(totalAttr1, { name: item });
                });
                if (isChange) {
                  return _this.changeGoodsInCart.push({
                    id: secItem.skuCode,
                    name: secItem.name + (secItem.specification ? '-' + secItem.specification : '-') + secItem.attribute,
                    num: 0
                  });
                }
                attrIdArr = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flattenDeep(currentAttr.map(function (item) {
                  var findObj = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(totalAttr, { name: item }) || {};
                  return [findObj.attributeTypeId, findObj.id];
                }));
                attributes = currentAttr.map(function (item) {
                  var findObj = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(totalAttr, { name: item }) || {};
                  if (findObj.salePrice) {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name,
                        salePrice: findObj.salePrice,
                        skuCode: findObj.skuCode
                      }]
                    };
                  } else {
                    return {
                      id: findObj.attributeTypeId,
                      name: findObj.attributeTypeName,
                      attributeList: [{
                        id: findObj.id,
                        name: findObj.name
                      }]
                    };
                  }
                });
                // 存在加价属性
                if (secItem.attributeSkuList && secItem.attributeSkuList.length > 0) {
                  var idArray = [];
                  var newAarray = [];
                  attributes.forEach(function (ele, i) {
                    if (idArray.indexOf(attributes[i].id) === -1) {
                      newAarray.push(attributes[i]);
                      idArray.push(attributes[i].id);
                    } else {
                      newAarray.forEach(function (dom, k) {
                        if (newAarray[k].id == attributes[i].id) {
                          newAarray[k].attributeList.push(attributes[i].attributeList[0]);
                        }
                      });
                    }
                  });
                  attributes = newAarray;
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = secItem.attributeSkuList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var v = _step2.value;
                      var _iteratorNormalCompletion3 = true;
                      var _didIteratorError3 = false;
                      var _iteratorError3 = undefined;

                      try {
                        for (var _iterator3 = totalAttr[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                          var v1 = _step3.value;

                          if (v1.skuCode == v.skuCode) {
                            attrsPrice = (parseFloat(attrsPrice) + parseFloat(v1.salePrice)).toFixed(2);
                          }
                        }
                      } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                          }
                        } finally {
                          if (_didIteratorError3) {
                            throw _iteratorError3;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }
                if (specAttrStr.length > 0) {
                  specAttrStr += '/' + secItem.attribute;
                } else {
                  specAttrStr = secItem.attribute;
                }
              }
              var findSku = {};
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = firItem.sku_list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var obj = _step4.value;

                  if (obj.sku_id == goodsId) {
                    findSku = _extends({}, obj);
                    // 整理购物车数据
                    var singleTotalPrice = 0;
                    var singleOriginPrice = 0; // 单个商品现总价和原总价
                    var noStock = false;
                    // let findSku = _.find(firItem.sku_list, {sku_id: goodsId});

                    if (secItem.specification && secItem.specification.length > 0) {
                      // 判断规格名称改变
                      var specification = secItem.specification.substring(0, secItem.specification.indexOf('/')) || secItem.specification;
                      // let specFlag = 0
                      // firItem.sku_list.forEach(thirdItem => {
                      //   if (thirdItem.sku_id == secItem.skuCode && thirdItem.specification === specification) {
                      //     specFlag++
                      //   }
                      // })
                      if (findSku.specification != specification) {
                        _this.changeGoodsInCart.push({
                          id: secItem.skuCode,
                          name: secItem.name + secItem.specification,
                          num: 0
                        });
                        return;
                      }
                    }

                    // 判断库存
                    if (findSku.stock === 0) {
                      var _specificationName = secItem.specification || '';
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + _specificationName,
                        num: 0
                      });
                      return;
                    }
                    if (findSku.stock < secItem.buyNum) {
                      noStock = true; // 无库存
                      var _specificationName2 = secItem.specification || '';
                      _this.changeGoodsInCart.push({
                        id: secItem.skuCode,
                        name: secItem.name + _specificationName2,
                        num: findSku.stock
                      });
                      totalAmount += findSku.stock;
                    } else {
                      noStock = false; // 有库存
                      totalAmount += secItem.buyNum;
                    }
                    // 计算活动价格
                    if (attrsPrice > 0) {
                      findSku.activity_price = (parseFloat(findSku.activity_price) + parseFloat(attrsPrice)).toFixed(2);
                      findSku.sales_price = (parseFloat(findSku.sales_price) + parseFloat(attrsPrice)).toFixed(2);
                    }
                    if (findSku.num_per_goods > 0) {
                      // 是活动商品
                      singleTotalPrice = (findSku.activity_price * findSku.num_per_goods + findSku.sales_price * (secItem.buyNum - findSku.num_per_goods)).toFixed(2);
                    } else {
                      // 无活动商品
                      singleTotalPrice = (findSku.sales_price * secItem.buyNum).toFixed(2);
                    }
                    singleOriginPrice = (findSku.sales_price * secItem.buyNum).toFixed(2); // 单个折扣商品的总原价
                    goodsInfo = {
                      activeBuyNum: findSku.num_per_goods, // 活动商品限购数量
                      activePrice: findSku.activity_price,
                      activityId: findSku.activity_id,
                      cartNum: noStock ? findSku.stock : secItem.buyNum,
                      cateType: firItem.cateType, // 商品是否限购
                      gdName: secItem.name,
                      is_single_spec: firItem.is_single_spec, // 是否为单规格
                      noStock: noStock,
                      original_tag_id: firItem.tag_id,
                      restriction_num: firItem.restriction_num, // 限购数量
                      restriction_type: firItem.restriction_type, // 限购类型 0-不限购；1-每单限购
                      salePrice: findSku.sales_price,
                      singleOriginPrice: singleOriginPrice,
                      singleTotalPrice: singleTotalPrice,
                      sku_id: secItem.skuCode,
                      sku_list: firItem.sku_list,
                      specification: { id: findSku.specification_id, name: findSku.specification }, // 规格
                      specifications: findSku,
                      stock: findSku.stock,
                      tag_id1: firItem.tag_id,
                      goodsNum: findSku.num_per_goods,
                      orderNum: findSku.num_per_order,
                      leftNum: findSku.left_stock,
                      specAttrStr: specAttrStr,
                      attributes: attributes,
                      attrIdArr: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(attrIdArr),
                      packing_fee: firItem.packing_fee,
                      packing_fee_rule: firItem.packing_fee_rule,
                      gd_code: firItem.gd_code
                    };
                    marketObj[goodsId] = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(marketObj, goodsId, [])), [goodsInfo]);
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }
        });
        _this.cartInfo[code] = {
          total: totalAmount,
          amount: amount,
          market: marketObj,
          originAmount: real_pay
        };
      });
      window.localStorage.setItem('changeGoodsInCart', JSON.stringify(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqWith(_this.changeGoodsInCart, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual)));
      _this.$store.commit('changeCartInfo', _this.cartInfo); // 更新购物车总价信息
      _this.$router.push({ name: 'GoodsList', params: { orderCode: id } });
    },

    openCabinet: function openCabinet(order) {
      this.isShowCabinet = true;
      this.chooseCabinetItem = order;
    },
    cancelCab: function cancelCab() {
      this.isShowCabinet = false;
      this.isShowProgress = false;
    },
    sureCabinet: function sureCabinet() {
      var _this = this;
      var params = {
        operateType: 0,
        order_id: _this.chooseCabinetItem.orderId
        // _this.$indicator.open({text: '开柜中'})
      };_this.isShowProgress = true;
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].openCabinet(_this, params, function (data) {
        _this.isShowCabinet = false;
        _this.isShowProgress = false;
        _this.$router.push({ path: '/deviceDetail/' + _this.chooseCabinetItem.orderId });
      }, function (data) {
        _this.isShowProgress = false;
        _this.$toast(data.data.message);
      });
    },

    // 获取学校状态
    getSchoolStatus: function getSchoolStatus(schoolId) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].postSchoolStatus(_this, { school_id: schoolId }, function (data) {
        var schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_bridge__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { Indicator, MessageBox, Toast } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      propShow: false,
      dateList: [],
      currentTimeList: [],
      orderPreviewInfo: {
        canSubmit: true,
        supplier_short_name: '',
        gift_code: 0,
        gift_url: ''
      },
      defaultAddress: {}, //默认地址信息
      comment: '', //备注
      selectDateName: '', //选择日期名字
      selectDate: '', //选择日期
      selectTimeName: '', //选择时间名字
      selectTime: '', //选择时间
      selectTimeRange: '',
      timed: -1,
      createOrderId: 0,
      coupontext: '',
      discounttext: '',
      couponcount: 0,
      discount: 0,
      couponflag: false,
      discountflag: false,
      deliverSelectedtext: '',
      delivertext: '',
      delivertextvalue: '',
      bottomButtonShow: false,
      shopCode: window.localStorage.getItem('shop_code'),
      giftUrl: '',
      giftList: [],
      showMoreGift: false,
      defaultGift: {},
      couponInfo: JSON.parse(window.localStorage.getItem('selectedCoupon')),
      deliveryCouponInfo: JSON.parse(window.localStorage.getItem('selectedDeliveryCoupon')),
      orderOriginalInfo: {},
      couponsList: [],
      is_self_take_new_new: '', //是否支持自提，1是，0否
      is_take_out: '', //是否支持外送，1是，0否
      is_eat_in: '', //是否支持堂食，1是，0否
      isShow: false,
      showTake: true,
      showSelf: false,
      showEat: false,
      isSelect: true,
      orderType: 0,
      totalSave: '',
      selfTakeMp: '',
      timeTitle: '选择送达时间',
      isCanSubmit: true, //是否可以提交订单,
      orderSubmitType: 2,
      couponMobile: '', //预检：验证优惠券需要的电话
      hikes: [], //加价购商品列表,
      remarks: '',
      placeholder: '',
      placeholder1: '',
      showRemarks: false,
      banners: [],
      source: '',
      jdlwTokenStr: '', // 京东梨涡
      showFeeTips: false, // 显示配送费说明

      showChoseBuilding: true, // 自提楼栋
      showBuildingPop: false,
      buildInfo: [{ id: ' ', name: '请选择', checked: true }, { id: ' ', checked: false }, { id: ' ', checked: false }],
      buildingList: [],
      pickUpAddress: {},

      schoolCardCode: '',

      couponPackageList: [], // 券包
      //楼层
      deliveryPopup: false,
      deliveryWay: '',
      upstairsDelivery: 0,
      versionAgreement: {},
      buyInsurance: null
    };
  },

  computed: {
    cartInfo: function cartInfo() {
      return this.$store.state.cartInfo;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    },
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    }
  },
  mounted: function mounted() {
    var weakThis = this;
    this.initSDKToken().then(function (token) {
      var sdkToken = token.sdkToken,
          sdkTokenError = token.sdkTokenError;

      console.log(token);
      weakThis.jdlwTokenStr = sdkToken;
    }).catch(function (err) {
      console.error(err);
    });
  },
  created: function created() {
    var _this = this;
    // document.title = '确认下单';
    if (window.localStorage.getItem('shopType') || window.localStorage.getItem('is_take_out') || window.localStorage.getItem('is_eat_in')) {
      _this.is_self_take_new = window.localStorage.getItem('shopType');
      _this.is_take_out = window.localStorage.getItem('is_take_out');
      _this.is_eat_in = window.localStorage.getItem('is_eat_in');

      if (_this.is_take_out == 1) {
        _this.orderType = 0; //外卖
      } else if (_this.is_self_take_new == 1 && _this.is_take_out == 0 && _this.is_eat_in == 0) {
        _this.orderType = 1; //仅自提
      } else if (_this.is_eat_in == 1 && _this.is_self_take_new == 0 && _this.is_take_out == 0) {
        _this.orderType = 3; //仅堂食
      } else if (_this.is_self_take_new == 1 && _this.is_eat_in == 1 && _this.is_take_out == 0) {
        _this.orderType = 1; //自提+堂食
      }
    }

    if (window.localStorage.getItem('order-type')) {
      //订单类型 0-配送单，1-自提单，2-西游侠打赏订单，3-堂食订单
      _this.orderType = window.localStorage.getItem('order-type');
    }
    // console.log(_this.orderType)
    if (_this.orderType == 0) {
      _this.isShow = true;
      _this.showTake = true;
      _this.showSelf = false;
      _this.showEat = false;
      _this.timeTitle = '选择送达时间';
    } else if (_this.orderType == 1) {
      _this.showSelf = true;
      _this.isShow = false;
      _this.showTake = false;
      _this.showEat = false;
      _this.timeTitle = '选择取货时间';
    } else {
      _this.isShow = false;
      _this.showTake = false;
      _this.showSelf = false;
      _this.showEat = true;
      _this.timeTitle = '选择就餐时间';
    }
    if (window.localStorage.getItem("chooseAddress")) {
      _this.defaultAddress = JSON.parse(window.localStorage.getItem("chooseAddress"));
      // _this.defaultAddress.mp = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption)
      _this.defaultAddress.mp_real = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption);
      // _this.defaultAddress.addressee = _this.$utils.Decrypt(_this.defaultAddress.addressee_encryption)
    }
    // console.log(_this.defaultAddress)
    if (window.localStorage.getItem('orderPreviewType') == 1) {
      if (window.localStorage.getItem('orderPreviewInfo')) {
        var orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
        if (orderPreviewInfo.right_hikes && orderPreviewInfo.right_hikes.length > 0) {
          //加价购
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = orderPreviewInfo.right_hikes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              item.showHikes = false;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        // 多规格
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = orderPreviewInfo.right_goods[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            if (_item.specification) {
              var AttrStr = [];
              if (_item.attributes && _item.attributes.length > 0) {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = _item.attributes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item2 = _step5.value;
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                      for (var _iterator6 = item2.attributeList[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var item3 = _step6.value;

                        AttrStr.push(item3.name);
                      }
                    } catch (err) {
                      _didIteratorError6 = true;
                      _iteratorError6 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                          _iterator6.return();
                        }
                      } finally {
                        if (_didIteratorError6) {
                          throw _iteratorError6;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }

                _item.specAttrStr = _item.specification.name + '/' + AttrStr.join('/');
              } else {
                _item.specAttrStr = _item.specification.name;
              }
            } else {
              var _AttrStr = [];
              if (_item.attributes && _item.attributes.length > 0) {
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                  for (var _iterator7 = _item.attributes[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _item2 = _step7.value;
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                      for (var _iterator8 = _item2.attributeList[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var _item3 = _step8.value;

                        _AttrStr.push(_item3.name);
                      }
                    } catch (err) {
                      _didIteratorError8 = true;
                      _iteratorError8 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                          _iterator8.return();
                        }
                      } finally {
                        if (_didIteratorError8) {
                          throw _iteratorError8;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError7 = true;
                  _iteratorError7 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                      _iterator7.return();
                    }
                  } finally {
                    if (_didIteratorError7) {
                      throw _iteratorError7;
                    }
                  }
                }

                _item.specAttrStr = _AttrStr.join('/');
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (orderPreviewInfo.orderFeeList && orderPreviewInfo.orderFeeList.length > 0) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = orderPreviewInfo.orderFeeList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var v = _step3.value;

              if (v.isShowDesc && v.isShowDesc === 1) {
                v.showDesc = false;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }

        _this.orderPreviewInfo = orderPreviewInfo;
        _this.couponsList = _this.orderPreviewInfo.coupons || [];
        if (_this.orderPreviewInfo.promotionCouponPackageBeanList && _this.orderPreviewInfo.promotionCouponPackageBeanList.length > 0) {
          _this.getCouponPackageList();
        }
        _this.havePickUpTime = _this.orderPreviewInfo.havePickUpTime;
        if (_this.orderPreviewInfo.saveDiscount > 0) {
          _this.totalSave = parseFloat(_this.orderPreviewInfo.saveDiscount) + parseFloat(_this.orderPreviewInfo.saveDeliveryFee);
          _this.totalSave = _this.totalSave.toFixed(2);
        }

        var cansubmit = window.localStorage.getItem('canSubmit');
        if (cansubmit) {
          if (cansubmit == 1) {
            _this.orderSubmitType = 1;
            _this.orderPreviewInfo.canSubmit = false;
          } else {
            _this.orderSubmitType = 2;
            _this.orderPreviewInfo.canSubmit = true;
          }
        } else {
          if (_this.orderPreviewInfo.canSubmit == undefined) {
            _this.orderPreviewInfo.canSubmit = true;
            _this.orderSubmitType = 2;
          }
        }
        if (_this.orderPreviewInfo.gift_goods != undefined && _this.orderPreviewInfo.gift_goods.length > 0) {
          _this.giftList = _this.orderPreviewInfo.gift_goods;
          _this.defaultGift = _this.giftList[0];
        }
        if (window.localStorage.getItem('date')) {
          //有已选时间
          var dataObj = JSON.parse(window.localStorage.getItem('date')); //已选时间
          var dataListObj = JSON.parse(window.localStorage.getItem('dateList'));
          _this.dateList = dataListObj;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (_this.dateList[i].isActive == true) {
              _this.currentTimeList = _this.dateList[i].delivery_TimeList;
              _this.selectDateName2 = _this.dateList[i].delivery_date_name;
              _this.selectDate2 = _this.dateList[i].delivery_date;
            }
          }
          _this.selectDate = dataObj.selectDate;
          _this.selectDateName = dataObj.selectDateName;
          _this.selectTime = dataObj.selectTime;
          _this.selectTimeRange = dataObj.selectTimeRange;
          _this.selectTimeName = dataObj.selectTimeName;
        } else {
          if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType != 0) {
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType == 0) {
            _this.selectDateName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
            _this.selectTime = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time;
            _this.selectTimeRange = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_range;
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else {
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          }
          _this.dateList = _this.orderPreviewInfo.deliveryDateTimeList;
        }
        if (_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderPreviewInfo.deliveryWayList.length > 0) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = _this.orderPreviewInfo.deliveryWayList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var k = _step4.value;

              if (k.selected) {
                _this.deliveryWay = k.title;
                _this.upstairsDelivery = k.upstairsDelivery;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
        _this.giftUrl = _this.orderPreviewInfo.gift_url;
      }
      if (window.localStorage.getItem('selfTakeMp')) {
        _this.selfTakeMp = window.localStorage.getItem('selfTakeMp');
      }
      if (_this.orderPreviewInfo.canSubmit) {
        var ment = window.localStorage.getItem('shop_comment');
        if (ment && ment != '') {
          _this.comment = ment;
        }
      }
      if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1) {
        _this.getBuildInfo();
      }
    } else if (window.localStorage.getItem('orderPreviewType') == 2) {
      _this.postDefaultAddress(); //获取默认地址
    }

    //订单备注
    var uerRemarks = window.localStorage.getItem('remarks');
    // console.log(_this.orderPreviewInfo);
    if (uerRemarks) {
      if (_this.orderPreviewInfo.isOrderRemark) {
        _this.showRemarks = true;
      } else {
        _this.showRemarks = false;
      }
      _this.remarks = uerRemarks;
      _this.placeholder = '';
      _this.placeholder1 = '';
    } else if (_this.orderPreviewInfo.isOrderRemark && !uerRemarks) {
      _this.placeholder = _this.orderPreviewInfo.orderRemarkList ? _this.orderPreviewInfo.orderRemarkList : '请填写口味偏好';
      _this.placeholder1 = _this.orderPreviewInfo.orderRemarkColumn ? _this.orderPreviewInfo.orderRemarkColumn : '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～';
      _this.showRemarks = true;
      _this.remarks = '';
    } else {
      _this.showRemarks = false;
      _this.remarks = '';
      _this.placeholder = '请填写口味偏好';
      _this.placeholder1 = '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～';
    }

    // 打包费说明
    if (_this.orderPreviewInfo && _this.orderPreviewInfo.extraFeeList && _this.orderPreviewInfo.extraFeeList.length > 0 && _this.orderPreviewInfo.extraFeeList[0].jumpType == 500088) {
      localStorage.removeItem('packingFeeDetail');
      var packingFeeDetail = _this.orderPreviewInfo.extraFeeList[0].jumpParam;
      localStorage.setItem('packingFeeDetail', packingFeeDetail);
    }
    if (_this.orderPreviewInfo && _this.orderPreviewInfo.punctualArrive && _this.orderPreviewInfo.punctualArrive.changeAimed) {
      _this.getUserAgreement();
    }
    _this.banners = [];
    _this.getBanner();
    _this.source = _this.$utils.getCookie('source') ? _this.$utils.getCookie('source') : null;
  },

  // beforeRouteEnter(to, from, next){
  //   if(from.name == 'Payment') {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  methods: {
    // 梨涡
    initSDKToken: function initSDKToken() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_js_bridge__["a" /* callNative */])("jsGetRiskControlToken", null, { timeout: 2400 });
    },

    //外送广告位
    getBanner: function getBanner() {
      var _this = this;
      var url;
      var host = _this.$utils.getSpliceHost('adsvc');
      url = host + '/ad/app/getList.do';
      var params = {
        app_version: "5.3",
        client_type: 3,
        device_id: "123",
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: "124"
      };
      _this.$http.post(url, params).then(function (response) {
        _this.banners = response.data.data.list;
        // 响应成功回调
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      });
    },
    bannerJump: function bannerJump(item) {
      var _this = this;
      if (item.data && item.data != '{}') {
        var jump = JSON.parse(item.data);
        if (jump.isNeedLogin) {
          var uid = _this.$store.state.wxUid;
          if (uid == 'null' || uid == '' || uid == null) {
            // 如果没有登录信息先跳转登录页
            // _this.$router.push({name: 'Login'})
            _this.$utils.toLogin(_this);
          }
        }
        if (item.type === 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          };
          _this.$store.commit('changeState', obj);
          this.$router.push({ name: 'ShopList' });
        } else if (item.type === 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            window.location.href = jump.url;
          }
        }
      }
    },
    //添加备注
    toRemarks: function toRemarks() {
      this.$router.push({ name: 'OutRemarks' });
    },
    changeHikes: function changeHikes(item) {
      window.localStorage.removeItem('isSelectedCoupon');
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.orderPreviewInfo.right_hikes[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var obj = _step9.value;

          if (obj.goods_sale_id == item.goods_sale_id) {
            obj.showHikes = true;
            obj.number = 1;
            window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo));
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      this.secondCalculate();
    },

    addRefundGoods: function addRefundGoods(item) {
      window.localStorage.removeItem('isSelectedCoupon');
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this.orderPreviewInfo.right_hikes[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var obj = _step10.value;

          if (obj.goods_sale_id == item.goods_sale_id) {
            if (obj.number < obj.maxNumber) {
              obj.number++;
              window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo));
              this.secondCalculate();
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    subtractGoods: function subtractGoods(item) {
      window.localStorage.removeItem('isSelectedCoupon');
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = this.orderPreviewInfo.right_hikes[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var obj = _step11.value;

          if (obj.goods_sale_id == item.goods_sale_id) {
            if (obj.number > 1) {
              obj.number--;
            } else {
              obj.number = 0;
              obj.showHikes = false;
            }
            window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo));
            this.secondCalculate();
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    },
    // 监听滑动
    handleScroll: function handleScroll(e) {
      // console.log(e.target.scrollTop,'888')
    },

    // 切换配送方式
    switchStatus: function switchStatus(status) {
      var _this = this;
      window.localStorage.removeItem('isSelectedCoupon');
      if (_this.isCanSubmit) {
        if (status === 'take-away') {
          if (!_this.showTake) {
            _this.$toast({
              message: '因为您选择外卖配送，配送费已改变',
              duration: 2000
            });
            _this.timeTitle = '选择送达时间';
            _this.showTake = true;
            _this.showSelf = false;
            _this.showEat = false;
            _this.isShow = true;
            _this.orderType = 0; //配送
            // window.localStorage.removeItem('selectedCoupon')
            // _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'))
            // _this.isCanSubmit = false
            // window.localStorage.removeItem('date') //已选时间
            // window.localStorage.removeItem('dateList')
            _this.postDefaultAddress();
          } else {
            return false;
          }
        } else if (status === 'take-self') {
          if (!_this.showSelf) {
            if (_this.orderPreviewInfo.havePickUpTime == 1) {
              _this.timeTitle = '选择取货时间';
              _this.showSelf = true;
              _this.showTake = false;
              _this.showEat = false;
              _this.isShow = false;
              _this.orderType = 1; //字体
              // window.localStorage.removeItem('selectedCoupon')
              // _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'))
              // _this.isCanSubmit = false
              // window.localStorage.removeItem('date') //已选时间
              // window.localStorage.removeItem('dateList')
              // _this.postDefaultAddress()
            } else {
              _this.$messagebox.alert('当前时段不支持自提', '');
              _this.isCanSubmit = true;
            }
          } else {
            return false;
          }
        } else if (status === 'take-eat') {
          if (!_this.showshowEatSelf) {
            _this.timeTitle = '选择就餐时间';
            _this.showEat = true;
            _this.showTake = false;
            _this.showSelf = false;
            _this.orderType = 3; //堂食
            _this.isShow = false;
          } else {
            return false;
          }
        }
        window.localStorage.removeItem('selectedCoupon');
        window.localStorage.removeItem('selectedDeliveryCoupon');
        _this.couponInfo = JSON.parse(window.localStorage.getItem('selectedCoupon'));
        _this.deliveryCouponInfo = {};
        _this.isCanSubmit = false;
        window.localStorage.removeItem('date'); //已选时间
        window.localStorage.removeItem('dateList');
        _this.postDefaultAddress();
        window.localStorage.setItem('order-type', _this.orderType);
      } else {
        return false;
      }
    },
    inputPhone: function inputPhone(val) {
      var _this2 = this;

      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: val == 1 ? '请输入自提电话' : '请输入预留电话',
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: '请输入正确的手机号',
        inputValue: this.selfTakeMp,
        showCancelButton: true,
        showInput: true
      }).then(function (_ref) {
        var value = _ref.value,
            action = _ref.action;

        window.localStorage.setItem('userDefinedMobile', value);
        _this2.selfTakeMp = value;
        _this2.couponMobile = value;
        window.localStorage.setItem('selfTakeMp', _this2.selfTakeMp);
        _this2.secondCalculate();
      });
    },

    // 查看地图
    toCheckMap: function toCheckMap() {
      window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo));
      window.localStorage.setItem('order-type', this.orderType); //查看完地图返回显示自提页面
      window.localStorage.setItem('mapAddr', this.orderPreviewInfo.pickUpAddr);
      window.localStorage.setItem('mapPic', this.orderPreviewInfo.pickUpImage);
      this.$router.push({ name: 'Map' });
    },
    toCheckProtocol: function toCheckProtocol() {
      window.localStorage.setItem('order-type', this.orderType);
      window.localStorage.setItem('orderPreviewInfo', JSON.stringify(this.orderPreviewInfo));
      this.$router.push({ name: 'SelfTakeProtocol' });
    },
    isAgreeProtocol: function isAgreeProtocol() {
      this.isSelect = !this.isSelect;
    },
    //切换日期
    changeDate: function changeDate(id) {
      var _this = this;
      var dateList = _this.dateList;
      for (var i = 0; i < dateList.length; i++) {
        if (dateList[i].delivery_date === id) {
          dateList[i].isActive = true;
          _this.selectDate2 = dateList[i].delivery_date;
          _this.selectDateName2 = dateList[i].delivery_date_name;
          _this.currentTimeList = dateList[i].delivery_TimeList;
        } else {
          dateList[i].isActive = false;
        }
      }
      _this.dateList = dateList;
      document.getElementsByClassName('select-time')[0].scrollTop = 0;
    },
    inputFocus: function inputFocus() {
      document.getElementsByTagName('footer')[0].classList.remove('fixed');
    },
    inputBlur: function inputBlur() {
      document.getElementsByTagName('footer')[0].classList.add('fixed');
    },
    // 获取用户默认地址
    postDefaultAddress: function postDefaultAddress() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postDefaultAddress(_this, { school_id: this.$store.state.schoolInfo.schoolId }, function (data) {
        // 未设置默认地址的时候，返回的是最新地址
        console.log('---- 获取用户默认地址 ----');
        console.log(data);
        console.log('---- 获取用户默认地址 ----');
        if (data && data.mp) {
          _this.defaultAddress = data;
          _this.defaultAddress.mp_real = _this.$utils.Decrypt(_this.defaultAddress.mp_encryption);
          if (window.localStorage.getItem('userDefinedMobile')) {
            _this.selfTakeMp = window.localStorage.getItem('userDefinedMobile');
          } else {
            _this.selfTakeMp = _this.defaultAddress.mp_real;
          }
          window.localStorage.setItem('chooseAddress', JSON.stringify(data));
        } else {
          // console.log(data)
          // data.mp = _this.$utils.Decrypt(data.mp_encryption);
          // data.addressee = _this.$utils.Decrypt(data.addressee_encryption);
          if (window.localStorage.getItem('userDefinedMobile')) {
            _this.selfTakeMp = window.localStorage.getItem('userDefinedMobile');
          } else {
            _this.selfTakeMp = _this.$store.state.userInfo.mp;
            console.log(_this.$store.state.userInfo.mp_real);
          }
          window.localStorage.removeItem("chooseAddress");
        }
        // if(_this.orderType == 0){
        //   _this.couponMobile = _this.defaultAddress.mp_real
        // }else{
        //   _this.couponMobile = _this.selfTakeMp
        // }
        _this.couponMobile = _this.selfTakeMp;
        window.localStorage.setItem('selfTakeMp', _this.selfTakeMp);
        _this.secondCalculate();
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    toggleProp: function toggleProp() {
      var _this = this;
      _this.propShow = !_this.propShow;
    },
    toggleDeliveryProp: function toggleDeliveryProp() {
      var _this = this;
      _this.deliveryPopup = !_this.deliveryPopup;
    },
    choseDelivery: function choseDelivery(item) {
      var _this = this;
      var list = _this.orderPreviewInfo.deliveryWayList;
      if (item.isCanSelect) {
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = list[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var k = _step12.value;

            if (k.upstairsDelivery == item.upstairsDelivery) {
              k.selected = 1;
            } else {
              k.selected = 0;
            }
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        _this.upstairsDelivery = item.upstairsDelivery;
        _this.deliveryPopup = false;
        _this.orderPreviewInfo.deliveryWayList = list;
        _this.deliveryWay = item.title;
        this.secondCalculate();
      } else {
        _this.$messagebox({
          title: '',
          message: item.reason,
          showCancelButton: false
        });
      }
    },

    jumpToaddress: function jumpToaddress() {
      window.localStorage.setItem('shop_comment', this.comment);
      window.localStorage.setItem('fromPage', 'OrderSettle');
      this.$router.push({ path: '/addresslist' });
    },
    // 更改配送时间
    changeTime: function changeTime(time, name, item) {
      if (time != -1) {
        var _this = this;
        _this.selectDate = _this.selectDate2;
        _this.selectDateName = _this.selectDateName2;
        _this.selectTime = time;
        _this.selectTimeName = name;
        if (item.delivery_time_range) {
          _this.selectTimeRange = item.delivery_time_range;
        }
        _this.toggleProp();
        var obj = {
          selectDate: _this.selectDate,
          selectDateName: _this.selectDateName,
          selectTime: _this.selectTime,
          selectTimeName: _this.selectTimeName,
          selectTimeRange: _this.selectTimeRange
        };
        window.localStorage.setItem('date', JSON.stringify(obj));
        window.localStorage.setItem('dateList', JSON.stringify(_this.dateList));
        this.secondCalculate();
      }
    },
    changeGift: function changeGift(item) {
      var _this = this;
      for (var i = 0; i < _this.giftList.length; i++) {
        if (item.goods_sale_id == _this.giftList[i].goods_sale_id) {
          _this.giftList[i].is_selected = 1;
        } else {
          _this.giftList[i].is_selected = 0;
        }
      }
      _this.defaultGift = item;
      _this.showMoreGift = false;
    },
    selectGift: function selectGift() {
      var _this = this;
      _this.showMoreGift = !_this.showMoreGift;
    },
    //选择优惠券
    toSelectCoupon: function toSelectCoupon(flag) {
      if (this.orderType == 0) {
        //外卖
        if (JSON.stringify(this.defaultAddress) === '{}') {
          this.$messagebox.alert('请添加收货地址', '');
        } else {
          this.selectCoupon(flag);
        }
      } else {
        this.selectCoupon(flag);
      }
    },
    selectCoupon: function selectCoupon(flag) {
      var _this = this;
      window.localStorage.removeItem('couponList');
      window.localStorage.removeItem('unValidCoupons');
      if (_this.orderOriginalInfo.canSubmit == undefined) {
        _this.orderOriginalInfo.canSubmit = true;
        window.localStorage.setItem('canSubmit', 2);
        _this.orderSubmitType = 2;
      } else if (_this.orderOriginalInfo.canSubmit == false) {
        window.localStorage.setItem('canSubmit', 1);
        _this.orderSubmitType = 1;
      } else if (_this.orderOriginalInfo.canSubmit == true) {
        window.localStorage.setItem('canSubmit', 2);
        _this.orderSubmitType = 2;
      }

      window.localStorage.setItem('order-type', _this.orderType);
      if (flag == 1) {
        if (_this.orderPreviewInfo.coupons) {
          var objStr = JSON.stringify(_this.orderPreviewInfo.coupons);
          window.localStorage.setItem('couponList', objStr);
        }
        ;
        if (_this.orderPreviewInfo.unValidCoupons) {
          var objStr2 = JSON.stringify(_this.orderPreviewInfo.unValidCoupons);
          window.localStorage.setItem('unValidCoupons', objStr2);
        }
        _this.$router.push({ path: '/selectcoupon/1' });
      } else if (flag == 2) {
        if (_this.orderPreviewInfo.deliveryFeeCoupons) {
          var objStr = JSON.stringify(_this.orderPreviewInfo.deliveryFeeCoupons);
          window.localStorage.setItem('deliveryFeeCoupons', objStr);
        }
        ;
        if (_this.orderPreviewInfo.unValidDeliveryFeeCoupons) {
          var objStr2 = JSON.stringify(_this.orderPreviewInfo.unValidDeliveryFeeCoupons);
          window.localStorage.setItem('unValidDeliveryFeeCoupons', objStr2);
        }
        _this.$router.push({ path: '/selectcoupon/2' });
      }

      if (_this.orderPreviewInfo.right_hikes && _this.orderPreviewInfo.right_hikes.length > 0) {
        _this.hikes = [];
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = _this.orderPreviewInfo.right_hikes[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var item = _step13.value;

            if (item.number > 0) {
              _this.hikes.push(item);
            }
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
              _iterator13.return();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }

        window.localStorage.setItem('hikes', JSON.stringify(_this.hikes));
      }
    },
    // 二次预检
    secondCalculate: function secondCalculate() {
      var _this = this;
      _this.orderOriginalInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
      var cansubmit = window.localStorage.getItem('canSubmit');
      if (cansubmit) {
        if (cansubmit == 1) {
          _this.orderSubmitType = 1;
          _this.orderOriginalInfo.canSubmit = false;
        } else {
          _this.orderSubmitType = 2;
          _this.orderOriginalInfo.canSubmit = true;
        }
      } else {
        if (_this.orderOriginalInfo.canSubmit == undefined) {
          _this.orderOriginalInfo.canSubmit = true;
          _this.orderSubmitType = 2;
        }
      }
      var goodsList = _this.orderOriginalInfo.right_goods;
      var goods = [];
      for (var i = 0; i < goodsList.length; i++) {
        goods[i] = {
          goods_sale_id: goodsList[i].goods_sale_id,
          number: goodsList[i].number,
          original_price: goodsList[i].ori_price,
          price: goodsList[i].price
        };
        if (goodsList[i].attributePrice || goodsList[i].attributePrice === 0) {
          goods[i].attributePrice = goodsList[i].attributePrice;
        }
        if (goodsList[i].specification) {
          goods[i].specification = goodsList[i].specification;
        }
        if (goodsList[i].attributes) {
          //属性
          goods[i].attributes = goodsList[i].attributes;
        }
      }
      for (var i = 0; i < goods.length; i++) {
        if (goods[i].original_price === undefined) {
          delete goods[i].original_price;
        }
      }
      var hikes = [],
          isSelectedCoupon = void 0; //加价购
      if (window.localStorage.getItem('isSelectedCoupon')) {
        isSelectedCoupon = window.localStorage.getItem('isSelectedCoupon');
      } else {
        isSelectedCoupon = false;
      }
      if (isSelectedCoupon) {
        //选择优惠券后预检
        if (window.localStorage.getItem('hikes')) {
          _this.hikes = JSON.parse(window.localStorage.getItem('hikes'));
          if (_this.hikes && _this.hikes.length > 0) {
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
              for (var _iterator14 = _this.hikes[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                var item = _step14.value;

                if (item.number > 0) {
                  hikes.push(item);
                }
              }
            } catch (err) {
              _didIteratorError14 = true;
              _iteratorError14 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion14 && _iterator14.return) {
                  _iterator14.return();
                }
              } finally {
                if (_didIteratorError14) {
                  throw _iteratorError14;
                }
              }
            }
          }
        }
      } else {
        //非选择优惠券后预检
        if (_this.orderOriginalInfo.right_hikes && _this.orderOriginalInfo.right_hikes.length > 0) {
          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = _this.orderOriginalInfo.right_hikes[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var _item4 = _step15.value;

              if (_item4.number > 0) {
                hikes.push(_item4);
              }
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }
        }
      }
      // console.log(goods)
      var params = {
        school_id: _this.schoolInfo.schoolId,
        supplier_id: _this.orderOriginalInfo.supplier_id,
        supplier_short_name: _this.orderOriginalInfo.supplier_short_name,
        goods: goods,
        hikes: hikes,
        // client_type: 7,
        orderType: _this.orderType, //1支持自提，0不支持自提
        mobile: _this.couponMobile
        // 如果有默认地址，传默认地址经纬度
      };var chooseAddress = window.localStorage.getItem('chooseAddress');
      if (chooseAddress) {
        if (JSON.parse(chooseAddress).isLimitFloor) {
          params.buildingId = JSON.parse(chooseAddress).build_id;
          params.building = JSON.parse(chooseAddress).build_name;
          params.floorId = JSON.parse(chooseAddress).floor_id;
          params.floor = JSON.parse(chooseAddress).floor_name;
          params.roomId = JSON.parse(chooseAddress).room_id;
          params.room = JSON.parse(chooseAddress).room_name;
          params.isSelectAddress = 1;
        } else {
          params.isSelectAddress = 1;
          params.address_lng = JSON.parse(chooseAddress).lon;
          params.address_lat = JSON.parse(chooseAddress).lat;
        }
      }
      if (_this.couponInfo) {
        //选择了优惠券
        params.user_coupon_id = _this.couponInfo.user_coupon_id;
      }
      if (_this.deliveryCouponInfo && _this.deliveryCouponInfo.user_coupon_id) {
        //选择了优惠券
        params.deliveryFeeUserCouponId = _this.deliveryCouponInfo.user_coupon_id;
        params.isUseDeliveryFeeCoupon = true;
      } else {
        params.isUseDeliveryFeeCoupon = false;
      }
      params.upstairsDelivery = _this.upstairsDelivery;
      if (_this.selectDate) {
        params.delivery_date = _this.selectDate;
      }
      if (_this.selectTime) {
        params.delivery_time = _this.selectTime;
      }
      if (_this.selectTimeRange) {
        params.delivery_time_range = _this.selectTimeRange;
      }
      if (_this.buyInsurance) {
        params.buyInsurance = _this.buyInsurance;
      }
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postOrderPreview(_this, params, function (data) {
        data.canSubmit = _this.orderOriginalInfo.canSubmit;
        if (data.right_hikes) {
          var _iteratorNormalCompletion16 = true;
          var _didIteratorError16 = false;
          var _iteratorError16 = undefined;

          try {
            for (var _iterator16 = data.right_hikes[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
              var _item5 = _step16.value;

              if (_item5.number > 0) {
                _item5.showHikes = true;
              } else {
                _item5.showHikes = false;
              }
            }
          } catch (err) {
            _didIteratorError16 = true;
            _iteratorError16 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion16 && _iterator16.return) {
                _iterator16.return();
              }
            } finally {
              if (_didIteratorError16) {
                throw _iteratorError16;
              }
            }
          }
        }

        // 多规格
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
          for (var _iterator17 = data.right_goods[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
            var _item6 = _step17.value;

            if (_item6.specification) {
              var AttrStr = [];
              if (_item6.attributes && _item6.attributes.length > 0) {
                var _iteratorNormalCompletion20 = true;
                var _didIteratorError20 = false;
                var _iteratorError20 = undefined;

                try {
                  for (var _iterator20 = _item6.attributes[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                    var item2 = _step20.value;
                    var _iteratorNormalCompletion21 = true;
                    var _didIteratorError21 = false;
                    var _iteratorError21 = undefined;

                    try {
                      for (var _iterator21 = item2.attributeList[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                        var item3 = _step21.value;

                        AttrStr.push(item3.name);
                      }
                    } catch (err) {
                      _didIteratorError21 = true;
                      _iteratorError21 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion21 && _iterator21.return) {
                          _iterator21.return();
                        }
                      } finally {
                        if (_didIteratorError21) {
                          throw _iteratorError21;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError20 = true;
                  _iteratorError20 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion20 && _iterator20.return) {
                      _iterator20.return();
                    }
                  } finally {
                    if (_didIteratorError20) {
                      throw _iteratorError20;
                    }
                  }
                }

                _item6.specAttrStr = _item6.specification.name + '/' + AttrStr.join('/');
              } else {
                _item6.specAttrStr = _item6.specification.name;
              }
            } else {
              var _AttrStr2 = [];
              if (_item6.attributes && _item6.attributes.length > 0) {
                var _iteratorNormalCompletion22 = true;
                var _didIteratorError22 = false;
                var _iteratorError22 = undefined;

                try {
                  for (var _iterator22 = _item6.attributes[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                    var _item7 = _step22.value;
                    var _iteratorNormalCompletion23 = true;
                    var _didIteratorError23 = false;
                    var _iteratorError23 = undefined;

                    try {
                      for (var _iterator23 = _item7.attributeList[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                        var _item8 = _step23.value;

                        _AttrStr2.push(_item8.name);
                      }
                    } catch (err) {
                      _didIteratorError23 = true;
                      _iteratorError23 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion23 && _iterator23.return) {
                          _iterator23.return();
                        }
                      } finally {
                        if (_didIteratorError23) {
                          throw _iteratorError23;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError22 = true;
                  _iteratorError22 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion22 && _iterator22.return) {
                      _iterator22.return();
                    }
                  } finally {
                    if (_didIteratorError22) {
                      throw _iteratorError22;
                    }
                  }
                }

                _item6.specAttrStr = _AttrStr2.join('/');
              }
            }
          }
        } catch (err) {
          _didIteratorError17 = true;
          _iteratorError17 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion17 && _iterator17.return) {
              _iterator17.return();
            }
          } finally {
            if (_didIteratorError17) {
              throw _iteratorError17;
            }
          }
        }

        if (data.orderFeeList && data.orderFeeList.length > 0) {
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = data.orderFeeList[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var v = _step18.value;

              if (v.isShowDesc && v.isShowDesc == 1) {
                v.showDesc = false;
              }
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }
        }
        _this.orderPreviewInfo = data;
        _this.couponsList = _this.orderPreviewInfo.coupons || [];
        if (_this.orderPreviewInfo.saveDiscount > 0) {
          //优惠后的价格
          _this.totalSave = parseFloat(_this.orderPreviewInfo.saveDiscount) + parseFloat(_this.orderPreviewInfo.saveDeliveryFee);
          _this.totalSave = _this.totalSave.toFixed(2);
        }
        if (_this.orderPreviewInfo.gift_goods != undefined && _this.orderPreviewInfo.gift_goods.length > 0) {
          //有赠品
          _this.giftList = _this.orderPreviewInfo.gift_goods;
          _this.defaultGift = _this.giftList[0];
        }
        if (window.localStorage.getItem('date')) {
          var dataObj = JSON.parse(window.localStorage.getItem('date')); //已选时间
          var dataListObj = JSON.parse(window.localStorage.getItem('dateList'));
          _this.dateList = dataListObj;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (_this.dateList[i].isActive == true) {
              _this.currentTimeList = _this.dateList[i].delivery_TimeList;
              _this.selectDateName2 = _this.dateList[i].delivery_date_name;
              _this.selectDate2 = _this.dateList[i].delivery_date;
            }
          }
          _this.selectDate = dataObj.selectDate;
          _this.selectDateName = dataObj.selectDateName;
          _this.selectTime = dataObj.selectTime;
          _this.selectTimeRange = dataObj.selectTimeRange;
          if (_this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList && _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time == 0 && dataObj.selectTime == 0) {
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
            _this.dateList[0].delivery_TimeList = _this.currentTimeList;
            _this.selectDateName2 = _this.dateList[0].delivery_date_name;
            _this.selectDate2 = _this.dateList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
          } else {
            _this.selectTimeName = dataObj.selectTimeName;
          }
        } else {
          //没有选择过时间
          _this.dateList = _this.orderPreviewInfo.deliveryDateTimeList;
          for (var i = 0; i < _this.dateList.length; i++) {
            if (i === 0) {
              _this.dateList[i].isActive = true;
            } else {
              _this.dateList[i].isActive = false;
            }
          }
          if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType != 0) {
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else if (_this.orderPreviewInfo.is_in_business == 1 && _this.orderType == 0) {
            _this.selectDateName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectTimeName = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_name;
            _this.selectTime = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time;
            _this.selectTimeRange = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList[0].delivery_time_range;
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          } else {
            _this.selectDate2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date;
            _this.selectDateName2 = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_date_name;
            _this.selectDateName = '未选择（必选）';
            _this.selectDate = '';
            _this.selectTimeName = '';
            _this.selectTime = '';
            _this.selectTimeRange = '';
            _this.currentTimeList = _this.orderPreviewInfo.deliveryDateTimeList[0].delivery_TimeList;
          }
        }
        _this.giftUrl = _this.orderPreviewInfo.gift_url;
        if (_this.orderPreviewInfo.canSubmit) {
          var ment = window.localStorage.getItem('shop_comment');
          if (ment && ment != '') {
            _this.comment = ment;
          }
        }
        if (_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderPreviewInfo.deliveryWayList.length > 0) {
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = _this.orderPreviewInfo.deliveryWayList[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var k = _step19.value;

              if (k.selected) {
                _this.deliveryWay = k.title;
                _this.upstairsDelivery = k.upstairsDelivery;
              }
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }
        }
        _this.isCanSubmit = true;
        window.localStorage.setItem('orderPreviewInfo', JSON.stringify(_this.orderPreviewInfo));
        if (data.flag === 2001) {
          var goodsInfo = '',
              hikesInfo = '';
          if (data.update_goods && data.update_goods.length > 0) {
            //商品信息有误
            goodsInfo = data.update_goods[0].good_name + data.update_goods[0].message;
          }
          if (data.update_hikes && data.update_hikes.length > 0) {
            //加价购商品信息有误
            hikesInfo = data.update_hikes[0].good_name + data.update_hikes[0].message;
          }
          if (data.update_goods && data.update_goods.length > 0 && data.update_hikes && data.update_hikes.length > 0) {
            _this.$messagebox({
              title: '',
              message: goodsInfo + hikesInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            });
          } else if (data.update_goods && data.update_goods.length > 0) {
            _this.$messagebox({
              title: '',
              message: goodsInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            });
          } else if (data.update_hikes && data.update_hikes.length > 0) {
            _this.$messagebox({
              title: '',
              message: hikesInfo + '</br>已为您重新计算价格',
              showCancelButton: false
            });
          }
          return;
        }
        if (data.flag === 3005) {
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: false
          });
          return;
        }
        if (data.flag === 8001 && data.deliveryMode) {
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: true,
            confirmButtonText: '查看详情',
            cancelButtonText: '取消'
          }).then(function (res) {
            // console.log(res);
            if (res == 'confirm') {
              _this.$router.push({ path: '/findbuild' });
            }
          });
          return;
        }
        if (data.flag === 8001) {
          _this.$messagebox({
            title: '',
            message: data.message,
            showCancelButton: false
          });
          return;
        }
        if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1) {
          _this.getBuildInfo();
        }
      }, function (data) {
        _this.$messagebox.alert(data.data.message, '');
      });
    },
    //修改备注
    changeComment: function changeComment() {
      if (this.remarks.length > 0) {
        window.localStorage.setItem('remarks', this.remarks);
      }
    },

    // 提交订单
    createOrder: function createOrder() {
      var _this = this;
      if (_this.orderPreviewInfo.canSubmit) {
        if (_this.orderType == 0) {
          if (JSON.stringify(_this.defaultAddress) == '{}') {
            _this.$messagebox.alert('收货地址不能为空', '');
            return false;
          }
          if (_this.orderPreviewInfo.isCanChooseDeliveryWay && !_this.upstairsDelivery) {
            _this.$messagebox.alert('配送方式不能为空', '');
            return false;
          }
          if (_this.selectTime == '-1') {
            _this.$messagebox.alert('今天已不能配送啦', '');
            return false;
          }
        } else if (_this.orderType == 1) {
          if (_this.selfTakeMp == null || _this.selfTakeMp == '' || _this.selfTakeMp == undefined) {
            _this.$messagebox.alert('手机号不能为空', '');
            return false;
          }
          var phonereg = /^1\d{10}$/;
          var phonereg2 = /^1\d{2}[*]{6}\d{2}/;
          // if (!phonereg.test(_this.selfTakeMp)) {
          if (!phonereg.test(_this.selfTakeMp) && !phonereg2.test(_this.selfTakeMp)) {
            _this.$messagebox.alert('请输入正确的手机号', '');
            return false;
          }

          if (!_this.isSelect) {
            _this.$messagebox.alert('同意服务协议才能下单', '');
            return false;
          }
          if (_this.orderPreviewInfo.needBuild) {
            var _iteratorNormalCompletion24 = true;
            var _didIteratorError24 = false;
            var _iteratorError24 = undefined;

            try {
              for (var _iterator24 = _this.buildInfo[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                var v = _step24.value;

                if (!v.name || v.name == '请选择') {
                  _this.$messagebox.alert('请选择楼栋信息', '');
                  return false;
                }
              }
            } catch (err) {
              _didIteratorError24 = true;
              _iteratorError24 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion24 && _iterator24.return) {
                  _iterator24.return();
                }
              } finally {
                if (_didIteratorError24) {
                  throw _iteratorError24;
                }
              }
            }
          }
        } else {
          if (_this.selfTakeMp == null || _this.selfTakeMp == '' || _this.selfTakeMp == undefined) {
            _this.$messagebox.alert('手机号不能为空', '');
            return false;
          }
          var phonereg = /^1\d{10}$/;
          if (!phonereg.test(_this.selfTakeMp)) {
            _this.$messagebox.alert('请输入正确的手机号', '');
            return false;
          }
        }
        var params;
        // 配送方式为送货上门
        var rightGoods = [];
        if (_this.orderPreviewInfo.right_goods) {
          rightGoods = _this.orderPreviewInfo.right_goods;
        }
        var goods = [],
            gifts = [];
        if (rightGoods.length > 0) {
          for (var i = 0; i < rightGoods.length; i++) {
            var good = {};
            good.goods_sale_id = rightGoods[i].goods_sale_id + '';
            good.price = rightGoods[i].price;
            if (rightGoods[i].ori_price) {
              good.ori_price = rightGoods[i].ori_price;
            }
            good.number = rightGoods[i].number;
            if (rightGoods[i].specification) {
              good.specification = rightGoods[i].specification;
            }
            if (rightGoods[i].attributes) {
              good.attributes = rightGoods[i].attributes;
            }
            if (rightGoods[i].attributePrice || rightGoods[i].attributePrice === 0) {
              good.attributePrice = rightGoods[i].attributePrice;
            }
            goods.push(good);
          }
        }
        if (JSON.stringify(_this.defaultGift) != "{}") {
          var good = {};
          good.goods_sale_id = _this.defaultGift.goods_sale_id + '';
          good.price = _this.defaultGift.price;
          if (_this.defaultGift.ori_price) {
            good.ori_price = _this.defaultGift.ori_price;
          }
          good.number = _this.defaultGift.number;
          gifts.push(good);
        }
        var gender;

        if (_this.selectDate == '' || _this.selectTime == '') {
          if (_this.orderType == 0) {
            _this.$messagebox.alert('请选择送达时间', '');
          } else if (_this.orderType == 1) {
            _this.$messagebox.alert('请选择自提时间', '');
          } else {
            _this.$messagebox.alert('请选择就餐时间', '');
          }
        } else {
          if (_this.defaultAddress.gender === '男') {
            gender = 1;
          } else {
            gender = 0;
          }

          //订单备注
          if (_this.orderPreviewInfo.isOrderRemark && !_this.remarks) {
            _this.$messagebox.alert('根据学校运营需要，本店铺订单备注必填', '');
          }

          if (_this.orderType == 0) {
            params = {
              packPrice: _this.orderPreviewInfo.packing_fee,
              consignee: _this.defaultAddress.addressee_encryption,
              consignee_tel_encryption: _this.defaultAddress.mp_encryption,
              // consignee_tel: _this.defaultAddress.mp_encryption + '',
              gender: gender,
              supplier_id: _this.orderPreviewInfo.supplier_id + '',
              address_id: _this.defaultAddress.id + '',
              address_summary: _this.defaultAddress.poi_address,
              address_detail: _this.defaultAddress.detail,
              address_lat: _this.defaultAddress.lat,
              address_lng: _this.defaultAddress.lon,
              goods: goods,
              // hikes: _this.orderPreviewInfo.right_hikes,
              gifts: gifts,
              // client_type: 7,
              delivery_date: _this.selectDate,
              delivery_time: _this.selectTime,
              delivery_time_range: _this.selectTimeRange,
              comment: _this.remarks,
              orderType: _this.orderType
            };
          } else {
            params = {
              packPrice: _this.orderPreviewInfo.packing_fee,
              // consignee_tel: _this.selfTakeMp + '',
              consignee_tel_encryption: _this.$utils.Encrypt(_this.selfTakeMp + ''),
              gender: gender,
              supplier_id: _this.orderPreviewInfo.supplier_id + '',
              goods: goods,
              // hikes: _this.orderPreviewInfo.right_hikes,
              gifts: gifts,
              // client_type: 7,
              delivery_date: _this.selectDate,
              delivery_time: _this.selectTime,
              delivery_time_range: _this.selectTimeRange,
              comment: _this.remarks,
              orderType: _this.orderType,
              pickUpAddr: _this.orderPreviewInfo.pickUpAddr
            };
            if (_this.defaultAddress.addressee) {
              // params.consignee = _this.defaultAddress.addressee_encryption;
              params.consignee = _this.$utils.Decrypt(_this.defaultAddress.addressee_encryption);
            } else {
              params.consignee = _this.$store.state.userInfo.nickname;
            }
            // console.log(_this.buildInfo)
            if (_this.orderPreviewInfo.needBuild && _this.orderPreviewInfo.needBuild == 1 && _this.orderType == 0) {
              params.building = _this.buildInfo[0].name;
              params.buildingId = _this.buildInfo[0].id;
              params.floor = _this.buildInfo[1].name;
              params.floorId = _this.buildInfo[1].id;
              params.room = _this.buildInfo[2].name;
              params.roomId = _this.buildInfo[2].id;
            }
          }
          if (_this.orderPreviewInfo.isCanChooseDeliveryWay && _this.orderType == 0) {
            //楼层
            params.buildingId = _this.defaultAddress.build_id;
            params.building = _this.defaultAddress.build_name;
            params.floorId = _this.defaultAddress.floor_id;
            params.floor = _this.defaultAddress.floor_name;
            params.roomId = _this.defaultAddress.room_id;
            params.room = _this.defaultAddress.room_name;
            params.upstairsDelivery = _this.upstairsDelivery;
          }
          if (_this.orderPreviewInfo.reductionAmount) {
            params.reductionAmount = _this.orderPreviewInfo.reductionAmount;
          }
          var hikes = []; //加价购
          if (_this.orderPreviewInfo.right_hikes) {
            var _iteratorNormalCompletion25 = true;
            var _didIteratorError25 = false;
            var _iteratorError25 = undefined;

            try {
              for (var _iterator25 = _this.orderPreviewInfo.right_hikes[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                var item = _step25.value;

                if (item.number > 0) {
                  hikes.push(item);
                }
              }
            } catch (err) {
              _didIteratorError25 = true;
              _iteratorError25 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion25 && _iterator25.return) {
                  _iterator25.return();
                }
              } finally {
                if (_didIteratorError25) {
                  throw _iteratorError25;
                }
              }
            }
          }
          params.hikes = hikes;
          if (_this.couponInfo != null) {
            params.couponAmount = _this.orderPreviewInfo.couponAmount;
            params.userCouponId = _this.couponInfo.user_coupon_id;
            params.couponId = _this.couponInfo.coupon_id;
          } else {
            delete params.couponAmount;
            delete params.userCouponId;
            delete params.coupon_id;
          }
          if (_this.orderPreviewInfo.deliveryFeeCouponId) {
            params.isUseDeliveryFeeCoupon = true;
            params.deliveryFeeCouponAmount = _this.orderPreviewInfo.deliveryFeeCouponAmount;
            params.deliveryFeeUserCouponId = _this.orderPreviewInfo.deliveryFeeUserCouponId;
            params.deliveryFeeCouponId = _this.orderPreviewInfo.deliveryFeeCouponId;
          } else {
            params.isUseDeliveryFeeCoupon = false;
            delete params.deliveryFeeCouponAmount;
            delete params.deliveryFeeUserCouponId;
            delete params.deliveryFeeCouponId;
          }

          if (_this.orderPreviewInfo.activityJoinPreCheck) {
            params.activityJoinOrder = _this.orderPreviewInfo.activityJoinPreCheck;
          }
          params.source = _this.source;

          // 下单用户类型
          if (_this.$utils.getCookie('userType') == 1 || _this.$utils.getCookie('userType') == 2) {
            params.userType = _this.$utils.getCookie('userType');
          } else {
            params.userType = 0;
          }
          // 梨涡特殊处理
          if (_this.source == 'jdlw') {
            params.h5_device_id = this.jdlwTokenStr;
          }
          // saas
          if (_this.orderPreviewInfo.reqReserved) {
            params.reqReserved = _this.orderPreviewInfo.reqReserved;
          }
          if (_this.orderPreviewInfo.punctualArrive && _this.orderPreviewInfo.punctualArrive.aimed) {
            params.buyInsurance = _this.orderPreviewInfo.punctualArrive.aimed;
          }
          window.localStorage.removeItem("remarks");
          _this.isCanSubmit = false;
          _this.$indicator.open(); //loading
          __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postOrderCreate(_this, params, function (newdata) {
            _this.$indicator.close();
            if (newdata.status === 0) {
              var code = window.localStorage.getItem('shop_code');
              var shopInfo = _this.$store.state.shopCodeInfo;
              shopInfo[newdata.orderId] = code;
              _this.createOrderId = newdata.orderId;
              window.localStorage.setItem('orderCode', _this.createOrderId);
              var shopcode = shopInfo[_this.createOrderId];
              delete shopInfo[_this.createOrderId];
              _this.$store.commit('changeShopCodeInfo', shopInfo);
              delete _this.cartInfo[shopcode];
              _this.$store.commit('changeCartInfo', _this.cartInfo);
              window.localStorage.setItem('canSubmit', 1);
              window.localStorage.setItem('orderPreviewInfo', JSON.stringify(_this.orderPreviewInfo));

              _this.orderPreviewInfo.canSubmit = false;
              window.localStorage.setItem('order-type', _this.orderType);
              window.localStorage.setItem('orderCode', _this.createOrderId);

              // 常州纺织学院支付收银台
              var cfSchoolId = void 0;
              if (true) {
                cfSchoolId = 2803;
              } else {
                cfSchoolId = 1816;
              }
              if (cfSchoolId == _this.$store.state.schoolInfo.schoolId) {
                _this.getSchoolCardInfo();
              } else {
                // 下单成功
                _this.clickLog('food_order_info');
                _this.$router.push({ name: 'Payment' });
                window.localStorage.removeItem('selectedCoupon');
                window.localStorage.removeItem('selectedDeliveryCoupon');
              }
            } else if (newdata.status === 2000) {
              //赠品校验不通过
              _this.$messagebox({
                title: '',
                confirmButtonText: '不用了，谢谢',
                cancelButtonText: '返回重选',
                message: '当前赠品已无库存，是否返回重选？',
                showCancelButton: true
              }).then(function () {
                window.localStorage.setItem('order-type', _this.orderType);
                window.localStorage.setItem('orderCode', _this.createOrderId);
                _this.clickLog('food_order_info');
                _this.$router.push({ name: 'Payment' });
                //                  if (_this.$utils.isWeiXin()) { //判断是否微信浏览器中打开
                //                    _this.wxBridgeready()
                //                  } else {
                //                    window.localStorage.setItem('order-type', _this.orderType)
                //                    window.localStorage.setItem('orderCode', _this.createOrderId);
                //                    _this.$router.push({name: 'Payment'})
                //                  }
              });
            } else if (newdata.status === 1010 || newdata.status === 3000) {
              _this.$messagebox.alert(newdata.message, '');
              _this.isCanSubmit = true;
            } else {
              // _this.$messagebox.alert(newdata.wrongGoodsList[0].msg, '')
              _this.isCanSubmit = true;
              _this.secondCalculate();
            }
          }, function (newdata) {
            _this.$indicator.close();
            _this.$messagebox.alert(newdata.data.message, '');
            _this.isCanSubmit = true;
            _this.secondCalculate();
          });
        }
      }
    },
    //新埋点
    clickLog: function clickLog(code) {
      var _this = this;
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid,
          refId: _this.createOrderId,
          firstValue: _this.schoolInfo.schoolId,
          createTime: new Date().getTime(),
          code: code
        }]
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },
    getSchoolCardInfo: function getSchoolCardInfo() {
      var _this = this;
      // _this.orderSubmitType = 2;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].schoolCardInfo(_this, { school_id: _this.$store.state.schoolInfo.schoolId }, function (data) {
        if (data && data.card_no) {
          _this.schoolCardCode = data.card_no;
        } else {
          _this.schoolCardCode = '';
        }

        _this.cfPay();
      }, function () {
        _this.cfPay();
      });
    },

    // 常州纺织学院支付收银台
    cfPay: function cfPay() {
      var _this3 = this;

      var _this = this;
      this.$messagebox({
        title: '',
        $type: 'prompt',
        message: '请输入学生卡号',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '请输入正确的学工号',
        inputValue: _this.schoolCardCode,
        showCancelButton: true,
        showInput: true
      }).then(function (_ref2) {
        var value = _ref2.value,
            action = _ref2.action;

        _this3.schoolCardCode = value;
        var params = {
          cfOrderInfo: encodeURIComponent(JSON.stringify({ accNum: value })),
          order_id: _this.createOrderId,
          payType: 92
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (data) {
          var div = document.createElement('div');
          div.innerHTML = data;
          document.body.appendChild(div);
          document.forms[0].submit();
        });
      });
    },
    wxBridgeready: function wxBridgeready() {
      //开始调起微信支付
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.wxpay, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.wxpay);
          document.attachEvent('onWeixinJSBridgeReady', this.wxpay);
        }
      } else {
        this.wxpay();
      }
    },
    //微信支付
    wxpay: function wxpay() {
      var _this = this;
      var u = window.location.href.split('#')[0];
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJslbsConf(this, u, function (data) {
        var wxappid = JSON.parse(data).appId;
        var params = {
          order_id: _this.createOrderId,
          payType: 9, //h5支付为12
          openid: _this.$store.state.openId
          //type:1 //临时变量 暂时未cbd公众号支付
        };
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (redata) {
          _this.$indicator.close();
          WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": wxappid, //公众号名称，由商户传入
            "timeStamp": redata.timeStamp, //时间戳，自1970年以来的秒数
            "nonceStr": redata.rndStr, //随机串
            "package": redata.xpackage,
            "signType": "MD5", //微信签名方式：
            "paySign": redata.sign //微信签名
          }, function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getredPacketShare(_this, { order_id: _this.createOrderId }, function (data) {
                if (data) {
                  window.localStorage.setItem('redPacket', JSON.stringify(data));
                }
              }, function () {});
            } else {
              // _this.$messagebox.alert('支付失败！', '');
              alert('支付失败:' + JSON.stringify(res));
            }
            window.localStorage.setItem('order-type', _this.orderType);
            _this.$router.push({ name: 'OrderDetail' });
          });
        }, function (data) {
          _this.$indicator.close();
          _this.$messagebox.alert(data.data.message, '');
        });
      });
    },

    // 自提选择楼栋信息
    toChoseBuilding: function toChoseBuilding() {
      this.showBuildingPop = true;
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.buildInfo[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var v = _step26.value;

          v.checked = false;
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }

      this.buildInfo[0].checked = true;
      this.getShopBuildingList();
    },
    getShopBuildingList: function getShopBuildingList() {
      var _this4 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code')
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postShopBuildList(_this, params, function (data) {
        if (data && data.length > 0) {
          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = data[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var v = _step27.value;

              v.checked = false;
              if (_this4.buildInfo[0].id) {
                if (v.id == _this4.buildInfo[0].id) {
                  v.checked = true;
                }
              }
              // if(type == 2){
              //   if(this.buildInfo[1].id){
              //     if(v.id == this.buildInfo[1].id){
              //       v.checked = true;
              //     }
              //   }
              // }else if(type == 3){
              //   if(this.buildInfo[2].id){
              //     if(v.id == this.buildInfo[2].id){
              //       v.checked = true;
              //     }
              //   }
              // }else{
              //   if(this.buildInfo[0].id){
              //     if(v.id == this.buildInfo[0].id){
              //       v.checked = true;
              //     }
              //   }
              // }
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }

          _this4.buildingList = data;
        } else {
          _this4.buildingList = [];
        }
      });
    },
    getBuildingList: function getBuildingList(type, code) {
      var _this5 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        type: type || '',
        code: code || ''
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postBuildList1(_this, params, function (data) {
        if (data && data.length > 0) {
          var _iteratorNormalCompletion28 = true;
          var _didIteratorError28 = false;
          var _iteratorError28 = undefined;

          try {
            for (var _iterator28 = data[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
              var v = _step28.value;

              v.checked = false;
              if (type == 2) {
                if (_this5.buildInfo[1].id) {
                  if (v.id == _this5.buildInfo[1].id) {
                    v.checked = true;
                  }
                }
              } else if (type == 3) {
                if (_this5.buildInfo[2].id) {
                  if (v.id == _this5.buildInfo[2].id) {
                    v.checked = true;
                  }
                }
              } else {
                if (_this5.buildInfo[0].id) {
                  if (v.id == _this5.buildInfo[0].id) {
                    v.checked = true;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError28 = true;
            _iteratorError28 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion28 && _iterator28.return) {
                _iterator28.return();
              }
            } finally {
              if (_didIteratorError28) {
                throw _iteratorError28;
              }
            }
          }

          _this5.buildingList = data;
        } else {
          _this5.buildingList = [];
        }
      });
    },
    changeBuildingTitle: function changeBuildingTitle(item, index) {
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = this.buildInfo[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var v = _step29.value;

          v.checked = false;
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      item.checked = true;
      if (index == 0) {
        this.getShopBuildingList();
      } else if (index == 1) {
        this.getBuildingList(2, this.buildInfo[0].id);
      } else if (index == 2) {
        this.getBuildingList(3, this.buildInfo[1].id);
      }
    },
    changeBuilding: function changeBuilding(item) {
      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = this.buildInfo[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var v = _step30.value;

          v.checked = false;
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = this.buildingList[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var _v = _step31.value;

          _v.checked = false;
          if (item.id == _v.id) {
            _v.checked = true;
          }
        }
        // item.checked = true;
        // console.log(this.buildingList)
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      if (item.type == 1) {
        this.buildInfo[0].id = item.id;
        this.buildInfo[0].name = item.area;
        this.buildInfo[1].checked = true;
        this.buildInfo[1].name = '请选择';
        this.buildInfo[2].name = '请选择';
        this.showChoseBuilding = true;
        this.getBuildingList(2, item.id);
      } else if (item.type == 2) {
        this.buildInfo[1].id = item.id;
        this.buildInfo[1].name = item.area;
        this.buildInfo[2].checked = true;
        this.buildInfo[2].name = '请选择';
        this.showChoseBuilding = true;
        this.getBuildingList(3, item.id);
      } else {
        this.buildInfo[2].id = item.id;
        this.buildInfo[2].name = item.area;
        this.showBuildingPop = false;
        this.showChoseBuilding = false;
        // 保存楼栋信息
        this.saveBuildInfo();
      }
    },
    saveBuildInfo: function saveBuildInfo() {
      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        // shop_id: localStorage.getItem('shop_code'),
        type: 1,
        build_id: this.buildInfo[0].id,
        build_name: this.buildInfo[0].name,
        floor_id: this.buildInfo[1].id,
        floor_name: this.buildInfo[1].name,
        room_id: this.buildInfo[2].id,
        room_name: this.buildInfo[2].name,
        lon: '',
        detail: '',
        poi_address: '',
        mp: '',
        lat: '',
        gender: '',
        addressee: '',
        is_build: 1,
        addressType: 1
      };
      if (this.pickUpAddress && this.pickUpAddress.id) {
        params.id = this.pickUpAddress.id;
      }
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].savePickupAddress(_this, params, function (data) {});
    },
    getBuildInfo: function getBuildInfo() {
      var _this6 = this;

      var _this = this;
      var params = {
        school_id: this.$store.state.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code')
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].pickupInfo(_this, params, function (data) {
        if (data) {
          _this6.pickUpAddress = data;
          _this6.buildInfo[0].id = data.build_id;
          _this6.buildInfo[0].name = data.build_name;
          _this6.buildInfo[1].id = data.floor_id;
          _this6.buildInfo[1].name = data.floor_name;
          _this6.buildInfo[2].id = data.room_id;
          _this6.buildInfo[2].name = data.room_name;
          _this6.showChoseBuilding = false;
          // console.log(this.buildInfo)
        }
      }, function (data) {
        _this.$messagebox.alert(data.data.message, '');
        _this.buildInfo = [{ id: ' ', name: '请选择', checked: true }, { id: ' ', checked: false }, {
          id: ' ',
          checked: false
        }];
      });
    },
    viewPackDesc: function viewPackDesc() {
      this.$router.push({ name: 'PackingFee' });
    },

    // 显示收费名目
    showOrderFeeDesc: function showOrderFeeDesc(item) {
      if (item.isShowDesc) {
        item.showDesc = !item.showDesc;
      }
    },

    // 获取券包
    getCouponPackageList: function getCouponPackageList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        source: 1
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackageList(_this, params, function (data) {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_order_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.couponPackageList[0].package_id,
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.shopCode
          }];
          _this.addLog1(clickParams);
        }
      });
    },

    // 购买券包
    buyCouponPackage: function buyCouponPackage(item) {
      this.$router.push({ name: 'CouponPackage', query: { id: item.package_id } });
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_order_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.schoolInfo.schoolId,
        secondValue: this.shopCode
      }];
      this.addLog1(clickParams);
    },

    // 统计埋点
    addLog1: function addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },

    // 准时达
    viewPunctualArrive: function viewPunctualArrive() {
      if (this.orderPreviewInfo.punctualArrive.jumpParam) {
        this.$router.push({ name: 'PunctualArrive' });
      }
    },
    getUserAgreement: function getUserAgreement() {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        var _this = _this7;
        __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getUserInfoFullByUid(_this, {}, function (res) {
          if (res.user_version_agreement && res.version_agreement) {
            resolve(res);
            _this7.versionAgreement = { user_version_agreement: res.user_version_agreement, version_agreement: res.version_agreement };
          }
        });
      });
    },
    changePunctualArrive: function changePunctualArrive() {
      var _this8 = this;

      var aimed = this.orderPreviewInfo.punctualArrive.aimed;
      var versionAgreement = this.versionAgreement;
      if (!versionAgreement.user_version_agreement) {
        this.getUserAgreement().then(function (res) {
          _this8.changePunctualArrive();
        });
        return;
      }
      if (versionAgreement.user_version_agreement.zsd && versionAgreement.version_agreement.zsd) {
        if ((versionAgreement.user_version_agreement.zsd.version_number || 0) < versionAgreement.version_agreement.zsd.version_number) {
          this.$messagebox({
            title: '准时达协议',
            message: versionAgreement.version_agreement.zsd.agreement_content,
            showCancelButton: true,
            confirmButtonText: '同意',
            cancelButtonText: '取消'
          }).then(function (res) {
            if (res == 'confirm') {
              _this8.submitUserAgree();
            }
          });
          return;
        }
      }
      aimed = 1 - aimed;
      this.buyInsurance = aimed;
      this.secondCalculate();
    },
    submitUserAgree: function submitUserAgree() {
      var _this9 = this;

      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].setUserSignContract(_this, { type: 1 }, function (data) {
        _this9.getUserAgreement().then(function (res) {
          _this9.changePunctualArrive();
        });
      });
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_swiper_3_4_2_min_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_swiper_3_4_2_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_swiper_3_4_2_min_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cart',
  data: function data() {
    return {
      pictureTotal: 0,
      pictureIndex: 1,
      otherDetail: JSON.parse(window.localStorage.getItem('otherDetail'))
    };
  },
  created: function created() {
    var _this = this;
    document.title = _this.otherDetail.name;
    if (_this.otherDetail.image_list.length > 0) {
      _this.pictureTotal = _this.otherDetail.image_list.length;
      _this.pictureIndex;
    }
    _this.$nextTick(function () {
      var mySwiper = new __WEBPACK_IMPORTED_MODULE_1__assets_js_swiper_3_4_2_min_js___default.a('.swiper-container', {
        onSlideChangeEnd: function onSlideChangeEnd(swiper) {
          _this.pictureIndex = swiper.activeIndex + 1;
        }
      });
    });
  },

  methods: {}
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "OutRemarks",
  data: function data() {
    return {
      comment: '',
      remarkList: [],
      placeholder: ''
    };
  },
  created: function created() {
    var _this = this;

    if (window.localStorage.getItem('orderPreviewInfo')) {
      // console.log(JSON.parse(window.localStorage.getItem('orderPreviewInfo')))
      var data = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
      if (data.usedRemarkTag && data.usedRemarkTag.length) {
        var list = data.usedRemarkTag;
        if (list.length > 10) {
          list = list.splice(0, 10);
        }
        for (var i = 0; i < data.recommendRemarkList.length; i++) {
          if (data.recommendRemarkList[i]) {
            list.push(data.recommendRemarkList[i]);
          }
        }
        _this.remarkList = list;
      } else {
        _this.remarkList = data.recommendRemarkList;
      }
    }
    var val = window.localStorage.getItem('remarks');
    if (val) {
      _this.comment = val;
    } else {
      _this.comment = '';
      _this.placeholder = data.orderRemarkColumn ? data.orderRemarkColumn : '请填写口味偏好，推荐无接触配送，将商品放在楼下或寝室门口～';
    }
  },

  methods: {
    toOrder: function toOrder() {
      window.localStorage.setItem('remarks', this.comment);
      this.$router.push({ name: 'OrderSettle' });
    },
    addTips: function addTips(val) {
      // console.log(val);
      if (this.comment == '') {
        this.comment = this.comment + val;
      } else {
        this.comment = this.comment + ',' + val;
      }
      this.comment = this.comment.slice(0, 100);
      if (this.comment.length >= 100) {
        this.$toast({
          message: '备注最多输入100字哦',
          duration: 500
        });
      }
    },
    changeComment: function changeComment() {
      // console.log(this.comment.length)
      if (this.comment.length >= 100) {
        this.$toast({
          message: '备注最多输入100字哦',
          duration: 500
        });
      }
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaySuccess',
  data: function data() {
    return {};
  },
  created: function created() {
    /** 点金小票的js，需要在head中引入 */
    var head = document.querySelector('head');
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://wx.gtimg.com/pay_h5/goldplan/js/jgoldplan-1.0.0.js';
    head.appendChild(script);
  },
  mounted: function mounted() {
    this.wxInit();
  },


  methods: {
    // 微信商家小票
    wxInit: function wxInit() {
      //初始化小票
      var mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE'
      };
      var postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    },
    toOrderDetail: function toOrderDetail() {
      localStorage.setItem('paySource', 'kq');
      var mchData = {
        action: 'jumpOut',
        jumpOutUrl: 'https://alywechat.anlaiye.com/orderdetail' //跳转的页面
      };
      var postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
      // this.$router.replace({ name: 'OrderDetail' })
    }
  }

});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PaySuccess',
  data: function data() {
    return {
      orderId: '',
      orderInfo: {},
      orderCouponList: [],
      showOrderCoupon: false,
      showPlusCard: false,
      plusCardInfo: {},
      scoreInfo: {},
      orderBonus: {},
      adList: []
    };
  },
  created: function created() {
    if (this.$route.query && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      this.getOrderDetail();
    }
  },


  methods: {
    getOrderDetail: function getOrderDetail() {
      var _this = this;
      var param = {
        order_id: this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderDetail(_this, param, function (data) {
        _this.orderInfo = data;
        _this.getOrderCoupon(); // 下单发券
        _this.getOrderCard(); // 西游集卡
        _this.getScorePartake(); // 下单预计得积分
        _this.getOrderBonus();
        _this.getAdList();
      });
    },
    toOrderDetail: function toOrderDetail() {
      this.$router.replace({ name: 'OrderDetail' });
    },
    jumpToApp: function jumpToApp() {
      location.href = 'https://dl.anlaiye.com';
    },
    jumpToScore: function jumpToScore() {
      this.$router.replace({ name: 'MyScore' });
    },

    // 下单返券
    getOrderCoupon: function getOrderCoupon() {
      var _this = this;
      var params = {
        school_id: _this.orderInfo.schoolId,
        order_id: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderCoupon(_this, params, function (res) {
        if (res && res.length > 0) {
          _this.orderCouponList = res;
          _this.showOrderCoupon = true;
        }
      }, function () {});
    },

    // 下单预计得积分
    getScorePartake: function getScorePartake() {
      var _this = this;
      var params = {
        pay_amount: _this.orderInfo.real_pay,
        event_code: 'score_order_new'
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getScorePartake(_this, params, function (res) {
        if (res) {
          _this.scoreInfo = res;
        }
      }, function () {});
    },

    // 下单立减金
    getOrderBonus: function getOrderBonus() {
      var _this = this;
      var params = {
        school_id: _this.orderInfo.schoolId,
        order_id: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderBonus(_this, params, function (res) {
        if (res) {
          _this.orderBonus = res;
        }
      }, function () {});
    },

    // 广告
    getAdList: function getAdList() {
      var _this = this;
      var url;
      var host = _this.$utils.getSpliceHost('adsvc');
      url = host + '/ad/app/getList.do';
      var params = {
        app_version: '10.0.1',
        client_type: 3,
        device_id: '123',
        time: new Date().getTime(),
        schoolId: _this.orderInfo.schoolId,
        locationId: '116'
      };
      _this.$http.post(url, params).then(function (response) {
        _this.adList = response.data.data.list;
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      });
    },
    adJump: function adJump(item) {
      var obj = { type: item.type, data: item.data };
      this.jumpFun(obj);
    },

    //新埋点
    clickLog: function clickLog(jumpType, code) {
      var _this = this;
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid,
          refId: _this.orderId,
          firstValue: _this.orderInfo.schoolId,
          secondValue: jumpType,
          createTime: new Date().getTime(),
          code: code
        }]
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },

    // 西游集卡和单单返
    getOrderCard: function getOrderCard() {
      var _this = this;
      var params = {
        school_id: _this.orderInfo.schoolId,
        order_id: _this.orderId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderCard(_this, params, function (res) {
        if (res) {
          res.des = res.des.replace(/\n/g, "<br />");
          _this.plusCardInfo = res;
          _this.showPlusCard = true;
          _this.clickLog(res.jump_type, 'asa_order_paid_suspend');
        }
      }, function () {});
    },
    jumpToCard: function jumpToCard() {
      var item = { type: this.plusCardInfo.jump_type, data: this.plusCardInfo.jump_data };
      this.clickLog(item.type, 'click_order_paid_suspend');
      this.jumpFun(item);
    },
    jumpFun: function jumpFun(item) {
      if (item.data && item.data != '{}') {
        var jump = JSON.parse(item.data);
        if (jump.isNeedLogin && jump.isNeedLogin == 'true') {
          var uid = this.$store.state.wxUid;
          if (uid == 'null' || uid == '' || uid == null) {
            // 如果没有登录信息先跳转登录页
            this.$utils.toLogin(_this);
          }
        }
        if (item.type == 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          };
          this.$store.commit('changeState', obj);
          this.$router.push({ name: 'ShopList' });
        } else if (item.type == 1022) {
          if (jump.url) {
            window.location.href = jump.url;
          }
        } else if (item.type == 500071) {
          var obj = {
            shop_code: jump.key_id,
            shop_name: jump.key_title,
            showBlockType: 'orderDishes'
          };
          this.$store.commit('changeState', obj);
          this.$router.push({ name: 'GoodsList' });
        } else if (item.type == 500066) {
          this.$router.push({ name: 'TagPage' });
        }
      }
    }
  }

});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { Indicator, MessageBox } from 'mint-ui'

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      details: "",
      timer: "",
      minutes: "",
      seconds: "",
      paymentType: 12,
      isShowGoodsList: true,
      canSubmit: true,
      pageShow: false,
      orderId: window.localStorage.getItem("orderCode"),
      isDisabled: false,
      client_type: localStorage.getItem("platformType"),
      url: "",
      title: "",
      redirectUrl: "",
      source: "",
      isShowAuth: false,
      isShowCardInfo: false,
      schoolCardCode: "",
      dlbWxAppletFlag: false,
      schoolId: "",
      cardSchoolIds: "",
      schoolCard: {
        accNum: "",
        password: ""
      },
      isShowCardInfo1: false,
      paymentDetail: {},

      orderType: localStorage.getItem("order-type"),
      returnBackUrl: localStorage.getItem("returnBack")
    };
  },
  created: function created() {
    // document.title = "在线支付"
    if (this.$route.params.reward) {
      this.title = "支付打赏";
      this.redirectUrl = "Reward";
    } else {
      this.title = "在线支付";
      this.redirectUrl = "OrderDetail";
      // 券包
      if (this.orderType && this.orderType == 8) {
        this.redirectUrl = "CouponPackageRecord";
      }
    }
    this.source = this.$utils.getCookie("source") ? this.$utils.getCookie("source") : null;
    this.getBeforePaymentInfo();
    // 云闪付支付
    if (this.$utils.isAndroid()) {
      this.url = window.localStorage.getItem("upSDKUrl");
    } else {
      this.url = window.location.href;
    }
    // 获取哆啦宝配置
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getOrderPaywayStatus(_this, {}, function (data) {
      _this.dlbWxAppletFlag = data.dlbWxAppletFlag == 1 ? true : false;
      if (_this.$utils.isWxWork()) {
        // 企业微信
        _this.dlbWxAppletFlag = false;
      }
    });

    // 浙江工商 上海理工校园卡
    this.schoolId = JSON.parse(localStorage.getItem("schoolInfo")).schoolId;
    if (true) {
      this.cardSchoolIds = [296, 335];
    } else {
      this.cardSchoolIds = [1899, 335];
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    window.clearInterval(this.timer);
    next();
  },

  methods: {
    Countdowns: function Countdowns() {
      var _this = this;
      var SysSecond = parseFloat(_this.details.dateLineOfPayment) / 1000;
      _this.timer = window.setInterval(function () {
        if (SysSecond > 0) {
          SysSecond = SysSecond - 1;
          var minutes = Math.floor(SysSecond / 60 % 60); // 计算分
          var seconds = Math.floor(SysSecond % 60); // 计算秒

          // console.log(minutes,seconds)
          if (seconds < 10) {
            _this.seconds = "0" + seconds;
          } else {
            _this.seconds = seconds;
          }
          if (minutes < 10) {
            _this.minutes = "0" + minutes;
          } else {
            _this.minutes = minutes;
          }
          //            _this.pageShow = true
        } else {
          _this.canSubmit = false;
          window.clearInterval(_this.timer);
          _this.minutes = "00";
          _this.seconds = "00";
          _this.$messagebox.alert("支付超时", "");
        }
      }, 1000);
    },
    getBeforePaymentInfo: function getBeforePaymentInfo() {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        source: _this.source
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getPayWay(_this, params, function (data) {
        _this.$indicator.close();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = data.paywayList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            // item.selected = false
            if (item.payway_id == 3) {
              // item.selected = true
            }
            if (_this.client_type == "11" && item.payway_id == 31) {
              // item.selected = true
              _this.paymentType = 31;
            }
            if (item.selected) {
              if (item.payway_id === 3) {
                // 微信支付
                _this.paymentType = 12;
              } else if (item.payway_id === 5) {
                // 支付宝支付
                _this.paymentType = 52;
              } else if (item.payway_id === 31) {
                // 云闪付支付
                _this.paymentType = 31;
              } else if (item.payway_id === 20) {
                // 校园卡支付
                _this.paymentType = 20;
                if (_this.cardSchoolIds.includes(_this.schoolId)) {
                  _this.getSchoolCardInfo();
                }
              } else if (item.payway_id === 41) {
                // 数字人民币支付
                _this.paymentType = 41;
              }
              _this.paymentDetail = item;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this.details = data;
        _this.Countdowns();
        _this.isAuthSuc();
      }, function () {
        _this.$indicator.close();
      });
    },
    selected: function selected(id) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.details.paywayList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var v = _step2.value;

          if (v.payway_id === id) {
            v.selected = true;
            if (id === 3) {
              // 微信支付
              this.paymentType = 12;
            } else if (id === 5) {
              // 支付宝支付
              this.paymentType = 52;
            } else if (id === 31) {
              // 云闪付支付
              this.paymentType = 31;
            } else if (id === 20) {
              // 校园卡支付
              this.paymentType = 20;
              if (this.cardSchoolIds.includes(this.schoolId)) {
                this.getSchoolCardInfo();
              }
            } else if (id === 41) {
              // 数字人民币支付
              this.paymentType = 41;
            }
            this.paymentDetail = v;
          } else {
            v.selected = false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    // 校园卡信息
    getSchoolCardInfo: function getSchoolCardInfo() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].schoolCardInfo(_this, { school_id: _this.$store.state.schoolInfo.schoolId }, function (data) {
        if (data && data.per_code) {
          _this.schoolCard.accNum = data.per_code;
        } else {
          _this.schoolCard.accNum = "";
        }
      });
    },
    submitSchoolCardForm: function submitSchoolCardForm() {
      if (!this.schoolCard.accNum || this.schoolCard.accNum.length == 0) {
        this.$messagebox.alert("请输入一卡通账号", "");
        return;
      }
      if (this.paymentDetail.campusAuthType === 0 && (!this.schoolCard.password || this.schoolCard.password.length == 0)) {
        this.$messagebox.alert("请输入一卡通密码", "");
        return;
      }
      if (this.canSubmit) {
        this.H5pay();
      } else {
        this.$messagebox.alert("支付超时", "");
      }
    },

    showGoodsList: function showGoodsList() {
      if (this.isShowGoodsList) {
        this.isShowGoodsList = false;
      } else {
        this.isShowGoodsList = true;
      }
    },
    confirmPay: function confirmPay() {
      if (this.canSubmit) {
        this.H5pay();
      } else {
        this.$messagebox.alert("支付超时", "");
      }
    },
    H5pay: function H5pay() {
      var _this = this;
      var params = {
        order_id: _this.orderId,
        payType: _this.paymentType,
        openid: _this.$store.state.openId, // 微信需要
        returnUrl: encodeURIComponent(this.url) // 云闪付需要
      };
      if (_this.paymentType === 52) {
        params.returnUrl = encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
        // 券包
        if (_this.orderType && _this.orderType == 8) {
          params.returnUrl = encodeURIComponent(_this.$utils.getHost() + "/couponPackage/list");
        }
      }
      if (_this.paymentType === 12) {
        if (this.$utils.isWeiXin()) {
          params.payType = _this.dlbWxAppletFlag ? 21 : 9;
        }
        // 企业微信
        if (this.$utils.isWxWork()) {
          params.payType = 12;
        }
      }
      if (_this.paymentType === 41) {
        params.payType = 41;
        params.returnUrl = encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
        // 券包
        if (_this.orderType && _this.orderType == 8) {
          params.returnUrl = encodeURIComponent(_this.$utils.getHost() + "/couponPackage/list");
        }
      }
      // 浙江工商 校园卡
      if (_this.paymentType === 20) {
        if (_this.cardSchoolIds.includes(_this.schoolId)) {
          if (!_this.isShowCardInfo1) {
            _this.isShowCardInfo1 = true;
            return;
          } else {
            params.zyOrderInfo = {
              accNum: _this.schoolCard.accNum
            };
            if (_this.paymentDetail.campusAuthType === 0) {
              params.zyOrderInfo.password = _this.$utils.Encrypt(_this.schoolCard.password);
            }
          }
        }
      }
      _this.isDisabled = true;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postWxJsPay(_this, params, function (data) {
        // 微信
        if (_this.paymentType === 12) {
          if (_this.$utils.isWeiXin()) {
            // 判断是否微信浏览器中打开
            // 开始调起微信支付
            if (typeof WeixinJSBridge === "undefined") {
              if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", _this.wxpay(data), false);
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", _this.wxpay(data));
                document.attachEvent("onWeixinJSBridgeReady", _this.wxpay(data));
              }
            } else {
              _this.wxpay(data);
            }
          } else {
            _this.isDisabled = false;
            var url = data.mwebUrl + "&redirect_url=" + encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
            // 券包
            if (_this.orderType && _this.orderType == 8) {
              url = data.mwebUrl + "&redirect_url=" + encodeURIComponent(_this.$utils.getHost() + "/couponPackage/list");
            }
            location.href = url;
          }
          // 企业微信
          if (_this.$utils.isWxWork()) {
            _this.isDisabled = false;
            var _url = data.mwebUrl + "&redirect_url=" + encodeURIComponent(_this.$utils.getHost() + "/orderdetail");
            // 券包
            if (_this.orderType && _this.orderType == 8) {
              _url = data.mwebUrl + "&redirect_url=" + encodeURIComponent(_this.$utils.getHost() + "/couponPackage/list");
            }
            location.href = _url;
          }
        }
        // 支付宝
        if (_this.paymentType === 52) {
          if (_this.$utils.isWeiXin()) {
            // 判断是否微信浏览器中打开
            _this.$router.replace({
              name: "alipay",
              query: {
                oid: _this.orderId,
                t: window.localStorage.getItem("wxToken")
              }
            });
          } else {
            var div = document.createElement("div");
            div.innerHTML = data.body;
            document.body.appendChild(div);
            document.forms[0].submit();
          }
          _this.isDisabled = false;
        }
        // 云闪付
        if (_this.paymentType === 31) {
          if (!_this.$utils.isWeiXin()) {
            // 判断是否微信浏览器中打开
            // console.log(data,'data')
            upsdk.config({
              appId: data.appId, // 必填，接入方的唯一标识，由云闪付分配
              timestamp: data.timestamp, // 必填，生成签名的时间戳，从1970年1月1日00:00:00至今的秒数，取东八区的北京时间，例1556096162
              nonceStr: data.nonceStr, // 必填，生成签名的随机串，参见附录三生成签名随机字符串
              signature: data.signature, // 必填，生成签名的摘要，参见附录一、附录二
              debug: false // 开发阶段可打开此标记，云闪付APP会将调试信息toast出来
            });
            upsdk.error(function (err) {
              console.log(err);
            });
            upsdk.ready(function () {
              // config信息验证后会执行ready方法
              upsdk.pay({
                tn: data.tn,
                success: function success() {
                  _this.isDisabled = false;
                  // 支付成功，开发者执行后续操作
                  // localStorage.setItem('paySource','upsdk')
                  // _this.$router.replace({name: _this.redirectUrl})
                  _this.$router.replace({
                    name: "PaySuccess1",
                    query: { orderId: _this.orderId }
                  });
                },
                fail: function fail(err) {
                  _this.isDisabled = false;
                  // 支付失败，err.msg 是失败原因描述，比如TN号不合法，或者用户取消了交易等等
                  _this.$messagebox.alert(err.msg, "");
                  _this.$router.replace({ name: _this.redirectUrl });
                }
              });
            });
          }
        }
        // 上师大校园卡
        if (_this.paymentType === 20) {
          if (_this.cardSchoolIds.indexOf(_this.schoolId) > 0) {
            _this.isShowCardInfo1 = false;
          }
          _this.$router.replace({
            path: "schoolPaySuc",
            query: {
              payAmount: _this.details.amount,
              redirectUrl: _this.redirectUrl
            }
          });
          _this.isDisabled = false;
        }
        // 数字人民币
        if (_this.paymentType === 41 && data.status == 1) {
          window.location.href = data.payUrl;
          _this.isDisabled = false;
        }
      }, function (response) {
        // 响应错误回调
        _this.isDisabled = false;
        if (response.data.flag === -100) {
          if (_this.source === "shu") {
            //上海大学
            _this.$messagebox.alert("当前账号未开通校园卡消费功能");
          } else {
            //上海师范大学
            _this.isShowAuth = true;
          }
        } else {
          if (response.data.message) {
            _this.$messagebox.alert(response.data.message, "");
          }
        }
      });
    },
    // 微信支付
    wxpay: function wxpay(redata) {
      var _this = this;
      var u = window.location.href.split("#")[0];
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJslbsConf(_this, u, function (data) {
        var wxappid = JSON.parse(data).appId;
        _this.$indicator.close();
        _this.onBridgeReady(wxappid, redata);
      });
    },
    onBridgeReady: function onBridgeReady(wxappid, redata) {
      var _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", {
        appId: wxappid, // 公众号名称，由商户传入
        timeStamp: redata.timeStamp, // 时间戳，自1970年以来的秒数
        nonceStr: redata.rndStr, // 随机串
        package: redata.xpackage,
        signType: redata.signType ? redata.signType : _this.dlbWxAppletFlag ? "RSA" : "MD5", // 微信签名方式：
        paySign: redata.sign // 微信签名
      }, function (res) {
        _this.isDisabled = false;
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // localStorage.setItem('paySource','weixin')
          _this.$router.replace({
            name: "PaySuccess1",
            query: { orderId: _this.orderId }
          });
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          _this.$messagebox({
            title: "支付失败",
            message: "您取消了微信支付",
            confirmButtonText: "确认"
          }).then(function (action) {
            _this.$router.replace({ name: _this.redirectUrl });
          });
        } else {
          _this.$messagebox.alert(JSON.stringify(res), "");
          _this.$router.replace({ name: _this.redirectUrl });
        }
      });
    },
    // 校园卡授权
    toAutn: function toAutn() {
      var host = "";
      if (false) {
        host = "http://user-base.imcoming.com";
      } else if (false) {
        host = "http://user-base.imcoming.com.cn";
      } else if (false) {
        host = "http://user-base.imcoming.com";
      } else {
        host = "https://user-base.anlaiye.com";
      }
      var token = this.$store.state.wxLoginToken;
      var schoolId = this.$store.state.schoolInfo.schoolId;
      window.location.href = host + "/priv/campusCard/auth?school_id=" + schoolId + "&login_token=" + token + "&order_id=" + this.orderId;
    },

    // 判断是否授权成功
    isAuthSuc: function isAuthSuc() {
      if (this.source === "shnu" || this.source === "shnun") {
        // shnu为上师大标识
        if (this.$utils.resolveUrl().status == 0) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = this.details.paywayList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var v = _step3.value;

              if (v.payway_id === 20) {
                v.selected = true;
                this.paymentType = 20;
              } else {
                v.selected = false;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          this.isShowAuth = false;
          this.$toast("授权成功");
        } else if (this.$utils.resolveUrl().status < 0) {
          this.isShowAuth = false;
          this.$toast("授权失败");
        }
      }
    },

    // 校园卡详情
    cardDetail: function cardDetail() {
      var _this = this;
      var params = {
        login_token: _this.$store.state.wxLoginToken,
        school_id: _this.$store.state.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].schoolCardInfo(_this, params, function (data) {
        if (data && data.card_no) {
          _this.isShowCardInfo = true;
          _this.schoolCardCode = data.card_no;
        } else {
          //未授权
          if (_this.source === "shu") {
            //上海大学
            _this.$messagebox.alert("当前账号未开通校园卡消费功能");
          } else {
            //上海师范大学
            _this.isShowAuth = true;
          }
        }
      }, function () {});
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      punctualArriveInfo: {}
    };
  },
  created: function created() {
    var _this2 = this;

    if (localStorage.getItem('orderPreviewInfo')) {
      var orderPreviewInfo = JSON.parse(localStorage.getItem('orderPreviewInfo'));
      if (orderPreviewInfo.punctualArrive && orderPreviewInfo.punctualArrive.jumpParam) {
        var punctualArriveInfo = JSON.parse(orderPreviewInfo.punctualArrive.jumpParam);
        this.handleData(punctualArriveInfo.value);
        if (punctualArriveInfo.title) {
          document.title = punctualArriveInfo.title;
        }
      }
    }
    if (this.$route.query.orderId) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getPunctualOrderDetail(_this, { order_id: this.$route.query.orderId }, function (res) {
        _this2.handleData(res);
      });
    }
  },

  methods: {
    handleData: function handleData(data) {
      if (data.spanList) {
        var spanList = data.spanList;
        if (data.ruleTips) {
          var ruleTips = data.ruleTips;
          spanList.forEach(function (item) {
            if (ruleTips.indexOf(item.title) > -1) {
              data.ruleTips = ruleTips.replace(item.title, '<span style="color: ' + item.titleColor + '">' + item.title + '</span>');
              data.ruleTipsJump = JSON.parse(item.jumpParam);
            }
          });
        }
      }
      this.punctualArriveInfo = data;
    },
    viewRules: function viewRules() {
      if (this.punctualArriveInfo.ruleTipsJump && this.punctualArriveInfo.ruleTipsJump.url) {
        location.href = this.punctualArriveInfo.ruleTipsJump.url;
      }
    }
  }

});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcodejs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "QrCode",
  data: function data() {
    return {
      code: '',
      orderType: '', //1 字体 3堂食
      deliveryTime: '',
      // isShowRefresh: false,
      timer: null,
      number: 0,
      isShowSuc: false,
      supplier_name: '',
      qrCodeIndate: '',
      isInvalid: 0 //0代表正常 1代表未到用餐时间 2代表过了用餐时间二维码失效
    };
  },
  created: function created() {
    this.code = window.localStorage.getItem('Qr-code');
    this.deliveryTime = window.localStorage.getItem('deliveryTime');
    this.supplier_name = window.localStorage.getItem('supplier_name');
    this.orderType = this.$route.query.orderType;
    this.qrCodeIndate = window.localStorage.getItem('qrCodeIndate');
    this.isInvalid = window.localStorage.getItem('isInvalid');
  },
  mounted: function mounted() {
    this.init();
    this.getStatus();
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },

  methods: {
    init: function init() {
      this.qrcode = new __WEBPACK_IMPORTED_MODULE_0_qrcodejs2___default.a('qrcode', {
        width: 250,
        height: 250,
        text: this.code,
        colorDark: '#000',
        colorLight: '#fff'
      });
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: "Restaurant",
    data: function data() {
        return {
            showTop: false,
            orderId: '',
            order: {},
            goodsList: []
        };
    },

    computed: {
        wxUid: function wxUid() {
            return this.$store.state.wxUid;
        }
    },
    created: function created() {
        this.order = {
            "order_id": "50210903571000001",
            "supplier_id": 20159,
            "schoolId": "1397",
            "supplier_name": "俺来也智慧餐厅",
            "goods_list": [{ "name": "ttt", "gdAmount": 0.05, "buyNum": 1, "gdCode": 0, "skuCode": "0", "weight": 274 }],
            "gift_list": [],
            "amount": 0.05,
            "delivery_fee": 0,
            "package_fee": 0,
            "couponAmount": 0,
            "real_pay": "0.05",
            "order_status": 3001,
            "pay_status": 0,
            "isFinishAfter24H": 0,
            "delivery_time": "2021-09-3 立即就餐",
            "eatIn_time": "2021.09.03 15:51-16:36",
            "address": "",
            "create_time": "2021-09-03 15:51:40",
            "canEstimated": 0,
            "complaint": 2,
            "commercialId": 6980,
            "gift_url": "https://pic.anlaiye.com.cn/82cb2bba001b41be999a716dc4cb12cb_43x43.jpg",
            "gift_activity_name": "满赠优惠",
            "orderType": 4,
            "pickUpCode": "415",
            "refundStatus": 1,
            "supplierTel": "18995638200",
            "comment": "af355d2961c14a2190de0f53e792OA42",
            "showShopRefund": 0,
            "orderShortNumQrCode": {
                "o": "50210903571000001",
                "orderShortNum": "415"
            },
            "qrCodeIndate": "此二维码有效期为 2021.09.03 14:51-17:36",
            "isInvalid": 2,
            "mealStatus": 0,
            "sysCode": 10001,
            "trayNo": "9999",
            "payTime": "2021-09-03 16:15:05"
        };
        this.goodsList = this.order.goods_list;
        this.orderId = this.order.order_id;
        this.showTop = true;
    },
    mounted: function mounted() {
        if (this.$utils.resolveUrl().order_id) {
            this.orderId = this.$utils.resolveUrl().order_id;
        } else {
            this.orderId = window.localStorage.getItem('orderCode');
        }
        if (this.$utils.resolveUrl().school_id) {
            __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolStatus(this, { school_id: this.$utils.resolveUrl().school_id }, function (data) {
                var schoolInfo = {
                    schoolId: data.school_id,
                    schoolName: data.school_name
                };
                this.$store.commit('changeSchoolInfo', schoolInfo);
            }, function () {
                this.$messagebox.alert(data.body.message, '');
            });
        }
    },

    methods: {
        getDetail: function getDetail() {
            var _this = this;

            var params = {
                token: this.data.token,
                order_id: this.data.orderId
            };
            __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].youxinOrderList(this, params, function (res) {
                if (res.result && res.data) {
                    _this.order = res.data;
                    _this.goodsList = res.data.goods_list ? res.data.goods_list : [];
                    _this.showTop = true;
                } else {
                    _this.order = {};
                    _this.goodsList = [];
                }
            });
        },
        toComment: function toComment() {},
        toPay: function toPay() {}
    }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Reward",
  data: function data() {
    return {
      rewardInfo: {},
      rewardOrderList: [],
      isShowReward: false,
      amount: '',
      orderId: '',
      isActive: false
    };
  },
  created: function created() {
    this.orderId = window.localStorage.getItem('orderId');
    this.getRewardInfo();
  },

  methods: {
    getRewardInfo: function getRewardInfo() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getWeixinRewardInfo(_this, { orderId: _this.orderId }, function (data) {
        _this.rewardInfo = data;
        _this.rewardOrderList = data.rewardOrderList.slice(0, 3);
      }, function (data) {
        _this.$messagebox.alert(data.data.message, '');
      });
    },
    toRewardList: function toRewardList(id) {
      window.localStorage.setItem('deliveryId', id);
      this.$router.push({ path: '/rewardList' });
    },
    openReward: function openReward(item) {
      var _this = this;
      _this.amount = '';
      if (item.type == 1) {
        _this.isShowReward = true;
      } else {
        _this.submitReward(2, item.amount);
      }
    },

    // 打赏
    submitReward: function submitReward(number, val) {
      var _this = this;
      var realAmount = number == 1 ? _this.amount : val;
      var params = {
        orderType: 2,
        rewardOrderId: _this.orderId,
        rewardAmount: realAmount
      };
      _this.$indicator.open(); //loading
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postOrderCreate(_this, params, function (newdata) {
        _this.$indicator.close();
        if (newdata.status === 0) {
          window.localStorage.setItem('orderCode', newdata.orderId);
          _this.$router.push({ name: 'Payment', params: { reward: true } });
        }
      }, function (newdata) {
        _this.$indicator.close();
        _this.$messagebox.alert(newdata.data.message, '');
      });
    },
    closeMask: function closeMask() {
      this.isShowReward = false;
      window.scrollTo(3000, 7000);
    },
    changeAmount: function changeAmount(val) {
      if (val) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    }
  }

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "RewardList",
  data: function data() {
    return {
      rewardOrderList: [],
      deliveryId: ''
    };
  },
  created: function created() {
    this.deliveryId = window.localStorage.getItem('deliveryId');
    this.getRewardInfo();
  },

  methods: {
    getRewardInfo: function getRewardInfo() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getWeixinRewardList(_this, { deliveryId: _this.deliveryId }, function (data) {
        _this.rewardOrderList = data.list;
      }, function (data) {
        _this.$messagebox.alert(data.data.message, '');
      });
    }
  }

});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SchoolPaySuc',
  data: function data() {
    return {
      amount: '',
      redirectUrl: ''
    };
  },
  created: function created() {
    this.amount = this.$route.query.payAmount;
    this.redirectUrl = this.$route.query.redirectUrl;
  },

  methods: {
    toOrderDetail: function toOrderDetail() {
      localStorage.setItem('paySource', 'schoolPay');
      this.$router.push({ name: this.redirectUrl });
    }
  }

});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CommentStars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { MessageBox } from 'mint-ui';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      keyword: '',
      goodsInfo: [],
      showResult: false,
      historySearchList: [],
      searchRecom: [],
      shopRecom: [],
      remSize: 0,
      clientHeight: 0
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    next();
  },
  created: function created() {
    var _this = this;
    // document.title = '搜索';
    if (window.localStorage.getItem('historySearchList')) {
      _this.historySearchList = JSON.parse(window.localStorage.getItem('historySearchList'));
    } else {
      _this.historySearchList = [];
    }
    _this.getSearchRecom();
    _this.getShopRecom();
  },
  mounted: function mounted() {
    this.clientHeight = document.documentElement.clientHeight;
    var html = document.getElementsByTagName('html');
    if (html[0]) {
      var rem = html[0].style.fontSize;
      this.remSize = parseInt(rem);
    }
  },

  watch: {
    keyword: {
      handler: function handler(val) {
        var _this = this;
        if (val == '') {
          _this.showResult = false;
        }
      },
      deep: true
    }
  },
  methods: {
    showMoreGift: function showMoreGift(item) {
      item.iShowMore = !item.iShowMore;
    },
    key: function key(e) {
      var _this = this;
      if (e.keyCode == '13') {
        // console.log(_this.keyword)
        _this.getGoodsSearch(_this.keyword);
      }
    },
    toggleShowMore: function toggleShowMore(item) {
      var _this = this;
      for (var key in _this.goodsInfo) {
        if (_this.goodsInfo[key].id == item.id) {
          _this.goodsInfo[key].isShowAll = !_this.goodsInfo[key].isShowAll;
        }
      }
    },
    getGoodsSearch: function getGoodsSearch(e) {
      var _this = this;
      var school_id = _this.$store.state.schoolInfo.schoolId;
      if (e) {
        _this.keyword = e;
      }
      var params = {
        keyword: _this.keyword,
        page: '1',
        page_size: '30',
        school_id: school_id
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getGoodsSearch(_this, params, function (data) {
        for (var key in data) {
          data[key].isShowAll = false;
          data[key].iShowMore = false;
          // 替换搜索商品关键字
          if (data[key].goods_list.length > 0) {
            var goodsList = data[key].goods_list;
            for (var m in goodsList) {
              if (goodsList[m].name.indexOf(_this.keyword) >= 0) {
                goodsList[m].name = goodsList[m].name.replace(_this.keyword, '<span class="red">' + _this.keyword + '</span>');
              }
            }
          }
          // 替换搜索店铺名关键字
          if (data[key].shop_name.indexOf(_this.keyword) >= 0) {
            data[key].shop_name = data[key].shop_name.replace(_this.keyword, '<span class="red">' + _this.keyword + '</span>');
          }
          if (data[key].promotion_list && data[key].promotion_list.length > 0) {
            data[key].promotion_list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(data[key].promotion_list, function (item) {
              return item.promotion_type;
            });
          }
        }
        // console.log(data);
        _this.goodsInfo = data;
        _this.showResult = true;
        if (_this.keyword.replace(/\s+/g, "") != '') {
          if (_this.historySearchList.indexOf(_this.keyword) < 0) {
            _this.historySearchList.unshift(_this.keyword);
          }
          if (_this.historySearchList.length > 10) {
            _this.historySearchList = _this.historySearchList.slice(0, 9);
          }
        }
        window.localStorage.setItem('historySearchList', JSON.stringify(_this.historySearchList));

        _this.$nextTick(function () {
          var goodsList = document.getElementsByClassName('goods-list');
          var uid = localStorage.getItem('wxUid');
          if (uid && goodsList && goodsList[0] && _this.goodsInfo && _this.goodsInfo.length > 0) {
            var endLine = document.getElementsByClassName('end-line');
            endLine = endLine && endLine[0] ? endLine[0].clientHeight : 0;
            var item = (goodsList[0].clientHeight - endLine - _this.remSize * 0.4) / _this.goodsInfo.length;
            var size = Math.round((_this.clientHeight - _this.remSize * 0.88) / item);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.goodsInfo);
            _this.$store.commit('changeRecordOtherHeight', endLine + _this.remSize * 0.88);
            _this.$store.commit('changeRecordPage', 'Search');
            _this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this.goodsInfo, 'asa_merc_shop_search', 'id');
          }
        });
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    toGoodsList: function toGoodsList(data) {
      var _this = this;
      var obj = {
        shop_code: data,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    clearInput: function clearInput() {
      this.keyword = '';
      var uid = localStorage.getItem('wxUid');
      if (uid) {
        var data = this.shopRecom;
        var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
        exposureLog = exposureLog ? exposureLog : [];
        for (var k = 0; k < data.length; k++) {
          exposureLog.push({
            uid: uid == 'undefined' ? 0 : uid,
            firstValue: k,
            // shopid: data[k].shop_id,
            refId: data[k].shop_id,
            createTime: new Date().getTime(),
            code: 'asa_merc_shop_recommend'
          });
        }
        localStorage.setItem('lastLogTime', new Date().getTime());
        localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
      }
    },
    clearHistory: function clearHistory() {
      var _this = this;
      if (_this.historySearchList.length > 0) {
        _this.$messagebox.confirm('确定要清空搜索历史？', '').then(function (action) {
          _this.historySearchList = [];
          window.localStorage.setItem('historySearchList', []);
        });
      }
    },
    //搜索发现关键词
    getSearchRecom: function getSearchRecom() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getSearchRecom(_this, { school_id: _this.$store.state.schoolInfo.schoolId }, function (data) {
        _this.searchRecom = data;
      });
    },
    //搜索店铺推荐
    getShopRecom: function getShopRecom() {
      var _this = this;
      var params = {
        school_id: _this.$store.state.schoolInfo.schoolId,
        login_token: _this.$store.state.wxLoginToken
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopRecom(_this, params, function (data) {
        _this.shopRecom = data;
        var uid = localStorage.getItem('wxUid');
        // if (uid) {
        var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
        exposureLog = exposureLog ? exposureLog : [];
        for (var k = 0; k < data.length; k++) {
          exposureLog.push({
            uid: uid == 'undefined' ? 0 : uid,
            firstValue: k,
            // shopid: data[k].shop_id,
            refId: data[k].shop_id,
            createTime: new Date().getTime(),
            code: 'asa_merc_shop_recommend'
          });
        }
        localStorage.setItem('lastLogTime', new Date().getTime());
        localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        // }
      });
    }
  },
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default.a
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      couponsList: [],
      unValidCoupons: [],
      couponPackageList: [],
      couponType: 1
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  created: function created() {
    // document.title = "我的优惠券"
    this.couponType = this.$route.params.type;
    var couponsList = [],
        unValidCoupons = [];
    if (this.couponType == 1) {
      if (window.localStorage.getItem('couponList')) {
        couponsList = JSON.parse(window.localStorage.getItem('couponList'));
        localStorage.removeItem('couponList');
      }
      if (window.localStorage.getItem('unValidCoupons')) {
        unValidCoupons = JSON.parse(window.localStorage.getItem('unValidCoupons'));
        localStorage.removeItem('unValidCoupons');
      }
    } else {
      if (window.localStorage.getItem('deliveryFeeCoupons')) {
        couponsList = JSON.parse(window.localStorage.getItem('deliveryFeeCoupons'));
        localStorage.removeItem('deliveryFeeCoupons');
      }
      if (window.localStorage.getItem('unValidDeliveryFeeCoupons')) {
        unValidCoupons = JSON.parse(window.localStorage.getItem('unValidDeliveryFeeCoupons'));
        localStorage.removeItem('unValidDeliveryFeeCoupons');
      }
    }
    if (couponsList.length) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = couponsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;

          // v.showPackageRule = false;
          // if (v.package_rule) {
          //   v.package_rule = v.package_rule.replace(
          //     /(\n|\r|\r\n|↵)/g,
          //     "<br/>"
          //   );
          // }
          var coupon_property = v.coupon_property,
              coupon_property_str = "普通优惠";
          switch (coupon_property) {
            case 1:
              coupon_property_str = "普通优惠";
              break;
            case 2:
              coupon_property_str = "会员福利";
              break;
            case 3:
              coupon_property_str = "单单返现";
              break;
            case 4:
              coupon_property_str = '\u8D85\u503C\u5238\u5305x' + v.package_num + '\u5F20';
              break;
            case 7:
              coupon_property_str = "配送福利";
              break;
          }
          v.coupon_property_str = coupon_property_str;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    if (unValidCoupons.length) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = unValidCoupons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _v = _step2.value;

          // v.showPackageRule = false;
          // if (v.package_rule) {
          //   v.package_rule = v.package_rule.replace(
          //     /(\n|\r|\r\n|↵)/g,
          //     "<br/>"
          //   );
          // }
          var _coupon_property = _v.coupon_property,
              _coupon_property_str = "普通优惠";
          switch (_coupon_property) {
            case 1:
              _coupon_property_str = "普通优惠";
              break;
            case 2:
              _coupon_property_str = "会员福利";
              break;
            case 3:
              _coupon_property_str = "单单返现";
              break;
            case 4:
              _coupon_property_str = '\u8D85\u503C\u5238\u5305x' + _v.package_num + '\u5F20';
              break;
            case 7:
              _coupon_property_str = "配送福利";
              break;
          }
          _v.coupon_property_str = _coupon_property_str;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
    this.couponsList = couponsList;
    this.unValidCoupons = unValidCoupons;

    // 券包
    if (window.localStorage.getItem('orderPreviewInfo')) {
      var orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
      if (orderPreviewInfo.promotionCouponPackageBeanList && orderPreviewInfo.promotionCouponPackageBeanList.length > 0) {
        this.getCouponPackageList();
      }
    }
  },

  methods: {
    selectCoupon: function selectCoupon(item) {
      var _this2 = this;

      if (item.is_toast == 1 && item.toast_tips && item.toast_tips.length > 0) {
        this.$messagebox.alert(item.toast_tips, '使用须知').then(function (action) {
          for (var i = 0; i < _this2.couponsList.length; i++) {
            if (_this2.couponsList[i].user_coupon_id == item.user_coupon_id) {
              _this2.couponsList[i].selected = 1;
            } else {
              _this2.couponsList[i].selected = 0;
            }
          }
          var objStr = JSON.stringify(item);
          window.localStorage.setItem('selectedCoupon', objStr);
          window.localStorage.setItem('orderPreviewType', 2);
          window.localStorage.setItem('isSelectedCoupon', true);
          _this2.$router.push({ name: 'OrderSettle' });
        });
      } else {
        for (var i = 0; i < this.couponsList.length; i++) {
          if (this.couponsList[i].user_coupon_id == item.user_coupon_id) {
            this.couponsList[i].selected = 1;
          } else {
            this.couponsList[i].selected = 0;
          }
        }
        var objStr = JSON.stringify(item);
        if (this.couponType == 1) {
          window.localStorage.setItem('selectedCoupon', objStr);
        } else {
          window.localStorage.setItem('selectedDeliveryCoupon', objStr);
        }

        window.localStorage.setItem('orderPreviewType', 2);
        window.localStorage.setItem('isSelectedCoupon', true);
        this.$router.push({ name: 'OrderSettle' });
      }
    },
    donotUseCoupon: function donotUseCoupon() {
      if (this.couponsList) {
        window.localStorage.removeItem(this.couponType == 1 ? 'selectedCoupon' : 'selectedDeliveryCoupon');
        for (var i = 0; i < this.couponsList.length; i++) {
          this.couponsList[i].selected = 0;
        }
      }
      this.$router.push({ name: 'OrderSettle' });
      window.localStorage.setItem('orderPreviewType', 2);
      window.localStorage.setItem('isSelectedCoupon', true);
    },
    // 获取券包
    getCouponPackageList: function getCouponPackageList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        source: 2
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPackageList(_this, params, function (data) {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          // for (let v of data) {
          //   if (v.package_status === 1) {
          //     if (v.package_rule) {
          //       v.package_rule = v.package_rule.replace(
          //         /(\n|\r|\r\n|↵)/g,
          //         "<br/>"
          //       );
          //     }
          //     _this.couponPackageList.push(v);
          //   }
          // }
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_order_choose_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.couponPackageList[0].package_id,
            firstValue: _this.schoolInfo.schoolId
            // secondValue: _this.shopCode
          }];
          _this.addLog1(clickParams);
        }
      });
    },

    // 购买券包
    buyCouponPackage: function buyCouponPackage(item) {
      this.$router.push({ name: 'CouponPackage', query: { id: item.package_id } });
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_order_choose_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.schoolInfo.schoolId
        // secondValue: _this.shopCode
      }];
      this.addLog1(clickParams);
    },
    changePackageRule: function changePackageRule(item) {
      item.showPackageRule = !item.showPackageRule;
      this.$forceUpdate();
      // for(let v of this.couponsList){
      //   if(v.coupon_id == item.coupon_id){
      //     this.$set(v,'showPackageRule',!item.showPackageRule)
      //   }
      // }
    },

    // 统计埋点
    addLog1: function addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "self-take-protocol"
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CommentStars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AlertBox__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AlertBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AlertBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { MessageBox,Indicator } from 'mint-ui';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_0__components_CommentStars___default.a
  },
  data: function data() {
    return {
      shopList: [],
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      showPage: false,
      shopListType: '',
      bannerUrl: '',
      clientHeight: document.documentElement.clientHeight
    };
  },

  computed: {
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'TagPage') {
      to.meta.isUseCache = true;
    }
    next();
  },
  mounted: function mounted() {
    var _this = this;
    //页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      // var _this = this;
      // if(!this.$route.meta.isUseCache){
      //   _this.shopList = [];
      //   _this.currentPage = 1;
      //   _this.hasMore = true;
      //   _this.showPage = false;
      //   _this.bannerUrl = '';
      //   _this.getShopList();
      // }
      if (marginBot <= 1) {
        if (_this.hasMore) {
          _this.getShopList();
        }
      }
    };
  },
  activated: function activated() {
    if (window.localStorage.getItem('category_name')) {
      document.title = window.localStorage.getItem('category_name');
    } else {
      document.title = '校内订餐';
    }
    var _this = this;
    // console.log(this.$route.meta.isUseCache)
    // if(!this.$route.meta.isUseCache){
    _this.shopList = [];
    _this.currentPage = 1;
    _this.hasMore = true;
    _this.showPage = false;
    _this.bannerUrl = '';
    _this.getShopList();
    // }
  },

  methods: {
    showMoreGift: function showMoreGift(item) {
      item.iShowMore = !item.iShowMore;
    },
    getUserInfo: function getUserInfo() {
      var _this = this;
      var token = _this.$utils.getCookie('token');
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].postAuthInfo(_this, { token: token }, function (data) {
        if (data.uid) {
          var openid = _this.$store.state.openId;
          if (data.openid && data.openid != '') {
            openid = data.openid;
          }
          var obj = {
            openId: openid,
            wxUid: data.uid,
            wxLoginToken: data.login_token,
            wxToken: data.token
          };
          _this.$store.commit('changeState', obj);

          var userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex
          };
          _this.$store.commit('changeUserInfo', userInfo);
        }

        var schoolInfo = {
          schoolName: decodeURI(_this.$utils.resolveUrl().school_name),
          schoolId: _this.$utils.resolveUrl().school_id
        };
        _this.$store.commit('changeSchoolInfo', schoolInfo);
      });
    },

    getShopList: function getShopList() {
      var _this = this;
      // 华农
      if (_this.$utils.resolveUrl().tag_id) {
        //          var token = _this.$utils.getCookie('token')
        var obj = {
          shopListType: 'tag',
          tag_id: _this.$utils.resolveUrl().tag_id,
          category_name: decodeURI(_this.$utils.resolveUrl().category_name)
        };
        _this.$store.commit('changeState', obj);
        document.title = decodeURI(_this.$utils.resolveUrl().category_name);
        // 获取用户信息
        _this.getUserInfo();
      }
      _this.shopListType = window.localStorage.getItem('shopListType');
      _this.hasMore = false;
      _this.$indicator.open();
      //  category
      if (_this.shopListType === 'tag') {
        // 先获取标签图片信息
        _this.getTagsInfo();
        var params = {
          tag_id: window.localStorage.getItem('tag_id'),
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize
        };
        __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getTagShopList(_this, params, function (data) {
          if (data != null && data.length > 0) {
            if (data.length < _this.pageSize) {
              _this.hasMore = false;
            } else {
              _this.hasMore = true;
            }
            _this.currentPage = _this.currentPage + 1;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var shop = _step.value;

                var _obj = {
                  backgroundImage: "url(" + shop.pic + ")"
                };
                shop.backgroundimg = _obj;
                shop.iShowMore = false;
                if (shop.promotion_list && shop.promotion_list.length > 0) {
                  shop.promotion_list = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                    return item.promotion_type;
                  });
                }
                _this.shopList.push(shop);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            _this.hasMore = false;
          }
          // 只有一个店铺直接跳转店铺详情
          if (_this.shopList.length === 1) {
            _this.toGoodsList1(_this.shopList[0].id, _this.shopList[0].shop_name);
            return;
          }
          _this.showPage = true;
          _this.$indicator.close();
          _this.$nextTick(function () {
            var goodsList = document.getElementsByClassName('goods-list');
            var item = goodsList[0].clientHeight / _this.shopList.length;
            var size = Math.round(_this.clientHeight / item);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            _this.$store.commit('changeRecordOtherHeight', 0);
            _this.$store.commit('changeRecordPage', 'ShopList2');
            _this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this.shopList, 'asa_merc_shop_listForGoods_category', 'id');
          });
        }, function (data) {
          _this.showPage = true;
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        });
      } else if (_this.shopListType === 'category') {
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize,
          category_id: window.localStorage.getItem('category_code')
          // 获取当前校区商家列表
        };__WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getShopList(_this, params, function (data) {
          if (data != null && data.length > 0) {
            if (data.length < _this.pageSize) {
              _this.hasMore = false;
            } else {
              _this.hasMore = true;
            }
            _this.currentPage = _this.currentPage + 1;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var shop = _step2.value;

                var _obj2 = {
                  backgroundImage: "url(" + shop.pic + ")"
                };
                shop.backgroundimg = _obj2;
                shop.iShowMore = false;
                if (shop.promotion_list && shop.promotion_list.length > 0) {
                  shop.promotion_list = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                    return item.promotion_type;
                  });
                }
                _this.shopList.push(shop);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            _this.hasMore = false;
          }
          if (_this.shopList.length === 1) {
            _this.toGoodsList1(_this.shopList[0].id, _this.shopList[0].shop_name);
            return;
          }
          _this.showPage = true;
          _this.$indicator.close();
          _this.$nextTick(function () {
            var goodsList = document.getElementsByClassName('goods-list');
            var item = goodsList[0].clientHeight / _this.shopList.length;
            var size = Math.round(_this.clientHeight / item);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            _this.$store.commit('changeRecordOtherHeight', 0);
            _this.$store.commit('changeRecordPage', 'ShopList');
            _this.$store.commit('changeRecordState', true);
            _this.$utils.firstLogPush(size, _this.shopList, 'asa_merc_shop_specialList', 'id');
          });
        }, function (data) {
          _this.showPage = true;
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        });
      } else if (_this.shopListType === 'activity') {
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize
        };
        __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getPromtionList(_this, params, function (data) {
          if (data && data.length > 0) {
            if (data.length < _this.pageSize) {
              _this.hasMore = false;
            } else {
              _this.hasMore = true;
            }
            _this.currentPage = _this.currentPage + 1;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = data[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var shop = _step3.value;

                var _obj3 = {
                  backgroundImage: "url(" + shop.pic + ")"
                };
                shop.backgroundimg = _obj3;
                shop.iShowMore = false;
                if (shop.promotion_list && shop.promotion_list.length > 0) {
                  shop.promotion_list = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                    return item.promotion_type;
                  });
                }
                _this.shopList.push(shop);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          } else {
            _this.hasMore = false;
          }
          if (_this.shopList.length === 1) {
            _this.toGoodsList1(_this.shopList[0].id, _this.shopList[0].shop_name);
            return;
          }
          _this.showPage = true;
          _this.$indicator.close();
        }, function (data) {
          _this.showPage = true;
          _this.$indicator.close();
          _this.$messagebox.alert(data.body.message, '');
        });
      }
    },
    getTagsInfo: function getTagsInfo() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        tag_id: window.localStorage.getItem('tag_id'),
        page: 1,
        pageSize: 10
      };
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getTagInfo(_this, params, function (data) {
        if (data && data.pic) {
          _this.bannerUrl = data.pic;
        }
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    toGoodsList1: function toGoodsList1(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.replace({ name: 'GoodsList' });
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CommentStars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var wx = require('weixin-js-sdk')


// import { MessageBox , Indicator} from 'mint-ui'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'index',
  data: function data() {
    return {
      showPage: false,
      showHomePage: false,
      isOpenA: true,
      tagList: [],
      shopList: [],
      schoolLock: false,
      banners: [],
      schoolInfo: {
        schoolId: 1237,
        schoolName: '华东理工'
      },
      shopCategoryList: [],
      currentShopList: [],
      currentPage: 1,
      pageSize: 20,
      showTag: true,
      hasMore: false,
      lanternSlideList: [],
      showBottomTips: false,
      showRecommend: false, //是否显示活动banner
      activity: '',
      showCouponAlert: false,
      couponInfo: {},
      originNoticeContent: '', //公告
      noticeContent: '',
      showNoticeAlert: false, //是否显示公告详情弹框
      noticeList: [], //公告详情数组
      adsvPopList: [], // 广告弹窗
      showAdsvPop: false,
      adsvPopItem: {},
      // adsvPopStatus: localStorage.getItem('adsvPopStatus') ? JSON.parse(localStorage.getItem('adsvPopStatus')) : {},
      uid: null,
      isYSF: false,
      isjdlw: false,
      isJdlwNewCustomer: 0,
      stillHeight: 0,
      remSize: 0,
      clientHeight: 0,
      scollTop: window.appScroll,

      showBonusPop: false, // 新学期红包
      bonusPop: {},
      cardPlusInfo: {},

      shopTitles: [{ id: 0, title: '全部商家', checked: true }, { id: 1, title: '活动店铺', checked: false }, { id: 2, title: '买过的店', checked: false }],
      shopSorts: [{ id: 0, title: '综合排序', checked: true }, { id: 1, title: '只看外卖', checked: false }, { id: 2, title: '只看自提', checked: false }, { id: 3, title: '只看堂食', checked: false }],
      orderType: 0, //0-综合 1-外卖 2-自提 3-堂食
      currentTitle: 0, //0-全部商家 1-活动店铺 2-买过的店
      isFixed: false,
      headerHeight: 0,
      listOffsetTop: 0,
      noData: false,
      isClick: 0,

      benefitList: [],
      isOpenOrder: false
    };
  },

  watch: {
    scollTop: function scollTop(val, old) {
      // console.log(val)
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    from.meta.isUseCache = false;
    next();
  },
  activated: function activated() {
    if (!this.$route.meta.isUseCache) {
      var _this = this;
      // document.title = '校内订餐'

      _this.showPage = false;
      _this.banners = [];
      _this.benefitList = [];
      _this.showHomePage = false;
      _this.tagList = [];
      _this.shopList = [];
      _this.currentPage = 1;
      _this.shopCategoryList = [];
      _this.currentShopList = [];
      _this.cardPlusInfo = {};

      // 更新用户信息
      var token = window.localStorage.getItem('wxToken');
      if (_this.$utils.getCookie('token')) {
        token = _this.$utils.getCookie('token');
        var obj = {
          wxToken: token,
          wxUid: '',
          wxLoginToken: ''
        };
        _this.$store.commit('changeState', obj);

        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('wxLoginToken');
        _this.updateUserInfo(token);
      } else {
        _this.$messagebox.alert('授权不成功，请退出重新进入', '');
        // return;
      }

      // 邀请有礼
      if (_this.$utils.getCookie('clc') && _this.$utils.getCookie('clc').length > 0) {
        if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
          _this.$store.state.schoolInfo = {};
          _this.$store.commit('changeSchoolInfo', {});
        }
      }

      /**
       * 如果有指定学校id
       */
      var url_school_id = _this.$utils.resolveUrl().school_id;
      if (!url_school_id && !_this.$store.state.schoolInfo && document.domain.indexOf('xiyoushi.com') >= 0) {
        var obj = {
          wxToken: _this.randomWord(false, 32)
        };
        _this.$store.commit('changeState', obj);
        url_school_id = 1826;
        window.localStorage.setItem('school_lock', '1');
      }

      if (url_school_id) {
        _this.schoolInfo.schoolId = url_school_id;
        _this.getSchoolStatus(url_school_id);
      } else {
        if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
          _this.schoolInfo = _this.$store.state.schoolInfo;
          _this.getSchoolStatus(_this.schoolInfo.schoolId);
        } else {
          _this.$router.push({ path: '/chooseschool' });
          return false;
        }
      }

      /**
       * 是否是单校区*/
      if (_this.$utils.resolveUrl().school_lock == undefined) {
        var school_lock = window.localStorage.getItem('school_lock');
        if (school_lock == '1') {
          _this.schoolLock = true;
        } else {
          _this.schoolLock = false;
        }
      } else {
        if (_this.$utils.resolveUrl().school_lock == 'true') {
          window.localStorage.setItem('school_lock', '1');
          _this.schoolLock = true;
        } else {
          window.localStorage.setItem('school_lock', '2');
          _this.schoolLock = false;
        }
      }

      // if (this.$utils.getCookie('source') && this.$utils.getCookie('source') == 'jdlw') {
      //   // 京东梨涡
      //   this.isjdlw = true
      // }
      // // 梨涡新老用户参数
      // if (this.$utils.getCookie('isNewCustomer') && this.$utils.getCookie('isNewCustomer') == 1) {
      //   // 京东梨涡
      //   this.isJdlwNewCustomer = 1
      // }

      if (_this.$store.state.wxLoginToken && _this.$store.state.wxLoginToken.length > 0) {
        // 新学期领红包活动
        _this.isShowBonusPop();
        // 新学期礼券
        _this.isShowCoupon();
      }
    }
    var html = document.getElementsByTagName('html');
    if (html[0]) {
      var rem = html[0].style.fontSize;
      this.remSize = parseInt(rem);
      this.stillHeight = this.stillHeight + this.remSize * 0.98;
    }
    this.clientHeight = document.documentElement.clientHeight;

    var shopList = document.getElementsByClassName("category-list");
    var lanternList = document.getElementsByClassName("lantern-list");
    var tagList = document.getElementsByClassName("tag-list");
    this.stillHeight = this.stillHeight + this.remSize * 2.6;
    var goodsTitle = document.getElementsByClassName('goods-title');
    if (goodsTitle && goodsTitle[0]) {
      this.stillHeight = this.stillHeight + goodsTitle[0].offsetHeight + this.remSize * 0.4;
    }
    if (shopList && shopList[0]) {
      this.stillHeight = this.stillHeight + shopList[0].offsetHeight + this.remSize * 0.3;
    }
    if (lanternList && lanternList[0]) {
      this.stillHeight = this.stillHeight + lanternList[0].offsetHeight;
    }
    if (tagList && tagList[0]) {
      this.stillHeight = this.stillHeight + tagList[0].offsetHeight + this.remSize * 0.2;
    }
    var goodsList = document.getElementsByClassName('goods-ul');
    if (goodsList && goodsList[0]) {
      var item = Math.round(goodsList[0].offsetHeight / this.currentShopList.length);
      if (localStorage.getItem('wxUid')) {
        localStorage.setItem('recordLogIdx', 0);
      }
      this.$store.commit('changeRecordItemHeight', item);
      this.$store.commit('changeRecordList', this.currentShopList);
    }
    this.$store.commit('changeRecordOtherHeight', this.stillHeight);
    this.$store.commit('changeRecordPage', 'TagPage');
    this.$store.commit('changeRecordState', true);

    // 自定义分享
    var host = this.$utils.getHost();
    var link = this.$utils.isWxWork() ? host + '/wxWork' : this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=sch' + this.schoolInfo.schoolId;
    this.$utils.wxShareNew(this, '【俺来也】校内订餐，暖心服务', // 分享标题
    link, // 分享链接
    host + '/share.png', // 分享图标
    '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
    );
    if (document.domain == 'www.xiyoushi.com' || document.domain == 'xiyoushi.com') {
      _this.showBottomTips = true;
      document.title = '西游食';
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$store.commit('changeRecordPage', 'TagPage');
    this.$store.commit('changeRecordState', true);
    window.addEventListener('scroll', this.handleScroll);
    // 页面滚动到底部触发事件
    window.onscroll = function () {
      var marginBot = 0;
      if (document.documentElement.scrollTop) {
        marginBot = document.documentElement.scrollHeight - (document.documentElement.scrollTop + document.body.scrollTop) - document.documentElement.clientHeight;
      } else {
        marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight;
      }
      if (marginBot <= 0) {
        if (_this.hasMore) {
          if (_this.currentTitle == 0) {
            //全部商家
            _this.getShopList();
          } else if (_this.currentTitle == 1) {
            _this.getPromtionShop(); //活动店铺
          } else {
            _this.getBoughtShop(); //买过的店
          }
        }
      }
    };
    window.localStorage.setItem('upSDKUrl', window.location.href);

    var html = document.getElementsByTagName('html');
    if (html[0]) {
      var rem = html[0].style.fontSize;
      this.remSize = parseInt(rem);
      this.stillHeight = this.stillHeight + this.remSize * 0.98;
    }
    this.clientHeight = document.documentElement.clientHeight;
    this.$store.commit('changeRecordOtherHeight', this.stillHeight);
  },

  methods: {
    // 获取学校状态
    getSchoolStatus: function getSchoolStatus(url_school_id) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSchoolStatus(_this, { school_id: url_school_id }, function (data) {
        var schoolInfo = {
          schoolId: data.school_id,
          schoolName: data.school_name
        };
        _this.isOpenOrder = data.three_meals_status == 1 ? true : false;
        _this.$store.commit('changeSchoolInfo', schoolInfo);
        _this.schoolInfo = schoolInfo;
        _this.getHomeStatus();
        _this.getBanner(); // 顶部banner
        _this.getNotice(); // 公告
        _this.getLanternSlideList(); // 幻灯片
        _this.getAdsvcPop(); // 广告弹窗
        // _this.isShowRecommend() // 是否显示推荐下单领红包的bannner
        _this.getCardPlus(); // 常驻活动入口
        _this.getBenefitList(); //商家权益包
        _this.$utils.setCookie('alySchoolId', _this.schoolInfo.schoolId);
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    updateUserInfo: function updateUserInfo(token) {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postAuthInfo(_this, { token: token }, function (data) {
        var openid = _this.$store.state.openId;
        if (data.openid && data.openid != '') {
          openid = data.openid;
        }
        if (data.login_token) {
          var obj = {
            openId: openid,
            wxUid: data.uid,
            wxToken: data.token,
            wxLoginToken: data.login_token,
            platformType: data.platform_type
          };
          _this.$store.commit('changeState', obj);

          var userInfo = {
            avatar: data.avatar || data.headimgurl,
            nickname: data.nickname,
            mp: data.mp,
            sex: data.sex,
            mp_real: _this.$utils.Decrypt(data.mp_encryption)
          };
          _this.$store.commit('changeUserInfo', userInfo);
          if (_this.$store.state.schoolInfo && _this.$store.state.schoolInfo.schoolId) {
            // 新学期领红包活动
            _this.isShowBonusPop();
            // 新学期礼券
            _this.isShowCoupon();
          }
        }
      }, function () {});
    },

    // 分享
    weixinShare: function weixinShare() {
      var _this = this;
      var u = encodeURIComponent(window.location.href.split('#')[0]);
      window.localStorage.setItem('landingPage', u);
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getJsShareConf(_this, u, function (data) {
        var host = _this.$utils.getHost();
        wx.config({
          debug: false,
          appId: data.data.appId,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          signature: data.data.signature,
          jsApiList: data.data.jsApiList
        });
        var link = _this.$utils.isWxWork() ? host + '/wxWork' : _this.$utils.getAgentApiHost() + '/wechat/auth/enter?redirect=sch' + _this.schoolInfo.schoolId;
        wx.ready(function () {
          _this.$utils.wx_share('【俺来也】校内订餐，暖心服务', // 分享标题
          link, // 分享链接
          host + '/share.png', // 分享图标
          '订餐首选俺来也，美味餐食极速送达，爱吃节最低2.7元' // 分享描述
          );
        });
      });
    },

    // 统计埋点
    addLog: function addLog(param) {
      // 内部统计
      var _this = this;
      var params = param || {
        logDetails: [{
          uid: _this.$store.state.wxUid,
          code: 'aly_main_index_display',
          createTime: new Date().getTime(),
          firstValue: this.$utils.getCookie('UM_distinctid')
        }]
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {});
    },

    //生成32位token
    randomWord: function randomWord(randomFlag, min, max) {
      var str = "",
          range = '',
          pos = '',
          range = min,
          arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },

    //开学季红包 弹窗礼券
    isShowCoupon: function isShowCoupon() {
      var _this = this;
      var params = {
        token: _this.$store.state.wxLoginToken,
        uid: _this.$store.state.wxUid,
        mp: _this.$store.state.userInfo.mp_real,
        school_id: _this.schoolInfo.schoolId,
        isNewCustomer: _this.isJdlwNewCustomer
      };
      if (_this.isjdlw) {
        params.source = 'jdlw';
      }
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].showCoupon(_this, params, function (res) {
        if (res != null && res != 'null') {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = res.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.coupon_begin_time && item.coupon_end_time) {
                item.coupon_begin_time = item.coupon_begin_time.substr(0, 10);
                item.coupon_end_time = item.coupon_end_time.substr(0, 10);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.showCouponAlert = true;
          _this.couponInfo = res;
          var params = {
            logDetails: [{
              uid: _this.$store.state.wxUid || '',
              code: 'asa_popbonus_index',
              createTime: new Date().getTime(),
              firstValue: _this.schoolInfo.schoolId
            }]
          };
          _this.addLog(params);
        } else {
          _this.showCouponAlert = false;
        }
      }, function () {
        _this.showCouponAlert = false;
      });
    },
    closeCouponAlert: function closeCouponAlert() {
      this.showCouponAlert = false;
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid || '',
          code: 'click_popbonus_index',
          createTime: new Date().getTime(),
          firstValue: _this.schoolInfo.schoolId
        }]
      };
      this.addLog(params);
    },

    // 新学期红包
    isShowBonusPop: function isShowBonusPop() {
      var _this = this;
      var params = {
        login_token: _this.$store.state.wxLoginToken,
        school_id: _this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postPopBonusShow(_this, params, function (res) {
        if (res && res.business_jump_data) {
          res.business_jump_data = JSON.parse(res.business_jump_data);
          _this.bonusPop = res;
          _this.showBonusPop = true;
          var params = {
            logDetails: [{
              uid: _this.$store.state.wxUid || '',
              code: 'asa_ad_popbonus_index',
              createTime: new Date().getTime(),
              firstValue: _this.schoolInfo.schoolId,
              secondValue: res.business_type
            }]
          };
          _this.addLog(params);
        }
      }, function () {});
    },
    bonusPopJump: function bonusPopJump() {
      if (this.bonusPop.business_type == 1022) {
        if (!this.$utils.getCookie('alywechatToken')) {
          location.href = this.bonusPop.business_jump_data.url + '?token=' + this.$store.state.wxLoginToken;
        } else {
          location.href = this.bonusPop.business_jump_data.url;
        }
      }
      var params = {
        logDetails: [{
          uid: _this.$store.state.wxUid || '',
          code: 'click_ad_popbonus_index',
          createTime: new Date().getTime(),
          firstValue: _this.schoolInfo.schoolId,
          secondValue: this.bonusPop.business_type
        }]
      };
      this.addLog(params);
    },

    // 推荐下单活动
    isShowRecommend: function isShowRecommend() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].recommendBanner(_this, {}, function (res) {
        if (res != null) {
          _this.showRecommend = true;
          _this.activity = res;
        } else {
          _this.showRecommend = false;
        }
      }, function () {});
    },
    toRecommend: function toRecommend(item) {
      var obj = JSON.parse(item.data);
      if (obj.isNeedLogin) {
        var uid = this.$store.state.wxUid;
        if (uid == 'null' || uid == '' || uid == null) {
          // 如果没有登录信息先跳转登录页
          // this.$router.push({name: 'Login'})
          this.$utils.toLogin(this);
        } else {
          var token = this.$store.state.wxLoginToken;
          var _uid = this.$store.state.wxUid;
          var schoolId = this.schoolInfo.schoolId;
          var url = obj.url + '?token=' + token + '&uid=' + _uid + '&schoolId=' + schoolId;
          window.location.href = url;
        }
      } else {
        window.location.href = obj.url;
      }
    },

    showMoreGift: function showMoreGift(item) {
      item.iShowMore = !item.iShowMore;
    },
    // 公告
    getNotice: function getNotice() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };

      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getNoticeInfo(_this, params, function (data) {
        if (data && data.content) {
          // _this.noticeContent = data.content
          var noticeContent = data.content;
          _this.originNoticeContent = data.content;
          _this.noticeContent = noticeContent.replace(/<br\/>/g, ' ');
        }
      });
    },
    //公告弹框
    getNoticeDetail: function getNoticeDetail() {
      this.noticeList = this.originNoticeContent.split('<br/>');
      this.showNoticeAlert = true;
    },

    // 广告弹窗
    getAdsvcPop: function getAdsvcPop() {
      var _this = this;
      var url;
      var host = _this.$utils.getSpliceHost('adsvc');
      url = host + '/ad/app/getList.do';
      var params = {
        app_version: '5.3',
        client_type: 3,
        device_id: '123',
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: '62'
      };
      _this.$http.post(url, params).then(function (response) {
        // _this.adsvPopList = response.data.data.list
        // if (_this.adsvPopList.length > 0) {
        //   if (JSON.stringify(_this.adsvPopStatus) === '{}' || (_this.adsvPopStatus && !_this.adsvPopStatus.isClickClose) || (_this.adsvPopStatus && _this.adsvPopStatus.isClickClose && _this.adsvPopStatus.adsvId != _this.adsvPopList[0].adId)) {
        //     _this.showAdsvPop = true
        //   }
        // }
        if (response.data.data.list && response.data.data.list.length > 0) {
          // 0-每次启动都弹出 1-每日首次启动弹出一次 2-按设备仅弹出一次
          var lastDisplay = localStorage.getItem('lastDisplay'),
              // 已经展示过
          list = response.data.data.list,
              lastDisplayIds = [];
          if (lastDisplay && lastDisplay.length > 0) {
            lastDisplay = JSON.parse(lastDisplay);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = lastDisplay[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var v1 = _step2.value;
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                  for (var _iterator8 = list[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                    var _v4 = _step8.value;

                    // 判断每日首次
                    if (v1.frequency === 1 && _v4.adId == v1.adId) {
                      var today = new Date();
                      today.setHours(0);
                      today.setMinutes(0);
                      today.setSeconds(0);
                      today.setMilliseconds(0);
                      var otime = today.getTime();
                      var offset = v1.time - otime;
                      var isToday = offset / 1000 / 60 / 60;
                      if (isToday < 0 && isToday <= -24) {
                        // 昨天
                        v1.needDelete = true;
                      }
                    }
                    if (v1.frequency != _v4.frequency && _v4.adId == v1.adId) {
                      v1.needDelete = true;
                    }
                  }
                } catch (err) {
                  _didIteratorError8 = true;
                  _iteratorError8 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                      _iterator8.return();
                    }
                  } finally {
                    if (_didIteratorError8) {
                      throw _iteratorError8;
                    }
                  }
                }
              }
              // 判断每次启动都弹出
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (lastDisplay.length >= list.length) {
              var n2 = 0,
                  n3 = 0;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = lastDisplay[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _v = _step3.value;
                  var _iteratorNormalCompletion5 = true;
                  var _didIteratorError5 = false;
                  var _iteratorError5 = undefined;

                  try {
                    for (var _iterator5 = list[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                      var _v2 = _step5.value;

                      if (_v2.frequency === 0 && _v2.adId == _v.adId) {
                        n2++;
                      }
                    }
                  } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                      }
                    } finally {
                      if (_didIteratorError5) {
                        throw _iteratorError5;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var v2 = _step4.value;

                  if (v2.frequency === 0) {
                    n3++;
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }

              if (n2 == n3) {
                var array = [];
                lastDisplay.map(function (el, index) {
                  if (!list.find(function (item) {
                    return item.adId == el.adId;
                  })) {
                    array.push(lastDisplay[index]);
                  }
                });
                lastDisplay = array;
              }
            }
            var temp = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = lastDisplay[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _v3 = _step6.value;

                if (!_v3.needDelete) {
                  temp.push(_v3);
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }

            lastDisplay = temp;
            lastDisplay.forEach(function (v) {
              lastDisplayIds.push(v.adId);
            });
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = list[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var v = _step7.value;

                if (lastDisplayIds.indexOf(v.adId) == -1) {
                  if (v.frequency === 0 || v.frequency === 1 || v.frequency === 2) {
                    lastDisplay.push({
                      adId: v.adId,
                      frequency: v.frequency,
                      time: new Date().getTime()
                    });
                    this.isShowPop(v);
                    break;
                  }
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          } else {
            for (var i = 0; i < list.length; i++) {
              if (i == 0) {
                lastDisplay = [];
                lastDisplay.push({
                  adId: list[i].adId,
                  frequency: list[i].frequency,
                  time: new Date().getTime()
                });
                this.isShowPop(list[i]);
              }
            }
          }

          if (lastDisplay.length > 100) {
            lastDisplay = [];
          }
          localStorage.setItem('lastDisplay', JSON.stringify(lastDisplay));
        }
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      });
    },
    isShowPop: function isShowPop(item) {
      this.showAdsvPop = true;
      this.adsvPopItem = item;
    },
    closeAdsvPop: function closeAdsvPop() {
      this.showAdsvPop = false;
    },
    getBanner: function getBanner() {
      var _this = this;
      var url;
      var host = _this.$utils.getSpliceHost('adsvc');
      url = host + '/ad/app/getList.do';
      var params = {
        app_version: '5.3',
        client_type: 3,
        device_id: '123',
        time: new Date().getTime(),
        schoolId: _this.schoolInfo.schoolId,
        locationId: '118'
      };
      _this.$http.post(url, params).then(function (response) {
        _this.banners = response.data.data.list;

        if (_this.banners.length > 1) {
          setTimeout(function () {
            var mySwiper = new Swiper('.swiper-container.banner-container', {
              pagination: '.pagination',
              speed: 2000,
              loop: true,
              autoplay: 4000,
              onTap: function onTap(swiper, e) {
                var index = (swiper.activeIndex - 1) % _this.banners.length;
                //顶部轮播广告位的点击
                _this.bannerJump(_this.banners[index], '118', 'click_home_top_banner');
              }
              // autoplay: {
              //   delay: 4000,//4秒切换一次
              //   stopOnLastSlide: false,//如果设置为true，当切换到最后一个slide时停止自动切换。（loop模式下无效）
              //   disableOnInteraction: false,//用户操作swiper之后，是否禁止autoplay。默认为true：停止。
              //   reverseDirection: false,//不开启反向自动轮播。
              // }
            });
          }, 700);
        }

        var uid = localStorage.getItem('wxUid');
        if (uid) {
          var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
          exposureLog = exposureLog ? exposureLog : [];
          for (var k = 0; k < _this.banners.length; k++) {
            //顶部轮播广告位的曝光
            exposureLog.push({
              uid: uid == 'undefined' ? 0 : uid,
              refId: _this.banners[k].adId,
              firstValue: _this.schoolInfo.schoolId,
              secondValue: _this.banners[k].type || '',
              thirdValue: '118',
              createTime: new Date().getTime(),
              code: 'asa_home_top_banner'
            });
          }
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      }, function (response) {
        // _this.alert(response.message)
        // 响应错误回调
      });
    },
    bannerJump: function bannerJump(item, locationId, code) {
      var _this = this;
      if (item.data && item.data != '{}') {
        var jump = JSON.parse(item.data);
        if (jump.isNeedLogin && jump.isNeedLogin == 'true') {
          var uid = _this.$store.state.wxUid;
          if (uid == 'null' || uid == '' || uid == null) {
            // 如果没有登录信息先跳转登录页
            // _this.$router.push({name: 'Login'})
            _this.$utils.toLogin(_this);
            return;
          }
        }
        if (item.type == 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          };
          _this.$store.commit('changeState', obj);
          this.$router.push({ name: 'ShopList' });
        } else if (item.type == 500086) {
          // 活动店铺
          var obj = {
            category_name: jump.title,
            tag_id: jump.key_id,
            shopListType: 'activity'
          };
          _this.$store.commit('changeState', obj);
          this.$router.push({ name: 'ShopList' });
        } else if (item.type == 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            // 临时加
            if (jump.url.indexOf('bonus') > -1) {
              var uid = _this.$store.state.wxUid;
              if (uid == 'null' || uid == '' || uid == null) {
                // 如果没有登录信息先跳转登录页
                // _this.$router.push({name: 'Login'})
                _this.$utils.toLogin(_this);
              } else {
                if (!this.$utils.getCookie('alywechatToken')) {
                  location.href = jump.url + '?token=' + this.$store.state.wxLoginToken;
                } else {
                  location.href = jump.url;
                }
              }
            } else {
              window.location.href = jump.url;
            }
          }
        } else if (item.type == 500071) {
          var obj = {
            shop_code: jump.key_id,
            shop_name: jump.key_title,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'GoodsList' });
        }
      }
      var logDetails = [{
        uid: _this.$store.state.wxUid,
        code: code,
        createTime: new Date().getTime(),
        refId: item.adId || '',
        firstValue: _this.schoolInfo.schoolId,
        secondValue: item.type || '',
        thirdValue: locationId
      }];
      _this.addLog1(logDetails);
      // _this.getScoreClickAd()
    },
    //点击埋点
    addLog1: function addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, params, function (res) {
        console.log('success');
      }, function () {});
    },

    getLanternSlideList: function getLanternSlideList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getLanternSlide(_this, params, function (data) {
        _this.lanternSlideList = data;
        var uid = localStorage.getItem('wxUid');
        if (uid) {
          var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
          exposureLog = exposureLog ? exposureLog : [];
          for (var k = 0; k < data.length; k++) {
            //中间广告位的曝光
            exposureLog.push({
              uid: uid == 'undefined' ? 0 : uid,
              refId: data[k].id,
              firstValue: data[k].school_id,
              secondValue: data[k].app_jump_type || '',
              thirdValue: data[k].position || '',
              createTime: new Date().getTime(),
              code: 'asa_home_top_banner'
            });
          }
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
        }
      });
    },
    lanternSlideJump: function lanternSlideJump(item) {
      var _this = this;
      if (item.app_jump_params && item.app_jump_params != '{}') {
        var jump = JSON.parse(item.app_jump_params);
        if (item.app_jump_type == 500072) {
          var obj = {
            category_name: jump.key_title,
            tag_id: jump.key_id,
            shopListType: 'tag'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'ShopList' });
        } else if (item.app_jump_type == 1022) {
          if (jump.url != '' && jump.url != null && jump.url != 'undefined') {
            window.location.href = jump.url;
          }
        } else if (item.app_jump_type == 500071) {
          var obj = {
            shop_code: item.jump_target,
            shop_name: item.show_name,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'GoodsList' });
        } else if (item.app_jump_type == 500095) {
          _this.$router.push({ name: 'CouponPackage' });
        }
        //中间广告位点击埋点
        var logDetails = [{
          uid: _this.$store.state.wxUid,
          code: 'click_home_top_banner',
          createTime: new Date().getTime(),
          refId: item.id,
          firstValue: _this.schoolInfo.schoolId,
          secondValue: item.app_jump_type || '',
          thirdValue: item.position
        }];
        _this.addLog1(logDetails);
      }
      // _this.getScoreClickAd()
    },
    // 判断是否展示A页面
    getHomeStatus: function getHomeStatus() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getHomeStatus(_this, params, function (data) {
        if (data.home_status == 1) {
          // 展示A页
          _this.isOpenA = true;
          _this.getShowList();
        } else {
          _this.isOpenA = false;
          _this.getHomePageInfo();
          _this.getShopList();
        }
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
        // 响应错误回调
      });
    },
    // 获取A页面内容（球和食堂列表）
    getShowList: function getShowList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };
      _this.$indicator.open({
        text: '努力加载中'
      });
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getTagIndexList(_this, params, function (data) {
        _this.tagList = data.ball;
        _this.shopList = data.list;
        _this.showPage = true;
        // _this.getNotice();
        _this.$indicator.close();

        _this.$nextTick(function () {
          var shopList = document.getElementsByClassName("category-list");
          var lanternList = document.getElementsByClassName("lantern-list");
          var tagList = document.getElementsByClassName("tag-list");
          _this.stillHeight = _this.remSize * 3.58;
          if (shopList && shopList[0]) {
            _this.stillHeight = _this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3;
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight + _this.remSize * 0.2;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = _this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2;
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          var goodsList = document.getElementsByClassName('goods-ul');
          // console.log(_this.stillHeight)
          if (goodsList && goodsList[0]) {
            var item = Math.round(goodsList[0].offsetHeight / _this.shopList.length);
            if (localStorage.getItem('wxUid')) {
              localStorage.setItem('recordLogIdx', 0);
            }
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.shopList);
            localStorage.setItem('recordLogIdx', 0);
            _this.$store.commit('changeRecordPage', 'TagPage2');
            _this.$store.commit('changeRecordState', true);
            var uid = localStorage.getItem('wxUid');
            if (uid) {
              var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
              exposureLog = exposureLog ? exposureLog : [];
              //A页面球曝光
              for (var k = 0; k < data.ball.length; k++) {
                exposureLog.push({
                  uid: uid == 'undefined' ? 0 : uid,
                  refId: data.ball[k].id,
                  firstValue: data.ball[k].school_id,
                  createTime: new Date().getTime(),
                  code: 'asa_home_ball_scroll'
                });
              }
              localStorage.setItem('lastLogTime', new Date().getTime());
              localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
            }
          }
        });
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
        // 响应错误回调
      });
    },
    toGoHomePage: function toGoHomePage(item, n) {
      var _this = this;
      var jump_type = item.app_jump_type;
      if (item.app_jump_params && item.app_jump_params != '{}') {
        var jump_params = JSON.parse(item.app_jump_params);
        if (jump_type == 500072) {
          // 店铺标签
          var obj = {
            category_name: jump_params.key_title,
            tag_id: jump_params.key_id,
            shopListType: 'tag'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'ShopList' });
        } else if (jump_type == 500071) {
          // 店铺详情页面
          var obj = {
            shop_code: jump_params.key_id,
            shop_name: jump_params.key_title,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'GoodsList' });
        } else if (jump_type == 600007) {
          var obj = {
            category_code: jump_params.key_id,
            category_name: jump_params.key_title,
            shopListType: 'category'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'ShopList' });
        } else if (jump_type == 1022) {
          // h5
          if (jump_params.url) {
            window.location.href = jump_params.url;
          }
        }
      }

      // if (item.jump_type == 1) {
      //   var obj = {
      //     category_name: item.show_name,
      //     tag_id: item.jump_target,
      //     shopListType: 'tag'
      //   }
      //   _this.$store.commit('changeState', obj)
      //   this.$router.push({name: 'ShopList'})
      // } else if (item.jump_type == 4) {
      //   var obj = {
      //     shop_code: item.jump_target,
      //     shop_name: item.show_name,
      //     showBlockType: 'orderDishes'
      //   }
      //   _this.$store.commit('changeState', obj)
      //   _this.$router.push({name: 'GoodsList'})
      // } else {
      //   window.location.href = item.jump_target;
      // }
      // 埋点
      var clickParams;
      if (n) {
        // A球点击埋点
        var clickParams = [{
          uid: _this.$store.state.wxUid,
          code: 'click_home_ball',
          refId: item.id,
          firstValue: item.school_id,
          secondValue: item.app_jump_type || '',
          createTime: new Date().getTime()
        }];
        _this.addLog1(clickParams);
      } else {
        clickParams = {
          logDetails: [{
            uid: _this.$store.state.wxUid,
            code: 'click_takeout_indexa_school_refectory',
            createTime: new Date().getTime(),
            refId: jump_type,
            firstValue: _this.schoolInfo.schoolId
          }]
        };
        _this.addLog(clickParams);
      }
    },
    chooseSchool: function chooseSchool() {
      this.$router.push({ path: '/chooseschool' });
    },
    toSearch: function toSearch() {
      var _this = this;
      _this.$router.push({ name: 'Search' });
    },
    // 非A页面球列表
    getHomePageInfo: function getHomePageInfo() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: 1,
        pageSize: 1000
      };
      _this.$indicator.open({
        text: '努力加载中'
      });
      // 获取店铺分类列表
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postShopCategoryList(_this, params, function (data) {
        if (data && data.length > 0) {
          var list = [];
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = data[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var shop = _step9.value;

              var obj = {
                backgroundImage: 'url(' + shop.show_icon + ')'
              };
              shop.backgroundimg = obj;
              list.push(shop);
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          _this.shopCategoryList = list;
          _this.$nextTick(function () {
            var uid = localStorage.getItem('wxUid');
            if (uid) {
              var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
              exposureLog = exposureLog ? exposureLog : [];
              for (var k = 0; k < list.length; k++) {
                //非A页球曝光
                exposureLog.push({
                  uid: _this.$store.state.wxUid,
                  code: 'asa_home_ball_scroll',
                  createTime: new Date().getTime(),
                  refId: list[k].id,
                  firstValue: _this.schoolInfo.schoolId
                });
              }
              localStorage.setItem('lastLogTime', new Date().getTime());
              localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
            }
          });
        }
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        // _this.$messagebox.alert(data.body.message, '')
      });
    },
    handleScroll: function handleScroll() {
      // 得到页面滚动的距离
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置
      var val = scrollTop >= this.listOffsetTop - this.headerHeight * 2.5;
      this.isFixed = val;
    },

    getBenefitList: function getBenefitList() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getBenefitList(_this, params, function (data) {
        if (data && data.length > 0) {
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = data[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var item = _step10.value;

              if (item.promotion_list && item.promotion_list.length) {
                if (item.promotion_list.length > 3 && item.promotion_package && item.promotion_package.length) {
                  item.promotion_reduce.splice(2);
                  item.coupon_list = [];
                }
                if (item.promotion_list.length < 3 && !item.promotion_package.length && item.promotion_reduce.length > 4) {
                  item.coupon_list.splice(2);
                }
                if (item.promotion_list.length == 1 && !item.promotion_package && !item.promotion_reduce && !item.coupon_list) {
                  item.showMsg = true;
                }
              }
              if (item.promotion_package.length && item.promotion_reduce && item.promotion_reduce.reduce_info && item.promotion_reduce.reduce_info.length && item.coupon_list.length) {
                item.coupon_list = [];
              }
            }
            // _this.benefitList = data.concat(data)
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          _this.benefitList = data;
          _this.record1('', '', 'asa_index');
          _this.record1(_this.benefitList[0].id, '', 'asa_index_shop');
          for (var i = 0; i < _this.benefitList[0].goods.length; i++) {
            _this.record1('', _this.benefitList[0].goods[i].gdCode, 'asa_index_gd_area'); //菜品位置曝光
          }
          var uid = localStorage.getItem('wxUid');
          if (_this.benefitList.length > 1) {
            setTimeout(function () {
              var mySwiper = new Swiper('.swiper-container.benefit-container', {
                speed: 2000,
                loop: false,
                autoplay: 4000,
                observer: true,
                observeParents: true,
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
                onTap: function onTap(swiper, e) {
                  //商家权益轮播的点击
                  var data = _this.benefitList[swiper.activeIndex];
                  _this.record1(data.id, '', 'asa_index_shop');
                  //菜品位置曝光
                  for (var _i = 0; _i < data.goods.length; _i++) {
                    _this.record1('', data.goods[_i].gdCode, 'asa_index_gd_area');
                  }
                }
              });
            }, 300);
          }
        }
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    benefitJump: function benefitJump(val) {
      var _this = this;
      var obj = {
        shop_code: val.id,
        shop_name: val.shop_name,
        showBlockType: 'orderDishes'
      };
      _this.record1(val.id, '', 'click_index_shop');
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
    },
    goodsJump: function goodsJump(val, item) {
      var _this = this;
      var obj = {
        shop_code: val.id,
        shop_name: val.shop_name,
        showBlockType: 'orderDishes'
      };
      _this.record1('', item.gdCode, 'click_index_gd_area');
      _this.$store.commit('changeState', obj);
      _this.$router.push({ path: '/goodsList?gdCode=' + item.gdCode });
    },
    //选择商家分类
    switchTitle: function switchTitle(val) {
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = this.shopTitles[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var v = _step11.value;

          v.checked = false;
          if (v.id == val.id) {
            v.checked = true;
          }
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      this.shopSorts = [{ id: 0, title: '综合排序', checked: true }, { id: 1, title: '只看外卖', checked: false }, { id: 2, title: '只看自提', checked: false }, { id: 3, title: '只看堂食', checked: false }];
      this.currentPage = 1;
      this.page_size = 20;
      this.hasMore = false;
      this.noData = false;
      this.currentShopList = [];
      this.orderType = 0;
      this.currentTitle = val.id;
      this.isClick = 1;
      if (val.id == 0) {
        //全部商家
        this.getShopList();
      } else if (val.id == 1) {
        this.getPromtionShop();
      } else {
        this.getBoughtShop();
      }
      this.record2('click_index', '');
    },
    switchSort: function switchSort(val) {
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = this.shopSorts[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var v = _step12.value;

          v.checked = false;
          if (v.id == val.id) {
            v.checked = true;
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      this.currentPage = 1;
      this.page_size = 20;
      this.hasMore = false;
      this.noData = false;
      this.currentShopList = [];
      this.orderType = val.id;
      this.isClick = 2;
      this.getShopList();
      this.record2('click_index', '');
    },
    getPromtionShop: function getPromtionShop() {
      var _this = this;
      _this.hasMore = false;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getPromtionList(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = data[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var shop = _step13.value;

              var obj = {
                backgroundImage: 'url(' + shop.pic + ')'
              };
              shop.backgroundimg = obj;
              shop.iShowMore = false;
              if (shop.promotion_list && shop.promotion_list.length > 0) {
                if (shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list) {
                  shop.showMsg = true;
                }
                shop.promotion_list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                  return item.promotion_type;
                });
              }
              _this.currentShopList.push(shop);
              _this.record(); //店铺的曝光
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }
        } else {
          _this.hasMore = false;
          _this.noData = true;
        }
        _this.showPage = true;
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(function () {
          var shopList = document.getElementsByClassName("category-list");
          var lanternList = document.getElementsByClassName("lantern-list");
          var tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = _this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3;
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = _this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2;
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          var goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            var item = Math.round(goodsList[0].offsetHeight / _this.currentShopList.length);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }
          var header = document.getElementById("header");
          var list = document.getElementById('goods-list');

          // 这里要得到top的距离和元素自身的高度
          if (list) {
            _this.listOffsetTop = list.offsetTop;
          }
          if (header) {
            _this.headerHeight = header.offsetHeight;
          }
        });
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    getBoughtShop: function getBoughtShop() {
      var _this = this;
      _this.hasMore = false;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getBoughtList(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = data[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var shop = _step14.value;

              var obj = {
                backgroundImage: 'url(' + shop.pic + ')'
              };
              shop.backgroundimg = obj;
              shop.iShowMore = false;
              if (shop.promotion_list && shop.promotion_list.length > 0) {
                if (shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list) {
                  shop.showMsg = true;
                }
                shop.promotion_list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                  return item.promotion_type;
                });
              }
              _this.currentShopList.push(shop);
              _this.record(); //店铺的曝光
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }
        } else {
          _this.hasMore = false;
          _this.noData = true;
        }
        _this.showPage = true;
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(function () {
          var shopList = document.getElementsByClassName("category-list");
          var lanternList = document.getElementsByClassName("lantern-list");
          var tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = _this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3;
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = _this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2;
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          var goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            var item = Math.round(goodsList[0].offsetHeight / _this.currentShopList.length);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }
          var header = document.getElementById("header");
          var list = document.getElementById('goods-list');

          // 这里要得到top的距离和元素自身的高度
          if (list) {
            _this.listOffsetTop = list.offsetTop;
          }
          if (header) {
            _this.headerHeight = header.offsetHeight;
          }
        });
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    record: function record() {
      var indexId = 200;
      if (this.currentTitle == 0 && this.isClick == 1) {
        indexId = 200;
      } else if (this.currentTitle == 1) {
        indexId = 201;
      } else if (this.currentTitle == 2) {
        indexId = 202;
      }
      if (this.orderType == 1) {
        indexId = 204;
      } else if (this.orderType == 2) {
        indexId = 205;
      } else if (this.orderType == 3) {
        indexId = 206;
      } else if (this.orderType == 0 && this.isClick == 2) {
        indexId = 203;
      }
      localStorage.setItem('indexId', indexId);
    },
    record1: function record1(id, gd_code, code) {
      var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
      exposureLog = exposureLog ? exposureLog : [];
      exposureLog.push({
        uid: localStorage.getItem('wxUid') || '',
        secondValue: 207,
        firstValue: this.schoolInfo.schoolId,
        refId: id ? id : gd_code,
        createTime: new Date().getTime(),
        code: code
      });
      this.addLog1(exposureLog);
    },
    record2: function record2(code, id) {
      var indexId = void 0;
      if (this.currentTitle == 0 && this.isClick == 1) {
        indexId = 200;
      } else if (this.currentTitle == 1) {
        indexId = 201;
      } else if (this.currentTitle == 2) {
        indexId = 202;
      }
      if (this.orderType == 1) {
        indexId = 204;
      } else if (this.orderType == 2) {
        indexId = 205;
      } else if (this.orderType == 3) {
        indexId = 206;
      } else if (this.orderType == 0 && this.isClick == 2) {
        indexId = 203;
      }
      var exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
      exposureLog = exposureLog ? exposureLog : [];
      exposureLog.push({
        uid: localStorage.getItem('wxUid') || '',
        secondValue: indexId,
        firstValue: this.schoolInfo.schoolId,
        refId: id ? id : '',
        createTime: new Date().getTime(),
        code: code
      });
      this.addLog1(exposureLog);
    },

    // 非A页面商家列表
    getShopList: function getShopList() {
      var _this = this;
      _this.hasMore = false;
      var params = {
        school_id: _this.schoolInfo.schoolId,
        page: _this.currentPage,
        pageSize: _this.pageSize,
        orderType: _this.orderType,
        sort_type: 0
        // 获取当前校区商家列表
      };__WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getShopListNew(_this, params, function (data) {
        if (data && data.length > 0) {
          if (data.length < _this.pageSize) {
            _this.hasMore = false;
          } else {
            _this.hasMore = true;
          }
          _this.currentPage = _this.currentPage + 1;
          var _iteratorNormalCompletion15 = true;
          var _didIteratorError15 = false;
          var _iteratorError15 = undefined;

          try {
            for (var _iterator15 = data[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
              var shop = _step15.value;

              var obj = {
                backgroundImage: 'url(' + shop.pic + ')'
              };
              shop.backgroundimg = obj;
              shop.iShowMore = false;
              if (shop.promotion_list && shop.promotion_list.length > 0) {
                if (shop.promotion_list.length == 1 && !shop.promotion_package && !shop.promotion_reduce && !shop.coupon_list) {
                  shop.showMsg = true;
                }
                shop.promotion_list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(shop.promotion_list, function (item) {
                  return item.promotion_type;
                });
              }
              _this.currentShopList.push(shop);
            }
          } catch (err) {
            _didIteratorError15 = true;
            _iteratorError15 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion15 && _iterator15.return) {
                _iterator15.return();
              }
            } finally {
              if (_didIteratorError15) {
                throw _iteratorError15;
              }
            }
          }

          _this.record(); //店铺的曝光
        } else {
          _this.hasMore = false;
          _this.noData = true;
        }
        _this.showPage = true;
        // _this.getNotice();
        // _this.ScrollImgLeft();
        _this.$indicator.close();
        // console.log('是A么')
        // console.log(data)
        _this.$nextTick(function () {
          var shopList = document.getElementsByClassName("category-list");
          var lanternList = document.getElementsByClassName("lantern-list");
          var tagList = document.getElementsByClassName("tag-list");
          if (shopList && shopList[0]) {
            _this.stillHeight = _this.stillHeight + shopList[0].offsetHeight + _this.remSize * 0.3;
          }
          if (lanternList && lanternList[0]) {
            _this.stillHeight = _this.stillHeight + lanternList[0].offsetHeight;
          }
          if (tagList && tagList[0]) {
            _this.stillHeight = _this.stillHeight + tagList[0].offsetHeight + _this.remSize * 0.2;
          }
          _this.$store.commit('changeRecordOtherHeight', _this.stillHeight);
          var goodsList = document.getElementsByClassName('goods-ul');
          // console.log(goodsList)
          if (goodsList && goodsList[0]) {
            var item = Math.round(goodsList[0].offsetHeight / _this.currentShopList.length);
            _this.$store.commit('changeRecordItemHeight', item);
            _this.$store.commit('changeRecordList', _this.currentShopList);
            _this.$store.commit('changeRecordPage', 'TagPage');
            _this.$store.commit('changeRecordState', true);
          }

          var header = document.getElementById("header");
          var list = document.getElementById('goods-list');
          // 这里要得到top的距离和元素自身的高度
          if (list) {
            _this.listOffsetTop = list.offsetTop;
          }
          if (header) {
            _this.headerHeight = header.offsetHeight;
          }
        });
      }, function (data) {
        _this.showPage = true;
        _this.$indicator.close();
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    toGoodsList: function toGoodsList(id, name) {
      var _this = this;
      var obj = {
        shop_code: id,
        shop_name: name,
        showBlockType: 'orderDishes'
      };
      _this.$store.commit('changeState', obj);
      _this.$router.push({ name: 'GoodsList' });
      // 埋点
      this.record2('click_index_shop', id);
    },
    toShopList: function toShopList(item) {
      var _this = this;
      var jump_type = item.app_jump_type;
      if (item.app_jump_params && item.app_jump_params != '{}') {
        var jump_params = JSON.parse(item.app_jump_params);
        if (jump_type == 500072) {
          // 店铺标签
          var obj = {
            category_name: jump_params.key_title,
            tag_id: jump_params.key_id,
            shopListType: 'tag'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'ShopList' });
        } else if (jump_type == 500071) {
          // 店铺详情页面
          var obj = {
            shop_code: jump_params.key_id,
            shop_name: jump_params.key_title,
            showBlockType: 'orderDishes'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'GoodsList' });
        } else if (jump_type == 600007) {
          var obj = {
            category_code: jump_params.key_id,
            category_name: jump_params.key_title,
            shopListType: 'category'
          };
          _this.$store.commit('changeState', obj);
          _this.$router.push({ name: 'ShopList' });
        } else if (jump_type == 1022) {
          // h5
          if (jump_params.url) {
            window.location.href = jump_params.url;
          }
        }
      }
      // 非A球点击埋点
      var clickParams = [{
        uid: _this.$store.state.wxUid,
        code: 'click_home_ball',
        refId: item.id,
        firstValue: item.school_id,
        secondValue: item.app_jump_type || '',
        createTime: new Date().getTime()
      }];
      _this.addLog1(clickParams);
    },
    //右下悬浮块
    clickLog: function clickLog(jumpType, code) {
      var _this = this;
      var logs = [{
        uid: _this.$store.state.wxUid,
        firstValue: _this.schoolInfo.schoolId,
        secondValue: jumpType,
        createTime: new Date().getTime(),
        code: code
      }];
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postLogAdd(_this, logs, function (data) {
        console.log('记录成功');
      }, function (data) {});
    },


    // 活动常驻入口
    getCardPlus: function getCardPlus() {
      var _this = this;
      var params = {
        school_id: _this.schoolInfo.schoolId
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postCardPlus(_this, params, function (res) {
        if (res && res.card) {
          _this.cardPlusInfo = res;
          var logDetails = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_app_suspend',
            createTime: new Date().getTime(),
            firstValue: _this.schoolInfo.schoolId,
            secondValue: _this.cardPlusInfo.jump_type
          }];
          _this.addLog1(logDetails); //右下悬浮块曝光
        }
      }, function () {});
    },
    cardJump: function cardJump() {
      var item = { type: this.cardPlusInfo.jump_type, data: this.cardPlusInfo.jump_data };
      this.bannerJump(item, '', 'click_app_suspend'); //右下悬浮块点击
    },

    // 点击广告得积分
    getScoreClickAd: function getScoreClickAd() {
      var _this = this;
      if (!_this.$store.state.wxUid) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].scoreClickAd(_this, {}, function (res) {}, function () {});
    }
  },
  components: {
    CommentStars: __WEBPACK_IMPORTED_MODULE_1__components_CommentStars___default.a
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { MessageBox }  from 'mint-ui';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPage: false,
      uid: null,
      showRecommend: false,
      bannerUrl: '', //banner图片链接
      activityUrl: '', //活动链接
      isJdlwHide: false,
      scoreInfo: {} //会员积分信息
    };
  },

  computed: {
    userInfo: function userInfo() {
      return this.$store.state.userInfo;
    },
    schoolInfo: function schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    wxUid: function wxUid() {
      return this.$store.state.wxUid;
    },
    wxLoginToken: function wxLoginToken() {
      return this.$store.state.wxLoginToken;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderList') {
      to.meta.isUseCache = false;
    }
    // if (to.name == 'TagPage') {
    //   to.meta.isUseCache = true
    // }
    next();
  },
  created: function created() {
    var _this = this;
    _this.uid = window.localStorage.getItem('wxUid');
    if (_this.uid && _this.uid != "null" && _this.uid != '') {
      var obj = {
        backgroundImage: "url(" + _this.userInfo.avatar + ")"
      };
      _this.userInfo.backgroundimg = obj;
      _this.isShowRecommend(); //是否显示推荐下单领红包的bannner
      _this.showPage = true;
      _this.getScoreInfo(); // 我的西游积分
    }
    if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
      _this.isJdlwHide = true;
    }
  },

  methods: {
    /**
     * 发起接入请求
     * @param  {Number} productId  需要接入产品 id
     * @param  {[Object]} data     需要传递的用户信息
     */
    request: function request(productId, data) {
      var form = document.createElement("form");
      form.id = "form";
      form.name = "form";
      document.body.appendChild(form);

      // 设置相应参数
      for (var key in data) {
        var input = document.createElement("input");
        input.type = "text";
        input.name = key;
        input.value = data[key];
        // 将该输入框插入到 form 中
        form.appendChild(input);
      }
      // form 的提交方式
      form.method = "POST";
      // form 提交路径
      form.action = "https://support.qq.com/product/" + productId;
      // 对该 form 执行提交
      form.submit();
      // 删除该 form
      document.body.removeChild(form);
    },
    goTuCao: function goTuCao() {
      var data = {
        "nickname": this.userInfo.nickname,
        "avatar": this.userInfo.backgroundimg,
        "openid": this.$store.state.openId
      },
          productId = 43614; // 把1221数字换成你的产品ID，否则会不成功
      this.request(productId, data);
    },
    isShowRecommend: function isShowRecommend() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].recommendBanner(_this, {}, function (res) {
        if (res != null) {
          _this.showRecommend = true;
          _this.bannerUrl = res.imageUrl;
          var obj = JSON.parse(res.data);
          _this.activityUrl = obj.url; //banner跳转链接
        } else {
          _this.showRecommend = false;
        }
      }, function () {});
    },
    getScoreInfo: function getScoreInfo() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getMyScore(_this, { uid: _this.$store.state.wxUid }, function (res) {
        _this.scoreInfo = res;
      }, function () {});
    },
    toMyScore: function toMyScore() {
      this.$router.push({ name: 'MyScore' });
    },
    toMemberLevel: function toMemberLevel() {
      this.$router.push({ name: 'MemberLevel' });
    },
    toRecommend: function toRecommend() {
      var token = this.$store.state.wxLoginToken;
      var uid = this.$store.state.wxUid;
      var schoolId = this.schoolInfo.schoolId;
      var url = this.activityUrl + '?token=' + token + '&uid=' + uid + '&schoolId=' + schoolId;
      window.location.href = url;
    },

    loginOut: function loginOut() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].postSignOut(_this, { token: _this.$store.state.wxToken }, function () {
        var obj = {
          wxUid: ''
        };
        window.localStorage.removeItem('userDefinedMobile'); //退出账号清除自定义自提电话
        window.localStorage.removeItem('cartInfo'); //退出账号清除购物车信息
        window.localStorage.removeItem('userInfo');
        window.localStorage.removeItem('wxLoginToken');
        _this.$store.commit('changeState', obj);
        _this.$router.push({ name: 'TagPage' });
      }, function (data) {
        _this.$messagebox.alert(data.body.message, '');
      });
    },
    toAddressList: function toAddressList() {
      var _this = this;
      window.localStorage.setItem('fromPage', 'UserCenter'); //存储fromPage，用来判断页面是否可以选择地址
      _this.$router.push({ name: 'AddressList' });
    },
    toMyComment: function toMyComment() {
      var _this = this;
      window.localStorage.setItem('commentType', 1);
      _this.$router.push({ name: 'MyComment' });
    },
    toMyComplaints: function toMyComplaints() {
      var _this = this;
      _this.$router.push({ name: 'MyComplaints' });
    },
    toMyCoupons: function toMyCoupons() {
      this.$router.push({ name: 'MyCoupons' });
    },
    downLoadApp: function downLoadApp() {
      window.location.href = 'https://dl.anlaiye.com';
    },
    toGoLogin: function toGoLogin() {
      this.$utils.toLogin(this);
    },
    toMyService: function toMyService() {
      window.location.href = 'https://service.anlaiye.com.cn/service/service/index';
    },
    toShare: function toShare() {
      var token = this.$store.state.wxLoginToken;
      var schoolId = this.schoolInfo.schoolId;
      window.location.href = this.$utils.getSpliceHost('special') + '/theme/v1/h5/202404/invite/index.html?token=' + token + '&schoolId=' + schoolId;
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__store_actions__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "myScore",
  data: function data() {
    return {
      scoreList: [],
      scoreInfo: {},
      showMask: false,
      signedInfo: {},
      showMakeScore: false,
      makeScoreInfo: {},
      userSignInfo: {},
      taskInfo: {}
    };
  },
  created: function created() {
    this.getScoreInfo();
    this.getScoreList();
  },

  methods: {
    getScoreInfo: function getScoreInfo() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getMyScore(_this, { uid: _this.$store.state.wxUid }, function (res) {
        _this.scoreInfo = res;
      }, function () {});
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getUserSignList(_this, { uid: _this.$store.state.wxUid }, function (res) {
        _this.userSignInfo = res;
      }, function () {});
    },
    getScoreList: function getScoreList() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].getScoreListNew(_this, { uid: _this.$store.state.wxUid }, function (res) {
        _this.taskInfo = res;
      }, function () {});
    },
    toScoreDetail: function toScoreDetail() {
      this.$router.push({ name: 'ScoreDetail' });
    },
    toSign: function toSign(status) {
      if (status === 0) {
        return;
      }
      var _this = this;
      var params = {
        uid: _this.$store.state.wxUid,
        school_id: _this.$store.state.schoolInfo.schoolId,
        school_name: _this.$store.state.schoolInfo.schoolName,
        mp_encryption: this.$utils.Encrypt(_this.$store.state.userInfo.mp_real)
      };
      __WEBPACK_IMPORTED_MODULE_0__store_actions__["actions"].userSign(_this, params, function (res) {
        _this.signedInfo = res;
        _this.showMask = true;
        _this.getScoreInfo();
      }, function (res) {
        _this.showMask = false;
        _this.$messagebox.alert(res.body.message, '');
      });
    },
    makeScore: function makeScore(item) {
      // this.showMakeScore = true;
      // this.makeScoreInfo = item;
      if (item.jump_type == 500077) {
        this.$router.push({ name: 'OrderList' });
      } else {
        this.$router.push({ name: 'TagPage' });
      }
    },
    toRules: function toRules() {
      location.href = 'https://special.anlaiye.com/theme/v1/h5/protocol/alyScore1.html';
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      packingFeeDetail: {},
      description: ''
    };
  },
  created: function created() {
    if (localStorage.getItem('packingFeeDetail')) {
      this.packingFeeDetail = JSON.parse(localStorage.getItem('packingFeeDetail'));
      // this.packingFeeDetail.value = JSON.parse(this.packingFeeDetail.value);
      if (this.packingFeeDetail.value.description) {
        this.packingFeeDetail.value.description = this.packingFeeDetail.value.description.replace(/\n/g, "<br />");
      }
      if (this.packingFeeDetail.title) {
        document.title = this.packingFeeDetail.title;
      }
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_mint_ui__["InfiniteScroll"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "scoreDetail",
  data: function data() {
    return {
      scoreDetail: [],
      page: 1,
      page_size: 20,
      hasMore: true,
      isOk: false,
      loading: false
    };
  },
  created: function created() {
    this.$indicator.open();
    this.getScoreDetail(true);
  },

  methods: {
    getScoreDetail: function getScoreDetail(flag) {
      var _this = this;
      _this.isOk = false;
      if (!_this.hasMore) {
        return;
      }
      if (flag) {
        _this.scoreDetail = [];
        _this.page = 1;
      }
      var params = {
        uid: _this.$store.state.wxUid,
        page: _this.page,
        page_size: _this.page_size
      };
      __WEBPACK_IMPORTED_MODULE_1__store_actions__["actions"].getScoreDetail(_this, params, function (res) {
        _this.$indicator.close();
        if (res != null && res.list.length > 0) {
          if (res.list.length < _this.page_size) {
            _this.hasMore = false;
          }
          _this.page++;
          var scoreDetail = _this.scoreDetail.concat(res.list);
          _this.scoreDetail = scoreDetail;
          _this.isOk = true;
        } else {
          _this.hasMore = false;
        }
      }, function () {
        _this.$indicator.close();
      });
    },

    loadMore: function loadMore() {
      var _this2 = this;

      if (!this.hasMore) {
        return;
      }
      if (this.isOk) {
        this.loading = true;
        //          this.$indicator.open()
        setTimeout(function () {
          _this2.getScoreDetail(false);
          _this2.loading = false;
        }, 1000);
      }
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {}
});

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! iScroll v5.2.0-snapshot ~ (c) 2008-2017 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
	var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
		window.setTimeout(callback, 1000 / 60);
	};

	var utils = function () {
		var me = {};

		var _elementStyle = document.createElement('div').style;
		var _vendor = function () {
			var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			    transform,
			    i = 0,
			    l = vendors.length;

			for (; i < l; i++) {
				transform = vendors[i] + 'ransform';
				if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
			}

			return false;
		}();

		function _prefixStyle(style) {
			if (_vendor === false) return false;
			if (_vendor === '') return style;
			return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
		}

		me.getTime = Date.now || function getTime() {
			return new Date().getTime();
		};

		me.extend = function (target, obj) {
			for (var i in obj) {
				target[i] = obj[i];
			}
		};

		me.addEvent = function (el, type, fn, capture) {
			el.addEventListener(type, fn, !!capture);
		};

		me.removeEvent = function (el, type, fn, capture) {
			el.removeEventListener(type, fn, !!capture);
		};

		me.prefixPointerEvent = function (pointerEvent) {
			return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8) : pointerEvent;
		};

		me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
			var distance = current - start,
			    speed = Math.abs(distance) / time,
			    destination,
			    duration;

			deceleration = deceleration === undefined ? 0.0006 : deceleration;

			destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
			duration = speed / deceleration;

			if (destination < lowerMargin) {
				destination = wrapperSize ? lowerMargin - wrapperSize / 2.5 * (speed / 8) : lowerMargin;
				distance = Math.abs(destination - current);
				duration = distance / speed;
			} else if (destination > 0) {
				destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
				distance = Math.abs(current) + destination;
				duration = distance / speed;
			}

			return {
				destination: Math.round(destination),
				duration: duration
			};
		};

		var _transform = _prefixStyle('transform');

		me.extend(me, {
			hasTransform: _transform !== false,
			hasPerspective: _prefixStyle('perspective') in _elementStyle,
			hasTouch: 'ontouchstart' in window,
			hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
			hasTransition: _prefixStyle('transition') in _elementStyle
		});

		/*
  This should find all Android browsers lower than build 535.19 (both stock browser and webview)
  - galaxy S2 is ok
     - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
     - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S3 is badAndroid (stock brower, webview)
      `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S4 is badAndroid (stock brower, webview)
      `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
    - galaxy S5 is OK
      `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
    - galaxy S6 is OK
      `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   */
		me.isBadAndroid = function () {
			var appVersion = window.navigator.appVersion;
			// Android browser is not a chrome browser.
			if (/Android/.test(appVersion) && !/Chrome\/\d/.test(appVersion)) {
				var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
				if (safariVersion && (typeof safariVersion === 'undefined' ? 'undefined' : _typeof(safariVersion)) === "object" && safariVersion.length >= 2) {
					return parseFloat(safariVersion[1]) < 535.19;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}();

		me.extend(me.style = {}, {
			transform: _transform,
			transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
			transitionDuration: _prefixStyle('transitionDuration'),
			transitionDelay: _prefixStyle('transitionDelay'),
			transformOrigin: _prefixStyle('transformOrigin'),
			touchAction: _prefixStyle('touchAction')
		});

		me.hasClass = function (e, c) {
			var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
			return re.test(e.className);
		};

		me.addClass = function (e, c) {
			if (me.hasClass(e, c)) {
				return;
			}

			var newclass = e.className.split(' ');
			newclass.push(c);
			e.className = newclass.join(' ');
		};

		me.removeClass = function (e, c) {
			if (!me.hasClass(e, c)) {
				return;
			}

			var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
			e.className = e.className.replace(re, ' ');
		};

		me.offset = function (el) {
			var left = -el.offsetLeft,
			    top = -el.offsetTop;

			// jshint -W084
			while (el = el.offsetParent) {
				left -= el.offsetLeft;
				top -= el.offsetTop;
			}
			// jshint +W084

			return {
				left: left,
				top: top
			};
		};

		me.preventDefaultException = function (el, exceptions) {
			for (var i in exceptions) {
				if (exceptions[i].test(el[i])) {
					return true;
				}
			}

			return false;
		};

		me.extend(me.eventType = {}, {
			touchstart: 1,
			touchmove: 1,
			touchend: 1,

			mousedown: 2,
			mousemove: 2,
			mouseup: 2,

			pointerdown: 3,
			pointermove: 3,
			pointerup: 3,

			MSPointerDown: 3,
			MSPointerMove: 3,
			MSPointerUp: 3
		});

		me.extend(me.ease = {}, {
			quadratic: {
				style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
				fn: function fn(k) {
					return k * (2 - k);
				}
			},
			circular: {
				style: 'cubic-bezier(0.1, 0.57, 0.1, 1)', // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
				fn: function fn(k) {
					return Math.sqrt(1 - --k * k);
				}
			},
			back: {
				style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
				fn: function fn(k) {
					var b = 4;
					return (k = k - 1) * k * ((b + 1) * k + b) + 1;
				}
			},
			bounce: {
				style: '',
				fn: function fn(k) {
					if ((k /= 1) < 1 / 2.75) {
						return 7.5625 * k * k;
					} else if (k < 2 / 2.75) {
						return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
					} else if (k < 2.5 / 2.75) {
						return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
					} else {
						return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
					}
				}
			},
			elastic: {
				style: '',
				fn: function fn(k) {
					var f = 0.22,
					    e = 0.4;

					if (k === 0) {
						return 0;
					}
					if (k == 1) {
						return 1;
					}

					return e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1;
				}
			}
		});

		me.tap = function (e, eventName) {
			var ev = document.createEvent('Event');
			ev.initEvent(eventName, true, true);
			ev.pageX = e.pageX;
			ev.pageY = e.pageY;
			e.target.dispatchEvent(ev);
		};

		me.click = function (e) {
			var target = e.target,
			    ev;

			if (!/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {
				// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
				// initMouseEvent is deprecated.
				ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
				ev.initEvent('click', true, true);
				ev.view = e.view || window;
				ev.detail = 1;
				ev.screenX = target.screenX || 0;
				ev.screenY = target.screenY || 0;
				ev.clientX = target.clientX || 0;
				ev.clientY = target.clientY || 0;
				ev.ctrlKey = !!e.ctrlKey;
				ev.altKey = !!e.altKey;
				ev.shiftKey = !!e.shiftKey;
				ev.metaKey = !!e.metaKey;
				ev.button = 0;
				ev.relatedTarget = null;
				ev._constructed = true;
				target.dispatchEvent(ev);
			}
		};

		me.getTouchAction = function (eventPassthrough, addPinch) {
			var touchAction = 'none';
			if (eventPassthrough === 'vertical') {
				touchAction = 'pan-y';
			} else if (eventPassthrough === 'horizontal') {
				touchAction = 'pan-x';
			}
			if (addPinch && touchAction != 'none') {
				// add pinch-zoom support if the browser supports it, but if not (eg. Chrome <55) do nothing
				touchAction += ' pinch-zoom';
			}
			return touchAction;
		};

		me.getRect = function (el) {
			if (el instanceof SVGElement) {
				var rect = el.getBoundingClientRect();
				return {
					top: rect.top,
					left: rect.left,
					width: rect.width,
					height: rect.height
				};
			} else {
				return {
					top: el.offsetTop,
					left: el.offsetLeft,
					width: el.offsetWidth,
					height: el.offsetHeight
				};
			}
		};

		return me;
	}();
	function IScroll(el, options) {
		this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
		this.scroller = this.wrapper.children[0];
		this.scrollerStyle = this.scroller.style; // cache style for better performance

		this.options = {

			resizeScrollbars: true,

			mouseWheelSpeed: 20,

			snapThreshold: 0.334,

			// INSERT POINT: OPTIONS
			disablePointer: !utils.hasPointer,
			disableTouch: utils.hasPointer || !utils.hasTouch,
			disableMouse: utils.hasPointer || utils.hasTouch,
			startX: 0,
			startY: 0,
			scrollY: true,
			directionLockThreshold: 5,
			momentum: true,

			bounce: true,
			bounceTime: 600,
			bounceEasing: '',

			preventDefault: true,
			preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

			HWCompositing: true,
			useTransition: true,
			useTransform: true,
			bindToWrapper: typeof window.onmousedown === "undefined"
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		// Normalize options
		this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

		this.options.useTransition = utils.hasTransition && this.options.useTransition;
		this.options.useTransform = utils.hasTransform && this.options.useTransform;

		this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
		this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

		// If you want eventPassthrough I have to lock one of the axes
		this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
		this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

		// With eventPassthrough we also need lockDirection mechanism
		this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
		this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

		this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

		this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

		if (this.options.tap === true) {
			this.options.tap = 'tap';
		}

		// https://github.com/cubiq/iscroll/issues/1029
		if (!this.options.useTransition && !this.options.useTransform) {
			if (!/relative|absolute/i.test(this.scrollerStyle.position)) {
				this.scrollerStyle.position = "relative";
			}
		}

		if (this.options.shrinkScrollbars == 'scale') {
			this.options.useTransition = false;
		}

		this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

		if (this.options.probeType == 3) {
			this.options.useTransition = false;
		}

		// INSERT POINT: NORMALIZATION

		// Some defaults
		this.x = 0;
		this.y = 0;
		this.directionX = 0;
		this.directionY = 0;
		this._events = {};

		// INSERT POINT: DEFAULTS

		this._init();
		this.refresh();

		this.scrollTo(this.options.startX, this.options.startY);
		this.enable();
	}

	IScroll.prototype = {
		version: '5.2.0-snapshot',

		_init: function _init() {
			this._initEvents();

			if (this.options.scrollbars || this.options.indicators) {
				this._initIndicators();
			}

			if (this.options.mouseWheel) {
				this._initWheel();
			}

			if (this.options.snap) {
				this._initSnap();
			}

			if (this.options.keyBindings) {
				this._initKeys();
			}

			// INSERT POINT: _init
		},

		destroy: function destroy() {
			this._initEvents(true);
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = null;
			this._execEvent('destroy');
		},

		_transitionEnd: function _transitionEnd(e) {
			if (e.target != this.scroller || !this.isInTransition) {
				return;
			}

			this._transitionTime();
			if (!this.resetPosition(this.options.bounceTime)) {
				this.isInTransition = false;
				this._execEvent('scrollEnd');
			}
		},

		_start: function _start(e) {
			// React to left mouse button only
			if (utils.eventType[e.type] != 1) {
				// for button property
				// http://unixpapa.com/js/mouse.html
				var button;
				if (!e.which) {
					/* IE case */
					button = e.button < 2 ? 0 : e.button == 4 ? 1 : 2;
				} else {
					/* All others */
					button = e.button;
				}
				if (button !== 0) {
					return;
				}
			}

			if (!this.enabled || this.initiated && utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    pos;

			this.initiated = utils.eventType[e.type];
			this.moved = false;
			this.distX = 0;
			this.distY = 0;
			this.directionX = 0;
			this.directionY = 0;
			this.directionLocked = 0;

			this.startTime = utils.getTime();

			if (this.options.useTransition && this.isInTransition) {
				this._transitionTime();
				this.isInTransition = false;
				pos = this.getComputedPosition();
				this._translate(Math.round(pos.x), Math.round(pos.y));
				this._execEvent('scrollEnd');
			} else if (!this.options.useTransition && this.isAnimating) {
				this.isAnimating = false;
				this._execEvent('scrollEnd');
			}

			this.startX = this.x;
			this.startY = this.y;
			this.absStartX = this.x;
			this.absStartY = this.y;
			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault) {
				// increases performance on Android? TODO: check!
				e.preventDefault();
			}

			var point = e.touches ? e.touches[0] : e,
			    deltaX = point.pageX - this.pointX,
			    deltaY = point.pageY - this.pointY,
			    timestamp = utils.getTime(),
			    newX,
			    newY,
			    absDistX,
			    absDistY;

			this.pointX = point.pageX;
			this.pointY = point.pageY;

			this.distX += deltaX;
			this.distY += deltaY;
			absDistX = Math.abs(this.distX);
			absDistY = Math.abs(this.distY);

			// We need to move at least 10 pixels for the scrolling to initiate
			if (timestamp - this.endTime > 300 && absDistX < 10 && absDistY < 10) {
				return;
			}

			// If you are scrolling in one direction lock the other
			if (!this.directionLocked && !this.options.freeScroll) {
				if (absDistX > absDistY + this.options.directionLockThreshold) {
					this.directionLocked = 'h'; // lock horizontally
				} else if (absDistY >= absDistX + this.options.directionLockThreshold) {
					this.directionLocked = 'v'; // lock vertically
				} else {
					this.directionLocked = 'n'; // no lock
				}
			}

			if (this.directionLocked == 'h') {
				if (this.options.eventPassthrough == 'vertical') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'horizontal') {
					this.initiated = false;
					return;
				}

				deltaY = 0;
			} else if (this.directionLocked == 'v') {
				if (this.options.eventPassthrough == 'horizontal') {
					e.preventDefault();
				} else if (this.options.eventPassthrough == 'vertical') {
					this.initiated = false;
					return;
				}

				deltaX = 0;
			}

			deltaX = this.hasHorizontalScroll ? deltaX : 0;
			deltaY = this.hasVerticalScroll ? deltaY : 0;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			// Slow down if outside of the boundaries
			if (newX > 0 || newX < this.maxScrollX) {
				newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
			}
			if (newY > 0 || newY < this.maxScrollY) {
				newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
			}

			this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
			this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

			if (!this.moved) {
				this._execEvent('scrollStart');
			}

			this.moved = true;

			this._translate(newX, newY);

			/* REPLACE START: _move */
			if (timestamp - this.startTime > 300) {
				this.startTime = timestamp;
				this.startX = this.x;
				this.startY = this.y;

				if (this.options.probeType == 1) {
					this._execEvent('scroll');
				}
			}

			if (this.options.probeType > 1) {
				this._execEvent('scroll');
			}
			/* REPLACE END: _move */
		},

		_end: function _end(e) {
			if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
				return;
			}

			if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
				e.preventDefault();
			}

			var point = e.changedTouches ? e.changedTouches[0] : e,
			    momentumX,
			    momentumY,
			    duration = utils.getTime() - this.startTime,
			    newX = Math.round(this.x),
			    newY = Math.round(this.y),
			    distanceX = Math.abs(newX - this.startX),
			    distanceY = Math.abs(newY - this.startY),
			    time = 0,
			    easing = '';

			this.isInTransition = 0;
			this.initiated = 0;
			this.endTime = utils.getTime();

			// reset if we are outside of the boundaries
			if (this.resetPosition(this.options.bounceTime)) {
				return;
			}

			this.scrollTo(newX, newY); // ensures that the last position is rounded

			// we scrolled less than 10 pixels
			if (!this.moved) {
				if (this.options.tap) {
					utils.tap(e, this.options.tap);
				}

				if (this.options.click) {
					utils.click(e);
				}

				this._execEvent('scrollCancel');
				return;
			}

			if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
				this._execEvent('flick');
				return;
			}

			// start momentum animation if needed
			if (this.options.momentum && duration < 300) {
				momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
				momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
				newX = momentumX.destination;
				newY = momentumY.destination;
				time = Math.max(momentumX.duration, momentumY.duration);
				this.isInTransition = 1;
			}

			if (this.options.snap) {
				var snap = this._nearestSnap(newX, newY);
				this.currentPage = snap;
				time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
				newX = snap.x;
				newY = snap.y;

				this.directionX = 0;
				this.directionY = 0;
				easing = this.options.bounceEasing;
			}

			// INSERT POINT: _end

			if (newX != this.x || newY != this.y) {
				// change easing function when scroller goes out of the boundaries
				if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
					easing = utils.ease.quadratic;
				}

				this.scrollTo(newX, newY, time, easing);
				return;
			}

			this._execEvent('scrollEnd');
		},

		_resize: function _resize() {
			var that = this;

			clearTimeout(this.resizeTimeout);

			this.resizeTimeout = setTimeout(function () {
				that.refresh();
			}, this.options.resizePolling);
		},

		resetPosition: function resetPosition(time) {
			var x = this.x,
			    y = this.y;

			time = time || 0;

			if (!this.hasHorizontalScroll || this.x > 0) {
				x = 0;
			} else if (this.x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (!this.hasVerticalScroll || this.y > 0) {
				y = 0;
			} else if (this.y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			if (x == this.x && y == this.y) {
				return false;
			}

			this.scrollTo(x, y, time, this.options.bounceEasing);

			return true;
		},

		disable: function disable() {
			this.enabled = false;
		},

		enable: function enable() {
			this.enabled = true;
		},

		refresh: function refresh() {
			utils.getRect(this.wrapper); // Force reflow

			this.wrapperWidth = this.wrapper.clientWidth;
			this.wrapperHeight = this.wrapper.clientHeight;

			var rect = utils.getRect(this.scroller);
			/* REPLACE START: refresh */

			this.scrollerWidth = rect.width;
			this.scrollerHeight = rect.height;

			this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
			this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

			/* REPLACE END: refresh */

			this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
			this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

			if (!this.hasHorizontalScroll) {
				this.maxScrollX = 0;
				this.scrollerWidth = this.wrapperWidth;
			}

			if (!this.hasVerticalScroll) {
				this.maxScrollY = 0;
				this.scrollerHeight = this.wrapperHeight;
			}

			this.endTime = 0;
			this.directionX = 0;
			this.directionY = 0;

			if (utils.hasPointer && !this.options.disablePointer) {
				// The wrapper should have `touchAction` property for using pointerEvent.
				this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, true);

				// case. not support 'pinch-zoom'
				// https://github.com/cubiq/iscroll/issues/1118#issuecomment-270057583
				if (!this.wrapper.style[utils.style.touchAction]) {
					this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, false);
				}
			}
			this.wrapperOffset = utils.offset(this.wrapper);

			this._execEvent('refresh');

			this.resetPosition();

			// INSERT POINT: _refresh
		},

		on: function on(type, fn) {
			if (!this._events[type]) {
				this._events[type] = [];
			}

			this._events[type].push(fn);
		},

		off: function off(type, fn) {
			if (!this._events[type]) {
				return;
			}

			var index = this._events[type].indexOf(fn);

			if (index > -1) {
				this._events[type].splice(index, 1);
			}
		},

		_execEvent: function _execEvent(type) {
			if (!this._events[type]) {
				return;
			}

			var i = 0,
			    l = this._events[type].length;

			if (!l) {
				return;
			}

			for (; i < l; i++) {
				this._events[type][i].apply(this, [].slice.call(arguments, 1));
			}
		},

		scrollBy: function scrollBy(x, y, time, easing) {
			x = this.x + x;
			y = this.y + y;
			time = time || 0;

			this.scrollTo(x, y, time, easing);
		},

		scrollTo: function scrollTo(x, y, time, easing) {
			easing = easing || utils.ease.circular;

			this.isInTransition = this.options.useTransition && time > 0;
			var transitionType = this.options.useTransition && easing.style;
			if (!time || transitionType) {
				if (transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
				this._translate(x, y);
			} else {
				this._animate(x, y, time, easing.fn);
			}
		},

		scrollToElement: function scrollToElement(el, time, offsetX, offsetY, easing) {
			el = el.nodeType ? el : this.scroller.querySelector(el);

			if (!el) {
				return;
			}

			var pos = utils.offset(el);

			pos.left -= this.wrapperOffset.left;
			pos.top -= this.wrapperOffset.top;

			// if offsetX/Y are true we center the element to the screen
			var elRect = utils.getRect(el);
			var wrapperRect = utils.getRect(this.wrapper);
			if (offsetX === true) {
				offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
			}
			if (offsetY === true) {
				offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
			}

			pos.left -= offsetX || 0;
			pos.top -= offsetY || 0;

			pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
			pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

			time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

			this.scrollTo(pos.left, pos.top, time, easing);
		},

		_transitionTime: function _transitionTime(time) {
			if (!this.options.useTransition) {
				return;
			}
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			if (!durationProp) {
				return;
			}

			this.scrollerStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.scrollerStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function () {
					if (self.scrollerStyle[durationProp] === '0.0001ms') {
						self.scrollerStyle[durationProp] = '0s';
					}
				});
			}

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTime(time);
				}
			}

			// INSERT POINT: _transitionTime
		},

		_transitionTimingFunction: function _transitionTimingFunction(easing) {
			this.scrollerStyle[utils.style.transitionTimingFunction] = easing;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].transitionTimingFunction(easing);
				}
			}

			// INSERT POINT: _transitionTimingFunction
		},

		_translate: function _translate(x, y) {
			if (this.options.useTransform) {

				/* REPLACE START: _translate */

				this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

				/* REPLACE END: _translate */
			} else {
				x = Math.round(x);
				y = Math.round(y);
				this.scrollerStyle.left = x + 'px';
				this.scrollerStyle.top = y + 'px';
			}

			this.x = x;
			this.y = y;

			if (this.indicators) {
				for (var i = this.indicators.length; i--;) {
					this.indicators[i].updatePosition();
				}
			}

			// INSERT POINT: _translate
		},

		_initEvents: function _initEvents(remove) {
			var eventType = remove ? utils.removeEvent : utils.addEvent,
			    target = this.options.bindToWrapper ? this.wrapper : window;

			eventType(window, 'orientationchange', this);
			eventType(window, 'resize', this);

			if (this.options.click) {
				eventType(this.wrapper, 'click', this, true);
			}

			if (!this.options.disableMouse) {
				eventType(this.wrapper, 'mousedown', this);
				eventType(target, 'mousemove', this);
				eventType(target, 'mousecancel', this);
				eventType(target, 'mouseup', this);
			}

			if (utils.hasPointer && !this.options.disablePointer) {
				eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
				eventType(target, utils.prefixPointerEvent('pointermove'), this);
				eventType(target, utils.prefixPointerEvent('pointercancel'), this);
				eventType(target, utils.prefixPointerEvent('pointerup'), this);
			}

			if (utils.hasTouch && !this.options.disableTouch) {
				eventType(this.wrapper, 'touchstart', this);
				eventType(target, 'touchmove', this);
				eventType(target, 'touchcancel', this);
				eventType(target, 'touchend', this);
			}

			eventType(this.scroller, 'transitionend', this);
			eventType(this.scroller, 'webkitTransitionEnd', this);
			eventType(this.scroller, 'oTransitionEnd', this);
			eventType(this.scroller, 'MSTransitionEnd', this);
		},

		getComputedPosition: function getComputedPosition() {
			var matrix = window.getComputedStyle(this.scroller, null),
			    x,
			    y;

			if (this.options.useTransform) {
				matrix = matrix[utils.style.transform].split(')')[0].split(', ');
				x = +(matrix[12] || matrix[4]);
				y = +(matrix[13] || matrix[5]);
			} else {
				x = +matrix.left.replace(/[^-\d.]/g, '');
				y = +matrix.top.replace(/[^-\d.]/g, '');
			}

			return { x: x, y: y };
		},
		_initIndicators: function _initIndicators() {
			var interactive = this.options.interactiveScrollbars,
			    customStyle = typeof this.options.scrollbars != 'string',
			    indicators = [],
			    indicator;

			var that = this;

			this.indicators = [];

			if (this.options.scrollbars) {
				// Vertical scrollbar
				if (this.options.scrollY) {
					indicator = {
						el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenX: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}

				// Horizontal scrollbar
				if (this.options.scrollX) {
					indicator = {
						el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
						interactive: interactive,
						defaultScrollbars: true,
						customStyle: customStyle,
						resize: this.options.resizeScrollbars,
						shrink: this.options.shrinkScrollbars,
						fade: this.options.fadeScrollbars,
						listenY: false
					};

					this.wrapper.appendChild(indicator.el);
					indicators.push(indicator);
				}
			}

			if (this.options.indicators) {
				// TODO: check concat compatibility
				indicators = indicators.concat(this.options.indicators);
			}

			for (var i = indicators.length; i--;) {
				this.indicators.push(new Indicator(this, indicators[i]));
			}

			// TODO: check if we can use array.map (wide compatibility and performance issues)
			function _indicatorsMap(fn) {
				if (that.indicators) {
					for (var i = that.indicators.length; i--;) {
						fn.call(that.indicators[i]);
					}
				}
			}

			if (this.options.fadeScrollbars) {
				this.on('scrollEnd', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollCancel', function () {
					_indicatorsMap(function () {
						this.fade();
					});
				});

				this.on('scrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1);
					});
				});

				this.on('beforeScrollStart', function () {
					_indicatorsMap(function () {
						this.fade(1, true);
					});
				});
			}

			this.on('refresh', function () {
				_indicatorsMap(function () {
					this.refresh();
				});
			});

			this.on('destroy', function () {
				_indicatorsMap(function () {
					this.destroy();
				});

				delete this.indicators;
			});
		},

		_initWheel: function _initWheel() {
			utils.addEvent(this.wrapper, 'wheel', this);
			utils.addEvent(this.wrapper, 'mousewheel', this);
			utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

			this.on('destroy', function () {
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = null;
				utils.removeEvent(this.wrapper, 'wheel', this);
				utils.removeEvent(this.wrapper, 'mousewheel', this);
				utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
			});
		},

		_wheel: function _wheel(e) {
			if (!this.enabled) {
				return;
			}

			e.preventDefault();

			var wheelDeltaX,
			    wheelDeltaY,
			    newX,
			    newY,
			    that = this;

			if (this.wheelTimeout === undefined) {
				that._execEvent('scrollStart');
			}

			// Execute the scrollEnd event after 400ms the wheel stopped scrolling
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(function () {
				if (!that.options.snap) {
					that._execEvent('scrollEnd');
				}
				that.wheelTimeout = undefined;
			}, 400);

			if ('deltaX' in e) {
				if (e.deltaMode === 1) {
					wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
					wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
				} else {
					wheelDeltaX = -e.deltaX;
					wheelDeltaY = -e.deltaY;
				}
			} else if ('wheelDeltaX' in e) {
				wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
				wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
			} else if ('wheelDelta' in e) {
				wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
			} else if ('detail' in e) {
				wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
			} else {
				return;
			}

			wheelDeltaX *= this.options.invertWheelDirection;
			wheelDeltaY *= this.options.invertWheelDirection;

			if (!this.hasVerticalScroll) {
				wheelDeltaX = wheelDeltaY;
				wheelDeltaY = 0;
			}

			if (this.options.snap) {
				newX = this.currentPage.pageX;
				newY = this.currentPage.pageY;

				if (wheelDeltaX > 0) {
					newX--;
				} else if (wheelDeltaX < 0) {
					newX++;
				}

				if (wheelDeltaY > 0) {
					newY--;
				} else if (wheelDeltaY < 0) {
					newY++;
				}

				this.goToPage(newX, newY);

				return;
			}

			newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
			newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

			this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
			this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

			if (newX > 0) {
				newX = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
			}

			if (newY > 0) {
				newY = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
			}

			this.scrollTo(newX, newY, 0);

			if (this.options.probeType > 1) {
				this._execEvent('scroll');
			}

			// INSERT POINT: _wheel
		},

		_initSnap: function _initSnap() {
			this.currentPage = {};

			if (typeof this.options.snap == 'string') {
				this.options.snap = this.scroller.querySelectorAll(this.options.snap);
			}

			this.on('refresh', function () {
				var i = 0,
				    l,
				    m = 0,
				    n,
				    cx,
				    cy,
				    x = 0,
				    y,
				    stepX = this.options.snapStepX || this.wrapperWidth,
				    stepY = this.options.snapStepY || this.wrapperHeight,
				    el,
				    rect;

				this.pages = [];

				if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
					return;
				}

				if (this.options.snap === true) {
					cx = Math.round(stepX / 2);
					cy = Math.round(stepY / 2);

					while (x > -this.scrollerWidth) {
						this.pages[i] = [];
						l = 0;
						y = 0;

						while (y > -this.scrollerHeight) {
							this.pages[i][l] = {
								x: Math.max(x, this.maxScrollX),
								y: Math.max(y, this.maxScrollY),
								width: stepX,
								height: stepY,
								cx: x - cx,
								cy: y - cy
							};

							y -= stepY;
							l++;
						}

						x -= stepX;
						i++;
					}
				} else {
					el = this.options.snap;
					l = el.length;
					n = -1;

					for (; i < l; i++) {
						rect = utils.getRect(el[i]);
						if (i === 0 || rect.left <= utils.getRect(el[i - 1]).left) {
							m = 0;
							n++;
						}

						if (!this.pages[m]) {
							this.pages[m] = [];
						}

						x = Math.max(-rect.left, this.maxScrollX);
						y = Math.max(-rect.top, this.maxScrollY);
						cx = x - Math.round(rect.width / 2);
						cy = y - Math.round(rect.height / 2);

						this.pages[m][n] = {
							x: x,
							y: y,
							width: rect.width,
							height: rect.height,
							cx: cx,
							cy: cy
						};

						if (x > this.maxScrollX) {
							m++;
						}
					}
				}

				this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

				// Update snap threshold if needed
				if (this.options.snapThreshold % 1 === 0) {
					this.snapThresholdX = this.options.snapThreshold;
					this.snapThresholdY = this.options.snapThreshold;
				} else {
					this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
					this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
				}
			});

			this.on('flick', function () {
				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.x - this.startX), 1000), Math.min(Math.abs(this.y - this.startY), 1000)), 300);

				this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, time);
			});
		},

		_nearestSnap: function _nearestSnap(x, y) {
			if (!this.pages.length) {
				return { x: 0, y: 0, pageX: 0, pageY: 0 };
			}

			var i = 0,
			    l = this.pages.length,
			    m = 0;

			// Check if we exceeded the snap threshold
			if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
				return this.currentPage;
			}

			if (x > 0) {
				x = 0;
			} else if (x < this.maxScrollX) {
				x = this.maxScrollX;
			}

			if (y > 0) {
				y = 0;
			} else if (y < this.maxScrollY) {
				y = this.maxScrollY;
			}

			for (; i < l; i++) {
				if (x >= this.pages[i][0].cx) {
					x = this.pages[i][0].x;
					break;
				}
			}

			l = this.pages[i].length;

			for (; m < l; m++) {
				if (y >= this.pages[0][m].cy) {
					y = this.pages[0][m].y;
					break;
				}
			}

			if (i == this.currentPage.pageX) {
				i += this.directionX;

				if (i < 0) {
					i = 0;
				} else if (i >= this.pages.length) {
					i = this.pages.length - 1;
				}

				x = this.pages[i][0].x;
			}

			if (m == this.currentPage.pageY) {
				m += this.directionY;

				if (m < 0) {
					m = 0;
				} else if (m >= this.pages[0].length) {
					m = this.pages[0].length - 1;
				}

				y = this.pages[0][m].y;
			}

			return {
				x: x,
				y: y,
				pageX: i,
				pageY: m
			};
		},

		goToPage: function goToPage(x, y, time, easing) {
			easing = easing || this.options.bounceEasing;

			if (x >= this.pages.length) {
				x = this.pages.length - 1;
			} else if (x < 0) {
				x = 0;
			}

			if (y >= this.pages[x].length) {
				y = this.pages[x].length - 1;
			} else if (y < 0) {
				y = 0;
			}

			var posX = this.pages[x][y].x,
			    posY = this.pages[x][y].y;

			time = time === undefined ? this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

			this.currentPage = {
				x: posX,
				y: posY,
				pageX: x,
				pageY: y
			};

			this.scrollTo(posX, posY, time, easing);
		},

		next: function next(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x++;

			if (x >= this.pages.length && this.hasVerticalScroll) {
				x = 0;
				y++;
			}

			this.goToPage(x, y, time, easing);
		},

		prev: function prev(time, easing) {
			var x = this.currentPage.pageX,
			    y = this.currentPage.pageY;

			x--;

			if (x < 0 && this.hasVerticalScroll) {
				x = 0;
				y--;
			}

			this.goToPage(x, y, time, easing);
		},

		_initKeys: function _initKeys(e) {
			// default key bindings
			var keys = {
				pageUp: 33,
				pageDown: 34,
				end: 35,
				home: 36,
				left: 37,
				up: 38,
				right: 39,
				down: 40
			};
			var i;

			// if you give me characters I give you keycode
			if (_typeof(this.options.keyBindings) == 'object') {
				for (i in this.options.keyBindings) {
					if (typeof this.options.keyBindings[i] == 'string') {
						this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
					}
				}
			} else {
				this.options.keyBindings = {};
			}

			for (i in keys) {
				this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
			}

			utils.addEvent(window, 'keydown', this);

			this.on('destroy', function () {
				utils.removeEvent(window, 'keydown', this);
			});
		},

		_key: function _key(e) {
			if (!this.enabled) {
				return;
			}

			var snap = this.options.snap,
			    // we are using this alot, better to cache it
			newX = snap ? this.currentPage.pageX : this.x,
			    newY = snap ? this.currentPage.pageY : this.y,
			    now = utils.getTime(),
			    prevTime = this.keyTime || 0,
			    acceleration = 0.250,
			    pos;

			if (this.options.useTransition && this.isInTransition) {
				pos = this.getComputedPosition();

				this._translate(Math.round(pos.x), Math.round(pos.y));
				this.isInTransition = false;
			}

			this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

			switch (e.keyCode) {
				case this.options.keyBindings.pageUp:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX += snap ? 1 : this.wrapperWidth;
					} else {
						newY += snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.pageDown:
					if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
						newX -= snap ? 1 : this.wrapperWidth;
					} else {
						newY -= snap ? 1 : this.wrapperHeight;
					}
					break;
				case this.options.keyBindings.end:
					newX = snap ? this.pages.length - 1 : this.maxScrollX;
					newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
					break;
				case this.options.keyBindings.home:
					newX = 0;
					newY = 0;
					break;
				case this.options.keyBindings.left:
					newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.up:
					newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.right:
					newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
					break;
				case this.options.keyBindings.down:
					newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
					break;
				default:
					return;
			}

			if (snap) {
				this.goToPage(newX, newY);
				return;
			}

			if (newX > 0) {
				newX = 0;
				this.keyAcceleration = 0;
			} else if (newX < this.maxScrollX) {
				newX = this.maxScrollX;
				this.keyAcceleration = 0;
			}

			if (newY > 0) {
				newY = 0;
				this.keyAcceleration = 0;
			} else if (newY < this.maxScrollY) {
				newY = this.maxScrollY;
				this.keyAcceleration = 0;
			}

			this.scrollTo(newX, newY, 0);

			this.keyTime = now;
		},

		_animate: function _animate(destX, destY, duration, easingFn) {
			var that = this,
			    startX = this.x,
			    startY = this.y,
			    startTime = utils.getTime(),
			    destTime = startTime + duration;

			function step() {
				var now = utils.getTime(),
				    newX,
				    newY,
				    easing;

				if (now >= destTime) {
					that.isAnimating = false;
					that._translate(destX, destY);

					if (!that.resetPosition(that.options.bounceTime)) {
						that._execEvent('scrollEnd');
					}

					return;
				}

				now = (now - startTime) / duration;
				easing = easingFn(now);
				newX = (destX - startX) * easing + startX;
				newY = (destY - startY) * easing + startY;
				that._translate(newX, newY);

				if (that.isAnimating) {
					rAF(step);
				}

				if (that.options.probeType == 3) {
					that._execEvent('scroll');
				}
			}

			this.isAnimating = true;
			step();
		},

		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
				case 'orientationchange':
				case 'resize':
					this._resize();
					break;
				case 'transitionend':
				case 'webkitTransitionEnd':
				case 'oTransitionEnd':
				case 'MSTransitionEnd':
					this._transitionEnd(e);
					break;
				case 'wheel':
				case 'DOMMouseScroll':
				case 'mousewheel':
					this._wheel(e);
					break;
				case 'keydown':
					this._key(e);
					break;
				case 'click':
					if (this.enabled && !e._constructed) {
						e.preventDefault();
						e.stopPropagation();
					}
					break;
			}
		}
	};
	function createDefaultScrollbar(direction, interactive, type) {
		var scrollbar = document.createElement('div'),
		    indicator = document.createElement('div');

		if (type === true) {
			scrollbar.style.cssText = 'position:absolute;z-index:9999';
			indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
		}

		indicator.className = 'iScrollIndicator';

		if (direction == 'h') {
			if (type === true) {
				scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
				indicator.style.height = '100%';
			}
			scrollbar.className = 'iScrollHorizontalScrollbar';
		} else {
			if (type === true) {
				scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
				indicator.style.width = '100%';
			}
			scrollbar.className = 'iScrollVerticalScrollbar';
		}

		scrollbar.style.cssText += ';overflow:hidden';

		if (!interactive) {
			scrollbar.style.pointerEvents = 'none';
		}

		scrollbar.appendChild(indicator);

		return scrollbar;
	}

	function Indicator(scroller, options) {
		this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
		this.wrapperStyle = this.wrapper.style;
		this.indicator = this.wrapper.children[0];
		this.indicatorStyle = this.indicator.style;
		this.scroller = scroller;

		this.options = {
			listenX: true,
			listenY: true,
			interactive: false,
			resize: true,
			defaultScrollbars: false,
			shrink: false,
			fade: false,
			speedRatioX: 0,
			speedRatioY: 0
		};

		for (var i in options) {
			this.options[i] = options[i];
		}

		this.sizeRatioX = 1;
		this.sizeRatioY = 1;
		this.maxPosX = 0;
		this.maxPosY = 0;

		if (this.options.interactive) {
			if (!this.options.disableTouch) {
				utils.addEvent(this.indicator, 'touchstart', this);
				utils.addEvent(window, 'touchend', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(this.indicator, 'mousedown', this);
				utils.addEvent(window, 'mouseup', this);
			}
		}

		if (this.options.fade) {
			this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
			var durationProp = utils.style.transitionDuration;
			if (!durationProp) {
				return;
			}
			this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
			// remove 0.0001ms
			var self = this;
			if (utils.isBadAndroid) {
				rAF(function () {
					if (self.wrapperStyle[durationProp] === '0.0001ms') {
						self.wrapperStyle[durationProp] = '0s';
					}
				});
			}
			this.wrapperStyle.opacity = '0';
		}
	}

	Indicator.prototype = {
		handleEvent: function handleEvent(e) {
			switch (e.type) {
				case 'touchstart':
				case 'pointerdown':
				case 'MSPointerDown':
				case 'mousedown':
					this._start(e);
					break;
				case 'touchmove':
				case 'pointermove':
				case 'MSPointerMove':
				case 'mousemove':
					this._move(e);
					break;
				case 'touchend':
				case 'pointerup':
				case 'MSPointerUp':
				case 'mouseup':
				case 'touchcancel':
				case 'pointercancel':
				case 'MSPointerCancel':
				case 'mousecancel':
					this._end(e);
					break;
			}
		},

		destroy: function destroy() {
			if (this.options.fadeScrollbars) {
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
			}
			if (this.options.interactive) {
				utils.removeEvent(this.indicator, 'touchstart', this);
				utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
				utils.removeEvent(this.indicator, 'mousedown', this);

				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);

				utils.removeEvent(window, 'touchend', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
				utils.removeEvent(window, 'mouseup', this);
			}

			if (this.options.defaultScrollbars && this.wrapper.parentNode) {
				this.wrapper.parentNode.removeChild(this.wrapper);
			}
		},

		_start: function _start(e) {
			var point = e.touches ? e.touches[0] : e;

			e.preventDefault();
			e.stopPropagation();

			this.transitionTime();

			this.initiated = true;
			this.moved = false;
			this.lastPointX = point.pageX;
			this.lastPointY = point.pageY;

			this.startTime = utils.getTime();

			if (!this.options.disableTouch) {
				utils.addEvent(window, 'touchmove', this);
			}
			if (!this.options.disablePointer) {
				utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
			}
			if (!this.options.disableMouse) {
				utils.addEvent(window, 'mousemove', this);
			}

			this.scroller._execEvent('beforeScrollStart');
		},

		_move: function _move(e) {
			var point = e.touches ? e.touches[0] : e,
			    deltaX,
			    deltaY,
			    newX,
			    newY,
			    timestamp = utils.getTime();

			if (!this.moved) {
				this.scroller._execEvent('scrollStart');
			}

			this.moved = true;

			deltaX = point.pageX - this.lastPointX;
			this.lastPointX = point.pageX;

			deltaY = point.pageY - this.lastPointY;
			this.lastPointY = point.pageY;

			newX = this.x + deltaX;
			newY = this.y + deltaY;

			this._pos(newX, newY);

			if (this.scroller.options.probeType == 1 && timestamp - this.startTime > 300) {
				this.startTime = timestamp;
				this.scroller._execEvent('scroll');
			} else if (this.scroller.options.probeType > 1) {
				this.scroller._execEvent('scroll');
			}

			// INSERT POINT: indicator._move

			e.preventDefault();
			e.stopPropagation();
		},

		_end: function _end(e) {
			if (!this.initiated) {
				return;
			}

			this.initiated = false;

			e.preventDefault();
			e.stopPropagation();

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			if (this.scroller.options.snap) {
				var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

				var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

				if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
					this.scroller.directionX = 0;
					this.scroller.directionY = 0;
					this.scroller.currentPage = snap;
					this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
				}
			}

			if (this.moved) {
				this.scroller._execEvent('scrollEnd');
			}
		},

		transitionTime: function transitionTime(time) {
			time = time || 0;
			var durationProp = utils.style.transitionDuration;
			if (!durationProp) {
				return;
			}

			this.indicatorStyle[durationProp] = time + 'ms';

			if (!time && utils.isBadAndroid) {
				this.indicatorStyle[durationProp] = '0.0001ms';
				// remove 0.0001ms
				var self = this;
				rAF(function () {
					if (self.indicatorStyle[durationProp] === '0.0001ms') {
						self.indicatorStyle[durationProp] = '0s';
					}
				});
			}
		},

		transitionTimingFunction: function transitionTimingFunction(easing) {
			this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
		},

		refresh: function refresh() {
			this.transitionTime();

			if (this.options.listenX && !this.options.listenY) {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
			} else if (this.options.listenY && !this.options.listenX) {
				this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
			} else {
				this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
			}

			if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
				utils.addClass(this.wrapper, 'iScrollBothScrollbars');
				utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '8px';
					} else {
						this.wrapper.style.bottom = '8px';
					}
				}
			} else {
				utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
				utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

				if (this.options.defaultScrollbars && this.options.customStyle) {
					if (this.options.listenX) {
						this.wrapper.style.right = '2px';
					} else {
						this.wrapper.style.bottom = '2px';
					}
				}
			}

			utils.getRect(this.wrapper); // force refresh

			if (this.options.listenX) {
				this.wrapperWidth = this.wrapper.clientWidth;
				if (this.options.resize) {
					this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
					this.indicatorStyle.width = this.indicatorWidth + 'px';
				} else {
					this.indicatorWidth = this.indicator.clientWidth;
				}

				this.maxPosX = this.wrapperWidth - this.indicatorWidth;

				if (this.options.shrink == 'clip') {
					this.minBoundaryX = -this.indicatorWidth + 8;
					this.maxBoundaryX = this.wrapperWidth - 8;
				} else {
					this.minBoundaryX = 0;
					this.maxBoundaryX = this.maxPosX;
				}

				this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX;
			}

			if (this.options.listenY) {
				this.wrapperHeight = this.wrapper.clientHeight;
				if (this.options.resize) {
					this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
					this.indicatorStyle.height = this.indicatorHeight + 'px';
				} else {
					this.indicatorHeight = this.indicator.clientHeight;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;

				if (this.options.shrink == 'clip') {
					this.minBoundaryY = -this.indicatorHeight + 8;
					this.maxBoundaryY = this.wrapperHeight - 8;
				} else {
					this.minBoundaryY = 0;
					this.maxBoundaryY = this.maxPosY;
				}

				this.maxPosY = this.wrapperHeight - this.indicatorHeight;
				this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY;
			}

			this.updatePosition();
		},

		updatePosition: function updatePosition() {
			var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			    y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

			if (!this.options.ignoreBoundaries) {
				if (x < this.minBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth + x, 8);
						this.indicatorStyle.width = this.width + 'px';
					}
					x = this.minBoundaryX;
				} else if (x > this.maxBoundaryX) {
					if (this.options.shrink == 'scale') {
						this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
						this.indicatorStyle.width = this.width + 'px';
						x = this.maxPosX + this.indicatorWidth - this.width;
					} else {
						x = this.maxBoundaryX;
					}
				} else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
					this.width = this.indicatorWidth;
					this.indicatorStyle.width = this.width + 'px';
				}

				if (y < this.minBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight + y * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
					}
					y = this.minBoundaryY;
				} else if (y > this.maxBoundaryY) {
					if (this.options.shrink == 'scale') {
						this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
						this.indicatorStyle.height = this.height + 'px';
						y = this.maxPosY + this.indicatorHeight - this.height;
					} else {
						y = this.maxBoundaryY;
					}
				} else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
					this.height = this.indicatorHeight;
					this.indicatorStyle.height = this.height + 'px';
				}
			}

			this.x = x;
			this.y = y;

			if (this.scroller.options.useTransform) {
				this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
			} else {
				this.indicatorStyle.left = x + 'px';
				this.indicatorStyle.top = y + 'px';
			}
		},

		_pos: function _pos(x, y) {
			if (x < 0) {
				x = 0;
			} else if (x > this.maxPosX) {
				x = this.maxPosX;
			}

			if (y < 0) {
				y = 0;
			} else if (y > this.maxPosY) {
				y = this.maxPosY;
			}

			x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
			y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

			this.scroller.scrollTo(x, y);
		},

		fade: function fade(val, hold) {
			if (hold && !this.visible) {
				return;
			}

			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;

			var time = val ? 250 : 500,
			    delay = val ? 0 : 300;

			val = val ? '1' : '0';

			this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

			this.fadeTimeout = setTimeout(function (val) {
				this.wrapperStyle.opacity = val;
				this.visible = +val;
			}.bind(this, val), delay);
		}
	};

	IScroll.utils = utils;

	if (typeof module != 'undefined' && module.exports) {
		module.exports = IScroll;
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return IScroll;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.IScroll = IScroll;
	}
})(window, document, Math);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*globals window, global, require*/

/**
 * CryptoJS core components.
 */
var CryptoJS = CryptoJS || function (Math, undefined) {

    var crypto;

    // Native crypto from window (Browser)
    if (typeof window !== 'undefined' && window.crypto) {
        crypto = window.crypto;
    }

    // Native (experimental IE 11) crypto from window (Browser)
    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
        crypto = window.msCrypto;
    }

    // Native crypto from global (NodeJS)
    if (!crypto && typeof global !== 'undefined' && global.crypto) {
        crypto = global.crypto;
    }

    // Native crypto import via require (NodeJS)
    if (!crypto && "function" === 'function') {
        try {
            crypto = __webpack_require__(220);
        } catch (err) {}
    }

    /*
     * Cryptographically secure pseudorandom number generator
     *
     * As Math.random() is cryptographically not safe to use
     */
    var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
        if (crypto) {
            // Use getRandomValues method (Browser)
            if (typeof crypto.getRandomValues === 'function') {
                try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
            }

            // Use randomBytes method (NodeJS)
            if (typeof crypto.randomBytes === 'function') {
                try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
        }

        throw new Error('Native crypto module could not be used to get secure random number.');
    };

    /*
     * Local polyfill of Object.create
      */
    var create = Object.create || function () {
        function F() {}

        return function (obj) {
            var subtype;

            F.prototype = obj;

            subtype = new F();

            F.prototype = null;

            return subtype;
        };
    }();

    /**
     * CryptoJS namespace.
     */
    var C = {};

    /**
     * Library namespace.
     */
    var C_lib = C.lib = {};

    /**
     * Base object for prototypal inheritance.
     */
    var Base = C_lib.Base = function () {

        return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function extend(overrides) {
                // Spawn
                var subtype = create(this);

                // Augment
                if (overrides) {
                    subtype.mixIn(overrides);
                }

                // Create default initializer
                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
                    subtype.init = function () {
                        subtype.$super.init.apply(this, arguments);
                    };
                }

                // Initializer's prototype is the subtype object
                subtype.init.prototype = subtype;

                // Reference supertype
                subtype.$super = this;

                return subtype;
            },

            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function create() {
                var instance = this.extend();
                instance.init.apply(instance, arguments);

                return instance;
            },

            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function init() {},

            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function mixIn(properties) {
                for (var propertyName in properties) {
                    if (properties.hasOwnProperty(propertyName)) {
                        this[propertyName] = properties[propertyName];
                    }
                }

                // IE won't copy toString using the loop above
                if (properties.hasOwnProperty('toString')) {
                    this.toString = properties.toString;
                }
            },

            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function clone() {
                return this.init.prototype.extend(this);
            }
        };
    }();

    /**
     * An array of 32-bit words.
     *
     * @property {Array} words The array of 32-bit words.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */
    var WordArray = C_lib.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function init(words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
                this.sigBytes = sigBytes;
            } else {
                this.sigBytes = words.length * 4;
            }
        },

        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function toString(encoder) {
            return (encoder || Hex).stringify(this);
        },

        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function concat(wordArray) {
            // Shortcuts
            var thisWords = this.words;
            var thatWords = wordArray.words;
            var thisSigBytes = this.sigBytes;
            var thatSigBytes = wordArray.sigBytes;

            // Clamp excess bits
            this.clamp();

            // Concat
            if (thisSigBytes % 4) {
                // Copy one byte at a time
                for (var i = 0; i < thatSigBytes; i++) {
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
            } else {
                // Copy one word at a time
                for (var i = 0; i < thatSigBytes; i += 4) {
                    thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                }
            }
            this.sigBytes += thatSigBytes;

            // Chainable
            return this;
        },

        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function clamp() {
            // Shortcuts
            var words = this.words;
            var sigBytes = this.sigBytes;

            // Clamp
            words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
            words.length = Math.ceil(sigBytes / 4);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function clone() {
            var clone = Base.clone.call(this);
            clone.words = this.words.slice(0);

            return clone;
        },

        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function random(nBytes) {
            var words = [];

            for (var i = 0; i < nBytes; i += 4) {
                words.push(cryptoSecureRandomInt());
            }

            return new WordArray.init(words, nBytes);
        }
    });

    /**
     * Encoder namespace.
     */
    var C_enc = C.enc = {};

    /**
     * Hex encoding strategy.
     */
    var Hex = C_enc.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var hexChars = [];
            for (var i = 0; i < sigBytes; i++) {
                var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                hexChars.push((bite >>> 4).toString(16));
                hexChars.push((bite & 0x0f).toString(16));
            }

            return hexChars.join('');
        },

        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function parse(hexStr) {
            // Shortcut
            var hexStrLength = hexStr.length;

            // Convert
            var words = [];
            for (var i = 0; i < hexStrLength; i += 2) {
                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
            }

            return new WordArray.init(words, hexStrLength / 2);
        }
    };

    /**
     * Latin1 encoding strategy.
     */
    var Latin1 = C_enc.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var latin1Chars = [];
            for (var i = 0; i < sigBytes; i++) {
                var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                latin1Chars.push(String.fromCharCode(bite));
            }

            return latin1Chars.join('');
        },

        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function parse(latin1Str) {
            // Shortcut
            var latin1StrLength = latin1Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < latin1StrLength; i++) {
                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
            }

            return new WordArray.init(words, latin1StrLength);
        }
    };

    /**
     * UTF-8 encoding strategy.
     */
    var Utf8 = C_enc.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            try {
                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
            } catch (e) {
                throw new Error('Malformed UTF-8 data');
            }
        },

        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function parse(utf8Str) {
            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
    };

    /**
     * Abstract buffered block algorithm template.
     *
     * The property blockSize must be implemented in a concrete subtype.
     *
     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
     */
    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function reset() {
            // Initial values
            this._data = new WordArray.init();
            this._nDataBytes = 0;
        },

        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function _append(data) {
            // Convert string to WordArray, else assume WordArray already
            if (typeof data == 'string') {
                data = Utf8.parse(data);
            }

            // Append
            this._data.concat(data);
            this._nDataBytes += data.sigBytes;
        },

        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function _process(doFlush) {
            var processedWords;

            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var dataSigBytes = data.sigBytes;
            var blockSize = this.blockSize;
            var blockSizeBytes = blockSize * 4;

            // Count blocks ready
            var nBlocksReady = dataSigBytes / blockSizeBytes;
            if (doFlush) {
                // Round up to include partial blocks
                nBlocksReady = Math.ceil(nBlocksReady);
            } else {
                // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
            }

            // Count words ready
            var nWordsReady = nBlocksReady * blockSize;

            // Count bytes ready
            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

            // Process blocks
            if (nWordsReady) {
                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
                    // Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                }

                // Remove processed words
                processedWords = dataWords.splice(0, nWordsReady);
                data.sigBytes -= nBytesReady;
            }

            // Return processed words
            return new WordArray.init(processedWords, nBytesReady);
        },

        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function clone() {
            var clone = Base.clone.call(this);
            clone._data = this._data.clone();

            return clone;
        },

        _minBufferSize: 0
    });

    /**
     * Abstract hasher template.
     *
     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
     */
    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         */
        cfg: Base.extend(),

        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function init(cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Set initial values
            this.reset();
        },

        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function reset() {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-hasher logic
            this._doReset();
        },

        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function update(messageUpdate) {
            // Append
            this._append(messageUpdate);

            // Update the hash
            this._process();

            // Chainable
            return this;
        },

        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function finalize(messageUpdate) {
            // Final message update
            if (messageUpdate) {
                this._append(messageUpdate);
            }

            // Perform concrete-hasher logic
            var hash = this._doFinalize();

            return hash;
        },

        blockSize: 512 / 32,

        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function _createHelper(hasher) {
            return function (message, cfg) {
                return new hasher.init(cfg).finalize(message);
            };
        },

        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function _createHmacHelper(hasher) {
            return function (message, key) {
                return new C_algo.HMAC.init(hasher, key).finalize(message);
            };
        }
    });

    /**
     * Algorithm namespace.
     */
    var C_algo = C.algo = {};

    return C;
}(Math);

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_enc = C.enc;

    /**
     * Base64 encoding strategy.
     */
    var Base64 = C_enc.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;
            var map = this._map;

            // Clamp excess bits
            wordArray.clamp();

            // Convert
            var base64Chars = [];
            for (var i = 0; i < sigBytes; i += 3) {
                var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;

                var triplet = byte1 << 16 | byte2 << 8 | byte3;

                for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                    base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
            }

            // Add padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
                while (base64Chars.length % 4) {
                    base64Chars.push(paddingChar);
                }
            }

            return base64Chars.join('');
        },

        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function parse(base64Str) {
            // Shortcuts
            var base64StrLength = base64Str.length;
            var map = this._map;
            var reverseMap = this._reverseMap;

            if (!reverseMap) {
                reverseMap = this._reverseMap = [];
                for (var j = 0; j < map.length; j++) {
                    reverseMap[map.charCodeAt(j)] = j;
                }
            }

            // Ignore padding
            var paddingChar = map.charAt(64);
            if (paddingChar) {
                var paddingIndex = base64Str.indexOf(paddingChar);
                if (paddingIndex !== -1) {
                    base64StrLength = paddingIndex;
                }
            }

            // Convert
            return parseLoop(base64Str, base64StrLength, reverseMap);
        },

        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    };

    function parseLoop(base64Str, base64StrLength, reverseMap) {
        var words = [];
        var nBytes = 0;
        for (var i = 0; i < base64StrLength; i++) {
            if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
        }
        return WordArray.create(words, nBytes);
    }
})();

(function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo;

    // Constants table
    var T = [];

    // Compute constants
    (function () {
        for (var i = 0; i < 64; i++) {
            T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
        }
    })();

    /**
     * MD5 hash algorithm.
     */
    var MD5 = C_algo.MD5 = Hasher.extend({
        _doReset: function _doReset() {
            this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Swap endian
            for (var i = 0; i < 16; i++) {
                // Shortcuts
                var offset_i = offset + i;
                var M_offset_i = M[offset_i];

                M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
            }

            // Shortcuts
            var H = this._hash.words;

            var M_offset_0 = M[offset + 0];
            var M_offset_1 = M[offset + 1];
            var M_offset_2 = M[offset + 2];
            var M_offset_3 = M[offset + 3];
            var M_offset_4 = M[offset + 4];
            var M_offset_5 = M[offset + 5];
            var M_offset_6 = M[offset + 6];
            var M_offset_7 = M[offset + 7];
            var M_offset_8 = M[offset + 8];
            var M_offset_9 = M[offset + 9];
            var M_offset_10 = M[offset + 10];
            var M_offset_11 = M[offset + 11];
            var M_offset_12 = M[offset + 12];
            var M_offset_13 = M[offset + 13];
            var M_offset_14 = M[offset + 14];
            var M_offset_15 = M[offset + 15];

            // Working varialbes
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];

            // Computation
            a = FF(a, b, c, d, M_offset_0, 7, T[0]);
            d = FF(d, a, b, c, M_offset_1, 12, T[1]);
            c = FF(c, d, a, b, M_offset_2, 17, T[2]);
            b = FF(b, c, d, a, M_offset_3, 22, T[3]);
            a = FF(a, b, c, d, M_offset_4, 7, T[4]);
            d = FF(d, a, b, c, M_offset_5, 12, T[5]);
            c = FF(c, d, a, b, M_offset_6, 17, T[6]);
            b = FF(b, c, d, a, M_offset_7, 22, T[7]);
            a = FF(a, b, c, d, M_offset_8, 7, T[8]);
            d = FF(d, a, b, c, M_offset_9, 12, T[9]);
            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
            a = FF(a, b, c, d, M_offset_12, 7, T[12]);
            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

            a = GG(a, b, c, d, M_offset_1, 5, T[16]);
            d = GG(d, a, b, c, M_offset_6, 9, T[17]);
            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
            b = GG(b, c, d, a, M_offset_0, 20, T[19]);
            a = GG(a, b, c, d, M_offset_5, 5, T[20]);
            d = GG(d, a, b, c, M_offset_10, 9, T[21]);
            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
            b = GG(b, c, d, a, M_offset_4, 20, T[23]);
            a = GG(a, b, c, d, M_offset_9, 5, T[24]);
            d = GG(d, a, b, c, M_offset_14, 9, T[25]);
            c = GG(c, d, a, b, M_offset_3, 14, T[26]);
            b = GG(b, c, d, a, M_offset_8, 20, T[27]);
            a = GG(a, b, c, d, M_offset_13, 5, T[28]);
            d = GG(d, a, b, c, M_offset_2, 9, T[29]);
            c = GG(c, d, a, b, M_offset_7, 14, T[30]);
            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

            a = HH(a, b, c, d, M_offset_5, 4, T[32]);
            d = HH(d, a, b, c, M_offset_8, 11, T[33]);
            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
            a = HH(a, b, c, d, M_offset_1, 4, T[36]);
            d = HH(d, a, b, c, M_offset_4, 11, T[37]);
            c = HH(c, d, a, b, M_offset_7, 16, T[38]);
            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
            a = HH(a, b, c, d, M_offset_13, 4, T[40]);
            d = HH(d, a, b, c, M_offset_0, 11, T[41]);
            c = HH(c, d, a, b, M_offset_3, 16, T[42]);
            b = HH(b, c, d, a, M_offset_6, 23, T[43]);
            a = HH(a, b, c, d, M_offset_9, 4, T[44]);
            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
            b = HH(b, c, d, a, M_offset_2, 23, T[47]);

            a = II(a, b, c, d, M_offset_0, 6, T[48]);
            d = II(d, a, b, c, M_offset_7, 10, T[49]);
            c = II(c, d, a, b, M_offset_14, 15, T[50]);
            b = II(b, c, d, a, M_offset_5, 21, T[51]);
            a = II(a, b, c, d, M_offset_12, 6, T[52]);
            d = II(d, a, b, c, M_offset_3, 10, T[53]);
            c = II(c, d, a, b, M_offset_10, 15, T[54]);
            b = II(b, c, d, a, M_offset_1, 21, T[55]);
            a = II(a, b, c, d, M_offset_8, 6, T[56]);
            d = II(d, a, b, c, M_offset_15, 10, T[57]);
            c = II(c, d, a, b, M_offset_6, 15, T[58]);
            b = II(b, c, d, a, M_offset_13, 21, T[59]);
            a = II(a, b, c, d, M_offset_4, 6, T[60]);
            d = II(d, a, b, c, M_offset_11, 10, T[61]);
            c = II(c, d, a, b, M_offset_2, 15, T[62]);
            b = II(b, c, d, a, M_offset_9, 21, T[63]);

            // Intermediate hash value
            H[0] = H[0] + a | 0;
            H[1] = H[1] + b | 0;
            H[2] = H[2] + c | 0;
            H[3] = H[3] + d | 0;
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;

            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
            var nBitsTotalL = nBitsTotal;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;

            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 4; i++) {
                // Shortcut
                var H_i = H[i];

                H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
            }

            // Return final computed hash
            return hash;
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        }
    });

    function FF(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + x + t;
        return (n << s | n >>> 32 - s) + b;
    }

    function GG(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + x + t;
        return (n << s | n >>> 32 - s) + b;
    }

    function HH(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + x + t;
        return (n << s | n >>> 32 - s) + b;
    }

    function II(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + x + t;
        return (n << s | n >>> 32 - s) + b;
    }

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.MD5('message');
     *     var hash = CryptoJS.MD5(wordArray);
     */
    C.MD5 = Hasher._createHelper(MD5);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacMD5(message, key);
     */
    C.HmacMD5 = Hasher._createHmacHelper(MD5);
})(Math);

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo;

    // Reusable object
    var W = [];

    /**
     * SHA-1 hash algorithm.
     */
    var SHA1 = C_algo.SHA1 = Hasher.extend({
        _doReset: function _doReset() {
            this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];

            // Computation
            for (var i = 0; i < 80; i++) {
                if (i < 16) {
                    W[i] = M[offset + i] | 0;
                } else {
                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                    W[i] = n << 1 | n >>> 31;
                }

                var t = (a << 5 | a >>> 27) + e + W[i];
                if (i < 20) {
                    t += (b & c | ~b & d) + 0x5a827999;
                } else if (i < 40) {
                    t += (b ^ c ^ d) + 0x6ed9eba1;
                } else if (i < 60) {
                    t += (b & c | b & d | c & d) - 0x70e44324;
                } else /* if (i < 80) */{
                        t += (b ^ c ^ d) - 0x359d3e2a;
                    }

                e = d;
                d = c;
                c = b << 30 | b >>> 2;
                b = a;
                a = t;
            }

            // Intermediate hash value
            H[0] = H[0] + a | 0;
            H[1] = H[1] + b | 0;
            H[2] = H[2] + c | 0;
            H[3] = H[3] + d | 0;
            H[4] = H[4] + e | 0;
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        }
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA1('message');
     *     var hash = CryptoJS.SHA1(wordArray);
     */
    C.SHA1 = Hasher._createHelper(SHA1);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA1(message, key);
     */
    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
})();

(function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo;

    // Initialization and round constants tables
    var H = [];
    var K = [];

    // Compute constants
    (function () {
        function isPrime(n) {
            var sqrtN = Math.sqrt(n);
            for (var factor = 2; factor <= sqrtN; factor++) {
                if (!(n % factor)) {
                    return false;
                }
            }

            return true;
        }

        function getFractionalBits(n) {
            return (n - (n | 0)) * 0x100000000 | 0;
        }

        var n = 2;
        var nPrime = 0;
        while (nPrime < 64) {
            if (isPrime(n)) {
                if (nPrime < 8) {
                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
                }
                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

                nPrime++;
            }

            n++;
        }
    })();

    // Reusable object
    var W = [];

    /**
     * SHA-256 hash algorithm.
     */
    var SHA256 = C_algo.SHA256 = Hasher.extend({
        _doReset: function _doReset() {
            this._hash = new WordArray.init(H.slice(0));
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcut
            var H = this._hash.words;

            // Working variables
            var a = H[0];
            var b = H[1];
            var c = H[2];
            var d = H[3];
            var e = H[4];
            var f = H[5];
            var g = H[6];
            var h = H[7];

            // Computation
            for (var i = 0; i < 64; i++) {
                if (i < 16) {
                    W[i] = M[offset + i] | 0;
                } else {
                    var gamma0x = W[i - 15];
                    var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;

                    var gamma1x = W[i - 2];
                    var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;

                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                }

                var ch = e & f ^ ~e & g;
                var maj = a & b ^ a & c ^ b & c;

                var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);

                var t1 = h + sigma1 + ch + K[i] + W[i];
                var t2 = sigma0 + maj;

                h = g;
                g = f;
                f = e;
                e = d + t1 | 0;
                d = c;
                c = b;
                b = a;
                a = t1 + t2 | 0;
            }

            // Intermediate hash value
            H[0] = H[0] + a | 0;
            H[1] = H[1] + b | 0;
            H[2] = H[2] + c | 0;
            H[3] = H[3] + d | 0;
            H[4] = H[4] + e | 0;
            H[5] = H[5] + f | 0;
            H[6] = H[6] + g | 0;
            H[7] = H[7] + h | 0;
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Return final computed hash
            return this._hash;
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        }
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA256('message');
     *     var hash = CryptoJS.SHA256(wordArray);
     */
    C.SHA256 = Hasher._createHelper(SHA256);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA256(message, key);
     */
    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
})(Math);

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_enc = C.enc;

    /**
     * UTF-16 BE encoding strategy.
     */
    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
        /**
         * Converts a word array to a UTF-16 BE string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-16 BE string.
         *
         * @static
         *
         * @example
         *
         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
                var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
        },

        /**
         * Converts a UTF-16 BE string to a word array.
         *
         * @param {string} utf16Str The UTF-16 BE string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
         */
        parse: function parse(utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
                words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
            }

            return WordArray.create(words, utf16StrLength * 2);
        }
    };

    /**
     * UTF-16 LE encoding strategy.
     */
    C_enc.Utf16LE = {
        /**
         * Converts a word array to a UTF-16 LE string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-16 LE string.
         *
         * @static
         *
         * @example
         *
         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
         */
        stringify: function stringify(wordArray) {
            // Shortcuts
            var words = wordArray.words;
            var sigBytes = wordArray.sigBytes;

            // Convert
            var utf16Chars = [];
            for (var i = 0; i < sigBytes; i += 2) {
                var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                utf16Chars.push(String.fromCharCode(codePoint));
            }

            return utf16Chars.join('');
        },

        /**
         * Converts a UTF-16 LE string to a word array.
         *
         * @param {string} utf16Str The UTF-16 LE string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
         */
        parse: function parse(utf16Str) {
            // Shortcut
            var utf16StrLength = utf16Str.length;

            // Convert
            var words = [];
            for (var i = 0; i < utf16StrLength; i++) {
                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
            }

            return WordArray.create(words, utf16StrLength * 2);
        }
    };

    function swapEndian(word) {
        return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
    }
})();

(function () {
    // Check if typed arrays are supported
    if (typeof ArrayBuffer != 'function') {
        return;
    }

    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;

    // Reference original init
    var superInit = WordArray.init;

    // Augment WordArray.init to handle typed arrays
    var subInit = WordArray.init = function (typedArray) {
        // Convert buffers to uint8
        if (typedArray instanceof ArrayBuffer) {
            typedArray = new Uint8Array(typedArray);
        }

        // Convert other array views to uint8
        if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
        }

        // Handle Uint8Array
        if (typedArray instanceof Uint8Array) {
            // Shortcut
            var typedArrayByteLength = typedArray.byteLength;

            // Extract bytes
            var words = [];
            for (var i = 0; i < typedArrayByteLength; i++) {
                words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
            }

            // Initialize this word array
            superInit.call(this, words, typedArrayByteLength);
        } else {
            // Else call normal init
            superInit.apply(this, arguments);
        }
    };

    subInit.prototype = WordArray;
})();

/** @preserve
 (c) 2012 by C��dric Mesnil. All rights reserved.
 
 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 
 - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 
 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

(function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_algo = C.algo;

    // Constants table
    var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);
    var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);
    var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);
    var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);

    var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
    var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

    /**
     * RIPEMD160 hash algorithm.
     */
    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
        _doReset: function _doReset() {
            this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {

            // Swap endian
            for (var i = 0; i < 16; i++) {
                // Shortcuts
                var offset_i = offset + i;
                var M_offset_i = M[offset_i];

                // Swap
                M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
            }
            // Shortcut
            var H = this._hash.words;
            var hl = _hl.words;
            var hr = _hr.words;
            var zl = _zl.words;
            var zr = _zr.words;
            var sl = _sl.words;
            var sr = _sr.words;

            // Working variables
            var al, bl, cl, dl, el;
            var ar, br, cr, dr, er;

            ar = al = H[0];
            br = bl = H[1];
            cr = cl = H[2];
            dr = dl = H[3];
            er = el = H[4];
            // Computation
            var t;
            for (var i = 0; i < 80; i += 1) {
                t = al + M[offset + zl[i]] | 0;
                if (i < 16) {
                    t += f1(bl, cl, dl) + hl[0];
                } else if (i < 32) {
                    t += f2(bl, cl, dl) + hl[1];
                } else if (i < 48) {
                    t += f3(bl, cl, dl) + hl[2];
                } else if (i < 64) {
                    t += f4(bl, cl, dl) + hl[3];
                } else {
                    // if (i<80) {
                    t += f5(bl, cl, dl) + hl[4];
                }
                t = t | 0;
                t = rotl(t, sl[i]);
                t = t + el | 0;
                al = el;
                el = dl;
                dl = rotl(cl, 10);
                cl = bl;
                bl = t;

                t = ar + M[offset + zr[i]] | 0;
                if (i < 16) {
                    t += f5(br, cr, dr) + hr[0];
                } else if (i < 32) {
                    t += f4(br, cr, dr) + hr[1];
                } else if (i < 48) {
                    t += f3(br, cr, dr) + hr[2];
                } else if (i < 64) {
                    t += f2(br, cr, dr) + hr[3];
                } else {
                    // if (i<80) {
                    t += f1(br, cr, dr) + hr[4];
                }
                t = t | 0;
                t = rotl(t, sr[i]);
                t = t + er | 0;
                ar = er;
                er = dr;
                dr = rotl(cr, 10);
                cr = br;
                br = t;
            }
            // Intermediate hash value
            t = H[1] + cl + dr | 0;
            H[1] = H[2] + dl + er | 0;
            H[2] = H[3] + el + ar | 0;
            H[3] = H[4] + al + br | 0;
            H[4] = H[0] + bl + cr | 0;
            H[0] = t;
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
            data.sigBytes = (dataWords.length + 1) * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var hash = this._hash;
            var H = hash.words;

            // Swap endian
            for (var i = 0; i < 5; i++) {
                // Shortcut
                var H_i = H[i];

                // Swap
                H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
            }

            // Return final computed hash
            return hash;
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        }
    });

    function f1(x, y, z) {
        return x ^ y ^ z;
    }

    function f2(x, y, z) {
        return x & y | ~x & z;
    }

    function f3(x, y, z) {
        return (x | ~y) ^ z;
    }

    function f4(x, y, z) {
        return x & z | y & ~z;
    }

    function f5(x, y, z) {
        return x ^ (y | ~z);
    }

    function rotl(x, n) {
        return x << n | x >>> 32 - n;
    }

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.RIPEMD160('message');
     *     var hash = CryptoJS.RIPEMD160(wordArray);
     */
    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
     */
    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
})(Math);

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var C_enc = C.enc;
    var Utf8 = C_enc.Utf8;
    var C_algo = C.algo;

    /**
     * HMAC algorithm.
     */
    var HMAC = C_algo.HMAC = Base.extend({
        /**
         * Initializes a newly created HMAC.
         *
         * @param {Hasher} hasher The hash algorithm to use.
         * @param {WordArray|string} key The secret key.
         *
         * @example
         *
         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
         */
        init: function init(hasher, key) {
            // Init hasher
            hasher = this._hasher = new hasher.init();

            // Convert string to WordArray, else assume WordArray already
            if (typeof key == 'string') {
                key = Utf8.parse(key);
            }

            // Shortcuts
            var hasherBlockSize = hasher.blockSize;
            var hasherBlockSizeBytes = hasherBlockSize * 4;

            // Allow arbitrary length keys
            if (key.sigBytes > hasherBlockSizeBytes) {
                key = hasher.finalize(key);
            }

            // Clamp excess bits
            key.clamp();

            // Clone key for inner and outer pads
            var oKey = this._oKey = key.clone();
            var iKey = this._iKey = key.clone();

            // Shortcuts
            var oKeyWords = oKey.words;
            var iKeyWords = iKey.words;

            // XOR keys with pad constants
            for (var i = 0; i < hasherBlockSize; i++) {
                oKeyWords[i] ^= 0x5c5c5c5c;
                iKeyWords[i] ^= 0x36363636;
            }
            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

            // Set initial values
            this.reset();
        },

        /**
         * Resets this HMAC to its initial state.
         *
         * @example
         *
         *     hmacHasher.reset();
         */
        reset: function reset() {
            // Shortcut
            var hasher = this._hasher;

            // Reset
            hasher.reset();
            hasher.update(this._iKey);
        },

        /**
         * Updates this HMAC with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {HMAC} This HMAC instance.
         *
         * @example
         *
         *     hmacHasher.update('message');
         *     hmacHasher.update(wordArray);
         */
        update: function update(messageUpdate) {
            this._hasher.update(messageUpdate);

            // Chainable
            return this;
        },

        /**
         * Finalizes the HMAC computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The HMAC.
         *
         * @example
         *
         *     var hmac = hmacHasher.finalize();
         *     var hmac = hmacHasher.finalize('message');
         *     var hmac = hmacHasher.finalize(wordArray);
         */
        finalize: function finalize(messageUpdate) {
            // Shortcut
            var hasher = this._hasher;

            // Compute HMAC
            var innerHash = hasher.finalize(messageUpdate);
            hasher.reset();
            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

            return hmac;
        }
    });
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var SHA1 = C_algo.SHA1;
    var HMAC = C_algo.HMAC;

    /**
     * Password-Based Key Derivation Function 2 algorithm.
     */
    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
        /**
         * Configuration options.
         *
         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
         * @property {Hasher} hasher The hasher to use. Default: SHA1
         * @property {number} iterations The number of iterations to perform. Default: 1
         */
        cfg: Base.extend({
            keySize: 128 / 32,
            hasher: SHA1,
            iterations: 1
        }),

        /**
         * Initializes a newly created key derivation function.
         *
         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
         *
         * @example
         *
         *     var kdf = CryptoJS.algo.PBKDF2.create();
         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
         */
        init: function init(cfg) {
            this.cfg = this.cfg.extend(cfg);
        },

        /**
         * Computes the Password-Based Key Derivation Function 2.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         *
         * @return {WordArray} The derived key.
         *
         * @example
         *
         *     var key = kdf.compute(password, salt);
         */
        compute: function compute(password, salt) {
            // Shortcut
            var cfg = this.cfg;

            // Init HMAC
            var hmac = HMAC.create(cfg.hasher, password);

            // Initial values
            var derivedKey = WordArray.create();
            var blockIndex = WordArray.create([0x00000001]);

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var blockIndexWords = blockIndex.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
                var block = hmac.update(salt).finalize(blockIndex);
                hmac.reset();

                // Shortcuts
                var blockWords = block.words;
                var blockWordsLength = blockWords.length;

                // Iterations
                var intermediate = block;
                for (var i = 1; i < iterations; i++) {
                    intermediate = hmac.finalize(intermediate);
                    hmac.reset();

                    // Shortcut
                    var intermediateWords = intermediate.words;

                    // XOR intermediate with block
                    for (var j = 0; j < blockWordsLength; j++) {
                        blockWords[j] ^= intermediateWords[j];
                    }
                }

                derivedKey.concat(block);
                blockIndexWords[0]++;
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
        }
    });

    /**
     * Computes the Password-Based Key Derivation Function 2.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.PBKDF2(password, salt);
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
     */
    C.PBKDF2 = function (password, salt, cfg) {
        return PBKDF2.create(cfg).compute(password, salt);
    };
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var MD5 = C_algo.MD5;

    /**
     * This key derivation function is meant to conform with EVP_BytesToKey.
     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
     */
    var EvpKDF = C_algo.EvpKDF = Base.extend({
        /**
         * Configuration options.
         *
         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
         * @property {number} iterations The number of iterations to perform. Default: 1
         */
        cfg: Base.extend({
            keySize: 128 / 32,
            hasher: MD5,
            iterations: 1
        }),

        /**
         * Initializes a newly created key derivation function.
         *
         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
         *
         * @example
         *
         *     var kdf = CryptoJS.algo.EvpKDF.create();
         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
         */
        init: function init(cfg) {
            this.cfg = this.cfg.extend(cfg);
        },

        /**
         * Derives a key from a password.
         *
         * @param {WordArray|string} password The password.
         * @param {WordArray|string} salt A salt.
         *
         * @return {WordArray} The derived key.
         *
         * @example
         *
         *     var key = kdf.compute(password, salt);
         */
        compute: function compute(password, salt) {
            var block;

            // Shortcut
            var cfg = this.cfg;

            // Init hasher
            var hasher = cfg.hasher.create();

            // Initial values
            var derivedKey = WordArray.create();

            // Shortcuts
            var derivedKeyWords = derivedKey.words;
            var keySize = cfg.keySize;
            var iterations = cfg.iterations;

            // Generate key
            while (derivedKeyWords.length < keySize) {
                if (block) {
                    hasher.update(block);
                }
                block = hasher.update(password).finalize(salt);
                hasher.reset();

                // Iterations
                for (var i = 1; i < iterations; i++) {
                    block = hasher.finalize(block);
                    hasher.reset();
                }

                derivedKey.concat(block);
            }
            derivedKey.sigBytes = keySize * 4;

            return derivedKey;
        }
    });

    /**
     * Derives a key from a password.
     *
     * @param {WordArray|string} password The password.
     * @param {WordArray|string} salt A salt.
     * @param {Object} cfg (Optional) The configuration options to use for this computation.
     *
     * @return {WordArray} The derived key.
     *
     * @static
     *
     * @example
     *
     *     var key = CryptoJS.EvpKDF(password, salt);
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
     */
    C.EvpKDF = function (password, salt, cfg) {
        return EvpKDF.create(cfg).compute(password, salt);
    };
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var C_algo = C.algo;
    var SHA256 = C_algo.SHA256;

    /**
     * SHA-224 hash algorithm.
     */
    var SHA224 = C_algo.SHA224 = SHA256.extend({
        _doReset: function _doReset() {
            this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
        },

        _doFinalize: function _doFinalize() {
            var hash = SHA256._doFinalize.call(this);

            hash.sigBytes -= 4;

            return hash;
        }
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA224('message');
     *     var hash = CryptoJS.SHA224(wordArray);
     */
    C.SHA224 = SHA256._createHelper(SHA224);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA224(message, key);
     */
    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
})();

(function (undefined) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var X32WordArray = C_lib.WordArray;

    /**
     * x64 namespace.
     */
    var C_x64 = C.x64 = {};

    /**
     * A 64-bit word.
     */
    var X64Word = C_x64.Word = Base.extend({
        /**
         * Initializes a newly created 64-bit word.
         *
         * @param {number} high The high 32 bits.
         * @param {number} low The low 32 bits.
         *
         * @example
         *
         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
         */
        init: function init(high, low) {
            this.high = high;
            this.low = low;
        }

        /**
         * Bitwise NOTs this word.
         *
         * @return {X64Word} A new x64-Word object after negating.
         *
         * @example
         *
         *     var negated = x64Word.not();
         */
        // not: function () {
        // var high = ~this.high;
        // var low = ~this.low;

        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise ANDs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to AND with this word.
         *
         * @return {X64Word} A new x64-Word object after ANDing.
         *
         * @example
         *
         *     var anded = x64Word.and(anotherX64Word);
         */
        // and: function (word) {
        // var high = this.high & word.high;
        // var low = this.low & word.low;

        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise ORs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to OR with this word.
         *
         * @return {X64Word} A new x64-Word object after ORing.
         *
         * @example
         *
         *     var ored = x64Word.or(anotherX64Word);
         */
        // or: function (word) {
        // var high = this.high | word.high;
        // var low = this.low | word.low;

        // return X64Word.create(high, low);
        // },

        /**
         * Bitwise XORs this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to XOR with this word.
         *
         * @return {X64Word} A new x64-Word object after XORing.
         *
         * @example
         *
         *     var xored = x64Word.xor(anotherX64Word);
         */
        // xor: function (word) {
        // var high = this.high ^ word.high;
        // var low = this.low ^ word.low;

        // return X64Word.create(high, low);
        // },

        /**
         * Shifts this word n bits to the left.
         *
         * @param {number} n The number of bits to shift.
         *
         * @return {X64Word} A new x64-Word object after shifting.
         *
         * @example
         *
         *     var shifted = x64Word.shiftL(25);
         */
        // shiftL: function (n) {
        // if (n < 32) {
        // var high = (this.high << n) | (this.low >>> (32 - n));
        // var low = this.low << n;
        // } else {
        // var high = this.low << (n - 32);
        // var low = 0;
        // }

        // return X64Word.create(high, low);
        // },

        /**
         * Shifts this word n bits to the right.
         *
         * @param {number} n The number of bits to shift.
         *
         * @return {X64Word} A new x64-Word object after shifting.
         *
         * @example
         *
         *     var shifted = x64Word.shiftR(7);
         */
        // shiftR: function (n) {
        // if (n < 32) {
        // var low = (this.low >>> n) | (this.high << (32 - n));
        // var high = this.high >>> n;
        // } else {
        // var low = this.high >>> (n - 32);
        // var high = 0;
        // }

        // return X64Word.create(high, low);
        // },

        /**
         * Rotates this word n bits to the left.
         *
         * @param {number} n The number of bits to rotate.
         *
         * @return {X64Word} A new x64-Word object after rotating.
         *
         * @example
         *
         *     var rotated = x64Word.rotL(25);
         */
        // rotL: function (n) {
        // return this.shiftL(n).or(this.shiftR(64 - n));
        // },

        /**
         * Rotates this word n bits to the right.
         *
         * @param {number} n The number of bits to rotate.
         *
         * @return {X64Word} A new x64-Word object after rotating.
         *
         * @example
         *
         *     var rotated = x64Word.rotR(7);
         */
        // rotR: function (n) {
        // return this.shiftR(n).or(this.shiftL(64 - n));
        // },

        /**
         * Adds this word with the passed word.
         *
         * @param {X64Word} word The x64-Word to add with this word.
         *
         * @return {X64Word} A new x64-Word object after adding.
         *
         * @example
         *
         *     var added = x64Word.add(anotherX64Word);
         */
        // add: function (word) {
        // var low = (this.low + word.low) | 0;
        // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
        // var high = (this.high + word.high + carry) | 0;

        // return X64Word.create(high, low);
        // }
    });

    /**
     * An array of 64-bit words.
     *
     * @property {Array} words The array of CryptoJS.x64.Word objects.
     * @property {number} sigBytes The number of significant bytes in this word array.
     */
    var X64WordArray = C_x64.WordArray = Base.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.x64.WordArray.create();
         *
         *     var wordArray = CryptoJS.x64.WordArray.create([
         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
         *     ]);
         *
         *     var wordArray = CryptoJS.x64.WordArray.create([
         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
         *     ], 10);
         */
        init: function init(words, sigBytes) {
            words = this.words = words || [];

            if (sigBytes != undefined) {
                this.sigBytes = sigBytes;
            } else {
                this.sigBytes = words.length * 8;
            }
        },

        /**
         * Converts this 64-bit word array to a 32-bit word array.
         *
         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
         *
         * @example
         *
         *     var x32WordArray = x64WordArray.toX32();
         */
        toX32: function toX32() {
            // Shortcuts
            var x64Words = this.words;
            var x64WordsLength = x64Words.length;

            // Convert
            var x32Words = [];
            for (var i = 0; i < x64WordsLength; i++) {
                var x64Word = x64Words[i];
                x32Words.push(x64Word.high);
                x32Words.push(x64Word.low);
            }

            return X32WordArray.create(x32Words, this.sigBytes);
        },

        /**
         * Creates a copy of this word array.
         *
         * @return {X64WordArray} The clone.
         *
         * @example
         *
         *     var clone = x64WordArray.clone();
         */
        clone: function clone() {
            var clone = Base.clone.call(this);

            // Clone "words" array
            var words = clone.words = this.words.slice(0);

            // Clone each X64Word object
            var wordsLength = words.length;
            for (var i = 0; i < wordsLength; i++) {
                words[i] = words[i].clone();
            }

            return clone;
        }
    });
})();

(function (Math) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var Hasher = C_lib.Hasher;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var C_algo = C.algo;

    // Constants tables
    var RHO_OFFSETS = [];
    var PI_INDEXES = [];
    var ROUND_CONSTANTS = [];

    // Compute Constants
    (function () {
        // Compute rho offset constants
        var x = 1,
            y = 0;
        for (var t = 0; t < 24; t++) {
            RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;

            var newX = y % 5;
            var newY = (2 * x + 3 * y) % 5;
            x = newX;
            y = newY;
        }

        // Compute pi index constants
        for (var x = 0; x < 5; x++) {
            for (var y = 0; y < 5; y++) {
                PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            }
        }

        // Compute round constants
        var LFSR = 0x01;
        for (var i = 0; i < 24; i++) {
            var roundConstantMsw = 0;
            var roundConstantLsw = 0;

            for (var j = 0; j < 7; j++) {
                if (LFSR & 0x01) {
                    var bitPosition = (1 << j) - 1;
                    if (bitPosition < 32) {
                        roundConstantLsw ^= 1 << bitPosition;
                    } else /* if (bitPosition >= 32) */{
                            roundConstantMsw ^= 1 << bitPosition - 32;
                        }
                }

                // Compute next LFSR
                if (LFSR & 0x80) {
                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                } else {
                    LFSR <<= 1;
                }
            }

            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
        }
    })();

    // Reusable objects for temporary values
    var T = [];
    (function () {
        for (var i = 0; i < 25; i++) {
            T[i] = X64Word.create();
        }
    })();

    /**
     * SHA-3 hash algorithm.
     */
    var SHA3 = C_algo.SHA3 = Hasher.extend({
        /**
         * Configuration options.
         *
         * @property {number} outputLength
         *   The desired number of bits in the output hash.
         *   Only values permitted are: 224, 256, 384, 512.
         *   Default: 512
         */
        cfg: Hasher.cfg.extend({
            outputLength: 512
        }),

        _doReset: function _doReset() {
            var state = this._state = [];
            for (var i = 0; i < 25; i++) {
                state[i] = new X64Word.init();
            }

            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcuts
            var state = this._state;
            var nBlockSizeLanes = this.blockSize / 2;

            // Absorb
            for (var i = 0; i < nBlockSizeLanes; i++) {
                // Shortcuts
                var M2i = M[offset + 2 * i];
                var M2i1 = M[offset + 2 * i + 1];

                // Swap endian
                M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;

                // Absorb message into state
                var lane = state[i];
                lane.high ^= M2i1;
                lane.low ^= M2i;
            }

            // Rounds
            for (var round = 0; round < 24; round++) {
                // Theta
                for (var x = 0; x < 5; x++) {
                    // Mix column lanes
                    var tMsw = 0,
                        tLsw = 0;
                    for (var y = 0; y < 5; y++) {
                        var lane = state[x + 5 * y];
                        tMsw ^= lane.high;
                        tLsw ^= lane.low;
                    }

                    // Temporary values
                    var Tx = T[x];
                    Tx.high = tMsw;
                    Tx.low = tLsw;
                }
                for (var x = 0; x < 5; x++) {
                    // Shortcuts
                    var Tx4 = T[(x + 4) % 5];
                    var Tx1 = T[(x + 1) % 5];
                    var Tx1Msw = Tx1.high;
                    var Tx1Lsw = Tx1.low;

                    // Mix surrounding columns
                    var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                    var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                    for (var y = 0; y < 5; y++) {
                        var lane = state[x + 5 * y];
                        lane.high ^= tMsw;
                        lane.low ^= tLsw;
                    }
                }

                // Rho Pi
                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                    var tMsw;
                    var tLsw;

                    // Shortcuts
                    var lane = state[laneIndex];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    var rhoOffset = RHO_OFFSETS[laneIndex];

                    // Rotate lanes
                    if (rhoOffset < 32) {
                        tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                        tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                    } else /* if (rhoOffset >= 32) */{
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }

                    // Transpose lanes
                    var TPiLane = T[PI_INDEXES[laneIndex]];
                    TPiLane.high = tMsw;
                    TPiLane.low = tLsw;
                }

                // Rho pi at x = y = 0
                var T0 = T[0];
                var state0 = state[0];
                T0.high = state0.high;
                T0.low = state0.low;

                // Chi
                for (var x = 0; x < 5; x++) {
                    for (var y = 0; y < 5; y++) {
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];

                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                }

                // Iota
                var lane = state[0];
                var roundConstant = ROUND_CONSTANTS[round];
                lane.high ^= roundConstant.high;
                lane.low ^= roundConstant.low;
            }
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;
            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;
            var blockSizeBits = this.blockSize * 32;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
            dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Shortcuts
            var state = this._state;
            var outputLengthBytes = this.cfg.outputLength / 8;
            var outputLengthLanes = outputLengthBytes / 8;

            // Squeeze
            var hashWords = [];
            for (var i = 0; i < outputLengthLanes; i++) {
                // Shortcuts
                var lane = state[i];
                var laneMsw = lane.high;
                var laneLsw = lane.low;

                // Swap endian
                laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;

                // Squeeze state to retrieve hash
                hashWords.push(laneLsw);
                hashWords.push(laneMsw);
            }

            // Return final computed hash
            return new WordArray.init(hashWords, outputLengthBytes);
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);

            var state = clone._state = this._state.slice(0);
            for (var i = 0; i < 25; i++) {
                state[i] = state[i].clone();
            }

            return clone;
        }
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA3('message');
     *     var hash = CryptoJS.SHA3(wordArray);
     */
    C.SHA3 = Hasher._createHelper(SHA3);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA3(message, key);
     */
    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
})(Math);

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Hasher = C_lib.Hasher;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var X64WordArray = C_x64.WordArray;
    var C_algo = C.algo;

    function X64Word_create() {
        return X64Word.create.apply(X64Word, arguments);
    }

    // Constants
    var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)];

    // Reusable objects
    var W = [];
    (function () {
        for (var i = 0; i < 80; i++) {
            W[i] = X64Word_create();
        }
    })();

    /**
     * SHA-512 hash algorithm.
     */
    var SHA512 = C_algo.SHA512 = Hasher.extend({
        _doReset: function _doReset() {
            this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcuts
            var H = this._hash.words;

            var H0 = H[0];
            var H1 = H[1];
            var H2 = H[2];
            var H3 = H[3];
            var H4 = H[4];
            var H5 = H[5];
            var H6 = H[6];
            var H7 = H[7];

            var H0h = H0.high;
            var H0l = H0.low;
            var H1h = H1.high;
            var H1l = H1.low;
            var H2h = H2.high;
            var H2l = H2.low;
            var H3h = H3.high;
            var H3l = H3.low;
            var H4h = H4.high;
            var H4l = H4.low;
            var H5h = H5.high;
            var H5l = H5.low;
            var H6h = H6.high;
            var H6l = H6.low;
            var H7h = H7.high;
            var H7l = H7.low;

            // Working variables
            var ah = H0h;
            var al = H0l;
            var bh = H1h;
            var bl = H1l;
            var ch = H2h;
            var cl = H2l;
            var dh = H3h;
            var dl = H3l;
            var eh = H4h;
            var el = H4l;
            var fh = H5h;
            var fl = H5l;
            var gh = H6h;
            var gl = H6l;
            var hh = H7h;
            var hl = H7l;

            // Rounds
            for (var i = 0; i < 80; i++) {
                var Wil;
                var Wih;

                // Shortcut
                var Wi = W[i];

                // Extend message
                if (i < 16) {
                    Wih = Wi.high = M[offset + i * 2] | 0;
                    Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                } else {
                    // Gamma0
                    var gamma0x = W[i - 15];
                    var gamma0xh = gamma0x.high;
                    var gamma0xl = gamma0x.low;
                    var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                    var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);

                    // Gamma1
                    var gamma1x = W[i - 2];
                    var gamma1xh = gamma1x.high;
                    var gamma1xl = gamma1x.low;
                    var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                    var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);

                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                    var Wi7 = W[i - 7];
                    var Wi7h = Wi7.high;
                    var Wi7l = Wi7.low;

                    var Wi16 = W[i - 16];
                    var Wi16h = Wi16.high;
                    var Wi16l = Wi16.low;

                    Wil = gamma0l + Wi7l;
                    Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                    Wil = Wil + gamma1l;
                    Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                    Wil = Wil + Wi16l;
                    Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);

                    Wi.high = Wih;
                    Wi.low = Wil;
                }

                var chh = eh & fh ^ ~eh & gh;
                var chl = el & fl ^ ~el & gl;
                var majh = ah & bh ^ ah & ch ^ bh & ch;
                var majl = al & bl ^ al & cl ^ bl & cl;

                var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);

                // t1 = h + sigma1 + ch + K[i] + W[i]
                var Ki = K[i];
                var Kih = Ki.high;
                var Kil = Ki.low;

                var t1l = hl + sigma1l;
                var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                var t1l = t1l + chl;
                var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                var t1l = t1l + Kil;
                var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                var t1l = t1l + Wil;
                var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);

                // t2 = sigma0 + maj
                var t2l = sigma0l + majl;
                var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);

                // Update working variables
                hh = gh;
                hl = gl;
                gh = fh;
                gl = fl;
                fh = eh;
                fl = el;
                el = dl + t1l | 0;
                eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                dh = ch;
                dl = cl;
                ch = bh;
                cl = bl;
                bh = ah;
                bl = al;
                al = t1l + t2l | 0;
                ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
            }

            // Intermediate hash value
            H0l = H0.low = H0l + al;
            H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
            H1l = H1.low = H1l + bl;
            H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
            H2l = H2.low = H2l + cl;
            H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
            H3l = H3.low = H3l + dl;
            H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
            H4l = H4.low = H4l + el;
            H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
            H5l = H5.low = H5l + fl;
            H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
            H6l = H6.low = H6l + gl;
            H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
            H7l = H7.low = H7l + hl;
            H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
        },

        _doFinalize: function _doFinalize() {
            // Shortcuts
            var data = this._data;
            var dataWords = data.words;

            var nBitsTotal = this._nDataBytes * 8;
            var nBitsLeft = data.sigBytes * 8;

            // Add padding
            dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
            dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
            data.sigBytes = dataWords.length * 4;

            // Hash final blocks
            this._process();

            // Convert hash to 32-bit word array before returning
            var hash = this._hash.toX32();

            // Return final computed hash
            return hash;
        },

        clone: function clone() {
            var clone = Hasher.clone.call(this);
            clone._hash = this._hash.clone();

            return clone;
        },

        blockSize: 1024 / 32
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA512('message');
     *     var hash = CryptoJS.SHA512(wordArray);
     */
    C.SHA512 = Hasher._createHelper(SHA512);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA512(message, key);
     */
    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_x64 = C.x64;
    var X64Word = C_x64.Word;
    var X64WordArray = C_x64.WordArray;
    var C_algo = C.algo;
    var SHA512 = C_algo.SHA512;

    /**
     * SHA-384 hash algorithm.
     */
    var SHA384 = C_algo.SHA384 = SHA512.extend({
        _doReset: function _doReset() {
            this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
        },

        _doFinalize: function _doFinalize() {
            var hash = SHA512._doFinalize.call(this);

            hash.sigBytes -= 16;

            return hash;
        }
    });

    /**
     * Shortcut function to the hasher's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     *
     * @return {WordArray} The hash.
     *
     * @static
     *
     * @example
     *
     *     var hash = CryptoJS.SHA384('message');
     *     var hash = CryptoJS.SHA384(wordArray);
     */
    C.SHA384 = SHA512._createHelper(SHA384);

    /**
     * Shortcut function to the HMAC's object interface.
     *
     * @param {WordArray|string} message The message to hash.
     * @param {WordArray|string} key The secret key.
     *
     * @return {WordArray} The HMAC.
     *
     * @static
     *
     * @example
     *
     *     var hmac = CryptoJS.HmacSHA384(message, key);
     */
    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
})();

/**
 * Cipher core components.
 */
CryptoJS.lib.Cipher || function (undefined) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var Base = C_lib.Base;
    var WordArray = C_lib.WordArray;
    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
    var C_enc = C.enc;
    var Utf8 = C_enc.Utf8;
    var Base64 = C_enc.Base64;
    var C_algo = C.algo;
    var EvpKDF = C_algo.EvpKDF;

    /**
     * Abstract base cipher template.
     *
     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
     */
    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
        /**
         * Configuration options.
         *
         * @property {WordArray} iv The IV to use for this operation.
         */
        cfg: Base.extend(),

        /**
         * Creates this cipher in encryption mode.
         *
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {Cipher} A cipher instance.
         *
         * @static
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
         */
        createEncryptor: function createEncryptor(key, cfg) {
            return this.create(this._ENC_XFORM_MODE, key, cfg);
        },

        /**
         * Creates this cipher in decryption mode.
         *
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {Cipher} A cipher instance.
         *
         * @static
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
         */
        createDecryptor: function createDecryptor(key, cfg) {
            return this.create(this._DEC_XFORM_MODE, key, cfg);
        },

        /**
         * Initializes a newly created cipher.
         *
         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @example
         *
         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
         */
        init: function init(xformMode, key, cfg) {
            // Apply config defaults
            this.cfg = this.cfg.extend(cfg);

            // Store transform mode and key
            this._xformMode = xformMode;
            this._key = key;

            // Set initial values
            this.reset();
        },

        /**
         * Resets this cipher to its initial state.
         *
         * @example
         *
         *     cipher.reset();
         */
        reset: function reset() {
            // Reset data buffer
            BufferedBlockAlgorithm.reset.call(this);

            // Perform concrete-cipher logic
            this._doReset();
        },

        /**
         * Adds data to be encrypted or decrypted.
         *
         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
         *
         * @return {WordArray} The data after processing.
         *
         * @example
         *
         *     var encrypted = cipher.process('data');
         *     var encrypted = cipher.process(wordArray);
         */
        process: function process(dataUpdate) {
            // Append
            this._append(dataUpdate);

            // Process available blocks
            return this._process();
        },

        /**
         * Finalizes the encryption or decryption process.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
         *
         * @return {WordArray} The data after final processing.
         *
         * @example
         *
         *     var encrypted = cipher.finalize();
         *     var encrypted = cipher.finalize('data');
         *     var encrypted = cipher.finalize(wordArray);
         */
        finalize: function finalize(dataUpdate) {
            // Final data update
            if (dataUpdate) {
                this._append(dataUpdate);
            }

            // Perform concrete-cipher logic
            var finalProcessedData = this._doFinalize();

            return finalProcessedData;
        },

        keySize: 128 / 32,

        ivSize: 128 / 32,

        _ENC_XFORM_MODE: 1,

        _DEC_XFORM_MODE: 2,

        /**
         * Creates shortcut functions to a cipher's object interface.
         *
         * @param {Cipher} cipher The cipher to create a helper for.
         *
         * @return {Object} An object with encrypt and decrypt shortcut functions.
         *
         * @static
         *
         * @example
         *
         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
         */
        _createHelper: function () {
            function selectCipherStrategy(key) {
                if (typeof key == 'string') {
                    return PasswordBasedCipher;
                } else {
                    return SerializableCipher;
                }
            }

            return function (cipher) {
                return {
                    encrypt: function encrypt(message, key, cfg) {
                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                    },

                    decrypt: function decrypt(ciphertext, key, cfg) {
                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                    }
                };
            };
        }()
    });

    /**
     * Abstract base stream cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
     */
    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
        _doFinalize: function _doFinalize() {
            // Process partial blocks
            var finalProcessedBlocks = this._process(!!'flush');

            return finalProcessedBlocks;
        },

        blockSize: 1
    });

    /**
     * Mode namespace.
     */
    var C_mode = C.mode = {};

    /**
     * Abstract base block cipher mode template.
     */
    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
        /**
         * Creates this mode for encryption.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @static
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
         */
        createEncryptor: function createEncryptor(cipher, iv) {
            return this.Encryptor.create(cipher, iv);
        },

        /**
         * Creates this mode for decryption.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @static
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
         */
        createDecryptor: function createDecryptor(cipher, iv) {
            return this.Decryptor.create(cipher, iv);
        },

        /**
         * Initializes a newly created mode.
         *
         * @param {Cipher} cipher A block cipher instance.
         * @param {Array} iv The IV words.
         *
         * @example
         *
         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
         */
        init: function init(cipher, iv) {
            this._cipher = cipher;
            this._iv = iv;
        }
    });

    /**
     * Cipher Block Chaining mode.
     */
    var CBC = C_mode.CBC = function () {
        /**
         * Abstract base CBC mode.
         */
        var CBC = BlockCipherMode.extend();

        /**
         * CBC encryptor.
         */
        CBC.Encryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;

                // XOR and encrypt
                xorBlock.call(this, words, offset, blockSize);
                cipher.encryptBlock(words, offset);

                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });

        /**
         * CBC decryptor.
         */
        CBC.Decryptor = CBC.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function processBlock(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;

                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);

                // Decrypt and XOR
                cipher.decryptBlock(words, offset);
                xorBlock.call(this, words, offset, blockSize);

                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });

        function xorBlock(words, offset, blockSize) {
            var block;

            // Shortcut
            var iv = this._iv;

            // Choose mixing block
            if (iv) {
                block = iv;

                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else {
                block = this._prevBlock;
            }

            // XOR blocks
            for (var i = 0; i < blockSize; i++) {
                words[offset + i] ^= block[i];
            }
        }

        return CBC;
    }();

    /**
     * Padding namespace.
     */
    var C_pad = C.pad = {};

    /**
     * PKCS #5/7 padding strategy.
     */
    var Pkcs7 = C_pad.Pkcs7 = {
        /**
         * Pads data using the algorithm defined in PKCS #5/7.
         *
         * @param {WordArray} data The data to pad.
         * @param {number} blockSize The multiple that the data should be padded to.
         *
         * @static
         *
         * @example
         *
         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
         */
        pad: function pad(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;

            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

            // Create padding word
            var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;

            // Create padding
            var paddingWords = [];
            for (var i = 0; i < nPaddingBytes; i += 4) {
                paddingWords.push(paddingWord);
            }
            var padding = WordArray.create(paddingWords, nPaddingBytes);

            // Add padding
            data.concat(padding);
        },

        /**
         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
         *
         * @param {WordArray} data The data to unpad.
         *
         * @static
         *
         * @example
         *
         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
         */
        unpad: function unpad(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;

            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };

    /**
     * Abstract base block cipher template.
     *
     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
     */
    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
        /**
         * Configuration options.
         *
         * @property {Mode} mode The block mode to use. Default: CBC
         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
         */
        cfg: Cipher.cfg.extend({
            mode: CBC,
            padding: Pkcs7
        }),

        reset: function reset() {
            var modeCreator;

            // Reset cipher
            Cipher.reset.call(this);

            // Shortcuts
            var cfg = this.cfg;
            var iv = cfg.iv;
            var mode = cfg.mode;

            // Reset block mode
            if (this._xformMode == this._ENC_XFORM_MODE) {
                modeCreator = mode.createEncryptor;
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }

            if (this._mode && this._mode.__creator == modeCreator) {
                this._mode.init(this, iv && iv.words);
            } else {
                this._mode = modeCreator.call(mode, this, iv && iv.words);
                this._mode.__creator = modeCreator;
            }
        },

        _doProcessBlock: function _doProcessBlock(words, offset) {
            this._mode.processBlock(words, offset);
        },

        _doFinalize: function _doFinalize() {
            var finalProcessedBlocks;

            // Shortcut
            var padding = this.cfg.padding;

            // Finalize
            if (this._xformMode == this._ENC_XFORM_MODE) {
                // Pad data
                padding.pad(this._data, this.blockSize);

                // Process final blocks
                finalProcessedBlocks = this._process(!!'flush');
            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
                    // Process final blocks
                    finalProcessedBlocks = this._process(!!'flush');

                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }

            return finalProcessedBlocks;
        },

        blockSize: 128 / 32
    });

    /**
     * A collection of cipher parameters.
     *
     * @property {WordArray} ciphertext The raw ciphertext.
     * @property {WordArray} key The key to this ciphertext.
     * @property {WordArray} iv The IV used in the ciphering operation.
     * @property {WordArray} salt The salt used with a key derivation function.
     * @property {Cipher} algorithm The cipher algorithm.
     * @property {Mode} mode The block mode used in the ciphering operation.
     * @property {Padding} padding The padding scheme used in the ciphering operation.
     * @property {number} blockSize The block size of the cipher.
     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
     */
    var CipherParams = C_lib.CipherParams = Base.extend({
        /**
         * Initializes a newly created cipher params object.
         *
         * @param {Object} cipherParams An object with any of the possible cipher parameters.
         *
         * @example
         *
         *     var cipherParams = CryptoJS.lib.CipherParams.create({
         *         ciphertext: ciphertextWordArray,
         *         key: keyWordArray,
         *         iv: ivWordArray,
         *         salt: saltWordArray,
         *         algorithm: CryptoJS.algo.AES,
         *         mode: CryptoJS.mode.CBC,
         *         padding: CryptoJS.pad.PKCS7,
         *         blockSize: 4,
         *         formatter: CryptoJS.format.OpenSSL
         *     });
         */
        init: function init(cipherParams) {
            this.mixIn(cipherParams);
        },

        /**
         * Converts this cipher params object to a string.
         *
         * @param {Format} formatter (Optional) The formatting strategy to use.
         *
         * @return {string} The stringified cipher params.
         *
         * @throws Error If neither the formatter nor the default formatter is set.
         *
         * @example
         *
         *     var string = cipherParams + '';
         *     var string = cipherParams.toString();
         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
         */
        toString: function toString(formatter) {
            return (formatter || this.formatter).stringify(this);
        }
    });

    /**
     * Format namespace.
     */
    var C_format = C.format = {};

    /**
     * OpenSSL formatting strategy.
     */
    var OpenSSLFormatter = C_format.OpenSSL = {
        /**
         * Converts a cipher params object to an OpenSSL-compatible string.
         *
         * @param {CipherParams} cipherParams The cipher params object.
         *
         * @return {string} The OpenSSL-compatible string.
         *
         * @static
         *
         * @example
         *
         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
         */
        stringify: function stringify(cipherParams) {
            var wordArray;

            // Shortcuts
            var ciphertext = cipherParams.ciphertext;
            var salt = cipherParams.salt;

            // Format
            if (salt) {
                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
            } else {
                wordArray = ciphertext;
            }

            return wordArray.toString(Base64);
        },

        /**
         * Converts an OpenSSL-compatible string to a cipher params object.
         *
         * @param {string} openSSLStr The OpenSSL-compatible string.
         *
         * @return {CipherParams} The cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
         */
        parse: function parse(openSSLStr) {
            var salt;

            // Parse base64
            var ciphertext = Base64.parse(openSSLStr);

            // Shortcut
            var ciphertextWords = ciphertext.words;

            // Test for salt
            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                // Extract salt
                salt = WordArray.create(ciphertextWords.slice(2, 4));

                // Remove salt from ciphertext
                ciphertextWords.splice(0, 4);
                ciphertext.sigBytes -= 16;
            }

            return CipherParams.create({
                ciphertext: ciphertext,
                salt: salt
            });
        }
    };

    /**
     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
     */
    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
        /**
         * Configuration options.
         *
         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
         */
        cfg: Base.extend({
            format: OpenSSLFormatter
        }),

        /**
         * Encrypts a message.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {WordArray|string} message The message to encrypt.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {CipherParams} A cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         */
        encrypt: function encrypt(cipher, message, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Encrypt
            var encryptor = cipher.createEncryptor(key, cfg);
            var ciphertext = encryptor.finalize(message);

            // Shortcut
            var cipherCfg = encryptor.cfg;

            // Create and return serializable cipher params
            return CipherParams.create({
                ciphertext: ciphertext,
                key: key,
                iv: cipherCfg.iv,
                algorithm: cipher,
                mode: cipherCfg.mode,
                padding: cipherCfg.padding,
                blockSize: cipher.blockSize,
                formatter: cfg.format
            });
        },

        /**
         * Decrypts serialized ciphertext.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
         * @param {WordArray} key The key.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {WordArray} The plaintext.
         *
         * @static
         *
         * @example
         *
         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
         */
        decrypt: function decrypt(cipher, ciphertext, key, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Decrypt
            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

            return plaintext;
        },

        /**
         * Converts serialized ciphertext to CipherParams,
         * else assumed CipherParams already and returns ciphertext unchanged.
         *
         * @param {CipherParams|string} ciphertext The ciphertext.
         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
         *
         * @return {CipherParams} The unserialized ciphertext.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
         */
        _parse: function _parse(ciphertext, format) {
            if (typeof ciphertext == 'string') {
                return format.parse(ciphertext, this);
            } else {
                return ciphertext;
            }
        }
    });

    /**
     * Key derivation function namespace.
     */
    var C_kdf = C.kdf = {};

    /**
     * OpenSSL key derivation function.
     */
    var OpenSSLKdf = C_kdf.OpenSSL = {
        /**
         * Derives a key and IV from a password.
         *
         * @param {string} password The password to derive from.
         * @param {number} keySize The size in words of the key to generate.
         * @param {number} ivSize The size in words of the IV to generate.
         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
         *
         * @return {CipherParams} A cipher params object with the key, IV, and salt.
         *
         * @static
         *
         * @example
         *
         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
         */
        execute: function execute(password, keySize, ivSize, salt) {
            // Generate random salt
            if (!salt) {
                salt = WordArray.random(64 / 8);
            }

            // Derive key and IV
            var key = EvpKDF.create({
                keySize: keySize + ivSize
            }).compute(password, salt);

            // Separate key and IV
            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
            key.sigBytes = keySize * 4;

            // Return params
            return CipherParams.create({
                key: key,
                iv: iv,
                salt: salt
            });
        }
    };

    /**
     * A serializable cipher wrapper that derives the key from a password,
     * and returns ciphertext as a serializable cipher params object.
     */
    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
        /**
         * Configuration options.
         *
         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
         */
        cfg: SerializableCipher.cfg.extend({
            kdf: OpenSSLKdf
        }),

        /**
         * Encrypts a message using a password.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {WordArray|string} message The message to encrypt.
         * @param {string} password The password.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {CipherParams} A cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
         */
        encrypt: function encrypt(cipher, message, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Encrypt
            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

            // Mix in derived params
            ciphertext.mixIn(derivedParams);

            return ciphertext;
        },

        /**
         * Decrypts serialized ciphertext using a password.
         *
         * @param {Cipher} cipher The cipher algorithm to use.
         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
         * @param {string} password The password.
         * @param {Object} cfg (Optional) The configuration options to use for this operation.
         *
         * @return {WordArray} The plaintext.
         *
         * @static
         *
         * @example
         *
         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
         */
        decrypt: function decrypt(cipher, ciphertext, password, cfg) {
            // Apply config defaults
            cfg = this.cfg.extend(cfg);

            // Convert string to CipherParams
            ciphertext = this._parse(ciphertext, cfg.format);

            // Derive key and other params
            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

            // Add IV to config
            cfg.iv = derivedParams.iv;

            // Decrypt
            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

            return plaintext;
        }
    });
}();

/**
 * Cipher Feedback block mode.
 */
CryptoJS.mode.CFB = function () {
    var CFB = CryptoJS.lib.BlockCipherMode.extend();

    CFB.Encryptor = CFB.extend({
        processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // Remember this block to use with next block
            this._prevBlock = words.slice(offset, offset + blockSize);
        }
    });

    CFB.Decryptor = CFB.extend({
        processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;

            // Remember this block to use with next block
            var thisBlock = words.slice(offset, offset + blockSize);

            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

            // This block becomes the previous block
            this._prevBlock = thisBlock;
        }
    });

    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
        var keystream;

        // Shortcut
        var iv = this._iv;

        // Generate keystream
        if (iv) {
            keystream = iv.slice(0);

            // Remove IV for subsequent blocks
            this._iv = undefined;
        } else {
            keystream = this._prevBlock;
        }
        cipher.encryptBlock(keystream, 0);

        // Encrypt
        for (var i = 0; i < blockSize; i++) {
            words[offset + i] ^= keystream[i];
        }
    }

    return CFB;
}();

/**
 * Electronic Codebook block mode.
 */
CryptoJS.mode.ECB = function () {
    var ECB = CryptoJS.lib.BlockCipherMode.extend();

    ECB.Encryptor = ECB.extend({
        processBlock: function processBlock(words, offset) {
            this._cipher.encryptBlock(words, offset);
        }
    });

    ECB.Decryptor = ECB.extend({
        processBlock: function processBlock(words, offset) {
            this._cipher.decryptBlock(words, offset);
        }
    });

    return ECB;
}();

/**
 * ANSI X.923 padding strategy.
 */
CryptoJS.pad.AnsiX923 = {
    pad: function pad(data, blockSize) {
        // Shortcuts
        var dataSigBytes = data.sigBytes;
        var blockSizeBytes = blockSize * 4;

        // Count padding bytes
        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

        // Compute last byte position
        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

        // Pad
        data.clamp();
        data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
        data.sigBytes += nPaddingBytes;
    },

    unpad: function unpad(data) {
        // Get number of padding bytes from last byte
        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;

        // Remove padding
        data.sigBytes -= nPaddingBytes;
    }
};

/**
 * ISO 10126 padding strategy.
 */
CryptoJS.pad.Iso10126 = {
    pad: function pad(data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4;

        // Count padding bytes
        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

        // Pad
        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
    },

    unpad: function unpad(data) {
        // Get number of padding bytes from last byte
        var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;

        // Remove padding
        data.sigBytes -= nPaddingBytes;
    }
};

/**
 * ISO/IEC 9797-1 Padding Method 2.
 */
CryptoJS.pad.Iso97971 = {
    pad: function pad(data, blockSize) {
        // Add 0x80 byte
        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

        // Zero pad the rest
        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
    },

    unpad: function unpad(data) {
        // Remove zero padding
        CryptoJS.pad.ZeroPadding.unpad(data);

        // Remove one more byte -- the 0x80 byte
        data.sigBytes--;
    }
};

/**
 * Output Feedback block mode.
 */
CryptoJS.mode.OFB = function () {
    var OFB = CryptoJS.lib.BlockCipherMode.extend();

    var Encryptor = OFB.Encryptor = OFB.extend({
        processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var keystream = this._keystream;

            // Generate keystream
            if (iv) {
                keystream = this._keystream = iv.slice(0);

                // Remove IV for subsequent blocks
                this._iv = undefined;
            }
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
                words[offset + i] ^= keystream[i];
            }
        }
    });

    OFB.Decryptor = Encryptor;

    return OFB;
}();

/**
 * A noop padding strategy.
 */
CryptoJS.pad.NoPadding = {
    pad: function pad() {},

    unpad: function unpad() {}
};

(function (undefined) {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var CipherParams = C_lib.CipherParams;
    var C_enc = C.enc;
    var Hex = C_enc.Hex;
    var C_format = C.format;

    var HexFormatter = C_format.Hex = {
        /**
         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
         *
         * @param {CipherParams} cipherParams The cipher params object.
         *
         * @return {string} The hexadecimally encoded string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
         */
        stringify: function stringify(cipherParams) {
            return cipherParams.ciphertext.toString(Hex);
        },

        /**
         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
         *
         * @param {string} input The hexadecimally encoded string.
         *
         * @return {CipherParams} The cipher params object.
         *
         * @static
         *
         * @example
         *
         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
         */
        parse: function parse(input) {
            var ciphertext = Hex.parse(input);
            return CipherParams.create({
                ciphertext: ciphertext
            });
        }
    };
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var BlockCipher = C_lib.BlockCipher;
    var C_algo = C.algo;

    // Lookup tables
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX_0 = [];
    var SUB_MIX_1 = [];
    var SUB_MIX_2 = [];
    var SUB_MIX_3 = [];
    var INV_SUB_MIX_0 = [];
    var INV_SUB_MIX_1 = [];
    var INV_SUB_MIX_2 = [];
    var INV_SUB_MIX_3 = [];

    // Compute lookup tables
    (function () {
        // Compute double table
        var d = [];
        for (var i = 0; i < 256; i++) {
            if (i < 128) {
                d[i] = i << 1;
            } else {
                d[i] = i << 1 ^ 0x11b;
            }
        }

        // Walk GF(2^8)
        var x = 0;
        var xi = 0;
        for (var i = 0; i < 256; i++) {
            // Compute sbox
            var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;

            // Compute multiplication
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];

            // Compute sub bytes, mix columns tables
            var t = d[sx] * 0x101 ^ sx * 0x1010100;
            SUB_MIX_0[x] = t << 24 | t >>> 8;
            SUB_MIX_1[x] = t << 16 | t >>> 16;
            SUB_MIX_2[x] = t << 8 | t >>> 24;
            SUB_MIX_3[x] = t;

            // Compute inv sub bytes, inv mix columns tables
            var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
            INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
            INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
            INV_SUB_MIX_3[sx] = t;

            // Compute next counter
            if (!x) {
                x = xi = 1;
            } else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    })();

    // Precomputed Rcon lookup
    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

    /**
     * AES block cipher algorithm.
     */
    var AES = C_algo.AES = BlockCipher.extend({
        _doReset: function _doReset() {
            var t;

            // Skip reset of nRounds has been set before and key did not change
            if (this._nRounds && this._keyPriorReset === this._key) {
                return;
            }

            // Shortcuts
            var key = this._keyPriorReset = this._key;
            var keyWords = key.words;
            var keySize = key.sigBytes / 4;

            // Compute number of rounds
            var nRounds = this._nRounds = keySize + 6;

            // Compute number of key schedule rows
            var ksRows = (nRounds + 1) * 4;

            // Compute key schedule
            var keySchedule = this._keySchedule = [];
            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
                if (ksRow < keySize) {
                    keySchedule[ksRow] = keyWords[ksRow];
                } else {
                    t = keySchedule[ksRow - 1];

                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;

                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];

                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) {
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    }

                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
            }

            // Compute inv key schedule
            var invKeySchedule = this._invKeySchedule = [];
            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
                var ksRow = ksRows - invKsRow;

                if (invKsRow % 4) {
                    var t = keySchedule[ksRow];
                } else {
                    var t = keySchedule[ksRow - 4];
                }

                if (invKsRow < 4 || ksRow <= 4) {
                    invKeySchedule[invKsRow] = t;
                } else {
                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            }
        },

        encryptBlock: function encryptBlock(M, offset) {
            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
        },

        decryptBlock: function decryptBlock(M, offset) {
            // Swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;

            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

            // Inv swap 2nd and 4th rows
            var t = M[offset + 1];
            M[offset + 1] = M[offset + 3];
            M[offset + 3] = t;
        },

        _doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
            // Shortcut
            var nRounds = this._nRounds;

            // Get input, add round key
            var s0 = M[offset] ^ keySchedule[0];
            var s1 = M[offset + 1] ^ keySchedule[1];
            var s2 = M[offset + 2] ^ keySchedule[2];
            var s3 = M[offset + 3] ^ keySchedule[3];

            // Key schedule row counter
            var ksRow = 4;

            // Rounds
            for (var round = 1; round < nRounds; round++) {
                // Shift rows, sub bytes, mix columns, add round key
                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
            }

            // Shift rows, sub bytes, add round key
            var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
            var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
            var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
            var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

            // Set output
            M[offset] = t0;
            M[offset + 1] = t1;
            M[offset + 2] = t2;
            M[offset + 3] = t3;
        },

        keySize: 256 / 32
    });

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
     */
    C.AES = BlockCipher._createHelper(AES);
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var WordArray = C_lib.WordArray;
    var BlockCipher = C_lib.BlockCipher;
    var C_algo = C.algo;

    // Permuted Choice 1 constants
    var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4];

    // Permuted Choice 2 constants
    var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32];

    // Cumulative bit shift constants
    var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

    // SBOXes and round permutation constants
    var SBOX_P = [{
        0x0: 0x808200,
        0x10000000: 0x8000,
        0x20000000: 0x808002,
        0x30000000: 0x2,
        0x40000000: 0x200,
        0x50000000: 0x808202,
        0x60000000: 0x800202,
        0x70000000: 0x800000,
        0x80000000: 0x202,
        0x90000000: 0x800200,
        0xa0000000: 0x8200,
        0xb0000000: 0x808000,
        0xc0000000: 0x8002,
        0xd0000000: 0x800002,
        0xe0000000: 0x0,
        0xf0000000: 0x8202,
        0x8000000: 0x0,
        0x18000000: 0x808202,
        0x28000000: 0x8202,
        0x38000000: 0x8000,
        0x48000000: 0x808200,
        0x58000000: 0x200,
        0x68000000: 0x808002,
        0x78000000: 0x2,
        0x88000000: 0x800200,
        0x98000000: 0x8200,
        0xa8000000: 0x808000,
        0xb8000000: 0x800202,
        0xc8000000: 0x800002,
        0xd8000000: 0x8002,
        0xe8000000: 0x202,
        0xf8000000: 0x800000,
        0x1: 0x8000,
        0x10000001: 0x2,
        0x20000001: 0x808200,
        0x30000001: 0x800000,
        0x40000001: 0x808002,
        0x50000001: 0x8200,
        0x60000001: 0x200,
        0x70000001: 0x800202,
        0x80000001: 0x808202,
        0x90000001: 0x808000,
        0xa0000001: 0x800002,
        0xb0000001: 0x8202,
        0xc0000001: 0x202,
        0xd0000001: 0x800200,
        0xe0000001: 0x8002,
        0xf0000001: 0x0,
        0x8000001: 0x808202,
        0x18000001: 0x808000,
        0x28000001: 0x800000,
        0x38000001: 0x200,
        0x48000001: 0x8000,
        0x58000001: 0x800002,
        0x68000001: 0x2,
        0x78000001: 0x8202,
        0x88000001: 0x8002,
        0x98000001: 0x800202,
        0xa8000001: 0x202,
        0xb8000001: 0x808200,
        0xc8000001: 0x800200,
        0xd8000001: 0x0,
        0xe8000001: 0x8200,
        0xf8000001: 0x808002
    }, {
        0x0: 0x40084010,
        0x1000000: 0x4000,
        0x2000000: 0x80000,
        0x3000000: 0x40080010,
        0x4000000: 0x40000010,
        0x5000000: 0x40084000,
        0x6000000: 0x40004000,
        0x7000000: 0x10,
        0x8000000: 0x84000,
        0x9000000: 0x40004010,
        0xa000000: 0x40000000,
        0xb000000: 0x84010,
        0xc000000: 0x80010,
        0xd000000: 0x0,
        0xe000000: 0x4010,
        0xf000000: 0x40080000,
        0x800000: 0x40004000,
        0x1800000: 0x84010,
        0x2800000: 0x10,
        0x3800000: 0x40004010,
        0x4800000: 0x40084010,
        0x5800000: 0x40000000,
        0x6800000: 0x80000,
        0x7800000: 0x40080010,
        0x8800000: 0x80010,
        0x9800000: 0x0,
        0xa800000: 0x4000,
        0xb800000: 0x40080000,
        0xc800000: 0x40000010,
        0xd800000: 0x84000,
        0xe800000: 0x40084000,
        0xf800000: 0x4010,
        0x10000000: 0x0,
        0x11000000: 0x40080010,
        0x12000000: 0x40004010,
        0x13000000: 0x40084000,
        0x14000000: 0x40080000,
        0x15000000: 0x10,
        0x16000000: 0x84010,
        0x17000000: 0x4000,
        0x18000000: 0x4010,
        0x19000000: 0x80000,
        0x1a000000: 0x80010,
        0x1b000000: 0x40000010,
        0x1c000000: 0x84000,
        0x1d000000: 0x40004000,
        0x1e000000: 0x40000000,
        0x1f000000: 0x40084010,
        0x10800000: 0x84010,
        0x11800000: 0x80000,
        0x12800000: 0x40080000,
        0x13800000: 0x4000,
        0x14800000: 0x40004000,
        0x15800000: 0x40084010,
        0x16800000: 0x10,
        0x17800000: 0x40000000,
        0x18800000: 0x40084000,
        0x19800000: 0x40000010,
        0x1a800000: 0x40004010,
        0x1b800000: 0x80010,
        0x1c800000: 0x0,
        0x1d800000: 0x4010,
        0x1e800000: 0x40080010,
        0x1f800000: 0x84000
    }, {
        0x0: 0x104,
        0x100000: 0x0,
        0x200000: 0x4000100,
        0x300000: 0x10104,
        0x400000: 0x10004,
        0x500000: 0x4000004,
        0x600000: 0x4010104,
        0x700000: 0x4010000,
        0x800000: 0x4000000,
        0x900000: 0x4010100,
        0xa00000: 0x10100,
        0xb00000: 0x4010004,
        0xc00000: 0x4000104,
        0xd00000: 0x10000,
        0xe00000: 0x4,
        0xf00000: 0x100,
        0x80000: 0x4010100,
        0x180000: 0x4010004,
        0x280000: 0x0,
        0x380000: 0x4000100,
        0x480000: 0x4000004,
        0x580000: 0x10000,
        0x680000: 0x10004,
        0x780000: 0x104,
        0x880000: 0x4,
        0x980000: 0x100,
        0xa80000: 0x4010000,
        0xb80000: 0x10104,
        0xc80000: 0x10100,
        0xd80000: 0x4000104,
        0xe80000: 0x4010104,
        0xf80000: 0x4000000,
        0x1000000: 0x4010100,
        0x1100000: 0x10004,
        0x1200000: 0x10000,
        0x1300000: 0x4000100,
        0x1400000: 0x100,
        0x1500000: 0x4010104,
        0x1600000: 0x4000004,
        0x1700000: 0x0,
        0x1800000: 0x4000104,
        0x1900000: 0x4000000,
        0x1a00000: 0x4,
        0x1b00000: 0x10100,
        0x1c00000: 0x4010000,
        0x1d00000: 0x104,
        0x1e00000: 0x10104,
        0x1f00000: 0x4010004,
        0x1080000: 0x4000000,
        0x1180000: 0x104,
        0x1280000: 0x4010100,
        0x1380000: 0x0,
        0x1480000: 0x10004,
        0x1580000: 0x4000100,
        0x1680000: 0x100,
        0x1780000: 0x4010004,
        0x1880000: 0x10000,
        0x1980000: 0x4010104,
        0x1a80000: 0x10104,
        0x1b80000: 0x4000004,
        0x1c80000: 0x4000104,
        0x1d80000: 0x4010000,
        0x1e80000: 0x4,
        0x1f80000: 0x10100
    }, {
        0x0: 0x80401000,
        0x10000: 0x80001040,
        0x20000: 0x401040,
        0x30000: 0x80400000,
        0x40000: 0x0,
        0x50000: 0x401000,
        0x60000: 0x80000040,
        0x70000: 0x400040,
        0x80000: 0x80000000,
        0x90000: 0x400000,
        0xa0000: 0x40,
        0xb0000: 0x80001000,
        0xc0000: 0x80400040,
        0xd0000: 0x1040,
        0xe0000: 0x1000,
        0xf0000: 0x80401040,
        0x8000: 0x80001040,
        0x18000: 0x40,
        0x28000: 0x80400040,
        0x38000: 0x80001000,
        0x48000: 0x401000,
        0x58000: 0x80401040,
        0x68000: 0x0,
        0x78000: 0x80400000,
        0x88000: 0x1000,
        0x98000: 0x80401000,
        0xa8000: 0x400000,
        0xb8000: 0x1040,
        0xc8000: 0x80000000,
        0xd8000: 0x400040,
        0xe8000: 0x401040,
        0xf8000: 0x80000040,
        0x100000: 0x400040,
        0x110000: 0x401000,
        0x120000: 0x80000040,
        0x130000: 0x0,
        0x140000: 0x1040,
        0x150000: 0x80400040,
        0x160000: 0x80401000,
        0x170000: 0x80001040,
        0x180000: 0x80401040,
        0x190000: 0x80000000,
        0x1a0000: 0x80400000,
        0x1b0000: 0x401040,
        0x1c0000: 0x80001000,
        0x1d0000: 0x400000,
        0x1e0000: 0x40,
        0x1f0000: 0x1000,
        0x108000: 0x80400000,
        0x118000: 0x80401040,
        0x128000: 0x0,
        0x138000: 0x401000,
        0x148000: 0x400040,
        0x158000: 0x80000000,
        0x168000: 0x80001040,
        0x178000: 0x40,
        0x188000: 0x80000040,
        0x198000: 0x1000,
        0x1a8000: 0x80001000,
        0x1b8000: 0x80400040,
        0x1c8000: 0x1040,
        0x1d8000: 0x80401000,
        0x1e8000: 0x400000,
        0x1f8000: 0x401040
    }, {
        0x0: 0x80,
        0x1000: 0x1040000,
        0x2000: 0x40000,
        0x3000: 0x20000000,
        0x4000: 0x20040080,
        0x5000: 0x1000080,
        0x6000: 0x21000080,
        0x7000: 0x40080,
        0x8000: 0x1000000,
        0x9000: 0x20040000,
        0xa000: 0x20000080,
        0xb000: 0x21040080,
        0xc000: 0x21040000,
        0xd000: 0x0,
        0xe000: 0x1040080,
        0xf000: 0x21000000,
        0x800: 0x1040080,
        0x1800: 0x21000080,
        0x2800: 0x80,
        0x3800: 0x1040000,
        0x4800: 0x40000,
        0x5800: 0x20040080,
        0x6800: 0x21040000,
        0x7800: 0x20000000,
        0x8800: 0x20040000,
        0x9800: 0x0,
        0xa800: 0x21040080,
        0xb800: 0x1000080,
        0xc800: 0x20000080,
        0xd800: 0x21000000,
        0xe800: 0x1000000,
        0xf800: 0x40080,
        0x10000: 0x40000,
        0x11000: 0x80,
        0x12000: 0x20000000,
        0x13000: 0x21000080,
        0x14000: 0x1000080,
        0x15000: 0x21040000,
        0x16000: 0x20040080,
        0x17000: 0x1000000,
        0x18000: 0x21040080,
        0x19000: 0x21000000,
        0x1a000: 0x1040000,
        0x1b000: 0x20040000,
        0x1c000: 0x40080,
        0x1d000: 0x20000080,
        0x1e000: 0x0,
        0x1f000: 0x1040080,
        0x10800: 0x21000080,
        0x11800: 0x1000000,
        0x12800: 0x1040000,
        0x13800: 0x20040080,
        0x14800: 0x20000000,
        0x15800: 0x1040080,
        0x16800: 0x80,
        0x17800: 0x21040000,
        0x18800: 0x40080,
        0x19800: 0x21040080,
        0x1a800: 0x0,
        0x1b800: 0x21000000,
        0x1c800: 0x1000080,
        0x1d800: 0x40000,
        0x1e800: 0x20040000,
        0x1f800: 0x20000080
    }, {
        0x0: 0x10000008,
        0x100: 0x2000,
        0x200: 0x10200000,
        0x300: 0x10202008,
        0x400: 0x10002000,
        0x500: 0x200000,
        0x600: 0x200008,
        0x700: 0x10000000,
        0x800: 0x0,
        0x900: 0x10002008,
        0xa00: 0x202000,
        0xb00: 0x8,
        0xc00: 0x10200008,
        0xd00: 0x202008,
        0xe00: 0x2008,
        0xf00: 0x10202000,
        0x80: 0x10200000,
        0x180: 0x10202008,
        0x280: 0x8,
        0x380: 0x200000,
        0x480: 0x202008,
        0x580: 0x10000008,
        0x680: 0x10002000,
        0x780: 0x2008,
        0x880: 0x200008,
        0x980: 0x2000,
        0xa80: 0x10002008,
        0xb80: 0x10200008,
        0xc80: 0x0,
        0xd80: 0x10202000,
        0xe80: 0x202000,
        0xf80: 0x10000000,
        0x1000: 0x10002000,
        0x1100: 0x10200008,
        0x1200: 0x10202008,
        0x1300: 0x2008,
        0x1400: 0x200000,
        0x1500: 0x10000000,
        0x1600: 0x10000008,
        0x1700: 0x202000,
        0x1800: 0x202008,
        0x1900: 0x0,
        0x1a00: 0x8,
        0x1b00: 0x10200000,
        0x1c00: 0x2000,
        0x1d00: 0x10002008,
        0x1e00: 0x10202000,
        0x1f00: 0x200008,
        0x1080: 0x8,
        0x1180: 0x202000,
        0x1280: 0x200000,
        0x1380: 0x10000008,
        0x1480: 0x10002000,
        0x1580: 0x2008,
        0x1680: 0x10202008,
        0x1780: 0x10200000,
        0x1880: 0x10202000,
        0x1980: 0x10200008,
        0x1a80: 0x2000,
        0x1b80: 0x202008,
        0x1c80: 0x200008,
        0x1d80: 0x0,
        0x1e80: 0x10000000,
        0x1f80: 0x10002008
    }, {
        0x0: 0x100000,
        0x10: 0x2000401,
        0x20: 0x400,
        0x30: 0x100401,
        0x40: 0x2100401,
        0x50: 0x0,
        0x60: 0x1,
        0x70: 0x2100001,
        0x80: 0x2000400,
        0x90: 0x100001,
        0xa0: 0x2000001,
        0xb0: 0x2100400,
        0xc0: 0x2100000,
        0xd0: 0x401,
        0xe0: 0x100400,
        0xf0: 0x2000000,
        0x8: 0x2100001,
        0x18: 0x0,
        0x28: 0x2000401,
        0x38: 0x2100400,
        0x48: 0x100000,
        0x58: 0x2000001,
        0x68: 0x2000000,
        0x78: 0x401,
        0x88: 0x100401,
        0x98: 0x2000400,
        0xa8: 0x2100000,
        0xb8: 0x100001,
        0xc8: 0x400,
        0xd8: 0x2100401,
        0xe8: 0x1,
        0xf8: 0x100400,
        0x100: 0x2000000,
        0x110: 0x100000,
        0x120: 0x2000401,
        0x130: 0x2100001,
        0x140: 0x100001,
        0x150: 0x2000400,
        0x160: 0x2100400,
        0x170: 0x100401,
        0x180: 0x401,
        0x190: 0x2100401,
        0x1a0: 0x100400,
        0x1b0: 0x1,
        0x1c0: 0x0,
        0x1d0: 0x2100000,
        0x1e0: 0x2000001,
        0x1f0: 0x400,
        0x108: 0x100400,
        0x118: 0x2000401,
        0x128: 0x2100001,
        0x138: 0x1,
        0x148: 0x2000000,
        0x158: 0x100000,
        0x168: 0x401,
        0x178: 0x2100400,
        0x188: 0x2000001,
        0x198: 0x2100000,
        0x1a8: 0x0,
        0x1b8: 0x2100401,
        0x1c8: 0x100401,
        0x1d8: 0x400,
        0x1e8: 0x2000400,
        0x1f8: 0x100001
    }, {
        0x0: 0x8000820,
        0x1: 0x20000,
        0x2: 0x8000000,
        0x3: 0x20,
        0x4: 0x20020,
        0x5: 0x8020820,
        0x6: 0x8020800,
        0x7: 0x800,
        0x8: 0x8020000,
        0x9: 0x8000800,
        0xa: 0x20800,
        0xb: 0x8020020,
        0xc: 0x820,
        0xd: 0x0,
        0xe: 0x8000020,
        0xf: 0x20820,
        0x80000000: 0x800,
        0x80000001: 0x8020820,
        0x80000002: 0x8000820,
        0x80000003: 0x8000000,
        0x80000004: 0x8020000,
        0x80000005: 0x20800,
        0x80000006: 0x20820,
        0x80000007: 0x20,
        0x80000008: 0x8000020,
        0x80000009: 0x820,
        0x8000000a: 0x20020,
        0x8000000b: 0x8020800,
        0x8000000c: 0x0,
        0x8000000d: 0x8020020,
        0x8000000e: 0x8000800,
        0x8000000f: 0x20000,
        0x10: 0x20820,
        0x11: 0x8020800,
        0x12: 0x20,
        0x13: 0x800,
        0x14: 0x8000800,
        0x15: 0x8000020,
        0x16: 0x8020020,
        0x17: 0x20000,
        0x18: 0x0,
        0x19: 0x20020,
        0x1a: 0x8020000,
        0x1b: 0x8000820,
        0x1c: 0x8020820,
        0x1d: 0x20800,
        0x1e: 0x820,
        0x1f: 0x8000000,
        0x80000010: 0x20000,
        0x80000011: 0x800,
        0x80000012: 0x8020020,
        0x80000013: 0x20820,
        0x80000014: 0x20,
        0x80000015: 0x8020000,
        0x80000016: 0x8000000,
        0x80000017: 0x8000820,
        0x80000018: 0x8020820,
        0x80000019: 0x8000020,
        0x8000001a: 0x8000800,
        0x8000001b: 0x0,
        0x8000001c: 0x20800,
        0x8000001d: 0x820,
        0x8000001e: 0x20020,
        0x8000001f: 0x8020800
    }];

    // Masks that select the SBOX input
    var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];

    /**
     * DES block cipher algorithm.
     */
    var DES = C_algo.DES = BlockCipher.extend({
        _doReset: function _doReset() {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;

            // Select 56 bits according to PC1
            var keyBits = [];
            for (var i = 0; i < 56; i++) {
                var keyBitPos = PC1[i] - 1;
                keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
            }

            // Assemble 16 subkeys
            var subKeys = this._subKeys = [];
            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
                // Create subkey
                var subKey = subKeys[nSubKey] = [];

                // Shortcut
                var bitShift = BIT_SHIFTS[nSubKey];

                // Select 48 bits according to PC2
                for (var i = 0; i < 24; i++) {
                    // Select from the left 28 key bits
                    subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;

                    // Select from the right 28 key bits
                    subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                }

                // Since each subkey is applied to an expanded 32-bit input,
                // the subkey can be broken into 8 values scaled to 32-bits,
                // which allows the key to be used without expansion
                subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                for (var i = 1; i < 7; i++) {
                    subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                }
                subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
            }

            // Compute inverse subkeys
            var invSubKeys = this._invSubKeys = [];
            for (var i = 0; i < 16; i++) {
                invSubKeys[i] = subKeys[15 - i];
            }
        },

        encryptBlock: function encryptBlock(M, offset) {
            this._doCryptBlock(M, offset, this._subKeys);
        },

        decryptBlock: function decryptBlock(M, offset) {
            this._doCryptBlock(M, offset, this._invSubKeys);
        },

        _doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
            // Get input
            this._lBlock = M[offset];
            this._rBlock = M[offset + 1];

            // Initial permutation
            exchangeLR.call(this, 4, 0x0f0f0f0f);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeRL.call(this, 2, 0x33333333);
            exchangeRL.call(this, 8, 0x00ff00ff);
            exchangeLR.call(this, 1, 0x55555555);

            // Rounds
            for (var round = 0; round < 16; round++) {
                // Shortcuts
                var subKey = subKeys[round];
                var lBlock = this._lBlock;
                var rBlock = this._rBlock;

                // Feistel function
                var f = 0;
                for (var i = 0; i < 8; i++) {
                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                }
                this._lBlock = rBlock;
                this._rBlock = lBlock ^ f;
            }

            // Undo swap from last round
            var t = this._lBlock;
            this._lBlock = this._rBlock;
            this._rBlock = t;

            // Final permutation
            exchangeLR.call(this, 1, 0x55555555);
            exchangeRL.call(this, 8, 0x00ff00ff);
            exchangeRL.call(this, 2, 0x33333333);
            exchangeLR.call(this, 16, 0x0000ffff);
            exchangeLR.call(this, 4, 0x0f0f0f0f);

            // Set output
            M[offset] = this._lBlock;
            M[offset + 1] = this._rBlock;
        },

        keySize: 64 / 32,

        ivSize: 64 / 32,

        blockSize: 64 / 32
    });

    // Swap bits across the left and right words
    function exchangeLR(offset, mask) {
        var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
        this._rBlock ^= t;
        this._lBlock ^= t << offset;
    }

    function exchangeRL(offset, mask) {
        var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
        this._lBlock ^= t;
        this._rBlock ^= t << offset;
    }

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
     */
    C.DES = BlockCipher._createHelper(DES);

    /**
     * Triple-DES block cipher algorithm.
     */
    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
        _doReset: function _doReset() {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;
            // Make sure the key length is valid (64, 128 or >= 192 bit)
            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
            }

            // Extend the key according to the keying options defined in 3DES standard
            var key1 = keyWords.slice(0, 2);
            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

            // Create DES instances
            this._des1 = DES.createEncryptor(WordArray.create(key1));
            this._des2 = DES.createEncryptor(WordArray.create(key2));
            this._des3 = DES.createEncryptor(WordArray.create(key3));
        },

        encryptBlock: function encryptBlock(M, offset) {
            this._des1.encryptBlock(M, offset);
            this._des2.decryptBlock(M, offset);
            this._des3.encryptBlock(M, offset);
        },

        decryptBlock: function decryptBlock(M, offset) {
            this._des3.decryptBlock(M, offset);
            this._des2.encryptBlock(M, offset);
            this._des1.decryptBlock(M, offset);
        },

        keySize: 192 / 32,

        ivSize: 64 / 32,

        blockSize: 64 / 32
    });

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
     */
    C.TripleDES = BlockCipher._createHelper(TripleDES);
})();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo;

    /**
     * RC4 stream cipher algorithm.
     */
    var RC4 = C_algo.RC4 = StreamCipher.extend({
        _doReset: function _doReset() {
            // Shortcuts
            var key = this._key;
            var keyWords = key.words;
            var keySigBytes = key.sigBytes;

            // Init sbox
            var S = this._S = [];
            for (var i = 0; i < 256; i++) {
                S[i] = i;
            }

            // Key setup
            for (var i = 0, j = 0; i < 256; i++) {
                var keyByteIndex = i % keySigBytes;
                var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;

                j = (j + S[i] + keyByte) % 256;

                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
            }

            // Counters
            this._i = this._j = 0;
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            M[offset] ^= generateKeystreamWord.call(this);
        },

        keySize: 256 / 32,

        ivSize: 0
    });

    function generateKeystreamWord() {
        // Shortcuts
        var S = this._S;
        var i = this._i;
        var j = this._j;

        // Generate keystream word
        var keystreamWord = 0;
        for (var n = 0; n < 4; n++) {
            i = (i + 1) % 256;
            j = (j + S[i]) % 256;

            // Swap
            var t = S[i];
            S[i] = S[j];
            S[j] = t;

            keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
        }

        // Update counters
        this._i = i;
        this._j = j;

        return keystreamWord;
    }

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
     */
    C.RC4 = StreamCipher._createHelper(RC4);

    /**
     * Modified RC4 stream cipher algorithm.
     */
    var RC4Drop = C_algo.RC4Drop = RC4.extend({
        /**
         * Configuration options.
         *
         * @property {number} drop The number of keystream words to drop. Default 192
         */
        cfg: RC4.cfg.extend({
            drop: 192
        }),

        _doReset: function _doReset() {
            RC4._doReset.call(this);

            // Drop
            for (var i = this.cfg.drop; i > 0; i--) {
                generateKeystreamWord.call(this);
            }
        }
    });

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
     */
    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
})();

/** @preserve
 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
 * derived from CryptoJS.mode.CTR
 * Jan Hruby jhruby.web@gmail.com
 */
CryptoJS.mode.CTRGladman = function () {
    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

    function incWord(word) {
        if ((word >> 24 & 0xff) === 0xff) {
            //overflow
            var b1 = word >> 16 & 0xff;
            var b2 = word >> 8 & 0xff;
            var b3 = word & 0xff;

            if (b1 === 0xff) // overflow b1
                {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) {
                            b3 = 0;
                        } else {
                            ++b3;
                        }
                    } else {
                        ++b2;
                    }
                } else {
                ++b1;
            }

            word = 0;
            word += b1 << 16;
            word += b2 << 8;
            word += b3;
        } else {
            word += 0x01 << 24;
        }
        return word;
    }

    function incCounter(counter) {
        if ((counter[0] = incWord(counter[0])) === 0) {
            // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
        }
        return counter;
    }

    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
        processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
                counter = this._counter = iv.slice(0);

                // Remove IV for subsequent blocks
                this._iv = undefined;
            }

            incCounter(counter);

            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
                words[offset + i] ^= keystream[i];
            }
        }
    });

    CTRGladman.Decryptor = Encryptor;

    return CTRGladman;
}();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo;

    // Reusable objects
    var S = [];
    var C_ = [];
    var G = [];

    /**
     * Rabbit stream cipher algorithm
     */
    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
        _doReset: function _doReset() {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Swap endian
            for (var i = 0; i < 4; i++) {
                K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
            }

            // Generate initial state values
            var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];

            // Generate initial counter values
            var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
                nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
                C[i] ^= X[i + 4 & 7];
            }

            // IV setup
            if (iv) {
                // Shortcuts
                var IV = iv.words;
                var IV_0 = IV[0];
                var IV_1 = IV[1];

                // Generate four subvectors
                var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                var i1 = i0 >>> 16 | i2 & 0xffff0000;
                var i3 = i2 << 16 | i0 & 0x0000ffff;

                // Modify counter values
                C[0] ^= i0;
                C[1] ^= i1;
                C[2] ^= i2;
                C[3] ^= i3;
                C[4] ^= i0;
                C[5] ^= i1;
                C[6] ^= i2;
                C[7] ^= i3;

                // Iterate the system four times
                for (var i = 0; i < 4; i++) {
                    nextState.call(this);
                }
            }
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

            for (var i = 0; i < 4; i++) {
                // Swap endian
                S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;

                // Encrypt
                M[offset + i] ^= S[i];
            }
        },

        blockSize: 128 / 32,

        ivSize: 64 / 32
    });

    function nextState() {
        // Shortcuts
        var X = this._X;
        var C = this._C;

        // Save old counter values
        for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
        }

        // Calculate new counter values
        C[0] = C[0] + 0x4d34d34d + this._b | 0;
        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;

        // Calculate the g-values
        for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
            var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);

            // High XOR low
            G[i] = gh ^ gl;
        }

        // Calculate new state values
        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
    }

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
     */
    C.Rabbit = StreamCipher._createHelper(Rabbit);
})();

/**
 * Counter block mode.
 */
CryptoJS.mode.CTR = function () {
    var CTR = CryptoJS.lib.BlockCipherMode.extend();

    var Encryptor = CTR.Encryptor = CTR.extend({
        processBlock: function processBlock(words, offset) {
            // Shortcuts
            var cipher = this._cipher;
            var blockSize = cipher.blockSize;
            var iv = this._iv;
            var counter = this._counter;

            // Generate keystream
            if (iv) {
                counter = this._counter = iv.slice(0);

                // Remove IV for subsequent blocks
                this._iv = undefined;
            }
            var keystream = counter.slice(0);
            cipher.encryptBlock(keystream, 0);

            // Increment counter
            counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;

            // Encrypt
            for (var i = 0; i < blockSize; i++) {
                words[offset + i] ^= keystream[i];
            }
        }
    });

    CTR.Decryptor = Encryptor;

    return CTR;
}();

(function () {
    // Shortcuts
    var C = CryptoJS;
    var C_lib = C.lib;
    var StreamCipher = C_lib.StreamCipher;
    var C_algo = C.algo;

    // Reusable objects
    var S = [];
    var C_ = [];
    var G = [];

    /**
     * Rabbit stream cipher algorithm.
     *
     * This is a legacy version that neglected to convert the key to little-endian.
     * This error doesn't affect the cipher's security,
     * but it does affect its compatibility with other implementations.
     */
    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
        _doReset: function _doReset() {
            // Shortcuts
            var K = this._key.words;
            var iv = this.cfg.iv;

            // Generate initial state values
            var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];

            // Generate initial counter values
            var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];

            // Carry bit
            this._b = 0;

            // Iterate the system four times
            for (var i = 0; i < 4; i++) {
                nextState.call(this);
            }

            // Modify the counters
            for (var i = 0; i < 8; i++) {
                C[i] ^= X[i + 4 & 7];
            }

            // IV setup
            if (iv) {
                // Shortcuts
                var IV = iv.words;
                var IV_0 = IV[0];
                var IV_1 = IV[1];

                // Generate four subvectors
                var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                var i1 = i0 >>> 16 | i2 & 0xffff0000;
                var i3 = i2 << 16 | i0 & 0x0000ffff;

                // Modify counter values
                C[0] ^= i0;
                C[1] ^= i1;
                C[2] ^= i2;
                C[3] ^= i3;
                C[4] ^= i0;
                C[5] ^= i1;
                C[6] ^= i2;
                C[7] ^= i3;

                // Iterate the system four times
                for (var i = 0; i < 4; i++) {
                    nextState.call(this);
                }
            }
        },

        _doProcessBlock: function _doProcessBlock(M, offset) {
            // Shortcut
            var X = this._X;

            // Iterate the system
            nextState.call(this);

            // Generate four keystream words
            S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
            S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
            S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
            S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;

            for (var i = 0; i < 4; i++) {
                // Swap endian
                S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;

                // Encrypt
                M[offset + i] ^= S[i];
            }
        },

        blockSize: 128 / 32,

        ivSize: 64 / 32
    });

    function nextState() {
        // Shortcuts
        var X = this._X;
        var C = this._C;

        // Save old counter values
        for (var i = 0; i < 8; i++) {
            C_[i] = C[i];
        }

        // Calculate new counter values
        C[0] = C[0] + 0x4d34d34d + this._b | 0;
        C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
        C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
        C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
        C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
        C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
        C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
        C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
        this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;

        // Calculate the g-values
        for (var i = 0; i < 8; i++) {
            var gx = X[i] + C[i];

            // Construct high and low argument for squaring
            var ga = gx & 0xffff;
            var gb = gx >>> 16;

            // Calculate high and low result of squaring
            var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
            var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);

            // High XOR low
            G[i] = gh ^ gl;
        }

        // Calculate new state values
        X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
        X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
        X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
        X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
        X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
        X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
        X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
        X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
    }

    /**
     * Shortcut functions to the cipher's object interface.
     *
     * @example
     *
     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
     */
    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
})();

/**
 * Zero padding strategy.
 */
CryptoJS.pad.ZeroPadding = {
    pad: function pad(data, blockSize) {
        // Shortcut
        var blockSizeBytes = blockSize * 4;

        // Pad
        data.clamp();
        data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
    },

    unpad: function unpad(data) {
        // Shortcut
        var dataWords = data.words;

        // Unpad
        var i = data.sigBytes - 1;
        for (var i = data.sigBytes - 1; i >= 0; i--) {
            if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    }
};
module.exports = CryptoJS;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_style_css__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__store_actions__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole() // 初始化
// 引入vue-amap
// import VueAMap from 'vue-amap'

__webpack_require__(128);
// require('babel-polyfill')

// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';



// Sentry.init({
//   dsn: 'https://c99e69f29e824e499ad6932651b87742@sentry.anlaiye.com/9',
//   integrations: [new Integrations.Vue({Vue, attachProps: true})],
// });



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils = __WEBPACK_IMPORTED_MODULE_5__common_utils__["a" /* default */];
// mint-ui全局引用
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Toast"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$messagebox = __WEBPACK_IMPORTED_MODULE_7_mint_ui__["MessageBox"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$indicator = __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Indicator"];
global.wx = __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ignoredElements = ['wx-open-launch-weapp'];

var screenWidth = window.screen.width;
var fontS = 0;
// 移动端基准值计算（设计稿750px）
if (screenWidth <= 768) {
  fontS = screenWidth / 750 * 100;
}
// PC端适配方案
else {
    fontS = 56; // 固定基准值
  }
var html = document.getElementsByTagName('html')[0];
html.style.fontSize = fontS + 'px';

/* eslint-disable no-new */
var vueMain = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

// 页面标题
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.needRecord) {
    window.appScroll = 0;
    var exposureLog = localStorage.getItem('exposureLog');
    exposureLog = exposureLog ? JSON.parse(exposureLog) : [];
    if (exposureLog.length > 0) {
      var params = {
        logDetails: exposureLog,
        source: 3
      };
      __WEBPACK_IMPORTED_MODULE_9__store_actions__["actions"].postLogAdd(vueMain, params, function (res) {
        if (res.body.message === "Success" && res.body.result) {
          localStorage.setItem('lastLogTime', new Date().getTime());
          localStorage.setItem('exposureLog', JSON.stringify([]));
        }
      }, function () {});
    }
    // if (vuexStore.state.recordPage)
  }
  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('changeRecordState', false);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

// 全局路由守卫
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_7_mint_ui__["MessageBox"].close();
  __WEBPACK_IMPORTED_MODULE_7_mint_ui__["Indicator"].close();
});
/* harmony default export */ __webpack_exports__["default"] = (vueMain);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/mujia/login',
  name: 'mujiaLogin',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(480)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/order',
  name: 'mujiaOrder',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(481)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/scanResult',
  name: 'mujiaScanResult',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(486)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/orderDetail/:id',
  name: 'mujiaOrderDetail',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(482)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/orderDetail1/:id',
  name: 'mujiaOrderDetail1',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(483)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/scanQRCode',
  name: 'mujiaScanCode',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(484)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/mujia/scanQREnter',
  name: 'mujiaScanQREnter',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(485)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Created by xq on 17/12/28.
 */
module.exports = function () {
  var k = 'S7QBZ-3HD37-XIEXQ-PAFUR-KZ6AF-NGFA4'; // 备用：ZCSBZ-TJVKC-E552R-ALVRK-QHAOT-EZFBD
  var mapUrl = "https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=" + k + "&callback=onMapCallback";
  return new Promise(function (resolve) {
    // 地图异步加载回调处理
    window.onMapCallback = function () {
      resolve(TMap);
    };
    var scriptLabel = document.createElement("script");
    scriptLabel.setAttribute("type", "text/javascript");
    scriptLabel.setAttribute("src", mapUrl);
    document.body.appendChild(scriptLabel);
  });
};

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"__npminstall_done":"Fri Jan 14 2022 19:23:06 GMT+0800 (CST)","_from":"elliptic@6.5.4","_resolved":"https://registry.nlark.com/elliptic/download/elliptic-6.5.4.tgz"}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAAXNSR0IArs4c6QAAAPRJREFUOBGd1DEOgjAUBmD6ok7CLVw9gRdwcHBBV0I4gpOJgytnIMwyyODgBTyBiZO3ADcJ+H4HEkJLXnlJA4X3vVIKdZyRobIsmxVFcYT3PC/2ff8jqUVlWW6apjmhcYE7F5qLIBE9OfGLZMYrKaYgCN6Md7ZYYSREkiTbuq4vfDpFXyn14DmvTXNuIZJtcAfa4B6UYi2UYEKSLsIwzPn6npt2qYwQxaIoumqW6oB7gxAJphiEhuWJUWz0y9FCw0idr6gHJaj3qFLUgTaohbboD9M0XVRV9eKO6HcCQhD/g0s+WiHAieu6N94uzujYbFbIHxU/CGfE2OBRtyUAAAAASUVORK5CYII="

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABDpJREFUWAnNmc9LG0EUx7OLhwQDuZQWBJGQnEykiH+ERAq2pVKsh95De1J6kVZt8VKaW+m9h1aKpSKUBv8IkWL0lCAiRCy9BCLJQZJ+v+O87WRjapLubhxY3+zLm/c+82Pnl1aoz7S/v5+wbXu22WxOwcWI8dBjWR7LsnYbjcb2xMREiT/0mqxeChSLxdv1ev0ZoB6gXLqXsrAtAHYrHA6/TyaTv7ot2xXgwcFBFA4XAbaEh/m+EyCreN7BQS6VSlWvc3QtILryIZx8wHPH5ewcgXYA/AP60tDQUBldya4NoetHLi4u2O0J2MzAZhr5Yf5mpDPks+j6b4auLdsREE6tw8PDV5ArzEtJBNwDwJtIJJKPx+N10f9LHh0dhWu1WgYVeAlfk2ILX008a+Pj46+ZF70pncCm8uTkJFKpVD7C2Zzo4eAYzzKcfe7kTGw7SVYUlX4CuY5nTOzgbzMWiz0dHR2tiU6kLRmRdHIFXB4tdhdj5lO/cPTPsvRBX8jnjZhzOmZbg7Up8EGsoCtWpTBkLp1Ov4DDhqH77ywawi4UCm/haFGcYeisogJr8k7ZAsgPAiBf2YraKIdBvGQW8DqPmPyiFSRbGOmR+eEISIhTCVquCGP1tbILUJt7Xrecu4JsScT+DpnRv52hJZOIraYgcwyyFgJ3jHEy7zccgRhDxzrWgGT42+1UcoVADZyuRKHlRCJR0QV8F4zFmBKILGTiu2pBLF/PoVQrBAz3OJWIcVBST197jEcWLqnMK0Ao7vOFCf3fcdK8tPDnLxqmyQVAvIOJ633I4q4Ekh8H03k0Gr0V73KFuCzi3V+uONVq9Tc8yrKYBLQ9KyFQi51BwZGBsckgPGSz0ZRTokCeC/9Ak8lANo5B7jok9bWplMIeSZNhpAWQWyaPgvTtxsXQCij7ub69e1DQxaAAr9yHeRDLCxdNdvGpeMJXY45HUQcqXQynBHTGnd6mBwrkDuZiKLcAwpiT9qCTyVC2MTHuChHyM5IflDQZyGbjq9kWGEyM01xu5D1oydhkkLhks7F75cRY0Mphnr7EIGipY8s6XCAbxyA3jVsCA2oeDZ2dtuj9lozJ2BJHmBQgryOgUFtsGE7yaCiGQUl9HFVnZrKQibEVIO9KoOThRSVArpdKpZi8+y0ZizElDlnk/kYB6h9ykLyO4I52DONhA9L8XZt5KxhDx5KDPBnIopIDoE9RWdCrpQ8FM/rcKra+SMZgLDrXsbNyoqPOAeQLz6MwWmNep0WeW/1oSfo0z8SMx9jmmVjpNIgjUNDCOfULpHkvw6uPea9OehxzuludKQ1wm2i5x7oVHZ6WFlTE6GJe5LCAWAE2A4c/Ab7ACoi+V6krv0Bf9CnlGUvHbNtZdQxGZzf2+k1qRolxcjMvME1I3tvg/WZeAZug+hKdtxA86KfN37rI+3eJflVwdH0g/4b4A1FdVZb4pRNnAAAAAElFTkSuQmCC"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAhlJREFUSA2t189KwzAcB/C1nawHH8LDHmDuXLz4D28WFQ/Dq+AbzNtu2xvoC2zgQHEHwatj7DqYKOgDiODussmY329pStcubdMlkDVNmt/HpGlajQJSo9HYms1me4vFYthsNt9Zpzt1u11rNBq5MIxqtfpgEJ1Op6+o2AT2h3zRarXudMIwbBiPMA4Z1zCMjomKfR9l3QZyu16vn/NER/LRnkAZE2XXLBaLQ5Q5UpEsFLTgIfRABOcRI36x+v3+j+M4nzh3kU02IPHoov5jMBi8eTWKPwnouFQqHXN0BQYngqIWPAXdRfvEg3XiWVB6AawDz4rG4HVwFXQlnAdXRaWwCp4HZXyDP0nJ30zauCa8HuY4r9m23cMGxM0h+pzykfFWryx2KsyOCfgYzdvh4NgcUlFenwnmhRKcTUHKirJDePqCAKsKkk0muFQFZSexRQYBkgq8p2jn9MYS7vMNFtok1iCpyDxisXoRx5HEOlLZ2zPBAo2u3sgfoPRiSZ1qGcp7CvgKmY+WSBxIpldqIpyE8jnFl8otoBqyMi6d6jQU7d5Ckqz21GlfCWdFxfzmwWOwKpoXX4LzonnwAF4XVcU9WBeqghv+F/4TNgfvY1t0Vt17Rb/wUfJimSP2qVUul0+AXoc76EAZL2G175hAljYRXagYiP/vUHSTMc1KpXIPrIMLf3F8TvtyEAFVjsQtyzpDny/kb5Qv/wFYIfemhsxLmwAAAABJRU5ErkJggg=="

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAD1SURBVDgRtdXRbYRAEANQOqGTXDFXbMqghCthMg8FNEF7y4Iuliywx57dL5imaXomX8nv5Jy8Az19e+xbXyKfuCQFrkBeL35p8XrCZngKzAYDkJOPQjdeFxwH9GzYgXm3dxo4LB/OjwZHc/s9zgpn833R8eVd8SuDSzIKafkhCCpEh+Zyl6CgGA3yzW/hka3WUv4tuMmSbC3lm1+CgmJ0aC43BEGFKKQfb/w5/S4ELIhCmg+edBTS/CYMBKKQ5lfQ/Cik+X/AMIhCmt8C3zwKaf4KL4wopPk9mMtFIc3/n++pL/V22n6S0wbhZnrbjvXL//F/1A/f9bRbFixGiAAAAABJRU5ErkJggg=="

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/delivery.83eb07d.png";

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/get-ways.4df3ce1.png";

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABSZJREFUaEPVWV1oHFUUPmdmLYmsFklD1SI0IhQfFGRmstlGJKWiEIP4t/hQS9r0QX3wRcVWLEoo7ZOgFCEVwaYWtCZUK6LBWGQloc0kc0VfqhTMgj+lpYrUJE2anb3HnjgbN3Gyc2d3bqr3beCe73zfveece+dcBA0jk8lYvu/vAoAnAGAWEY+ZpnnEdd0zSbvDpAAty1pnGMY2KWUPANwdhouIE0R0uLGx8djo6OgfSfiuS0AulzMLhcIDANBDRA8DwBoVUog4BwAnWExXV9fJ3t5eqWIXuii1GGaz2TuKxeJOIuoGgA21YJRtEPFnIupHxH7P8ybjYinvgGVZ1wNADhF5te+L60hhPiHi1wDwLhEdF0JcVrCBSAGtra3ZUqnUg4hPEtENKqD1zkHEPwGAE/+w67pj1fBCBWQymfVSyu1BQt5ZL6E67c8YhnHYMIyjruteWI61KKCjoyM1PT3dyQkJAA8RUapOx4maI6IPAJ9xiKXT6c/z+Tx/AwaxvTeI7fWJetUEhogXuIIBwD60bfuToARqcqcPFhE/ZQGXiahRnxt9yIg4yyFUAgBDnxutyJIFkFYXmsH/7wKIc6D4HyqZHA2Rh2vFphZZwCwRNWje6Uh4RPwdADqJ6FU+hyINWGmQxFMAkFYx0DWHySPi/RMTE9/mcrk1k5OTHymKuMQ7cJ6IrtkBVkm+vEAsolAofExEfDOoNs6xgB+J6HZdq1v1Ilax8pXzLMtai4hfEpETYX+Wq9B3K/1B6RQVtvLsT5V8wE2wgBEAuFcn2eXYCZFn2K84hI4T0WMxBFwEgOYY85dMTZA8V6EPWEAfET2jQggR9xPRm6wcAO5SsamckyR5xkXENziEegGAa2/VweQ9z9sbxOm6uCKSJh8I2M078DQRHYrI9kOe5z27rFIoi9BBnrkYhrEdHcfZKqU8GSGAz4otQogf4orQRT4Q0MoCbrv67/uTQgjFFqGTPPNNpVJrkYhYxIzKTw0iKovQTR4AzgkhNizc/Gzb/oaI7onahSBxIkWsAnmmMiyEeLAs4CARPaciQEHEgGEYz/PFbFm+KF0PYnB4xfO8AwsCLMvKAcCAqnE1EWEYMa8HSjRM09w8Pj5+ekEAN7J83z+vZFkxaaWc0LnyAfYMANwkhCgu/v1YlsUtvEySInSsfMDvfSHEtoVIKBN2HGeHlJKbRbFH2E5oJM/lM1vumS4KyGazjfPz87/y1sRW8Pe9ZLE66STPjySe57WWOS75gXYc52Up5YFaBJQT2zTNR0ulEle1qj8jdfjo9DxvKFQAN3inpqZGa8mFWgnFtDsihNhRafOvFobjODdLKU8DwMaY4FqnI+KpdDq9NZ/P8/PU4gjtwbS3t986NzfH2xT6WKeVaTj4F01NTY8PDw9z+VwyVmwiZTKZG33fPwEAW64B4X9WGPEoEe3imh/Go2oXzLKs6xDxNQDYQ0TmagrhphUR7fY8762rHFbs3yq18Wzb5rL1HhFtWiURY6Zpdo+Pj5+N8qckgEGCc+JFAHhJYyfvN0TsbWlp6RscHOS2f+RQFlBGsizrFkTcR0Q7E3xXuIKIfHbsF0JcimQdVYVUAGzb3kREexDxqTq62/wW/E4qlXrddd1fVPwqVyFVsLa2to2+778AAN0x3pEvGobxdkNDw8GRkRHuM9U8YofQSp6CssunJPeYQt+WEZEPyL7m5uaBoaGhKzWzTiKEqjl3HGezlJJz5BEAmEHED1OpVP/Y2Nj3SZCuxPgLGYCP87pEfRkAAAAASUVORK5CYII="

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAANqSURBVEgNnZZNaFNBEMebF9uDje1BvSTYCr20lYIH8SSaHGwPBUXFUoo2pY3Fj5OCUrwYPRRR1JMiJP1IkViLIAoiCkIFLyoIUmw9iGClQVAPhjSHYBp/87ovbF5fXtI+2LezM/+Z2Z3dnVlPTRXfzMyMN5PJ7FtZWQkA9yuVlGEYSz6f721PT0++khlPOUChUPDE4/EOj8dzGboT3AL0In1K6fjhN8FrZ/wSejQSicwxLih5SefoKJlMblteXr4LMkiL1tXVPQuHw0slmmowNjbmZ6WHBUebBXsW7B8lLnZrHImTbDb7DsSDhoaGm4QlU0S7EITXl06nLwLpJ6Tdg4OD8zq8xNH4+Hh7Pp//zPLvEIYLOrBamnCHCeNkfX399r6+vt+WXtFRIpHYmsvlPjCba0NDQ5MWYCM9zm6hd7S2tnaPFUbTETOQjZ9mJV9YyRUn4+zFFnDXkYXom8F+g35EeG8Q3pxdB3tXwbVir1cOiCEAmB10QdkTu4KMlZOPKAZQGqa10y4hOs6+PHbSUbaCynbNJgGhJEc4Wm7jOVUjYH4yuyP01vH9zgQ+IfvK3h5g89/oDsVWLBaLim34vYZcRpx0yhHWgToNuJsW05yYYvYyBW8OZ7t1vEWz30+hu8SHITeewUK5e6KU5JC8twzY+kacZW08cygTYRHz4kNC5wf4wwlo8QjZKYvWe0J3DEPN8J7rfJ3G9iIrDhjcG8ldVlrRMa408T+IgSlAp2XmLmCR+c3D4AJyFLESOeJPCGeEQ/DQEWRjGl6v1/Ro45cdqqOeBDBSpRMzYnKPZMN2lLVsE4DdD2tzS0vLfZvIcQi+iZUvGVJPQLSRgqTWVPzY3J0ovw6FQv8qgZXNNuXDzAzTbO6ZSorrlYtNSW2iZ6YgZjgKHZVUX8nYxMREK5mgqxJO2Yoq26uOuCdzKM6qeuJqg+sQ51i/wFCjG1DZmlW2Vx0R94JURhT7WaqkeLdPctcwuexvORAncwDZCWrSObEtuGI9koEq4b8QDjCThPDW+zHR24TrPNdml15lSxyJUamyhEZSytRGSjlOTrKSvXp1FbtrHAlTVdt7kEGa6+NEjjCV+ZDgaNU/TgCbHzNzem5J8pVMIp88t+SitxHqV9Drf26ZZrSf1BNVTvwqCdeo1JWq9gH5Hz3XqmwIasa1AAAAAElFTkSuQmCC"

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 331 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAiCAYAAAEls7lsAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAAIgAAAAA7iArTAAAB3UlEQVRIDZVWO0oEQRBdV10/ix7AAxiaeQpjQfGHG6wYCAYGgoEg7A3EQBBBUQRBRRA8gaGeQm+gqb639Bu7e6a6ZwaK+rxXNT0901XTav1fGzK/ZLzLkC4QM9DqEJoVntYsNyoKnWk5bRnQP54dmKXVBKicgFXTYe4K5FFFpPswbuiMKAJ9AJkvngPOG2TRZ8AvXcFSYpQgZSwG6AucrAI/HaFbBXJblyBc2wfkG5K8toDydvdJlgP3HPmyDvnIkU9z5AEJlfvgMo+htyFTzi+pQ0T4EGclxAX2HeHCIuw6wrVF6DnCnUVYd4QHi7DsCM8WgXE+xWuKwBf8C1mAzKSIxPQdFafOShDR3GElijihgKVFHLcIiovoHy9hgRax7beOgAFnzgVWY6CJfwKy7rbWJFFcffoqwiOQWrXyCs2Go2Tqc0h2g4psGDqpKsITm30VfoE+HCVT30KyL90vsBkVYIPJfl5+AbZnfwVP8LMfsl+AfVDNkoVeINkj4xeQzSmplfBw1hx+Sg8124C/KraDbkhp5qnxaIVsQI32Kb5dDwEVo2bLq5xEcaLlq7mq6BWIHYtcJ652roJs66kBkq2pAaKCHCTD85ab8VZljqwdDzTHhsdJmgOgw/+3P6z5ce0v8KncAAAAAElFTkSuQmCC"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAA05JREFUWAnNmL9rFEEUx7+zBmORhFwjJBA7kfwDQmLsPDQkjY2VlgqKoiJY2GklIUGPGFALIY2gKCn8CYeGGE/8D0SsVBCxid5ZBBJv/L7Z283+mN3b+8kNzO3uvDfvfW7mzey8VWiwaI0cypiBQp5d97GOQrNKUfjBX6nf2FbEEF4ohQ0RZS0qq6Iu4zh1L7AeprO+TP0Utqm3zrqohrCSpU9dIIIcoqE5QkxmMZioo/CBsqsEKyXqUJAIxKnZhb9YQBUX0ww0LHNQwACucCr/2fpagQgzzDh5zA4SJ50oEl8nCPU7ajwGZGAqHF6N8ahyW58VPmEQk1EoJ+jETJOMTKdhxKn4oC/jMwARAjIx07lpCrj1b/M1n36DP2VmNWm89yXdvFGY8lZfcITmuskQ8eX7NkBm02t1n4l4aOiRvmsbL7wRkh24Y2WNgXDtOrD6LtWFYVCM8hwq+MWoz/Y6SLUZF957AJy9LIvK3YVLRWDiYFyPW/Q2t4G9DpfebDdgBEGgSh8tMK6wT1ic2ls7Qav55uDIeFb6dwMzR70ny5UnCImhMYuopaYkmJWHwPiBVNNjAuSeZVL1sgvTYKbrvxlHHU5sKtDmJlCtZgNqEUaCjEBurFk93rgJDIwAI/uB4lurit/YMoxrSYMb0mf9Bzpaf36B5ntFFoape/qhXz+N60m/u7fCutKHAaxfPrHrR335z2QRoFW/IQC28dU16gHJ1QbVNhjxTRYBWrYBSdv9QvyfB6HaCuMCLYOOTyUBSfvSvB3q/Jl4e1PTJCA79SSfkOMobQUagwrm3gYVnMqmY2YHRKZrS1icWt4kqUpiOXcauDOfnBHIDiybXoZ9JtEHBevCIsteyqJ7Sf4VqKWFOFSbYOIMHLJS2rR5Mpk+9jbVUdDPHoViIDbdXr/UK317Q9HUEVbONW/WgGNHgKkJz1QL18AR1gcSc7qC221PDOtxMnFUg7jkqYWBJFst4xWFeU+hw1dJGKcZzH4WGwIS51x6wzxB9kaiKEAmk2RGyVseNjtWirasVbx5yz7k2UBxKCkthATteBCb7jTF8noxH5uyqE9uB73xOcYC1hsfrGJg7ie92VpyIOdx2ye979w6ZQU9l9dB1Eba83/h/8WQ5i1lygAAAABJRU5ErkJggg=="

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAA4BJREFUWAnNmE1LG1EUhs0kCxGEdiMYsCBkU0jMwq7SdumiVKhFaOmPaEoRXLRd2i4EKeqPKBTELpQu0p2tOxd+QDeCoBChmxYC4iIffd7hnuH6kXa0yTQX9Jy5c+a8T86duXPvpPqu2HZ2dm6mUqmHzWZzAnur1WplsVmlwa/iV7GHQRBUsOtjY2M/ryKRihu8u7v7GIjnxN/nLxPzujpxG8AtFwqF1TjX/BVob2/vLiDz/NpSnITtYqjcJmCz+Xz+W7sY9bcFAiANzAIwL/wEJG5yTsk/0b+VyWSqxFQVQ1+2Xq9r+MbpmyK2RGygc9aIWQRqhnMN6/PtpUAHBwc3arXaR5JNWDAJTvGXBgYGFnK53A/r/5Pd398fOjk5mSGmTK5+iyVXZXBw8Mno6Ogv6zN7AcjBbJLgtgVhV/hlL7kPjry+2C733wgVe88F03YRUN+BKp2HOgMERJqLP1tluAi39aZYLL6zRP9it7e3X5FzjpyhrirFj3yAjYbvzPjqnvFhCHzWKRj9EOVSTv5aOpaWNOVbiyqkp6nRaHy1E9jXnYTx8vapUhy/tb50On3Pnr6oQozxvAVgV7oFIw2Xe8X0fO0QSJMe5QvnGcp5qhvYgrtlpSEt5Ze2GOSHQBBqBra2dN2nyRLEsU5jyWKNIaV3E4SaVzIQN5lnhuPOM5bsutbNU8foqzB19IcC/k0KRkk5sZkUjPSkJU35NBVkMqBU0WzMuOp1kGjzNcWiCo14BFuen5QbaYoloGR6GYZNL0rzk7K+plhUoQiIkiUO5GuKRXd3OI2rIsyY0cydVIXOabY0ZMcmjj9sflLW1xSLhiwaJre4Sool1PE1xaIKHXoE456flHvHhMTCNBB8sQ5usCnzk7JoPjItWCqq0Bod2h30UbKSpnML6LaVljSdTh2W9cDtmzbUSUfg1sDdZgnzS0uaTmxDLOEBpVr2CMpaA3vHXXGdRtmSG0MIxFJgldKFLzmI+xlXLci72qQhLYlIWwzyrVzaU82qw7Vpt8y0445alzvagfjaEZDWtJxYNGWo5yjrUzvulFVO5bZ80rT1tPoiIB24HWVFPuXUHuhDJyulXMqp3NIArCJN+dYuvLt6aqNolD21lTYoyto7HxsMSlYbSB7R//85xoeSz9PRGx+szoO5T3qTVE2f9EYY2ss+6R3xOOuT3tpVP+n9BimhFm1p7Hp1AAAAAElFTkSuQmCC"

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon_content.7252ed1.png";

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAABvCAYAAAAZvqn6AAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAi9SURBVHgB7Z3LjxRFHMe/tct7EUVARNld8YUYg3ox8XkwauLFhIvxxEH9A9RoRA9qSAwGjdGD4cJNTYx60cT4SDRqZiBE8c1Dg2EXVFYRFFjQ5WH7rZkdmOkZpmqW3/T0LN9Kmu6q/vWvqj/9paq6dtI/h1RKfsMAjmIlEtzFUwNw+I/Hu7jfzHwRM1F0C/F76jJlRSCKgKtYJQl6MISnmX+c2/RKecO9ww6KsEgRFrgv4BL86ByPlEQgQKAkuJLYhvE2JbMiYN/4tMM+XruBki0LcBCbKcCxxsYqPZsJlAU3jDUcOFcZghhj7/cFRVikCEub68d+Q/9y1aUEXLIbl+M4trL9U9t2D+Xhdhv9l4dhx3ngAH5uW31ynFsCLhnCWvZEj2XeQocR1llk3QX0ct+PrzkMH8+8HaowUwIu2YlvWePyTGttVJnDERZv4lYoDcN92Ojm4WAjU5V1LwEvuANs/pzc3UJ5Oeb78TfhIqah4C7G7ty1Uw1qiYAXXNPljOQf+uvl1lPec9hTEoHTE3AY5Um/bvsR9+vdILZUG4cFd7janMdeeOPiqxxLgylGypYJ+FEKWIdBPMKO6qgvbF1wZVen/vVqqxYge0MJ8BQeHZGAwycU3d1edF4qZ5b8gHyCm9fvv9zYIybcJ8wnLOeistLZTiDB7RjGix7DmfdwMTCrh2HfA6oLjKE2uWz88OqwfEomd+VHcr+Nr7IlXnBVLyJ+DJYIM3kSnavE/63e4cFsBJe+TT/MppZ4E9/zzUgbKj+pCPAXSGc+h7Mi4ueBSpOdwEB+BDfZUev++AaJ2Z0ZUicK3y8pKuWXwOxw09TDhRnJwpCABGcIU67CBCS4MCNZGBKQ4AxhylWYgAQXZiQLQwISnCFMuQoTkODCjGRhSECCM4QpV2ECElyYkSwMCUhwhjDlKkxAggszkoUhAQnOEKZchQlIcGFGsjAkIMEZwpSrMAEJLsxIFoYEJDhDmHIVJiDBhRnJwpCABGcIU67CBCS4MCNZGBKQ4AxhylWYgAQXZiQLQwISnCFMuQoTkODCjGRhSECCM4QpV2ECElyYkSwMCUhwhjDlKkxAggszkoUhAQnOEKZchQlIcGFGsjAkIMEZwox2NX0ZsKQALGPck4F3+DXQBdGXdruhBNeJJ9j/BtB3M4V2DkOy3AMseqkTrehInRJc1th7zgVmpCJN9d2WdSs6Vp8EF42eX77uPT/a+rSGblr9Kdc8HnL9BekSfiC5Z266MJd5CS7mscy6CbhymHOufcBl3zDQ52DMVdnY9N0JLP0FuHo/cOkGYMqibOqdYC0SXAy4xa8B0/rLljOvBfrf5LH/9n+HU+8FfOl4i/8BLiw3ZNaNwIVrO9yo5tVLcM35UFczKbYltVazbgDOW1lb1oncwmc5zHNOWJ38G3COkwQXejg+nOKRjfVWC9dw3hTxFeX6K21KZlwPzL2/3tfoJ/VlOSqR4GIexsgT9VZTOVda8GR9eVYli15m75t6fCf+Bv7UkJrVI2hfPUc+Aw68Xe9/3iOcP11aX97ukjn3ch3v1vpa/niGgfb+rC/PUUnqv0iOWpa3pow8xnhhPlxiVerhcsaiF6oKIg59mMV0SsbSJafP+zlloxeDse3AvldOf11OzkhwsQ/i2BCHqwbimrOCvc3tsV4o2gMM8/ldrf3hz2vzzXLzH+VLTINlmT0P86pUALNmfjp0ToJrBfze54Bjv9ZfsWBVfVmzkt33Ma5skcPfIeDgu8Ceh5pZnzrnF43ncxhPp0PvAaMfpEtzme+u0EedRpgcBkYorv5Xa1vS6jxubBuw85ZaHzE5/5eO3vNqLZNjFGwDEdZa5SanHq7VR3HgdfYmn9Zedeid2ny7csdHuESzqdb73ucZjfun2rIc57KJCB0JwPUFDPMS3M33NBesLv8RfvRjYC8XYLOaP/mfMvkF3+lLgUPvjy+D+OjHOUizw22Q4MKMZBFLIEJwGlJjYcrOhIAEZ4JRTmIJSHCxpGRnQkCCM8EoJ7EEJLhYUrIzISDBmWCUk1gCElwsKdmZEJDgTDDKSSwBCS6WlOxMCEhwJhjlJJaABBdLSnYmBCQ4E4xyEktAgoslJTsTAhKcCUY5iSUgwcWSkp0JAQnOBKOcxBKQ4GJJyc6EgARnglFOYglIcLGkZGdCQIIzwSgnsQQkuFhSsjMhIMGZYJSTWAISXCwp2ZkQkOBMMMpJLAEJLpaU7EwISHAmGOUkloAEF0tKdiYEJDgTjHISS6C7vg/XwpdJYwHIzpCAV9OM5v7UwzXno7OtEOD3GsHvIzZLElwzOjrXOgF+RRZNPlcnwbWOVFc0I5DwpBed36eTw2g+BOfDVjEgntIkIeA/pt74a6W7OvPS4AXmpe5F5jfmnS9TmjwEfDiKI9xmVd2Sw0fZCK4irsreC6yqHTqcpAQYpgxeYT5ErCvN7Na3R3C+16qIi3v1XuRxtiY/tM7hNhXr3CC2nPlHpX1XVRHXuNDa1nsxPq5SFxKYjj24Bpew4znaeg/nxVUR2Phx2wTWhWzV5CoCju+q0/A9FuAmLzZ/Jiy4irgqvZfUVUVUh3UEvMh6McZOaSvFttpdhZqoKS4Zwl80ScXTqXOTfYGfZCb4gZPNAisvsvEFdxF2Zd8Q1WhJwPdwQ9yus3Q6IV+u9BLt4/oUKbQizsEGNw8HJ+RLF+WWwBQ+3A/Zuk4I7nf2Xl5cBQ7sRSzGVxzn8x9/MbePsjsa5pLduIKPeQubO7VtTfbjOrCdW7E0RPag6Pqxo231yXFuCZReAZJhrOGMiXEZzdIYhfVlaWjsYQ/Wy+FxMbSoYYa3ex2VBeffK4bxFgWyYkK34rB/XFxFXl/AAL7k8Khfr00I5uS+6OQiR5LwRXYIT/F2fU/HYO5NksPPFFiBV5TnYIPYToE1+n1AEyc6dTYSOCm4ys1zTncxh9cHuN3BYbGfMvIrcDt5vJn70hukWwJGilUSgdYJ/A/PWHg0yJwlQwAAAABJRU5ErkJggg=="

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/no-net.afc7f50.png";

/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-coupon-bottom.d2c082a.png";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-coupon-bottom1.39c978a.png";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-coupon-title.9a5768e.png";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/order-coupon-title1.7868f43.png";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qr-mask.74bd325.png";

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAD6SURBVDgRndQxDoIwFAZgSoUTuHACGdGwSnoBExfO4B101tOoR3B1IZGJoRMjg4SwsbTYRywJoWDrS0hp+L++phAsS1QYhmu44F63cBAEhDH25JwfPM9zi6J46GAbIbSUwbZtj2Khs5zPjdj3fdo0DWxz9Q1udTrjPM95FEW3siwDE4yhS5ZlzBR38B/cQ1M8gCZ4BHWxEupgBKG5iuPYpZReRWYnc47jbGw5MR1noaqb+EQvSZK8Jrc6hdI0PcHulPAXUkIdNIK6aABNUA9NUQcJIYuqqu5i0r9gOHJ5ehBSlV3X9V48MEKwkC3+M2+5ok4nme3Gf36PH5h6w/4SSqemAAAAAElFTkSuQmCC"

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAD1SURBVDgRtdXRbYRAEANQOqGTXDFXbMqghCthMg8FNEF7y4Iuliywx57dL5imaXomX8nv5Jy8Az19e+xbXyKfuCQFrkBeL35p8XrCZngKzAYDkJOPQjdeFxwH9GzYgXm3dxo4LB/OjwZHc/s9zgpn833R8eVd8SuDSzIKafkhCCpEh+Zyl6CgGA3yzW/hka3WUv4tuMmSbC3lm1+CgmJ0aC43BEGFKKQfb/w5/S4ELIhCmg+edBTS/CYMBKKQ5lfQ/Cik+X/AMIhCmt8C3zwKaf4KL4wopPk9mMtFIc3/n++pL/V22n6S0wbhZnrbjvXL//F/1A/f9bRbFixGiAAAAABJRU5ErkJggg=="

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAHrSURBVDgRnZW/SwJhGMe9M2kIaki4IRqiIFJoLRsag4ooCPXEpSFuaKsoGiqkQKGlQdcGCSWxoaUgImgIzP4Bl4gaGqJBiRoKvev7SK+c3vueP154ed73+3yfzz3e+6qS438EAoFlwzD2sf3GXMxmsx8s126UqcDv98cAPMdyHNOHeaFpmguxoyEDuILKnYbqqVKptNegtbylTukjWwY638YDRyyJFgSCKgJfN/QjQc5WJuiTjWMpHA732uS5KYJecTMQJUl6TqVSn6K8SCdoAvNXYDgU6LayjPv4Bscpz4XDeuHpzTTq1OFyuaijL4451sl9rULT6fQr3t8GB+orFosnHN1WksxZ3Es6tFmzRms88DiTyWwiGo053r4OGgqF3OVyOQej5dIDmPR4PKuRSKRMIDQwijDg9XrvoOmksVEHJZG+RQDkcEhuZjLFR1mWk7quz0GbJx3eArwaDvye+SxQSgDsg/kG5h5mbBIN+BOKomzF4/EfLpQAqqpOVCqVSyz7mwBraYAfnE7nghBKzmAwOIZurzEHa5XNF/nqlRL5cOIFvMNJ5G9FHo7eZ9spK0CnEv4Z1rGPYtKvl3DgFURbgjICXSMU7eIhKrQupptiHuvptqCsGPAhwNcAn0EcRnxHPMPpH9Dp/wGCZ5BvC/QQiwAAAABJRU5ErkJggg=="

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tag-coupon-expried.436dcb6.png";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tag-coupon-used.72b4626.png";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/view.ec101d3.png";

/***/ }),
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c1ca71e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-147951c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(419),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8b74a622",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(442),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(413),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14864a5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-391fff43",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51c76fa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(414),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-148d4f25",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49b474c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07a8f060",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67ae5772",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4896e1a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8912eb0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45c4701c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(418),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d74dfd3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(425),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36b326af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc6757c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4848aa89",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1173f5d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5393e1cb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fd7f123",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0278fe99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cb06668",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cc2e018",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(449),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d1ca28a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6daf84e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b2a744c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa18a6e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6999806a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c5dc722a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(416),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a36c8c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9d553cee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b662e12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e2b4e44a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed834c44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1797d278",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(459),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d64eca4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e74c9f96",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-890ced60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(120),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("支付成功")]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow suc-btn",
    on: {
      "click": _vm.toOrderDetail
    }
  }, [_vm._v("查看订单")])])
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exp"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.medal,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_vm._v("所需经验" + _vm._s(item.exp))])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list complaints_List feedBack_list"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    class: {
      on: _vm.resultFeedBack == 1
    },
    on: {
      "click": function($event) {
        return _vm.selected('good')
      }
    }
  }, [_c('span', {
    staticClass: "feedBack_con fl"
  }, [_vm._v("满意")]), _c('span', {
    staticClass: "feedBack_icon fr"
  })]), _vm._v(" "), _c('li', {
    class: {
      on: _vm.resultFeedBack == 2
    },
    on: {
      "click": function($event) {
        return _vm.selected('bad')
      }
    }
  }, [_c('span', {
    staticClass: "feedBack_con fl"
  }, [_vm._v("不满意")]), _c('span', {
    staticClass: "feedBack_icon fr"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "feedBack_submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])])
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isWeixin) ? _c('div', {
    staticClass: "alipay"
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPage) ? _c('div', {
    staticClass: "mycoupons"
  }, [_c('div', {
    staticClass: "tabBar fixed"
  }, [_c('div', {
    class: ['fl', {
      active: _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take')
      }
    }
  }, [_c('p', [_vm._v("已领取")])]), _vm._v(" "), _c('div', {
    class: ['fr', {
      active: !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('untake')
      }
    }
  }, [_c('p', [_vm._v("待领取")])])]), _vm._v(" "), _c('div', {
    staticClass: "redeem"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemCode),
      expression: "redeemCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入兑换码"
    },
    domProps: {
      "value": (_vm.redeemCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fr",
    on: {
      "click": function($event) {
        return _vm.redeemCoupon()
      }
    }
  }, [_vm._v("兑换")])]), _vm._v(" "), (_vm.isShow && _vm.couponPackageList.length > 0) ? _c('div', {
    staticClass: "cpackage-list"
  }, _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.package_status === 0 ? item.package_error : item.package_shop_desc))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n            ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(item)
        }
      }
    }, [_vm._v("立即购买")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTake),
      expression: "showTake"
    }]
  }, [(_vm.couponsList.length > 0) ? _c('ul', _vm._l((_vm.couponsList), function(item, index) {
    return _c('li', {
      key: index,
      class: item.coupon_property == 4 ? 'package' : ''
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v("\n          " + _vm._s(item.coupon_property_str) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_image && item.coupon_image.length) ? _c('img', {
      staticStyle: {
        "width": ".8rem",
        "margin-right": ".1rem"
      },
      attrs: {
        "src": item.coupon_image,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "coupon-name-tit ellipses",
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date",
      staticStyle: {
        "margin-top": ".1rem"
      }
    }, [_vm._v("\n                " + _vm._s(item.finished_at) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-colum-se red"
    }, [(item.coupon_type != 5) ? _c('div', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]) : _vm._e(), _vm._v(" "), (item.is_discount == 1 && item.amount == 0) ? _c('span', [_vm._v("全免")]) : _c('span', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (item.is_discount == 1 && item.amount != 0) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.coupon_type != 5) ? _c('div', {
      staticClass: "fs-20 red"
    }, [_vm._v("\n              " + _vm._s(item.use_condition) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "with-top-line flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-ss",
      on: {
        "click": function($event) {
          item.showPackageRule = !item.showPackageRule
        }
      }
    }, [_c('div', {
      class: !item.showPackageRule ? 'ellipses' : '',
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.package_limit || item.description))]), _vm._v(" "), (item.package_rule) ? _c('img', {
      staticStyle: {
        "width": ".2rem",
        "margin": ".1rem 0 0 .1rem"
      },
      attrs: {
        "src": __webpack_require__(115),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "use-btn",
      on: {
        "click": function($event) {
          return _vm.toUseCoupon(item)
        }
      }
    }, [_vm._v("去使用")])]), _vm._v(" "), (item.showPackageRule) ? _c('p', {
      staticClass: "use-rule",
      domProps: {
        "innerHTML": _vm._s(item.package_rule)
      }
    }) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ac",
    staticStyle: {
      "color": "#666",
      "padding": ".6rem"
    },
    on: {
      "click": _vm.toDisableCoupon
    }
  }, [_vm._v("查看无效优惠券 >")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUntake),
      expression: "showUntake"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContent),
      expression: "showContent"
    }]
  }, [(_vm.untakeCouponsList != '') ? _c('ul', _vm._l((_vm.untakeCouponsList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v(_vm._s(item.coupon_property_str))]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_image && item.coupon_image.length) ? _c('img', {
      staticStyle: {
        "width": ".8rem",
        "margin-right": ".1rem"
      },
      attrs: {
        "src": item.coupon_image,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "coupon-name-tit ellipses",
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date",
      staticStyle: {
        "margin-top": ".1rem"
      }
    }, [_vm._v("\n                " + _vm._s(item.coupon_deadline) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-colum-se red"
    }, [(item.coupon_type != 5) ? _c('div', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]) : _vm._e(), _vm._v(" "), (item.is_discount == 1 && item.amount == 0) ? _c('span', [_vm._v("全免")]) : _c('span', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (item.is_discount == 1 && item.amount != 0) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.coupon_type != 5) ? _c('div', {
      staticClass: "fs-20 red"
    }, [_vm._v("\n              " + _vm._s(item.use_condition) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "with-top-line flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-ss",
      on: {
        "click": function($event) {
          item.showPackageRule = !item.showPackageRule
        }
      }
    }, [_c('div', {
      class: !item.showPackageRule ? 'ellipses' : '',
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.package_limit || item.coupon_description))]), _vm._v(" "), (item.package_rule) ? _c('img', {
      staticStyle: {
        "width": ".2rem",
        "margin": ".1rem 0 0 .1rem"
      },
      attrs: {
        "src": __webpack_require__(115),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "use-btn",
      on: {
        "click": function($event) {
          return _vm.receiveCoupon(item)
        }
      }
    }, [_vm._v("领取")])]), _vm._v(" "), (item.showPackageRule) ? _c('p', {
      staticClass: "use-rule",
      domProps: {
        "innerHTML": _vm._s(item.package_rule)
      }
    }) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里没有可用的优惠券")])])
}]}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderInfo) ? _c('div', {
    staticClass: "orderdetails"
  }, [(_vm.orderInfo.source == 'luckSunday' || _vm.showHappySunday) ? _c('div', {
    staticClass: "back-luck-sunday"
  }, [_vm._v("\n      幸福星期天品牌特卖 >\n      "), _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": "gh_3318973708df",
      "path": "happySunday/pages/index/index"
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n          <style>.btn {position: absolute;top:0;left:0;width:100%;height:100%;opacity:0}</style>\n          <button class=\"btn\"></button>\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderStatusTitle) + " >")]), _vm._v(" "), (_vm.orderInfoVisible) ? _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "dialog-order br20"
  }, [(_vm.orderStatus != '') ? _c('ul', {
    staticClass: "main no-foot mydialog"
  }, _vm._l((_vm.orderInfo.flowList), function(item) {
    return _c('li', {
      staticClass: "order-list"
    }, [_c('div', {
      staticClass: "order-cards icon"
    }, [_c('div', {
      staticClass: "cards-first "
    }, [_c('div', {
      staticClass: "cards-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "cards-sec"
    }, [_vm._v("\n                " + _vm._s(item.subTitle) + "\n                "), (item.mobile) ? _c('a', {
      staticClass: "shop-tel-icon",
      staticStyle: {
        "border-left": "none",
        "width": ".4rem",
        "padding-left": ".2rem",
        "margin-left": "0"
      },
      attrs: {
        "href": 'tel:' + item.mobile
      }
    }) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mybnt"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.orderInfoVisible = false
      }
    }
  }, [_vm._v("关 闭")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orderProgress"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderStatusSubTitle))]), _vm._v(" "), (_vm.orderInfo.orderFuncStr) ? _c('div', {
    staticClass: "fs-24 mb20"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderFuncStr))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.beGuaranteed === 1) ? _c('div', {
    staticClass: "fs-20 fw-bold flex-row-sc mb20",
    on: {
      "click": function($event) {
        return _vm.viewPunctual()
      }
    }
  }, [_c('img', {
    staticClass: "mr10",
    staticStyle: {
      "width": ".24rem"
    },
    attrs: {
      "src": __webpack_require__(324)
    }
  }), _vm._v("\n        " + _vm._s(_vm.orderInfo.guaranteeTitle) + "\n        "), _c('div', {
    staticClass: "fs-20 fc-999 ml10 flex-row-sc"
  }, [_vm._v("\n          " + _vm._s(_vm.orderInfo.guaranteeStatusStr) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".1rem"
    },
    attrs: {
      "src": __webpack_require__(314)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progress-contain"
  }, [(_vm.orderStatus == 1000) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.clickHandle(2)
      }
    }
  }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 1000) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderId)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 2002 || _vm.orderStatus == 3001 || _vm.orderStatus == 9000) ? _c('a', {
    staticClass: " btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.moreOrder(_vm.orderId, _vm.orderInfo.supplier_id, _vm.orderInfo.supplier_name)
      }
    }
  }, [_vm._v("再来一单")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderStatus < 3001) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.clickHandle(3)
      }
    }
  }, [_vm._v("确认收货")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.reminderButton == 1) ? _c('a', {
    staticClass: " btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.reminderOrder(_vm.orderId)
      }
    }
  }, [_vm._v("催单")]) : _vm._e(), _vm._v(" "), ((_vm.orderInfo.refundStatus == 1 && !_vm.orderInfo.cancelLeftSeconds) && (_vm.orderStatus == 1001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 3001)) ? _c('a', {
    staticClass: "btn-ellipse moreOrder-padding border",
    on: {
      "click": function($event) {
        return _vm.clickHandle(1)
      }
    }
  }, [_vm._v("申请售后\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEstimated == 1) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.clickHandle(5)
      }
    }
  }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.refundStatus == 3 && (_vm.orderStatus == 3001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 1001)) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.clickHandle(8)
      }
    }
  }, [_vm._v("退款进度")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.cancelLeftSeconds > 0 && (_vm.orderStatus == 1001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 3001)) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.cancelAndRefundOrder(_vm.orderId)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e()])]), _vm._v(" "), (_vm.orderStatus != '') ? _c('div', {
    staticClass: "main no-foot"
  }, [(_vm.orderInfo && _vm.orderInfo.showShopRefund == 1) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家修改了您的退款商品，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.showShopRefund == 2) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家拒绝了该退款申请，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.showShopRefund == 3) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家同意了退款申请，退款金额将在2个工作日左右到账。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.pickUpCode && _vm.orderInfo.orderType == 3 && _vm.orderStatus != 3001) ? _c('div', {
    staticClass: "food-code br20"
  }, [_c('div', {
    staticStyle: {
      "font-size": ".28rem",
      "color": "#4A4A4A"
    }
  }, [_vm._v("堂食取餐码")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code",
    on: {
      "click": function($event) {
        return _vm.toQrCode(_vm.orderInfo.orderShortNumQrCode)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".29rem",
      "height": ".29rem"
    },
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fz-28",
    staticStyle: {
      "color": "#F2596C",
      "margin-left": ".15rem"
    }
  }, [_vm._v("二维码")]), _vm._v(" "), _c('span', {
    staticClass: "qr-line"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C",
      "margin-left": ".32rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.pickUpCode))])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', [_c('div', {
    staticClass: "self-take-addr br20"
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "#787878"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? '自提柜地址' : '自提地点'))]), _vm._v(" "), _c('div', {
    staticClass: "clearflow"
  }, [_c('h3', {
    staticClass: "fl"
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.orderPickUpInfoBean ? _vm.orderInfo.orderPickUpInfoBean.deviceAddress : _vm.orderInfo.pickUpAddr))]), _vm._v(" "), (!_vm.orderInfo.orderPickUpInfoBean) ? _c('span', {
    staticClass: "check-map fr",
    on: {
      "click": _vm.toCheckMap
    }
  }, [_vm._v("查看")]) : _vm._e()])]), _vm._v(" "), (_vm.orderStatus != 3001) ? _c('div', {
    staticClass: "self-take-box br20"
  }, [_c('div', {
    staticClass: "self-take-code",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? '存餐员联系电话' : '商家联系电话'))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C"
    },
    attrs: {
      "href": 'tel:' + _vm.orderInfo.supplierTel
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? _vm.orderInfo.orderPickUpInfoBean.deliveryTel : _vm.orderInfo.supplierTel))])]), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderStatus != 9000 && !_vm.orderInfo.orderPickUpInfoBean) ? _c('div', {
    staticClass: "self-take-code"
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v("取货码")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code",
    on: {
      "click": function($event) {
        return _vm.toQrCode(_vm.orderInfo.orderShortNumQrCode)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".29rem",
      "height": ".29rem"
    },
    attrs: {
      "src": __webpack_require__(109),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fz-28",
    staticStyle: {
      "color": "#F2596C",
      "margin-left": ".15rem"
    }
  }, [_vm._v("二维码")]), _vm._v(" "), _c('span', {
    staticClass: "qr-line"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C",
      "margin-left": ".32rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.pickUpCode))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.buildingAddress && _vm.orderInfo.buildingAddress.length > 0) ? _c('div', {
    staticClass: "self-take-box br20"
  }, [_c('div', {
    staticClass: "self-take-code",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v("宿舍信息")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.buildingAddress))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean && _vm.orderInfo.orderPickUpInfoBean.takeType == 0) ? _c('div', {
    staticClass: "selfInfo br20"
  }, [(_vm.orderInfo.orderPickUpInfoBean.takeStatus == '0') ? _c('div', {
    staticClass: "selfCode"
  }, [_c('div', {
    staticClass: "selfDes"
  }, [_vm._v("自提柜取餐码\n            "), _c('span', {
    staticClass: "takeCode"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.takeCode ? _vm.orderInfo.orderPickUpInfoBean.takeCode : '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "selfInfo-wrap"
  }, [_c('span', {
    staticClass: "selfBtn",
    on: {
      "click": _vm.showSelfInfo
    }
  }, [_vm._v("自提柜信息")])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == '2' || _vm.orderInfo.orderPickUpInfoBean.takeStatus == '3') ? _c('div', {
    staticClass: "selfSuc"
  }, [_vm._v("\n          " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.takeName) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean && _vm.orderInfo.orderPickUpInfoBean.takeType == 1) ? _c('div', {
    staticClass: "selfInfo1 br20"
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": __webpack_require__(35)
    }
  }), _vm._v("\n          " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no"
  }, [(_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "status"
  }, [_vm._v("待取")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background": "#7ED321",
      "color": "#fff"
    }
  }, [_vm._v("已取\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background": "#D51A2A",
      "color": "#fff"
    }
  }, [_vm._v("废餐\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "no"
  }, [_vm._v("\n            " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-24",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("存餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.saveTimeStr))]), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("\n          取餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.takeTimeStr) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("\n          废餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.lockTimeStr) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "margin": ".14rem 0 .2rem 0"
    },
    on: {
      "click": _vm.openCabinet
    }
  }, [_vm._v("一键开柜\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "btn-open disabled"
  }, [_vm._v("已取餐")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "btn-open disabled"
  }, [_vm._v("已废餐")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "fc-grey-light"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.orderInfo.orderPickUpInfoBean.msgTemplate)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.orderInfo.order_status === 2001 || _vm.orderInfo.order_status === 2002 || _vm.orderInfo.order_status === 3001) && _vm.orderInfo.deliveryNickName) ? _c('div', {
    staticClass: "reward-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".6rem",
      "height": ".6rem",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.orderInfo.deliveryAvatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "delivery-name"
  }, [_vm._v(_vm._s(_vm.orderInfo.deliveryNickName))])]), _vm._v(" "), (_vm.orderInfo.canContactDelivery) ? _c('a', {
    staticClass: "order-tel1",
    staticStyle: {
      "width": "1.8rem"
    },
    attrs: {
      "href": 'tel:' + _vm.orderInfo.deliveryPhone
    }
  }, [_vm._v("联系西游侠")]) : _c('div', {
    staticClass: "delivery-btn",
    on: {
      "click": function($event) {
        return _vm.toReward(_vm.orderInfo.order_id)
      }
    }
  }, [_vm._v("打赏西游侠")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list order-list",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('ul', {
    staticClass: "br20"
  }, [_c('li', {
    staticClass: "title flexrow",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "0.15rem"
    }
  }, [_c('span', {
    staticClass: "shop-name ellipse",
    on: {
      "click": function($event) {
        return _vm.toGoodsList(_vm.orderInfo.supplier_id, _vm.orderInfo.supplier_name)
      }
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.supplier_name))]), _vm._v(" "), _c('span', {
    staticClass: "flexrow"
  }, [(_vm.managerInfo.mp) ? _c('a', {
    staticClass: "order-tel",
    attrs: {
      "href": 'tel:' + _vm.managerInfo.mp
    }
  }, [_vm._v("联系本校客服")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "order-tel1",
    attrs: {
      "href": 'tel:' + _vm.orderInfo.supplierTel
    }
  }, [_vm._v("联系商家")])])]), _vm._v(" "), _c('div', {
    staticClass: "order-id"
  }, [_vm._v("单号："), _c('span', {
    attrs: {
      "id": "codeNum"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.order_id))]), _c('span', {
    staticClass: "copy",
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_vm._v("复制")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "goods-list"
  }, [_vm._l((_vm.orderInfo.goods_list), function(item) {
    return _c('div', {
      staticClass: "clearflow goods-container"
    }, [_c('div', {
      staticClass: "goods-img fl",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "fl flexcol",
      staticStyle: {
        "margin": "0",
        "width": "65%"
      }
    }, [_c('span', {
      staticClass: "goods-name",
      staticStyle: {
        "font-weight": "bold",
        "width": "100%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.specification) ? _c('span', {
      staticClass: "goods-spec"
    }, [_vm._v(_vm._s(item.specification))]) : _vm._e(), _vm._v(" "), (item.attribute) ? _c('span', {
      staticClass: "goods-spec"
    }, [_vm._v(_vm._s(item.attribute))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flexcol",
      staticStyle: {
        "align-items": "flex-end"
      }
    }, [_c('div', {
      staticClass: "flexrow"
    }, [(item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined) ? _c('span', {
      staticClass: "pri ori_pri"
    }, [_vm._v("￥" + _vm._s(item.originalGdAmount))]) : _c('span', {
      staticClass: "pri ori_pri"
    }), _vm._v(" "), _c('span', {
      class: ['pri', {
        on: item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined
      }]
    }, [_vm._v("￥" + _vm._s(item.gdAmount))])]), _vm._v(" "), _c('span', {
      staticClass: "goods_num"
    }, [_vm._v("x" + _vm._s(item.buyNum))])])])
  }), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.gift_list && _vm.orderInfo.gift_list.length > 0) ? _c('div', {
    staticClass: "gift-info clearflow"
  }, [_c('div', {
    staticClass: "fl flexrow",
    staticStyle: {
      "width": "30%",
      "align-items": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.orderInfo.gift_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.gift_activity_name))])]), _vm._v(" "), (_vm.orderInfo.gift_list[0].name.length < 10) ? _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.orderInfo.gift_list[0].name) + "x" + _vm._s(_vm.orderInfo.gift_list[0].buyNum))]) : _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.orderInfo.gift_list[0].name.substring(0, 10)) + "...x" + _vm._s(_vm.orderInfo.gift_list[0].buyNum))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderInfo.orderFeeList), function(item) {
    return _c('div', {
      staticStyle: {
        "margin-top": "0.26rem",
        "font-size": ".26rem"
      }
    }, [_c('span', {
      style: ({
        color: item.titleColor
      })
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "fr ml10",
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.originValue) ? _c('span', {
      staticClass: "fr",
      staticStyle: {
        "text-decoration": "line-through",
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(item.originValue))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "goods-list foot"
  }, [_c('span', {
    staticClass: "fr"
  }, [_vm._v("总计 "), _c('span', {
    staticClass: "c-red",
    staticStyle: {
      "font-size": "0.36rem",
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderInfo.real_pay))])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "order-info br20"
  }, [_c('li', [_c('div', {
    staticClass: "goods-list details"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderDesc))])]), _vm._v(" "), (_vm.orderInfo.orderType == 0) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("送达时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("自提时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("就餐时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.upstairsDeliveryStr) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.upstairsDeliveryStr))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 0) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee) + " " + _vm._s(_vm.orderInfo.consignee_tel)), _c('br'), _vm._v(_vm._s(_vm.orderInfo.address))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("自提电话")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee_tel))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("预留电话")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee_tel))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.create_time))])]), _vm._v(" "), (_vm.orderInfo.comment) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.comment))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.paywayStr) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.paywayStr))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.singleItemCouponName) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("    ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": ".18rem",
      "color": "#707070"
    }
  }, [_vm._v("优惠说明：本单参与" + _vm._s(_vm.orderInfo.singleItemCouponName) + "，共享受优惠" + _vm._s(_vm.orderInfo.singleItemAmount) + "元")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, _vm._l((_vm.orderInfo.text_info), function(text) {
    return _c('li', [_vm._v(_vm._s(text.txt)), _c('span', {
      staticClass: "fr"
    }, [_vm._v("￥" + _vm._s(text.val))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.serviceList) ? _c('div', {
    staticClass: "service mask",
    on: {
      "click": _vm.closeServiceList,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "arrow-right"
  }, [(_vm.orderInfo.isFinishAfter24H == 0) ? _c('div', [(_vm.complaint == 3 || _vm.complaint == 2) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(9)
      }
    }
  }, [_vm._v("在线投诉")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.isFinishAfter24H == 1) ? _c('div', [(_vm.complaint == 3 || _vm.complaint == 2) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(11)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  }, [_vm._v("在线投诉")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.complaint == 1) ? _c('p', {
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandle(10)
      }
    }
  }, [_vm._v("查看投诉")]) : _vm._e()]), _vm._v(" "), (_vm.orderInfo.refundStatus != 2) ? _c('li', {
    staticClass: "arrow-right"
  }, [(_vm.orderInfo.refundStatus == 1) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(7)
      }
    }
  }, [_vm._v("申请退款")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.refundStatus == 3) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(8)
      }
    }
  }, [_vm._v("退款进度")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isShowRedPacket) ? _c('div', {
    staticClass: "redPacketAlert",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "redPacketBox"
  }, [_c('div', {
    staticClass: "redPacketClose",
    on: {
      "click": function($event) {
        _vm.isShowRedPacket = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0.3rem 0.5rem"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.redPacketInfo.show_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.redPacketInfo.show_content))]), _vm._v(" "), _c('div', {
    staticClass: "redPacket",
    style: ({
      backgroundImage: 'url(' + _vm.redPacketInfo.show_pic + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "redPacketBtn",
    on: {
      "click": function($event) {
        _vm.wxShareMask = true
      }
    }
  }, [_vm._v("发红包")])])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderInfo.redPacket != undefined && _vm.orderInfo.redPacket != null) ? _c('div', {
    staticClass: "redPacketIcon",
    style: ({
      backgroundImage: 'url(' + _vm.orderInfo.redPacket.show_pic + ')'
    }),
    on: {
      "click": function($event) {
        _vm.wxShareMask = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.wxShareMask) ? _c('div', {
    staticClass: "wxShareTips",
    on: {
      "click": function($event) {
        _vm.wxShareMask = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "wxShareImg"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowSelf) ? _c('div', {
    staticClass: "selfWrap",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.isShowSelf = false
      }
    }
  }, [_c('div', {
    staticClass: "self-mask"
  }, [_c('div', {
    staticClass: "self-top"
  }, [_vm._v("自提柜信息")]), _vm._v(" "), _c('div', {
    staticClass: "self-name",
    staticStyle: {
      "margin-bottom": ".32rem"
    }
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("自提柜名称")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName))])]), _vm._v(" "), _c('div', {
    staticClass: "self-name",
    staticStyle: {
      "margin-bottom": ".32rem"
    }
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("自提柜地址")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "self-name"
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("格子号")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo))])]), _vm._v(" "), _c('div', {
    staticClass: "closeBtn",
    on: {
      "click": function($event) {
        _vm.isShowSelf = false
      }
    }
  }, [_vm._v("确定")])])]) : _vm._e(), _vm._v(" "), (_vm.isShowCabinet) ? _c('div', {
    staticClass: "selfWrap"
  }, [_c('div', {
    staticClass: "self-mask",
    staticStyle: {
      "width": "6.4rem",
      "margin-left": "-3.2rem",
      "margin-top": "-3rem",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "padding": ".7rem .4rem .5rem .4rem",
      "margin-bottom": "0",
      "background-color": "transparent"
    }
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": __webpack_require__(35)
    }
  }), _vm._v("\n            " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no",
    staticStyle: {
      "width": "1.8rem"
    }
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": ".4rem 0"
    }
  }, [_vm._v("请确保在自提柜附近操作开柜，防止餐品丢失。")]), _vm._v(" "), (!_vm.isShowProgress) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "height": ".84rem",
      "line-height": ".84rem",
      "margin-bottom": ".2rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("确认开柜\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isShowProgress) ? _c('div', {
    staticClass: "progressbar"
  }, [_c('div', {
    staticClass: "fill"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-cancle",
    on: {
      "click": _vm.cancelCab
    }
  }, [_vm._v("取消开柜")])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.addressList && _vm.addressList.length > 0) ? _c('div', {
    staticClass: "list address-list"
  }, [_c('ul', _vm._l((_vm.addressList), function(item) {
    return _c('li', {
      class: !item.isVaild && _vm.isForm ? 'vaild' : ''
    }, [_c('div', {
      staticClass: "delete-btn"
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "swiper-container swiper-delete swiper-container-horizontal"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_c('div', {
      staticClass: "content swiper-slide",
      on: {
        "click": function($event) {
          return _vm.handleClickChooseAddress(item)
        }
      }
    }, [_c('div', {
      staticClass: "content-box",
      staticStyle: {
        "width": "100%"
      }
    }, [(!item.isLimitFloor) ? _c('div', {
      staticClass: "item ellipses-two",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [(item.detail && item.poi_address) ? _c('span', [_vm._v(_vm._s(item.poi_address) + _vm._s(item.detail))]) : (item.build_name) ? _c('span', [_vm._v("【" + _vm._s(item.build_name) + "-" + _vm._s(item.floor_name) + "-" + _vm._s(item.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(item.poi_address))])]) : _c('div', {
      staticClass: "item ellipses-two",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [(item.build_name) ? _c('span', [_vm._v("【" + _vm._s(item.build_name) + "-" + _vm._s(item.floor_name) + "-" + _vm._s(item.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(item.poi_address) + " " + _vm._s(item.detail))])]), _vm._v(" "), _c('span', {
      staticClass: "address",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [_vm._v(_vm._s(item.addressee) + " " + _vm._s(item.mp))])]), _vm._v(" "), (item.isVaild || !_vm.isForm) ? _c('a', {
      staticClass: "icon icon-edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAddress(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!item.isVaild && _vm.isForm) ? _c('a', {
      staticClass: "iconEdit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAddress(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": ".38rem",
        "height": ".38rem"
      },
      attrs: {
        "src": __webpack_require__(320)
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": ".38rem",
        "margin-left": "0.05rem"
      }
    }, [_vm._v("完善信息")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        choose: item.id === _vm.chooseAddress.id && (item.isVaild || !_vm.isForm)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete-btn2 swiper-slide",
      on: {
        "click": function($event) {
          return _vm.handleClickDeleteAddress(item)
        }
      }
    })])])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]), _vm._v(" "), _c('footer', {
    staticClass: "block fixed"
  }, [_c('a', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": _vm.toAddAddress
    }
  }, [_vm._v("新增收货地址")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里没有收货地址")])])
}]}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.showPage) ? _c('div', [_c('div', {
    staticClass: "package-title"
  }, [_c('div', {
    staticClass: "flex-row-sc"
  }, [_vm._v("\n      优惠券包\n      "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.showUseBox = true
      }
    }
  }, [_vm._v(_vm._s(_vm.couponPackageList[0].package_ttl) + "天内有效 | 使用说明\n      ")]) : _vm._e(), _vm._v(" "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": __webpack_require__(114),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.toRecord()
      }
    }
  }, [_vm._v("购买记录"), _c('span', {
    staticClass: "icon_arrow_next"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cpackage-list"
  }, [_vm._l((_vm.recordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      staticStyle: {
        "align-items": "center"
      }
    }, [_c('div', [_c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v("您有订单未完成支付")]), _vm._v(" "), _c('div', {
      staticClass: "fs-24",
      staticStyle: {
        "margin-top": ".16rem"
      }
    }, [_vm._v(_vm._s(item.promotion_name) + "-" + _vm._s(item.coupon_num) + "张" + _vm._s(item.coupon_amount) + "元优惠券")])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      staticStyle: {
        "margin-top": "0"
      },
      on: {
        "click": function($event) {
          return _vm.toRecord()
        }
      }
    }, [_vm._v("待支付")])])
  }), _vm._v(" "), _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(item.package_status === 0 ? item.package_error : item.package_shop_desc) + "\n            "), _c('span', {
      staticStyle: {
        "color": "#5cb9ff",
        "margin-left": "0.1rem",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.viewShops(item)
        }
      }
    }, [_vm._v("去查看")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n            ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.openShowPay(item)
        }
      }
    }, [_vm._v("\n        立即购买\n      ")])])
  })], 2), _vm._v(" "), (_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('div', {
    staticClass: "shop-list"
  }, [_c('div', {
    staticClass: "package-title"
  }, [_vm._v("以下为红包可用商家")]), _vm._v(" "), (_vm.packageShop.length > 0) ? _c('div', {
    staticClass: "goods-list shop"
  }, [_c('ul', {
    staticClass: "goods"
  }, _vm._l((_vm.packageShop), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg"
    }, [_c('img', {
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    })]), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v("\n                  " + _vm._s(item.mark) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#e3e3e3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "threshold"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#e3e3e3"
      }
    }, [_vm._v("|")]), _vm._v(" "), (
      item.new_delivery_fee || item.new_delivery_fee === 0
    ) ? _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.new_delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])]) : _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()]), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (
      item.promotion_reduce && item.promotion_reduce.reduce_info
    ) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2, index2) {
      return _c('span', {
        key: index2,
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showPayBox) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.showPayBox = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPayBox) ? _c('div', {
    staticClass: "pay-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认购买")]), _vm._v(" "), _c('div', {
    staticClass: "cpackage-list"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "img"
  }, [_c('div', {
    staticClass: "c-tit"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_coupon_title))]), _vm._v(" "), _c('div', {
    staticClass: "c-price"
  }, [_c('span', [_vm._v(_vm._s(_vm.packageDetail.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(_vm.packageDetail.package_unit_num))]), _vm._v("张\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "c-desc"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_coupon_desc))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.packageDetail.package_name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ff4a61",
      "padding-bottom": "0.16rem"
    }
  }, [_vm._v("\n              有效期至：" + _vm._s(_vm.packageDetail.package_sendTime) + "\n              "), _c('span', {
    staticClass: "leave-day"
  }, [_vm._v("剩余" + _vm._s(_vm.packageDetail.package_ttl) + "天")])]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.packageDetail.package_shop_desc)), _c('span', {
    staticStyle: {
      "color": "#5cb9ff",
      "margin-left": "0.1rem",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.viewShops(_vm.packageDetail)
      }
    }
  }, [_vm._v("去查看")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "use-tips"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("使用说明")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.package_rule)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "to-pay",
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("\n      ¥" + _vm._s(_vm.packageDetail.package_selling_price) + "立即支付\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showUseBox) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.showUseBox = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUseBox) ? _c('div', {
    staticClass: "pay-box"
  }, [_c('div', {
    staticClass: "use-tips"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("使用说明")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.packageDetail.package_rule)
    }
  })])]) : _vm._e()]) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v("\n    暂时没有可购的券包~\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "count-down"
  }, [_c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#FF8C00"
    }
  }, [_vm._v(_vm._s(_vm.countDownLatch) + "s")])]), _vm._v(" "), _c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "width": "100%",
      "padding": "0"
    }
  }, [_c('img', {
    staticClass: "guizi",
    staticStyle: {
      "width": "1.56rem"
    },
    attrs: {
      "src": __webpack_require__(335)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin": ".55rem 0 .2rem 0",
      "padding": "0 .5rem"
    }
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": __webpack_require__(35)
    }
  }), _vm._v("\n      " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no"
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin-top": ".4rem"
    }
  }, [_vm._v("箱门已打开")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "margin-bottom": ".4rem"
    }
  }, [_vm._v("请取走您的餐盒并关好箱门")]), _vm._v(" "), _c('div', {
    staticClass: "btn-open fz-32",
    staticStyle: {
      "height": "1rem",
      "line-height": "1rem"
    },
    on: {
      "click": _vm.closePage
    }
  }, [_vm._v("确认已取，并关好箱门")]), _vm._v(" "), _c('div', {
    staticClass: "fz-30",
    staticStyle: {
      "color": "#4A90E2",
      "margin-top": ".4rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("箱门未开，重试箱门")])])])
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "myScore"
  }, [_c('div', {
    staticClass: "flex-row-bc"
  }, [_c('div', [_c('div', {
    staticClass: "fs-32 fw-bold flex-row-sc"
  }, [_vm._v("\n          我的蟠桃\n          "), _c('span', {
    staticClass: "detail",
    on: {
      "click": function($event) {
        return _vm.toScoreDetail()
      }
    }
  }, [_vm._v("明细")])]), _vm._v(" "), _c('div', {
    staticClass: "fw-bold",
    staticStyle: {
      "font-size": ".96rem",
      "padding": ".15rem 0"
    }
  }, [_vm._v(_vm._s(_vm.scoreInfo.score))])]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2rem",
      "margin-right": ".56rem"
    },
    attrs: {
      "src": _vm.scoreInfo.icon,
      "mode": "widthFix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rules",
    on: {
      "click": function($event) {
        return _vm.toRules()
      }
    }
  }, [_vm._v("说明")])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-tit"
  }, [_vm._v(_vm._s(_vm.userSignInfo.title))]), _vm._v(" "), _c('div', {
    staticClass: "sign-list flex-row-bc"
  }, _vm._l((_vm.userSignInfo.signList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-colum-cc"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.toSign(item.is_today_sign)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), (item.is_today_sign === 0) ? _c('div', {
      staticClass: "tips",
      style: ({
        color: item.text_color
      })
    }, [_vm._v(_vm._s(item.tips))]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.taskInfo.rookieTaskList) ? _c('div', {
    staticClass: "card"
  }, [(_vm.taskInfo.rookieTaskList.title) ? _c('div', {
    staticClass: "card-tit"
  }, [_vm._v("\n      " + _vm._s(_vm.taskInfo.rookieTaskList.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.taskInfo.rookieTaskList.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v("+" + _vm._s(item.score))])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [(item.complete_status == 3) ? _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title) + "(仅限俺来也APP)")]) : _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20 fc-666 marginT14"
    }, [_vm._v(_vm._s(item.des))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [(item.complete_status == 1) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.makeScore(item)
        }
      }
    }, [_vm._v("做任务")]) : (item.complete_status == 2) ? _c('div', {
      staticClass: "btn completed"
    }, [_vm._v("已完成")]) : (item.complete_status == 3) ? _c('div', {
      staticClass: "btn"
    }, [_c('a', {
      staticStyle: {
        "color": "#2F2F2F"
      },
      attrs: {
        "href": "https://dl.anlaiye.com"
      }
    }, [_vm._v("下载APP")])]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.taskInfo.dailyTaskList) ? _c('div', {
    staticClass: "card"
  }, [(_vm.taskInfo.dailyTaskList.title) ? _c('div', {
    staticClass: "card-tit"
  }, [_vm._v("\n      " + _vm._s(_vm.taskInfo.dailyTaskList.title) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, _vm._l((_vm.taskInfo.dailyTaskList.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "score"
    }, [_vm._v("+" + _vm._s(item.score))])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [(item.complete_status == 3) ? _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title) + "(仅限俺来也APP)")]) : _c('div', {
      staticClass: "fs-28 fw-bold"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20 fc-666 marginT14"
    }, [_vm._v(_vm._s(item.des))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [(item.complete_status == 1) ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.makeScore(item)
        }
      }
    }, [_vm._v("做任务")]) : (item.complete_status == 2) ? _c('div', {
      staticClass: "btn completed"
    }, [_vm._v("已完成")]) : (item.complete_status == 3) ? _c('div', {
      staticClass: "btn"
    }, [_c('a', {
      staticStyle: {
        "color": "#2F2F2F"
      },
      attrs: {
        "href": "https://dl.anlaiye.com"
      }
    }, [_vm._v("下载APP")])]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "mask-box",
    on: {
      "click": function($event) {
        _vm.showMask = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "ac fs-42"
  }, [_vm._v(_vm._s(_vm.signedInfo.msg))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.signedInfo.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "height": "1rem",
      "line-height": "1rem",
      "font-size": ".4rem",
      "font-weight": "bold",
      "border-radius": ".24rem",
      "padding": "0"
    }
  }, [_vm._v("开心收下")])])]) : _vm._e(), _vm._v(" "), (_vm.showMakeScore) ? _c('div', {
    staticClass: "mask-box",
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "mask"
  }, [_c('img', {
    staticClass: "mask-close",
    attrs: {
      "src": __webpack_require__(317)
    },
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.makeScoreInfo.tips))]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showMakeScore = false
      }
    }
  }, [_vm._v("知道了")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "search",
      "placeholder": "搜索商家、商品名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keydown": function($event) {
        return _vm.key($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.keyword != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.getGoodsSearch()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (!_vm.showResult) ? _c('div', {
    staticClass: "search-result"
  }, [(_vm.historySearchList.length > 0) ? _c('div', {
    staticClass: "icon icon-hot"
  }, [_vm._v("历史搜索 "), _c('span', {
    staticClass: "icon icon-delete fr",
    on: {
      "click": function($event) {
        return _vm.clearHistory()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.historySearchList.length > 0) ? _c('div', {
    staticClass: "hot-keys"
  }, _vm._l((_vm.historySearchList), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getGoodsSearch(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-hot",
    staticStyle: {
      "margin-top": ".4rem",
      "margin-bottom": ".04rem"
    }
  }, [_vm._v("搜索发现")]), _vm._v(" "), (_vm.searchRecom.length > 0) ? _c('div', {
    staticClass: "hot-keys"
  }, _vm._l((_vm.searchRecom), function(item) {
    return _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getGoodsSearch(item.keyword)
        }
      }
    }, [_vm._v(_vm._s(item.keyword))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shop-head"
  }, _vm._l((_vm.shopRecom), function(item) {
    return _c('div', {
      staticClass: "shop-recom",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.shop_id)
        }
      }
    }, [_c('img', {
      staticClass: "recom-img",
      attrs: {
        "src": item.pic,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "ellipse recom-name"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "recom-type"
    }, [_vm._v(_vm._s(item.type_name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goods-list search-goods"
  }, [(_vm.showResult) ? _c('div', [(_vm.goodsInfo.length > 0) ? _c('ul', [_vm._l((_vm.goodsInfo), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: ({
        backgroundImage: 'url(' + item.pic + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse",
      domProps: {
        "innerHTML": _vm._s(item.shop_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('span', [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3",
        "padding": "0 0.05rem"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(item.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('span', [_vm._v(_vm._s(item.new_delivery_fee))]) : _c('span', [_vm._v(_vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? [_c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])] : _vm._e(), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()], 2), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title",
      staticStyle: {
        "margin": "0 0 0 .2rem"
      }
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2) {
      return _c('span', {
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.goods_list.length > 0) ? _c('div', {
      staticClass: "related-goods"
    }, [(item.isShowAll) ? _c('div', {
      staticClass: "more-goods"
    }, _vm._l((item.goods_list), function(item2) {
      return _c('a', {
        domProps: {
          "innerHTML": _vm._s(item2.name)
        }
      })
    }), 0) : _c('div', {
      staticClass: "more-goods"
    }, [_c('a', {
      domProps: {
        "innerHTML": _vm._s(item.goods_list[0].name)
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id)
        }
      }
    })]), _vm._v(" "), (item.goods_list.length > 1) ? _c('div', [(item.isShowAll) ? _c('span', {
      staticClass: "shield-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    }, [_vm._v("收起")]) : _c('span', {
      staticClass: "show-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    }, [_vm._v("展开其他" + _vm._s(item.goods_list.length - 1) + "个商品")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), _vm._v(" "), _vm._m(0)], 2) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "end-line"
  }, [_c('span', [_vm._v("- end -")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0.2rem 0"
    }
  }, [_vm._v("抱歉，未能找到您搜索的商家或商品")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0.2rem 0"
    }
  }, [_vm._v("换个关键词试试吧")])])
}]}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "fl back-btn",
    attrs: {
      "to": "/index"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fr icon icon-delete",
    on: {
      "click": _vm.clearCart
    }
  }, [_c('span')]), _vm._v(" "), _c('h2', [_vm._v("购物车")])], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.cartInfo.total == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_vm._v("\n      您的购物车为空\n    ")]) : _c('div', {
    staticClass: "list"
  }, [_c('ul', [_vm._l((_vm.cartInfo.market), function(item) {
    return _c('li', [_c('div', {
      staticClass: "media-box"
    }, [_c('div', {
      staticClass: "media-img fl"
    }, [_c('a', {
      staticClass: "gd picw"
    }, [_c('img', {
      attrs: {
        "src": item.title_image_path
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "price fl"
    }, [_c('span', [_vm._v(_vm._s(item.wx_price))])]), _vm._v(" "), _c('div', {
      staticClass: "num-box fr"
    }, [_c('span', {
      staticClass: "btns minusBtn icon-removecart",
      attrs: {
        "id": item.goods_id
      },
      on: {
        "click": function($event) {
          return _vm.minusGoods($event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    }, [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('span', {
      staticClass: "btns addBtn icon-addtocart",
      attrs: {
        "id": item.goods_id
      },
      on: {
        "click": function($event) {
          return _vm.addGoods($event)
        }
      }
    })])])])])
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "settle-box"
  }, [_c('div', {
    staticClass: "footer-cart fl"
  }, [_vm._v("合计：\n              "), _c('span', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "amounts"
  }, [_vm._v(_vm._s(_vm.cartInfo.amount))])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-red btn-lg fr",
    attrs: {
      "data-name": "market"
    },
    on: {
      "click": _vm.settleAccount
    }
  }, [_vm._v("结算")])])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycomment"
  }, [(_vm.showPage) ? _c('div', [(_vm.commentType == 1) ? _c('div', [(_vm.commentList.length > 0) ? _c('ul', {
    staticClass: "comment_list"
  }, _vm._l((_vm.commentList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "comment_top arrow-right",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.supplierId, item.supplierShortName)
        }
      }
    }, [_c('span', {
      staticClass: "dp_img fl",
      style: ({
        backgroundImage: 'url(' + item.shopLogoUrl + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "shop_name fl"
    }, [_vm._v(_vm._s(item.supplierShortName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "0.84rem"
      }
    }, [_c('span', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "score_star"
    }, [_c('span', [_vm._v("评分")]), _vm._v(" "), _c('CommentStars', {
      attrs: {
        "qualityCode": item.qualityCode
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "time fl",
      staticStyle: {
        "margin-left": "0.4rem"
      }
    }, [_vm._v("时间：" + _vm._s(item.date))])], 1), _vm._v(" "), _c('div', {
      staticClass: "comment_des"
    }, [_vm._v(_vm._s(item.comment))]), _vm._v(" "), (item.urls && item.urls.length > 0) ? _c('PreviewPicture', {
      attrs: {
        "previewPictures": item.urls
      }
    }) : _vm._e(), _vm._v(" "), (item.goodsMarkList.length > 0) ? _c('div', {
      staticClass: "goodsmark_list"
    }, [_c('div', [(item.goodList.length > 0) ? _c('span', {
      staticClass: "icon good"
    }) : _vm._e(), _c('p', _vm._l((item.goodList), function(item1, index) {
      return _c('span', [_vm._v(_vm._s(item1)), (index < item.goodList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)]), _vm._v(" "), _c('div', [(item.badList.length > 0) ? _c('span', {
      staticClass: "icon bad"
    }) : _vm._e(), _c('p', _vm._l((item.badList), function(item2, index) {
      return _c('span', [_vm._v(_vm._s(item2)), (index < item.badList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)])]) : _vm._e(), _vm._v(" "), (item.isReply == 1) ? _c('div', {
      staticClass: "reply_comment"
    }, [_vm._v("商家回复：" + _vm._s(item.replyComment))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment_bottom"
    }, [_c('div', {
      staticClass: "delete fr",
      on: {
        "click": function($event) {
          return _vm.deleteComment(item.id)
        }
      }
    }, [_vm._v("删除")])])], 1)])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _c('div', [_c('ul', {
    staticClass: "comment_list"
  }, [_c('li', [_c('div', {
    staticClass: "comment_top arrow-right",
    on: {
      "click": function($event) {
        return _vm.toGoodsList(_vm.commentDetail.supplierId, _vm.commentDetail.supplierShortName)
      }
    }
  }, [_c('span', {
    staticClass: "dp_img fl",
    style: ({
      backgroundImage: 'url(' + _vm.commentDetail.shopLogoUrl + ')'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "shop_name fl"
  }, [_vm._v(_vm._s(_vm.commentDetail.supplierShortName))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0.84rem"
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "score_star"
  }, [_c('span', [_vm._v("评分")]), _vm._v(" "), _c('CommentStars', {
    attrs: {
      "qualityCode": _vm.commentDetail.qualityCode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time fl",
    staticStyle: {
      "margin-left": "0.4rem"
    }
  }, [_vm._v("时间：" + _vm._s(_vm.commentDetail.date))])], 1), _vm._v(" "), _c('div', {
    staticClass: "comment_des"
  }, [_vm._v(_vm._s(_vm.commentDetail.comment))]), _vm._v(" "), (_vm.commentDetail.urls && _vm.commentDetail.urls.length > 0) ? _c('PreviewPicture', {
    attrs: {
      "previewPictures": _vm.commentDetail.urls
    }
  }) : _vm._e(), _vm._v(" "), (_vm.commentDetail.goodsMarkList && _vm.commentDetail.goodsMarkList.length > 0) ? _c('div', {
    staticClass: "goodsmark_list"
  }, [_c('div', [(_vm.commentDetail.goodList && _vm.commentDetail.goodList.length > 0) ? _c('span', {
    staticClass: "icon good"
  }) : _vm._e(), _c('p', _vm._l((_vm.commentDetail.goodList), function(item1, index) {
    return _c('span', [_vm._v(_vm._s(item1)), (index < _vm.commentDetail.goodList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', [(_vm.commentDetail.badList && _vm.commentDetail.badList.length > 0) ? _c('span', {
    staticClass: "icon bad"
  }) : _vm._e(), _c('p', _vm._l((_vm.commentDetail.badList), function(item2, index) {
    return _c('span', [_vm._v(_vm._s(item2)), (index < _vm.commentDetail.badList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.commentDetail.isReply == 1) ? _c('div', {
    staticClass: "reply_comment"
  }, [_vm._v("商家回复：" + _vm._s(_vm.commentDetail.replyComment))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "comment_bottom"
  }, [_c('div', {
    staticClass: "delete fr",
    on: {
      "click": function($event) {
        return _vm.deleteComment(_vm.commentDetail.estimateId)
      }
    }
  }, [_vm._v("删除")])])], 1)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbox"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mp),
      expression: "mp",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "tel",
    attrs: {
      "type": "number",
      "placeholder": "手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value.trim()
      }, _vm.onlyNum],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.countDown) ? _c('span', {
    staticClass: "get-code"
  }, [_vm._v(_vm._s(_vm.time) + "s")]) : _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.postSmsCaptcha
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.captcha),
      expression: "captcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "验证码",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.postSignIn.apply(null, arguments)
      }
    }
  }, [_vm._v("绑定手机号")])])])
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "complaint_details",
    staticStyle: {
      "padding-bottom": "2.7rem"
    }
  }, [(_vm.processType == 0) ? _c('div', [_c('div', {
    staticClass: "details"
  }, [_c('ul', {
    staticClass: "details_content"
  }, [_c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("商家名称:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.shopName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单号码:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.orderId))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("申请金额:")]), _c('span', {
    staticClass: "details_con",
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundDetails.refundAmount))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("申请商品:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.refundGoodsDetail))])]), _vm._v(" "), (_vm.refundDetails.showResult == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("退款金额:")]), _c('span', {
    staticClass: "details_con",
    staticStyle: {
      "color": "#F2596C"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundDetails.realrefundAmount))])]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showResult == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("退款商品:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.refundDetails.finalRefundGoodsDesc))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('ul', {
    staticClass: "process_content"
  }, _vm._l((_vm.refundDetails.messageList), function(item) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "process_time"
    }, [_vm._v(_vm._s(item.handleDate))]), _vm._v(" "), (item.title) ? _c('div', {
      staticClass: "process_box"
    }, [_c('span', {
      class: ['process_icon fl', {
        'active': item.selected === 1
      }]
    }), _vm._v(" "), _c('span', {
      class: ['process_tit fl', {
        'active': item.selected === 1
      }]
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "process_des",
      domProps: {
        "innerHTML": _vm._s(item.refundGoodsStr)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "process_des",
      domProps: {
        "innerHTML": _vm._s(item.message)
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.refundDetails.showAccept == 1 || _vm.refundDetails.showAppealStaus == 1) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "background": "#f6f6f6"
    }
  }, [(_vm.refundDetails.showAccept == 1) ? _c('div', {
    staticClass: "btn-big btn-yellow",
    on: {
      "click": _vm.acceptResult
    }
  }, [_c('h4', [_vm._v("接受商家处理结果")]), _vm._v(" "), _c('p', [_vm._v("(退款金额立即到账)")])]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showAppealStaus == 1) ? _c('div', {
    staticClass: "btn-big",
    on: {
      "click": _vm.confirmAppeal
    }
  }, [_c('h4', [_vm._v("退款申诉")]), _vm._v(" "), _c('p', [_vm._v("(商家处理后72h内可发起申诉，超时将默认您接受商家处理结果)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.isCanCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("撤销退款申请")]) : _vm._e(), _vm._v(" "), (_vm.refundDetails.showAppealStaus == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.handleClickAppeal(2)
      }
    }
  }, [_vm._v("撤销退款申诉")]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "details"
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("投诉详情")]), _vm._v(" "), _c('ul', {
    staticClass: "details_content"
  }, [_c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("商家名称:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.supplierShortName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单号码:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.orderId))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("投诉对象:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.responsibleParty))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("投诉理由:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.complainReason))])]), _vm._v(" "), (_vm.details.compainComment != '') ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("详细描述:")]), _c('span', {
    staticClass: "details_con"
  }, [_vm._v(_vm._s(_vm.details.compainComment))])]) : _vm._e(), _vm._v(" "), (_vm.details.afterSaleType == 1) ? _c('li', [_c('span', {
    staticClass: "details_tit"
  }, [_vm._v("订单金额:")]), _c('span', {
    staticClass: "details_con"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.details.realAmount != '' && _vm.details.realAmount != null),
      expression: "details.realAmount!='' && details.realAmount!=null"
    }]
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.details.realAmount))])]) : _vm._e()]), _vm._v(" "), (_vm.urls.length > 0) ? _c('PreviewPicture', {
    staticClass: "details_pic",
    attrs: {
      "previewPictures": _vm.urls
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('ul', {
    staticClass: "process_content"
  }, _vm._l((_vm.details.messageList), function(item) {
    return _c('li', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "process_time"
    }, [_vm._v(_vm._s(item.handleDate))]), _vm._v(" "), _c('div', {
      staticClass: "process_box"
    }, [_c('span', {
      class: ['process_icon fl', {
        'active': item.selected === 1
      }]
    }), _vm._v(" "), _c('span', {
      class: ['process_tit fl', {
        'active': item.selected === 1
      }]
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "process_des"
    }, [_vm._v(_vm._s(item.message))])])
  }), 0)]), _vm._v(" "), (_vm.details.afterSaleType == 1) ? _c('div', [(_vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("取消投诉")]) : _vm._e(), _vm._v(" "), (_vm.messageList.length >= 2 && _vm.details.resultFeedBack == 0 && _vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toFeedBack
    }
  }, [_vm._v("投诉反馈")]) : _vm._e()]) : _c('div', [(_vm.details.canCancel == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancelComplaint
    }
  }, [_vm._v("取消售后")]) : _vm._e(), _vm._v(" "), (_vm.messageList.length == 4 && _vm.details.resultFeedBack == 0) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toFeedBack
    }
  }, [_vm._v("售后反馈")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppealAlert),
      expression: "showAppealAlert"
    }],
    staticClass: "appeal-alert mask"
  }, [_c('div', {
    staticClass: "appeal-alert-box"
  }, [_c('h3', [_vm._v("退款申诉")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appealReason),
      expression: "appealReason"
    }],
    attrs: {
      "placeholder": "请输入申诉理由，不超过200字",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.appealReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appealReason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "appeal-description"
  }, [_vm._v("发起申诉后，您的此笔退款订单将由俺来也平台\n        介入审核。期间您可能会收到俺来也平台的客服\n        电话，请保持手机畅通。审核约需1-3个工作日。")]), _vm._v(" "), _c('div', {
    staticClass: "appeal-btn flexrow"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showAppealAlert = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.handleClickAppeal(1)
      }
    }
  }, [_vm._v("提交申诉")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('form', [_c('div', {
    staticClass: "list order edit-address"
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressee),
      expression: "addressee"
    }],
    attrs: {
      "placeholder": "请输入您的姓名",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.addressee)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sex-box",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-boy",
    class: {
      'checked': _vm.gender === '1'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "1")
    },
    on: {
      "change": function($event) {
        _vm.gender = "1"
      }
    }
  }), _vm._v("男\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "icon icon-girl",
    class: {
      'checked': _vm.gender === '0'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "0")
    },
    on: {
      "change": function($event) {
        _vm.gender = "0"
      }
    }
  }), _vm._v("女\n                ")])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mp),
      expression: "mp"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入您的手机号",
      "maxlength": 11
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.chooseAddress
    }
  }, [_c('label', [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.poi_address))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleBuildProp
    }
  }, [_c('label', [_vm._v("楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.buildInfo.name ? _vm.buildInfo.name : '请选择楼栋'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleFloorProp
    }
  }, [_c('label', [_vm._v("楼层")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.floorInfo.name ? _vm.floorInfo.name : '请选择楼层'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleRoomProp
    }
  }, [_c('label', [_vm._v("房间")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.roomInfo.name ? _vm.roomInfo.name : '请选择房间'))])])]) : _vm._e(), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('label', [_vm._v("详细")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail),
      expression: "detail"
    }],
    attrs: {
      "placeholder": "请输入您的详细地址",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.detail)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detail = $event.target.value
      }
    }
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('footer', {
    staticClass: "block",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('a', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("完成")])]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.closeProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propBuildShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.buildTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item3",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.buildingList), function(item) {
    return _c('li', {
      class: {
        'canSelect': item.id == _vm.buildInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeBuilding(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propFloorShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.floorTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.floorList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.floorInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeFloor(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propRoomShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.roomTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.roomList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.roomInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeRoom(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0), _vm._v(" "), (_vm.isCustom) ? _c('div', {
    staticClass: "custom",
    on: {
      "click": _vm.changeOpenCustom
    }
  }, [_vm._v("\n      没有找到自己房间号？点击这里添加\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.openCustomRoom) ? _c('div', {
    staticClass: "custom-pop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("自定义房间号")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customRoomName),
      expression: "customRoomName"
    }],
    attrs: {
      "autofocus": "",
      "type": "text",
      "placeholder": "请输入你的房间号",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.customRoomName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customRoomName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("温馨提示：为确保餐品顺利送到，请填写真实房间号")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.changeOpenCustom()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-ok",
    on: {
      "click": _vm.choseCustomRoom
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.alertBody))]), _vm._v(" "), (_vm.type == '0') ? _c('div', {
    staticClass: "foot",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("知道了")]) : _vm._e(), _vm._v(" "), (_vm.type == '1') ? _c('div', {
    staticClass: "foot col2"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("确定")])]) : _vm._e(), _vm._v(" "), (_vm.type == '2') ? _c('div', {
    staticClass: "foot",
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("知道了")]) : _vm._e(), _vm._v(" "), (_vm.type == '3') ? _c('div', {
    staticClass: "foot col2"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(false)
      }
    }
  }, [_vm._v("返回重选")]), _c('span', {
    on: {
      "click": function($event) {
        return _vm.confirmAlert(true)
      }
    }
  }, [_vm._v("不用了，谢谢")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [(_vm.showBackBtn) ? _c('span', {
    staticClass: "go-back-btn",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("首页")]) : _vm._e(), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), (_vm.$route.meta.showTab) ? _c('footer', {
    staticClass: "fixed flex"
  }, [_c('router-link', {
    attrs: {
      "to": "index"
    }
  }, [_c('span', {
    staticClass: "icon icon-home"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "orderlist"
    }
  }, [_c('span', {
    staticClass: "icon icon-order"
  }, [_vm._v("订单")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "usercenter"
    }
  }, [_c('span', {
    staticClass: "icon icon-user"
  }, [_vm._v("我的")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-delivery"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.showPage) ? _c('div', [(_vm.orderType == 0) ? _c('div', [(_vm.isShopDelivery) ? _c('div', [_c('div', {
    staticClass: "delivery-content"
  }, [_c('h2', [_vm._v("商家自行配送，暂无配送信息 "), _c('a', {
    staticClass: "btn fr",
    attrs: {
      "href": 'tel:' + _vm.shopTel
    }
  }, [_vm._v("催单")])]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("商家电话 "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.shopTel
    }
  }, [_vm._v(_vm._s(_vm.shopTel))])])])]) : _c('div', [_c('div', {
    staticClass: "navbar col22 fixed"
  }, [_c('a', {
    class: {
      active: _vm.showStatus
    },
    attrs: {
      "id": "info"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("进程状态")]), _vm._v(" "), _c('a', {
    class: {
      active: !_vm.showStatus
    },
    attrs: {
      "id": "status"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("配送信息")])]), _vm._v(" "), (_vm.showStatus) ? _c('div', {
    staticClass: "change-box"
  }, [_c('div', {
    staticClass: "status-list"
  }, [_c('ul', _vm._l((_vm.statusList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "text-box"
    }, [_c('h2', [_vm._v(_vm._s(item.progressInfo))]), _vm._v(" "), _c('div', {
      staticClass: "des"
    }, [_vm._v(_vm._s(item.handlers) + " "), _c('span', {
      staticStyle: {
        "color": "#638bbb"
      }
    }, [_vm._v(_vm._s(item.handlersTel))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatDate(item.executionTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "status-tip",
      class: {
        'transparent': _vm.statusList.length == 1
      }
    }, [_c('span')])])
  }), 0)])]) : _c('div', {
    staticClass: "change-box"
  }, [_c('ul', {
    staticClass: "order-info-box goods-list"
  }, [_c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("配送单号")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderInfo.code))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("取单信息")]), _vm._v(" "), _c('p', {
    staticClass: "ellipse"
  }, [_c('span', [_vm._v("店铺:")]), _vm._v(_vm._s(_vm.orderInfo.shopName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话:")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.orderInfo.shopTel
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.shopTel))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("地址:")]), _vm._v(_vm._s(_vm.orderInfo.pickUpPlace))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("配送信息")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("运费:")]), _vm._v("￥" + _vm._s(_vm.orderInfo.shopDeliveryFee))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("配送员:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryTel))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("状态:")]), _vm._v(_vm._s(_vm.deliveryStatusName))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("送单信息")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("商品总价:")]), _vm._v("￥" + _vm._s(_vm.orderInfo.orderAmount))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": ".3rem"
    }
  }, [_c('span', [_vm._v("支付:")]), _vm._v(_vm._s(_vm.orderInfo.orderStatusName))]), _vm._v(" "), _vm._l((_vm.orderInfo.orderGoods), function(item) {
    return _c('div', {
      staticClass: "goodsInfo",
      staticStyle: {
        "overflow": "hidden",
        "margin-bottom": "0.3rem"
      }
    }, [_c('div', {
      staticClass: "goods-img fl",
      style: ({
        backgroundImage: 'url(' + item.pic + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "fl flexcol",
      staticStyle: {
        "margin": "0",
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "goods_num",
      staticStyle: {
        "margin-top": "0.25rem"
      }
    }, [_vm._v("x" + _vm._s(item.number))])]), _vm._v(" "), _c('div', {
      staticClass: "fr flexrow"
    }, [(item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined) ? _c('span', {
      staticClass: "fr pri ori_pri",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.originalGdAmount))]) : _c('span', {
      staticClass: "fr pri ori_pri",
      staticStyle: {
        "margin-right": "0"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fr pri",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.salePrice))])])])
  }), _vm._v(" "), _c('p', [_c('span', [_vm._v("送达:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryDate) + " " + _vm._s(_vm.orderInfo.deliveryTime))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("单号:")]), _vm._v(_vm._s(_vm.orderInfo.orderCode))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("来源:")]), _vm._v(_vm._s(_vm.orderInfo.sysName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("标识:")]), _vm._v(_vm._s(_vm.orderInfo.orderShortNum))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("下单:")]), _vm._v(_vm._s(_vm.orderCreateTime))])], 2)])])])])]) : _c('div', [_c('div', {
    staticClass: "status-list slef-take-status"
  }, [_c('ul', _vm._l((_vm.pickupProcess), function(item) {
    return _c('li', [_c('div', {
      staticClass: "text-box"
    }, [_c('h2', {
      staticStyle: {
        "font-size": ".26rem"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "status-tip",
      class: {
        'transparent': _vm.statusList.length == 1
      }
    }, [_c('span')])])
  }), 0)])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPage) ? _c('div', {
    staticClass: "mycoupons"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTake),
      expression: "showTake"
    }]
  }, [(_vm.couponsList.length > 0) ? _c('ul', _vm._l((_vm.couponsList), function(item, index) {
    return _c('li', {
      key: index,
      class: item.coupon_property == 4 ? 'package' : ''
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v("\n          " + _vm._s(item.coupon_property_str) + "\n        ")]), _vm._v(" "), _c('p', {
      staticClass: "coupon-name"
    }, [_c('span', {
      staticClass: "coupon-name-tit disabled"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]) : _vm._e(), _vm._v("\n            " + _vm._s(item.amount) + "\n            "), (item.is_discount == 1) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date disabled"
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.finished_at))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "fr fs-20"
    }, [_vm._v("\n            " + _vm._s(item.use_condition) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "with-top-line"
    }, [(item.coupon_property == 4) ? _c('span', {
      staticClass: "fl disabled"
    }, [_vm._v(_vm._s(item.package_limit))]) : _c('span', {
      staticClass: "fl disabled"
    }, [_vm._v(_vm._s(item.description))])]), _vm._v(" "), (item.showPackageRule && item.coupon_property == 4) ? _c('p', {
      staticClass: "use-rule",
      domProps: {
        "innerHTML": _vm._s(item.package_rule)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [(item.status == 2) ? _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": __webpack_require__(348)
      }
    }) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": __webpack_require__(347)
      }
    }) : _vm._e()])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.couponsList.length > 0) ? _c('div', {
    staticClass: "ac",
    staticStyle: {
      "padding": ".3rem 0",
      "color": "#999"
    }
  }, [_vm._v("仅展示最近14天的过期优惠券")]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "record-list"
  }, _vm._l((_vm.recordList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(((item.promotion_name) + "-" + (item.coupon_num) + "张" + (item.coupon_amount) + "元优惠券")))]), _vm._v(" "), _c('div', {
      staticClass: "price",
      class: item.order_status === 0 ? 'c-FF4A61' : ''
    }, [_vm._v("¥"), _c('span', [_vm._v(_vm._s(item.payment_amount))])])]), _vm._v(" "), (item.order_status === 0) ? _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div'), _vm._v(" "), _c('div', {
      staticClass: "c-FF4A61"
    }, [_vm._v("待支付")])]) : _vm._e(), _vm._v(" "), (item.order_status === 0) ? _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div', [_vm._v(_vm._s(item.order_date) + "自动取消")]), _vm._v(" "), _c('div', {
      staticClass: "btns"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.cancelOrder(item.order_id)
        }
      }
    }, [_vm._v("取消订单")]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-pay",
      on: {
        "click": function($event) {
          return _vm.toPay(item)
        }
      }
    }, [_vm._v("继续支付")])])]) : _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "padding-top": ".2rem"
      }
    }, [_c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', {
      staticClass: "c-999"
    }, [_vm._v(_vm._s(item.order_statusTips))])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "address-box"
  }, [_vm._m(0), _vm._v(" "), (_vm.mapAddr != null && _vm.mapAddr != '' && _vm.mapAddr != undefined) ? _c('h3', [_vm._v(_vm._s(_vm.mapAddr))]) : _vm._e()]), _vm._v(" "), (_vm.mapPic != null && _vm.mapPic != '' && _vm.mapPic != undefined) ? _c('img', {
    staticClass: "pic",
    attrs: {
      "src": _vm.mapPic
    }
  }) : _c('div', {
    staticClass: "no-pic"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "icon-location"
  }), _vm._v("自提地点")])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluate"
  }, [_c('a', [_c('em', {
    style: ({
      width: _vm.star1
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star2
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star3
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star4
    })
  })]), _vm._v(" "), _c('a', [_c('em', {
    style: ({
      width: _vm.star5
    })
  })])])
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "member"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }), _vm._v("\n    " + _vm._s(_vm.userInfo.nickname) + "\n  ")]), _vm._v(" "), (_vm.userInfo && _vm.userInfo.level_pic_three.length > 0) ? _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.level_pic_three,
      "alt": "",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_vm._v("已打败" + _vm._s(_vm.userInfo.win_user * 100) + "%的用户")])]), _vm._v(" "), _c('div', {
    staticClass: "medal"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.medal_three,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "exp"
  }, [_c('div', {
    staticStyle: {
      "font-size": ".24rem"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.exp))]), _vm._v("/" + _vm._s(_vm.userInfo.next_level_exp))]), _vm._v(" "), _c('div', {
    staticClass: "process"
  }, [_c('div', {
    style: ({
      width: _vm.userInfo.expPecent
    })
  })]), _vm._v(" "), _c('div', [_vm._v("再获取" + _vm._s(_vm.userInfo.need_exp) + "经验值可升级")])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold fs-24"
  }, [_c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.join_aly_day))]), _vm._v("天")]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("加入俺来也")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold fs-24"
  }, [_c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.order_time))]), _vm._v("次")]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("累计下单")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("¥"), _c('span', {
    staticClass: "fs-32"
  }, [_vm._v(_vm._s(_vm.userInfo.order_money))])]), _vm._v(" "), _c('p', {
    staticClass: "fs-20"
  }, [_vm._v("累计消费")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "get-ways"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("2021年01月08日生效")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.viewExp()
      }
    }
  }, [_vm._v("查看升级所需经验")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(321),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(325),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("每日签到")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+5")]), _vm._v("经验/天，连续签到"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+8")]), _vm._v("经验/天")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(329),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("校内订餐")]), _vm._v(" "), _c('p', [_vm._v("每单每元"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+1")]), _vm._v("经验，上限"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验/单")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(322),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("订单评价")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+5")]), _vm._v("经验/每单评价")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(328),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("完善社区资料头像昵称")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验，仅限获得一次")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(330),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("申请西游侠")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+20")]), _vm._v("经验")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": __webpack_require__(323),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "words"
  }, [_c('p', {
    staticClass: "fs-28 c-000"
  }, [_vm._v("每日送单")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+2")]), _vm._v("经验，上限"), _c('span', {
    staticClass: "c-FF9E00"
  }, [_vm._v("+10")]), _vm._v("经验")])])])])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbox"
  })
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.previewPictures && _vm.previewPictures.length > 0) ? _c('div', {
    staticClass: "prove-images"
  }, _vm._l((_vm.previewPictures), function(item) {
    return _c('div', {
      staticClass: "thumbnail",
      style: ({
        backgroundImage: 'url(' + item + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.viewLarge($event)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showLarge) ? _c('div', {
    staticClass: "large-box",
    on: {
      "click": _vm.viewLarge
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.largeImageList), function(item) {
    return _c('div', {
      staticClass: "swiper-slide swiper-item",
      style: (item)
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "page-num"
  }, [_vm._v(_vm._s(_vm.pictureIndex) + " / " + _vm._s(_vm.pictureTotal))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "refund"
  }, [_c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', {
      'active': _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('total')
      }
    }
  }, [_c('p', [_vm._v("退全部商品")])]), _vm._v(" "), _c('div', {
    class: ['fl', {
      'active': !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('part')
      }
    }
  }, [_c('p', [_vm._v("退部分商品")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "goods-info",
    staticStyle: {
      "padding": "0.3rem 0.2rem"
    }
  }, [_c('h3', [_vm._v("退款商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.goodsList), function(item) {
    return _c('li', [_c('div', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "fl",
      staticStyle: {
        "width": "70%",
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "goodImg",
      style: ({
        backgroundImage: 'url(' + item.picAddr + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "goodsInfo"
    }, [_c('span', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.attribute) ? _c('span', {
      staticStyle: {
        "font-size": ".24rem",
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.attribute))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("x" + _vm._s(item.number))])])]), _vm._v(" "), _c('div', {
      staticClass: "fr",
      staticStyle: {
        "width": "30%",
        "height": "1rem",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "flex",
        "justify-content": "flex-end",
        "color": "#333"
      }
    }, [_vm._v("实付：￥" + _vm._s(item.realAmount))]), _vm._v(" "), (!_vm.isShow) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "flex-end"
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showRefundNum),
        expression: "item.showRefundNum"
      }],
      staticClass: "operatorBtn minus",
      on: {
        "click": function($event) {
          return _vm.subtractGoods(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showRefundNum),
        expression: "item.showRefundNum"
      }],
      staticClass: "operatorBtn number"
    }, [_vm._v(_vm._s(item.refundNumber))]), _vm._v(" "), _c('span', {
      staticClass: "operatorBtn plus",
      on: {
        "click": function($event) {
          return _vm.addRefundGoods(item)
        }
      }
    })]) : _vm._e()])]), _vm._v(" "), _vm._l((item.attributeGoodsList), function(attr) {
      return _c('div', {
        staticStyle: {
          "padding-top": ".2rem",
          "overflow": "hidden"
        }
      }, [_c('div', {
        staticClass: "fl",
        staticStyle: {
          "width": "70%",
          "display": "flex"
        }
      }, [_vm._m(0, true), _vm._v(" "), _c('div', {
        staticClass: "goodsInfo"
      }, [_c('span', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(attr.title))]), _vm._v(" "), _c('span', [_vm._v("x" + _vm._s(attr.number))])])]), _vm._v(" "), _c('div', {
        staticClass: "fr",
        staticStyle: {
          "width": "30%",
          "height": "1rem",
          "display": "flex",
          "flex-direction": "column",
          "justify-content": "space-between"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "flex",
          "justify-content": "flex-end",
          "color": "#333"
        }
      }, [_vm._v("实付：￥" + _vm._s(attr.realAmount))]), _vm._v(" "), (!_vm.isShow) ? _c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "flex-end"
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (attr.showRefundNum),
          expression: "attr.showRefundNum"
        }],
        staticClass: "operatorBtn minus",
        on: {
          "click": function($event) {
            return _vm.subtractGoods(item, attr)
          }
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (attr.showRefundNum),
          expression: "attr.showRefundNum"
        }],
        staticClass: "operatorBtn number"
      }, [_vm._v(_vm._s(attr.refundNumber))]), _vm._v(" "), _c('span', {
        staticClass: "operatorBtn plus",
        on: {
          "click": function($event) {
            return _vm.addRefundGoods(item, attr)
          }
        }
      })]) : _vm._e()])])
    })], 2)
  }), 0), _vm._v(" "), (_vm.totalGoodList.length > 2) ? _c('div', [(_vm.showMore == true) ? _c('div', {
    staticClass: "more ac",
    on: {
      "click": _vm.openList
    }
  }, [_c('span', [_vm._v("查看更多")]), _c('span', {
    staticClass: "arrow-down",
    staticStyle: {
      "background-size": "0.14rem 0.08rem"
    }
  })]) : _c('div', {
    staticClass: "more ac",
    on: {
      "click": _vm.closeList
    }
  }, [_c('span', [_vm._v("收起")]), _c('span', {
    staticClass: "arrow-up"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "refund-reason"
  }, [_c('ul', [_c('li', {
    staticClass: "arrow-right clearflow",
    staticStyle: {
      "padding-right": "0.3rem"
    },
    on: {
      "click": _vm.showReasonBox
    }
  }, [_c('h3', {
    staticClass: "fl"
  }, [_vm._v("退款原因")]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.refundReason.reasonDesc))])]), _vm._v(" "), (_vm.refundReason.responsibleDesc) ? _c('li', {
    staticClass: "flex-row-bc make-call"
  }, [_c('div', [_vm._v(_vm._s(_vm.refundReason.responsibleDesc))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-yellow fs-24",
    staticStyle: {
      "padding": ".1rem"
    },
    attrs: {
      "href": 'tel:' + _vm.refundReason.responsibleTel
    }
  }, [_vm._v(_vm._s(_vm.refundReason.responsibleBtn))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1.06rem",
      "padding": "0.2rem",
      "background": "#F8F8F8"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "请输入详细信息以便更快帮您处理（必填）"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "upLoadPicture",
    staticStyle: {
      "padding-top": "0.3rem"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "addPic"
  }, [_c('ul', {
    staticClass: "fl"
  }, _vm._l((_vm.goodsImages), function(item) {
    return _c('li', {
      staticClass: "fl upLoadPic"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletepic(item)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddShow),
      expression: "isAddShow"
    }],
    staticClass: "addPicBtn fl"
  }, [_c('form', {
    attrs: {
      "id": "uploadForm",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "uploadImg",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.getImage($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "complaints_reason_select",
    on: {
      "click": function($event) {
        return _vm.hiddenList(2)
      }
    }
  }, [_c('div', {
    staticClass: "reason-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请选择退款原因")]), _vm._v(" "), _vm._l((_vm.reasonList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.list), function(item1, index1) {
      return _c('div', {
        key: index1,
        staticClass: "item",
        class: {
          on: item1.isDefault == 1
        },
        on: {
          "click": function($event) {
            return _vm.handleClick(item1, index1)
          }
        }
      }, [_vm._v("\n          " + _vm._s(item1.reasonDesc) + "\n          "), _c('span', {
        staticClass: "icon_selected"
      })])
    })], 2)
  })], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "fixed"
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "footer-con fl flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('p', {
    staticClass: "save",
    staticStyle: {
      "color": "#F4576A"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.36rem",
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundAmount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.28rem"
    }
  }, [_vm._v("(原路返回)")])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.refundDetail.totalRefundDesc))])]) : _c('div', {
    staticClass: "footer-con fl flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('p', {
    staticClass: "save",
    staticStyle: {
      "color": "#F4576A"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.36rem",
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.refundAmount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.28rem"
    }
  }, [_vm._v("(原路返回)")])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.refundDetail.partRefundDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "footer-con fr flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.canSubmit) ? _c('a', {
    staticClass: "btn btn-yellow",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]) : _c('a', {
    staticClass: "btn btn-gray"
  }, [_vm._v("提交")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(315),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearflow"
  }, [_c('h3', {
    staticClass: "fl"
  }, [_vm._v("上传图片")]), _c('span', {
    staticClass: "tips"
  }, [_vm._v("(上传照片作为凭证，退款申请被同意的概率更大)")])])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodsList",
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.showPage) ? _c('div', [_c('div', {
    class: ['main', {
      'no-foot': _vm.showBlock != 'orderDishes'
    }]
  }, [_c('div', {
    staticClass: "top-area",
    staticStyle: {
      "margin-bottom": "0.5rem"
    },
    attrs: {
      "id": "topArea"
    },
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  }, [_c('div', {
    staticClass: "bg-pic-box"
  }, [_c('div', {
    staticClass: "bg-pic",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }, [_c('div', {
    staticClass: "top-area-mask"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "shop-img",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-info fl"
  }, [_c('div', {
    staticClass: "shop-des"
  }, [_c('div', {
    staticClass: "flexrow ellipse",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("起送 ￥" + _vm._s(_vm.shopDetail.threshold_amount))]), _c('span', {
    staticStyle: {
      "margin": "0 0.05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v(" "), (_vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                  ")]) : _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.shopDetail.delivery_fee))]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 0.05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v("月售" + _vm._s(_vm.shopDetail.sales_append) + "单\n                ")], 2), _vm._v(" "), (_vm.shopDetail.announcement && !_vm.shopDetail.dinner_duration) ? _c('div', {
    staticClass: "announcement"
  }, [_vm._v("\n                公告：" + _vm._s(_vm.shopDetail.announcement) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.dinner_duration) ? _c('div', {
    staticStyle: {
      "font-size": ".22rem",
      "width": "100%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.shopDetail.dinner_duration) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), ((_vm.couponInfo.coupon_list && _vm.couponInfo.coupon_list.length > 0) || _vm.shopDetail.promotion_package) ? _c('div', {
    staticClass: "shop-coupon"
  }, [(_vm.shopDetail.promotion_package && _vm.shopDetail.promotion_package.length > 0) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.shopDetail.promotion_package), function(coupon, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-item package",
      class: {
        checked: coupon.status == 1
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(coupon)
        }
      }
    }, [_c('div', {
      staticClass: "fs-20"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-40 fw-bold"
    }, [_vm._v(_vm._s(coupon.package_price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0 .15rem"
      }
    }, [_c('div', {
      staticClass: "fs-24 ellipse"
    }, [_vm._v(_vm._s(coupon.promotion_name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-18 ellipse"
    }, [_vm._v(_vm._s(coupon.package_desc))])]), _vm._v(" "), (coupon.status == 1) ? _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": __webpack_require__(116)
      }
    }) : _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": __webpack_require__(117)
      }
    }), _vm._v(" "), (coupon.status == 1) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("已购")]) : _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("超值购")])])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.couponInfo.coupon_list), function(coupon, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-item",
      class: {
        checked: coupon.status == 1 || coupon.status == 2
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.receiveCoupon(coupon)
        }
      }
    }, [_c('div', {
      staticClass: "fs-20"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-40 fw-bold"
    }, [_vm._v(_vm._s(coupon.couponAmount))]), _vm._v(_vm._s(coupon.decimal ? '.' + coupon.decimal : '') + "\n              ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0 .15rem"
      }
    }, [_c('div', {
      staticClass: "fs-24"
    }, [_vm._v(_vm._s(coupon.couponName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-18 ellipse"
    }, [_vm._v(_vm._s(coupon.amountCondition))])]), _vm._v(" "), (coupon.status == 1 || coupon.status == 2) ? _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": __webpack_require__(116)
      }
    }) : _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": __webpack_require__(117)
      }
    }), _vm._v(" "), (coupon.status == 1) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("已领")]) : (coupon.status == 2) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("不可领")]) : _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("领")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [((_vm.shopDetail.promotion_list && _vm.shopDetail.promotion_list.length > 0) || _vm.shopDetail.promotion_reduce) ? _c('div', {
    staticClass: "activity-info"
  }, [_c('div', {
    staticClass: "special-goods arrow-down flexrow",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "75%"
    }
  }, [(_vm.shopDetail.promotion_list1) ? _c('div', {
    staticClass: "promotion_reduce"
  }, _vm._l((_vm.shopDetail.promotion_list1), function(item) {
    return _c('span', {
      staticClass: "promotion_reduce-type border"
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0) ? _c('span', {
    staticClass: "activities fr"
  }, [_vm._v("共" + _vm._s(_vm.shopDetail.promotion_list ? (_vm.shopDetail.promotion_list.length + 1) : 1) + "个活动")]) : _c('span', {
    staticClass: "activities fr"
  }, [_vm._v("共" + _vm._s(_vm.shopDetail.promotion_list.length) + "个活动")])])]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.announcement && _vm.shopDetail.dinner_duration) ? _c('div', {
    staticClass: "announcement",
    staticStyle: {
      "margin-left": ".26rem",
      "color": "#999"
    }
  }, [_vm._v("公告：" + _vm._s(_vm.shopDetail.announcement) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar col33",
    staticStyle: {
      "margin-top": "0.3rem"
    },
    attrs: {
      "id": "checkTab"
    }
  }, [_c('a', {
    class: {
      active: _vm.showBlock == 'orderDishes'
    },
    attrs: {
      "id": "orderDishes"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showBlock == 'commentInfo'
    },
    attrs: {
      "id": "commentInfo"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("评价")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showBlock == 'shopInfo'
    },
    attrs: {
      "id": "shopInfo"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("商家")]), _vm._v(" "), _c('div', {
    staticClass: "shop-search",
    on: {
      "click": function($event) {
        return _vm.toShopSearch()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'orderDishes'),
      expression: "showBlock == 'orderDishes'"
    }],
    staticClass: "content"
  }, [(_vm.req_type) ? _c('div', [_c('div', {
    staticClass: "goods-list1",
    attrs: {
      "id": "goodList"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      "id": "scroller"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.myGoodsList), function(item1) {
    return (item1.goods_list && item1.goods_list.length) ? _c('ul', {
      staticStyle: {
        "border": "none"
      },
      attrs: {
        "id": "myUl"
      }
    }, [_vm._l((item1.goods_list), function(item, index) {
      return _c('li', {
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "id": item.tag_id + 'goods' + index
        }
      }, [_c('div', {
        staticClass: "goods-box",
        class: item.gd_code == _vm.gdCode ? 'isHightGood' : '',
        on: {
          "click": function($event) {
            return _vm.toggleProp('goodInfo', item)
          }
        }
      }, [_c('div', {
        staticClass: "goods-img"
      }, [_c('div', {
        staticClass: "lazy goodimg",
        style: ({
          backgroundImage: 'url(' + item.image_url + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-des flexrow",
        staticStyle: {
          "padding-right": "0"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), (item.activity_specification && item.is_single_spec == 0) ? _c('p', [_vm._v("\n                          " + _vm._s(item.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item.sales_volume))]), _vm._v(" "), _c('div', {
        staticClass: "flexrow",
        staticStyle: {
          "justify-content": "space-between",
          "align-items": "center"
        }
      }, [(item.activity_id > 0) ? _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item.price))])]) : _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item.price))]), _vm._v(" "), (item.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item.sales_status == 1 && item.stock > 0) ? _c('div', {
        staticClass: "num-box"
      }, [(item.is_options == 1) ? _c('div', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleProp('specInfo', item)
          }
        }
      }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item.cartNum > 0) ? _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s(item.cartNum))]) : _vm._e()]) : _c('div', [(item.cartNum > 0) ? _c('span', {
        staticClass: "btns minusBtn icon-removecart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.minusGoods(item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.cartNum > 0) ? _c('span', {
        staticClass: "box"
      }, [_vm._v(_vm._s(item.cartNum))]) : _vm._e(), _vm._v(" "), (item.smallNumber > 1 && !item.cartNum) ? _c('span', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item)
          }
        }
      }, [_vm._v(_vm._s(item.smallNumber) + "份起购")]) : (!item.noStock || item.smallNumber <= 1 && !item.cartNum) ? _c('span', {
        staticClass: "btns addBtn icon-addtocart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item)
          }
        }
      }) : _c('span', {
        staticClass: "btns addBtn icon-cantaddtocart"
      })])]) : _c('span', {
        staticClass: "num-box sales-out"
      }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item.activity_desc) ? _c('div', {
        staticClass: "sale-box"
      }, [(item.activity_desc && item.activity_desc != '') ? _c('span', {
        staticClass: "no-bg"
      }, [_vm._v(_vm._s(item.activity_desc))]) : _vm._e(), _vm._v(" "), (item.activity_id > 0 && item.sales_status == 1 && item.left_stock <= 10) ? _c('span', {
        staticClass: "bg"
      }, [_vm._v("剩" + _vm._s(item.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "1.26rem",
          "margin-top": "0.1rem"
        }
      }, [(item.partner != 0 && item.activity_desc_extra) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item.show_text) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item.show_text))]) : _vm._e()])])])
    }), _vm._v(" "), (_vm.noMore) ? _c('li', {
      staticClass: "no-more"
    }, [_vm._v("没有更多内容啦~请切换下一个分类")]) : _vm._e()], 2) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "side-bar",
    attrs: {
      "id": "sideBar1"
    }
  }, [_c('div', {
    staticClass: "side-bar-scroll",
    attrs: {
      "id": "scrollBox1"
    }
  }, _vm._l((_vm.myGoodsList), function(item) {
    return _c('a', {
      class: {
        active: item.isActive
      },
      attrs: {
        "id": item.tag_name
      },
      on: {
        "click": function($event) {
          return _vm.scrollGoods1(item)
        }
      }
    }, [(item.is_special_tag > 0) ? _c('span', {
      staticClass: "icon icon-sale"
    }, [_vm._v(_vm._s(item.tag_name_short))]) : _c('span', [_vm._v(_vm._s(item.tag_name_short))]), _vm._v(" "), (item.tagNum > 0 && item.is_special_tag <= 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.tagNum))]) : _vm._e()])
  }), 0)])]) : _c('div', [_c('div', {
    staticClass: "goods-list",
    attrs: {
      "id": "goodList"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      "id": "scroller"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('ul', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('li', {
      staticClass: "title",
      attrs: {
        "id": item.tag_id
      }
    }, [_vm._v(_vm._s(item.tag_name))]), _vm._v(" "), _vm._l((item.goods_list), function(item2, index) {
      return _c('li', {
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "id": item.tag_id + 'goods' + index
        }
      }, [_c('div', {
        staticClass: "goods-box",
        class: item2.gd_code == _vm.gdCode ? 'isHightGood' : '',
        on: {
          "click": function($event) {
            return _vm.toggleProp('goodInfo', item2)
          }
        }
      }, [_c('div', {
        staticClass: "goods-img"
      }, [_c('div', {
        staticClass: "lazy goodimg",
        style: ({
          backgroundImage: 'url(' + item2.image_url + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-des flexrow",
        staticStyle: {
          "padding-right": "0"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item2.goods_name))]), _vm._v(" "), (item2.activity_specification && item2.is_single_spec == 0) ? _c('p', [_vm._v("\n                          " + _vm._s(item2.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item2.sales_volume))]), _vm._v(" "), _c('div', {
        staticClass: "flexrow",
        staticStyle: {
          "justify-content": "space-between",
          "align-items": "center"
        }
      }, [(item2.activity_id > 0) ? _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item2.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item2.price))])]) : _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item2.price))]), _vm._v(" "), (item2.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item2.sales_status == 1 && item2.stock > 0) ? _c('div', {
        staticClass: "num-box"
      }, [(item2.is_options == 1) ? _c('div', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleProp('specInfo', item2)
          }
        }
      }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e()]) : _c('div', [(item2.cartNum > 0) ? _c('span', {
        staticClass: "btns minusBtn icon-removecart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.minusGoods(item2)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
        staticClass: "box"
      }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e(), _vm._v(" "), (item2.smallNumber > 1 && !item2.cartNum) ? _c('span', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item2)
          }
        }
      }, [_vm._v(_vm._s(item2.smallNumber) + "份起购")]) : (!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum) ? _c('span', {
        staticClass: "btns addBtn icon-addtocart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item2)
          }
        }
      }) : _c('span', {
        staticClass: "btns addBtn icon-cantaddtocart"
      })])]) : _c('span', {
        staticClass: "num-box sales-out"
      }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item2.activity_desc) ? _c('div', {
        staticClass: "sale-box"
      }, [(item2.activity_desc && item2.activity_desc != '') ? _c('span', {
        staticClass: "no-bg"
      }, [_vm._v(_vm._s(item2.activity_desc))]) : _vm._e(), _vm._v(" "), (item2.activity_id > 0 && item2.sales_status == 1 && item2.left_stock <= 10) ? _c('span', {
        staticClass: "bg"
      }, [_vm._v("剩" + _vm._s(item2.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "1.26rem",
          "margin-top": "0.1rem"
        }
      }, [(item2.partner != 0 && item2.activity_desc_extra) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item2.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item2.show_text) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item2.show_text))]) : _vm._e()])])])
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "side-bar",
    attrs: {
      "id": "sideBar"
    }
  }, [_c('div', {
    staticClass: "side-bar-scroll",
    attrs: {
      "id": "scrollBox"
    }
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('a', {
      class: {
        active: item.isActive
      },
      attrs: {
        "id": item.tag_name
      },
      on: {
        "click": function($event) {
          return _vm.scrollGoods(item)
        }
      }
    }, [(item.is_special_tag > 0) ? _c('span', {
      staticClass: "icon icon-sale"
    }, [_vm._v(_vm._s(item.tag_name_short))]) : _c('span', [_vm._v(_vm._s(item.tag_name_short))]), _vm._v(" "), (item.tagNum > 0 && item.is_special_tag <= 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.tagNum))]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'commentInfo'),
      expression: "showBlock == 'commentInfo'"
    }],
    staticClass: "content3 usercenter",
    attrs: {
      "id": "content3"
    }
  }, [_c('div', [_c('div', {
    staticClass: "shop-comment"
  }, [_c('span', [_vm._v(_vm._s(_vm.shopDetail.score))]), _vm._v(" "), _c('CommentStars', {
    attrs: {
      "qualityCode": _vm.shopDetail.score
    }
  }), _vm._v(" "), (_vm.CommentNum != '') ? _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.CommentNum) + "名同学参与菜品反馈")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.businessCommentList.length) ? _c('ul', {
    staticClass: "comments-list"
  }, _vm._l((_vm.businessCommentList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + item.userPhotoUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "font-size": "0.22rem",
        "color": "#797979",
        "align-items": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("评分")]), _vm._v(" "), _c('CommentStars', {
      attrs: {
        "qualityCode": item.qualityCode
      }
    })], 1), _vm._v(" "), (item.comment != '') ? _c('div', {
      staticClass: "des"
    }, [_vm._v(_vm._s(item.comment))]) : _vm._e(), _vm._v(" "), _c('PreviewPicture', {
      attrs: {
        "previewPictures": item.urls
      }
    }), _vm._v(" "), (item.goodsMarkList.length > 0) ? _c('div', {
      staticClass: "goodsmark_list"
    }, [(item.goodList.length > 0) ? _c('div', [_c('span', {
      staticClass: "icon good"
    }), _vm._v(" "), _c('p', _vm._l((item.goodList), function(item1, index) {
      return _c('span', [_vm._v(_vm._s(item1)), (index < item.goodList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.badList.length > 0) ? _c('div', [_c('span', {
      staticClass: "icon bad"
    }), _vm._v(" "), _c('p', _vm._l((item.badList), function(item2, index) {
      return _c('span', [_vm._v(_vm._s(item2)), (index < item.badList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.isReply == 1) ? _c('div', {
      staticClass: "reply_comment"
    }, [_vm._v("商家回复：" + _vm._s(item.replyComment))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))])], 1)])
  }), 0) : _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "10rem",
      "text-align": "center"
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'shopInfo'),
      expression: "showBlock == 'shopInfo'"
    }],
    staticClass: "content2 usercenter",
    attrs: {
      "id": "content2"
    }
  }, [_c('div', [_c('div', {
    staticClass: "shop-info"
  }, [_c('h3', [_vm._v("商家信息")]), _vm._v(" "), _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商家电话:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.shopDetail.service_tel))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商家地址:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.shopDetail.address))])]), _vm._v(" "), (_vm.shopDetail.open_rules == 0 && _vm.shopDetail.open_setting != null) ? _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("营业时间:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.openTime))])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.open_rules == 1 && _vm.shopDetail.weeks_no && _vm.shopDetail.weeks_no.length > 0) ? _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("营业时间:")]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, _vm._l((_vm.shopDetail.weeks_no), function(item) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(item.weekstr))]), _vm._v(" "), _vm._l((item.open_setting), function(item2) {
      return _c('p', [_vm._v("\n                      " + _vm._s(item2.begin_time) + "-" + _vm._s(item2.end_time) + "\n                    ")])
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.aptitude && _vm.shopDetail.aptitude.license_list && _vm.shopDetail.aptitude.license_list.length > 0) ? _c('div', [_c('span', {
    staticClass: "license"
  }, [_vm._v("营业执照:")]), _vm._v(" "), _c('PreviewPicture', {
    attrs: {
      "previewPictures": _vm.shopDetail.aptitude.license_url_list
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shopDetail.aptitude && _vm.shopDetail.aptitude.food_license_list && _vm.shopDetail.aptitude.food_license_list.length > 0) ? _c('div', [_c('span', {
    staticClass: "license"
  }, [_vm._v("食品经营许可证(食品流通许可证):")]), _vm._v(" "), _c('PreviewPicture', {
    attrs: {
      "previewPictures": _vm.shopDetail.aptitude.food_license_url_list
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "list order-list"
  }, [_c('ul', _vm._l((_vm.shopDetail.other_info), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.showOtherInfo(item)
        }
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "icon_arrow_next fr"
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(_vm.showBlock == 'orderDishes') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "fixed",
      "bottom": "1rem",
      "left": "0",
      "z-index": "18"
    }
  }, [(_vm.cartInfo[_vm.shopCode].total > 0) ? _c('div', [(_vm.shopDetail.promotion_reduce && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [(_vm.nextFullReductionAmountGap != '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元，")]) : _vm._e(), _vm._v("再买"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.nextFullReductionAmountGap) + "元 ")]), _vm._v("减"), _c('span', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.nextFullReductionAmount) + "元")])]) : (_vm.nextFullReductionAmountGap == '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元")]) : _vm._e()]) : _vm._e()]) : (_vm.hasSpecial && _vm.reductionAmount > 0) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_c('span', [_vm._v("特价折扣优惠" + _vm._s(_vm.reductionAmount) + "元")])]) : _vm._e()]) : _c('div', [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0 && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_vm._v("\n              " + _vm._s(_vm.shopDetail.promotion_reduce.promotion_name) + "\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showBlock == 'orderDishes') ? _c('footer', {
    staticClass: "dark fixed cart flexrow",
    staticStyle: {
      "padding": "0 0.26rem",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "footer-cart"
  }, [_c('div', {
    staticClass: "cart-box-bg"
  }, [(_vm.cartInfo[_vm.shopCode].total <= 0) ? _c('div', {
    staticClass: "cart-box empty"
  }) : _c('div', {
    staticClass: "cart-box",
    attrs: {
      "id": "cart"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toggleProp('cart')
      }
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.cartTotal))])])])]), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 0)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("只能打包自提")])]) : _vm._e(), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 0 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("只能堂食")])]) : _vm._e(), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("支持自提 | 堂食")])]) : (_vm.cartTotal <= 0 && _vm.shopDetail.is_take_out == 1) ? _c('div', {
    staticClass: "price empty tips"
  }, [(_vm.shopDetail.new_delivery_fee === 0 && _vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                另需配送费￥" + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n              ")]) : _c('span', [_vm._v("另需配送费￥" + _vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1) ? _c('span', [_vm._v(" | 支持自提")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_eat_in == 1) ? _c('span', [_vm._v(" | 堂食")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cartTotal > 0) ? _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.cartAmount))]), _vm._v(" "), (_vm.cartOriginAmount - _vm.cartAmount > 0) ? _c('span', {
    staticStyle: {
      "text-decoration": "line-through",
      "color": "#797979",
      "font-size": "0.2rem"
    }
  }, [_vm._v("￥" + _vm._s(_vm.cartOriginAmount))]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 0) ? _c('div', {
    staticClass: "tips"
  }, [_c('span', [_vm._v("只能打包自提")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 0 && (_vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price tips"
  }, [_c('span', [_vm._v("只能堂食")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1 && (_vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price tips"
  }, [_c('span', [_vm._v("支持自提 | 堂食")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_take_out == 1) ? _c('div', {
    staticClass: "tips"
  }, [(_vm.shopDetail.new_delivery_fee === 0 && _vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                  另需配送费￥" + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                ")]) : _c('span', [_vm._v("另需配送费￥" + _vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1) ? _c('span', [_vm._v(" | 支持自提")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_eat_in == 1) ? _c('span', [_vm._v(" | 堂食")]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [(_vm.cartTotal <= 0) ? _c('div', {
    staticClass: "btn btn-gray btn-lg fr"
  }, [_vm._v("去结算")]) : _c('div', [(_vm.spreadPrice <= 0 && _vm.hasNeedChoose) ? _c('div', {
    staticClass: "btn btn-main btn-lg fr",
    on: {
      "click": _vm.settleAccounts
    }
  }, [_vm._v("\n                去结算\n              ")]) : _vm._e(), _vm._v(" "), (_vm.spreadPrice <= 0 && !_vm.hasNeedChoose) ? _c('div', {
    staticClass: "btn btn-main btn-lg fr",
    staticStyle: {
      "font-size": ".28rem"
    },
    on: {
      "click": _vm.settleAccounts
    }
  }, [_vm._v("\n                未点必选品\n              ")]) : _vm._e(), _vm._v(" "), (_vm.spreadPrice > 0) ? _c('div', {
    staticClass: "btn btn-gray btn-lg fr",
    staticStyle: {
      "font-size": "0.24rem"
    }
  }, [_vm._v("\n                还差￥" + _vm._s(_vm.spreadPrice) + "起送\n              ")]) : _vm._e()])])]) : _vm._e()]) : _c('div', [_vm._m(2)]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.toggleProp('cart')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "prop-box cart-list"
  }, [(_vm.cartInfo[_vm.shopCode].total > 0) ? _c('div', [(_vm.shopDetail.promotion_reduce && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [(_vm.nextFullReductionAmountGap != '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元，")]) : _vm._e(), _vm._v("再买"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.nextFullReductionAmountGap) + "元 ")]), _vm._v("减"), _c('span', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.nextFullReductionAmount) + "元")])]) : (_vm.nextFullReductionAmountGap == '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元")]) : _vm._e()]) : _vm._e()]) : (_vm.hasSpecial && _vm.reductionAmount > 0) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_c('span', [_vm._v("特价折扣优惠" + _vm._s(_vm.reductionAmount) + "元")])]) : _vm._e()]) : _c('div', [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0 && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_vm._v("\n            " + _vm._s(_vm.shopDetail.promotion_reduce.promotion_name) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.cartInfo[_vm.shopCode].packFee > 0) ? _c('div', {
    staticClass: "flex-row-sc fl",
    on: {
      "click": function($event) {
        return _vm.viewPackDesc()
      }
    }
  }, [_c('div', {
    staticClass: "fs-24",
    staticStyle: {
      "padding": "0 .1rem"
    }
  }, [_vm._v("打包费"), _c('span', {
    staticClass: "red"
  }, [_vm._v("¥" + _vm._s(_vm.cartInfo[_vm.shopCode].packFee))])]), _vm._v(" "), _c('span', {
    staticClass: "icon-desc"
  }, [_vm._v("?")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon icon-delete fr",
    on: {
      "click": _vm.clearCart
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('ul', _vm._l((_vm.shopCartInfo), function(item) {
    return _c('li', [_c('div', {
      staticClass: "rol goods-name",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n              " + _vm._s(item.gdName) + "\n              "), (item.specAttrStr) ? _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.specAttrStr))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "rol pr"
    }, [_vm._v("￥" + _vm._s(item.singleTotalPrice))]), _vm._v(" "), (item.activityId > 0 && item.activeBuyNum > 0) ? _c('del', {
      staticClass: "rol pr"
    }, [_vm._v("￥" + _vm._s(item.singleOriginPrice))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rol num-box"
    }, [_c('span', {
      staticClass: "btns minusBtn icon-removecart",
      on: {
        "click": function($event) {
          return _vm.minusGoods(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    }, [_vm._v(_vm._s(item.cartNum))]), _vm._v(" "), (!item.noStock) ? _c('span', {
      staticClass: "btns addBtn icon-addtocart",
      on: {
        "click": function($event) {
          return _vm.addGoods(item)
        }
      }
    }) : _c('span', {
      staticClass: "btns addBtn icon-cantaddtocart"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propShopInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShopInfo) ? _c('div', {
    staticClass: "alert-box info",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "shop-img",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-name"
  }, [_vm._v(_vm._s(_vm.shopDetail.shop_name))]), _vm._v(" "), _c('CommentStars', {
    attrs: {
      "qualityCode": _vm.shopDetail.score
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopDetail.score))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 .05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售" + _vm._s(_vm.shopDetail.sales_append) + "单")]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "font-size": ".22rem"
    }
  }, [_c('div', [_vm._v("起送 ￥" + _vm._s(_vm.shopDetail.threshold_amount))]), _vm._v(" "), _c('div', {
    staticClass: "ml10"
  }, [(_vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                  ")]) : _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.shopDetail.delivery_fee))]) : _vm._e()], 2), _vm._v(" "), (_vm.shopDetail.delivery_type == 1) ? _c('span', {
    staticClass: "ml10"
  }, [_vm._v("(商家配送)")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.zsd) ? _c('span', {
    staticClass: "punctual-arrive ml10"
  }, [_vm._v(_vm._s(_vm.shopDetail.zsd))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "special-box",
    staticStyle: {
      "max-height": "50vh",
      "overflow-y": "scroll",
      "overflow-scrolling": "touch",
      "-webkit-overflow-scrolling": "touch"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0) ? _c('div', {
    staticClass: "special-goods",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.promotion_reduce.icon_url + ')'
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.shopDetail.promotion_reduce.promotion_name))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shopDetail.promotion_list), function(item) {
    return (_vm.shopDetail.promotion_list && _vm.shopDetail.promotion_list.length > 0) ? _c('div', {
      staticClass: "special-goods",
      style: ({
        backgroundImage: 'url(' + item.icon_url + ')'
      })
    }, [_c('span', [_vm._v(_vm._s(item.promotion_name))])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.shopDetail.announcement) ? _c('div', {
    staticClass: "shopNoticeBox"
  }, [_c('h3', [_vm._v("公告")]), _vm._v(" "), _c('div', {
    staticClass: "special-box",
    staticStyle: {
      "border-top": "none",
      "padding-top": "0"
    }
  }, [_vm._v(_vm._s(_vm.shopDetail.announcement))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close-box shop-details",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.propGoodInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('goodInfo')
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propGoodInfo) ? _c('div', {
    staticClass: "alert-box info goods",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsDetail.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "good-name"
  }, [_vm._v(_vm._s(_vm.goodsDetail.goods_name))]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [(_vm.goodsDetail.activity_specification) ? _c('span', [_vm._v(_vm._s(_vm.goodsDetail.activity_specification) + " | ")]) : _vm._e(), _vm._v("\n            销量 " + _vm._s(_vm.goodsDetail.sales_volume) + " | 好评率 " + _vm._s(_vm.goodsDetail.praise_rate) + "%\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "price-box flexrow",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsDetail.activity_price))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.goodsDetail.price))]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(_vm.goodsDetail.sales_status == 1 && _vm.goodsDetail.stock > 0) ? _c('div', {
    staticClass: "num-box"
  }, [(_vm.goodsDetail.is_options == 1) ? _c('div', {
    staticClass: "btn-yellow select-spec-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleProp('specInfo', _vm.goodsDetail)
      }
    }
  }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.goodsDetail.cartNum))]) : _vm._e()]) : _c('div', [(_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "btns minusBtn icon-removecart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.minusGoods(_vm.goodsDetail)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "box"
  }, [_vm._v(_vm._s(_vm.goodsDetail.cartNum))]) : _vm._e(), _vm._v(" "), (!_vm.goodsDetail.noStock) ? _c('span', {
    staticClass: "btns addBtn icon-addtocart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addGoods(_vm.goodsDetail)
      }
    }
  }) : _c('span', {
    staticClass: "btns addBtn icon-cantaddtocart"
  })])]) : _c('span', {
    staticClass: "num-box sales-out"
  }, [_vm._v("售罄")])]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.activity_desc) ? _c('div', {
    staticClass: "sale-box"
  }, [_c('span', {
    staticClass: "no-bg"
  }, [_vm._v(_vm._s(_vm.goodsDetail.activity_desc))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0 && _vm.goodsDetail.sales_status == 1 && _vm.goodsDetail.left_stock <= 10) ? _c('span', {
    staticClass: "bg"
  }, [_vm._v("剩" + _vm._s(_vm.goodsDetail.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.detail) ? _c('div', {
    staticStyle: {
      "color": "#9b9b9b",
      "font-size": ".26rem",
      "margin-top": ".1rem",
      "word-break": "break-all"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.goodsDetail.detail) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": function($event) {
        return _vm.toggleProp('goodInfo')
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.previewPic) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.previewPic = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "pic-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImgUrl
    },
    on: {
      "click": function($event) {
        _vm.previewPic = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.propSpecInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('specInfo', _vm.goodsDetail)
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propSpecInfo) ? _c('div', {
    staticClass: "prop-box spec"
  }, [_c('div', {
    staticClass: "spec-close-btn",
    on: {
      "click": function($event) {
        _vm.propSpecInfo = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info flexrow"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsDetail.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexcol goods-des"
  }, [_c('div', {
    staticClass: "ellipse",
    staticStyle: {
      "font-size": "0.3rem",
      "color": "#4A4A4A",
      "font-weight": "bolder"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.goodsDetail.goods_name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "goods-spec"
  }, [_vm._v("已选: " + _vm._s(_vm.goodsDetail.specAttrStr))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0) ? _c('div', {
    staticClass: "red"
  }, [_vm._v("\n              ￥" + _vm._s(_vm.goodsDetail.activity_price) + "\n            ")]) : _c('div', {
    staticClass: "red"
  }, [_vm._v("￥" + _vm._s(_vm.goodsDetail.sales_price))])])]), _vm._v(" "), _c('div', {
    staticClass: "spec-content"
  }, [(_vm.goodsDetail.sku_list[0].specification && _vm.goodsDetail.sku_list[0].specification != '') ? _c('div', {
    staticClass: "spec-params"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_vm._v("规格")]), _vm._v(" "), _c('ul', {
    staticClass: "flexrow"
  }, _vm._l((_vm.goodsDetail.sku_list), function(item) {
    return _c('li', {
      class: [{
        'selected': item.is_selected == 1
      }, {
        'disabled-spec': item.is_can_choose == 0
      }],
      on: {
        "click": function($event) {
          return _vm.handleSelect('spec', item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.specification) + "￥" + _vm._s(item.sales_price) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.goodsDetail.attribute_list), function(item) {
    return _c('div', {
      staticClass: "spec-params"
    }, [_c('p', [_vm._v("\n              " + _vm._s(item.attributeTypeName) + "\n              "), (item.addPrice == 1) ? _c('span', [_vm._v("(" + _vm._s(item.selectTips) + ")")]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "flexrow"
    }, _vm._l((item.attributeList), function(item2) {
      return _c('li', {
        class: [{
          'selected': item2.is_selected
        }, {
          'disabled-spec': item2.saleStatus === 0
        }],
        on: {
          "click": function($event) {
            return _vm.handleSelect('attr', item2, item)
          }
        }
      }, [(item.addPrice == 1) ? _c('span', [_vm._v(_vm._s(item2.name) + "¥" + _vm._s(item2.salePrice))]) : _c('span', [_vm._v(_vm._s(item2.name))])])
    }), 0)])
  })], 2), _vm._v(" "), (_vm.goodsDetail.specifications.sales_status == 1 && _vm.goodsDetail.specifications.stock != 0) ? _c('div', {
    staticClass: "btn-yellow select-spec-alert-btn fixed",
    on: {
      "click": function($event) {
        return _vm.addGoods(_vm.goodsDetail)
      }
    }
  }, [_vm._v("选好了\n        ")]) : _c('div', {
    staticClass: "btn-gray select-spec-alert-btn fixed"
  }, [_vm._v("售罄")])]) : _vm._e(), _vm._v(" "), (_vm.isShowCartGoods) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCartGoods) ? _c('div', {
    staticClass: "alert-box change-goods"
  }, [_c('img', {
    staticStyle: {
      "width": ".21rem",
      "height": ".21rem",
      "float": "right"
    },
    attrs: {
      "src": __webpack_require__(318),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change-tit"
  }, [_vm._v("以下商品发生了变化")]), _vm._v(" "), _c('div', {
    staticClass: "change-sec-tit"
  }, [_vm._v("你可以选购其他商品")]), _vm._v(" "), _vm._l((_vm.changeGoodsInCart), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "change-goods-item"
    }, [_c('div', {
      staticClass: "ellipse",
      staticStyle: {
        "max-width": "2.8rem"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.num == 0) ? _c('span', [_vm._v("下架/售罄")]) : _vm._e(), _vm._v(" "), (item.num > 0) ? _c('span', [_vm._v(_vm._s(item.message ? item.message : ('仅剩' + item.num + '份')))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow change-goods-btn",
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      }
    }
  }, [_vm._v("重新选购")])], 2) : _vm._e(), _vm._v(" "), (_vm.couponModalOpened) ? _c('div', {
    staticClass: "mask flex-row-cc",
    on: {
      "click": _vm.closeCouponModal
    }
  }, [_c('div', {
    staticClass: "dialog-coupon"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.couponInfo.coupon_pic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, _vm._l((_vm.couponInfo.coupon_list), function(item) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "cnt flex-row-bc"
    }, [_c('div', [_c('div', {
      staticClass: "fs-46 fc-red fw-bold"
    }, [_vm._v(_vm._s(item.couponName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-26",
      staticStyle: {
        "color": "#666",
        "padding-top": ".1rem"
      }
    }, [_vm._v(_vm._s(item.couponDes))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "1.65rem"
      }
    }, [_c('div', {
      staticClass: "fc-red ac fs-36"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-46 fw-bold fc-red"
    }, [_vm._v(_vm._s(item.couponAmount))]), _vm._v(_vm._s(item.decimal ? '.' + item.decimal : '') + "\n                  ")]), _vm._v(" "), (item.status === 1) ? _c('div', {
      staticClass: "get checked"
    }, [_vm._v("已领取")]) : _vm._e(), _vm._v(" "), (item.status === 2) ? _c('div', {
      staticClass: "get checked"
    }, [_vm._v("不可领")]) : _vm._e(), _vm._v(" "), (item.status === 0) ? _c('div', {
      staticClass: "get",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.receiveCoupon(item)
        }
      }
    }, [_vm._v("点击领取")]) : _vm._e()])])])
  }), 0)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTip) ? _c('div', {
    staticClass: "sys_busy"
  }, [_c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(121)
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.tips))])])]) : _vm._e(), _vm._v(" "), (_vm.showShopSearch) ? _c('div', {
    staticClass: "shop-search-body"
  }, [_c('div', {
    staticClass: "shop-header"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": function($event) {
        return _vm.closeShopSearch()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".18rem"
    },
    attrs: {
      "src": __webpack_require__(331)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('img', {
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": __webpack_require__(111),
      "mode": "widthFix"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "placeholder": "想吃什么搜一搜",
      "id": "keyword"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "blur": function($event) {
        return _vm.submitShopSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.searchResults.length > 0) ? _c('div', {
    staticClass: "search-list"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('ul', {
    staticClass: "goods-list"
  }, _vm._l((_vm.searchResults), function(item2) {
    return _c('li', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('div', {
      staticClass: "goods-box",
      on: {
        "click": function($event) {
          return _vm.toggleProp('goodInfo', item2)
        }
      }
    }, [_c('div', {
      staticClass: "goods-img"
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: ({
        backgroundImage: 'url(' + item2.image_url + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des flexrow",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item2.goods_name))]), _vm._v(" "), (item2.activity_specification && item2.is_single_spec == 0) ? _c('p', [_vm._v("\n                    " + _vm._s(item2.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item2.sales_volume))]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [(item2.activity_id > 0) ? _c('p', [_c('span', {
      staticClass: "price amounts",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item2.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item2.price))])]) : _c('p', [_c('span', {
      staticClass: "price amounts",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item2.price))]), _vm._v(" "), (item2.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item2.sales_status == 1 && item2.stock > 0) ? _c('div', {
      staticClass: "num-box"
    }, [(item2.is_options == 1) ? _c('div', {
      staticClass: "btn-yellow select-spec-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleProp('specInfo', item2)
        }
      }
    }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e()]) : _c('div', [(item2.cartNum > 0) ? _c('span', {
      staticClass: "btns minusBtn icon-removecart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.minusGoods(item2)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
      staticClass: "box"
    }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e(), _vm._v(" "), (item2.smallNumber > 1 && !item2.cartNum) ? _c('span', {
      staticClass: "btn-yellow select-spec-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addGoods(item2)
        }
      }
    }, [_vm._v(_vm._s(item2.smallNumber) + "份起购")]) : (!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum) ? _c('span', {
      staticClass: "btns addBtn icon-addtocart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addGoods(item2)
        }
      }
    }) : _c('span', {
      staticClass: "btns addBtn icon-cantaddtocart"
    })])]) : _c('span', {
      staticClass: "num-box sales-out"
    }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item2.activity_desc) ? _c('div', {
      staticClass: "sale-box"
    }, [(item2.activity_desc && item2.activity_desc != '') ? _c('span', {
      staticClass: "no-bg"
    }, [_vm._v(_vm._s(item2.activity_desc))]) : _vm._e(), _vm._v(" "), (item2.activity_id > 0 && item2.sales_status == 1 && item2.left_stock <= 10) ? _c('span', {
      staticClass: "bg"
    }, [_vm._v("剩" + _vm._s(item2.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "1.26rem",
        "margin-top": "0.1rem"
      }
    }, [(item2.partner != 0 && item2.activity_desc_extra) ? _c('span', {
      staticClass: "activity-tip"
    }, [_vm._v(_vm._s(item2.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item2.show_text) ? _c('span', {
      staticClass: "activity-tip"
    }, [_vm._v(_vm._s(item2.show_text))]) : _vm._e()])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.iShowSearchNothing) ? _c('div', {
    staticClass: "nothing"
  }, [_vm._v("抱歉，未能找到您搜索的商品")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#9b9b9b"
    }
  }, [_vm._v("搜索商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    staticStyle: {
      "width": "2.37rem",
      "height": "2.42rem"
    },
    attrs: {
      "src": __webpack_require__(334)
    }
  }), _vm._v(" "), _c('div', [_vm._v("吃完记得给大厨一个反馈哦～")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "fixed closeShop"
  }, [_c('p', [_vm._v("店铺打烊，请其他方式下单或电话联系")])])
}]}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('form', [_c('div', {
    staticClass: "list order edit-address"
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressee),
      expression: "addressee"
    }],
    attrs: {
      "placeholder": "请输入您的姓名",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.addressee)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sex-box",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-boy",
    class: {
      'checked': _vm.gender === '1'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "1")
    },
    on: {
      "change": function($event) {
        _vm.gender = "1"
      }
    }
  }), _vm._v("男生\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "icon icon-girl",
    class: {
      'checked': _vm.gender === '0'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    staticClass: "sex",
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.gender, "0")
    },
    on: {
      "change": function($event) {
        _vm.gender = "0"
      }
    }
  }), _vm._v("女生\n                ")])])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("电话")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mp),
      expression: "mp"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入您的手机号",
      "maxlength": 11
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.chooseAddress
    }
  }, [_c('label', [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.poi_address))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleBuildProp
    }
  }, [_c('label', [_vm._v("楼栋")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.buildInfo.name ? _vm.buildInfo.name : '请选择楼栋'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleFloorProp
    }
  }, [_c('label', [_vm._v("楼层")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.floorInfo.name ? _vm.floorInfo.name : '请选择楼层'))])])]) : _vm._e(), _vm._v(" "), (_vm.needBuilding) ? _c('li', [_c('a', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.toggleRoomProp
    }
  }, [_c('label', [_vm._v("房间")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._v(_vm._s(_vm.roomInfo.name ? _vm.roomInfo.name : '请选择房间'))])])]) : _vm._e(), _vm._v(" "), (!_vm.needBuilding) ? _c('li', [_c('label', [_vm._v("详细")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail),
      expression: "detail"
    }],
    attrs: {
      "placeholder": "请输入您的详细地址",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.detail)
    },
    on: {
      "blur": _vm.inputBlur,
      "focus": _vm.inputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.detail = $event.target.value
      }
    }
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('footer', {
    staticClass: "block",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('a', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": _vm.saveAddress
    }
  }, [_vm._v("保存")])]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.closeProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propBuildShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.buildTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item3",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.buildingList), function(item) {
    return _c('li', {
      class: {
        'canSelect': item.id == _vm.buildInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeBuilding(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propFloorShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.floorTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.floorList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.floorInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeFloor(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propRoomShow) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.roomTitle))]), _vm._v(" "), _c('ul', {
    staticClass: "flex-ui item5",
    staticStyle: {
      "left": "0",
      "right": "0"
    }
  }, _vm._l((_vm.roomList), function(item) {
    return _c('li', {
      staticClass: "ellipses",
      class: {
        'canSelect': item.id == _vm.roomInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.changeRoom(item)
        }
      }
    }, [_vm._v(_vm._s(item.area))])
  }), 0), _vm._v(" "), (_vm.isCustom) ? _c('div', {
    staticClass: "custom",
    on: {
      "click": _vm.changeOpenCustom
    }
  }, [_vm._v("\n          没有找到自己房间号？点击这里添加\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.openCustomRoom) ? _c('div', {
    staticClass: "custom-pop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("自定义房间号")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customRoomName),
      expression: "customRoomName"
    }],
    attrs: {
      "autofocus": "",
      "type": "text",
      "placeholder": "请输入你的房间号",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.customRoomName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customRoomName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("温馨提示：为确保餐品顺利送到，请填写真实房间号")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.changeOpenCustom()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-ok",
    on: {
      "click": _vm.choseCustomRoom
    }
  }, [_vm._v("确定")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycoupons main selectCoupon"
  }, [(_vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('div', {
    staticClass: "cpackage-title"
  }, [_vm._v("本单可用立减"), _c('span', {
    staticStyle: {
      "color": "#FF4A61"
    }
  }, [_vm._v(_vm._s(_vm.couponPackageList[0].package_unit_price) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.couponPackageList.length > 0) ? _c('div', {
    staticClass: "cpackage-list"
  }, _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.package_shop_desc))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n            ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(item)
        }
      }
    }, [_vm._v("立即购买")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.couponsList.length > 0 || _vm.unValidCoupons.length > 0) ? _c('div', [(_vm.couponsList.length > 0) ? _c('ul', _vm._l((_vm.couponsList), function(item, index) {
    return _c('li', {
      key: index,
      class: item.coupon_property == 4 ? 'package' : ''
    }, [(item.selected == 1) ? _c('span', {
      staticClass: "selected-icon"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          return _vm.selectCoupon(item)
        }
      }
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v("\n            " + _vm._s(item.coupon_property_str) + "\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "coupon-name"
    }, [_c('span', {
      staticClass: "coupon-name-tit"
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥ ")]) : _vm._e(), _vm._v(_vm._s(item.amount) + "\n              "), (item.is_discount == 1) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date"
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.use_end_time))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "fr red fs-20"
    }, [_vm._v("\n              " + _vm._s(item.use_condition))]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.unValidCoupons.length > 0) ? _c('div', {
    staticClass: "splitLine"
  }, [_c('p', [_vm._v("不可用优惠券")])]) : _vm._e(), _vm._v(" "), (_vm.unValidCoupons.length > 0) ? _c('ul', {
    staticClass: "unavailable-coupon"
  }, _vm._l((_vm.unValidCoupons), function(item) {
    return _c('li', {
      class: item.coupon_property == 4 ? 'package' : ''
    }, [(item.selected == 1) ? _c('span', {
      staticClass: "selected-icon"
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "property"
    }, [_vm._v("\n            " + _vm._s(item.coupon_property_str) + "\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "coupon-name"
    }, [_c('span', {
      staticClass: "coupon-name-tit"
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥ ")]) : _vm._e(), _vm._v(_vm._s(item.amount) + "\n              "), (item.is_discount == 1) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date"
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.use_end_time))]), _vm._v(" "), (item.coupon_type != 5) ? _c('span', {
      staticClass: "fr red fs-20"
    }, [_vm._v("\n              " + _vm._s(item.use_condition) + "\n            ")]) : _vm._e()])]), _vm._v(" "), (item.unable_message) ? _c('p', {
      staticClass: "cant-use-reason"
    }, [_vm._v("不可用原因：" + _vm._s(item.unable_message))]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.couponsList != null) ? _c('div', {
    staticClass: "no-use-btn",
    on: {
      "click": _vm.donotUseCoupon
    }
  }, [_vm._v("不使用优惠券")]) : _vm._e()]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这笔订单没有可用的优惠券")])])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "p-header"
  }, [_c('img', {
    staticClass: "suc-img",
    attrs: {
      "src": __webpack_require__(327)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("支付成功")]), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v("¥"), _c('span', [_vm._v(_vm._s(_vm.orderInfo.real_pay))])]), _vm._v(" "), _c('div', {
    staticClass: "suc-btn",
    on: {
      "click": _vm.toOrderDetail
    }
  }, [_vm._v("查看订单")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "fs-32 fw-bold al"
  }, [_vm._v("支付有福利")]), _vm._v(" "), (_vm.orderBonus && _vm.orderBonus.icon) ? _c('div', {
    staticClass: "flex-row-bc",
    staticStyle: {
      "padding": ".4rem 0 .2rem 0",
      "border-bottom": ".01rem solid rgba(0,0,0,0.06)"
    }
  }, [_c('div', {
    staticClass: "flex-row-sc"
  }, [_c('img', {
    staticStyle: {
      "width": ".56rem"
    },
    attrs: {
      "src": _vm.orderBonus.icon
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 .1rem 0 .3rem"
    }
  }, [_c('div', {
    staticClass: "fs-32 fw-bold"
  }, [_vm._v(_vm._s(_vm.orderBonus.bonus))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin-top": ".1rem"
    }
  }, [_vm._v(_vm._s(_vm.orderBonus.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "suc-btn",
    on: {
      "click": _vm.jumpToApp
    }
  }, [_vm._v("去APP查看")])]) : _vm._e(), _vm._v(" "), (_vm.scoreInfo && _vm.scoreInfo.icon) ? _c('div', {
    staticClass: "flex-row-bc",
    staticStyle: {
      "padding": ".4rem 0 .2rem 0"
    }
  }, [_c('div', {
    staticClass: "flex-row-sc"
  }, [_c('img', {
    staticStyle: {
      "width": ".56rem"
    },
    attrs: {
      "src": _vm.scoreInfo.icon
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 .1rem 0 .3rem"
    }
  }, [_c('div', {
    staticClass: "fs-32 fw-bold"
  }, [_vm._v(_vm._s(_vm.scoreInfo.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin-top": ".1rem"
    }
  }, [_vm._v(_vm._s(_vm.scoreInfo.sub_title))])])]), _vm._v(" "), _c('div', {
    staticClass: "suc-btn",
    on: {
      "click": _vm.jumpToScore
    }
  }, [_vm._v("立即查看")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ad-list"
  }, _vm._l((_vm.adList), function(item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.adJump(item)
        }
      }
    })
  }), 0), _vm._v(" "), (_vm.showOrderCoupon) ? _c('div', {
    staticClass: "notice_detail_alert coupon",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.showOrderCoupon = false
      }
    }
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.orderCouponList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.is_discount == 1) ? _c('img', {
      attrs: {
        "src": __webpack_require__(112),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(113),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2.9rem"
      }
    }, [_c('div', {
      staticClass: "fs-32 fw-bold ellipse"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-22",
      staticStyle: {
        "color": "#999",
        "margin-top": ".16rem"
      }
    }, [_vm._v("有效期至：" + _vm._s(item.finished_at))])])]), _vm._v(" "), (item.is_discount == 1) ? _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v(_vm._s(item.amount) + "折")])]) : _c('div', {
      staticClass: "price"
    }, [_vm._v("\n                ¥"), _c('span', [_vm._v(_vm._s(item.amount))])])])])
  }), 0)]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.showPlusCard) ? _c('div', {
    staticClass: "notice_detail_alert plus-card",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.showPlusCard = false
      }
    }
  }, [_c('div', {
    staticClass: "notice_detail_content",
    on: {
      "click": function($event) {
        return _vm.jumpToCard()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.plusCardInfo.bg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('img', {
    staticStyle: {
      "width": "3.35rem",
      "margin": "0 auto"
    },
    attrs: {
      "src": _vm.plusCardInfo.card
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.plusCardInfo.cardTitle))]), _vm._v(" "), _c('span', {
    staticClass: "des",
    domProps: {
      "innerHTML": _vm._s(_vm.plusCardInfo.des)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.plusCardInfo.bt
    }
  })])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(340),
      "width": "100%",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(338),
      "width": "100%",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jump-btn"
  }, [_c('a', {
    attrs: {
      "href": "https://dl.anlaiye.com"
    }
  }, [_vm._v("前往俺来也app下单使用")])])])
}]}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container payment main"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "p-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.32rem"
    }
  }, [_vm._v("\n          支付剩余时间 " + _vm._s(_vm.minutes) + ":" + _vm._s(_vm.seconds) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "amount"
  }, [_vm._v("\n          ￥"), _c('span', [_vm._v(_vm._s(_vm.details.amount))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.details.shopName) + "-" + _vm._s(_vm.details.orderId))])]), _vm._v(" "), _c('div', {
    staticClass: "p-card"
  }, [_c('div', {
    staticClass: "payment-list"
  }, [_c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.details.paywayList), function(item, index) {
    return (
      _vm.client_type != '11' &&
      (item.payway_id == 3 ||
        item.payway_id == 5 ||
        item.payway_id == 20 ||
        item.payway_id == 41)
    ) ? _c('li', {
      key: index,
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.selected(item.payway_id)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "height": "100%",
        "justify-content": "center"
      }
    }, [_c('div', {
      staticClass: "pay_logo"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.recommendInfo) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, [_vm._v("\n                  " + _vm._s(item.recommendInfo) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.recommendInfoList) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, _vm._l((item.recommendInfoList), function(info) {
      return _c('span', [_vm._v(_vm._s(info.recommendInfo) + ";")])
    }), 0) : _vm._e()]), _vm._v(" "), (item.payway_id == 20 && !_vm.cardSchoolIds.includes(_vm.schoolId)) ? _c('span', {
      staticClass: "card-detail",
      on: {
        "click": _vm.cardDetail,
        "touchmove": function($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['pay_icon', {
        on: item.selected
      }]
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.details.paywayList), function(item) {
    return (_vm.client_type == '11' && item.payway_id == 31) ? _c('li', {
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.selected(item.payway_id)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "height": "100%",
        "justify-content": "center"
      }
    }, [_c('div', {
      staticClass: "pay_logo"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.recommendInfo) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, [_vm._v("\n                  " + _vm._s(item.recommendInfo) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.recommendInfoList) ? _c('div', {
      staticClass: "recommend-info-txt"
    }, _vm._l((item.recommendInfoList), function(info) {
      return _c('span', [_vm._v(_vm._s(info.recommendInfo) + ";")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
      class: ['pay_icon', {
        on: item.selected == true
      }]
    })]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-white fixed fixed-bottom"
  }, [_c('button', {
    staticClass: "btn btn-yellow btn-confirm",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.confirmPay
    }
  }, [_vm._v("\n        立即支付\n      ")])])]), _vm._v(" "), (_vm.isShowAuth) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowAuth = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAuth) ? _c('div', {
    staticClass: "alert-box",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("还未授权校园卡")]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn",
    on: {
      "click": function($event) {
        return _vm.toAutn()
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      立即授权\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("为保证卡片安全会不定期重新授权")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowAuth = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo) ? _c('div', {
    staticClass: "alert-box",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("校园卡信息")]), _vm._v(" "), _c('p', {
    staticClass: "des desInfo"
  }, [_vm._v("卡号：" + _vm._s(_vm.schoolCardCode))]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn sureBtn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      确定\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo1) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo1 = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCardInfo1) ? _c('div', {
    staticClass: "alert-box school-card",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("请输入账号" + _vm._s(_vm.paymentDetail.campusAuthType === 0 ? '和密码' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("工号/学号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolCard.accNum),
      expression: "schoolCard.accNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入工号/学号"
    },
    domProps: {
      "value": (_vm.schoolCard.accNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolCard, "accNum", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.paymentDetail.campusAuthType === 0 || _vm.paymentDetail.campusAuthType === 2) ? _c('div', {
    staticClass: "input"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("密码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolCard.password),
      expression: "schoolCard.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.schoolCard.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.schoolCard, "password", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow authBtn sureBtn",
    on: {
      "click": function($event) {
        return _vm.submitSchoolCardForm()
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n      去支付\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.isShowCardInfo1 = false
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "online_complaints"
  }, [_c('ul', {
    staticStyle: {
      "background-color": "#fff",
      "padding": "0 0.2rem"
    }
  }, [_c('li', [_c('span', {
    staticClass: "fl complaints_fixed complaints_tel"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "fl"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userTel),
      expression: "userTel"
    }],
    attrs: {
      "placeholder": "请输入手机号",
      "type": "number",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.userTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userTel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.selectResponsibleParty
    }
  }, [_c('span', {
    staticClass: "fl complaints_fixed complaints_reason"
  }, [_vm._v("投诉对象")]), _vm._v(" "), (_vm.responsible.responsibleParty == null || _vm.responsible.responsibleParty == '' || _vm.responsible.responsibleParty == undefined) ? _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fl select-item"
  }, [_vm._v(_vm._s(_vm.responsible.responsibleParty))]), _c('span', {
    staticClass: "fr icon_arrow_down"
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.selectReason
    }
  }, [_c('span', {
    staticClass: "fl complaints_fixed complaints_reason"
  }, [_vm._v("投诉理由")]), _vm._v(" "), (_vm.responsible.responsibleParty == null || _vm.responsible.responsibleParty == '' || _vm.responsible.responsibleParty == undefined) ? _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "fl select-item"
  }, [_vm._v(_vm._s(_vm.reason.reasonDesc))]), _c('span', {
    staticClass: "fr icon_arrow_down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "complaints_des_box"
  }, [_c('h3', {
    staticClass: "complaints_des"
  }, [_vm._v("详细描述")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "name": "",
      "id": "complaints_con",
      "maxlength": "200",
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }, _vm.descInput]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.remnant) + "/200")])]), _vm._v(" "), _c('div', {
    staticClass: "addPicBox"
  }, [_c('div', {
    staticClass: "addimg_tips"
  }, [_vm._v("上传凭证处理更快（不超过3张）")]), _vm._v(" "), _c('div', {
    staticClass: "addPic"
  }, [_c('ul', {
    staticClass: "fl"
  }, _vm._l((_vm.goodsImages), function(item, index) {
    return _c('li', {
      staticClass: "fl upLoadPic"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletepic(index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddShow),
      expression: "isAddShow"
    }],
    staticClass: "addPicBtn fl"
  }, [_c('form', {
    attrs: {
      "id": "uploadForm",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "uploadImg",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.getImage($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "goodsList"
  }, [_c('div', {
    staticClass: "shopName arrow-right ellipse"
  }, [_vm._v(_vm._s(_vm.shopName))]), _vm._v(" "), _c('ul', _vm._l((_vm.goodsList), function(item) {
    return _c('li', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "60%"
      }
    }, [_c('img', {
      staticClass: "shopPic",
      attrs: {
        "src": item.picAddr
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodsName flexcol",
      staticStyle: {
        "width": "60%",
        "height": "100%",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "ellipse",
      staticStyle: {
        "width": "60%",
        "color": "#333",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#9B9B9B"
      }
    }, [_vm._v("x" + _vm._s(item.number))])])]), _vm._v(" "), _c('div', {
      staticClass: "goodsPri"
    }, [_vm._v("￥ " + _vm._s(item.salePrice))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "btn submit_btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag1),
      expression: "flag1"
    }],
    staticClass: "complaints_reason_select",
    on: {
      "click": function($event) {
        return _vm.hiddenList(1)
      }
    }
  }, [_c('ul', _vm._l((_vm.responsiblePartyList), function(item, index) {
    return _c('li', {
      ref: "menuItem",
      refInFor: true,
      staticClass: "reason_list",
      class: {
        on: item.isDefault == 1
      },
      on: {
        "click": function($event) {
          return _vm.handleClick1(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.responsibleParty))]), _c('span', {
      staticClass: "icon_selected"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }],
    staticClass: "complaints_reason_select",
    on: {
      "click": function($event) {
        return _vm.hiddenList(2)
      }
    }
  }, [_c('ul', _vm._l((_vm.reasonList), function(item, index) {
    return _c('li', {
      ref: "menuItem",
      refInFor: true,
      staticClass: "reason_list",
      class: {
        on: item.isDefault == 1
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.reasonDesc))]), _c('span', {
      staticClass: "icon_selected"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "telComplaint"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticStyle: {
      "padding": ".26rem 0",
      "font-size": ".32rem",
      "font-weight": "bold"
    }
  }, [_vm._v("券包可用商家")]), _vm._v(" "), _c('div', {
    staticClass: "main no-foot"
  }, [(_vm.showPage) ? _c('div', [(_vm.bannerUrl) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.bannerUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopList.length > 0) ? _c('div', {
    staticClass: "goods-list shop"
  }, [_c('ul', {
    staticClass: "goods"
  }, _vm._l((_vm.shopList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    }), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v(_vm._s(item.mark))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "threshold"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.new_delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])]) : _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()]), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2) {
      return _c('span', {
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ordersettle"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.is_take_out == 1 && (_vm.is_self_take_new == 1 && _vm.is_eat_in == 0)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && (_vm.is_self_take_new == 0 && _vm.is_eat_in == 1)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), ((_vm.is_self_take_new == 1 && _vm.is_eat_in == 1) && _vm.is_take_out == 0) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', {
      'active': _vm.showSelf
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', {
      'active': _vm.showEat
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && (_vm.is_self_take_new == 1 && _vm.is_eat_in == 1)) ? _c('div', {
    staticClass: "tabBar"
  }, [_c('div', {
    class: ['fl', 'take', 'newTab', {
      'active': _vm.showTake
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-away')
      }
    }
  }, [_c('p', [_vm._v("外卖配送")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', 'newTab', {
      'active': _vm.showSelf
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-self')
      }
    }
  }, [_c('p', [_vm._v("打包自提")])]), _vm._v(" "), _c('div', {
    class: ['fl', 'self', 'newTab', {
      'active': _vm.showEat
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take-eat')
      }
    }
  }, [_c('p', [_vm._v("堂食")])])]) : _vm._e(), _vm._v(" "), (_vm.is_take_out == 1 && _vm.showTake) ? _c('div', [_c('div', {
    staticClass: "address",
    staticStyle: {
      "padding": "0.3rem 0.2rem 0 .2rem !important"
    }
  }, [(_vm.is_take_out == 1 && (_vm.is_eat_in == 0 && _vm.is_self_take_new == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("外卖配送")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-bottom"
  }, [(JSON.stringify(_vm.defaultAddress) === '{}') ? _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.jumpToaddress
    }
  }, [_vm._v("\n            新增收货地址\n          ")]) : _c('div', {
    staticClass: "arrow-right",
    on: {
      "click": _vm.jumpToaddress
    }
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.defaultAddress.addressee) + " " + _vm._s(_vm.defaultAddress.mp))]), _vm._v(" "), (!_vm.defaultAddress.isLimitFloor) ? _c('div', {
    staticClass: "small"
  }, [(_vm.defaultAddress.poi_address && _vm.defaultAddress.detail) ? _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address) + " " + _vm._s(_vm.defaultAddress.detail))]) : (_vm.defaultAddress.build_name) ? _c('span', [_vm._v("【" + _vm._s(_vm.defaultAddress.build_name) + "-" + _vm._s(_vm.defaultAddress.floor_name) + "-" + _vm._s(_vm.defaultAddress.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address))])]) : _c('div', [(_vm.defaultAddress.build_name) ? _c('span', [_vm._v("【" + _vm._s(_vm.defaultAddress.build_name) + "-" + _vm._s(_vm.defaultAddress.floor_name) + "-" + _vm._s(_vm.defaultAddress.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(_vm.defaultAddress.poi_address) + " " + _vm._s(_vm.defaultAddress.detail))])])])])]), _vm._v(" "), _c('div', {
    class: _vm.orderPreviewInfo.isCanChooseDeliveryWay ? 'sendTime' : 'sendTime pb20 mb20',
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "select arrive-time arrow-right",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("送达时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectDateName) + " " + _vm._s(_vm.selectTimeName) + "\n          ")])])]), _vm._v(" "), (_vm.orderPreviewInfo.isCanChooseDeliveryWay) ? _c('div', {
    staticClass: "sendTime pb20 mb20"
  }, [_c('div', {
    staticClass: "select arrive-time arrow-right",
    on: {
      "click": _vm.toggleDeliveryProp
    }
  }, [_c('span', [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "input-text",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.deliveryWay || '未选择（必选）') + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.banners.length > 0) ? _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.banners[0].imageUrl
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.banners[0])
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.is_self_take_new == 1 && _vm.showSelf) ? _c('div', {
    staticClass: "self-take"
  }, [_c('div', {
    staticClass: "address"
  }, [(_vm.is_self_take_new == 1 && (_vm.is_eat_in == 0 && _vm.is_take_out == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("打包自提")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("自提地点")]), _vm._v(" "), _c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "space-between",
      "margin-top": "0.2rem"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.orderPreviewInfo.pickUpAddr))]), _vm._v(" "), _c('span', {
    staticClass: "check-map",
    on: {
      "click": _vm.toCheckMap
    }
  }, [_vm._v("查看")])])]), _vm._v(" "), _c('div', {
    staticClass: "sendTime mb20 selt-take-time",
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "border-box"
  }, [_c('div', {
    staticClass: "select arrive-time",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("自提时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectDateName) + _vm._s(_vm.selectTimeName))]), _c('span', {
    staticClass: "arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "select arrive-time",
    staticStyle: {
      "padding-left": "0.2rem"
    }
  }, [_c('span', [_vm._v("自提电话")]), _vm._v(" "), (_vm.selfTakeMp != '' && _vm.selfTakeMp != null && _vm.selfTakeMp != undefined) ? _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selfTakeMp))]), _c('span', {
    staticClass: "arrow-right"
  })]) : _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(1)
      }
    }
  }, [_c('span', [_vm._v("请输入手机号")]), _c('span', {
    staticClass: "arrow-right"
  })])])])]), _vm._v(" "), (_vm.orderPreviewInfo.needBuild && _vm.orderPreviewInfo.needBuild == 1) ? _c('div', {
    staticClass: "building fs-28"
  }, [_c('div', {
    staticClass: "flex-row-bc arrow-right",
    on: {
      "click": function($event) {
        return _vm.toChoseBuilding()
      }
    }
  }, [_c('div', {
    staticClass: "color-gray"
  }, [_vm._v("宿舍信息")]), _vm._v(" "), (_vm.showChoseBuilding) ? _c('div', {
    staticStyle: {
      "margin-right": ".25rem",
      "color": "#787878"
    }
  }, [_vm._v("未选择（必选）")]) : _c('div', {
    staticStyle: {
      "margin-right": ".25rem",
      "color": "#787878"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.buildInfo[0].name) + "-" + _vm._s(_vm.buildInfo[1].name) + "-" + _vm._s(_vm.buildInfo[2].name) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "protocol"
  }, [_c('span', {
    class: ['icon-agree', {
      'select': _vm.isSelect
    }],
    on: {
      "click": _vm.isAgreeProtocol
    }
  }), _vm._v("同意"), _c('span', {
    on: {
      "click": _vm.toCheckProtocol
    }
  }, [_vm._v("《打包自提服务协议》")])])]) : _vm._e(), _vm._v(" "), (_vm.is_eat_in == 1 && _vm.showEat) ? _c('div', {
    staticClass: "eatBox self-take"
  }, [(_vm.is_eat_in == 1 && (_vm.is_self_take_new == 0 && _vm.is_take_out == 0)) ? _c('div', {
    staticClass: "oneTab"
  }, [_c('span', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#333",
      "font-weight": "600"
    }
  }, [_vm._v("堂食")])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.dineInShopTips) ? _c('div', {
    staticStyle: {
      "font-size": ".32rem",
      "color": "#4a4a4a"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderPreviewInfo.dineInShopTips) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.dineInTips) ? _c('div', {
    staticClass: "tips-eat"
  }, [_vm._v(_vm._s(_vm.orderPreviewInfo.dineInTips))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sendTime mb20 selt-take-time",
    attrs: {
      "id": "inputPanel"
    }
  }, [_c('div', {
    staticClass: "border-box",
    staticStyle: {
      "display": "flex",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "select arrive-time",
    on: {
      "click": _vm.toggleProp
    }
  }, [_c('span', [_vm._v("就餐时间")]), _vm._v(" "), _c('div', {
    staticClass: "input-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectDateName) + _vm._s(_vm.selectTimeName))]), _c('span', {
    staticClass: "arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "select arrive-time",
    staticStyle: {
      "padding-left": "0.2rem"
    }
  }, [_c('span', [_vm._v("预留电话")]), _vm._v(" "), (_vm.selfTakeMp != '' && _vm.selfTakeMp != null && _vm.selfTakeMp != undefined) ? _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(2)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selfTakeMp))]), _c('span', {
    staticClass: "arrow-right"
  })]) : _c('div', {
    staticClass: "input-text",
    on: {
      "click": function($event) {
        return _vm.inputPhone(2)
      }
    }
  }, [_c('span', [_vm._v("请输入手机号")]), _c('span', {
    staticClass: "arrow-right"
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, [_c('h3', {
    staticClass: "shop-name ellipse"
  }, [_vm._v(_vm._s(_vm.orderPreviewInfo.supplier_short_name))]), _vm._v(" "), _c('ul', {
    staticClass: "order-goods-list"
  }, _vm._l((_vm.orderPreviewInfo.right_goods), function(item) {
    return _c('li', {
      staticClass: "flexrow"
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "goods-img",
      style: ({
        backgroundImage: 'url(' + item.thumbnail + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-name-box flexcol",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.good_name))]), _vm._v(" "), (item.specAttrStr) ? _c('span', {
      staticClass: "goods-spec ellipse"
    }, [_vm._v(_vm._s(item.specAttrStr))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("x" + _vm._s(item.number))])])]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "30%",
        "justify-content": "flex-end",
        "align-items": "center"
      }
    }, [(item.ori_price) ? _c('span', {
      staticClass: "ori_price"
    }, [_vm._v("￥" + _vm._s(item.ori_price))]) : _vm._e(), _c('span', [_vm._v("￥" + _vm._s(item.price))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line",
    staticStyle: {
      "margin": ".2rem 0"
    }
  }), _vm._v(" "), _vm._l((_vm.orderPreviewInfo.extraFeeList), function(item) {
    return _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      style: ({
        color: item.titleColor
      }),
      on: {
        "click": function($event) {
          return _vm.viewPackDesc()
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n          "), (item.subTitle) ? _c('span', {
      staticStyle: {
        "font-size": ".2rem",
        "margin-left": ".1rem",
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.subTitle))]) : _vm._e(), _vm._v(" "), (item.jumpType == 500088) ? _c('span', {
      staticClass: "icon-desc"
    }, [_vm._v("?")]) : _vm._e()]), _vm._v(" "), _c('span', {
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))])])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#fff",
      "padding": "0.2rem 0.2rem 0",
      "margin-bottom": "0.2rem"
    }
  }, [_vm._l((_vm.orderPreviewInfo.orderFeeList), function(item) {
    return _c('div', {
      staticStyle: {
        "padding-bottom": ".2rem",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "flex-row-bc",
      style: ({
        color: item.titleColor
      })
    }, [_c('div', [_c('div', {
      staticClass: "flex-row-sc",
      on: {
        "click": function($event) {
          return _vm.showOrderFeeDesc(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n              "), (item.isShowDesc && item.isShowDesc == 1) ? _c('img', {
      staticStyle: {
        "display": "inline-block",
        "width": ".26rem"
      },
      attrs: {
        "src": __webpack_require__(326),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.showDesc) ? _c('span', {
      staticStyle: {
        "font-size": ".18rem",
        "padding": ".02rem .1rem",
        "border-radius": ".12rem",
        "background-color": "#ddd"
      }
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e()]), _vm._v(" "), (item.subTitle) ? _c('span', {
      staticStyle: {
        "font-size": ".2rem",
        "margin-left": ".1rem",
        "color": "#999"
      }
    }, [_vm._v("\n              " + _vm._s(item.subTitle) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [(item.originValue) ? _c('span', {
      staticStyle: {
        "text-decoration": "line-through",
        "color": "#999"
      }
    }, [_vm._v("\n              " + _vm._s(item.originValue) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "ml10",
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))])])]), _vm._v(" "), (item.isShowDirectDesc == 1) ? _c('div', {
      staticClass: "fs-20 mt10",
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.directDesc))]) : _vm._e()])
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.orderPreviewInfo.reductionAmount && _vm.orderPreviewInfo.reductionAmount > 0) ? _c('div', {
    staticClass: "activity reduction"
  }, [_vm._v("满减优惠\n        "), _c('span', {
    staticClass: "fr",
    staticStyle: {
      "color": "#F2596C"
    }
  }, [_vm._v("-￥" + _vm._s(_vm.orderPreviewInfo.reductionAmount))])]) : _vm._e(), _vm._v(" "), (_vm.giftList.length == 1) ? _c('div', [_c('div', {
    staticClass: "activity special-goods arrow-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_activity_name))]), _vm._v(" "), (_vm.defaultGift.good_name.length < 10) ? _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name) + "x" + _vm._s(_vm.defaultGift.number))]) : _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name.substring(0, 10)) + "...x" + _vm._s(_vm.defaultGift.number))])])]) : _vm._e(), _vm._v(" "), (_vm.giftList.length > 1) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "activity special-goods arrow-right",
    class: {
      'open': _vm.showMoreGift
    },
    on: {
      "click": _vm.selectGift
    }
  }, [_c('div', {
    staticClass: "more"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_activity_name))]), _vm._v(" "), (_vm.defaultGift.good_name.length < 10) ? _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name) + "x" + _vm._s(_vm.defaultGift.number))]) : _c('span', {
    staticClass: "fr red"
  }, [_vm._v(_vm._s(_vm.defaultGift.good_name.substring(0, 10)) + "...x" + _vm._s(_vm.defaultGift.number))])])])]) : _vm._e(), _vm._v(" "), (_vm.orderType == 0 && (_vm.orderPreviewInfo.deliveryFeeCoupons || _vm.orderPreviewInfo.unValidDeliveryFeeCoupons)) ? _c('div', {
    staticClass: "flex-row-bc arrow-right activity",
    on: {
      "click": function($event) {
        return _vm.toSelectCoupon(2)
      }
    }
  }, [_c('span', [_vm._v("配送券")]), _vm._v(" "), (JSON.stringify(_vm.defaultAddress) === '{}' && _vm.orderType == 0) ? _c('div', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请添加收货地址")]) : _c('div', [(_vm.orderPreviewInfo.deliveryFeeCoupons && _vm.orderPreviewInfo.canUseDeliveryFeeCouponNum > 0) ? _c('div', {
    staticClass: "red"
  }, [(_vm.orderPreviewInfo.deliveryFeeCouponId) ? _c('span', [_vm._v("- ￥" + _vm._s(_vm.orderPreviewInfo.deliveryFeeCouponAmount))]) : _c('div', [_vm._v("\n              " + _vm._s(_vm.orderPreviewInfo.canUseDeliveryFeeCouponNum) + "张可用\n              "), (_vm.orderPreviewInfo.maxDeliveryFeeCouponAmount) ? _c('span', [_vm._v("，最高可减" + _vm._s(_vm.orderPreviewInfo.maxDeliveryFeeCouponAmount) + "元")]) : _vm._e()])]) : _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("无可用")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc arrow-right activity",
    on: {
      "click": function($event) {
        return _vm.toSelectCoupon(1)
      }
    }
  }, [_c('span', [_vm._v("优惠券")]), _vm._v(" "), (JSON.stringify(_vm.defaultAddress) === '{}' && _vm.orderType == 0) ? _c('div', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("请添加收货地址")]) : _c('div', [(_vm.couponsList.length && _vm.orderPreviewInfo.canUseCouponNum > 0) ? _c('div', {
    staticClass: "red"
  }, [(_vm.couponInfo && _vm.couponInfo.amount) ? _c('span', [_vm._v("- ￥" + _vm._s(_vm.orderPreviewInfo.couponAmount))]) : _c('div', [_vm._v("\n              " + _vm._s(_vm.orderPreviewInfo.canUseCouponNum) + "张可用\n              "), (_vm.orderPreviewInfo.maxCouponAmount) ? _c('span', [_vm._v("，最高可减" + _vm._s(_vm.orderPreviewInfo.maxCouponAmount) + "元")]) : _vm._e()])]) : _c('span', {
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("无可用")])])]), _vm._v(" "), _c('div', {
    staticClass: "activity",
    staticStyle: {
      "padding-right": "0",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_vm._v("\n          小计"), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.phaseSubtotal))])])]), _vm._v(" "), (_vm.orderPreviewInfo.gift_code == '-2') ? _c('div', {
    staticClass: "notice",
    staticStyle: {
      "color": "#9b9b9b",
      "padding": "0.2rem 0",
      "border-top": "1px solid #f6f6f6"
    }
  }, [_vm._v("\n        温馨提示：赠品已经全部送完啦～\n      ")]) : _vm._e()], 2), _vm._v(" "), (_vm.orderPreviewInfo.punctualArrive) ? _c('div', {
    staticClass: "card marginB20"
  }, [_c('div', {
    staticClass: "flex-row-bc fs-28 fw-bold"
  }, [_c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.titleColor
    })
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.title) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".5rem"
    },
    attrs: {
      "src": _vm.orderPreviewInfo.punctualArrive.imgUrl
    }
  })]), _vm._v(" "), (_vm.orderPreviewInfo.punctualArrive.changeAimed) ? _c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.valueColor
    }),
    on: {
      "click": function($event) {
        return _vm.changePunctualArrive()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.value) + "\n          "), (_vm.orderPreviewInfo.punctualArrive.aimed) ? _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": __webpack_require__(108)
    }
  }) : _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": __webpack_require__(316)
    }
  })]) : _c('div', {
    staticClass: "flex-row-bc",
    style: ({
      color: _vm.orderPreviewInfo.punctualArrive.valueColor
    })
  }, [_vm._v("\n          " + _vm._s(_vm.orderPreviewInfo.punctualArrive.value) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": __webpack_require__(108)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fc-999 fs-22 mt10",
    on: {
      "click": function($event) {
        return _vm.viewPunctualArrive()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.orderPreviewInfo.punctualArrive.desc) + "\n        "), _c('img', {
    staticStyle: {
      "display": "inline-block",
      "width": ".24rem",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(114)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.right_hikes && _vm.orderPreviewInfo.right_hikes.length) ? _c('div', {
    staticClass: "order-info hikes",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('h3', {
    staticClass: "shop-name"
  }, [_vm._v("超值换购")]), _vm._v(" "), _c('ul', {
    staticClass: "order-goods-list"
  }, _vm._l((_vm.orderPreviewInfo.right_hikes), function(item) {
    return _c('li', {
      staticClass: "flexrow"
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "goods-img",
      style: ({
        backgroundImage: 'url(' + item.thumbnail + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-name-box flexcol",
      staticStyle: {
        "justify-content": "space-between"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.good_name))]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(item.price))])])]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "30%",
        "justify-content": "flex-end",
        "align-items": "center"
      }
    }, [(item.maxNumber > 0) ? _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.showHikes),
        expression: "!item.showHikes"
      }],
      staticClass: "add-goods-btn btn-yellow",
      on: {
        "click": function($event) {
          return _vm.changeHikes(item)
        }
      }
    }, [_vm._v("加价购")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showHikes),
        expression: "item.showHikes"
      }],
      staticClass: "operator-box flexrow"
    }, [_c('span', {
      class: ['operatorBtn', 'minus', {
        'grey-minus': item.number == 0
      }],
      on: {
        "click": function($event) {
          return _vm.subtractGoods(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "operatorBtn number"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('span', {
      class: ['operatorBtn', 'plus', {
        'grey-minus': item.number < item.maxNumber
      }],
      on: {
        "click": function($event) {
          return _vm.addRefundGoods(item)
        }
      }
    })])]) : _c('div', {
      staticClass: "add-goods-btn"
    }, [_vm._v("售罄")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "activity",
    staticStyle: {
      "padding-right": "0",
      "border-bottom": "none",
      "border-top": "1px solid #f6f6f6"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_vm._v("\n          小计\n          "), (_vm.orderPreviewInfo.hikeSubTotal) ? _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.hikeSubTotal))]) : _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#333"
    }
  }, [_vm._v("￥0")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list list-indent order"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.orderType != 0) ? _c('li', {
    staticStyle: {
      "padding": "0 0.2rem"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "0.26rem"
    }
  }, [(_vm.showRemarks) ? _c('span', {
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("备注")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticStyle: {
      "width": "85%",
      "height": "1.2rem",
      "margin-top": "0.2rem",
      "border-radius": "0.1rem",
      "padding": "0.1rem",
      "font-size": "0.28rem"
    },
    attrs: {
      "maxlength": "100",
      "placeholder": _vm.placeholder1
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }, function($event) {
        return _vm.changeComment()
      }]
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.is_take_out == 1 && _vm.showTake) ? _c('div', {
    staticClass: "remarks-box fs-28"
  }, [_c('div', {
    staticClass: "arrow-right out-remarks",
    on: {
      "click": function($event) {
        return _vm.toRemarks()
      }
    }
  }, [_c('div', {
    staticClass: "color-gray"
  }, [(_vm.showRemarks) ? _c('span', {
    staticStyle: {
      "color": "#f2596c"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("备注")]), _vm._v(" "), (_vm.remarks) ? _c('div', {
    staticStyle: {
      "max-width": "5.5rem",
      "margin-right": ".2rem",
      "color": "#787878",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.remarks) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.placeholder && !_vm.remarks) ? _c('div', {
    staticStyle: {
      "max-width": "5.5rem",
      "margin-right": ".2rem",
      "color": "#787878",
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.placeholder) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.canUseCouponNum === 0 && _vm.couponPackageList && _vm.couponPackageList.length == 1) ? _c('div', {
    staticClass: "cpackage-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("本单可用立减"), _c('span', {
    staticStyle: {
      "color": "#FF4A61"
    }
  }, [_vm._v(_vm._s(_vm.couponPackageList[0].package_unit_price) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.canUseCouponNum === 0 && _vm.couponPackageList && _vm.couponPackageList.length > 0) ? _c('div', {
    staticClass: "cpackage-list"
  }, _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.package_shop_desc))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n              ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(item)
        }
      }
    }, [_vm._v("立即购买")])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.orderPreviewInfo.gift_msg || _vm.orderPreviewInfo.reductionMsg) ? _c('div', {
    staticClass: "reduce_tips"
  }, [(_vm.orderPreviewInfo.gift_msg && _vm.orderPreviewInfo.gift_msg != '') ? _c('p', [_vm._v(_vm._s(_vm.orderPreviewInfo.gift_msg))]) : _vm._e(), _vm._v(" "), (_vm.orderPreviewInfo.reductionMsg && _vm.orderPreviewInfo.reductionMsg != '') ? _c('p', [_vm._v("\n      " + _vm._s(_vm.orderPreviewInfo.reductionMsg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "dark fixed flexrow"
  }, [_c('div', [((_vm.orderType == 0 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount > 0) ? _c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticStyle: {
      "line-height": "1rem",
      "font-size": "0.28rem",
      "color": "#333"
    }
  }, [_vm._v("已优惠 ￥" + _vm._s(_vm.orderPreviewInfo.saveDiscount))])]) : ((_vm.orderType == 0 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount == 0) ? _c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#333",
      "width": "1.7rem",
      "height": "1rem"
    }
  })]) : ((_vm.orderType == 1 || _vm.orderType == 3) && _vm.orderPreviewInfo.saveDiscount > 0) ? _c('div', {
    staticClass: "footer-cart flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#333"
    }
  }, [_vm._v("节省 ￥" + _vm._s(_vm.totalSave))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "#787878"
    }
  }, [_vm._v("优惠" + _vm._s(_vm.orderPreviewInfo.saveDiscount) + "+配送费" + _vm._s(_vm.orderPreviewInfo.saveDeliveryFee))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flexrow"
  }, [_c('div', {
    staticClass: "footer-cart"
  }, [_c('span', {
    staticClass: "price",
    staticStyle: {
      "line-height": "1rem",
      "margin-right": "0.2rem"
    }
  }, [_vm._v("合计 "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderPreviewInfo.real_pay))])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-cart flexcol",
    staticStyle: {
      "justify-content": "center"
    }
  }, [(_vm.orderSubmitType == 2 && _vm.isCanSubmit) ? _c('a', {
    staticClass: "btn btn-main",
    on: {
      "click": _vm.createOrder
    }
  }, [_vm._v("提交订单")]) : _c('a', {
    staticClass: "btn btn-gray"
  }, [_vm._v("提交订单")])])])]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "prop-box time-list",
    attrs: {
      "id": "prop-box"
    }
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v(_vm._s(_vm.timeTitle))]), _vm._v(" "), (_vm.orderPreviewInfo.dineInLimitTips && _vm.orderType == 3) ? _c('div', {
    staticClass: "dineInLimitTips"
  }, [_vm._v("\n      " + _vm._s(_vm.orderPreviewInfo.dineInLimitTips) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "select-date"
  }, _vm._l((_vm.dateList), function(item) {
    return _c('li', {
      key: item.delivery_date,
      class: {
        active: item.isActive
      },
      on: {
        "click": function($event) {
          return _vm.changeDate(item.delivery_date)
        }
      }
    }, [_vm._v(_vm._s(item.delivery_date_name) + "\n      ")])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "select-time",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.currentTimeList), function(item) {
    return _c('li', {
      class: {
        'canSelect': item.canSelected == 0
      },
      on: {
        "click": function($event) {
          item.canSelected == 0 ? null : _vm.changeTime(item.delivery_time, item.delivery_time_name, item)
        }
      }
    }, [_vm._v(_vm._s(item.delivery_time_name) + "\n      ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.deliveryPopup) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toggleDeliveryProp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deliveryPopup) ? _c('div', {
    staticClass: "prop-box delivery-list"
  }, [_c('div', {
    staticClass: "title ac"
  }, [_vm._v("请选择配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.orderPreviewInfo.deliveryWayList), function(item) {
    return _c('div', {
      staticClass: "item flex-row-bc",
      on: {
        "click": function($event) {
          return _vm.choseDelivery(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, [_c('span', {
      class: !item.isCanSelect && item.upstairsDelivery == 1 ? 'fc-999' : '',
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "fc-999",
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v(" "), _c('span', {
      staticClass: "fc-999",
      staticStyle: {
        "font-size": "11px"
      }
    }, [(item.upstairsDelivery == 1) ? _c('span', [_vm._v(_vm._s(item.tip))]) : _vm._e()])]), _vm._v(" "), (item.selected) ? _c('img', {
      staticStyle: {
        "width": ".36rem",
        "height": ".36rem"
      },
      attrs: {
        "src": __webpack_require__(332)
      }
    }) : _vm._e(), _vm._v(" "), (!item.selected) ? _c('img', {
      class: !item.isCanSelect && item.upstairsDelivery == 1 ? 'opa-5' : '',
      staticStyle: {
        "width": ".36rem",
        "height": ".36rem"
      },
      attrs: {
        "src": __webpack_require__(333)
      }
    }) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreGift),
      expression: "showMoreGift"
    }],
    staticClass: "gift-list ",
    on: {
      "click": _vm.selectGift
    }
  }, [_c('ul', [_c('li', {
    staticClass: "title"
  }, [_vm._v("可选赠品")]), _vm._v(" "), _vm._l((_vm.giftList), function(item) {
    return _c('li', {
      staticClass: "select-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeGift(item)
        }
      }
    }, [_c('span', {
      staticClass: "gift-name"
    }, [_vm._v(_vm._s(item.good_name) + "x" + _vm._s(item.number))]), _vm._v(" "), _c('span', {
      staticClass: "icon icon-select",
      class: {
        'on': item.is_selected == 1
      }
    })])
  })], 2)]), _vm._v(" "), (_vm.showBuildingPop) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.showBuildingPop = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBuildingPop) ? _c('div', {
    staticClass: "prop-box"
  }, [_c('ul', {
    staticClass: "building-title"
  }, _vm._l((_vm.buildInfo), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.changeBuildingTitle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n      ")])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "building-cnt"
  }, _vm._l((_vm.buildingList), function(item) {
    return _c('li', {
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.changeBuilding(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.area) + "\n      ")])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "flexrow",
    staticStyle: {
      "align-items": "center",
      "justify-content": "space-between",
      "padding": "0 0.2rem"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "0.26rem"
    }
  }, [_vm._v("支付")]), _c('span', [_vm._v("在线支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "header"
  }, [(!_vm.schoolLock) ? _c('div', {
    staticClass: "choose-school",
    on: {
      "click": _vm.chooseSchool
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]) : _c('div', {
    staticClass: "choose-school no-choose"
  }, [_c('span', [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]), _vm._v(" "), _c('div', {
    staticClass: "to-search",
    on: {
      "click": _vm.toSearch
    }
  }, [_c('span', [_vm._v("搜索商家、商品名称")])])]), _vm._v(" "), _c('div', {
    staticClass: "main no-foot"
  }, [_c('div', {
    staticClass: "banner",
    attrs: {
      "id": "banner1"
    }
  }, [(_vm.banners.length > 0) ? _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + item.imageUrl + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.bannerJump(item.data)
        }
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })]), _vm._v(" "), (_vm.showPage) ? _c('div', [(_vm.shopCategoryList.length > 0) ? _c('div', {
    staticClass: "category-list"
  }, [_c('ul', _vm._l((_vm.shopCategoryList), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toShopList(item.id, item.category_name)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: (item.backgroundimg)
    }), _vm._v(_vm._s(item.category_name) + "\n            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goods-list shop"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("本校商家")]), _vm._v(" "), _c('ul', _vm._l((_vm.currentShopList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des"
    }, [_c('div', {
      staticClass: "name",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "threshold"
    }, [_c('span', [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), (item.delivery_type == 0) ? _c('span', [_vm._v("配送 ￥" + _vm._s(item.delivery_fee))]) : _c('span', [_vm._v("配送 ￥" + _vm._s(item.delivery_fee) + " (商家自配送)")])]), _vm._v(" "), (item.promotion_list.length > 0) ? _c('div', [(item.promotion_list.length <= 2) ? _c('div', {
      staticClass: "more-promotion"
    }, _vm._l((item.promotion_list), function(p) {
      return _c('div', {
        staticClass: "des"
      }, [_c('span', {
        style: ({
          backgroundImage: 'url(' + p.icon_url + ')'
        })
      }, [_vm._v(_vm._s(p.promotion_name))])])
    }), 0) : _c('div', {
      staticClass: "more-promotion"
    }, [(item.isShowAll) ? _c('div', [_vm._l((item.promotion_list), function(p) {
      return _c('div', {
        staticClass: "des"
      }, [_c('span', {
        style: ({
          backgroundImage: 'url(' + p.icon_url + ')'
        })
      }, [_vm._v(_vm._s(p.promotion_name))])])
    }), _vm._v(" "), _c('span', {
      staticClass: "shield-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    })], 2) : _c('div', [_c('div', {
      staticClass: "des"
    }, [_c('span', {
      style: ({
        backgroundImage: 'url(' + item.promotion_list[0].icon_url + ')'
      })
    }, [_vm._v(_vm._s(item.promotion_list[0].promotion_name))])]), _vm._v(" "), _c('div', {
      staticClass: "des"
    }, [_c('span', {
      style: ({
        backgroundImage: 'url(' + item.promotion_list[1].icon_url + ')'
      })
    }, [_vm._v(_vm._s(item.promotion_list[1].promotion_name))])]), _vm._v(" "), _c('span', {
      staticClass: "show-more",
      on: {
        "click": function($event) {
          return _vm.toggleShowMore(item)
        }
      }
    })])])]) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("休息中")])])])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooseschool chooseschool2"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_c('span', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "placeholder": "请输入学校名称"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.message != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.searchSchool()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), (!_vm.iSearch && _vm.nearSchoolList.length > 0) ? _c('div', {
    staticClass: "search-result search-result2"
  }, [_c('div', {
    staticClass: "c-gray"
  }, [_vm._v("附近学校")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.nearSchoolList), function(item, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item.schoolName)
      },
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.schoolName))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.iSearch && _vm.schoolList.length > 0) ? _c('div', {
    staticClass: "search-result search-result2"
  }, [_c('div', {
    staticClass: "c-gray"
  }, [_vm._v("搜索结果")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item.schoolName)
      },
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.schoolName))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isjdlw) ? _c('div', {
    staticClass: "jdlw-ready"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _vm._v(" "), _c('p', [_vm._v("亲爱的同学，你的学校当前尚未开通，快搜索别的学校看看吧~")])]) : _vm._e()]), _vm._v(" "), (_vm.showBottomTips) ? _c('div', {
    staticClass: "bottomTips"
  }, [_c('p', [_vm._v("上海鎏帑网络科技有限公司   沪ICP备18024716号-1")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v(" 联系电话：021-60761299")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.2rem",
      "height": "0.2rem",
      "margin-top": "0.08rem",
      "float": "left"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("沪公网安备 31010402004817号")])])])
}]}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remarkContainer"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "remarks-boder",
    attrs: {
      "maxlength": "100",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }, function($event) {
        return _vm.changeComment()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-28",
    staticStyle: {
      "color": "#787878",
      "margin-top": ".1rem",
      "margin-left": ".2rem"
    }
  }, [_vm._v("快捷标签")]), _vm._v(" "), _c('div', {
    staticClass: "remark-tag"
  }, _vm._l((_vm.remarkList), function(item) {
    return _c('div', {
      staticClass: "tag-items ellipse",
      on: {
        "click": function($event) {
          return _vm.addTips(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-main btn-lg btn-block",
    staticStyle: {
      "margin": ".2rem auto",
      "width": "7.1rem"
    },
    on: {
      "click": function($event) {
        return _vm.toOrder()
      }
    }
  }, [_vm._v("完 成")])])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "fl back-btn",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart",
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('div', {
    staticClass: "main"
  }, [(!_vm.uid || _vm.uid == 'null' || _vm.uid == '') ? _c('div', {
    staticClass: "unlogin"
  }, [_c('div', {
    staticClass: "unlogin-img"
  }), _vm._v(" "), _c('p', [_vm._v("您还没有登录，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "goToLogin_btn",
    on: {
      "click": _vm.toGoLogin
    }
  }, [_vm._v("登录")])]) : _c('div', [(_vm.showPage) ? _c('div', [(_vm.orderList.length > 0) ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "list order_list",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_c('ul', _vm._l((_vm.orderList), function(order) {
    return _c('li', [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "height": "0.8rem",
        "justify-content": "space-between"
      }
    }, [_c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "shopImg",
      style: ({
        backgroundImage: 'url(' + order.supplierUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_c('span', {
      staticClass: "arrow-right ellipse shop_name",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(order.supplierId, order.supplier_name, order)
        }
      }
    }, [_vm._v(_vm._s(order.supplier_name))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(order.create_time))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "text-align": "right",
        "color": "#787878"
      }
    }, [_c('div', {
      staticClass: "order-status"
    }, [_vm._v(_vm._s(order.orderStatusStr))]), _vm._v(" "), (order.aboutOutDinnerDesc) ? _c('div', {
      staticStyle: {
        "font-size": ".2rem",
        "color": "#FEC300"
      }
    }, [_vm._v("\n                    " + _vm._s(order.aboutOutDinnerDesc) + "\n                  ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "goods-list",
      on: {
        "click": function($event) {
          return _vm.jumpToOrder(order.orderId, order.orderType)
        }
      }
    }, [_vm._l((order.goodsList), function(item) {
      return _c('div', [_c('span', {
        staticClass: "ellipse",
        staticStyle: {
          "display": "inline-block",
          "width": "80%"
        }
      }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "color": "#787878"
        }
      }, [_vm._v("x " + _vm._s(item.goodsNum))])])
    }), _vm._v(" "), (order.omit) ? _c('div', {
      staticClass: "moreList"
    }, [_vm._v("···")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "clearflow",
      staticStyle: {
        "width": "100%",
        "margin": "0.15rem 0 0.2rem 0"
      }
    }, [_c('span', {
      staticClass: "fr pr"
    }, [_c('span', {
      staticStyle: {
        "color": "#787878"
      }
    }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(order.real_pay))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearflow"
    }, [(order.canEstimated == 1 && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.toComment(order.orderId)
        }
      }
    }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), ((order.order_status == 2002 || order.order_status == 3001 || order.order_status == 9000) && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-plain fr",
      on: {
        "click": function($event) {
          return _vm.moreOrder(order.orderId, order.supplierId, order.supplier_name)
        }
      }
    }, [_vm._v("再来一单")]) : _vm._e(), _vm._v(" "), (order.order_status == 1000) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.jumpToOrder(order.orderId, order.orderType)
        }
      }
    }, [_vm._v("去支付")]) : _vm._e(), _vm._v(" "), (order.order_status == 1000 && order.orderType != 4) ? _c('span', {
      staticClass: "btn btn-order btn-plain fr",
      staticStyle: {
        "padding": "0.08rem 0.2rem"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(order.orderId)
        }
      }
    }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (order.orderPickUpInfoBean && order.orderPickUpInfoBean.takeStatus == 0) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.openCabinet(order)
        }
      }
    }, [_vm._v("一键开柜取餐")]) : _vm._e(), _vm._v(" "), (order.reminderButton == 1) ? _c('span', {
      staticClass: "btn btn-order btn-yellow fr",
      on: {
        "click": function($event) {
          return _vm.reminderOrder(order.orderId)
        }
      }
    }, [_vm._v("催单")]) : _vm._e()])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    staticStyle: {
      "margin-top": "-.16rem"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118),
      "alt": ""
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.noNetwork) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.isShowCabinet) ? _c('div', {
    staticClass: "selfWrap"
  }, [_c('div', {
    staticClass: "self-mask",
    staticStyle: {
      "width": "6.4rem",
      "margin-left": "-3.2rem",
      "margin-top": "-3rem",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "padding": ".7rem .4rem .5rem .4rem",
      "margin-bottom": "0",
      "background-color": "transparent"
    }
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": __webpack_require__(35)
    }
  }), _vm._v("\n          " + _vm._s(_vm.chooseCabinetItem.orderPickUpInfoBean.deviceName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no",
    staticStyle: {
      "width": "1.8rem"
    }
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.chooseCabinetItem.orderPickUpInfoBean.cellNo) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": ".4rem 0"
    }
  }, [_vm._v("请确保在自提柜附近操作开柜，防止餐品丢失。")]), _vm._v(" "), (!_vm.isShowProgress) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "height": ".84rem",
      "line-height": ".84rem",
      "margin-bottom": ".2rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("确认开柜\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isShowProgress) ? _c('div', {
    staticClass: "progressbar"
  }, [_c('div', {
    staticClass: "fill"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-cancle",
    on: {
      "click": _vm.cancelCab
    }
  }, [_vm._v("取消开柜")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337)
    }
  }), _vm._v(" "), _c('p', [_vm._v("还没有产生过订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(336)
    }
  }), _vm._v(" "), _c('p', [_vm._v("连接不到网络...")])])
}]}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("本店(" + _vm._s(_vm.schoolName) + ")目前支持的配送楼栋如下：")]), _vm._v(" "), (_vm.buildsList.length > 0) ? _c('div', {
    staticClass: "builds"
  }, _vm._l((_vm.buildsList), function(item) {
    return _c('div', {
      staticClass: "builds"
    }, [_vm._v(_vm._s(item.area)), (item.msg) ? _c('span', [_vm._v(_vm._s(item.msg))]) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "ac"
  }, [_vm._v("暂无楼栋")])])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.rewardOrderList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "rewardList"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.createTime))])])]), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(item.rewardAmount) + "元")])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restaurant-detail"
  }, [(_vm.showTop) ? _c('div', {
    staticClass: "state-box box"
  }, [(_vm.order.pay_status) ? _c('img', {
    staticClass: "state-img",
    attrs: {
      "src": __webpack_require__(120),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "state-img",
    attrs: {
      "src": __webpack_require__(343)
    }
  }), _vm._v(" "), (_vm.order.pay_status) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("订单完成")]) : _c('div', {
    staticClass: "title"
  }, [_vm._v("支付失败")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [(false) ? _c('div', {
    staticClass: "btn-info",
    on: {
      "click": _vm.toComment
    }
  }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), (!_vm.order.pay_status) ? _c('div', {
    staticClass: "btn-warn",
    on: {
      "click": _vm.toPay
    }
  }, [_vm._v("立即支付")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-box box"
  }, [_c('div', {
    staticClass: "info-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.order.supplier_name))]), _vm._v(" "), _vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      key: item.skuCode,
      staticClass: "list"
    }, [_c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "data"
    }, [_c('div', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.weight) + "克")]), _vm._v(" "), _c('div', [_vm._v("¥" + _vm._s(item.gdAmount))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_c('div', [_vm._v("合计 "), _c('span', [_vm._v("¥" + _vm._s(_vm.order.real_pay))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-box box"
  }, [_c('div', {
    staticClass: "order-code"
  }, [_c('div', [_vm._v("托盘编号")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.trayNo))])]), _vm._v(" "), _c('div', {
    staticClass: "order-log"
  }, [_c('div', [_vm._v("绑定时间"), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])]), _vm._v(" "), (_vm.order.payTime) ? _c('div', [_vm._v("解绑时间"), _c('span', [_vm._v(_vm._s(_vm.order.payTime))])]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("订单编号"), _c('span', [_vm._v(_vm._s(_vm.orderId))])]), _vm._v(" "), _c('div', [_vm._v("下单时间"), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])]), _vm._v(" "), (_vm.order.payTime) ? _c('div', [_vm._v("支付时间"), _c('span', [_vm._v(_vm._s(_vm.order.payTime))])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.punctualArriveInfo.description) ? _c('div', {
    staticClass: "card"
  }, [_vm._v("\n  " + _vm._s(_vm.punctualArriveInfo.description) + "\n")]) : _vm._e(), _vm._v(" "), (_vm.punctualArriveInfo.supplier_id) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.supplier_name))]), _vm._v(" "), _c('div', {
    staticClass: "fw-bold border-bottom mt10",
    staticStyle: {
      "font-size": ".56rem",
      "padding-bottom": ".24rem"
    }
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.guaranteeStatusStr))]), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc mt24"
  }, [_c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.punctualArriveInfo.orderStatusTitle))]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.guaranteeDetailDesc))])]), _vm._v(" "), (_vm.punctualArriveInfo.headOfficeTel) ? _c('a', {
    staticClass: "btn-plain btn-yellow btn-kf",
    attrs: {
      "href": 'tel:' + _vm.punctualArriveInfo.headOfficeTel
    }
  }, [_vm._v("联系客服")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fs-32 fw-bold"
  }, [_vm._v(_vm._s(_vm.punctualArriveInfo.content))]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._l((_vm.punctualArriveInfo.contentList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-row-bc mb24"
    }, [_c('div', {
      staticClass: "fw-bold"
    }, [_vm._v(_vm._s(item.contentKey))]), _vm._v(" "), _c('div', {
      staticClass: "fc-666"
    }, [_vm._v(_vm._s(item.contentValue))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "rule-list"
  }, _vm._l((_vm.punctualArriveInfo.ruleList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(item.overTimeDesc))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.compensateDesc))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rule-tips",
    on: {
      "click": function($event) {
        return _vm.viewRules()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.punctualArriveInfo.ruleTips)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['container', {
      'containerGreen': _vm.orderType == 3
    }]
  }, [_c('div', {
    staticClass: "x-qrcode"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.orderType == 1 ? '自提' : '堂食'))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(JSON.parse(_vm.code).orderShortNum))]), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("商家名称")]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.supplier_name))]), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.orderType == 1 ? '自提时间：' : '就餐时间：'))]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.deliveryTime))]), _vm._v(" "), (_vm.isInvalid != 2) ? _c('div', {
    attrs: {
      "id": "qrcode"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInvalid == 2 && _vm.orderType == 3) ? _c('div', {
    staticStyle: {
      "background": "rgba(255,255,255,0.50)",
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "qr-mask",
    attrs: {
      "src": __webpack_require__(342),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-out"
  }, [_vm._v("已过用餐时间，二维码失效")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "red ac",
    staticStyle: {
      "margin-top": ".08rem",
      "font-size": ".24rem"
    }
  }, [_vm._v(_vm._s(_vm.qrCodeIndate))]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("取餐时出示给商家/同学，完成堂食或自提订单验证")])])])])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mycomplaints"
  }, [(_vm.showPage) ? _c('div', [(_vm.complaitintList.length > 0) ? _c('ul', {
    staticClass: "complaints_list"
  }, _vm._l((_vm.complaitintList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "title",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.supplierId, item.supplierShortName)
        }
      }
    }, [_c('div', {
      staticClass: "fl shop_icon",
      style: ({
        backgroundImage: 'url(' + item.shopIcon + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shop_info"
    }, [_c('span', {
      staticClass: "fl shop_name"
    }, [_vm._v(_vm._s(item.supplierShortName))]), _c('span', {
      staticClass: "fr state"
    }, [_vm._v(_vm._s(_vm.complainStatus[item.complainStatus]))])]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-list"
    }, [_c('ul', {
      staticStyle: {
        "margin-top": "0.2rem"
      }
    }, _vm._l((item.goodsList), function(order) {
      return _c('li', {
        staticStyle: {
          "margin-bottom": "0.12rem",
          "padding-top": "0",
          "padding-right": "0"
        }
      }, [_c('span', {
        staticClass: "fl"
      }, [_vm._v(_vm._s(order.name))]), _vm._v(" "), _c('span', {
        staticClass: "fr",
        staticStyle: {
          "color": "#9B9B9B"
        }
      }, [_vm._v("x " + _vm._s(order.buyNum))])])
    }), 0), _vm._v(" "), (item.omit) ? _c('div', {
      staticClass: "moreList"
    }, [_vm._v("···")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "price_info clearflow"
    }, [_c('p', {
      staticStyle: {
        "font-size": "0.28rem"
      }
    }, [_vm._v("总计"), _c('span', {
      staticClass: "pay_price",
      staticStyle: {
        "color": "#4A4A4A",
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item.amount))])]), _vm._v(" "), _c('span', {
      staticClass: "fr btn_check",
      on: {
        "click": function($event) {
          return _vm.toCheckComplaints(item.complaintId)
        }
      }
    }, [_vm._v("查看投诉")])])])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "main no-foot"
  }, [(_vm.showPage) ? _c('div', [(_vm.bannerUrl) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.bannerUrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopList.length > 0) ? _c('div', {
    staticClass: "goods-list shop"
  }, [_c('ul', {
    staticClass: "goods"
  }, _vm._l((_vm.shopList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    }), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v(_vm._s(item.mark))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('CommentStars', {
      attrs: {
        "qualityCode": item.score
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "threshold"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("起送 ￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.new_delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])]) : _c('div', [_c('span', {
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("配送￥" + _vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()]), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce"
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2) {
      return _c('span', {
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon"
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, _vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1 && item.is_book == 0) ? _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")]) : (item.is_open == 1 && item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxwork"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(349),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("请在学校企业号中使用云订餐")])])])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbox"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-group"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mp),
      expression: "mp",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "tel",
    attrs: {
      "type": "tel",
      "placeholder": "手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.mp)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.mp = $event.target.value.trim()
      }, _vm.onlyNum],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.countDown) ? _c('span', {
    staticClass: "get-code"
  }, [_vm._v(_vm._s(_vm.time) + "s")]) : _c('span', {
    staticClass: "get-code",
    on: {
      "click": _vm.postSmsCaptcha
    }
  }, [_vm._v("获取验证码")])]), _vm._v(" "), _c('div', {
    staticClass: "input-box border"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.captcha),
      expression: "captcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "number",
      "placeholder": "验证码",
      "maxlength": "6",
      "oninput": "if(value.length>6) value = value.slice(0,6)"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如果您还没有用这个手机号注册过俺来也，我们将为您创建俺来也账号。")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.postSignIn.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")])]), _vm._v(" "), (_vm.showDrag) ? _c('div', {
    staticClass: "mask",
    staticStyle: {
      "z-index": "105"
    }
  }, [_c('div', {
    staticClass: "drag"
  }, [_c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showDrag = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', [_vm._v("请您通过验证")]), _vm._v(" "), _c('div', {
    staticClass: "drag_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "handler_bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "handler",
    on: {
      "touchstart": function($event) {
        return _vm.mouseDownFn($event)
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("向右滑吃掉豆子~")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "drag_bg"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooseschool chooseschool1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "search-box",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    class: ['current-city', {
      'on': _vm.showCity
    }],
    on: {
      "click": _vm.toggleCity
    }
  }, [_vm._v(_vm._s(_vm.currentCity.city_name))]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipinput),
      expression: "tipinput"
    }],
    attrs: {
      "id": "tipinput",
      "placeholder": "搜索当前城市下的具体地址"
    },
    domProps: {
      "value": (_vm.tipinput)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.tipinput = $event.target.value
      }, function($event) {
        return _vm.getSuggestions()
      }]
    }
  }), _vm._v(" "), (_vm.suggestionList.length) ? _c('ul', _vm._l((_vm.suggestionList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.setCitySearch(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.tipinput != '') ? _c('span', {
    staticClass: "clearbtn",
    on: {
      "click": _vm.clearInput
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCity),
      expression: "showCity"
    }],
    staticClass: "choose-city"
  }, [_c('div', {
    staticClass: "city-list"
  }, [_c('div', {
    attrs: {
      "id": "cityList"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('div', {
      staticClass: "city-box"
    }, [_c('div', {
      staticClass: "title",
      attrs: {
        "id": item.pinyin_index
      }
    }, [_vm._v(_vm._s(item.pinyin_index))]), _vm._v(" "), _c('ul', _vm._l((item.city_list), function(item2) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.chooseCity(item2.city_name, item2.city_id)
          }
        }
      }, [_vm._v(_vm._s(item2.city_name))])
    }), 0)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pinyin"
  }, _vm._l((_vm.pinyinList), function(item) {
    return _c('div', {
      on: {
        "click": function($event) {
          return _vm.choosePinyin(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCity),
      expression: "!showCity"
    }]
  }, [_c('div', {
    staticStyle: {
      "height": "5rem",
      "margin-top": "0.88rem"
    },
    attrs: {
      "id": "mapContainer"
    }
  }), _vm._v(" "), (_vm.poiList.length) ? _c('div', {
    staticClass: "search-result",
    staticStyle: {
      "padding": "0 0.26rem"
    }
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.poiList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.saveInfo(item)
        }
      }
    }, [_c('a', [_c('p', {
      class: {
        'first': index == 0
      }
    }, [(index == 0) ? _c('span', [_vm._v("[当前位置]")]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "detail"
    }, [_vm._v(_vm._s(item.address))])])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.5rem 0.3rem",
      "background": "#F6F6F6"
    }
  }, [_c('div', [_vm._v("\n    服务协议是您与俺来也之间就俺来也提供的订餐服务等相关事宜所订立的协议。请您仔细阅读本协议，您勾选\"同意并接受《打包自提用户协议》\"并点击使用服务后，本服务协议对您产生约束力。您应当在使用服务平台的服务之前认真阅读、充分理解全部条款的内容，如您对条款有任何疑问的，应向平台客服咨询。\n  ")]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("1. 定义")]), _vm._v(" "), _c('p', [_vm._v("1.1 服务平台：是搭建、提供及维护打包自提服务信息发布的平台，即俺来也平台。")]), _vm._v(" "), _c('p', [_vm._v("1.2 用户：即本协议中的“您”，是指在服务平台上下打包自提订单的俺来也外卖用户。")]), _vm._v(" "), _c('p', [_vm._v("1.3 商家：是指通过服务平台为用户提供打包自提服务的商家。用户在服务平台下打包自提订单后，服务平台将向商家推送订单，商家在在成功接受订单后，将在规定完成商品准备并等待您打包自提。")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("\n      2. 服务协议的确认和接受\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.1 在您使用服务平台的服务之前认真阅读全部条款内容。如您对服务协议有任何疑问的，应联系客服咨询，如不同意，您有权拒绝使用平台提供的服务。一旦您使用服务平台的服务，即表示您已充分阅读、理解并接受本服务协议的全部内容，服务协议即对您产生约束力。届时您不应以未阅读（理解或同意）服务协议的内容为由，主张服务协议无效，或要求撤销服务协议。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.2 您在阅读并同意本服务协议并实际使用服务平台的服务时，您即受本服务协议的约束。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.3 本协议内容包括服务协议正文及所有服务平台已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与服务协议正文具有同等法律效力。您承诺接受并遵守本协议的约定，如果您不同意本协议的约定，您应立即停止使用服务平台的服务。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      2.4 服务平台有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议或各类规则，并在服务平台公示或向您的账户推送消息通知您。如您继续使用服务平台的服务的，即表示您接受经修订的协议和规则。\n    ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("\n      3. 服务平台提供的服务\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.1 搭建、提供及维护服务信息，为用户和商家提供信息发布和撮合交易。\n    ")]), _vm._v(" "), _c('p', [_vm._v("3.2 用户可以通过服务平台下打包自提订单。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.3 服务平台根据用户提交的订单信息，包括自提电话、自提时间、订单商品等，生成自提订单，并在用户支付后将订单信息推送至商家，并提醒商家根据相应的订单信息及时准确备货，以备用户前来自提。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.4 在本协议项下，服务平台仅为用户和商家提供达成双方打包自提订单的居间撮合服务。用户与商家达成的打包自提服务过程中产生的全部权利义务，包括但不限于没有取到商品、商品未及时准备、商品品质、质量和价值分歧等，由用户与商家间的违约方承担，与服务平台无关。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.5 服务平台保留在后续服务在运营过程中收取用户的平台服务费的权利，如收费，以本平台实际展示为准。服务平台保留在无须发出书面通知，仅在消息通知、短信通知、网站通知、系统推送或其他方式通知的情况下，暂时或永久地更改或停止部分或全部打包自提服务的权利。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.6 服务平台受理用户和商家的投诉，并联系对方对投诉进行调查核实。若用户对商家进行投诉，服务平台有权按照平台规则追究法律责任的权利；另外，服务平台有权禁止受投诉商家使用平台服务。若商家对用户进行投诉，服务平台有权暂时禁止受投诉用户使用平台服务。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      3.7 打包自提服务只能为已开通打包自提服务的城市的用户提供服务。\n    ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("\n      4. 用户权利义务\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.1 用户保证，通过服务平台下的自提订单时选择合理的自提商品时间及正确可联系到的自提电话，并在预定的自提时间前后不超过10分钟打包自提订单的商品。如迟到或早到，而带来的后果包括不限于等待、商品丢失、商品品质及质量下降、订单不退款等，由用户自行承担。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.2 商家接受打包自提订单后，若因用户的原因导致订单无法完成从而给商家造成损失的，用户应当予以赔偿。如因不可抗力或其他服务平台无法控制的原因使系统崩溃或无法正常使用服务平台导致网上交易无法完成或丢失有关信息、记录等，服务平台不承担责任。但是服务平台会尽可能地协助处理善后事宜，并努力使用户免受经济损失。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.3 商家就已接受的自提订单，但无法完成的，应由平台合作伙及时通知平台，或协助与用户协商解决。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.4 用户同意，在使用打包自提服务过程中出现的与商家的分歧，应由您和商家自行友好协商解决。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4.5用户应当严格遵守本服务协议及服务平台发布的其他规则、须知或协议，因用户违反本服务协议或其他规则、须知或协议的行为给第三方、或给服务平台造成损失的，用户应当承担赔偿责任。\n    ")])]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("\n      5. 责任范围与责任限制\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.1 用户需确认，您在实际使用服务平台的服务时，应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果，服务平台有权注销您的账户或停止向您提供服务。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.2 用户在服务平台注册成功后，将产生用户名和密码等账户信息，您可以根据服务平台的规则改变您的密码。用户应谨慎合理的保存、使用其用户名和密码并对通过您的账户和密码实施的所有行为、活动及事件负全责。用户若发现任何不当使用用户账号或存在安全漏洞等其他可能危及用户账户安全的情况，应当立即以有效方式通知服务平台，要求服务平台暂停相关服务，并向公安机关报案。您理解服务平台对您的请求采取行动需要合理时间，服务平台对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。用户不得将在本服务平台账户借（租）给他人使用，否则您应承担由此产生的全部责任。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.3 用户同意自行承担使用网络服务的风险，服务平台不作任何类型的担保，包括但不限于：不担保服务一定能满足用户的要求；不担保服务不会受中断，对服务的及时性，安全性，出错发生不担保；对在服务平台上以及第三方合作得到的任何服务或交易进程，不作担保；对平台服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、稳定性、完整性和及时性不作出任何承诺和保证；不担保平台服务的适用性没有错误或疏漏。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.4 用户理解并同意服务平台作为信息发布平台，无法控制每一任务事项所涉及的商品/服务质量、安全或合法性、任务事项内容的真实性或准确性、以及任务事项所涉各方履行任务事项的能力。您应自行谨慎判断确定相关信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。您应在使用打包自提服务并自提商品时检查商品的数量是否正确及商品是否完整，在用户端操作订单完成或用户无任何操作 时后应视为认可打包自提的商品符合您的要求。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.5 用户同意并确认，服务平台拥有独自决定拒绝服务、关闭用户账户或取消任务事项的权利。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.6 用户在通过服务平台进行在线下订单等活动时，涉及用户真实姓名/名称、履行地址、联系电话等隐私信息的，服务平台将予以严格保密，除非得到用户的授权或法律法规、本条款另有规（约）定外，服务平台不会向外界披露用户隐私信息。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.7 用户同意服务平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与服务平台同等的保护用户隐私的责任，则服务平台有权将用户的信息资料等提供给该第三方。另外，在不透露单个用户隐私资料的前提下，服务平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n     5.8 用户对商家的评价或评分等信息都将作为服务平台的数据财产，服务平台有权予以展示、汇编及其他合理使用。用户接受本协议即表明该用户将其在服务平台发表的任何形式的信息的著作权或其他合法权利，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给服务平台所有，同时表明用户许可服务平台有权就任何主体侵权而单独提起诉讼，并获得全部赔偿。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      5.9 用户同意服务平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知与本协议相关服务信息的权利，用户允许平台向其发送上述电子信息。\n    ")])])])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schoolPay"
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._v("校园卡扣款成功")]), _vm._v(" "), _c('div', {
    staticClass: "ac name"
  }, [_vm._v("俺来也")]), _vm._v(" "), _c('div', {
    staticClass: "num ac"
  }, [_c('span', {
    staticClass: "fs-60"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.amount))]), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow suc-btn",
    on: {
      "click": _vm.toOrderDetail
    }
  }, [_vm._v("完成")])])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "online_comment main"
  }, [_c('div', {
    staticClass: "top-tips"
  }, [_vm._v("提交评价或建议，可以帮助骑手和商家做的更好哦～")]), _vm._v(" "), (_vm.mainInfo.deliveryName) ? _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-cnt"
  }, [_c('div', {
    staticClass: "delivery-info"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainInfo.deliveryImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.mainInfo.deliveryName))])]), _vm._v(" "), _c('div', {
    staticClass: "delivery-comment"
  }, [_c('div', {
    staticClass: "options"
  }, _vm._l((_vm.deliveryScores), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item",
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkDeliveryScore(item)
        }
      }
    })
  }), 0), _vm._v(" "), (_vm.deliveryScores[0].checked) ? _c('div', [_c('div', {
    staticClass: "tips"
  }, [_vm._v("*请选择原因，我们会督促骑手")]), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.mainInfo.badDeliveryTemplateList), function(item) {
    return _c('li', {
      key: item.estimateCode,
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkBadDeliveryTag(item)
        }
      }
    }, [_vm._v(_vm._s(item.estimateDesc))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryComment),
      expression: "deliveryComment"
    }],
    attrs: {
      "name": "deliveryComment",
      "id": "deliveryComment",
      "maxlength": "100",
      "placeholder": "非常抱歉，您的反馈会督促我们做的更好"
    },
    domProps: {
      "value": (_vm.deliveryComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryComment = $event.target.value
      }
    }
  })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('div', [_vm._v("您对商家/菜品满意吗？")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": _vm.selectAnonymous
    }
  }, [_c('span', {
    staticClass: "anonymous_btn",
    class: {
      'selected': _vm.selected
    }
  }), _vm._v("\n        匿名提交\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-cnt"
  }, [_c('div', {
    staticClass: "shop-info",
    staticStyle: {
      "margin-bottom": ".4rem"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainInfo.shopImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.mainInfo.shopName))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-comment"
  }, [_vm._l((_vm.stars), function(star, index) {
    return _c('div', {
      key: index,
      staticClass: "stars"
    }, [(star.isShow) ? _c('div', [_c('span', [_vm._v(_vm._s(star.title))]), _vm._v(" "), _c('ul', _vm._l((star.list), function(item, index1) {
      return _c('li', {
        key: index1,
        class: {
          'active': item.active
        },
        on: {
          "click": function($event) {
            return _vm.tapStar(star, index1)
          }
        }
      })
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(star.desc))])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    attrs: {
      "name": "comment",
      "id": "comment",
      "maxlength": "100",
      "placeholder": "写下用餐感受，给大家参考～"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "addPic"
  }, [_c('ul', _vm._l((_vm.goodsImages), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "fl upLoadPic"
    }, [_c('div', {
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.deletepic(index)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddShow),
      expression: "isAddShow"
    }],
    staticClass: "addPicBtn"
  }, [_c('form', {
    attrs: {
      "id": "uploadForm",
      "method": "post",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "uploadImg",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.getImage($event)
      }
    }
  })])])])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('img', {
      staticStyle: {
        "width": ".52rem",
        "height": ".52rem",
        "border-radius": ".08rem",
        "margin-right": ".16rem"
      },
      attrs: {
        "src": item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-sc"
    }, [_c('div', {
      staticClass: "bad",
      class: {
        'active': item.scoreType == 1
      },
      on: {
        "click": function($event) {
          return _vm.selectClick(item, 'bad', index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "good",
      class: {
        'active': item.scoreType == 2
      },
      on: {
        "click": function($event) {
          return _vm.selectClick(item, 'good', index)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bottom"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交点评")])]), _vm._v(" "), (_vm.isOk) ? _c('div', {
    staticClass: "alert_mask fixed",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "alert_con"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('p', [_vm._v("感谢您的评价")]), _vm._v(" "), _c('p', [_vm._v("让我们做的更好～")]), _vm._v(" "), _c('div', {
    staticClass: "ok",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('div', [_vm._v("您对西游侠配送满意吗？")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("已对西游侠匿名")])])
}]}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "height": "12rem",
      "overflow": "auto"
    }
  }, _vm._l((_vm.packingFeeDetail.value.packingFeeDetail), function(item) {
    return (item.packing_fee != '0') ? _c('div', {
      staticClass: "fs-28 flex-row-bc item"
    }, [_c('div', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "fs-24"
    }, [_c('span', {
      staticClass: "c-gray",
      staticStyle: {
        "padding-right": ".24rem"
      }
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v("\n        " + _vm._s(item.value) + "\n      ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": ".4rem",
      "left": ".32rem",
      "right": ".32rem",
      "line-height": ".46rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.packingFeeDetail.value.description)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "otherDetail"
  }, [_c('div', {
    staticClass: "des",
    domProps: {
      "innerHTML": _vm._s(_vm.otherDetail.content)
    }
  }), _vm._v(" "), (_vm.otherDetail.image_list.length > 0) ? _c('div', {
    staticClass: "page-num"
  }, [_vm._v(_vm._s(_vm.pictureIndex) + " / " + _vm._s(_vm.pictureTotal))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.otherDetail.image_list), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + item + ')'
      })
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPage) ? _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [(!_vm.schoolLock) ? _c('span', {
    staticClass: "choose-school",
    on: {
      "click": _vm.chooseSchool
    }
  }, [_c('span', {
    staticClass: "ellipse"
  }, [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]) : _c('span', {
    staticClass: "choose-school no-choose"
  }, [_c('span', {
    staticClass: "ellipse"
  }, [_vm._v(_vm._s(_vm.schoolInfo.schoolName))])]), _vm._v(" "), _c('span', {
    staticClass: "to-search",
    on: {
      "click": _vm.toSearch
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.banners.length > 0) ? _c('div', {
    staticClass: "banner card",
    attrs: {
      "id": "banner"
    }
  }, [(_vm.banners.length > 1) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "swiper-container banner-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.banners), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "padding": "0 .2rem",
        "position": "relative"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "border-radius": ".16rem"
      },
      attrs: {
        "src": item.imageUrl
      }
    }), _vm._v(" "), (item.type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.data).miniProgramId,
        "path": JSON.parse(item.data).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  })]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border-radius": ".16rem"
    },
    attrs: {
      "src": _vm.banners[0].imageUrl
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.banners[0], '118', 'click_home_top_banner')
      }
    }
  }), _vm._v(" "), (_vm.banners[0].type == 500085) ? _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": JSON.parse(_vm.banners[0].data).miniProgramId,
      "path": JSON.parse(_vm.banners[0].data).path
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n              <style>.btn {padding: 100px 50px;color: transparent;border: none;background: transparent}</style>\n              <button class=\"btn\"></button>\n            ")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isOpenA) ? _c('div', [(_vm.tagList.length > 0 || _vm.shopList.length > 0) ? _c('div', [(_vm.tagList.length > 0) ? _c('div', {
    staticClass: "category-list"
  }, [_c('ul', {
    staticClass: "card shop-list"
  }, _vm._l((_vm.tagList), function(item) {
    return _c('li', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoHomePage(item, 1)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: ({
        backgroundImage: 'url(' + item.show_icon + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "ellipse",
      staticStyle: {
        "display": "block",
        "font-size": ".22rem",
        "color": "#666",
        "height": ".28rem"
      }
    }, [_vm._v(_vm._s(item.show_name))])]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.noticeContent && _vm.noticeContent != '') ? _c('div', {
    staticClass: "marquee",
    on: {
      "click": _vm.getNoticeDetail
    }
  }, [_c('div', {
    staticClass: "marquee_bg card tag-list"
  }, [_c('span', {
    staticClass: "notice_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "marquee-box"
  }, [_c('div', [_c('p', {
    attrs: {
      "id": "marquee-dom"
    }
  }, [_vm._v(_vm._s(_vm.noticeContent))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lantern-slide lantern-list"
  }, _vm._l((_vm.lanternSlideList), function(item2) {
    return _c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          return _vm.lanternSlideJump(item2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item2.show_icon,
        "width": "100%"
      }
    })])
  }), 0), _vm._v(" "), (_vm.shopList.length > 0) ? _c('div', {
    staticClass: "goods-list card"
  }, [_c('div', {
    staticClass: "goods-title"
  }, [_vm._v("本校食堂")]), _vm._v(" "), _c('ul', _vm._l((_vm.shopList), function(item) {
    return _c('li', {
      staticStyle: {
        "padding": "0.2rem 0 0 0",
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "goods-box",
      on: {
        "click": function($event) {
          return _vm.toGoHomePage(item)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "lazy shopimg fl",
      style: ({
        backgroundImage: 'url(' + item.show_icon + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "shopname fl"
    }, [_vm._v(_vm._s(item.show_name))]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                        <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                        <button class=\"btn\"></button>\n                      ")])]) : _vm._e()], 1)])])
  }), 0)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isOpenA) ? _c('div', [(_vm.shopCategoryList.length > 0) ? _c('div', {
    ref: "categoryList",
    staticClass: "category-list"
  }, [_c('ul', {
    staticClass: "card shop-list"
  }, _vm._l((_vm.shopCategoryList), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "position": "relative"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toShopList(item)
        }
      }
    }, [_c('span', {
      staticClass: "icon",
      style: (item.backgroundimg)
    }), _vm._v(" "), _c('span', {
      staticClass: "ellipse c-666 fs-22",
      staticStyle: {
        "display": "block",
        "height": ".28rem"
      }
    }, [_vm._v(_vm._s(item.show_name))]), _vm._v(" "), (item.app_jump_type == 500085) ? _c('wx-open-launch-weapp', {
      staticStyle: {
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "top": "0",
        "left": "0"
      },
      attrs: {
        "username": JSON.parse(item.app_jump_params).miniProgramId,
        "path": JSON.parse(item.app_jump_params).path
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                    <style>.btn {padding: 24px 12px;color: transparent;border: none;background: transparent}</style>\n                    <button class=\"btn\"></button>\n                  ")])]) : _vm._e()], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.noticeContent && _vm.noticeContent != '') ? _c('div', {
    staticClass: "marquee",
    on: {
      "click": _vm.getNoticeDetail
    }
  }, [_c('div', {
    staticClass: "marquee_bg card tag-list"
  }, [_c('span', {
    staticClass: "notice_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "marquee-box"
  }, [_c('div', [_c('p', {
    attrs: {
      "id": "marquee-dom"
    }
  }, [_vm._v(_vm._s(_vm.noticeContent))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lantern-slide lantern-list"
  }, _vm._l((_vm.lanternSlideList), function(item2) {
    return _c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          return _vm.lanternSlideJump(item2)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item2.show_icon,
        "width": "100%"
      }
    })])
  }), 0), _vm._v(" "), (_vm.benefitList.length > 0) ? _c('div', {
    staticClass: "benefit card",
    attrs: {
      "id": "benefit"
    }
  }, [(_vm.benefitList.length > 1) ? _c('div', [_c('div', {
    staticClass: "swiper-container benefit-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.benefitList), function(item) {
    return _c('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "padding": ".20rem",
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "item-img",
      on: {
        "click": function($event) {
          return _vm.benefitJump(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "2.0rem",
        "height": "3.5rem"
      },
      attrs: {
        "src": item.pic
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-desc"
    }, [_c('div', [_c('div', {
      staticClass: "name ellipses",
      staticStyle: {
        "font-size": ".32rem",
        "font-weight": "600"
      },
      on: {
        "click": function($event) {
          return _vm.benefitJump(item)
        }
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "item-tag"
    }, [(item.is_open == 1) ? _c('span', [(item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")])]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('div', {
      staticClass: "fs-22 flex-row-cc"
    }, [_c('img', {
      staticClass: "star",
      staticStyle: {
        "width": ".24rem",
        "height": ".24rem"
      },
      attrs: {
        "src": __webpack_require__(57)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-right": ".10rem",
        "font-size": ".26rem",
        "color": "#FFB300"
      }
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticClass: "argver"
    }, [_vm._v("月售" + _vm._s(item.sales_append) + "单")])]), _vm._v(" "), (item.dinnerDuration) ? _c('span', {
      staticClass: "argver"
    }, [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "scroller",
      staticStyle: {
        "margin-top": "0.05rem"
      }
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('span', {
      staticClass: "item-imgs"
    }, _vm._l((item.promotion_list), function(pro) {
      return (item.promotion_list) ? _c('img', {
        staticStyle: {
          "width": ".30rem",
          "margin-right": ".10rem"
        },
        attrs: {
          "src": pro.icon_url,
          "mode": "widthFix"
        }
      }) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('span', {
      staticClass: "item-package"
    }, _vm._l((item.promotion_package), function(package) {
      return _c('div', [_vm._v(_vm._s(package.package_desc))])
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info && item.promotion_reduce.reduce_info.length > 0) ? _c('span', {
      staticClass: "item-promotion"
    }, _vm._l((item.promotion_reduce.reduce_info), function(promotion) {
      return _c('div', {
        staticClass: "reduce"
      }, [_vm._v(_vm._s(promotion.meet_price) + "减" + _vm._s(promotion.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('span', {
      staticClass: "item-coupon"
    }, [_vm._l((item.coupon_list), function(coupon) {
      return _c('div', {
        staticClass: "desc"
      }, [_vm._v("\n                            " + _vm._s(coupon.couponDes) + "\n                          ")])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bs",
      staticStyle: {
        "margin-top": "0.1rem"
      }
    }, _vm._l((item.goods), function(good) {
      return _c('div', [_c('div', {
        staticClass: "flex-colum-ss"
      }, [_c('img', {
        staticStyle: {
          "width": "1.38rem",
          "height": "1.38rem"
        },
        attrs: {
          "src": good.thumbnail
        },
        on: {
          "click": function($event) {
            return _vm.goodsJump(item, good)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ellipses",
        staticStyle: {
          "font-size": ".24rem",
          "width": "1.38rem",
          "margin-top": ".12rem",
          "color": "#333"
        }
      }, [_vm._v(_vm._s(good.gdName))]), _vm._v(" "), _c('div', {
        staticClass: "fs-20",
        staticStyle: {
          "color": "#FD394F",
          "margin-top": ".04rem"
        }
      }, [_vm._v("￥"), _c('span', {
        staticClass: "fs-28",
        staticStyle: {
          "color": "#FD394F"
        }
      }, [_vm._v(_vm._s(good.salePrice))])])])])
    }), 0)])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })]) : _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "item-img",
    on: {
      "click": function($event) {
        return _vm.benefitJump(_vm.benefitList[0])
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.0rem",
      "height": "3.5rem"
    },
    attrs: {
      "src": _vm.benefitList[0].pic
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-desc"
  }, [_c('div', [_c('div', {
    staticClass: "name ellipses",
    staticStyle: {
      "font-size": ".32rem"
    },
    on: {
      "click": function($event) {
        return _vm.benefitJump(_vm.benefitList[0])
      }
    }
  }, [_vm._v(_vm._s(_vm.benefitList[0].shop_name))]), _vm._v(" "), _c('div', {
    staticClass: "item-tag"
  }, [(_vm.benefitList[0].is_open == 1) ? _c('span', [(_vm.benefitList[0].is_book == 1) ? _c('span', {
    staticClass: "shop-status can-reserve"
  }, [_vm._v("可预订")]) : _c('span', {
    staticClass: "shop-status"
  }, [_vm._v("营业中")])]) : _c('span', {
    staticClass: "shop-status close"
  }, [_vm._v("已打烊")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bc",
    staticStyle: {
      "margin-top": ".12rem"
    }
  }, [_c('div', {
    staticClass: "fs-22 flex-row-cc"
  }, [_c('img', {
    staticClass: "star",
    staticStyle: {
      "width": ".24rem",
      "height": ".24rem"
    },
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": ".10rem",
      "font-size": ".26rem",
      "color": "#FFB300"
    }
  }, [_vm._v(_vm._s(_vm.benefitList[0].score))]), _vm._v(" "), _c('span', {
    staticClass: "argver"
  }, [_vm._v("月售" + _vm._s(_vm.benefitList[0].sales_append) + "单")])]), _vm._v(" "), (_vm.benefitList[0].dinnerDuration) ? _c('span', {
    staticClass: "argver"
  }, [_vm._v(_vm._s(_vm.benefitList[0].dinnerDuration))]) : _vm._e()]), _vm._v(" "), (_vm.benefitList && _vm.benefitList.length > 0) ? _c('div', {
    staticClass: "scroller",
    staticStyle: {
      "margin-top": ".14rem"
    }
  }, [(_vm.benefitList[0].promotion_list && _vm.benefitList[0].promotion_list.length > 0) ? _c('span', {
    staticClass: "item-imgs"
  }, [_vm._l((_vm.benefitList[0].promotion_list), function(pro) {
    return (_vm.benefitList[0].promotion_list) ? _c('img', {
      staticStyle: {
        "width": ".30rem",
        "margin-right": ".10rem"
      },
      attrs: {
        "src": pro.icon_url,
        "mode": "widthFix"
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.benefitList[0].showMsg) ? _c('span', [_vm._v(_vm._s(_vm.benefitList[0].promotion_list[0].promotion_name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].promotion_package && _vm.benefitList[0].promotion_package.length > 0) ? _c('span', {
    staticClass: "item-package"
  }, _vm._l((_vm.benefitList[0].promotion_package), function(package) {
    return _c('span', [_vm._v(_vm._s(package.package_desc))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].promotion_reduce && _vm.benefitList[0].promotion_reduce.reduce_info && _vm.benefitList[0].promotion_reduce.reduce_info.length > 0) ? _c('span', {
    staticClass: "item-promotion"
  }, _vm._l((_vm.benefitList[0].promotion_reduce.reduce_info), function(promotion) {
    return _c('span', {
      staticClass: "reduce"
    }, [_vm._v(_vm._s(promotion.meet_price) + "减" + _vm._s(promotion.cut_price))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.benefitList[0].coupon_list && _vm.benefitList[0].coupon_list.length > 0) ? _c('span', {
    staticClass: "item-coupon"
  }, [_vm._l((_vm.benefitList[0].coupon_list), function(coupon) {
    return _c('div', {
      staticClass: "desc"
    }, [_vm._v("\n                      " + _vm._s(coupon.couponDes) + "\n                    ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "get"
  }, [_vm._v("领券")])], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-row-bs",
    staticStyle: {
      "margin-top": ".08rem"
    }
  }, _vm._l((_vm.benefitList[0].goods), function(good) {
    return _c('div', [_c('div', {
      staticClass: "flex-colum-ss"
    }, [_c('img', {
      staticStyle: {
        "width": "1.38rem",
        "height": "1.38rem"
      },
      attrs: {
        "src": good.thumbnail
      },
      on: {
        "click": function($event) {
          return _vm.goodsJump(_vm.benefitList[0], good)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ellipses",
      staticStyle: {
        "font-size": ".24rem",
        "width": "1.38rem",
        "margin-top": ".12rem",
        "color": "#333"
      }
    }, [_vm._v(_vm._s(good.gdName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-20",
      staticStyle: {
        "color": "#FD394F",
        "margin-top": ".04rem"
      }
    }, [_vm._v("￥"), _c('span', {
      staticClass: "fs-28",
      staticStyle: {
        "color": "#FD394F"
      }
    }, [_vm._v(_vm._s(good.salePrice))])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isOpenOrder) ? _c('div', [_c('div', {
    staticClass: "goods-title1 flex-colum-ss",
    class: _vm.isFixed ? 'fixed' : '',
    style: ({
      top: _vm.headerHeight + 'px'
    }),
    attrs: {
      "id": "goods-title1"
    }
  }, [_c('div', {
    staticClass: "shop-title"
  }, _vm._l((_vm.shopTitles), function(item) {
    return _c('div', {
      staticClass: "item",
      class: item.checked ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.switchTitle(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n                "), _c('span')])
  }), 0), _vm._v(" "), (!_vm.currentTitle) ? _c('div', {
    staticClass: "shop-title1 flex-row-bc-w"
  }, _vm._l((_vm.shopSorts), function(item) {
    return _c('div', {
      staticClass: "item1",
      class: item.checked ? 'active' : '',
      style: ({
        backgroundColor: _vm.isFixed ? '#f8f8f8' : ''
      }),
      on: {
        "click": function($event) {
          return _vm.switchSort(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "goods-list shop card",
    staticStyle: {
      "min-height": "15rem"
    },
    attrs: {
      "id": "goods-list"
    }
  }, [(_vm.currentShopList.length) ? _c('ul', {
    staticClass: "goods-ul",
    staticStyle: {
      "min-height": "100vh"
    }
  }, _vm._l((_vm.currentShopList), function(item, index4) {
    return _c('li', {
      key: index4,
      staticStyle: {
        "padding": "0.2rem 0"
      }
    }, [_c('div', {
      staticClass: "goods-box"
    }, [_c('a', [_c('div', {
      staticClass: "goods-img",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: (item.backgroundimg)
    }), _vm._v(" "), (item.is_mark == 1) ? _c('div', {
      staticClass: "mark",
      style: ({
        backgroundColor: item.mark_color
      })
    }, [_vm._v("\n                        " + _vm._s(item.mark) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-des",
      on: {
        "click": function($event) {
          return _vm.toGoodsList(item.id, item.shop_name)
        }
      }
    }, [_c('div', {
      staticClass: "name ellipse"
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "comment",
      staticStyle: {
        "margin-top": "0.03rem"
      }
    }, [_c('img', {
      staticClass: "star",
      attrs: {
        "src": __webpack_require__(57)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#FEC300"
      }
    }, [_vm._v(_vm._s(item.score))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3"
      }
    }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售 " + _vm._s(item.sales_append) + "单")])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.05rem"
      }
    }, [_vm._v("起送￥" + _vm._s(item.threshold_amount))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#E3E3E3",
        "margin-right": "0.05rem"
      }
    }, [_vm._v("|")]), _vm._v(" "), (item.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(item.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? _c('span', [_vm._v(_vm._s(item.new_delivery_fee))]) : _c('span', [_vm._v(_vm._s(item.delivery_fee))]), _vm._v(" "), (item.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (item.new_delivery_fee || item.new_delivery_fee === 0) ? [_c('span', {
      staticStyle: {
        "color": "#999",
        "text-decoration": "line-through",
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.delivery_fee))])] : _vm._e(), _vm._v(" "), (item.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e()], 2), _vm._v(" "), (item.dinnerDuration) ? _c('div', [_vm._v(_vm._s(item.dinnerDuration))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [(item.vice_title) ? _c('div', {
      staticClass: "vice_title"
    }, [_vm._v(_vm._s(item.vice_title))]) : _vm._e(), _vm._v(" "), (item.zsd) ? _c('div', {
      staticClass: "punctual-arrive"
    }, [_vm._v(_vm._s(item.zsd))]) : _vm._e()]), _vm._v(" "), (item.promotion_reduce && item.promotion_reduce.reduce_info) ? _c('div', {
      staticClass: "promotion_reduce",
      staticStyle: {
        "padding-left": "0.2rem"
      }
    }, _vm._l((item.promotion_reduce.reduce_info), function(item2, index3) {
      return _c('span', {
        key: index3,
        staticClass: "promotion_reduce-type border"
      }, [_vm._v(_vm._s(item2.meet_price) + "减" + _vm._s(item2.cut_price))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "promotion-and-coupon",
      staticStyle: {
        "margin": ".1rem 0 0 2.2rem"
      }
    }, [(item.promotion_list && item.promotion_list.length > 0) ? _c('div', {
      staticClass: "promotion"
    }, _vm._l((item.promotion_list), function(pro) {
      return _c('img', {
        staticClass: "icon",
        attrs: {
          "src": pro.icon_url,
          "width": "100%"
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (item.promotion_package && item.promotion_package.length > 0) ? _c('div', {
      staticClass: "package"
    }, [_vm._l((item.promotion_package), function(proPackage, index5) {
      return _c('span', {
        key: index5
      }, [_vm._v(_vm._s(proPackage.package_desc))])
    }), _vm._v(" "), (item.showMsg) ? _c('span', [_vm._v(_vm._s(item.promotion_list[0].promotion_name))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (item.coupon_list && item.coupon_list.length > 0) ? _c('div', {
      staticClass: "coupon"
    }, [_vm._l((item.coupon_list), function(coupon, index6) {
      return _c('span', {
        key: index6,
        staticClass: "desc"
      }, [_vm._v(_vm._s(coupon.couponDes))])
    }), _vm._v(" "), _c('span', {
      staticClass: "get"
    }, [_vm._v("领券")])], 2) : _vm._e()]), _vm._v(" "), (item.is_open == 1) ? _c('span', [(item.is_book == 1) ? _c('span', {
      staticClass: "shop-status can-reserve"
    }, [_vm._v("可预订")]) : _c('span', {
      staticClass: "shop-status"
    }, [_vm._v("营业中")])]) : _c('span', {
      staticClass: "shop-status close"
    }, [_vm._v("已打烊")]), _vm._v(" "), _c('div', {
      staticClass: "shop-type-box"
    }, [(item.is_self_take_new == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("自提")]) : _vm._e(), _vm._v(" "), (item.is_take_out == 1) ? _c('span', {
      staticClass: "shop-type border"
    }, [_vm._v("外送")]) : _vm._e(), _vm._v(" "), (item.is_eat_in == 1) ? _c('span', {
      staticClass: "shop-type eat-in border"
    }, [_vm._v("堂食")]) : _vm._e()])])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.currentShopList.length == 0 && _vm.noData) ? _c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    staticStyle: {
      "width": "2.00rem",
      "height": "2.74rem",
      "margin": "auto"
    },
    attrs: {
      "src": __webpack_require__(121)
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂时没有符合条件的店铺去其他分类看看吧~")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isOpenOrder) ? _c('div', {
    staticClass: "clearflow",
    staticStyle: {
      "height": "100vh",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "empty-school"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110)
    }
  }), _vm._v(" "), (!_vm.isjdlw) ? _c('h3', {
    staticStyle: {
      "font-weight": "normal",
      "margin": "0"
    }
  }, [_vm._v("业务筹备中")]) : _vm._e(), _vm._v(" "), (_vm.isjdlw) ? _c('p', {
    staticStyle: {
      "font-size": ".24rem"
    }
  }, [_vm._v("亲爱的同学，你的学校当前尚未开通，我们全力开拓中，敬请期待~")]) : _vm._e(), _vm._v(" "), (!_vm.isYSF) ? _c('p', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#787878"
    }
  }, [_vm._v("请下载APP体验更多服务")]) : _vm._e(), _vm._v(" "), (!_vm.isYSF) ? _c('div', {
    staticClass: "btn btn-main",
    staticStyle: {
      "margin": "0",
      "padding": "0.22rem 0.72rem",
      "border-radius": "10rem"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000",
      "font-size": "0.32rem"
    },
    attrs: {
      "href": "https://dl.anlaiye.com"
    }
  }, [_vm._v("下载APP")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showBottomTips) ? _c('div', {
    staticClass: "bottomTips",
    staticStyle: {
      "bottom": "1.3rem"
    }
  }, [_c('p', [_vm._v("上海鎏帑网络科技有限公司 沪ICP备18024716号-1")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v(" 联系电话：021-60761299")])]) : _vm._e()]), _vm._v(" "), (_vm.showCouponAlert) ? _c('div', {
    staticClass: "notice_detail_alert coupon",
    on: {
      "click": function($event) {
        _vm.showCouponAlert = false
      }
    }
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.couponInfo.partner == 3) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.target_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 2) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.new_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 1) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.old_title))]) : _vm._e(), _vm._v(" "), (_vm.couponInfo.partner == 0) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.couponInfo.all_title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.couponInfo.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_type == 2) ? _c('img', {
      attrs: {
        "src": __webpack_require__(112),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(113),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "2.45rem"
      }
    }, [_c('div', {
      staticClass: "fs-30 fw-bold ellipse"
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-22",
      staticStyle: {
        "color": "#999",
        "margin-top": ".16rem"
      }
    }, [_vm._v("有效期至：" + _vm._s(item.coupon_end_time))])])]), _vm._v(" "), (item.coupon_type == 2) ? _c('div', {
      staticClass: "price"
    }, [_c('span', [_vm._v(_vm._s(item.amount) + "折")])]) : _c('div', {
      staticClass: "price"
    }, [_vm._v("\n                  ¥"), _c('span', [_vm._v(_vm._s(item.amount))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(339),
      "width": "100%",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jump-btn",
    on: {
      "click": function($event) {
        return _vm.closeCouponAlert()
      }
    }
  }, [_vm._v("立即使用")])])])]) : _vm._e(), _vm._v(" "), (_vm.showNoticeAlert) ? _c('div', {
    staticClass: "notice_detail_alert"
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_c('div', {
    staticClass: "notice_detail_bg"
  }, [_c('h3', [_vm._v("学校公告")]), _vm._v(" "), _c('div', {
    staticClass: "notice_detail_scroll"
  }, _vm._l((_vm.noticeList), function(item) {
    return _c('p', [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showNoticeAlert = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showAdsvPop) ? _c('div', {
    staticClass: "notice_detail_alert"
  }, [_c('div', {
    staticClass: "notice_detail_content",
    staticStyle: {
      "width": "5.4rem",
      "position": "relative"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.adsvPopItem.imageUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.bannerJump(_vm.adsvPopItem, '62', 'click_home_top_banner')
      }
    }
  }), _vm._v(" "), (_vm.adsvPopItem.type == 500085) ? _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "bottom": ".85rem",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": JSON.parse(_vm.adsvPopItem.data).miniProgramId,
      "path": JSON.parse(_vm.adsvPopItem.data).path
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n            <style>.btn{ position: absolute;top:0;left:0;width:100%;height:100%;opacity:0 }</style>\n            <div class=\"btn\"></div>\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeAdsvPop
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showBonusPop) ? _c('div', {
    staticClass: "notice_detail_alert bonus"
  }, [_c('div', {
    staticClass: "notice_detail_content"
  }, [_c('img', {
    attrs: {
      "src": _vm.bonusPop.icon,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.bonusPopJump()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showBonusPop = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.cardPlusInfo && _vm.cardPlusInfo.card) ? _c('div', {
    staticClass: "fixed-card"
  }, [_c('img', {
    attrs: {
      "src": _vm.cardPlusInfo.card,
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.cardJump()
      }
    }
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402004817"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.2rem",
      "height": "0.2rem",
      "margin-top": "0.08rem",
      "float": "left"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393"
    }
  }, [_vm._v("沪公网安备\n              31010402004817号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(341),
      "width": "100%",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "scoreDetail",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.scoreDetail), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "score-list"
    }, [_c('div', [_c('div', {
      staticClass: "fs-28"
    }, [_vm._v(_vm._s(item.score_event_name_show))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.created_at))])]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_c('span', [_vm._v(_vm._s(item.symbol == 1 ? '+' : '-'))]), _vm._v(_vm._s(item.score))])])
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    staticStyle: {
      "margin-top": "-.16rem"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(118),
      "alt": ""
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usercenter"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.uid == 'null' || _vm.uid == '' || _vm.uid == null) ? _c('div', {
    staticClass: "unlogin"
  }, [_c('div', {
    staticClass: "unlogin-img"
  }), _vm._v(" "), _c('p', [_vm._v("您还没有登录，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "goToLogin_btn",
    on: {
      "click": _vm.toGoLogin
    }
  }, [_vm._v("登录")])]) : _c('div', [(_vm.showPage) ? _c('div', [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "logo",
    style: (_vm.userInfo.backgroundimg)
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _vm._v(" "), (_vm.scoreInfo.level_pic_one) ? _c('img', {
    staticClass: "level_pic",
    attrs: {
      "src": _vm.scoreInfo.level_pic_one
    },
    on: {
      "click": function($event) {
        return _vm.toMemberLevel()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-bg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "scoreInfo",
    on: {
      "click": function($event) {
        return _vm.toMyScore()
      }
    }
  }, [_c('div', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "fs-28 score_bg"
  }, [_vm._v("蟠桃：")]), _vm._v(" "), _c('span', {
    staticClass: "fs-42"
  }, [_vm._v(_vm._s(_vm.scoreInfo.score))])]), _vm._v(" "), _c('span', {
    staticClass: "scoreBtn",
    class: {
      'signed': _vm.scoreInfo.sign_status == 1
    }
  }, [_vm._v(_vm._s(_vm.scoreInfo.sign_status == 1 ? '今日已签到' : '签到领积分'))])]), _vm._v(" "), (_vm.showRecommend) ? _c('div', {
    staticClass: "recommend",
    style: ({
      backgroundImage: 'url(' + _vm.bannerUrl + ')'
    }),
    on: {
      "click": _vm.toRecommend
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list order-list"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "padding-top": ".32rem"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toAddressList
    }
  }, [_c('span', {
    staticClass: "icon1 icon_adress fl"
  }, [_vm._v("我的地址")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyComment
    }
  }, [_c('span', {
    staticClass: "icon1 icon_comments fl"
  }, [_vm._v("我的评论")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyComplaints
    }
  }, [_c('span', {
    staticClass: "icon1 icon_complaints fl"
  }, [_vm._v("我的投诉")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyService
    }
  }, [_c('span', {
    staticClass: "icon1 icon_cs fl"
  }, [_vm._v("客服中心")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyCoupons
    }
  }, [_c('span', {
    staticClass: "icon1 icon_coupons fl"
  }, [_vm._v("我的优惠券")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-bottom": ".32rem"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toShare
    }
  }, [_c('span', {
    staticClass: "icon1 icon_share fl"
  }, [_vm._v("邀请有礼")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), (!_vm.isJdlwHide) ? _c('li', [_c('a', {
    staticStyle: {
      "border-bottom": "none",
      "border-top": "1px solid #F5F5F5",
      "padding": ".55rem 0 .54rem 0"
    },
    on: {
      "click": _vm.loginOut
    }
  }, [_c('span', {
    staticClass: "icon1 icon_logout fl"
  }, [_vm._v("退出登录")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]) : _vm._e()])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', [_c('div', {
    staticClass: "name ellipse"
  }, [_vm._v(_vm._s(_vm.rewardInfo.deliveryName))]), _vm._v(" "), _c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.rewardInfo.deliveryEnounce))])]), _vm._v(" "), _c('img', {
    staticClass: "headImg",
    attrs: {
      "src": _vm.rewardInfo.deliveryAvatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "href": 'tel:' + _vm.rewardInfo.deliveryTel
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".21rem",
      "height": ".21rem",
      "margin-right": ".07rem"
    },
    attrs: {
      "src": __webpack_require__(346),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_vm._v("电话联系")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".2rem",
      "background": "#F5F5F5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reward"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("打赏西游侠")]), _vm._v(" "), (!_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "des"
  }, [_vm._v("打赏将全额转给同学，平台不扣取任何费用")]) : _vm._e(), _vm._v(" "), (!_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "items-box"
  }, _vm._l((_vm.rewardInfo.configList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "reward-items"
    }, [_c('img', {
      staticClass: "avater",
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "reward-price"
    }, [_vm._v(_vm._s(item.type ? '其他金额' : '¥' + item.amount))]), _vm._v(" "), _c('span', {
      staticClass: "reward-btn",
      on: {
        "click": function($event) {
          return _vm.openReward(item)
        }
      }
    }, [_vm._v("打赏")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.rewardInfo.orderRewardAmount) ? _c('div', {
    staticClass: "receive-reward"
  }, [_c('img', {
    staticStyle: {
      "width": "2.28rem",
      "height": "2.08rem"
    },
    attrs: {
      "src": __webpack_require__(319),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#2F2F2F"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": ".34rem",
      "font-weight": "700"
    }
  }, [_vm._v("已收到打赏"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rewardInfo.orderRewardAmount) + "元")]), _vm._v("。谢谢您！")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".26rem",
      "margin-top": ".12rem"
    }
  }, [_vm._v("感谢您的认可，我会继续努力！")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reward-bottom"
  }, [_c('div', {
    staticClass: "reward-number"
  }, [_vm._v("他收到过" + _vm._s(_vm.rewardInfo.deliveryRewardCounts) + "次打赏")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    },
    on: {
      "click": function($event) {
        return _vm.toRewardList(_vm.rewardInfo.deliveryId)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.rewardOrderList), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "reward-img",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    })
  }), 0), _vm._v(" "), (_vm.rewardInfo.rewardOrderList.length > 0) ? _c('img', {
    staticStyle: {
      "display": "block",
      "width": ".14rem",
      "height": ".24rem"
    },
    attrs: {
      "src": __webpack_require__(344),
      "alt": ""
    }
  }) : _vm._e()])])])]), _vm._v(" "), (_vm.isShowReward) ? _c('div', {
    staticClass: "reward_mask"
  }, [_c('div', {
    staticClass: "reward_box"
  }, [_c('img', {
    staticClass: "reward-close",
    attrs: {
      "src": __webpack_require__(345),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeMask()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reward-tit"
  }, [_vm._v("感谢您的一份心意")]), _vm._v(" "), _c('div', {
    staticClass: "amount-box"
  }, [_c('span', {
    staticStyle: {
      "font-family": "PingFangSC-Medium",
      "font-size": ".42rem",
      "color": "#2F2F2F",
      "margin-right": ".2rem"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: [_vm.isActive ? 'active' : 'noActive'],
    staticStyle: {
      "width": "2.5rem",
      "outline": "none"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入1-50元的金额"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, function($event) {
        return _vm.changeAmount(_vm.amount)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "reward-submit",
    on: {
      "click": function($event) {
        return _vm.submitReward(1)
      }
    }
  }, [_vm._v("确定打赏")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 469 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 470 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 471 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 472 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 473 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 474 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 475 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAtpJREFUSA29lz1MFFEQx2fe7h0QbzEChR7GxkKNpR+RRBITCi2MRE0wckSNdsZDCjUkNleYaC4qXwmFhR+AMUETEUwsLRQTbTR+FWghFkchatjjkCC747yVd9zu8an32Gb2vZn5//JmP948hGVcdDoRydg/q1zXreS0KCEUCcARQkyFBLwp6Wr7ulQ5XCyQensNu+9ZDIGOAGENARXNn4OvBUAfQbiz9N610fnjABYE2/WNtQB0hYg2LySS50O0BWEyYpW14I3ERJ6fJ+YEUyIRTg/96CRyT82VtNQ5RHgXCpsHSm63fgnm5IGpvnlNGjL9vMrdweB/GSPiKAisLe1pf5Gbz49k9uKVmjZk7hcKKpVZq4IcGpg8Ht84SwLwge2h7y0cWZMbUJh7KpuaogE6ecFSelnwWCy+i6FnlKPQlgC2pCd/XVS6WTC6kFST+iydnYjF10t9D5xuaNrD32e1PuBfZSIodojOZcGuM31IN1TpuwQey/ucxurjw/x8Nyinbmsa5jYxfuL82pWEykW55O4UOP07qnuFQX0ud1RMg7Mu6NA95ucbFVxmVzcoT5+ZwuC9NM+heULu34JCsOJg/nmkhHWr4xvvIJ80L9IvHzIGZ36Z9Mjv0ThC+GzdafnggckwHmhE+aQRhcfywKu7215yuZ/4InQMENMYputSeqbUfGOKZoZr/bQYlpTvlA8c6Wp7y+3qJR0L9TQRX0XC5VeVvq/n4jYF07E4tz5wWAUUwjIkZRjm9lU9rSNKL1tqOcGlJitScYwD+1XAf1uEYTTF3lyo1PSB5YTsg61NFQcZflmO/+fihTwXRbjD6m5/H9TxlTrotI82VQE6yeV2nbK03NImrNrqm1hX5wR15XhBsEoYb2jc57p8hAHYL9tVNZ9rEXCKkJ7yCeJhxCrvnu8EoXKWBFbB8hyVeTy41XGcSuQ9lX8Gxby7jbgIqVKAj3i3w1axi9k/zHX2JxkHILsAAAAASUVORK5CYII="

/***/ })
],[198]);


// WEBPACK FOOTER //
// static/js/app.183dc38f0a74de193828.1772780027531.js